
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec425"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec425"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1L1Fr", function(module, exports) {

$parcel$export(module.exports, "processImageProxyUrls", () => $147b795af41a764b$export$7dff830eb2bf4d22);
$parcel$export(module.exports, "getProxyUrl", () => $147b795af41a764b$export$5dee9601e91f0ebf);
$parcel$export(module.exports, "attachProxyImageRemintHandlers", () => $147b795af41a764b$export$18758a703176ee6c);
/**
 * Image Proxy URL Post-Processor
 * Converts direct image URLs to proxy URLs in HTML content
 * and remints expired signed proxy tokens while the user is in the app.
 */ const $147b795af41a764b$var$REMINT_ATTR = 'data-proxy-reminted';
function $147b795af41a764b$export$82d2553ca5d17308(src) {
    if (!src || typeof src !== 'string') return false;
    try {
        const parsed = new URL(src, window.location.origin);
        return parsed.pathname === '/proxy/image' || parsed.pathname.endsWith('/proxy/image');
    } catch (_error) {
        return src.includes('/proxy/image?');
    }
}
function $147b795af41a764b$export$4d71238f579c5067(proxyUrl, size) {
    if (!proxyUrl || size !== 'thumbnail' && size !== 'original') return proxyUrl;
    try {
        const parsed = new URL(proxyUrl, window.location.origin);
        parsed.searchParams.set('size', size);
        return parsed.toString();
    } catch (_error) {
        const separator = proxyUrl.includes('?') ? '&' : '?';
        return `${proxyUrl}${separator}size=${encodeURIComponent(size)}`;
    }
}
function $147b795af41a764b$export$8c9457cb3c86d42e(src) {
    if (!src) return null;
    try {
        const parsed = new URL(src, window.location.origin);
        const size = parsed.searchParams.get('size');
        return size === 'thumbnail' || size === 'original' ? size : null;
    } catch (_error) {
        return null;
    }
}
async function $147b795af41a764b$export$7dff830eb2bf4d22(html, userId, postId = null, postContext = null) {
    if (!html || !userId) return html;
    try {
        // Find all image tags with data-image-url attributes
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const images = tempDiv.querySelectorAll('img[data-image-url]');
        if (images.length === 0) return html;
        // Collect unique image URLs (https and oauth)
        const imageUrls = Array.from(images).map((img)=>img.getAttribute('data-image-url')).filter((url)=>url && (url.startsWith('https://') || url.startsWith('oauth://')));
        if (imageUrls.length === 0) return html;
        const uniqueUrls = [
            ...new Set(imageUrls)
        ];
        const proxyUrlMap = await $147b795af41a764b$var$fetchProxyUrlMap(uniqueUrls, postId, postContext);
        if (!proxyUrlMap) {
            window.logger.warn('Failed to get proxy URLs, using original URLs');
            return html;
        }
        // Replace src attributes with proxy URLs
        images.forEach((img)=>{
            const originalUrl = img.getAttribute('data-image-url');
            const proxyUrl = proxyUrlMap.get(originalUrl);
            const size = $147b795af41a764b$export$8c9457cb3c86d42e(img.getAttribute('src') || '');
            if (proxyUrl) img.setAttribute('src', $147b795af41a764b$export$4d71238f579c5067(proxyUrl, size));
        });
        return tempDiv.innerHTML;
    } catch (error) {
        window.logger.error('Error processing image proxy URLs:', error);
        // On error, return original HTML
        return html;
    }
}
async function $147b795af41a764b$export$5dee9601e91f0ebf(imageUrl, userId, postId = null, postContext = null) {
    if (!imageUrl || !userId) return null;
    try {
        const proxyUrlMap = await $147b795af41a764b$var$fetchProxyUrlMap([
            imageUrl
        ], postId, postContext);
        if (!proxyUrlMap) return null;
        return proxyUrlMap.get(imageUrl) || null;
    } catch (error) {
        window.logger.error('Error getting proxy URL:', error);
        return null;
    }
}
/**
 * Batch-fetch proxy URLs for original image URLs
 * @param {string[]} imageUrls
 * @param {number|null} postId
 * @param {string|null} postContext
 * @returns {Promise<Map<string, string>|null>}
 */ async function $147b795af41a764b$var$fetchProxyUrlMap(imageUrls, postId = null, postContext = null) {
    const body = {
        image_urls: imageUrls,
        post_id: postId
    };
    if (postContext === 'friend' || postContext === 'group') body.post_context = postContext;
    const response = await fetch('/api/images/proxy-urls', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(body)
    });
    if (!response.ok) return null;
    const data = await response.json();
    const proxyUrlMap = new Map();
    (data.proxy_urls || []).forEach((item)=>{
        if (item.proxy_url) proxyUrlMap.set(item.original_url, item.proxy_url);
    });
    return proxyUrlMap;
}
function $147b795af41a764b$export$4f0eace8a12398db(img) {
    if (!img) return false;
    return img.naturalWidth > 0 && img.naturalHeight > 0 && img.naturalWidth <= 1 && img.naturalHeight <= 1;
}
async function $147b795af41a764b$export$6b017e893b13b237(img, options = {}) {
    if (!img || img.getAttribute($147b795af41a764b$var$REMINT_ATTR) === '1') return false;
    const originalUrl = img.getAttribute('data-image-url');
    if (!originalUrl || !(originalUrl.startsWith('https://') || originalUrl.startsWith('oauth://'))) return false;
    const { postId: postId = null, postContext: postContext = null } = options;
    img.setAttribute($147b795af41a764b$var$REMINT_ATTR, '1');
    try {
        const proxyUrlMap = await $147b795af41a764b$var$fetchProxyUrlMap([
            originalUrl
        ], postId, postContext);
        const proxyUrl = proxyUrlMap?.get(originalUrl);
        if (!proxyUrl) return false;
        const size = $147b795af41a764b$export$8c9457cb3c86d42e(img.getAttribute('src') || '');
        img.setAttribute('src', $147b795af41a764b$export$4d71238f579c5067(proxyUrl, size));
        return true;
    } catch (error) {
        window.logger?.warn('Failed to remint proxy image URL:', error);
        return false;
    }
}
function $147b795af41a764b$export$18758a703176ee6c(root, options = {}) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    const images = root.querySelectorAll('img.user-image[data-image-url], img[data-image-url]');
    images.forEach((img)=>{
        if (img.dataset.proxyRemintBound === '1') return;
        img.dataset.proxyRemintBound = '1';
        const tryRemint = async (reason)=>{
            if (!$147b795af41a764b$export$82d2553ca5d17308(img.getAttribute('src') || '')) return;
            window.logger?.debug('Reminting proxy image', {
                reason: reason,
                src: img.getAttribute('src')
            });
            await $147b795af41a764b$export$6b017e893b13b237(img, options);
        };
        img.addEventListener('error', ()=>{
            tryRemint('error');
        });
        img.addEventListener('load', ()=>{
            if ($147b795af41a764b$export$4f0eace8a12398db(img)) tryRemint('placeholder');
        });
        // Already loaded (cached) before handlers attached
        if (img.complete && $147b795af41a764b$export$4f0eace8a12398db(img) && $147b795af41a764b$export$82d2553ca5d17308(img.getAttribute('src') || '')) tryRemint('already_loaded_placeholder');
    });
}

});

// Main JavaScript entry point
// Clean URL Router for Fun Old Times

var $eZQHH = parcelRequire("eZQHH");
/** Deep-link helpers for group main feed and thread URLs (#post-…). */ /** Shareable group post/comment permalinks under /group/… (navigation stays /groups/…). */ const $2bb3cd4399004fe3$var$STREAM_PAGE_LIMIT = 10;
function $2bb3cd4399004fe3$export$611b42c8bf9737ff({ groupId: groupId, postId: postId }) {
    return `/group/${groupId}/post/${postId}`;
}
function $2bb3cd4399004fe3$export$634034df907f30cd({ groupId: groupId, postId: postId, commentId: commentId }) {
    return `/group/${groupId}/post/${postId}/comment/${commentId}`;
}
function $2bb3cd4399004fe3$export$d666a48355007a45({ groupId: groupId, threadId: threadId, page: page, postId: postId }) {
    const base = threadId ? `/groups/${groupId}/threads/${threadId}` : `/groups/${groupId}`;
    const url = new URL(base, window.location.origin);
    if (page && page > 1) url.searchParams.set('page', String(page));
    url.hash = `post-${postId}`;
    return `${url.pathname}${url.search}${url.hash}`;
}
function $2bb3cd4399004fe3$export$1a1c301579a08d1e(selector, root = document, timeout = 5000) {
    return new Promise((resolve)=>{
        const find = ()=>{
            if (root !== document && typeof root.querySelector === 'function') {
                const scoped = root.querySelector(selector);
                if (scoped) return scoped;
            }
            return document.querySelector(selector);
        };
        const existing = find();
        if (existing) {
            resolve(existing);
            return;
        }
        const observer = new MutationObserver(()=>{
            const element = find();
            if (element) {
                observer.disconnect();
                resolve(element);
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            resolve(find());
        }, timeout);
    });
}
async function $2bb3cd4399004fe3$export$28826d3e6e972258(timeout = 15000) {
    const start = Date.now();
    while(Date.now() - start < timeout){
        const feed = document.querySelector('group-shell posts-feed');
        if (feed && !feed.isLoadingPosts && !feed.isLoading) return feed;
        await new Promise((resolve)=>setTimeout(resolve, 50));
    }
    return $2bb3cd4399004fe3$export$1a1c301579a08d1e('group-shell posts-feed', document, 5000);
}
async function $2bb3cd4399004fe3$var$waitForCommentsLoaded(commentsSection, timeout = 10000) {
    const start = Date.now();
    while(!commentsSection.commentsLoaded && Date.now() - start < timeout)await new Promise((resolve)=>setTimeout(resolve, 50));
    while(commentsSection.isLoading && Date.now() - start < timeout)await new Promise((resolve)=>setTimeout(resolve, 50));
}
async function $2bb3cd4399004fe3$export$82a8941476802fd8(groupId, postId, { threadId: threadId = null } = {}) {
    const params = new URLSearchParams();
    params.set('limit', String($2bb3cd4399004fe3$var$STREAM_PAGE_LIMIT));
    if (threadId) params.set('thread_id', String(threadId));
    return window.API.request(`/groups/${groupId}/posts/${postId}/stream-page?${params}`);
}
function $2bb3cd4399004fe3$export$21aeeb261e519519(commentElement) {
    commentElement.classList.add('comment-highlight');
    setTimeout(()=>{
        commentElement.classList.remove('comment-highlight');
    }, 3000);
}
async function $2bb3cd4399004fe3$var$waitForFeedIdle(feed, timeout = 10000) {
    const start = Date.now();
    while(feed && (feed.isLoadingPosts || feed.isLoading) && Date.now() - start < timeout)await new Promise((resolve)=>setTimeout(resolve, 50));
}
async function $2bb3cd4399004fe3$var$ensurePostVisibleInFeed(feed, postId, page, { expandComments: expandComments = false } = {}) {
    if (!feed) return null;
    const targetPage = page || 1;
    if (feed.currentPage !== targetPage) {
        feed.currentPage = targetPage;
        await feed.load(true);
    } else await $2bb3cd4399004fe3$var$waitForFeedIdle(feed);
    const anchor = await $2bb3cd4399004fe3$export$1a1c301579a08d1e(`#post-${postId}`, feed, 10000);
    if (!anchor) return null;
    const postItem = anchor.closest('post-item');
    if (expandComments && postItem && typeof postItem.openComments === 'function') postItem.openComments(true);
    return {
        anchor: anchor,
        postItem: postItem
    };
}
async function $2bb3cd4399004fe3$export$9930b3e2d246d9fc({ groupId: groupId, postId: postId, location: location = null }) {
    let streamLocation = location;
    if (!streamLocation && window.API) try {
        streamLocation = await $2bb3cd4399004fe3$export$82a8941476802fd8(groupId, postId);
    } catch (_err) {
        return false;
    }
    const feed = await $2bb3cd4399004fe3$export$1a1c301579a08d1e('group-shell posts-feed');
    if (!feed) return false;
    const result = await $2bb3cd4399004fe3$var$ensurePostVisibleInFeed(feed, postId, streamLocation?.page);
    if (!result?.anchor) return false;
    result.anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
    return true;
}
async function $2bb3cd4399004fe3$export$fb46a8b6495eaff5({ groupId: groupId, postId: postId, commentId: commentId, location: location = null }) {
    let streamLocation = location;
    if (!streamLocation && window.API) try {
        streamLocation = await $2bb3cd4399004fe3$export$82a8941476802fd8(groupId, postId);
    } catch (_err) {
        return false;
    }
    const feed = await $2bb3cd4399004fe3$export$1a1c301579a08d1e('group-shell posts-feed');
    if (!feed) return false;
    const result = await $2bb3cd4399004fe3$var$ensurePostVisibleInFeed(feed, postId, streamLocation?.page);
    if (!result?.postItem) return false;
    const commentsSection = await $2bb3cd4399004fe3$export$1a1c301579a08d1e('comments-section', result.postItem, 10000);
    if (!commentsSection) return false;
    if (!commentsSection.commentsLoaded) await commentsSection.loadComments();
    else await $2bb3cd4399004fe3$var$waitForCommentsLoaded(commentsSection);
    if (result.postItem && typeof result.postItem.openComments === 'function') result.postItem.openComments(true);
    const commentElement = await $2bb3cd4399004fe3$export$1a1c301579a08d1e(`[data-comment-id="${commentId}"]`, result.postItem, 10000);
    if (!commentElement) {
        window.logger?.warn(`Group comment ${commentId} not found in post ${postId}`);
        return false;
    }
    commentElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
    });
    $2bb3cd4399004fe3$export$21aeeb261e519519(commentElement);
    return true;
}
async function $2bb3cd4399004fe3$export$a0644f33ba38b066({ postId: postId, feed: feed, pathContext: pathContext }) {
    if (!pathContext?.groupId || !window.API) return false;
    let location;
    try {
        location = await $2bb3cd4399004fe3$export$82a8941476802fd8(pathContext.groupId, postId, {
            threadId: pathContext.threadId
        });
    } catch (_err) {
        return false;
    }
    const resolvedThreadId = location.threadId ?? null;
    const pathThreadId = pathContext.threadId ?? null;
    if (resolvedThreadId !== pathThreadId && window.router) {
        window.router.navigate($2bb3cd4399004fe3$export$d666a48355007a45({
            groupId: location.groupId,
            threadId: resolvedThreadId,
            page: location.page,
            postId: postId
        }));
        return true;
    }
    if (!feed) return false;
    const targetPage = location.page || 1;
    if (feed.currentPage !== targetPage) {
        feed.currentPage = targetPage;
        feed._hashFocusRetry = true;
        await feed.load(true);
        return true;
    }
    return false;
}


function $243ef812260567e0$export$16d06c3c3bfa34ec(hash = window.location.hash) {
    if (!hash || hash.length < 2) return null;
    if (hash.startsWith('#post-')) {
        const postId = parseInt(hash.slice(6), 10);
        return Number.isNaN(postId) ? null : {
            type: 'post',
            postId: postId
        };
    }
    return null;
}
function $243ef812260567e0$export$6a89b9a581938348(pathname = window.location.pathname) {
    return /^\/groups\/\d+(?:\/threads\/\d+)?$/.test(pathname);
}
function $243ef812260567e0$export$d7d2110546156bca(pathname = window.location.pathname) {
    const threadMatch = pathname.match(/^\/groups\/(\d+)\/threads\/(\d+)$/);
    if (threadMatch) return {
        groupId: parseInt(threadMatch[1], 10),
        threadId: parseInt(threadMatch[2], 10)
    };
    const groupMatch = pathname.match(/^\/groups\/(\d+)$/);
    if (groupMatch) return {
        groupId: parseInt(groupMatch[1], 10),
        threadId: null
    };
    return null;
}
function $243ef812260567e0$var$focusPostElement(anchor) {
    const postItem = anchor.closest('post-item');
    if (postItem && typeof postItem.openComments === 'function') postItem.openComments(true);
    anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}
async function $243ef812260567e0$export$593b75043823fc36({ root: root = document, feed: feed = null, allowResolve: allowResolve = true } = {}) {
    if (!$243ef812260567e0$export$6a89b9a581938348()) return false;
    const parsed = $243ef812260567e0$export$16d06c3c3bfa34ec();
    if (!parsed || parsed.type !== 'post') return false;
    const pathContext = $243ef812260567e0$export$d7d2110546156bca();
    const isRetry = Boolean(feed?._hashFocusRetry);
    if (feed) feed._hashFocusRetry = false;
    let anchor = root.querySelector?.(`#post-${parsed.postId}`) || document.getElementById(`post-${parsed.postId}`);
    if (!anchor && allowResolve && !isRetry && pathContext) {
        const navigated = await (0, $2bb3cd4399004fe3$export$a0644f33ba38b066)({
            postId: parsed.postId,
            feed: feed,
            pathContext: pathContext
        });
        if (navigated) return navigated;
    }
    anchor = await (0, $2bb3cd4399004fe3$export$1a1c301579a08d1e)(`#post-${parsed.postId}`, root);
    if (!anchor) {
        if (allowResolve && !isRetry && pathContext) return (0, $2bb3cd4399004fe3$export$a0644f33ba38b066)({
            postId: parsed.postId,
            feed: feed,
            pathContext: pathContext
        });
        return false;
    }
    $243ef812260567e0$var$focusPostElement(anchor);
    return true;
}


/**
 * Split an app route string into pathname, search, and hash segments.
 * Query strings stay on the URL for pushState but are excluded from pathname routing.
 */ function $8378007740833a54$export$beb288433db98a8(path, fallbackPathname = '/') {
    if (path.startsWith('#')) return {
        pathname: fallbackPathname,
        search: '',
        hash: path
    };
    const hashIndex = path.indexOf('#');
    const hash = hashIndex === -1 ? '' : path.slice(hashIndex);
    const withoutHash = hashIndex === -1 ? path : path.slice(0, hashIndex);
    const queryIndex = withoutHash.indexOf('?');
    const pathname = (queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex)) || '/';
    const search = queryIndex === -1 ? '' : withoutHash.slice(queryIndex);
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
}


const $82c5ec211b0f131c$export$565024ad1528f4a2 = 'return';
const $82c5ec211b0f131c$var$DENYLISTED_PATHS = new Set([
    '/login',
    '/register'
]);
const $82c5ec211b0f131c$var$LABEL_MAP = {
    '/': 'Home',
    '/profile/me': 'My Profile',
    '/settings': 'Settings',
    '/settings/widgets': 'My Widgets',
    '/friends': 'Friends',
    '/events': 'Events',
    '/groups': 'Groups',
    '/memories': 'Memories'
};
function $82c5ec211b0f131c$export$21b1a4469922ed9e() {
    if (typeof window === 'undefined') return '';
    const { pathname: pathname, search: search, hash: hash } = window.location;
    return `${pathname}${search}${hash}`;
}
function $82c5ec211b0f131c$export$2c92ee81e846ef01(path) {
    if (!path || typeof path !== 'string') return false;
    if (!path.startsWith('/')) return false;
    if (path.startsWith('//')) return false;
    if (path.includes('://')) return false;
    const pathname = path.split('?')[0].split('#')[0];
    return !$82c5ec211b0f131c$var$DENYLISTED_PATHS.has(pathname);
}
function $82c5ec211b0f131c$export$4ce77c52271fbeec() {
    if (typeof window === 'undefined') return null;
    const { pathname: pathname, search: search, hash: hash } = window.location;
    if (pathname === '/docs' || pathname.startsWith('/docs/')) return null;
    return `${pathname}${search}${hash}`;
}
function $82c5ec211b0f131c$export$5792f1b1a678cbfd(fallback) {
    if (typeof window === 'undefined') return fallback && $82c5ec211b0f131c$export$2c92ee81e846ef01(fallback) ? fallback : null;
    const params = new URLSearchParams(window.location.search);
    const value = params.get($82c5ec211b0f131c$export$565024ad1528f4a2);
    if (value && $82c5ec211b0f131c$export$2c92ee81e846ef01(value)) return value;
    if (fallback && $82c5ec211b0f131c$export$2c92ee81e846ef01(fallback)) return fallback;
    return null;
}
function $82c5ec211b0f131c$export$251eed6ca26667ac() {
    return $82c5ec211b0f131c$export$5792f1b1a678cbfd() || $82c5ec211b0f131c$export$4ce77c52271fbeec();
}
function $82c5ec211b0f131c$export$7be6c6c696c8413b(href, returnTo) {
    const returnPath = returnTo ?? $82c5ec211b0f131c$export$251eed6ca26667ac();
    if (!returnPath || !$82c5ec211b0f131c$export$2c92ee81e846ef01(returnPath)) return href;
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const url = new URL(href, base);
    url.searchParams.set($82c5ec211b0f131c$export$565024ad1528f4a2, returnPath);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $82c5ec211b0f131c$export$505b44d8f33f195f(path) {
    if (!path) return 'Previous page';
    const pathname = path.split('?')[0].split('#')[0];
    if ($82c5ec211b0f131c$var$LABEL_MAP[pathname]) return $82c5ec211b0f131c$var$LABEL_MAP[pathname];
    if (pathname.startsWith('/groups/')) return 'Group';
    if (pathname.startsWith('/settings/')) return 'Settings';
    return 'Previous page';
}


const $0f47089e90838514$var$PUBLIC_ROUTE_PREFIXES = [
    '/login',
    '/register',
    '/reset-password',
    '/invite/',
    '/forgot-password',
    '/events/guest',
    '/privacy',
    '/terms',
    '/release-notes',
    '/docs'
];
function $0f47089e90838514$export$53f44bfb1c4a0685(path) {
    return path === '/' || path === '/home';
}
function $0f47089e90838514$export$2b943233a7784d73(path) {
    return $0f47089e90838514$var$PUBLIC_ROUTE_PREFIXES.some((prefix)=>path.startsWith(prefix));
}
function $0f47089e90838514$export$534cad851d98fbbd(path) {
    return !$0f47089e90838514$export$53f44bfb1c4a0685(path) && !$0f47089e90838514$export$2b943233a7784d73(path);
}


const $0c1c38b6cb0e7c6b$var$GROUP_INVITE_ROUTE_RE = /^\/groups\/invites\/([a-f0-9]+)$/i;
function $0c1c38b6cb0e7c6b$export$77dd37d1faf34783(path) {
    return $0c1c38b6cb0e7c6b$var$GROUP_INVITE_ROUTE_RE.test(path);
}
function $0c1c38b6cb0e7c6b$export$73a9120728e69f79(path) {
    const match = path.match($0c1c38b6cb0e7c6b$var$GROUP_INVITE_ROUTE_RE);
    return match ? match[1] : null;
}


function $2a71a25ef8798626$export$a70f9cc74b4a9f22(path) {
    return path.startsWith('/verify-email/');
}


class $8632dcb0fdec8888$var$Router {
    constructor(){
        this.routes = new Map();
        this.currentRoute = null;
        this.isAuthenticated = false; // Track authentication status
        this.init();
    }
    init() {
        // Handle browser back/forward buttons
        window.addEventListener('popstate', (_e)=>{
            this.handleRoute(window.location.pathname, false);
        });
        window.addEventListener('hashchange', ()=>{
            if ((0, $243ef812260567e0$export$6a89b9a581938348)()) {
                const feed = document.querySelector('group-shell posts-feed');
                (0, $243ef812260567e0$export$593b75043823fc36)({
                    feed: feed
                }).catch((err)=>{
                    (0, $eZQHH.default).warn('Failed to focus group post from hash change', err);
                });
            }
        });
        // Intercept navigation links
        document.addEventListener('click', (e)=>{
            const link = e.target.closest('a[href]');
            if (link && this.isInternalLink(link, e)) {
                e.preventDefault();
                this.navigate(link.getAttribute('href'));
            }
        });
        // Listen for auth status loaded to re-trigger section shown events
        document.addEventListener('auth-status-loaded', (e)=>{
            const { authenticated: authenticated } = e.detail;
            this.isAuthenticated = authenticated;
            // Update logo link after auth status is known
            this.updateLogoLink(window.location.pathname);
            if (authenticated) {
                // Re-call showSection for the current route to ensure components initialize properly
                const currentPath = window.location.pathname;
                this.handleRoute(currentPath, false);
            }
        });
        // Listen for auth-success events (login/register) to update authentication state
        document.addEventListener('auth-success', (e)=>{
            const { user: user } = e.detail;
            if (user) {
                this.isAuthenticated = true;
                this.updateLogoLink(window.location.pathname);
            }
        });
        // Listen for logout events to update authentication state
        document.addEventListener('user-logged-out', ()=>{
            this.isAuthenticated = false;
            // Update logo link after logout
            this.updateLogoLink(window.location.pathname);
        });
    }
    doInitialPageLoad() {
        // Handle initial page load
        this.handleRoute(window.location.pathname, false);
    }
    // Register a route
    addRoute(path, handler) {
        this.routes.set(path, handler);
    }
    splitRoutePath(path) {
        if (path.startsWith('#')) return (0, $8378007740833a54$export$beb288433db98a8)(path, window.location.pathname);
        return (0, $8378007740833a54$export$beb288433db98a8)(path);
    }
    // Navigate to a route
    navigate(path, addToHistory = true, forceReload = false) {
        // Force reload if requested
        if (forceReload) {
            window.location.href = path;
            return;
        }
        const { pathname: pathname, search: search, hash: hash } = this.splitRoutePath(path);
        const fullPath = `${pathname}${search}${hash}`;
        const currentFull = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        if (addToHistory && fullPath !== currentFull) window.history.pushState({}, '', fullPath);
        if (hash && pathname === window.location.pathname) {
            if ((0, $243ef812260567e0$export$6a89b9a581938348)(pathname)) {
                const feed = document.querySelector('group-shell posts-feed');
                (0, $243ef812260567e0$export$593b75043823fc36)({
                    feed: feed
                }).catch((err)=>{
                    (0, $eZQHH.default).warn('Failed to focus group post from hash navigation', err);
                });
                return;
            }
            const releaseNotes = document.querySelector('release-notes');
            if (releaseNotes && typeof releaseNotes.scrollToVersionHash === 'function') {
                releaseNotes.scrollToVersionHash();
                return;
            }
        }
        this.handleRoute(pathname, addToHistory);
    }
    // Handle route change
    async handleRoute(path, _addToHistory = true) {
        (0, $eZQHH.default).info(`\u{1F9ED} Navigating to: ${path}`);
        // Skip RSS feeds and other non-HTML routes - let the server handle them
        if (path.endsWith('.rss') || path.endsWith('.xml') || path.endsWith('.json')) {
            // Force a full page reload for these routes so the server can handle them
            window.location.href = path;
            return;
        }
        // Legacy /help URLs → /docs
        if (path === '/help' || path.startsWith('/help/')) {
            const docsPath = path.replace(/^\/help/, '/docs');
            this.navigate(docsPath, _addToHistory);
            return;
        }
        // Help screenshots — let the server serve static files, not the docs SPA
        if (path.startsWith('/docs/assets/')) {
            window.location.href = path;
            return;
        }
        this.currentRoute = path;
        // Update active navigation
        this.updateActiveNavigation(path);
        const isGuestRoute = path.startsWith('/events/guest');
        if (!isGuestRoute) this.resetGuestRouteLayout();
        // Handle special routes that don't use MainContent
        if (path === '/reset-password') await this.handleResetPassword();
        else if (path.startsWith('/invite/')) await this.handleInvitation();
        else if (path.startsWith('/verify-email/')) await this.handleEmailVerification();
        else if (path.startsWith('/events/guest')) await this.handleGuestRSVP();
        else if (path === '/privacy' || path === '/terms' || path === '/release-notes' || path === '/docs' || path.startsWith('/docs/')) {
            const pageMap = {
                '/privacy': 'privacy',
                '/terms': 'terms',
                '/release-notes': 'release-notes'
            };
            const page = pageMap[path] || (path.startsWith('/docs') ? 'docs' : null);
            if (page) document.dispatchEvent(new CustomEvent('public-page-request', {
                detail: {
                    page: page
                }
            }));
            // Update logo link and page title before returning
            this.updatePageTitle(path);
            this.updateLogoLink(path);
            return;
        } else if (path === '/login') {
            if (this.checkAuthStatus()) {
                this.navigate('/', true);
                return;
            }
            await this.showLogin();
        } else if (path === '/register') await this.showRegister();
        else {
            // Check if this is a landing route for unauthenticated users
            const isAuthenticated = this.checkAuthStatus();
            if (!isAuthenticated && (0, $0f47089e90838514$export$53f44bfb1c4a0685)(path)) {
                // For unauthenticated users on landing route, show landing page
                // Hide public page first, then show landing page
                document.dispatchEvent(new CustomEvent('hide-public-page'));
                document.dispatchEvent(new CustomEvent('show-landing-page'));
                this.updatePageTitle(path);
                this.updateLogoLink(path);
                return;
            }
            if (!isAuthenticated && (0, $0f47089e90838514$export$534cad851d98fbbd)(path)) {
                document.dispatchEvent(new CustomEvent('hide-public-page'));
                if ((0, $2a71a25ef8798626$export$a70f9cc74b4a9f22)(path)) {
                    this.hideAppShellForAuth();
                    this.updatePageTitle(path);
                    this.updateLogoLink(path);
                    return;
                }
                if (!(0, $0c1c38b6cb0e7c6b$export$77dd37d1faf34783)(path)) {
                    await this.redirectToLogin();
                    return;
                }
            }
            // For all other routes, hide public page and show main content
            // Dispatch event to hide public page (handled in main.js)
            document.dispatchEvent(new CustomEvent('hide-public-page'));
            // Trigger the MainContent component to handle the route
            const mainContent = document.querySelector('main-content');
            if (mainContent) {
                // Ensure main content is shown
                if (typeof window.showMainContent === 'function') window.showMainContent();
                // Dispatch route change event to MainContent
                const event = new CustomEvent('route-changed', {
                    detail: {
                        route: path
                    }
                });
                document.dispatchEvent(event);
            } else {
                (0, $eZQHH.default).warn('MainContent component not found, falling back to old routing');
                // Fallback to old routing for compatibility
                await this.handleRouteLegacy(path);
            }
        }
        // Update page title
        this.updatePageTitle(path);
        // Update logo link based on current route
        this.updateLogoLink(path);
    }
    updateLogoLink(path) {
        const logoLink = document.querySelector('.site-title-link');
        if (!logoLink) return;
        // Check if we're on a landing route
        const isLandingRoute = path === '/' || path === '/home';
        // Use dynamic auth check for accurate state
        const isAuthenticated = this.checkAuthStatus();
        if (path === '/release-notes') {
            // On release notes: go to home/landing depending on auth status
            logoLink.setAttribute('href', '/');
            logoLink.setAttribute('title', isAuthenticated ? 'Go to Home' : 'Go to Landing Page');
        } else if (!isAuthenticated && isLandingRoute) {
            // On landing page (unauthenticated): go to release notes
            logoLink.setAttribute('href', '/release-notes');
            logoLink.setAttribute('title', 'View Release Notes');
        } else {
            // Authenticated on home or other routes: go to release notes
            logoLink.setAttribute('href', '/release-notes');
            logoLink.setAttribute('title', 'View Release Notes');
        }
    }
    // Legacy routing for fallback compatibility
    async handleRouteLegacy(path) {
        // Hide all sections first
        this.hideAllSections();
        // Handle specific routes
        if (path === '/' || path === '/home') await this.showSection('home');
        else if (path === '/friends') await this.showSection('friends');
        else if (path === '/profile') await this.showSection('profile');
        else if (path === '/profile/me') await this.showUserProfile('me');
        else if (path.startsWith('/profile/')) {
            const username = path.split('/')[2];
            await this.showUserProfile(username);
        } else if (path === '/admin' || path.startsWith('/admin/')) await this.showSection('admin');
        else if (path === '/settings') await this.showSection('settings');
        else if (path === '/settings/security') await this.showSection('two-factor-settings');
        else if (path === '/settings/notifications') await this.showSection('notification-settings');
        else if (path === '/settings/sparkle-sources') await this.showSection('media-sources-settings');
        else if (path === '/settings/rss-feeds') await this.showSection('rss-feeds');
        else if (path.match(/^\/post\/\d+\/comment\/\d+$/)) {
            // Handle comment permalinks: /post/123/comment/456
            const pathParts = path.split('/');
            const postId = pathParts[2];
            const commentId = pathParts[4];
            await this.showComment(postId, commentId);
        } else if (path.startsWith('/post/')) {
            const postId = path.split('/')[2];
            // Check if there's a hash fragment for a comment
            const hash = window.location.hash;
            if (hash && hash.startsWith('#comment-')) {
                const commentId = hash.replace('#comment-', '');
                await this.showComment(postId, commentId);
            } else await this.showPost(postId);
        } else {
            // 404 - redirect to home
            this.navigate('/', true);
            return;
        }
    }
    // Show a main section
    async showSection(sectionName) {
        const section = document.getElementById(`${sectionName}-section`);
        if (section) {
            section.classList.remove('hidden');
            // Reset post detail view if switching away from home
            if (sectionName !== 'home') this.hidePostDetail();
            else // Reset home view when showing home section
            this.resetHomeView();
            // Trigger any section-specific initialization
            const event = new CustomEvent('section-shown', {
                detail: {
                    section: sectionName
                }
            });
            document.dispatchEvent(event);
        }
    }
    // Hide all content sections
    hideAllSections() {
        document.querySelectorAll('.content-section').forEach((section)=>{
            section.classList.add('hidden');
        });
    }
    // Update active navigation
    updateActiveNavigation(path) {
        try {
            // Remove active class from all nav links (both nav-link and menu-item classes)
            const navLinks = document.querySelectorAll('.nav-link, .menu-item');
            navLinks.forEach((link)=>{
                if (link && link.classList) link.classList.remove('active');
            });
            // Add active class to current route
            let activeSelector = null;
            if (path === '/' || path === '/home') activeSelector = 'a[href="/"], a[href="/home"], a[data-route="/"]';
            else if (path === '/friends') activeSelector = 'a[href="/friends"], a[data-route="/friends"]';
            else if (path === '/profile' || path.startsWith('/profile/')) activeSelector = 'a[href="/profile"], a[href="/profile/me"], a[data-route="/profile/me"]';
            else if (path === '/admin' || path.startsWith('/admin/')) activeSelector = 'a[href="/admin"], a[href*="/admin"], a[data-route*="/admin"]';
            else if (path === '/settings' || path.startsWith('/settings')) activeSelector = 'a[href="/settings"], a[href*="/settings"], a[data-route="/settings"], a[data-route*="/settings"]';
            else if (path === '/memories') activeSelector = 'a[href="/memories"], a[data-route="/memories"]';
            else if (path === '/groups' || path.startsWith('/groups/') || path.startsWith('/group/')) activeSelector = 'a[href="/groups"], a[data-route="/groups"]';
            else if (path === '/mascot-parade') activeSelector = 'a[href="/mascot-parade"], a[data-route="/mascot-parade"]';
            if (activeSelector) {
                const activeLink = document.querySelector(activeSelector);
                if (activeLink && activeLink.classList) activeLink.classList.add('active');
            }
        } catch (error) {
            (0, $eZQHH.default).warn('Error updating active navigation:', error);
        }
    }
    // Update page title
    updatePageTitle(path) {
        let title = 'Fun Old Times';
        if (path === '/friends') title = 'Friends - Fun Old Times';
        else if (path === '/profile') title = 'Profile - Fun Old Times';
        else if (path === '/profile/me') title = 'My Profile - Fun Old Times';
        else if (path.startsWith('/profile/')) {
            const username = path.split('/')[2];
            title = `${username} - Fun Old Times`;
        } else if (path === '/admin') title = 'Admin - Fun Old Times';
        else if (path === '/admin/audit-logs') title = 'Audit Logs - Admin - Fun Old Times';
        else if (path === '/admin/users') title = 'User Management - Admin - Fun Old Times';
        else if (path === '/admin/prompts') title = 'Writing Prompts - Admin - Fun Old Times';
        else if (path === '/admin/stats') title = 'Site Statistics - Admin - Fun Old Times';
        else if (path === '/admin/image-flags') title = 'Image Flags - Admin - Fun Old Times';
        else if (path === '/admin/widget-flags') title = 'Widget Flags - Admin - Fun Old Times';
        else if (path === '/admin/blocked-domains') title = 'Blocked Domains - Admin - Fun Old Times';
        else if (path === '/admin/oauth-clients') title = 'OAuth Clients - Admin - Fun Old Times';
        else if (path === '/admin/feature-flags') title = 'Feature Flags - Admin - Fun Old Times';
        else if (path.startsWith('/admin/')) title = 'Admin - Fun Old Times';
        else if (path === '/settings') title = 'Settings - Fun Old Times';
        else if (path === '/settings/security') title = 'Security Settings - Fun Old Times';
        else if (path === '/settings/notifications') title = 'Notification Settings - Fun Old Times';
        else if (path === '/settings/sparkle-sources') title = 'Sparkle Sources - Fun Old Times';
        else if (path === '/settings/rss-feeds') title = 'RSS Feeds Settings - Fun Old Times';
        else if (path === '/memories') title = 'Memories - Fun Old Times';
        else if (path === '/mascot-parade') title = 'Mascot Parade - Fun Old Times';
        else if (path.match(/^\/group\/(\d+)\/post\/(\d+)\/comment\/(\d+)$/)) title = 'Group comment - Fun Old Times';
        else if (path.match(/^\/group\/(\d+)\/post\/(\d+)$/)) title = 'Group post - Fun Old Times';
        else if (path.match(/^\/groups\/invites\//)) title = 'Group Invitation - Fun Old Times';
        else if (path === '/groups') title = 'Groups - Fun Old Times';
        else if (path === '/groups/new') title = 'Create Group - Fun Old Times';
        else if (path.match(/^\/groups\/(\d+)\/settings$/)) title = 'Group Settings - Fun Old Times';
        else if (path.match(/^\/groups\/(\d+)\/threads\/(\d+)$/)) title = 'Group thread - Fun Old Times';
        else if (path.match(/^\/groups\/(\d+)$/)) title = 'Group - Fun Old Times';
        else if (path.startsWith('/groups/')) title = 'Groups - Fun Old Times';
        else if (path === '/reset-password') title = 'Reset Password - Fun Old Times';
        else if (path.startsWith('/post/')) title = 'Post - Fun Old Times';
        // For unknown routes, default title "Fun Old Times" is used
        // The 404 component will display the "Page Not Found" message
        document.title = title;
    }
    async redirectToLogin() {
        this.setAuthReturnTo((0, $82c5ec211b0f131c$export$21b1a4469922ed9e)());
        this.hideAppShellForAuth();
        window.history.replaceState({}, '', '/login');
        this.currentRoute = '/login';
        await this.showLogin();
        this.updatePageTitle('/login');
        this.updateLogoLink('/login');
    }
    hideAppShellForAuth() {
        const loadingScreen = document.querySelector('#loadingScreen');
        const mainContent = document.querySelector('.main-content');
        const guestHost = document.getElementById('guest-route-host');
        if (loadingScreen) loadingScreen.style.display = 'none';
        if (mainContent) mainContent.style.display = 'none';
        if (guestHost) {
            guestHost.classList.add('hidden');
            guestHost.innerHTML = '';
        }
    }
    // Show login modal
    async showLogin() {
        this.hideAppShellForAuth();
        let authModal = document.querySelector('auth-modal');
        if (!authModal) {
            authModal = document.createElement('auth-modal');
            document.body.appendChild(authModal);
            // Wait for custom element to be defined and connected
            await customElements.whenDefined('auth-modal');
            // Give it a moment for connectedCallback to run
            await new Promise((resolve)=>setTimeout(resolve, 0));
        }
        // Ensure the element is connected and has the open method
        if (authModal.isConnected && typeof authModal.open === 'function') authModal.open('login', true);
        else {
            // Fallback: wait a bit more and try again
            await new Promise((resolve)=>setTimeout(resolve, 100));
            if (typeof authModal.open === 'function') authModal.open('login', true);
            else window.logger.error('AuthModal open method not available');
        }
    }
    // Show register modal
    async showRegister() {
        let authModal = document.querySelector('auth-modal');
        if (!authModal) {
            authModal = document.createElement('auth-modal');
            document.body.appendChild(authModal);
            // Wait for custom element to be defined and connected
            await customElements.whenDefined('auth-modal');
            // Give it a moment for connectedCallback to run
            await new Promise((resolve)=>setTimeout(resolve, 0));
        }
        // Ensure the element is connected and has the open method
        if (authModal.isConnected && typeof authModal.open === 'function') authModal.open('register', true);
        else {
            // Fallback: wait a bit more and try again
            await new Promise((resolve)=>setTimeout(resolve, 100));
            if (typeof authModal.open === 'function') authModal.open('register', true);
            else window.logger.error('AuthModal open method not available');
        }
    }
    setAuthReturnTo(path) {
        sessionStorage.setItem('fotAuthReturnTo', path);
    }
    navigateAfterAuth() {
        const returnTo = sessionStorage.getItem('fotAuthReturnTo');
        if (returnTo) {
            sessionStorage.removeItem('fotAuthReturnTo');
            this.navigate(returnTo, true);
            return;
        }
        const path = window.location.pathname;
        if (path === '/login' || path === '/register' || path.startsWith('/invite/')) this.navigate('/', true);
    }
    async openAuthModal(mode = 'login', options = {}) {
        let authModal = document.querySelector('auth-modal');
        if (!authModal) {
            authModal = document.createElement('auth-modal');
            document.body.appendChild(authModal);
            await customElements.whenDefined('auth-modal');
            await new Promise((resolve)=>setTimeout(resolve, 0));
        }
        if (mode === 'register' && typeof authModal.openRegisterWithOptions === 'function') authModal.openRegisterWithOptions(options);
        else if (typeof authModal.open === 'function') authModal.open(mode, false);
    }
    // Handle password reset page
    async handleResetPassword() {
        // Get the reset token from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        if (!token) {
            // No token provided, redirect to home
            this.navigate('/', true);
            return;
        }
        // Then open the auth modal in reset-password mode with the token
        setTimeout(()=>{
            const authModal = document.querySelector('auth-modal');
            if (authModal) authModal.openResetPassword(token);
        }, 100);
    }
    // Handle invitation page
    async handleInvitation() {
        // Extract invitation token from URL
        const pathParts = window.location.pathname.split('/');
        const invitationToken = pathParts[2]; // /invite/TOKEN
        if (!invitationToken) {
            // No token provided, redirect to home
            this.navigate('/', true);
            return;
        }
        // Show home page first using MainContent
        const mainContent = document.querySelector('main-content');
        if (mainContent) {
            const event = new CustomEvent('route-changed', {
                detail: {
                    route: '/'
                }
            });
            document.dispatchEvent(event);
        } else await this.showSection('home');
        // Then open the auth modal in register mode with the invitation token
        setTimeout(()=>{
            const authModal = document.querySelector('auth-modal');
            if (authModal) authModal.openRegister(invitationToken);
        }, 100);
    }
    // Handle email verification
    async handleEmailVerification() {
        // Extract verification token from URL
        const pathParts = window.location.pathname.split('/');
        const verificationToken = pathParts[2]; // /verify-email/TOKEN
        if (!verificationToken) {
            // No token provided, redirect to home
            this.navigate('/', true);
            return;
        }
        try {
            // Call the verification API
            const response = await window.API.request(`/auth/verify-email/${verificationToken}`, {
                method: 'GET'
            });
            if (response.verified) {
                // Show success message and redirect to login
                const mainContent = document.querySelector('main-content');
                if (mainContent) {
                    const event = new CustomEvent('route-changed', {
                        detail: {
                            route: '/'
                        }
                    });
                    document.dispatchEvent(event);
                } else this.showSection('home');
                setTimeout(()=>{
                    const authModal = document.querySelector('auth-modal');
                    if (authModal) {
                        authModal.open('login');
                        authModal.showAlert('Email verified successfully! You can now log in.', 'success');
                    }
                }, 100);
            }
        } catch (error) {
            (0, $eZQHH.default).error('Email verification failed:', error);
            // Show error and redirect to login
            const mainContent = document.querySelector('main-content');
            if (mainContent) {
                const event = new CustomEvent('route-changed', {
                    detail: {
                        route: '/'
                    }
                });
                document.dispatchEvent(event);
            } else this.showSection('home');
            setTimeout(()=>{
                const authModal = document.querySelector('auth-modal');
                if (authModal) {
                    authModal.open('login');
                    authModal.showAlert(error.message || 'Email verification failed', 'error');
                }
            }, 100);
        }
    }
    // Handle guest RSVP
    async handleGuestRSVP() {
        const url = new URL(window.location.href);
        const urlParams = url.searchParams;
        let token = urlParams.get('token');
        let magicToken = urlParams.get('magicToken');
        const pathname = window.location.pathname;
        // Support legacy path formats like /events/guest-verify/:token or /events/guest-access/:magicToken
        const pathSegments = pathname.split('/').filter(Boolean);
        if (pathSegments.length >= 3 && pathSegments[0] === 'events') {
            const routeType = pathSegments[1];
            const pathToken = pathSegments[2];
            if (routeType === 'guest-verify' && pathToken) {
                token = token || pathToken;
                url.searchParams.set('token', token);
                url.searchParams.delete('magicToken');
                magicToken = null;
                // Normalize URL to query-param version to avoid leaking token in path
                url.pathname = '/events/guest-verify';
                window.history.replaceState({}, '', url);
            } else if (routeType === 'guest-access' && pathToken) {
                magicToken = magicToken || pathToken;
                url.searchParams.set('magicToken', pathToken);
                url.pathname = '/events/guest-access';
                window.history.replaceState({}, '', url);
            }
        }
        if (!token && magicToken && !pathname.startsWith('/events/guest-access')) {
            token = magicToken;
            url.searchParams.set('token', token);
            url.searchParams.delete('magicToken');
            magicToken = null;
            window.history.replaceState({}, '', url);
        }
        this.showGuestRouteLayout();
        const guestHost = document.getElementById('guest-route-host');
        if (!guestHost) {
            (0, $eZQHH.default).warn('Guest route host not found');
            return;
        }
        let guestRSVP = guestHost.querySelector('guest-rsvp');
        if (!guestRSVP) guestRSVP = document.createElement('guest-rsvp');
        guestHost.innerHTML = '';
        guestHost.appendChild(guestRSVP);
        if (token) guestRSVP.setAttribute('token', token);
        if (magicToken) {
            url.searchParams.set('magicToken', magicToken);
            window.history.replaceState({}, '', url);
        }
    }
    showGuestRouteLayout() {
        const mainContainer = document.querySelector('.main-content');
        if (mainContainer) mainContainer.style.display = 'block';
        const primaryContent = document.querySelector('main-content');
        if (primaryContent) primaryContent.style.display = 'none';
        const guestHost = document.getElementById('guest-route-host');
        if (guestHost) guestHost.classList.remove('hidden');
    }
    resetGuestRouteLayout() {
        const guestHost = document.getElementById('guest-route-host');
        if (guestHost) {
            guestHost.innerHTML = '';
            guestHost.classList.add('hidden');
        }
        const primaryContent = document.querySelector('main-content');
        if (primaryContent) primaryContent.style.display = '';
    }
    // Show specific user profile
    async showUserProfile(username) {
        // Show the profile section with the user-profile component
        await this.showSection('profile');
        // Trigger event to load the specific user profile
        const event = new CustomEvent('profile-load', {
            detail: {
                username: username
            }
        });
        document.dispatchEvent(event);
    }
    // Show specific post
    async showPost(postId) {
        // Show the home section first
        await this.showSection('home');
        // Then show the post detail component
        setTimeout(()=>{
            const postDetail = document.querySelector('post-detail');
            if (postDetail) {
                postDetail.setAttribute('post-id', postId);
                postDetail.style.display = 'block';
            } else {
                // Create and show post detail component
                const newPostDetail = document.createElement('post-detail');
                newPostDetail.setAttribute('post-id', postId);
                newPostDetail.style.display = 'block';
                // Insert after the posts feed
                const postsFeed = document.querySelector('posts-feed');
                if (postsFeed && postsFeed.parentNode) postsFeed.parentNode.insertBefore(newPostDetail, postsFeed.nextSibling);
            }
            // Hide the posts feed to show only the individual post
            const postsFeed = document.querySelector('posts-feed');
            if (postsFeed) postsFeed.style.display = 'none';
            // Hide the post writer
            const postWriter = document.querySelector('post-writer');
            if (postWriter) postWriter.style.display = 'none';
        }, 100);
    }
    // Show specific comment (within a post)
    async showComment(postId, commentId) {
        try {
            // Show the post first
            await this.showPost(postId);
            // Wait for the comments section to be available
            const commentsSection = await this.waitForElement('comments-section');
            if (!commentsSection) {
                (0, $eZQHH.default).warn('Comments section not found');
                return;
            }
            // Trigger comment loading if not already loaded
            if (!commentsSection.commentsLoaded) await commentsSection.loadComments();
            // Wait for the specific comment element to be available
            const commentElement = await this.waitForElement(`[data-comment-id="${commentId}"]`);
            if (!commentElement) {
                (0, $eZQHH.default).warn(`Comment ${commentId} not found in post ${postId}`);
                return;
            }
            // Scroll to the comment
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            // Add a highlight effect
            this.highlightComment(commentElement);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load comment:', error);
        }
    }
    // Helper to wait for an element to appear in the DOM
    waitForElement(selector, timeout = 5000) {
        return new Promise((resolve)=>{
            const element = document.querySelector(selector);
            if (element) {
                resolve(element);
                return;
            }
            const observer = new MutationObserver(()=>{
                const element = document.querySelector(selector);
                if (element) {
                    observer.disconnect();
                    resolve(element);
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            // Timeout fallback
            setTimeout(()=>{
                observer.disconnect();
                resolve(null);
            }, timeout);
        });
    }
    // Helper to highlight a comment
    highlightComment(commentElement) {
        commentElement.classList.add('comment-highlight');
        setTimeout(()=>{
            commentElement.classList.remove('comment-highlight');
        }, 3000);
    }
    // Check if link is internal
    isInternalLink(link, event) {
        const href = link.getAttribute('href');
        const target = link.getAttribute('target');
        if (target && target !== '_self') return false;
        if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return false;
        // Skip external links
        if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('mailto:')) return false;
        // Skip hash-only links that we want to handle as routes
        if (href.startsWith('#')) return true;
        // Handle relative and absolute internal paths
        return true;
    }
    // Get current route
    getCurrentRoute() {
        return this.currentRoute;
    }
    // Check if we're on a specific route
    isRoute(path) {
        return this.currentRoute === path;
    }
    // Check authentication status dynamically (fallback to checking auth-status component)
    checkAuthStatus() {
        // First check cached value
        if (this.isAuthenticated) return true;
        // Fallback: check if auth-status component shows user as authenticated
        const authStatus = document.querySelector('auth-status');
        if (authStatus && authStatus.user) {
            this.isAuthenticated = true;
            return true;
        }
        return false;
    }
    // Hide post detail view
    hidePostDetail() {
        const postDetail = document.querySelector('post-detail');
        if (postDetail) postDetail.style.display = 'none';
    }
    // Reset home view to show normal feed
    resetHomeView() {
        const postsFeed = document.querySelector('posts-feed');
        const postWriter = document.querySelector('post-writer');
        const postDetail = document.querySelector('post-detail');
        if (postsFeed) postsFeed.style.display = 'block';
        if (postWriter) postWriter.style.display = 'block';
        if (postDetail) postDetail.style.display = 'none';
    }
}
const $8632dcb0fdec8888$export$5375cda95f0b0eb4 = new $8632dcb0fdec8888$var$Router();
// Make router available globally
window.router = $8632dcb0fdec8888$export$5375cda95f0b0eb4;
var // Export for use in other modules
$8632dcb0fdec8888$export$2e2bcd8739ae039 = $8632dcb0fdec8888$export$5375cda95f0b0eb4;


/** @type {Record<string, boolean>} */ let $4bd131ffd9e749e2$var$features = {};
function $4bd131ffd9e749e2$export$9378dc6d04015c6c(nextFeatures) {
    $4bd131ffd9e749e2$var$features = {
        ...nextFeatures
    };
}
function $4bd131ffd9e749e2$export$87e0f7dd6dec932f(key) {
    return Boolean($4bd131ffd9e749e2$var$features[key]);
}
function $4bd131ffd9e749e2$export$e02fc95a45760598() {
    return {
        ...$4bd131ffd9e749e2$var$features
    };
}






// Activity Panel Web Component
class $c9e818c1ca68a5d1$var$ProtectedComponent extends HTMLElement {
    constructor(){
        super();
        this.currentUser = null;
    }
    connectedCallback() {
        this.connectAuthListeners();
    }
    disconnectedCallback() {
        this.disconnectAuthListeners();
    }
    setCurrentUser(user) {
        this.currentUser = user;
        if (this.currentUser) {
            // Use loadIfVisible if available, otherwise call load directly
            if (typeof this.loadIfVisible === 'function') this.loadIfVisible();
            else this.load();
            return;
        }
        this.clear();
    }
    isAuthenticated() {
        return this.currentUser !== null;
    }
    load() {
    // abstract method to load content
    }
    clear() {
    // abstract method to clear content when logged out
    }
    handleAuthSuccess(e) {
        this.setCurrentUser(e.detail?.user || {});
    }
    handleUserLoggedOut() {
        this.setCurrentUser(null);
    }
    handleAuthStatusLoaded(e) {
        if (e.detail.authenticated) this.setCurrentUser(e.detail.user || {});
        else this.setCurrentUser(null);
    }
    connectAuthListeners() {
        // Listen for authentication events
        document.addEventListener('auth-success', this.handleAuthSuccess.bind(this));
        document.addEventListener('user-logged-out', this.handleUserLoggedOut.bind(this));
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded.bind(this));
    }
    disconnectAuthListeners() {
        // Remove event listeners when component is removed
        document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        document.removeEventListener('auth-success', this.handleAuthSuccess);
        document.removeEventListener('user-logged-out', this.handleUserLoggedOut);
    }
}
var $c9e818c1ca68a5d1$export$2e2bcd8739ae039 = $c9e818c1ca68a5d1$var$ProtectedComponent;


/**
 * HTML utility functions
 */ /**
 * Escape HTML special characters to prevent XSS attacks
 * @param {string} text - Text to escape
 * @returns {string} Escaped HTML string
 */ function $89169a3d85b55cc3$export$4cf11838cdc2a8a8(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}


/** Whimsical icons and labels for group threads. */ 
const $605b34b4fa47af77$export$62e93e481bfe83e0 = "\uD83E\uDDF5";
const $605b34b4fa47af77$export$ee2cc61bd9b9c54a = "\uD83D\uDCA4";
function $605b34b4fa47af77$export$ed41c87da8cb7bf4(name, { archived: archived = false } = {}) {
    const icon = archived ? $605b34b4fa47af77$export$ee2cc61bd9b9c54a : $605b34b4fa47af77$export$62e93e481bfe83e0;
    return `${icon} ${String(name ?? '')}`;
}
function $605b34b4fa47af77$export$275c9ad96473df21(name, options = {}) {
    const icon = options.archived ? $605b34b4fa47af77$export$ee2cc61bd9b9c54a : $605b34b4fa47af77$export$62e93e481bfe83e0;
    return `${icon} ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(name)}`;
}



class $43c469426bf0d475$var$ActivityPanel extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.activities = [];
        this.isLoading = false;
        this.currentPage = 1;
        this.hasMore = true;
        this.isExpanded = false;
        this.isWideScreen = window.innerWidth >= 1024;
        this.currentUser = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
        this.attachEventListeners();
        this.setupResponsiveHandling();
    }
    render() {
        // Always show the component, but control content visibility via auth
        this.style.display = 'block';
        this.innerHTML = `
      <div class="activity-panel-container">
        <!-- Mobile drag handle - positioned independently -->
        <div class="drag-handle" id="dragHandle" style="display: ${this.isAuthenticated() ? 'flex' : 'none'};">
          <div class="lightning-bolt">
            \u{26A1}
          </div>
          <div class="drag-indicator"></div>
        </div>
        
        <!-- Activity panel -->
        <div class="activity-panel ${this.isWideScreen ? 'always-visible' : ''}" id="activityPanel">
          <div class="panel-content" id="panelContent" style="display: none;">
            <div class="panel-header">
              <h3>\u{26A1} Friend Activity</h3>
              <button class="close-panel-btn" id="closePanelBtn" title="Close">&times;</button>
            </div>
            
            <div class="activities-container" id="activitiesContainer">
              <div class="loading-state" id="loadingState">
                <div class="spinner"></div>
                <div>Loading activities...</div>
              </div>
              
              <div class="activities-list" id="activitiesList" style="display: none;">
                <!-- Activities will be loaded here -->
              </div>
              
              <div class="load-more-container" id="loadMoreContainer" style="display: none;">
                <button class="load-more-btn" id="loadMoreBtn">
                  \u{26A1} Load More Activities
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Overlay for mobile blur effect -->
        <div class="activity-overlay" id="activityOverlay"></div>
      </div>
    `;
    }
    attachEventListeners() {
        const dragHandle = this.querySelector('#dragHandle');
        const closePanelBtn = this.querySelector('#closePanelBtn');
        const loadMoreBtn = this.querySelector('#loadMoreBtn');
        const activitiesContainer = this.querySelector('#activitiesContainer');
        const activityOverlay = this.querySelector('#activityOverlay');
        // Toggle handle for mobile - simple click to open/close
        if (dragHandle) dragHandle.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.togglePanel();
        });
        // Close button
        closePanelBtn.addEventListener('click', ()=>{
            this.closePanel();
        });
        // Overlay click to close panel
        if (activityOverlay) activityOverlay.addEventListener('click', ()=>{
            this.closePanel();
        });
        // Load more button
        loadMoreBtn.addEventListener('click', ()=>{
            this.loadMoreActivities();
        });
        // Infinite scroll
        activitiesContainer.addEventListener('scroll', ()=>{
            this.handleScroll();
        });
        // Activity item clicks
        this.addEventListener('click', (e)=>{
            const activityLink = e.target.closest('.activity-link');
            if (activityLink) {
                e.preventDefault(); // Prevent default link behavior
                const href = activityLink.getAttribute('href');
                if (href && href !== '#') {
                    // Use client-side router for navigation
                    if (window.router) window.router.navigate(href);
                    else // Fallback to regular navigation
                    window.location.href = href;
                }
                // Close panel on mobile after navigation
                if (!this.isWideScreen) setTimeout(()=>this.closePanel(), 100);
            }
        });
    }
    setupResponsiveHandling() {
        const handleResize = ()=>{
            const wasWideScreen = this.isWideScreen;
            this.isWideScreen = window.innerWidth >= 1024;
            if (wasWideScreen !== this.isWideScreen) {
                const panel = this.querySelector('.activity-panel');
                if (this.isWideScreen) {
                    // Switch to always-visible mode
                    panel.classList.add('always-visible');
                    panel.classList.remove('expanded');
                    this.isExpanded = false;
                } else {
                    // Switch to mobile mode
                    panel.classList.remove('always-visible');
                    if (this.isExpanded) panel.classList.add('expanded');
                }
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check
    }
    showPanel() {
        const panelContent = this.querySelector('#panelContent');
        const dragHandle = this.querySelector('#dragHandle');
        if (panelContent) panelContent.style.display = 'flex';
        // Show drag handle on mobile when authenticated
        if (dragHandle && !this.isWideScreen) dragHandle.style.display = 'flex';
        // Add authenticated class to body for CSS styling
        document.body.classList.add('authenticated');
    // Load activities when panel is shown
    }
    hidePanel() {
        const panelContent = this.querySelector('#panelContent');
        const dragHandle = this.querySelector('#dragHandle');
        if (panelContent) panelContent.style.display = 'none';
        // Hide drag handle when not authenticated
        if (dragHandle) dragHandle.style.display = 'none';
        // Remove authenticated class from body
        document.body.classList.remove('authenticated');
        this.closePanel();
    }
    togglePanel() {
        if (this.isWideScreen) return;
        if (this.isExpanded) this.closePanel();
        else this.expandPanel();
    }
    expandPanel() {
        if (this.isWideScreen) return;
        const panel = this.querySelector('.activity-panel');
        const dragHandle = this.querySelector('#dragHandle');
        const overlay = this.querySelector('#activityOverlay');
        panel.classList.add('expanded');
        if (dragHandle) dragHandle.classList.add('expanded');
        if (overlay) overlay.classList.add('visible');
        // Prevent body scrolling on mobile
        document.body.style.overflow = 'hidden';
        this.isExpanded = true;
    }
    closePanel() {
        if (this.isWideScreen) return;
        const panel = this.querySelector('.activity-panel');
        const dragHandle = this.querySelector('#dragHandle');
        const overlay = this.querySelector('#activityOverlay');
        panel.classList.remove('expanded');
        if (dragHandle) dragHandle.classList.remove('expanded');
        if (overlay) overlay.classList.remove('visible');
        // Restore body scrolling
        document.body.style.overflow = '';
        this.isExpanded = false;
    }
    setCurrentUser(user) {
        super.setCurrentUser(user);
        if (user) {
            this.showPanel();
            return;
        }
        this.hidePanel();
    }
    async load() {
        if (this.isLoading) return;
        this.isLoading = true;
        const loadingState = this.querySelector('#loadingState');
        const activitiesList = this.querySelector('#activitiesList');
        try {
            const response = await window.API.activities.getFriends(1, 20);
            this.activities = response.activities || [];
            this.hasMore = response.hasMore || false;
            this.currentPage = 1;
            this.renderActivities();
            this.updateLoadMoreButton();
            if (loadingState) loadingState.style.display = 'none';
            if (activitiesList) activitiesList.style.display = 'block';
        } catch (error) {
            window.logger.error('Failed to load activities:', error);
            this.renderError();
        } finally{
            this.isLoading = false;
        }
    }
    async loadMoreActivities() {
        if (this.isLoading || !this.hasMore) return;
        this.isLoading = true;
        const loadMoreBtn = this.querySelector('#loadMoreBtn');
        loadMoreBtn.disabled = true;
        loadMoreBtn.textContent = "\u23F3 Loading...";
        try {
            const response = await window.API.activities.getFriends(this.currentPage + 1, 20);
            const newActivities = response.activities || [];
            this.activities = [
                ...this.activities,
                ...newActivities
            ];
            this.hasMore = response.hasMore || false;
            this.currentPage++;
            this.renderActivities();
            this.updateLoadMoreButton();
        } catch (error) {
            window.logger.error('Failed to load more activities:', error);
        } finally{
            this.isLoading = false;
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = "\u26A1 Load More Activities";
        }
    }
    handleScroll() {
        // Use requestAnimationFrame to batch layout reads and avoid forced reflows
        requestAnimationFrame(()=>{
            const container = this.querySelector('#activitiesContainer');
            if (!container) return;
            const threshold = 100; // pixels from bottom
            // Batch all layout property reads
            const scrollTop = container.scrollTop;
            const clientHeight = container.clientHeight;
            const scrollHeight = container.scrollHeight;
            if (scrollTop + clientHeight >= scrollHeight - threshold) {
                if (this.hasMore && !this.isLoading) this.loadMoreActivities();
            }
        });
    }
    renderActivities() {
        const activitiesList = this.querySelector('#activitiesList');
        if (!activitiesList) {
            window.logger.error('activitiesList element not found');
            return;
        }
        if (this.activities.length === 0) {
            activitiesList.innerHTML = `
        <div class="empty-state">
          <div class="empty-icon">\u{26A1}</div>
          <h4>No friend activity yet</h4>
          <p>When your friends post or comment, you'll see their activity here!</p>
        </div>
      `;
            return;
        }
        activitiesList.innerHTML = this.activities.map((activity)=>this.renderActivity(activity)).join('');
    }
    renderActivity(activity) {
        const timeAgo = this.formatTimeAgo(new Date(activity.createdAt));
        const activityIcon = this.getActivityIcon(activity.type);
        const activityText = this.getActivityText(activity);
        const activityUser = this.getActivityUser(activity);
        const targetLink = this.getTargetLink(activity);
        const isGroupActivity = activity.type === 'group_post_created' || activity.type === 'group_comment_created';
        const targetBody = isGroupActivity ? this.renderGroupActivityTarget(activity) : this.renderDefaultActivityTarget(activity);
        return `
      <div class="activity-item">
        <div class="activity-header">
          <span class="activity-icon">${activityIcon}</span>
          <span class="activity-user">${activityUser}</span>
          <span class="activity-action">${activityText}</span>
        </div>
          <div class="activity-target">
            <a href="${targetLink}" class="activity-link">
              ${targetBody}
            </a>
          </div>
        <div class="activity-time">${timeAgo}</div>
      </div>
    `;
    }
    renderDefaultActivityTarget(activity) {
        const activityTitle = this.getActivityTitle(activity);
        return `
      <div class="activity-target-title">${activityTitle}</div>
      ${activity.target.postType === 'mood' && activity.target.moodStatus ? `
        <div class="activity-target-content mood-activity">
          - ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.target.moodStatus)}
        </div>
      ` : activity.target.content ? `
        <div class="activity-target-content">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.target.content)}</div>
      ` : ''}
    `;
    }
    renderGroupActivityTarget(activity) {
        const groupName = (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.target.groupName || activity.target.title || '');
        const threadName = activity.target.threadName;
        const postPreview = activity.target.postPreview;
        const content = activity.target.content;
        let contextTitle = '';
        if (threadName) contextTitle = `<div class="activity-target-title">${(0, $605b34b4fa47af77$export$275c9ad96473df21)(threadName)}</div>`;
        else if (postPreview && activity.type === 'group_comment_created') contextTitle = `<div class="activity-target-title activity-target-post-preview">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(postPreview)}</div>`;
        return `
      ${groupName ? `<div class="activity-target-group">${groupName}</div>` : ''}
      ${contextTitle}
      ${activity.type === 'group_post_created' && content ? `
        <div class="activity-target-content">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(content)}</div>
      ` : ''}
      ${activity.type === 'group_comment_created' && content ? `
        <div class="activity-target-content activity-target-comment">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(content)}</div>
      ` : ''}
    `;
    }
    getActivityIcon(type) {
        switch(type){
            case 'post_created':
                return "\uD83D\uDCDD";
            case 'comment_created':
                return "\uD83D\uDCAC";
            case 'group_post_created':
                return "\uD83D\uDCDD";
            case 'group_comment_created':
                return "\uD83D\uDCAC";
            case 'friend_request_sent':
                return "\uD83D\uDC65";
            case 'friend_request_accepted':
                return "\uD83D\uDC65";
            case 'invitation_accepted':
                return "\uD83D\uDC65";
            default:
                return "\u26A1";
        }
    }
    getActivityText(activity) {
        switch(activity.type){
            case 'post_created':
                if (activity.target.postType === 'mood') return `mood ${activity.target.moodIcon}`;
                return 'posted';
            case 'comment_created':
                return 'commented';
            case 'group_post_created':
                return 'posted in';
            case 'group_comment_created':
                return 'commented in';
            case 'friend_request_accepted':
                return 'friended';
            case 'invitation_accepted':
                return 'friended';
            case 'friend_request_sent':
                return '';
            default:
                return 'did something';
        }
    }
    getActivityUser(activity) {
        return `<user-mention username="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.user.username)}" mentioned-user-id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.user.id)}" user-id="${this.currentUser.id}"></user-mention>`;
    }
    getActivityTitle(activity) {
        switch(activity.type){
            case 'invitation_accepted':
            case 'friend_request_sent':
            case 'friend_request_accepted':
                if (activity.user.id === this.currentUser.id) // this happens when it's an email invitation
                return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.target.title);
                return `<user-mention username="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.target.title)}" real-username="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.target.title)}" user-id="${this.currentUser.id}"></user-mention>`;
            default:
                return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(activity.target.title);
        }
    }
    getTargetLink(activity) {
        switch(activity.type){
            case 'post_created':
                return `/post/${activity.target.id}`;
            case 'comment_created':
                return `/post/${activity.target.postId}/comment/${activity.target.id}`;
            case 'group_post_created':
                {
                    const groupId = activity.target.groupId;
                    const postId = activity.target.groupPostId;
                    if (!groupId || !postId) return '/groups';
                    return (0, $2bb3cd4399004fe3$export$611b42c8bf9737ff)({
                        groupId: groupId,
                        postId: postId
                    });
                }
            case 'group_comment_created':
                {
                    const groupId = activity.target.groupId;
                    const postId = activity.target.groupPostId;
                    const commentId = activity.target.id;
                    if (!groupId || !postId || !commentId) return '/groups';
                    return (0, $2bb3cd4399004fe3$export$634034df907f30cd)({
                        groupId: groupId,
                        postId: postId,
                        commentId: commentId
                    });
                }
            case 'friend_request_accepted':
            case 'friend_added':
                return `/profile/${activity.target.username}`;
            case 'invitation_accepted':
            case 'friend_request_sent':
                return '/friends?tab=requests';
            default:
                return '/';
        }
    }
    updateLoadMoreButton() {
        const loadMoreContainer = this.querySelector('#loadMoreContainer');
        loadMoreContainer.style.display = this.hasMore ? 'block' : 'none';
    }
    renderError() {
        const activitiesList = this.querySelector('#activitiesList');
        activitiesList.innerHTML = `
      <div class="error-state">
        <div class="error-icon">\u{1F61E}</div>
        <h4>Failed to load activities</h4>
        <p>There was an error loading friend activities. Please refresh to try again.</p>
      </div>
    `;
        const loadingState = this.querySelector('#loadingState');
        loadingState.style.display = 'none';
        activitiesList.style.display = 'block';
    }
    formatTimeAgo(date) {
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return 'just now';
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours}h ago`;
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7) return `${diffInDays}d ago`;
        return date.toLocaleDateString();
    }
}
// Register the custom element
customElements.define('activity-panel', $43c469426bf0d475$var$ActivityPanel);



const $b3db68075515588b$var$STORAGE_KEY = 'add-friend-cta-dismissed';
class $b3db68075515588b$var$AddFriendCTA extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isDismissed = false;
        this.friendCount = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkDismissed();
        // If user is already set (e.g., on page refresh), check and render
        if (this.currentUser && !this.isDismissed) this.load();
        // Bind event handlers for cleanup
        this.handleFriendUpdate = ()=>this.loadFriendCount();
        this.handleRouteChange = ()=>{
            // Re-render when route changes to update close button visibility
            // Just re-render with current friend count - it should already be loaded
            if (this.currentUser && !this.isDismissed) {
                this.render();
                this.attachEventListeners();
            }
        };
        // Listen for friend-related events to update count
        document.addEventListener('friend-request-sent', this.handleFriendUpdate);
        document.addEventListener('friend-request-accepted', this.handleFriendUpdate);
        document.addEventListener('friend-removed', this.handleFriendUpdate);
        // Listen for route changes to update close button visibility
        document.addEventListener('route-changed', this.handleRouteChange);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.handleFriendUpdate) {
            document.removeEventListener('friend-request-sent', this.handleFriendUpdate);
            document.removeEventListener('friend-request-accepted', this.handleFriendUpdate);
            document.removeEventListener('friend-removed', this.handleFriendUpdate);
        }
        if (this.handleRouteChange) document.removeEventListener('route-changed', this.handleRouteChange);
    }
    checkDismissed() {
        try {
            this.isDismissed = localStorage.getItem($b3db68075515588b$var$STORAGE_KEY) === 'true';
        } catch (_e) {
            // localStorage might not be available
            this.isDismissed = false;
        }
    }
    getCurrentRoute() {
        // Try multiple methods to get the current route
        // 1. Router's current route (most reliable)
        if (window.router && typeof window.router.getCurrentRoute === 'function') {
            const route = window.router.getCurrentRoute();
            if (route) return route;
        }
        // 2. Location pathname (fallback)
        if (window.location && window.location.pathname) return window.location.pathname;
        // 3. Default to home
        return '/';
    }
    async loadFriendCount() {
        if (!this.currentUser) return;
        try {
            const response = await window.API.request('/friends');
            this.friendCount = response.counts?.friends || 0;
            // Re-render to update close button visibility
            if (!this.isDismissed) {
                this.render();
                this.attachEventListeners();
            }
        } catch (error) {
            window.logger.error('Failed to load friend count', error);
            this.friendCount = 0;
        }
    }
    async load() {
        // Re-check dismissed status in case it changed
        this.checkDismissed();
        if (this.isDismissed) {
            this.innerHTML = '';
            return;
        }
        // Load friend count first
        await this.loadFriendCount();
        this.render();
        this.attachEventListeners();
    }
    clear() {
        this.innerHTML = '';
    }
    dismiss() {
        try {
            localStorage.setItem($b3db68075515588b$var$STORAGE_KEY, 'true');
            this.isDismissed = true;
            this.clear();
        } catch (_e) {
            // localStorage might not be available
            this.clear();
        }
    }
    render() {
        // Check if we're on the friends page
        const currentRoute = this.getCurrentRoute();
        const isOnFriendsPage = currentRoute === '/friends';
        // Show close button only if:
        // 1. Not on friends page (on main posts screen)
        // 2. User has 2+ friends
        const showCloseButton = !isOnFriendsPage && this.friendCount >= 2;
        this.innerHTML = `
      <section class="add-friend-cta">
        <div class="cta-content">
          <span class="cta-icon">\u{1F91D}</span>
          <span class="cta-text">Invite a friend to join Fun Old Times!</span>
          <button class="btn-cta" id="inviteFriendBtn" type="button">
            Add Friend
          </button>
        </div>
        ${showCloseButton ? `
          <button class="cta-close" id="closeBtn" type="button" aria-label="Close">
            \xd7
          </button>
        ` : ''}
      </section>
    `;
    }
    attachEventListeners() {
        const inviteBtn = this.querySelector('#inviteFriendBtn');
        if (inviteBtn) inviteBtn.addEventListener('click', ()=>{
            this.openInviteModal();
        });
        const closeBtn = this.querySelector('#closeBtn');
        if (closeBtn) closeBtn.addEventListener('click', ()=>{
            this.dismiss();
        });
    }
    // Open the invite friend modal
    openInviteModal() {
        let inviteModal = document.querySelector('invite-friend-modal');
        if (!inviteModal) {
            inviteModal = document.createElement('invite-friend-modal');
            document.body.appendChild(inviteModal);
        }
        inviteModal.open();
    }
}
customElements.define('add-friend-cta', $b3db68075515588b$var$AddFriendCTA);
var $b3db68075515588b$export$2e2bcd8739ae039 = $b3db68075515588b$var$AddFriendCTA;



const $4d5d12ec0b64bee1$export$d77a6d5ed96f36d0 = 'home-promo-rotation-index';
const $4d5d12ec0b64bee1$export$d587129864188c8e = {
    'invite-friend': 'add-friend-cta-dismissed',
    'create-group': 'home-promo-dismissed-create-group',
    'add-rss-feed': 'home-promo-dismissed-add-rss-feed'
};
const $4d5d12ec0b64bee1$export$c78b60b16d4567e6 = [
    {
        id: 'invite-friend',
        icon: "\uD83E\uDD1D",
        text: 'Invite a friend to join Fun Old Times!',
        buttonLabel: 'Add Friend',
        action: 'invite-modal'
    },
    {
        id: 'create-group',
        icon: "\uD83C\uDF31",
        text: 'Start a group for your crew!',
        buttonLabel: 'Create Group',
        action: 'navigate-groups-new'
    },
    {
        id: 'add-rss-feed',
        icon: "\uD83D\uDCE1",
        text: "Own your blog \u2014 import it here via RSS",
        buttonLabel: 'Add Feed',
        action: 'navigate-rss-feeds'
    }
];
const $4d5d12ec0b64bee1$export$5672934650c3eabe = $4d5d12ec0b64bee1$export$c78b60b16d4567e6.map((v)=>v.id);
/**
 * @component home-promo-banner
 * @css home-promo-banner.css
 * @primitives .btn-cta
 *
 * Rotating home-feed pill CTA: invite friend, create group, add RSS feed.
 */ class $4d5d12ec0b64bee1$var$HomePromoBanner extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.friendCount = 0;
        this.groupCount = 0;
        this.rssFeedCount = 0;
        this.activeVariant = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleFriendUpdate = ()=>this.loadCounts();
        this.handleRouteChange = ()=>{
            if (this.currentUser) this.load();
        };
        document.addEventListener('friend-request-sent', this.handleFriendUpdate);
        document.addEventListener('friend-request-accepted', this.handleFriendUpdate);
        document.addEventListener('friend-removed', this.handleFriendUpdate);
        document.addEventListener('route-changed', this.handleRouteChange);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('friend-request-sent', this.handleFriendUpdate);
        document.removeEventListener('friend-request-accepted', this.handleFriendUpdate);
        document.removeEventListener('friend-removed', this.handleFriendUpdate);
        document.removeEventListener('route-changed', this.handleRouteChange);
    }
    isDismissed(variantId) {
        try {
            return localStorage.getItem($4d5d12ec0b64bee1$export$d587129864188c8e[variantId]) === 'true';
        } catch (_e) {
            return false;
        }
    }
    isEligible(variantId) {
        if (this.isDismissed(variantId)) return false;
        if (variantId === 'create-group' && this.groupCount > 0) return false;
        if (variantId === 'add-rss-feed' && this.rssFeedCount > 0) return false;
        return true;
    }
    getEligibleVariantIds() {
        return $4d5d12ec0b64bee1$export$5672934650c3eabe.filter((id)=>this.isEligible(id));
    }
    advanceRotationIndex() {
        try {
            const current = parseInt(localStorage.getItem($4d5d12ec0b64bee1$export$d77a6d5ed96f36d0) || '0', 10);
            localStorage.setItem($4d5d12ec0b64bee1$export$d77a6d5ed96f36d0, String(current + 1));
            return current;
        } catch (_e) {
            return 0;
        }
    }
    pickVariant() {
        const eligible = this.getEligibleVariantIds();
        if (eligible.length === 0) return null;
        const rotationIdx = this.advanceRotationIndex();
        for(let i = 0; i < $4d5d12ec0b64bee1$export$5672934650c3eabe.length; i += 1){
            const candidate = $4d5d12ec0b64bee1$export$5672934650c3eabe[(rotationIdx + i) % $4d5d12ec0b64bee1$export$5672934650c3eabe.length];
            if (eligible.includes(candidate)) return $4d5d12ec0b64bee1$export$c78b60b16d4567e6.find((v)=>v.id === candidate) || null;
        }
        return null;
    }
    async loadCounts() {
        if (!this.currentUser) return;
        try {
            const [friendsRes, groupsRes, rssRes] = await Promise.all([
                window.API.request('/friends'),
                window.API.request('/groups'),
                window.API.rss.list()
            ]);
            this.friendCount = friendsRes.counts?.friends || 0;
            this.groupCount = Array.isArray(groupsRes.groups) ? groupsRes.groups.length : 0;
            this.rssFeedCount = Array.isArray(rssRes) ? rssRes.length : 0;
        } catch (error) {
            window.logger?.error('Failed to load home promo banner counts', error);
            this.friendCount = 0;
            this.groupCount = 0;
            this.rssFeedCount = 0;
        }
    }
    async load() {
        if (!this.currentUser) {
            this.clear();
            return;
        }
        if (this._loadInFlight) return this._loadInFlight;
        this._loadInFlight = this._load();
        try {
            await this._loadInFlight;
        } finally{
            this._loadInFlight = null;
        }
    }
    async _load() {
        await this.loadCounts();
        this.activeVariant = this.pickVariant();
        if (!this.activeVariant) {
            this.clear();
            return;
        }
        this.render();
        this.attachEventListeners();
    }
    clear() {
        this.innerHTML = '';
        this.activeVariant = null;
    }
    dismissCurrentVariant() {
        if (!this.activeVariant) return;
        try {
            localStorage.setItem($4d5d12ec0b64bee1$export$d587129864188c8e[this.activeVariant.id], 'true');
        } catch (_e) {
        // ignore
        }
        this.clear();
    }
    showCloseButton() {
        if (!this.activeVariant) return false;
        if (this.activeVariant.id === 'invite-friend') return this.friendCount >= 2;
        return true;
    }
    render() {
        const variant = this.activeVariant;
        if (!variant) return;
        const showCloseButton = this.showCloseButton();
        this.innerHTML = `
      <section class="home-promo-banner" aria-label="${variant.text}">
        <div class="promo-content">
          <span class="promo-icon" aria-hidden="true">${variant.icon}</span>
          <span class="promo-text">${variant.text}</span>
          <button class="btn-cta" id="promoActionBtn" type="button">
            ${variant.buttonLabel}
          </button>
        </div>
        ${showCloseButton ? `
          <button class="promo-close" id="promoCloseBtn" type="button" aria-label="Close">
            \xd7
          </button>
        ` : ''}
      </section>
    `;
    }
    attachEventListeners() {
        const actionBtn = this.querySelector('#promoActionBtn');
        if (actionBtn) actionBtn.addEventListener('click', ()=>this.handleAction());
        const closeBtn = this.querySelector('#promoCloseBtn');
        if (closeBtn) closeBtn.addEventListener('click', ()=>this.dismissCurrentVariant());
    }
    handleAction() {
        const variant = this.activeVariant;
        if (!variant) return;
        switch(variant.action){
            case 'invite-modal':
                this.openInviteModal();
                break;
            case 'navigate-groups-new':
                if (window.router?.navigate) window.router.navigate('/groups/new');
                else window.location.href = '/groups/new';
                break;
            case 'navigate-rss-feeds':
                if (window.router?.navigate) window.router.navigate('/settings/rss-feeds');
                else window.location.href = '/settings/rss-feeds';
                break;
            default:
                break;
        }
    }
    openInviteModal() {
        let inviteModal = document.querySelector('invite-friend-modal');
        if (!inviteModal) {
            inviteModal = document.createElement('invite-friend-modal');
            document.body.appendChild(inviteModal);
        }
        inviteModal.open();
    }
}
customElements.define('home-promo-banner', $4d5d12ec0b64bee1$var$HomePromoBanner);
var $4d5d12ec0b64bee1$export$2e2bcd8739ae039 = $4d5d12ec0b64bee1$var$HomePromoBanner;


// Admin Dashboard Web Component
class $07794ed040ca077e$var$AdminDashboard extends HTMLElement {
    constructor(){
        super();
        this.currentUser = null;
        this.isAdmin = false;
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
        this.setupRouteHandling();
    }
    async setupAuthListener() {
        // Listen for auth-status-loaded event from main.js
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user, authenticated: authenticated } = e.detail;
            if (authenticated && user) {
                this.currentUser = user;
                this.isAdmin = user.role === 'admin';
                if (this.isAdmin) {
                    this.renderAdminDashboard();
                    this.updateActiveTabFromRoute();
                    this.setCurrentUserOnActiveComponent();
                } else this.renderUnauthorized();
            } else {
                this.currentUser = null;
                this.isAdmin = false;
                this.renderUnauthorized();
            }
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        // Listen for auth-success event to update immediately after login
        this.handleAuthSuccess = (e)=>{
            const { user: user } = e.detail;
            if (user) {
                window.logger.info('auth-success in admin-dashboard', user);
                this.currentUser = user;
                this.isAdmin = user.role === 'admin';
                if (this.isAdmin) {
                    this.renderAdminDashboard();
                    this.updateActiveTabFromRoute();
                    this.setCurrentUserOnActiveComponent();
                } else this.renderUnauthorized();
            }
        };
        document.addEventListener('auth-success', this.handleAuthSuccess);
    }
    render() {
        this.innerHTML = `
      <div class="admin-dashboard">
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Checking admin permissions...</div>
        </div>
      </div>
    `;
    }
    renderUnauthorized() {
        this.innerHTML = `
      <div class="admin-dashboard">
        <div class="unauthorized-state">
          <div class="unauthorized-icon">\u{1F6AB}</div>
          <h2 class="unauthorized-title">Access Denied</h2>
          <p class="unauthorized-message">
            You don't have administrator privileges to access this section.
          </p>
          <a href="/" class="btn btn-primary">Return to Home</a>
        </div>
      </div>

    `;
    }
    renderAdminDashboard() {
        this.innerHTML = `
      <div class="admin-dashboard">
        <div class="admin-content">
          <div id="audit-logs-content">
            <audit-logs></audit-logs>
          </div>
          <div id="user-management-content" style="display: none;">
            <user-management></user-management>
          </div>
          <div id="prompt-management-content" style="display: none;">
            <prompt-management></prompt-management>
          </div>
          <div id="site-stats-content" style="display: none;">
            <site-stats></site-stats>
          </div>
          <div id="image-flags-content" style="display: none;">
            <image-flags></image-flags>
          </div>
          <div id="blocked-domains-content" style="display: none;">
            <blocked-domains></blocked-domains>
          </div>
          <div id="oauth-clients-content" style="display: none;">
            <oauth-clients></oauth-clients>
          </div>
        </div>
      </div>

    `;
        this.attachEventListeners();
    }
    setupRouteHandling() {
        // Listen for route changes to update active tab
        window.addEventListener('popstate', ()=>{
            this.updateActiveTabFromRoute();
        });
        // Listen for navigation events from the router
        document.addEventListener('section-shown', (e)=>{
            if (e.detail.section === 'admin') // Ensure admin dashboard is rendered before updating route
            {
                if (this.isAdmin) setTimeout(()=>this.updateActiveTabFromRoute(), 0);
            }
        });
        // Initial route check
        this.updateActiveTabFromRoute();
    }
    updateActiveTabFromRoute() {
        const currentPath = window.location.pathname;
        // Determine active tab based on route
        let activeTab = 'audit-logs'; // default
        if (currentPath === '/admin/users') activeTab = 'user-management';
        else if (currentPath === '/admin/prompts') activeTab = 'prompt-management';
        else if (currentPath === '/admin/stats') activeTab = 'site-stats';
        else if (currentPath === '/admin/image-flags') activeTab = 'image-flags';
        else if (currentPath === '/admin/blocked-domains') activeTab = 'blocked-domains';
        else if (currentPath === '/admin/oauth-clients') activeTab = 'oauth-clients';
        else if (currentPath === '/admin/audit-logs' || currentPath === '/admin') activeTab = 'audit-logs';
        this.switchTab(activeTab);
    }
    attachEventListeners() {
    // Tab navigation is now handled by the router
    // Remove old click handlers since we're using links
    }
    switchTab(tabName) {
        // Update active tab
        this.querySelectorAll('.admin-tab').forEach((tab)=>{
            tab.classList.toggle('active', tab.dataset.tab === tabName);
        });
        // Show/hide content
        this.querySelectorAll('[id$="-content"]').forEach((content)=>{
            content.style.display = 'none';
        });
        const activeContent = this.querySelector(`#${tabName}-content`);
        if (activeContent) {
            activeContent.style.display = 'block';
            // Set current user on the active component
            this.setCurrentUserOnActiveComponent();
        }
    }
    setCurrentUserOnActiveComponent() {
        // Find the currently active content div
        const activeContent = this.querySelector('[id$="-content"][style*="block"]');
        if (activeContent && this.currentUser) {
            const component = activeContent.querySelector('*');
            if (component && component.setCurrentUser) component.setCurrentUser(this.currentUser);
        }
    }
    disconnectedCallback() {
        // Remove event listeners when component is removed
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        if (this.handleAuthSuccess) document.removeEventListener('auth-success', this.handleAuthSuccess);
    }
    setCurrentUser(user) {
        this.currentUser = user;
        this.isAdmin = user.role === 'admin';
        this.renderAdminDashboard();
        this.updateActiveTabFromRoute();
        this.setCurrentUserOnActiveComponent();
    }
}
// Register the custom element
customElements.define('admin-dashboard', $07794ed040ca077e$var$AdminDashboard);


// Admin Settings Page Web Component - Index/List View
class $ec5fe6d9cbb39bea$var$AdminSettingsPage extends HTMLElement {
    constructor(){
        super();
        this.currentUser = null;
        this.isAdmin = false;
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
    }
    setupAuthListener() {
        // Listen for auth-status-loaded event
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user, authenticated: authenticated } = e.detail;
            if (authenticated && user) {
                this.currentUser = user;
                this.isAdmin = user.role === 'admin';
                if (this.isAdmin) this.renderAdminSettings();
                else this.renderUnauthorized();
            } else {
                this.currentUser = null;
                this.isAdmin = false;
                this.renderUnauthorized();
            }
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        // Listen for auth-success event
        this.handleAuthSuccess = (e)=>{
            const { user: user } = e.detail;
            if (user) {
                this.currentUser = user;
                this.isAdmin = user.role === 'admin';
                if (this.isAdmin) this.renderAdminSettings();
                else this.renderUnauthorized();
            }
        };
        document.addEventListener('auth-success', this.handleAuthSuccess);
    }
    render() {
        this.innerHTML = `
      <div class="admin-settings-page">
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Checking admin permissions...</div>
        </div>
      </div>
    `;
    }
    renderUnauthorized() {
        this.innerHTML = `
      <div class="admin-settings-page">
        <div class="unauthorized-state">
          <div class="unauthorized-icon">\u{1F6AB}</div>
          <h2 class="unauthorized-title">Access Denied</h2>
          <p class="unauthorized-message">
            You don't have administrator privileges to access this section.
          </p>
          <a href="/" class="btn btn-primary">Return to Home</a>
        </div>
      </div>
    `;
    }
    renderAdminSettings() {
        this.innerHTML = `
      <div class="admin-settings-page">
        <div class="admin-settings-header">
          <h1>\u{1F6E0}\u{FE0F} Admin</h1>
          <p>Manage site administration and moderation</p>
        </div>

        <div class="admin-settings-list">
          <a href="/admin/audit-logs" class="admin-settings-item" data-route="/admin/audit-logs">
            <span class="item-icon">\u{1F4CB}</span>
            <div class="item-content">
              <span class="item-title">Audit Logs</span>
              <span class="item-description">View system audit logs and user activity</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/users" class="admin-settings-item" data-route="/admin/users">
            <span class="item-icon">\u{1F3A0}</span>
            <div class="item-content">
              <span class="item-title">User Management</span>
              <span class="item-description">Manage users, roles, and permissions</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/prompts" class="admin-settings-item" data-route="/admin/prompts">
            <span class="item-icon">
              <svg class="menu-washing-machine" width="20" height="20" viewBox="0 0 16 16" fill="none">
                <!-- Machine body -->
                <rect x="2" y="2" width="12" height="12" rx="2" fill="currentColor" opacity="0.8"/>
                <!-- Door -->
                <circle cx="8" cy="8.5" r="4" fill="none" stroke="currentColor" stroke-width="1.5" opacity="0.6"/>
                <!-- Drum -->
                <circle cx="8" cy="8.5" r="2.5" fill="none" stroke="currentColor" stroke-width="1" opacity="0.4"/>
                <!-- Control buttons -->
                <circle cx="5" cy="4.5" r="0.5" fill="currentColor" opacity="0.7"/>
                <circle cx="7" cy="4.5" r="0.5" fill="currentColor" opacity="0.7"/>
                <!-- Door handle -->
                <rect x="11.5" y="7.5" width="0.5" height="2" rx="0.25" fill="currentColor" opacity="0.8"/>
              </svg>
            </span>
            <div class="item-content">
              <span class="item-title">Writing Prompts</span>
              <span class="item-description">Manage writing prompts and approvals</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/widgets" class="admin-settings-item" data-route="/admin/widgets">
            <span class="item-icon">\u{1F9E9}</span>
            <div class="item-content">
              <span class="item-title">Profile Widgets</span>
              <span class="item-description">Review and approve user-submitted widgets</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/stats" class="admin-settings-item" data-route="/admin/stats">
            <span class="item-icon">\u{1F4CA}</span>
            <div class="item-content">
              <span class="item-title">Site Statistics</span>
              <span class="item-description">View site statistics and metrics</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/widget-flags" class="admin-settings-item" data-route="/admin/widget-flags">
            <span class="item-icon">\u{1F9E9}</span>
            <div class="item-content">
              <span class="item-title">Widget Flags</span>
              <span class="item-description">Review flagged profile widgets</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/image-flags" class="admin-settings-item" data-route="/admin/image-flags">
            <span class="item-icon">\u{1F5BC}\u{FE0F}</span>
            <div class="item-content">
              <span class="item-title">Image Flags</span>
              <span class="item-description">Review and manage flagged images</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/blocked-domains" class="admin-settings-item" data-route="/admin/blocked-domains">
            <span class="item-icon">\u{1F6AB}</span>
            <div class="item-content">
              <span class="item-title">Blocked Domains</span>
              <span class="item-description">Manage site-wide blocked domains (images and widget links)</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/admin/oauth-clients" class="admin-settings-item" data-route="/admin/oauth-clients">
            <span class="item-icon">\u{1F510}</span>
            <div class="item-content">
              <span class="item-title">OAuth Clients</span>
              <span class="item-description">Manage OAuth2 client applications</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>

          <a href="/admin/feature-flags" class="admin-settings-item" data-route="/admin/feature-flags">
            <span class="item-icon">\u{1F6A9}</span>
            <div class="item-content">
              <span class="item-title">Feature Flags</span>
              <span class="item-description">Turn site features on or off</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
        </div>
      </div>
    `;
    }
    disconnectedCallback() {
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        if (this.handleAuthSuccess) document.removeEventListener('auth-success', this.handleAuthSuccess);
    }
    setCurrentUser(user) {
        this.currentUser = user;
        this.isAdmin = user?.role === 'admin';
        if (this.isAdmin) this.renderAdminSettings();
        else this.renderUnauthorized();
    }
}
// Register the custom element
customElements.define('admin-settings-page', $ec5fe6d9cbb39bea$var$AdminSettingsPage);



/**
 * Circular emoji badges — contrasting pill in light/dark mode.
 * @see components.css `.emoji-badge`
 */ /**
 * @param {string} emoji
 * @param {'sm'|'md'|'lg'|'xl'} [size='md']
 * @returns {string}
 */ function $b58f9d07dbba7b59$export$6453439b9bcd1b5d(emoji, size = 'md') {
    if (!emoji) return '';
    return `<span class="emoji-badge emoji-badge-${size}" aria-hidden="true">${emoji}</span>`;
}
function $b58f9d07dbba7b59$export$9861bc22ef8417be(emoji, titleHtml, tag = 'h2') {
    return `<${tag} class="page-title">${$b58f9d07dbba7b59$export$6453439b9bcd1b5d(emoji, 'lg')}${titleHtml}</${tag}>`;
}
function $b58f9d07dbba7b59$export$5a7512680e571ab2(emoji, label) {
    return `${$b58f9d07dbba7b59$export$6453439b9bcd1b5d(emoji, 'sm')}${label}`;
}


class $f17d570a2bf377d5$var$AdminFeatureFlags extends HTMLElement {
    constructor(){
        super();
        this.currentUser = null;
        this.isAdmin = false;
        this.flags = [];
        this.isLoading = true;
        this.isSaving = false;
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
        this.bootstrapAuth();
    }
    async bootstrapAuth() {
        if (!this.isLoading || this.isAdmin) return;
        try {
            if (!window.API) return;
            const authData = await window.API.request('/auth/status');
            if (authData.authenticated && authData.user?.role === 'admin') this.setCurrentUser(authData.user);
            else if (authData.authenticated) this.setCurrentUser(authData.user);
            else {
                this.isLoading = false;
                this.renderUnauthorized();
            }
        } catch (error) {
            window.logger.error('Failed to check auth for feature flags:', error);
            this.isLoading = false;
            this.showError('Failed to load feature flags');
        }
    }
    setCurrentUser(user) {
        this.currentUser = user;
        this.isAdmin = user?.role === 'admin';
        if (this.isAdmin) this.loadFlags();
        else {
            this.isLoading = false;
            this.renderUnauthorized();
        }
    }
    setupAuthListener() {
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user, authenticated: authenticated } = e.detail;
            if (authenticated && user) {
                this.currentUser = user;
                this.isAdmin = user.role === 'admin';
                if (this.isAdmin) this.loadFlags();
                else this.renderUnauthorized();
            } else this.renderUnauthorized();
        };
        this.handleAuthSuccess = (e)=>{
            const { user: user } = e.detail;
            if (user) {
                this.currentUser = user;
                this.isAdmin = user.role === 'admin';
                if (this.isAdmin) this.loadFlags();
                else this.renderUnauthorized();
            }
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        document.addEventListener('auth-success', this.handleAuthSuccess);
    }
    async loadFlags() {
        try {
            this.isLoading = true;
            this.render();
            const data = await window.API.request('/admin/feature-flags');
            this.flags = data.flags || [];
        } catch (error) {
            window.logger.error('Failed to load feature flags:', error);
            this.showError('Failed to load feature flags');
        } finally{
            this.isLoading = false;
            this.render();
            this.attachEventListeners();
        }
    }
    render() {
        if (!this.isAdmin && !this.isLoading) return;
        if (this.isLoading) {
            this.innerHTML = `
        <div class="admin-feature-flags">
          <div class="loading-state">
            <div class="spinner"></div>
            <div>Loading feature flags...</div>
          </div>
        </div>
      `;
            return;
        }
        this.innerHTML = `
      <div class="admin-feature-flags">
        <div class="admin-feature-flags-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDEA9", 'Feature Flags')}
          <p>Turn site features on or off without deploying new code</p>
        </div>

        <div class="admin-feature-flags-list">
          ${this.flags.map((flag)=>this.renderFlagRow(flag)).join('')}
        </div>

        <div class="admin-feature-flags-footer">
          <div class="save-status" id="save-status"></div>
          <a href="/admin" class="btn btn-secondary" data-route="/admin">\u{2190} Return to Admin</a>
        </div>
      </div>
    `;
    }
    renderFlagRow(flag) {
        return `
      <div class="feature-flag-row" data-flag-key="${flag.key}">
        <div class="feature-flag-info">
          <h3>${flag.label}</h3>
          <p class="feature-flag-description">${flag.description}</p>
          <code class="feature-flag-key">${flag.key}</code>
        </div>
        <label class="toggle-switch">
          <input type="checkbox"
                 data-flag-key="${flag.key}"
                 ${flag.enabled ? 'checked' : ''}
                 ${this.isSaving ? 'disabled' : ''}>
          <span class="toggle-slider"></span>
        </label>
      </div>
    `;
    }
    renderUnauthorized() {
        this.innerHTML = `
      <div class="admin-feature-flags">
        <div class="unauthorized-state">
          <div class="unauthorized-icon">\u{1F6AB}</div>
          <h2 class="unauthorized-title">Access Denied</h2>
          <p class="unauthorized-message">
            You don't have administrator privileges to access this section.
          </p>
          <a href="/" class="btn btn-primary">Return to Home</a>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        this.addEventListener('change', async (e)=>{
            if (e.target.type === 'checkbox' && e.target.dataset.flagKey) await this.handleFlagToggle(e.target);
        });
    }
    async handleFlagToggle(checkbox) {
        if (this.isSaving) return;
        const flagKey = checkbox.dataset.flagKey;
        const enabled = checkbox.checked;
        const previous = this.flags.find((f)=>f.key === flagKey);
        try {
            this.isSaving = true;
            this.updateSaveStatus('Saving...', 'saving');
            const data = await window.API.request(`/admin/feature-flags/${flagKey}`, {
                method: 'PUT',
                body: JSON.stringify({
                    enabled: enabled
                })
            });
            if (data.features) {
                (0, $4bd131ffd9e749e2$export$9378dc6d04015c6c)(data.features);
                document.dispatchEvent(new CustomEvent('feature-flags-loaded', {
                    detail: {
                        features: data.features
                    },
                    bubbles: true
                }));
            }
            if (previous) previous.enabled = enabled;
            this.updateSaveStatus('Flag updated!', 'success');
            setTimeout(()=>this.updateSaveStatus('', ''), 2000);
        } catch (error) {
            window.logger.error('Failed to update feature flag:', error);
            checkbox.checked = !enabled;
            if (previous) previous.enabled = !enabled;
            this.updateSaveStatus('Failed to save. Please try again.', 'error');
        } finally{
            this.isSaving = false;
        }
    }
    updateSaveStatus(message, type) {
        const statusEl = this.querySelector('#save-status');
        if (statusEl) {
            statusEl.textContent = message;
            statusEl.className = `save-status ${type}`;
        }
    }
    showError(message) {
        this.innerHTML = `
      <div class="admin-feature-flags">
        <div class="error-state">
          <p>${message}</p>
          <a href="/admin" class="btn btn-secondary" data-route="/admin">\u{2190} Return to Admin</a>
        </div>
      </div>
    `;
    }
    disconnectedCallback() {
        document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        document.removeEventListener('auth-success', this.handleAuthSuccess);
    }
}
customElements.define('admin-feature-flags', $f17d570a2bf377d5$var$AdminFeatureFlags);


// Audit Logs Web Component
class $6e10d5b15173a40c$var$AuditLogs extends HTMLElement {
    constructor(){
        super();
        this.logs = [];
        this.isLoading = false;
        this.currentPage = 1;
        this.totalPages = 1;
        this.filters = {
            action: '',
            userId: ''
        };
    }
    connectedCallback() {
        this.render();
        this.loadAuditLogs();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="audit-logs">
        <div class="audit-header">
          <h2>Audit Logs</h2>
          <div class="audit-controls">
            <div class="filter-group">
              <label for="actionFilter">Filter by Action:</label>
              <select id="actionFilter" class="form-control">
                <option value="">All Actions</option>
                <option value="login">Login</option>
                <option value="logout">Logout</option>
                <option value="register">Register</option>
                <option value="create_post">Create Post</option>
                <option value="update_post">Update Post</option>
                <option value="delete_post">Delete Post</option>
                <option value="send_friend_request">Friend Request</option>
                <option value="accept_friend_request">Accept Friend</option>
                <option value="decline_friend_request">Decline Friend</option>
                <option value="update_user_role">Update User Role</option>
                <option value="delete_user">Delete User</option>
              </select>
            </div>
            
            <div class="filter-group">
              <label for="userFilter">Filter by User ID:</label>
              <input type="number" id="userFilter" class="form-control" placeholder="User ID">
            </div>
            
            <button class="btn btn-primary" id="applyFilters">
              Apply Filters
            </button>
            
            <button class="btn btn-outline" id="clearFilters">
              Clear
            </button>
          </div>
        </div>

        <div class="audit-content">
          ${this.renderContent()}
        </div>

        ${this.renderPagination()}
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading audit logs...</div>
        </div>
      `;
        if (this.logs.length === 0) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F4CB}</div>
          <h3>No audit logs found</h3>
          <p>Try adjusting your filters or check back later.</p>
        </div>
      `;
        return `
      <div class="log-list">
        ${this.logs.map((log)=>this.renderLogEntry(log)).join('')}
      </div>
    `;
    }
    renderLogEntry(log) {
        const time = new Date(log.created_at).toLocaleString();
        const details = log.details ? JSON.stringify(log.details, null, 2) : '';
        return `
      <div class="log-entry">
        <div class="log-header">
          <span class="log-action">${log.action.replace(/_/g, ' ')}</span>
          <span class="log-time">${time}</span>
        </div>
        
        ${log.username ? `
          <div class="log-user">
            \u{1F464} ${log.username} (ID: ${log.user_id})
          </div>
        ` : ''}
        
        ${details ? `
          <div class="log-details">
            <strong>Details:</strong><br>
            <pre>${details}</pre>
          </div>
        ` : ''}
        
        ${log.ip_address ? `
          <div class="log-ip">
            \u{1F310} ${log.ip_address}
          </div>
        ` : ''}
      </div>
    `;
    }
    renderPagination() {
        if (this.totalPages <= 1) return '';
        const startPage = Math.max(1, this.currentPage - 2);
        const endPage = Math.min(this.totalPages, this.currentPage + 2);
        const pages = [];
        for(let i = startPage; i <= endPage; i++)pages.push(i);
        return `
      <div class="pagination">
        <div class="pagination-info">
          Page ${this.currentPage} of ${this.totalPages}
        </div>
        
        <div class="pagination-controls">
          <button class="pagination-btn" ${this.currentPage === 1 ? 'disabled' : ''} data-page="${this.currentPage - 1}">
            \u{2190} Previous
          </button>
          
          ${pages.map((page)=>`
            <button class="pagination-btn ${page === this.currentPage ? 'active' : ''}" data-page="${page}">
              ${page}
            </button>
          `).join('')}
          
          <button class="pagination-btn" ${this.currentPage === this.totalPages ? 'disabled' : ''} data-page="${this.currentPage + 1}">
            Next \u{2192}
          </button>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        this.attachFilterListeners();
        this.attachPaginationListeners();
    }
    attachFilterListeners() {
        // Remove existing listeners to prevent duplicates
        const applyBtn = this.querySelector('#applyFilters');
        const clearBtn = this.querySelector('#clearFilters');
        // Clone and replace elements to remove old event listeners
        if (applyBtn) {
            const newApplyBtn = applyBtn.cloneNode(true);
            applyBtn.parentNode.replaceChild(newApplyBtn, applyBtn);
        }
        if (clearBtn) {
            const newClearBtn = clearBtn.cloneNode(true);
            clearBtn.parentNode.replaceChild(newClearBtn, clearBtn);
        }
        // Re-query the new elements
        const newApplyBtn = this.querySelector('#applyFilters');
        const newClearBtn = this.querySelector('#clearFilters');
        const newActionFilter = this.querySelector('#actionFilter');
        const newUserFilter = this.querySelector('#userFilter');
        newApplyBtn?.addEventListener('click', ()=>{
            this.filters.action = newActionFilter?.value || '';
            this.filters.userId = newUserFilter?.value || '';
            this.currentPage = 1;
            this.loadAuditLogs();
        });
        newClearBtn?.addEventListener('click', ()=>{
            this.filters.action = '';
            this.filters.userId = '';
            newActionFilter.value = '';
            newUserFilter.value = '';
            this.currentPage = 1;
            this.loadAuditLogs();
        });
    }
    attachPaginationListeners() {
        // Pagination event delegation - this should work even after content updates
        this.addEventListener('click', (e)=>{
            if (e.target.classList.contains('pagination-btn') && !e.target.disabled) {
                const page = parseInt(e.target.dataset.page);
                if (page && page !== this.currentPage) {
                    this.currentPage = page;
                    this.loadAuditLogs();
                }
            }
        });
    }
    async loadAuditLogs() {
        this.isLoading = true;
        this.updateContent();
        try {
            const params = new URLSearchParams({
                page: this.currentPage,
                limit: 20,
                ...this.filters
            });
            const response = await fetch(`/api/admin/audit-logs?${params}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                this.logs = data.logs;
                this.totalPages = data.pagination.pages;
                this.currentPage = data.pagination.page;
            } else throw new Error('Failed to fetch audit logs');
        } catch (error) {
            window.logger.error('Failed to load audit logs:', error);
            this.logs = [];
            this.showError('Failed to load audit logs. Please try again.');
        } finally{
            this.isLoading = false;
            this.updateContent();
        }
    }
    updateContent() {
        const content = this.querySelector('.audit-content');
        if (content) content.innerHTML = this.renderContent();
        const pagination = this.querySelector('.pagination');
        if (pagination) pagination.outerHTML = this.renderPagination();
        // Re-attach event listeners to filter controls (they might have been re-rendered)
        this.attachFilterListeners();
    }
    showError(message) {
        const content = this.querySelector('.audit-content');
        if (content) content.innerHTML = `
        <div class="empty-state">
          <div class="empty-state-icon">\u{274C}</div>
          <h3>Error</h3>
          <p>${message}</p>
        </div>
      `;
    }
}
// Register the custom element
customElements.define('audit-logs', $6e10d5b15173a40c$var$AuditLogs);


// Authentication Modal Web Component
class $fea5aea847d1b128$var$AuthModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.currentMode = 'login'; // 'login', 'register', 'forgot-password', 'reset-password', '2fa-setup'
        this.isRequired = false; // Whether auth is required (can't be closed)
        this.resetToken = null; // For password reset flow
        this.invitationToken = null; // For site friend invitation flow
        this.prefillEmail = null; // For group invite registration prefill
        this.twoFactorData = null; // For 2FA setup
        this.pendingLoginData = null; // For 2FA verification
    }
    connectedCallback() {
        window.logger.component('connected', 'auth-modal');
        this.render();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="auth-modal-overlay ${this.isOpen ? 'open' : ''}" id="authModalOverlay">
        <div class="auth-modal">
          <div class="auth-modal-header">
            <h2 class="auth-modal-title" id="authModalTitle">
              ${this.getModalTitle()}
            </h2>
            ${!this.isRequired ? '<button class="auth-modal-close" id="authModalClose" aria-label="Close">\u2715</button>' : ''}
          </div>

          <div class="auth-modal-body">
            ${this.currentMode !== 'verify-email' ? `
            <div class="auth-tabs">
              <button class="auth-tab ${this.currentMode === 'login' ? 'active' : ''}" 
                      data-mode="login">
                Login
              </button>
              <button class="auth-tab ${this.currentMode === 'register' ? 'active' : ''}" 
                      data-mode="register">
                Sign Up
              </button>
              ${this.currentMode === 'forgot-password' || this.currentMode === 'reset-password' ? '<button class="auth-tab active" data-mode="forgot-password">Reset Password</button>' : ''}
            </div>
            ` : ''}

            <form class="auth-form" id="authForm">
              ${this.renderFormFields()}
              <div class="form-actions">
                <button type="submit" class="btn btn-primary btn-lg auth-submit-btn">
                  <span class="btn-text">
                    ${this.getSubmitButtonText()}
                  </span>
                  <span class="spinner hidden"></span>
                </button>
              </div>
            </form>

            <div class="auth-footer">
              ${this.renderAuthFooter()}
            </div>

            <div class="alert-container" id="authAlertContainer"></div>
          </div>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Close modal (only if not required)
        const closeBtn = this.querySelector('#authModalClose');
        const overlay = this.querySelector('#authModalOverlay');
        closeBtn?.addEventListener('click', ()=>{
            if (!this.isRequired) this.close();
        });
        overlay?.addEventListener('click', (e)=>{
            if (e.target === overlay && !this.isRequired) this.close();
        });
        // Tab switching
        const tabs = this.querySelectorAll('.auth-tab');
        tabs.forEach((tab)=>{
            tab.addEventListener('click', ()=>{
                const mode = tab.dataset.mode;
                this.switchMode(mode);
            });
        });
        // Auth link switching
        const authLinks = this.querySelectorAll('.auth-link');
        authLinks.forEach((link)=>{
            link.addEventListener('click', ()=>{
                const mode = link.dataset.mode;
                this.switchMode(mode);
            });
        });
        // Form submission
        const form = this.querySelector('#authForm');
        form?.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handleSubmit();
        });
        // Keyboard handling
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && this.isOpen && !this.isRequired) this.close();
        });
    }
    switchMode(mode) {
        this.currentMode = mode;
        this.render();
        this.attachEventListeners();
    }
    async handleSubmit() {
        const form = this.querySelector('#authForm');
        const formData = new FormData(form);
        const data = Object.fromEntries(formData);
        this.setLoading(true);
        this.clearAlerts();
        this.clearFieldErrors();
        try {
            let endpoint, requestData;
            switch(this.currentMode){
                case 'login':
                    endpoint = '/auth/login';
                    requestData = data;
                    break;
                case 'register':
                    // Validate password confirmation on client side
                    if (data.password !== data.confirmPassword) throw new Error('Passwords do not match');
                    endpoint = '/auth/register';
                    requestData = data;
                    break;
                case 'forgot-password':
                    endpoint = '/auth/forgot-password';
                    requestData = {
                        email: data.email
                    };
                    break;
                case 'reset-password':
                    if (data.password !== data.confirmPassword) throw new Error('Passwords do not match');
                    endpoint = '/auth/reset-password';
                    requestData = {
                        token: this.resetToken,
                        password: data.password
                    };
                    break;
                case '2fa-setup':
                    endpoint = '/auth/2fa/verify';
                    requestData = {
                        token: data.verificationToken
                    };
                    break;
                case '2fa-verify':
                    endpoint = '/auth/login';
                    requestData = {
                        ...this.pendingLoginData,
                        twoFactorToken: data.twoFactorToken
                    };
                    break;
                case 'verify-email':
                    endpoint = '/auth/resend-verification';
                    requestData = {
                        email: this.verificationEmail
                    };
                    break;
                default:
                    throw new Error('Invalid form mode');
            }
            // Use centralized API helper
            if (!window.API) throw new Error('API not available');
            const result = await window.API.request(endpoint, {
                method: 'POST',
                body: JSON.stringify(requestData)
            });
            // Handle success based on mode
            switch(this.currentMode){
                case 'login':
                    // Check if 2FA is required
                    if (result.requiresTwoFactor) {
                        this.pendingLoginData = data; // Store login data for 2FA verification
                        this.showAlert('Please enter your 2FA code', 'info');
                        this.switchMode('2fa-verify');
                        return;
                    }
                    this.showAlert('Success! Redirecting...', 'success');
                    // Dispatch custom event
                    this.dispatchEvent(new window.CustomEvent('auth-success', {
                        detail: {
                            mode: this.currentMode,
                            user: result.user
                        },
                        bubbles: true
                    }));
                    // Close modal immediately before navigation
                    this.isRequired = false;
                    this.close();
                    this.schedulePostAuthNavigation();
                    break;
                case 'register':
                    if (result.requiresEmailVerification) {
                        this.showAlert('Registration successful! Please check your email to verify your account.', 'success');
                        // Switch to email verification mode
                        this.currentMode = 'verify-email';
                        this.verificationEmail = result.email;
                        this.render();
                        this.attachEventListeners();
                    } else if (result.user) {
                        // Email already verified (invitation-based registration)
                        this.showAlert(result.message, 'success');
                        // Dispatch custom event
                        this.dispatchEvent(new CustomEvent('auth-success', {
                            detail: {
                                mode: this.currentMode,
                                user: result.user
                            },
                            bubbles: true
                        }));
                        // Close modal immediately before navigation
                        this.isRequired = false;
                        this.close();
                        this.schedulePostAuthNavigation();
                    } else {
                        // Fallback for old response format
                        this.showAlert(result.invitationAccepted ? "Account created and invitation accepted! You're now friends! \uD83C\uDF89" : 'Account created! Redirecting...', 'success');
                        // Dispatch custom event
                        this.dispatchEvent(new CustomEvent('auth-success', {
                            detail: {
                                mode: this.currentMode,
                                user: result.user,
                                invitationAccepted: result.invitationAccepted
                            },
                            bubbles: true
                        }));
                        // Close modal immediately before navigation
                        this.isRequired = false;
                        this.close();
                        this.schedulePostAuthNavigation();
                    }
                    break;
                case 'verify-email':
                    this.showAlert('Verification email sent! Please check your inbox.', 'success');
                    break;
                case 'forgot-password':
                    this.showAlert('Password reset email sent! Check your inbox.', 'success');
                    setTimeout(()=>{
                        this.currentMode = 'login';
                        this.render();
                        this.attachEventListeners();
                    }, 2000);
                    break;
                case 'reset-password':
                    this.showAlert('Password reset successful! You can now loginin.', 'success');
                    setTimeout(()=>{
                        this.currentMode = 'login';
                        this.render();
                        this.attachEventListeners();
                    }, 2000);
                    break;
                case '2fa-setup':
                    this.showAlert('Two-factor authentication enabled successfully!', 'success');
                    this.dispatchEvent(new CustomEvent('auth-success', {
                        detail: {
                            mode: this.currentMode,
                            twoFactorEnabled: true
                        },
                        bubbles: true
                    }));
                    setTimeout(()=>{
                        this.close();
                    }, 2000);
                    if (window.router) window.router.navigate('/settings/security', true);
                    break;
                case '2fa-verify':
                    this.showAlert('2FA verified! Redirecting...', 'success');
                    // Dispatch custom event
                    this.dispatchEvent(new window.CustomEvent('auth-success', {
                        detail: {
                            mode: this.currentMode,
                            user: result.user
                        },
                        bubbles: true
                    }));
                    // Close modal immediately before navigation
                    this.isRequired = false;
                    this.close();
                    this.schedulePostAuthNavigation();
                    break;
            }
        } catch (error) {
            window.logger.error('Form submission error', error, {
                component: 'auth-modal',
                mode: this.currentMode
            });
            // Show field-specific errors if they exist
            if (error.details && Array.isArray(error.details) && error.details.length > 0) {
                this.showFieldErrors(error.details);
                // Show a more helpful general message
                const message = error.error || 'Please correct the errors above';
                this.showAlert(message, 'error');
            } else // Show generic error message
            this.showAlert(error.message, 'error');
        } finally{
            this.setLoading(false);
        }
    }
    setLoading(isLoading) {
        const submitBtn = this.querySelector('.auth-submit-btn');
        const btnText = this.querySelector('.btn-text');
        const spinner = this.querySelector('.spinner');
        if (isLoading) {
            submitBtn.disabled = true;
            btnText.textContent = this.getLoadingButtonText();
            spinner.classList.remove('hidden');
        } else {
            submitBtn.disabled = false;
            btnText.textContent = this.getSubmitButtonText();
            spinner.classList.add('hidden');
        }
    }
    getLoadingButtonText() {
        switch(this.currentMode){
            case 'login':
                return 'Signing In...';
            case 'register':
                return 'Creating Account...';
            case 'verify-email':
                return 'Checking Email...';
            case 'forgot-password':
                return 'Sending Email...';
            case 'reset-password':
                return 'Resetting Password...';
            case '2fa-setup':
                return 'Enabling 2FA...';
            case '2fa-verify':
                return 'Verifying...';
            default:
                return 'Loading...';
        }
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('#authAlertContainer');
        const alert = document.createElement('div');
        alert.className = `alert alert-${type}`;
        alert.textContent = message;
        if (container) {
            container.appendChild(alert);
            // Auto-remove after 5 seconds
            setTimeout(()=>{
                if (alert.parentNode) alert.remove();
            }, 5000);
        }
    }
    clearAlerts() {
        const container = this.querySelector('#authAlertContainer');
        if (container) container.innerHTML = '';
    }
    /**
   * Clear all field-level error messages
   */ clearFieldErrors() {
        const errorElements = this.querySelectorAll('.field-error');
        errorElements.forEach((el)=>el.remove());
        const invalidFields = this.querySelectorAll('.form-control.is-invalid');
        invalidFields.forEach((el)=>el.classList.remove('is-invalid'));
    }
    /**
   * Display field-specific validation errors
   * @param {Array} details - Array of validation error details from server
   */ showFieldErrors(details) {
        if (!details || !Array.isArray(details)) return;
        details.forEach((detail)=>{
            let field = detail.field;
            field = field.substring(field.lastIndexOf('/') + 1);
            const message = detail.message;
            // Find the input field
            const input = this.querySelector(`[name="${field}"]`);
            if (!input) return;
            // Add error class to input
            input.classList.add('is-invalid');
            // Create error message element
            const errorDiv = document.createElement('div');
            errorDiv.className = 'field-error';
            errorDiv.textContent = message;
            // Insert error message after the input (or after form-text if it exists)
            const formGroup = input.closest('.form-group');
            if (formGroup) {
                const formText = formGroup.querySelector('.form-text');
                if (formText) formText.after(errorDiv);
                else input.after(errorDiv);
            } else input.after(errorDiv);
        });
    }
    schedulePostAuthNavigation() {
        setTimeout(()=>{
            if (window.router?.navigateAfterAuth) window.router.navigateAfterAuth();
            else if (window.router) window.router.navigate('/', true);
        }, 100);
    }
    open(mode = 'login', required = false) {
        this.currentMode = mode;
        this.isOpen = true;
        this.isRequired = required;
        this.render();
        this.attachEventListeners();
        // Focus first input
        setTimeout(()=>{
            const firstInput = this.querySelector('input:not([type="hidden"])');
            firstInput?.focus();
        }, 100);
    }
    close() {
        this.isOpen = false;
        const overlay = this.querySelector('#authModalOverlay');
        if (overlay) overlay.classList.remove('open');
        // Dispatch close event
        this.dispatchEvent(new window.CustomEvent('auth-modal-closed', {
            bubbles: true
        }));
    }
    getModalTitle() {
        switch(this.currentMode){
            case 'login':
                return 'Welcome Back!';
            case 'register':
                return 'Join Fun Old Times!';
            case 'verify-email':
                return 'Check Your Email';
            case 'forgot-password':
                return 'Reset Your Password';
            case 'reset-password':
                return 'Enter New Password';
            case '2fa-setup':
                return 'Setup Two-Factor Authentication';
            case '2fa-verify':
                return 'Two-Factor Authentication';
            default:
                return 'Authentication';
        }
    }
    getSubmitButtonText() {
        switch(this.currentMode){
            case 'login':
                return 'Login';
            case 'register':
                return 'Create Account';
            case 'verify-email':
                return 'Resend Email';
            case 'forgot-password':
                return 'Send Reset Email';
            case 'reset-password':
                return 'Reset Password';
            case '2fa-setup':
                return 'Enable 2FA';
            case '2fa-verify':
                return 'Verify';
            default:
                return 'Submit';
        }
    }
    renderFormFields() {
        switch(this.currentMode){
            case 'login':
                return this.renderLoginFields();
            case 'register':
                return this.renderRegisterFields();
            case 'verify-email':
                return this.renderVerifyEmailFields();
            case 'forgot-password':
                return this.renderForgotPasswordFields();
            case 'reset-password':
                return this.renderResetPasswordFields();
            case '2fa-setup':
                return this.render2FASetupFields();
            case '2fa-verify':
                return this.render2FAVerifyFields();
            default:
                return this.renderLoginFields();
        }
    }
    renderLoginFields() {
        return `
      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <input 
          type="email" 
          class="form-control" 
          id="email" 
          name="email"
          placeholder="your@email.com"
          required
        />
      </div>

      <div class="form-group">
        <label class="form-label" for="password">Password</label>
        <input 
          type="password" 
          class="form-control" 
          id="password" 
          name="password"
          placeholder="Enter your password"
          required
        />
      </div>
    `;
    }
    renderRegisterFields() {
        return `
      <div class="form-group">
        <label class="form-label" for="firstName">First Name</label>
        <input 
          type="text" 
          class="form-control" 
          id="firstName" 
          name="first_name"
          placeholder="Your first name"
          required
        />
      </div>

      <div class="form-group">
        <label class="form-label" for="lastName">Last Name</label>
        <input 
          type="text" 
          class="form-control" 
          id="lastName" 
          name="last_name"
          placeholder="Your last name"
          required
        />
      </div>

      <div class="form-group">
        <label class="form-label" for="username">Username</label>
        <input 
          type="text" 
          class="form-control" 
          id="username" 
          name="username"
          placeholder="Choose a unique username"
          required
        />
      </div>

      <div class="form-group">
        <label class="form-label" for="email">Email</label>
        <input 
          type="email" 
          class="form-control" 
          id="email" 
          name="email"
          placeholder="your@email.com"
          value="${(this.prefillEmail || '').replace(/"/g, '&quot;')}"
          required
        />
      </div>

      <div class="form-group">
        <label class="form-label" for="password">Password</label>
        <input 
          type="password" 
          class="form-control" 
          id="password" 
          name="password"
          placeholder="At least 8 characters"
          minlength="8"
          required
        />
        <div class="form-text">Must be at least 8 characters long</div>
      </div>
      <div class="form-group">
        <label class="form-label" for="confirmPassword">Confirm Password</label>
        <input 
          type="password" 
          class="form-control" 
          id="confirmPassword" 
          name="confirmPassword"
          placeholder="Confirm your new password"
          minlength="8"
          required
        />
      </div>
      
      ${this.invitationToken ? `
        <input type="hidden" name="invitationToken" value="${this.invitationToken}" />
        <div class="invitation-notice">
          <div class="alert alert-info">
            <strong>\u{1F389} You're invited!</strong><br>
            You'll automatically become friends with the person who invited you when you sign up.
          </div>
        </div>
      ` : ''}
    `;
    }
    renderVerifyEmailFields() {
        return `
      <div class="verification-info">
        <div class="verification-icon">\u{1F4E7}</div>
        <p>We've sent a verification email to <strong>${this.verificationEmail || 'your email address'}</strong>.</p>
        <p>Please check your inbox and click the verification link to activate your account.</p>
        <p>Didn't receive the email? Check your spam folder or click "Resend Email" below.</p>
      </div>
    `;
    }
    renderForgotPasswordFields() {
        return `
      <div class="form-group">
        <label class="form-label" for="email">Email Address</label>
        <input 
          type="email" 
          class="form-control" 
          id="email" 
          name="email"
          placeholder="Enter your email address"
          required
        />
        <div class="form-text">We'll send you a link to reset your password</div>
      </div>
    `;
    }
    renderResetPasswordFields() {
        return `
      <div class="form-group">
        <label class="form-label" for="password">New Password</label>
        <input 
          type="password" 
          class="form-control" 
          id="password" 
          name="password"
          placeholder="Enter your new password"
          minlength="8"
          required
        />
        <div class="form-text">Must be at least 8 characters long</div>
      </div>

      <div class="form-group">
        <label class="form-label" for="confirmPassword">Confirm Password</label>
        <input 
          type="password" 
          class="form-control" 
          id="confirmPassword" 
          name="confirmPassword"
          placeholder="Confirm your new password"
          minlength="8"
          required
        />
      </div>
    `;
    }
    render2FASetupFields() {
        if (!this.twoFactorData) return '<div class="form-text">Setting up 2FA...</div>';
        return `
      <div class="form-group">
        <label class="form-label">Scan QR Code</label>
        <div class="qr-code-container">
          <img src="${this.twoFactorData.qrCode}" alt="2FA QR Code" class="qr-code" />
        </div>
        <div class="form-text">Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)</div>
      </div>

      <div class="form-group">
        <label class="form-label" for="manualKey">Manual Entry Key</label>
        <div class="manual-key-container">
          <input 
            type="text" 
            class="form-control" 
            id="manualKey" 
            value="${this.twoFactorData.manualEntryKey}"
            readonly
          />
          <button type="button" class="btn btn-sm btn-outline copy-btn" onclick="navigator.clipboard.writeText('${this.twoFactorData.manualEntryKey}')">
            Copy
          </button>
        </div>
        <div class="form-text">Or manually enter this key in your authenticator app</div>
      </div>

      <div class="form-group">
        <label class="form-label" for="verificationToken">Verification Code</label>
        <input 
          type="text" 
          class="form-control" 
          id="verificationToken" 
          name="verificationToken"
          placeholder="Enter 6-digit code from your app"
          maxlength="6"
          pattern="[0-9]{6}"
          required
        />
        <div class="form-text">Enter the 6-digit code from your authenticator app</div>
      </div>
    `;
    }
    render2FAVerifyFields() {
        return `
      <div class="form-group">
        <label class="form-label" for="twoFactorToken">Verification Code</label>
        <input 
          type="text" 
          class="form-control" 
          id="twoFactorToken" 
          name="twoFactorToken"
          placeholder="Enter 6-digit code from your authenticator app"
          maxlength="6"
          pattern="[0-9]{6}"
          required
        />
        <div class="form-text">Enter the current code from your authenticator app</div>
      </div>
    `;
    }
    renderAuthFooter() {
        switch(this.currentMode){
            case 'login':
                return `
          <p class="auth-switch">
            Don't have an account? <button type="button" class="auth-link" data-mode="register">Sign up here</button>
          </p>
          <p class="auth-switch">
            Forgot your password? <button type="button" class="auth-link" data-mode="forgot-password">Reset it here</button>
          </p>
        `;
            case 'register':
                return `
          <p class="auth-switch">
            Already have an account? <button type="button" class="auth-link" data-mode="login">Login here</button>
          </p>
        `;
            case 'forgot-password':
                return `
          <p class="auth-switch">
            Remember your password? <button type="button" class="auth-link" data-mode="login">Login here</button>
          </p>
        `;
            case 'reset-password':
                return `
          <p class="auth-switch">
            Remember your password? <button type="button" class="auth-link" data-mode="login">Login here</button>
          </p>
        `;
            case '2fa-setup':
                return `
          <p class="auth-switch">
            <button type="button" class="auth-link" data-mode="login">Back to Login</button>
          </p>
        `;
            case '2fa-verify':
                return `
          <p class="auth-switch">
            <button type="button" class="auth-link" data-mode="login">Back to Login</button>
          </p>
        `;
            default:
                return '';
        }
    }
    // Method to open forgot password modal
    openForgotPassword() {
        this.open('forgot-password', false);
    }
    // Method to open reset password modal with token
    openResetPassword(token) {
        this.resetToken = token;
        this.open('reset-password', false);
    }
    // Method to open register modal with invitation token
    openRegister(invitationToken = null) {
        this.openRegisterWithOptions({
            invitationToken: invitationToken
        });
    }
    openRegisterWithOptions({ invitationToken: invitationToken = null, prefillEmail: prefillEmail = null } = {}) {
        this.invitationToken = invitationToken;
        this.prefillEmail = prefillEmail;
        this.open('register', false);
    }
    // Method to open 2FA setup modal
    async open2FASetup() {
        try {
            // Use centralized API helper
            if (!window.API) throw new Error('API not available');
            this.twoFactorData = await window.API.request('/auth/2fa/setup', {
                method: 'POST'
            });
            this.open('2fa-setup', false);
        } catch (error) {
            window.logger.error('2FA setup error', error, {
                component: 'auth-modal'
            });
            this.showAlert('Failed to setup 2FA. Please try again.', 'error');
        }
    }
}
// Register the custom element
customElements.define('auth-modal', $fea5aea847d1b128$var$AuthModal);


// Authentication Status Web Component

class $5ebcb02f16cce4cc$var$AuthStatus extends HTMLElement {
    constructor(){
        super();
        this.user = null;
        this.isLoading = true;
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
    }
    render() {
        if (this.isLoading) {
            this.innerHTML = `
        <div class="auth-status loading">
          <div class="spinner"></div>
        </div>
      `;
            return;
        }
        if (this.user) // User is authenticated
        this.innerHTML = `
        <div class="auth-status authenticated">
          <div class="user-info">
            <div class="avatar">
              ${this.user.username.charAt(0).toUpperCase()}
            </div>
            <div class="user-details">
              <div class="username">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.user.username)}</div>
              <div class="user-email">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.user.email)}</div>
            </div>
          </div>
          
          <div class="auth-actions">
            <button class="btn btn-sm btn-outline logout-btn">
              Logout
            </button>
          </div>
        </div>
      `;
        else // User is not authenticated
        this.innerHTML = `
        <div class="auth-status unauthenticated">
          <div class="auth-actions">
            <button class="btn btn-sm btn-outline login-btn">
              Login
            </button>
            <button class="btn btn-sm btn-primary register-btn">
              Sign Up
            </button>
          </div>
        </div>

      `;
        this.attachEventListeners();
    }
    attachEventListeners() {
        // Login button
        const loginBtn = this.querySelector('.login-btn');
        loginBtn?.addEventListener('click', ()=>{
            this.openAuthModal('login');
        });
        // Register button
        const registerBtn = this.querySelector('.register-btn');
        registerBtn?.addEventListener('click', ()=>{
            this.openAuthModal('register');
        });
        // Logout button
        const logoutBtn = this.querySelector('.logout-btn');
        logoutBtn?.addEventListener('click', ()=>{
            this.handleLogout();
        });
    }
    setupAuthListener() {
        // Listen for the auth-status-loaded event from main.js
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user } = e.detail;
            this.user = user;
            this.isLoading = false;
            this.render();
            this.updateNavigation();
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        // Listen for auth-success event to update status immediately after login
        this.handleAuthSuccess = (e)=>{
            const { user: user } = e.detail;
            if (user) {
                window.logger.info('auth-success in auth-status', user);
                this.user = user;
                this.isLoading = false;
                this.render();
                this.updateNavigation();
            }
        };
        document.addEventListener('auth-success', this.handleAuthSuccess);
    }
    disconnectedCallback() {
        // Remove event listeners when component is removed
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        if (this.handleAuthSuccess) document.removeEventListener('auth-success', this.handleAuthSuccess);
    }
    async handleLogout() {
        try {
            window.logger.info('Attempting logout...');
            const response = await fetch('/api/auth/logout', {
                method: 'POST',
                credentials: 'include'
            });
            window.logger.info('Logout response status:', response.status);
            if (response.ok || response.status === 401) {
                // 401 is expected on successful logout (user is now unauthorized)
                let data = null;
                try {
                    data = await response.json();
                    window.logger.info('Logout response data:', data);
                } catch (e) {
                    // 401 might not have JSON body, that's fine
                    window.logger.info('Logout successful (401 - now unauthorized)', e);
                }
                this.user = null;
                this.render();
                // Dispatch logout event
                this.dispatchEvent(new CustomEvent('user-logged-out', {
                    bubbles: true
                }));
                // Navigate to login page instead of reload
                setTimeout(()=>{
                    window.router.navigate('/login');
                }, 500);
            } else {
                const errorData = await response.json().catch(()=>({
                        error: 'Unknown error'
                    }));
                window.logger.error('Logout failed with status:', response.status, 'Error:', errorData);
                throw new Error(`Logout failed: ${errorData.error || response.statusText}`);
            }
        } catch (error) {
            window.logger.error('Logout error:', error);
            alert(`Logout failed: ${error.message}. Please try again.`);
        }
    }
    openAuthModal(mode = 'login') {
        // Create or get auth modal
        let authModal = document.querySelector('auth-modal');
        if (!authModal) {
            authModal = document.createElement('auth-modal');
            document.body.appendChild(authModal);
        }
        authModal.open(mode);
    }
    // Public method to update user info
    setUser(user) {
        this.user = user;
        this.isLoading = false;
        this.render();
    }
    // Public method to clear user
    clearUser() {
        this.user = null;
        this.isLoading = false;
        this.render();
    }
    // Update navigation based on user role
    updateNavigation() {
        const adminLink = document.querySelector('a[href="/admin"]');
        if (this.user && this.user.role === 'admin') {
            // Show admin link for admin users
            if (adminLink) adminLink.style.display = 'block';
            else {
                // Create admin link if it doesn't exist
                const nav = document.querySelector('.main-nav ul');
                if (nav) {
                    const adminListItem = document.createElement('li');
                    adminListItem.innerHTML = '<a href="/admin" class="nav-link">Admin</a>';
                    nav.appendChild(adminListItem);
                }
            }
        } else // Hide admin link for non-admin users
        if (adminLink) adminLink.parentElement.style.display = 'none';
    }
}
// Register the custom element
customElements.define('auth-status', $5ebcb02f16cce4cc$var$AuthStatus);


// Blocked Domains Web Component


class $77def45b4adb0bd4$var$BlockedDomains extends HTMLElement {
    constructor(){
        super();
        this.domains = [];
        this.isLoading = false;
        this.currentUser = null;
        this.isLoadingDomains = false;
        this.showAddForm = false;
        this.newDomain = '';
        this.newReason = '';
        this.actionHandler = null; // Store handler reference for cleanup
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
    }
    disconnectedCallback() {
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        // Remove action handler
        const content = this.querySelector('.domains-content');
        if (content && this.actionHandler) content.removeEventListener('click', this.actionHandler);
    }
    setupAuthListener() {
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user, authenticated: authenticated } = e.detail;
            if (authenticated && user && user.role === 'admin') {
                this.currentUser = user;
                if (this.isVisible()) this.loadDomains();
            } else this.currentUser = null;
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
    }
    isVisible() {
        return this.offsetParent !== null && !this.style.display.includes('none');
    }
    render() {
        this.innerHTML = `
      <div class="blocked-domains">
        <div class="domains-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDEAB", 'Blocked Domains')}
          <p>Manage site-wide blocked domains (external images and widget links)</p>
        </div>

        <div class="domains-actions">
          <button class="btn btn-primary" id="addDomainBtn">
            + Add Blocked Domain
          </button>
        </div>

        ${this.renderAddForm()}

        <div class="domains-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
        // Attach event listeners
        const addBtn = this.querySelector('#addDomainBtn');
        if (addBtn) addBtn.addEventListener('click', ()=>{
            this.showAddForm = !this.showAddForm;
            this.updateAddForm();
        });
        const cancelBtn = this.querySelector('#cancelAddBtn');
        if (cancelBtn) cancelBtn.addEventListener('click', ()=>{
            this.showAddForm = false;
            this.newDomain = '';
            this.newReason = '';
            this.updateAddForm();
        });
        const submitBtn = this.querySelector('#submitAddBtn');
        if (submitBtn) submitBtn.addEventListener('click', ()=>{
            this.handleAddDomain();
        });
    }
    renderAddForm() {
        return `
      <div class="add-form ${this.showAddForm ? '' : 'hidden'}" id="addForm">
        <div class="form-group">
          <label for="domainInput">Domain</label>
          <input type="text" 
                 id="domainInput" 
                 placeholder="example.com" 
                 value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.newDomain)}"
                 required>
          <small style="color: var(--text-muted); font-size: 0.75rem; margin-top: 0.25rem; display: block;">
            Enter the domain to block (e.g., example.com). Subdomains will also be blocked.
          </small>
        </div>
        <div class="form-group">
          <label for="reasonInput">Reason</label>
          <textarea id="reasonInput" 
                    placeholder="Why is this domain being blocked?" 
                    required>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.newReason)}</textarea>
        </div>
        <div class="form-actions">
          <button class="btn btn-primary" id="submitAddBtn">Add Domain</button>
          <button class="btn btn-secondary" id="cancelAddBtn">Cancel</button>
        </div>
      </div>
    `;
    }
    updateAddForm() {
        const form = this.querySelector('#addForm');
        if (form) form.classList.toggle('hidden', !this.showAddForm);
        const domainInput = this.querySelector('#domainInput');
        const reasonInput = this.querySelector('#reasonInput');
        if (domainInput) domainInput.value = this.newDomain;
        if (reasonInput) reasonInput.value = this.newReason;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading blocked domains...</div>
        </div>
      `;
        if (this.domains.length === 0) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F6AB}</div>
          <h3>No blocked domains</h3>
          <p>There are no domains currently blocked. Add a domain to get started.</p>
        </div>
      `;
        return `
      <div class="domains-list">
        ${this.domains.map((domain)=>this.renderDomainItem(domain)).join('')}
      </div>
    `;
    }
    renderDomainItem(domain) {
        return `
      <div class="domain-item">
        <div class="domain-header">
          <div class="domain-info">
            <div class="domain-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(domain.domain)}</div>
          </div>
        </div>

        <div class="domain-reason">
          <strong>Reason:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(domain.reason || 'No reason provided')}
        </div>

        <div class="domain-details">
          <div class="domain-detail">
            <span class="domain-detail-label">Blocked At</span>
            <span class="domain-detail-value">${this.formatDate(domain.created_at)}</span>
          </div>
          <div class="domain-detail">
            <span class="domain-detail-label">Blocked By</span>
            <span class="domain-detail-value">Admin (ID: ${domain.blocked_by_user_id || 'N/A'})</span>
          </div>
        </div>

        <div class="domain-actions">
          <button class="domain-action-btn delete" 
                  data-domain-id="${domain.id}" 
                  data-action="delete">
            \u{1F5D1}\u{FE0F} Delete
          </button>
        </div>
      </div>
    `;
    }
    async loadDomains() {
        if (this.isLoadingDomains) return;
        if (!this.currentUser || this.currentUser.role !== 'admin') return;
        if (!this.isVisible()) return;
        this.isLoadingDomains = true;
        this.isLoading = true;
        this.updateContent();
        try {
            const response = await window.API.request('/admin/blocked-domains');
            if (response && response.domains) this.domains = response.domains;
            else this.domains = [];
        } catch (error) {
            window.logger?.error('Failed to load blocked domains:', error);
            this.domains = [];
            const content = this.querySelector('.domains-content');
            if (content) {
                const errorDiv = document.createElement('div');
                errorDiv.className = 'error-state';
                errorDiv.textContent = 'Failed to load blocked domains. Please try again.';
                content.innerHTML = '';
                content.appendChild(errorDiv);
                return;
            }
        } finally{
            this.isLoading = false;
            this.isLoadingDomains = false;
            this.updateContent();
        // attachActionListeners is called in updateContent, no need to call it again
        }
    }
    async handleAddDomain() {
        const domainInput = this.querySelector('#domainInput');
        const reasonInput = this.querySelector('#reasonInput');
        if (!domainInput || !reasonInput) return;
        const domain = domainInput.value.trim();
        const reason = reasonInput.value.trim();
        if (!domain || !reason) {
            alert('Please fill in both domain and reason.');
            return;
        }
        // Basic domain validation
        if (!/^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(domain)) {
            alert('Please enter a valid domain name.');
            return;
        }
        const submitBtn = this.querySelector('#submitAddBtn');
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Adding...';
        }
        try {
            await window.API.request('/admin/blocked-domains', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    domain: domain,
                    reason: reason
                })
            });
            // Reset form and reload
            this.showAddForm = false;
            this.newDomain = '';
            this.newReason = '';
            this.updateAddForm();
            await this.loadDomains();
        } catch (error) {
            window.logger?.error('Failed to add blocked domain:', error);
            alert('Failed to add blocked domain. Please try again.');
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = 'Add Domain';
            }
        }
    }
    attachActionListeners() {
        const content = this.querySelector('.domains-content');
        if (!content) return;
        // Remove existing handler if any
        if (this.actionHandler) content.removeEventListener('click', this.actionHandler);
        // Use event delegation - attach one listener to the container
        this.actionHandler = async (e)=>{
            const btn = e.target.closest('.domain-action-btn');
            if (!btn) return;
            const domainId = btn.dataset.domainId;
            const action = btn.dataset.action;
            if (!domainId || !action) return;
            if (action === 'delete') {
                if (!confirm('Are you sure you want to unblock this domain? Images from this domain will be allowed again.')) return;
            }
            btn.disabled = true;
            try {
                await window.API.request(`/admin/blocked-domains/${domainId}`, {
                    method: 'DELETE'
                });
                // Reload domains after deletion
                await this.loadDomains();
            } catch (error) {
                window.logger?.error('Failed to delete blocked domain:', error);
                btn.disabled = false;
                alert('Failed to delete blocked domain. Please try again.');
            }
        };
        content.addEventListener('click', this.actionHandler);
    }
    updateContent() {
        const content = this.querySelector('.domains-content');
        if (content) {
            content.innerHTML = this.renderContent();
            this.attachActionListeners();
        }
    }
    formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (_e) {
            return dateString;
        }
    }
    setCurrentUser(user) {
        this.currentUser = user;
        if (this.isVisible() && user && user.role === 'admin') this.loadDomains();
    }
}
// Register the custom element
customElements.define('blocked-domains', $77def45b4adb0bd4$var$BlockedDomains);


// Comments Section Web Component




class $d64c83c9af5488d6$var$CommentsSection extends HTMLElement {
    constructor(){
        super();
        this.postId = null;
        this.comments = [];
        this.isLoading = false;
        this.error = null;
        this.replyingTo = null;
        this.currentUser = null;
        this.lazyLoad = false;
        this.commentsLoaded = false;
        this.commentCount = 0;
        this.editingCommentId = null; // Track which comment is being edited
        this._reportInFlight = false;
    }
    static get observedAttributes() {
        return [
            'post-id',
            'lazy-load',
            'group-id'
        ];
    }
    get groupId() {
        const raw = this.getAttribute('group-id');
        if (!raw) return null;
        const id = parseInt(raw, 10);
        return Number.isNaN(id) ? null : id;
    }
    isGroupMode() {
        return this.groupId !== null;
    }
    getCommentPermalink(commentId) {
        if (this.isGroupMode()) return (0, $2bb3cd4399004fe3$export$634034df907f30cd)({
            groupId: this.groupId,
            postId: this.postId,
            commentId: commentId
        });
        return `/post/${this.postId}/comment/${commentId}`;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        // Check if we should eagerly load comments
        const lazyLoad = this.getAttribute('lazy-load');
        if (lazyLoad === 'false' && this.postId && !this.commentsLoaded) this.loadComments();
    }
    disconnectedCallback() {
        this.removeEventListeners();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'post-id' && newValue !== oldValue) {
            this.postId = newValue;
            this.commentsLoaded = false;
            this.comments = [];
            this.updateContent();
            // If eager loading is enabled and we have a post ID, load comments immediately
            const lazyLoad = this.getAttribute('lazy-load');
            if (lazyLoad === 'false' && this.postId) this.loadComments();
        }
        if (name === 'lazy-load' && newValue !== oldValue) // If lazy-load changes to false and we haven't loaded comments yet, load them now
        {
            if (newValue === 'false' && this.postId && !this.commentsLoaded) this.loadComments();
        }
    }
    // Method to trigger lazy loading
    loadCommentsLazy() {
        if (!this.commentsLoaded && this.postId) this.loadComments();
    }
    // Method to set comment count from post data
    setCommentCount(count) {
        this.commentCount = count;
        this.updateCommentsCount();
    }
    setCurrentUser(user) {
        this.currentUser = user;
        this.populateAliasFields();
    }
    render() {
        this.innerHTML = `
      <div class="comments-section">
        <div class="comments-header">
          <h3>\u{1F4AC} Comments</h3>
          <div class="comments-count" id="commentsCount">${this.commentCount > 0 ? this.commentCount : '0'}</div>
        </div>

        <div class="comments-content">
          ${this.renderContent()}
        </div>
      </div>

    `;
    }
    renderContent() {
        // If eager loading is enabled, show loading state immediately
        const lazyLoad = this.getAttribute('lazy-load');
        const isEagerLoading = lazyLoad === 'false';
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading comments...</p>
        </div>
      `;
        // Show lazy loading state if comments haven't been loaded yet and lazy loading is enabled
        if (!this.commentsLoaded && !isEagerLoading) return `
        <div class="lazy-loading-state">
          <div class="lazy-load-trigger">
            <button class="btn btn-primary load-comments-btn" id="loadCommentsBtn">
              <span class="load-icon">\u{1F3AD}</span>
              <span class="load-text">Load Comments (${this.commentCount})</span>
            </button>
          </div>
        </div>
      `;
        // If eager loading but comments aren't loaded yet and we're not currently loading, show loading state
        if (!this.commentsLoaded && isEagerLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading comments...</p>
        </div>
      `;
        if (this.error) return `
        <div class="error-state">
          <span class="error-icon">\u{1F61E}</span>
          <h4>Failed to Load Comments</h4>
          <p>${this.error}</p>
        </div>
      `;
        const commentsHtml = this.comments.length === 0 ? `
        <div class="empty-state">
          <span class="empty-state-icon">\u{1F4AC}</span>
          <h4>No comments yet</h4>
          <p>Be the first to share your thoughts!</p>
        </div>
      ` : `
        <div class="comments-list">
          ${this.renderThreadedComments()}
        </div>
      `;
        return `
      ${commentsHtml}
      ${!this.replyingTo ? this.renderCommentForm() : ''}
    `;
    }
    renderComment(comment) {
        const createdDate = new Date(comment.createdAt);
        const timeAgo = this.formatTimeAgo(createdDate);
        const commentPermalink = this.getCommentPermalink(comment.id);
        return `
      <div class="comment-item" data-comment-id="${comment.id}">
        <a name="comment-${comment.id}"></a>
        <div class="comment-header">
          <div class="comment-author">
            <div class="comment-avatar">
              ${comment.username ? comment.username.charAt(0).toUpperCase() : '?'}
            </div>
            <div class="comment-author-info">
              <div class="comment-author-name">
                <user-mention username="${comment.username}" real-username="${comment.realUsername}" user-id="${this.currentUser.id}"  class="comment-author-link"></user-mention>
              </div>
              <div class="comment-meta">
                <span class="comment-time" title="${createdDate.toLocaleString()}">
                  ${timeAgo}
                </span>
                ${comment.isReply ? "<span>\u2022</span><span>Reply</span>" : ''}
              </div>
            </div>
          </div>
          <div class="comment-actions">
            ${comment.isOwner ? `
              <button class="comment-action-btn" data-action="edit" data-comment-id="${comment.id}" title="Edit comment">
                \u{270F}\u{FE0F}
              </button>
              <button class="comment-action-btn" data-action="delete" data-comment-id="${comment.id}" title="Delete comment">
                \u{1F5D1}\u{FE0F}
              </button>
            ` : `
              <button class="comment-action-btn" data-action="report" data-comment-id="${comment.id}" title="Report comment">
                \u{1F6A9}
              </button>
            `}
          </div>
        </div>
        
        <div class="comment-content">${comment.content_html || ''}</div>
        
        <div class="comment-footer">
          <button class="btn comment-reply-btn" data-action="reply" data-comment-id="${comment.id}">
            \u{1F4AC} Reply
          </button>
          <a href="${commentPermalink}" class="comment-permalink" title="Link to this comment">
            #${comment.id}
          </a>
        </div>
      </div>
    `;
    }
    renderThreadedComments() {
        // Organize comments into a tree structure
        const commentTree = this.buildCommentTree(this.comments);
        // Render the tree with proper threading
        return commentTree.map((comment)=>this.renderCommentThread(comment, 0)).join('');
    }
    buildCommentTree(comments) {
        const commentMap = new Map();
        const rootComments = [];
        // First pass: create a map of all comments
        comments.forEach((comment)=>{
            commentMap.set(comment.id, {
                ...comment,
                children: []
            });
        });
        // Second pass: organize into tree structure
        comments.forEach((comment)=>{
            if (comment.parentId && commentMap.has(comment.parentId)) // This is a reply, add it to its parent's children
            commentMap.get(comment.parentId).children.push(commentMap.get(comment.id));
            else // This is a root comment
            rootComments.push(commentMap.get(comment.id));
        });
        return rootComments;
    }
    renderCommentForm(isReply = false, replyToComment = null) {
        const replyingTo = replyToComment || this.replyingTo;
        const aliasField = this.isGroupMode() ? '' : `
        <div class="alias-field">
          <label for="aliasInput" class="alias-label">
            Post as:
            <span class="mischief-icon" title="You can change your display name for this comment! Don't worry, we still know it's you \u{1F609}">
              \u{1F99D}
            </span>
          </label>
          <input 
            type="text" 
            id="aliasInput" 
            name="alias" 
            class="alias-input"
            placeholder="Your display name..."
            maxlength="50"
            value="${this.currentUser && this.currentUser.username ? (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.currentUser.username) : ''}"
          />
        </div>
    `;
        return `
      <form class="comment-form ${isReply ? 'inline-reply-form' : ''}" id="commentForm" data-reply-to="${replyingTo ? replyingTo.id : ''}">
        ${replyingTo ? `
          <div class="comment-form-header">
            <h4 class="comment-form-title">Replying to ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(replyingTo.username)}</h4>
            <button type="button" class="cancel-reply-btn" id="cancelReplyBtn">Cancel</button>
          </div>
        ` : ''}
        
        ${aliasField}
        
        <markdown-preview>
          <textarea 
            id="commentTextarea" 
            name="content" 
            placeholder="${replyingTo ? 'Write your reply...' : 'Share your thoughts...'}"
            required
          ></textarea>
        </markdown-preview>
        <div class="comment-form-actions">
          <button type="submit" class="btn btn-primary" id="submitBtn">
            <span class="btn-text">${replyingTo ? 'Post Reply' : 'Post Comment'}</span>
            <span class="btn-loading" style="display: none;">\u{23F3} Posting...</span>
          </button>
          <button type="button" class="btn btn-secondary clear-btn" id="clearBtn">Clear</button>
        </div>
      </form>
    `;
    }
    renderCommentThread(comment, depth = 0) {
        const createdDate = new Date(comment.createdAt);
        const timeAgo = this.formatTimeAgo(createdDate);
        const commentPermalink = this.getCommentPermalink(comment.id);
        const isReply = depth > 0;
        const maxDepth = 3; // Limit threading depth to prevent excessive nesting
        // Show parent context for replies
        const parentContext = isReply && comment.parentId ? this.renderParentContext(comment.parentId) : '';
        const commentHtml = `
      <div class="comment-thread" data-comment-id="${comment.id}" data-depth="${depth}">
        <div class="comment-item ${isReply ? 'comment-reply' : 'comment-root'}" style="--thread-depth: ${Math.min(depth, maxDepth)}" data-depth="${depth}">
          ${parentContext}
          <div class="comment-main">
            <a name="comment-${comment.id}"></a>
            <div class="comment-header">
              <div class="comment-author">
                <div class="comment-avatar">
                  ${comment.username ? comment.username.charAt(0).toUpperCase() : '?'}
                </div>
                <div class="comment-author-info">
                  <div class="comment-author-name">
                    <user-mention username="${comment.username}" real-username="${comment.realUsername}" user-id="${this.currentUser?.id}" class="comment-author-link"></user-mention>
                  </div>
                  <div class="comment-meta">
                    <span class="comment-time" title="${createdDate.toLocaleString()}">
                      ${timeAgo}
                    </span>
                    ${isReply ? '<span class="reply-indicator">\u2022 Reply</span>' : ''}
                  </div>
                </div>
              </div>
              <div class="comment-actions">
                ${comment.isOwner ? `
                  <button class="comment-action-btn" data-action="edit" data-comment-id="${comment.id}" title="Edit comment">
                    \u{270F}\u{FE0F}
                  </button>
                  <button class="comment-action-btn" data-action="delete" data-comment-id="${comment.id}" title="Delete comment">
                    \u{1F5D1}\u{FE0F}
                  </button>
                ` : `
                  <button class="comment-action-btn" data-action="report" data-comment-id="${comment.id}" title="Report comment">
                    \u{1F6A9}
                  </button>
                `}
              </div>
            </div>
            
            ${this.editingCommentId === comment.id ? this.renderEditForm(comment) : `
              <div class="comment-content">${comment.content_html || ''}</div>
              
              <div class="comment-footer">
                <button class="btn comment-reply-btn" data-action="reply" data-comment-id="${comment.id}">
                  \u{1F4AC} Reply
                </button>
                <a href="${commentPermalink}" class="comment-permalink" title="Link to this comment">
                  #${comment.id}
                </a>
              </div>
            `}
          </div>
        </div>
        
        ${this.replyingTo && this.replyingTo.id === comment.id ? `
          <div class="inline-reply-container">
            ${this.renderCommentForm(true, comment)}
          </div>
        ` : ''}
        
        ${comment.children && comment.children.length > 0 ? `
          <div class="comment-replies">
            ${comment.children.map((child)=>this.renderCommentThread(child, depth + 1)).join('')}
          </div>
        ` : ''}
      </div>
    `;
        return commentHtml;
    }
    renderParentContext(parentId) {
        const parentComment = this.comments.find((c)=>c.id === parentId);
        if (!parentComment) return '';
        return `
      <div class="parent-context">
        <div class="parent-context-line"></div>
        <div class="parent-context-content">
          <span class="parent-context-author">@${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(parentComment.username)}</span>
          <span class="parent-context-text">${this.truncateText(parentComment.content, 50)}</span>
        </div>
      </div>
    `;
    }
    truncateText(text, maxLength) {
        if (text.length <= maxLength) return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(text);
        return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(text.substring(0, maxLength)) + '...';
    }
    attachEventListeners() {
        // Remove existing listeners to prevent duplicates
        this.removeEventListeners();
        // Comment form submission - handle all forms
        const commentForms = this.querySelectorAll('.comment-form');
        commentForms.forEach((form)=>{
            form.addEventListener('submit', this.handleFormSubmit);
        });
        // Edit form submission - handle all edit forms
        const editForms = this.querySelectorAll('.edit-comment-form');
        editForms.forEach((form)=>{
            form.addEventListener('submit', this.handleEditFormSubmit);
        });
        // Clear button - clears the comment form
        const clearBtns = this.querySelectorAll('#clearBtn');
        clearBtns.forEach((btn)=>{
            btn.addEventListener('click', this.handleClearClick);
        });
        // Cancel buttons - handle cancel reply and edit cancel buttons
        const cancelBtns = this.querySelectorAll('#cancelReplyBtn, #editCancelBtn');
        cancelBtns.forEach((btn)=>{
            btn.addEventListener('click', this.handleCancelClick);
        });
        // Load comments button
        const loadCommentsBtn = this.querySelector('#loadCommentsBtn');
        if (loadCommentsBtn) loadCommentsBtn.addEventListener('click', this.handleLoadComments);
        // Comment actions - delegated click handler (stable reference for add/remove)
        this.addEventListener('click', this.handleCommentActionClick);
        // Character count for edit forms
        const editTextareas = this.querySelectorAll('#editTextarea');
        editTextareas.forEach((textarea)=>{
            const charCount = textarea.parentElement.querySelector('#editCharCount');
            if (charCount) textarea.addEventListener('input', ()=>{
                charCount.textContent = textarea.value.length;
            });
        });
    }
    removeEventListeners() {
        // Remove all form event listeners
        const commentForms = this.querySelectorAll('.comment-form');
        commentForms.forEach((form)=>{
            form.removeEventListener('submit', this.handleFormSubmit);
        });
        const editForms = this.querySelectorAll('.edit-comment-form');
        editForms.forEach((form)=>{
            form.removeEventListener('submit', this.handleEditFormSubmit);
        });
        const clearBtns = this.querySelectorAll('#clearBtn');
        clearBtns.forEach((btn)=>{
            btn.removeEventListener('click', this.clearForm);
        });
        const cancelBtns = this.querySelectorAll('#cancelReplyBtn, #editCancelBtn');
        cancelBtns.forEach((btn)=>{
            btn.removeEventListener('click', this.handleCancelClick);
        });
        const loadCommentsBtn = this.querySelector('#loadCommentsBtn');
        if (loadCommentsBtn) loadCommentsBtn.removeEventListener('click', this.handleLoadComments);
        this.removeEventListener('click', this.handleCommentActionClick);
    }
    handleCommentActionClick = (e)=>{
        const actionEl = e.target.closest('[data-action]');
        if (!actionEl || !this.contains(actionEl)) return;
        const action = actionEl.dataset.action;
        const commentId = actionEl.dataset.commentId;
        switch(action){
            case 'reply':
                this.startReply(commentId);
                break;
            case 'edit':
                this.editComment(commentId);
                break;
            case 'delete':
                this.deleteComment(commentId);
                break;
            case 'report':
                e.preventDefault();
                e.stopPropagation();
                this.reportComment(commentId);
                break;
        }
    };
    // Bound event handlers to prevent memory leaks and allow removal
    handleFormSubmit = (e)=>{
        e.preventDefault();
        this.handleSubmit(e.target);
    };
    handleEditFormSubmit = (e)=>{
        e.preventDefault();
        const commentId = e.target.id.replace('edit-form-', '');
        this.handleEditSubmit(commentId);
    };
    handleClearClick = ()=>{
        this.clearForm();
    };
    handleCancelClick = (e)=>{
        if (e.target.id === 'cancelReplyBtn') this.cancelReply();
        else if (e.target.id === 'editCancelBtn') this.cancelEdit();
    };
    handleLoadComments = ()=>{
        this.loadCommentsLazy();
    };
    populateAliasFields() {
        const aliasInputs = this.querySelectorAll('.alias-input');
        aliasInputs.forEach((input)=>{
            if (this.currentUser && this.currentUser.username) input.value = this.currentUser.username;
        });
    }
    async loadComments() {
        if (!this.postId) return;
        this.isLoading = true;
        this.error = null;
        this.commentsLoaded = true;
        this.updateContent();
        try {
            const response = this.isGroupMode() ? await window.API.request(`/groups/${this.groupId}/posts/${this.postId}/comments`) : await window.API.request(`/comments/post/${this.postId}`);
            this.comments = response.comments || [];
            this.updateCommentsCount();
        } catch (error) {
            window.logger.error('Failed to load comments:', error);
            this.comments = [];
            this.error = error.message || 'Failed to load comments';
        } finally{
            this.isLoading = false;
            this.updateContent();
        }
    }
    async updateContent() {
        const contentContainer = this.querySelector('.comments-content');
        if (contentContainer) {
            contentContainer.innerHTML = this.renderContent();
            this.attachEventListeners();
            this.populateAliasFields();
            // Note: Images already have proxy URLs from backend (content_html field)
            // Only process if content_html is missing (fallback for old data)
            if (this.currentUser?.id) {
                const postContext = this.isGroupMode() ? 'group' : 'friend';
                const needsProcessing = this.comments.some((comment)=>comment.content && !comment.content_html);
                if (needsProcessing) try {
                    const { processImageProxyUrls: processImageProxyUrls } = await Promise.resolve((parcelRequire("1L1Fr")));
                    const processedHtml = await processImageProxyUrls(contentContainer.innerHTML, this.currentUser.id, this.postId || null, postContext);
                    contentContainer.innerHTML = processedHtml;
                } catch (error) {
                    window.logger.warn('Failed to process image proxy URLs in comments:', error);
                }
                try {
                    const { attachProxyImageRemintHandlers: attachProxyImageRemintHandlers } = await Promise.resolve((parcelRequire("1L1Fr")));
                    attachProxyImageRemintHandlers(contentContainer, {
                        postId: this.postId ? parseInt(this.postId, 10) : null,
                        postContext: postContext
                    });
                } catch (error) {
                    window.logger.warn('Failed to attach proxy image remint handlers:', error);
                }
            }
        }
    }
    updateCommentsCount() {
        const countElement = this.querySelector('#commentsCount');
        if (countElement) {
            const count = this.comments.length;
            countElement.textContent = count === 1 ? '1 comment' : `${count} comments`;
        }
    }
    async handleSubmit(form = null) {
        // If no form provided, try to find the active form
        if (!form) form = this.querySelector('.comment-form');
        const textarea = form.querySelector('#commentTextarea');
        const aliasInput = form.querySelector('#aliasInput');
        const submitBtn = form.querySelector('#submitBtn');
        const content = textarea.value.trim();
        const alias = aliasInput?.value?.trim() || '';
        if (!content) return;
        // Use alias if provided, otherwise fall back to current username
        const displayName = alias || (this.currentUser ? this.currentUser.username : 'Anonymous');
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
        // Determine if this is a reply based on the form's data attribute
        const replyToId = form.dataset.replyTo;
        const isReply = replyToId && replyToId !== '';
        try {
            let response;
            if (this.isGroupMode()) response = await window.API.request(`/groups/${this.groupId}/posts/${this.postId}/comments`, {
                method: 'POST',
                body: JSON.stringify({
                    content_markdown: content,
                    ...isReply && {
                        parent_comment_id: parseInt(replyToId, 10)
                    }
                })
            });
            else {
                const requestBody = {
                    postId: parseInt(this.postId),
                    content: content,
                    displayName: displayName,
                    ...isReply && {
                        parentId: parseInt(replyToId)
                    }
                };
                response = await window.API.request('/comments', {
                    method: 'POST',
                    body: JSON.stringify(requestBody)
                });
            }
            this.showSuccess(isReply ? 'Reply posted!' : 'Comment posted!');
            this.clearForm();
            await this.loadComments();
            // Dispatch event for other components
            this.dispatchEvent(new CustomEvent('comment-added', {
                detail: {
                    comment: response.comment || response
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to post comment:', error);
            this.showError(error.message || 'Failed to post comment');
        } finally{
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
        }
    }
    startReply(commentId) {
        // Prevent replying if already editing a comment
        if (this.editingCommentId) {
            this.showError('Please finish or cancel your edit before replying to a comment.');
            return;
        }
        const comment = this.comments.find((c)=>c.id === parseInt(commentId));
        if (comment) {
            this.replyingTo = comment;
            this.updateContent();
            const textarea = this.querySelector('#commentTextarea');
            textarea?.focus();
        }
    }
    cancelReply() {
        this.replyingTo = null;
        this.updateContent();
    }
    clearForm() {
        this.replyingTo = null;
        const textarea = this.querySelector('#commentTextarea');
        if (textarea) textarea.value = '';
        this.updateContent();
    }
    editComment(commentId) {
        // Convert string ID to number for comparison
        const numericCommentId = parseInt(commentId, 10);
        window.logger.component('edit_start', 'comments-section', {
            commentId: numericCommentId
        });
        // Prevent editing if already replying to a comment
        if (this.replyingTo) {
            this.showError('Please finish or cancel your reply before editing a comment.');
            return;
        }
        // Find the comment to edit
        const comment = this.findCommentById(numericCommentId);
        if (!comment) {
            window.logger.error('Comment not found for editing', null, {
                commentId: numericCommentId,
                availableIds: this.comments.map((c)=>c.id),
                totalComments: this.comments.length
            });
            this.showError('Comment not found.');
            return;
        }
        // Set editing state
        this.editingCommentId = numericCommentId;
        this.updateContent();
    }
    // Helper method to find a comment by ID (including nested replies)
    findCommentById(commentId, comments = this.comments) {
        for (const comment of comments){
            if (comment.id === commentId) return comment;
            // Check replies recursively
            if (comment.replies && comment.replies.length > 0) {
                const found = this.findCommentById(commentId, comment.replies);
                if (found) return found;
            }
        }
        return null;
    }
    // Handle edit form submission
    async handleEditSubmit(commentId) {
        // Convert string ID to number
        const numericCommentId = parseInt(commentId, 10);
        const editForm = this.querySelector(`#edit-form-${numericCommentId}`);
        if (!editForm) return;
        const textarea = editForm.querySelector('#editTextarea');
        const submitBtn = editForm.querySelector('#editSubmitBtn');
        const content = textarea.value.trim();
        if (!content) {
            this.showError('Comment content cannot be empty.');
            return;
        }
        if (content.length > 1000) {
            this.showError('Comment content must be less than 1000 characters.');
            return;
        }
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
        try {
            let response;
            if (this.isGroupMode()) response = await window.API.request(`/groups/${this.groupId}/posts/${this.postId}/comments/${numericCommentId}`, {
                method: 'PUT',
                body: JSON.stringify({
                    content_markdown: content
                })
            });
            else response = await window.API.request(`/comments/${numericCommentId}`, {
                method: 'PUT',
                body: JSON.stringify({
                    content: content
                })
            });
            window.logger.component('edit_success', 'comments-section', {
                commentId: numericCommentId
            });
            this.showSuccess('Comment updated successfully!');
            // Exit edit mode and reload comments
            this.editingCommentId = null;
            await this.loadComments();
            // Dispatch event for other components
            this.dispatchEvent(new CustomEvent('comment-updated', {
                detail: {
                    comment: response.comment || response
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to update comment', error, {
                commentId: numericCommentId
            });
            this.showError(error.message || 'Failed to update comment');
        } finally{
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
        }
    }
    // Cancel edit mode
    cancelEdit() {
        window.logger.component('edit_cancel', 'comments-section', {
            commentId: this.editingCommentId
        });
        this.editingCommentId = null;
        this.updateContent();
    }
    // Render edit form for a comment
    renderEditForm(comment) {
        return `
      <form class="edit-comment-form" id="edit-form-${comment.id}">
        <div class="edit-form-group">
          <textarea 
            id="editTextarea" 
            class="edit-comment-textarea"
            placeholder="Edit your comment..."
            maxlength="1000"
            required
          >${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(comment.content)}</textarea>
          <div class="edit-form-actions">
            <button type="submit" id="editSubmitBtn" class="edit-submit-btn">
              \u{1F4BE} Save
            </button>
            <button type="button" id="editCancelBtn" class="edit-cancel-btn">
              \u{274C} Cancel
            </button>
          </div>
          <div class="char-count">
            <span id="editCharCount">${comment.content.length}</span>/1000 characters
          </div>
        </div>
      </form>
    `;
    }
    async deleteComment(commentId) {
        // Convert string ID to number
        const numericCommentId = parseInt(commentId, 10);
        if (!confirm('Are you sure you want to delete this comment? This action cannot be undone.')) return;
        window.logger.component('delete_start', 'comments-section', {
            commentId: numericCommentId
        });
        try {
            if (this.isGroupMode()) await window.API.request(`/groups/${this.groupId}/posts/${this.postId}/comments/${numericCommentId}`, {
                method: 'DELETE'
            });
            else await window.API.request(`/comments/${numericCommentId}`, {
                method: 'DELETE'
            });
            window.logger.component('delete_success', 'comments-section', {
                commentId: numericCommentId
            });
            this.showSuccess('Comment deleted successfully!');
            // Reload comments to reflect the deletion
            await this.loadComments();
            // Dispatch event for other components
            this.dispatchEvent(new CustomEvent('comment-deleted', {
                detail: {
                    commentId: numericCommentId
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to delete comment', error, {
                commentId: numericCommentId
            });
            this.showError(error.message || 'Failed to delete comment');
        }
    }
    formatTimeAgo(date) {
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return 'Just now';
        else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes}m ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours}h ago`;
        } else if (diffInSeconds < 2592000) {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days}d ago`;
        } else return date.toLocaleDateString();
    }
    showSuccess(message) {
        const successDiv = document.createElement('div');
        successDiv.className = 'alert alert-success';
        successDiv.textContent = message;
        successDiv.style.position = 'fixed';
        successDiv.style.top = '20px';
        successDiv.style.right = '20px';
        successDiv.style.zIndex = '10000';
        successDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(successDiv);
        setTimeout(()=>successDiv.remove(), 4000);
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10000';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
    async reportComment(commentId) {
        if (this._reportInFlight) return;
        const numericCommentId = parseInt(commentId, 10);
        const comment = this.findCommentById(numericCommentId);
        if (!comment) {
            window.logger.error('Comment not found for reporting', null, {
                commentId: numericCommentId
            });
            alert('Comment not found.');
            return;
        }
        this._reportInFlight = true;
        try {
            const reason = prompt('Why are you reporting this comment?\n\nPlease provide a brief reason (e.g., "Inappropriate content", "Spam", "Harassment", etc.):');
            if (!reason || reason.trim().length === 0) return;
            const description = prompt('Additional details (optional):\n\nProvide any additional context that might help us understand the issue:') || '';
            if (this.isGroupMode()) {
                await window.API.request(`/groups/${this.groupId}/reports`, {
                    method: 'POST',
                    body: JSON.stringify({
                        target_type: 'comment',
                        target_id: numericCommentId,
                        reason: reason.trim(),
                        details: `Comment #${numericCommentId}: ${description.trim()}`
                    })
                });
                alert('Thank you for reporting this comment. Group moderators will review it.');
                return;
            }
            const response = await window.API.request('/support/flag-post', {
                method: 'POST',
                body: JSON.stringify({
                    post_id: this.postId,
                    comment_id: numericCommentId,
                    reason: reason.trim(),
                    description: `Comment #${numericCommentId}: ${description.trim()}\n\nComment content: ${comment.content.substring(0, 200)}${comment.content.length > 200 ? '...' : ''}`
                })
            });
            alert('Thank you for reporting this comment. Our team will review it shortly.');
            const safetyArmadillo = document.querySelector('safety-armadillo');
            if (safetyArmadillo && response.ticket) {
                safetyArmadillo.open();
                setTimeout(()=>{
                    safetyArmadillo.viewTicket(response.ticket.id || response.ticket.conversation_id);
                }, 500);
            }
        } catch (error) {
            window.logger.error('Failed to report comment:', error);
            alert(`Failed to report comment: ${error.message || 'Please try again later.'}`);
        } finally{
            this._reportInFlight = false;
        }
    }
}
// Register the custom element
customElements.define('comments-section', $d64c83c9af5488d6$var$CommentsSection);


// Event Comments Section Web Component

class $e2503a8b2c7086b2$var$EventComments extends HTMLElement {
    constructor(){
        super();
        this.eventId = null;
        this.comments = [];
        this.isLoading = false;
        this.error = null;
        this.replyingTo = null;
        this.currentUser = null;
        this.isPublic = false;
        this.editingCommentId = null;
        this.subscriptionStatus = null;
        // These will be set by parent component
        this.renderWatchButton = null;
        this.onWatchButtonClick = null;
        this.onWatchOptionClick = null;
    }
    static get observedAttributes() {
        return [
            'event-id',
            'is-public'
        ];
    }
    connectedCallback() {
        this.render();
        if (this.eventId) this.loadComments();
    }
    disconnectedCallback() {
        this.removeEventListeners();
        if (this.commentActionsListener) {
            this.removeEventListener('click', this.commentActionsListener);
            this.commentActionsListener = null;
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'event-id' && newValue !== oldValue) {
            this.eventId = newValue;
            this.comments = [];
            this.loadComments();
        }
        if (name === 'is-public' && newValue !== oldValue) this.isPublic = newValue === 'true';
    }
    setCurrentUser(user) {
        this.currentUser = user;
        this.populateAliasFields();
    }
    setSubscriptionStatus(status) {
        this.subscriptionStatus = status;
        this.render();
    }
    render() {
        this.innerHTML = `
      <div class="event-comments">
        <div class="comments-header">
          <h3>\u{1F4AC} Discussion</h3>
          <div class="comments-header-right">
            ${this.renderWatchButton ? this.renderWatchButton() : ''}
            <div class="comments-count" id="commentsCount">${this.comments.length > 0 ? this.comments.length : '0'}</div>
          </div>
        </div>

        ${this.isPublic ? this.renderPublicEventWarning() : ''}

        <div class="comments-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
        // Re-attach event listeners after render
        this.attachEventListeners();
    }
    renderPublicEventWarning() {
        return `
      <div class="public-event-warning">
        <div class="warning-icon">\u{26A0}\u{FE0F}</div>
        <div class="warning-text">
          <strong>This is a public event.</strong>
          Your comment will be visible to anyone viewing this event, including search engines.
        </div>
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading comments...</p>
        </div>
      `;
        if (this.error) return `
        <div class="error-state">
          <span class="error-icon">\u{1F61E}</span>
          <h4>Failed to Load Comments</h4>
          <p>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.error)}</p>
        </div>
      `;
        const commentsHtml = this.comments.length === 0 ? `
        <div class="empty-state">
          <h4>No comments yet</h4> \u{2014} <p>Be the first to share your thoughts!</p>
        </div>
      ` : `
        <div class="comments-list">
          ${this.renderThreadedComments()}
        </div>
      `;
        return `
      ${commentsHtml}
      ${!this.replyingTo ? this.renderCommentForm() : ''}
    `;
    }
    renderCommentForm(isReply = false, replyToComment = null) {
        const replyingTo = replyToComment || this.replyingTo;
        return `
      <form class="comment-form ${isReply ? 'inline-reply-form' : ''}" id="commentForm" data-reply-to="${replyingTo ? replyingTo.id : ''}">
        ${replyingTo ? `
          <div class="comment-form-header">
            <h4 class="comment-form-title">Replying to ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(replyingTo.username)}</h4>
            <button type="button" class="cancel-reply-btn" id="cancelReplyBtn">Cancel</button>
          </div>
        ` : ''}
        
        ${this.currentUser ? `
          <div class="alias-field">
            <label for="aliasInput" class="alias-label">
              Post as:
              <span class="mischief-icon" title="You can change your display name for this comment! Don't worry, we still know it's you \u{1F609}">
                \u{1F99D}
              </span>
            </label>
            <input 
              type="text" 
              id="aliasInput" 
              name="alias" 
              class="alias-input"
              placeholder="Your display name..."
              maxlength="50"
              value="${this.currentUser && this.currentUser.username ? (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.currentUser.username) : ''}"
            />
          </div>
        ` : `
          <div class="guest-fields">
            <input 
              type="text" 
              id="guestNameInput" 
              name="guestName" 
              class="guest-input"
              placeholder="Your name..."
              maxlength="100"
              required
            />
            <input 
              type="email" 
              id="guestEmailInput" 
              name="guestEmail" 
              class="guest-input"
              placeholder="Your email..."
              required
            />
          </div>
        `}
        
        <markdown-preview>
          <textarea 
            id="commentTextarea" 
            name="content" 
            placeholder="${replyingTo ? 'Write your reply...' : 'Share your thoughts...'}"
            required
          ></textarea>
        </markdown-preview>
        <div class="comment-form-actions">
          <button type="submit" class="btn btn-primary" id="submitBtn">
            <span class="btn-text">${replyingTo ? 'Post Reply' : 'Post Comment'}</span>
            <span class="btn-loading" style="display: none;">\u{23F3} Posting...</span>
          </button>
          <button type="button" class="btn btn-secondary clear-btn" id="clearBtn">Clear</button>
        </div>
      </form>
    `;
    }
    renderThreadedComments() {
        const commentTree = this.buildCommentTree(this.comments);
        return commentTree.map((comment)=>this.renderCommentThread(comment, 0)).join('');
    }
    buildCommentTree(comments) {
        const commentMap = new Map();
        const rootComments = [];
        comments.forEach((comment)=>{
            commentMap.set(comment.id, {
                ...comment,
                children: []
            });
        });
        comments.forEach((comment)=>{
            if (comment.parentId && commentMap.has(comment.parentId)) commentMap.get(comment.parentId).children.push(commentMap.get(comment.id));
            else rootComments.push(commentMap.get(comment.id));
        });
        return rootComments;
    }
    renderCommentThread(comment, depth = 0) {
        const createdDate = new Date(comment.createdAt);
        const timeAgo = this.formatTimeAgo(createdDate);
        const isReply = depth > 0;
        const maxDepth = 3;
        const parentContext = isReply && comment.parentId ? this.renderParentContext(comment.parentId) : '';
        const commentHtml = `
      <div class="comment-thread" data-comment-id="${comment.id}" data-depth="${depth}">
        <div class="comment-item ${isReply ? 'comment-reply' : 'comment-root'}" style="--thread-depth: ${Math.min(depth, maxDepth)}" data-depth="${depth}">
          ${parentContext}
          <div class="comment-main">
            <a name="comment-${comment.id}"></a>
            <div class="comment-header">
              <div class="comment-author">
                <div class="comment-avatar">
                  ${comment.username ? comment.username.charAt(0).toUpperCase() : '?'}
                </div>
                <div class="comment-author-info">
                  <div class="comment-author-name">
                    <user-mention username="${comment.username}" real-username="${comment.realUsername}" user-id="${this.currentUser.id}"  class="comment-author-link"></user-mention>
                  </div>
                  <div class="comment-meta">
                    <span class="comment-time" title="${createdDate.toLocaleString()}">
                      ${timeAgo}
                    </span>
                    ${isReply ? '<span class="reply-indicator">\u2022 Reply</span>' : ''}
                  </div>
                </div>
              </div>
              <div class="comment-actions">
                ${comment.isOwner ? `
                  <button class="comment-action-btn" data-action="edit" data-comment-id="${comment.id}" title="Edit comment">
                    \u{270F}\u{FE0F}
                  </button>
                  <button class="comment-action-btn" data-action="delete" data-comment-id="${comment.id}" title="Delete comment">
                    \u{1F5D1}\u{FE0F}
                  </button>
                ` : `
                  <button class="comment-action-btn" data-action="report" data-comment-id="${comment.id}" title="Report comment">
                    \u{1F6A9}
                  </button>
                `}
              </div>
            </div>
            
            ${this.editingCommentId === comment.id ? this.renderEditForm(comment) : `
              <div class="comment-content">${comment.content_html || ''}</div>
              
              <div class="comment-footer">
                ${this.currentUser || this.isPublic ? `
                  <button class="btn comment-reply-btn" data-action="reply" data-comment-id="${comment.id}">
                    \u{1F4AC} Reply
                  </button>
                ` : ''}
                <a href="#comment-${comment.id}" class="comment-permalink" title="Link to this comment">
                  #${comment.id}
                </a>
              </div>
            `}
          </div>
        </div>
        
        ${this.replyingTo && this.replyingTo.id === comment.id ? `
          <div class="inline-reply-container">
            ${this.renderCommentForm(true, comment)}
          </div>
        ` : ''}
        
        ${comment.children && comment.children.length > 0 ? `
          <div class="comment-replies">
            ${comment.children.map((child)=>this.renderCommentThread(child, depth + 1)).join('')}
          </div>
        ` : ''}
      </div>
    `;
        return commentHtml;
    }
    renderParentContext(parentId) {
        const parentComment = this.comments.find((c)=>c.id === parentId);
        if (!parentComment) return '';
        return `
      <div class="parent-context">
        <div class="parent-context-line"></div>
        <div class="parent-context-content">
          <span class="parent-context-author">@${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(parentComment.username || parentComment.guestName || 'Guest')}</span>
          <span class="parent-context-text">${this.truncateText(parentComment.content, 50)}</span>
        </div>
      </div>
    `;
    }
    renderEditForm(comment) {
        return `
      <form class="edit-comment-form" id="edit-form-${comment.id}">
        <div class="edit-form-group">
          <textarea 
            id="editTextarea" 
            class="edit-comment-textarea"
            placeholder="Edit your comment..."
            maxlength="2000"
            required
          >${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(comment.content)}</textarea>
          <div class="edit-form-actions">
            <button type="submit" id="editSubmitBtn" class="edit-submit-btn">
              \u{1F4BE} Save
            </button>
            <button type="button" id="editCancelBtn" class="edit-cancel-btn">
              \u{274C} Cancel
            </button>
          </div>
          <div class="char-count">
            <span id="editCharCount">${comment.content.length}</span>/2000 characters
          </div>
        </div>
      </form>
    `;
    }
    truncateText(text, maxLength) {
        if (text.length <= maxLength) return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(text);
        return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(text.substring(0, maxLength)) + '...';
    }
    attachEventListeners() {
        this.removeEventListeners();
        const commentForms = this.querySelectorAll('.comment-form');
        commentForms.forEach((form)=>{
            form.addEventListener('submit', this.handleFormSubmit);
        });
        const editForms = this.querySelectorAll('.edit-comment-form');
        editForms.forEach((form)=>{
            form.addEventListener('submit', this.handleEditFormSubmit);
        });
        // Clear button - clears the comment form
        const clearBtns = this.querySelectorAll('#clearBtn');
        clearBtns.forEach((btn)=>{
            btn.addEventListener('click', this.handleClearClick);
        });
        // Cancel buttons - handle cancel reply and edit cancel buttons
        const cancelBtns = this.querySelectorAll('#cancelReplyBtn, #editCancelBtn');
        cancelBtns.forEach((btn)=>{
            btn.addEventListener('click', this.handleCancelClick);
        });
        if (!this.commentActionsListener) {
            this.commentActionsListener = (e)=>{
                const action = e.target.closest('[data-action]')?.dataset.action;
                const commentId = e.target.closest('[data-action]')?.dataset.commentId;
                switch(action){
                    case 'reply':
                        this.startReply(commentId);
                        break;
                    case 'edit':
                        this.editComment(commentId);
                        break;
                    case 'delete':
                        this.deleteComment(commentId);
                        break;
                    case 'report':
                        this.reportComment(commentId);
                        break;
                }
            };
            this.addEventListener('click', this.commentActionsListener);
        }
        const editTextareas = this.querySelectorAll('#editTextarea');
        editTextareas.forEach((textarea)=>{
            const charCount = textarea.parentElement.querySelector('#editCharCount');
            if (charCount) textarea.addEventListener('input', ()=>{
                charCount.textContent = textarea.value.length;
            });
        });
        // Watch button for comment notifications
        const watchBtn = this.querySelector('#watchBtn');
        if (watchBtn && this.onWatchButtonClick) watchBtn.addEventListener('click', (e)=>{
            e.stopPropagation();
            this.onWatchButtonClick();
        });
        // Watch dropdown options
        const watchOptions = this.querySelectorAll('.watch-option');
        watchOptions.forEach((option)=>{
            option.addEventListener('click', async (e)=>{
                e.stopPropagation();
                const type = e.currentTarget.dataset.type;
                if (this.onWatchOptionClick) await this.onWatchOptionClick(type);
            });
        });
    }
    removeEventListeners() {
        const commentForms = this.querySelectorAll('.comment-form');
        commentForms.forEach((form)=>{
            form.removeEventListener('submit', this.handleFormSubmit);
        });
        const editForms = this.querySelectorAll('.edit-comment-form');
        editForms.forEach((form)=>{
            form.removeEventListener('submit', this.handleEditFormSubmit);
        });
        const clearBtns = this.querySelectorAll('#clearBtn');
        clearBtns.forEach((btn)=>{
            btn.removeEventListener('click', this.handleClearClick);
        });
        const cancelBtns = this.querySelectorAll('#cancelReplyBtn, #editCancelBtn');
        cancelBtns.forEach((btn)=>{
            btn.removeEventListener('click', this.handleCancelClick);
        });
    }
    handleFormSubmit = (e)=>{
        e.preventDefault();
        this.handleSubmit(e.target);
    };
    handleEditFormSubmit = (e)=>{
        e.preventDefault();
        const commentId = e.target.id.replace('edit-form-', '');
        this.handleEditSubmit(commentId);
    };
    handleClearClick = ()=>{
        this.clearForm();
    };
    handleCancelClick = (e)=>{
        if (e.target.id === 'cancelReplyBtn') this.cancelReply();
        else if (e.target.id === 'editCancelBtn') this.cancelEdit();
    };
    populateAliasFields() {
        const aliasInputs = this.querySelectorAll('.alias-input');
        aliasInputs.forEach((input)=>{
            if (this.currentUser && this.currentUser.username) input.value = this.currentUser.username;
        });
    }
    async loadComments() {
        if (!this.eventId) return;
        this.isLoading = true;
        this.error = null;
        this.updateContent();
        try {
            const response = await window.API.request(`/events/${this.eventId}/comments`);
            this.comments = response.comments || [];
            this.updateCommentsCount();
        } catch (error) {
            window.logger.error('Failed to load event comments:', error);
            this.comments = [];
            this.error = error.message || 'Failed to load comments';
        } finally{
            this.isLoading = false;
            this.updateContent();
        }
    }
    updateContent() {
        const contentContainer = this.querySelector('.comments-content');
        if (contentContainer) {
            contentContainer.innerHTML = this.renderContent();
            this.attachEventListeners();
            this.populateAliasFields();
        }
    }
    updateCommentsCount() {
        const countElement = this.querySelector('#commentsCount');
        if (countElement) {
            const count = this.comments.length;
            countElement.textContent = count === 1 ? '1 comment' : `${count} comments`;
        }
    }
    async handleSubmit(form = null) {
        if (!form) form = this.querySelector('.comment-form');
        const textarea = form.querySelector('#commentTextarea');
        const aliasInput = form.querySelector('#aliasInput');
        const guestNameInput = form.querySelector('#guestNameInput');
        const guestEmailInput = form.querySelector('#guestEmailInput');
        const submitBtn = form.querySelector('#submitBtn');
        const content = textarea.value.trim();
        if (!content) return;
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
        const replyToId = form.dataset.replyTo;
        const isReply = replyToId && replyToId !== '';
        try {
            const requestBody = {
                content: content
            };
            if (this.currentUser) {
                const displayName = aliasInput ? aliasInput.value.trim() : this.currentUser.username;
                requestBody.displayName = displayName;
            } else {
                if (!guestNameInput || !guestEmailInput || !guestNameInput.value.trim() || !guestEmailInput.value.trim()) {
                    this.showError('Please provide your name and email to comment as a guest.');
                    return;
                }
                requestBody.guestName = guestNameInput.value.trim();
                requestBody.guestEmail = guestEmailInput.value.trim();
            }
            if (isReply) requestBody.parentId = parseInt(replyToId);
            const response = await window.API.request(`/events/${this.eventId}/comments`, {
                method: 'POST',
                body: JSON.stringify(requestBody)
            });
            this.showSuccess(isReply ? 'Reply posted!' : 'Comment posted!');
            this.clearForm();
            await this.loadComments();
            this.dispatchEvent(new CustomEvent('comment-added', {
                detail: {
                    comment: response.comment
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to post comment:', error);
            this.showError(error.message || 'Failed to post comment');
        } finally{
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
        }
    }
    startReply(commentId) {
        if (this.editingCommentId) {
            this.showError('Please finish or cancel your edit before replying to a comment.');
            return;
        }
        if (!this.currentUser && !this.isPublic) {
            this.showError('You must be logged in to reply to comments on private events.');
            return;
        }
        const comment = this.comments.find((c)=>c.id === parseInt(commentId));
        if (comment) {
            this.replyingTo = comment;
            this.updateContent();
            const textarea = this.querySelector('#commentTextarea');
            textarea?.focus();
        }
    }
    cancelReply() {
        this.replyingTo = null;
        this.updateContent();
    }
    clearForm() {
        this.replyingTo = null;
        const textarea = this.querySelector('#commentTextarea');
        const aliasInput = this.querySelector('#aliasInput');
        const guestNameInput = this.querySelector('#guestNameInput');
        const guestEmailInput = this.querySelector('#guestEmailInput');
        if (textarea) textarea.value = '';
        if (aliasInput) aliasInput.value = this.currentUser ? this.currentUser.username : '';
        if (guestNameInput) guestNameInput.value = '';
        if (guestEmailInput) guestEmailInput.value = '';
        this.updateContent();
    }
    editComment(commentId) {
        const numericCommentId = parseInt(commentId, 10);
        if (this.replyingTo) {
            this.showError('Please finish or cancel your reply before editing a comment.');
            return;
        }
        const comment = this.findCommentById(numericCommentId);
        if (!comment) {
            this.showError('Comment not found.');
            return;
        }
        if (!comment.isOwner) {
            this.showError('You can only edit your own comments.');
            return;
        }
        this.editingCommentId = numericCommentId;
        this.updateContent();
    }
    findCommentById(commentId, comments = this.comments) {
        for (const comment of comments){
            if (comment.id === commentId) return comment;
            if (comment.children && comment.children.length > 0) {
                const found = this.findCommentById(commentId, comment.children);
                if (found) return found;
            }
        }
        return null;
    }
    async handleEditSubmit(commentId) {
        const numericCommentId = parseInt(commentId, 10);
        const editForm = this.querySelector(`#edit-form-${numericCommentId}`);
        if (!editForm) return;
        const textarea = editForm.querySelector('#editTextarea');
        const submitBtn = editForm.querySelector('#editSubmitBtn');
        const content = textarea.value.trim();
        if (!content) {
            this.showError('Comment content cannot be empty.');
            return;
        }
        if (content.length > 2000) {
            this.showError('Comment content must be less than 2000 characters.');
            return;
        }
        submitBtn.classList.add('loading');
        submitBtn.disabled = true;
        try {
            const response = await window.API.request(`/events/${this.eventId}/comments/${numericCommentId}`, {
                method: 'PUT',
                body: JSON.stringify({
                    content: content
                })
            });
            this.showSuccess('Comment updated successfully!');
            this.editingCommentId = null;
            await this.loadComments();
            this.dispatchEvent(new CustomEvent('comment-updated', {
                detail: {
                    comment: response.comment
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to update comment', error);
            this.showError(error.message || 'Failed to update comment');
        } finally{
            submitBtn.classList.remove('loading');
            submitBtn.disabled = false;
        }
    }
    cancelEdit() {
        this.editingCommentId = null;
        this.updateContent();
    }
    async deleteComment(commentId) {
        const numericCommentId = parseInt(commentId, 10);
        if (!confirm('Are you sure you want to delete this comment? This action cannot be undone.')) return;
        try {
            await window.API.request(`/events/${this.eventId}/comments/${numericCommentId}`, {
                method: 'DELETE'
            });
            this.showSuccess('Comment deleted successfully!');
            await this.loadComments();
            this.dispatchEvent(new CustomEvent('comment-deleted', {
                detail: {
                    commentId: numericCommentId
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to delete comment', error);
            this.showError(error.message || 'Failed to delete comment');
        }
    }
    formatTimeAgo(date) {
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return 'Just now';
        else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes}m ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours}h ago`;
        } else if (diffInSeconds < 2592000) {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days}d ago`;
        } else return date.toLocaleDateString();
    }
    showSuccess(message) {
        const successDiv = document.createElement('div');
        successDiv.className = 'alert alert-success';
        successDiv.textContent = message;
        successDiv.style.position = 'fixed';
        successDiv.style.top = '20px';
        successDiv.style.right = '20px';
        successDiv.style.zIndex = '10000';
        successDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(successDiv);
        setTimeout(()=>successDiv.remove(), 4000);
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10000';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
    async reportComment(commentId) {
        const numericCommentId = parseInt(commentId, 10);
        if (!numericCommentId || isNaN(numericCommentId)) {
            window.logger.error('Event comment not found for reporting', null, {
                commentId: numericCommentId
            });
            this.showError('Invalid comment ID.');
            return;
        }
        // Show report modal
        const reason = prompt('Why are you reporting this comment?\n\nPlease provide a brief reason (e.g., "Inappropriate content", "Spam", "Harassment", etc.):');
        if (!reason || reason.trim().length === 0) return; // User cancelled or didn't provide a reason
        try {
            // Report event comment using the flag-post endpoint with event_comment_id
            const response = await window.API.request('/support/flag-post', {
                method: 'POST',
                body: JSON.stringify({
                    event_comment_id: numericCommentId,
                    reason: reason.trim(),
                    description: ''
                })
            });
            if (response && response.ticket) this.showSuccess('Thank you for reporting this comment. Our team will review it shortly.');
            else this.showSuccess('Thank you for reporting this comment. Our team will review it shortly.');
        } catch (error) {
            window.logger.error('Failed to report event comment:', error);
            this.showError(`Failed to report comment: ${error.message || 'Please try again later.'}`);
        }
    }
}
// Register the custom element
customElements.define('event-comments', $e2503a8b2c7086b2$var$EventComments);


/**
 * Date helper utilities for parsing and formatting event dates
 */ /**
 * Parse a date string from the API (handles both MySQL and ISO formats)
 * @param {string} dateString - Date string from API
 * @returns {Date} JavaScript Date object
 */ function $abf83f7e582f4a57$export$d1d7aa5ddaf1e876(dateString, timeZone = 'UTC') {
    if (!dateString) return null;
    const normalized = dateString.includes('T') ? dateString : dateString.replace(' ', 'T');
    const hasExplicitOffset = /[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized);
    if (!hasExplicitOffset && typeof dayjs?.tz === 'function' && timeZone) try {
        const zoned = dayjs.tz(normalized, timeZone);
        if (zoned.isValid()) return zoned.toDate();
    } catch (_err) {
    // dayjs.tz can throw "Invalid time value" - fall through to plain dayjs
    }
    const fallback = dayjs(normalized);
    return fallback.isValid() ? fallback.toDate() : null;
}
function $abf83f7e582f4a57$export$3d49a77a0c87c6aa(date) {
    if (!date || !(date instanceof Date) || isNaN(date)) return 'Invalid Date';
    // ll	MMM D, YYYY	Aug 16, 2018
    return dayjs.utc(date).local().format('ddd, MMM D, YYYY');
}
function $abf83f7e582f4a57$export$e6fb52c7265a62e5(date) {
    if (!date || !(date instanceof Date) || isNaN(date)) return 'Invalid Time';
    return dayjs.utc(date).local().format('h:mm A');
}
function $abf83f7e582f4a57$export$913e078cc32e4067(date, timeZone) {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) return '';
    try {
        if (typeof dayjs?.tz === 'function' && timeZone) return dayjs(date).tz(timeZone).format('YYYY-MM-DDTHH:mm');
        return dayjs(date).format('YYYY-MM-DDTHH:mm');
    } catch (_err) {
        return '';
    }
}
/**
 * Regex for datetime-local format: YYYY-MM-DD[ T]HH:mm or YYYY-MM-DD[ T]HH:mm:ss
 * Used to validate before parsing to avoid dayjs.tz throwing on malformed input
 */ const $abf83f7e582f4a57$var$DATETIME_LOCAL_REGEX = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(?::\d{2})?$/;
function $abf83f7e582f4a57$export$fda5dfd4def5d3a1(datetimeLocal, timeZone) {
    const trimmed = typeof datetimeLocal === 'string' ? datetimeLocal.trim() : '';
    if (!trimmed) return null;
    // Validate format before parsing - dayjs.tz can throw "Invalid time value" for
    // malformed input (via Intl.DateTimeFormat.formatToParts)
    if (!$abf83f7e582f4a57$var$DATETIME_LOCAL_REGEX.test(trimmed)) return null;
    let localDate;
    try {
        if (timeZone && typeof dayjs?.tz === 'function') localDate = dayjs.tz(trimmed, timeZone);
        else localDate = dayjs(trimmed);
    } catch (_err) {
        return null;
    }
    if (!localDate.isValid()) return null;
    // Format as MySQL DATETIME (YYYY-MM-DD HH:MM:SS)
    return localDate.format('YYYY-MM-DD HH:mm:ss');
}


/**
 * Mascot rendering utilities for Fun Old Times
 * Centralized mascot components for reuse across the application
 * All SVG content is externalized to reduce file size
 */ /**
 * Renders a miniature Party Panda mascot with party hat
 * @returns {string} HTML string with img tag
 */ function $72156d6136272719$export$ecd7744ff94b6c2c() {
    return `
    <img 
      src="/frontend/images/mascots/tiny-party-panda.svg" 
      alt="Tiny Party Panda" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$54881ba96924d965() {
    return `
    <img 
      src="/frontend/images/mascots/social-otter.svg" 
      alt="Society Otter" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$9e692b1d5bd8d52b() {
    return $72156d6136272719$export$54881ba96924d965();
}
function $72156d6136272719$export$1bb9b41c0ac99906() {
    return `
    <img 
      src="/frontend/images/mascots/party-panda.svg" 
      alt="Party Panda" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$10887f604112412() {
    return `
    <img 
      src="/frontend/images/mascots/party-panda-megaphone.svg" 
      alt="Party Panda with Megaphone" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$c122825150439c0c() {
    return `
    <img 
      src="/frontend/images/mascots/disco-capybara.svg" 
      alt="Disco Capybara" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$37862db051631868() {
    return `
    <img 
      src="/frontend/images/mascots/safety-armadillo.svg" 
      alt="Safety Armadillo" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$49858dd6b5cd22f8() {
    return `
    <img 
      src="/frontend/images/mascots/taco-ufo.svg" 
      alt="Taco UFO" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$6d8f7be78b6bb2fb() {
    return `
    <img 
      src="/frontend/images/mascots/gossip-goose.svg" 
      alt="Gossip Goose" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}
function $72156d6136272719$export$5b8162d51027501d() {
    return `
    <img 
      src="/frontend/images/mascots/missing-mole.svg" 
      alt="Missing Mole - Unknown file type" 
      class="mascot-icon"
      aria-hidden="true"
    />
  `;
}



const $ec0e472fc3ccab74$export$939d3f7c126c7c3f = 'tab';
function $ec0e472fc3ccab74$export$e2b2b57dce2a82fb(tabId, allowedTabs) {
    return Boolean(tabId && Array.isArray(allowedTabs) && allowedTabs.includes(tabId));
}
function $ec0e472fc3ccab74$export$4d96fceac8695298(allowedTabs, { defaultTab: defaultTab = null } = {}) {
    if (typeof window === 'undefined') return defaultTab;
    const params = new URLSearchParams(window.location.search);
    const tab = params.get($ec0e472fc3ccab74$export$939d3f7c126c7c3f);
    if ($ec0e472fc3ccab74$export$e2b2b57dce2a82fb(tab, allowedTabs)) return tab;
    return defaultTab;
}
function $ec0e472fc3ccab74$export$19a03c6887cb23d9(tabId, { omitDefault: omitDefault = null } = {}) {
    if (typeof window === 'undefined') return;
    const url = new URL(window.location.href);
    if (omitDefault && tabId === omitDefault) url.searchParams.delete($ec0e472fc3ccab74$export$939d3f7c126c7c3f);
    else url.searchParams.set($ec0e472fc3ccab74$export$939d3f7c126c7c3f, tabId);
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
}


const $20c8801317818cae$var$EVENT_DETAIL_DEFAULT_TAB = 'details';
// Event Detail Component
class $20c8801317818cae$var$EventDetail extends HTMLElement {
    constructor(){
        super();
        this.event = null;
        this.currentUser = null;
        this.loading = true;
        this.reminders = [];
        this.invitations = [];
        this.userInvitation = null; // Current user's invitation (for opt-out status)
        this.activeTab = 'details'; // details or invited
        this.subscriptionStatus = null; // {subscribed: bool, subscription_type: string, is_organizer: bool}
        this.showSubscriptionDropdown = false;
    }
    async connectedCallback() {
        const eventId = this.getAttribute('event-id');
        if (eventId) await this.loadEvent(eventId);
        this.render();
    }
    setCurrentUser(user) {
        this.currentUser = user;
        // If event is already loaded and user is organizer, load invitations
        if (this.event && this.currentUser) {
            const eventId = this.getAttribute('event-id');
            if (eventId) {
                this.loadInvitations(eventId);
                // Also load user's own invitation for recurring events (for opt-out status)
                if (this.event.is_recurring || this.event.parent_event_id) this.loadUserInvitation(eventId);
            }
        }
        // Also set currentUser on the comments component if it exists
        const commentsComponent = this.querySelector('#eventCommentsComponent');
        if (commentsComponent && this.currentUser) commentsComponent.setCurrentUser(this.currentUser);
    }
    async loadInvitations(eventId) {
        if (!this.isCurrentUserOrganizer()) return;
        try {
            const invitationData = await window.API.request(`/events/${eventId}/invitations`);
            this.invitations = invitationData.invitations || [];
            this.render();
        } catch (error) {
            if (error.statusCode !== 403 && error.statusCode !== 404) window.logger.error('Failed to load invitations:', error);
            this.invitations = [];
        }
    }
    async loadUserInvitation(eventId) {
        if (!this.currentUser) return;
        try {
            const invitationData = await window.API.request(`/events/${eventId}/invitations`);
            // Find current user's invitation
            this.userInvitation = invitationData.invitations?.find((inv)=>inv.user_id === this.currentUser.id) || null;
            this.render();
        } catch (error) {
            // 404 or 403 is OK - user might not be invited
            if (error.statusCode !== 403 && error.statusCode !== 404) window.logger.error('Failed to load user invitation:', error);
            this.userInvitation = null;
        }
    }
    async loadEvent(eventId) {
        try {
            this.loading = true;
            this.event = await window.API.request(`/events/${eventId}`);
            // Load reminders if user has RSVP'd
            if (this.event.user_rsvp) try {
                const reminderData = await window.API.request(`/events/${eventId}/reminders`);
                this.reminders = reminderData.reminders || [];
            } catch (error) {
                // 404 is OK - means no reminders configured yet
                if (error.statusCode !== 404) window.logger.error('Failed to load reminders:', error);
                this.reminders = [];
            }
            else this.reminders = [];
            // Load user's invitation to get opt-out status (for recurring events)
            if (this.currentUser && (this.event.is_recurring || this.event.parent_event_id)) await this.loadUserInvitation(eventId);
            else this.userInvitation = null;
            // Load invitations if user is already set and is organizer
            if (this.currentUser && this.isCurrentUserOrganizer()) {
                try {
                    const invitationData = await window.API.request(`/events/${eventId}/invitations`);
                    this.invitations = invitationData.invitations || [];
                } catch (error) {
                    if (error.statusCode !== 403 && error.statusCode !== 404) window.logger.error('Failed to load invitations:', error);
                    this.invitations = [];
                }
                // Load subscription status
                await this.loadSubscriptionStatus(eventId);
            }
            this.activeTab = this.resolveActiveTabFromUrl();
            this.loading = false;
            this.render();
        } catch (error) {
            window.logger.error('Failed to load event:', error);
            this.loading = false;
            this.innerHTML = `
        <div class="event-container">
          <div class="error">Failed to load event. Please try again.</div>
        </div>
      `;
        }
    }
    render() {
        if (this.loading) {
            this.innerHTML = `
      <div class="event-container">
        <div class="loading">Loading event...</div>
      </div>
    `;
            return;
        }
        if (!this.event) return;
        // Parse event times and convert to user's local timezone
        const eventTimezone = this.event.timezone || 'UTC';
        const startDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.start_time, eventTimezone);
        const endDate = this.event.end_time ? (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.end_time, eventTimezone) : null;
        const dateStr = (0, $abf83f7e582f4a57$export$3d49a77a0c87c6aa)(startDate, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        const timeStr = (0, $abf83f7e582f4a57$export$e6fb52c7265a62e5)(startDate);
        const endTimeStr = endDate ? (0, $abf83f7e582f4a57$export$e6fb52c7265a62e5)(endDate) : null;
        const isOrganizer = this.currentUser && this.event.organizers && this.event.organizers.some((org)=>org.user_id === this.currentUser.id);
        const isInstance = !!this.event.parent_event_id;
        const isRecurringParent = this.event.is_recurring && !this.event.parent_event_id;
        // Add colored border class based on event type
        const containerClass = isInstance ? 'event-container viewing-instance' : isRecurringParent ? 'event-container viewing-recurring' : 'event-container';
        const isCancelled = !!this.event.is_cancelled;
        this.innerHTML = `
      <div class="${containerClass}${isCancelled ? ' event-cancelled' : ''}">
        <div class="event-header">
          <button class="btn-back" id="backBtn">\u{2190} Back to Events</button>
          <div class="event-title-row">
            <h1>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.title)}</h1>
            ${isCancelled ? '<span class="badge-cancelled">\u274C Cancelled</span>' : ''}
            ${!isCancelled && this.event.is_public && !this.event.group_id ? '<span class="badge-public">\uD83C\uDF0D Public Event</span>' : ''}
            ${!isCancelled && !this.event.is_public && !this.event.group_id ? '<span class="badge-private">\uD83D\uDD12 Private Event</span>' : ''}
            ${this.event.group_id ? `<a class="badge-group" href="/groups/${this.event.group_id}">\u{1F465} Part of ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.group_name || 'group')}</a>` : ''}
          </div>
          ${isCancelled ? '' : this.renderOrganizerActions(isInstance)}
        </div>

        ${isCancelled ? this.renderCancelledBanner() : ''}
        ${isInstance && !isCancelled ? this.renderInstanceBanner() : ''}

        <div class="event-content">
          <div class="event-main">
            <div class="event-info-card">
              ${isOrganizer ? `
                <div class="invited-tabs">
                  <button class="tab ${this.activeTab === 'details' ? 'active' : ''}" data-tab="details">
                    \u{1F4CB} Event Details
                  </button>
                  <button class="tab ${this.activeTab === 'invited' ? 'active' : ''}" data-tab="invited">
                    \u{1F465} Invited People (${this.invitations.length})
                  </button>
                </div>
                <div class="tab-content-area">
                  ${this.renderTabContent(dateStr, timeStr, endTimeStr)}
                </div>
              ` : this.renderEventDetails(dateStr, timeStr, endTimeStr)}
            </div>
          </div>
        </div>

        <event-comments 
          event-id="${this.event.id}" 
          is-public="${this.event.is_public ? 'true' : 'false'}"
          id="eventCommentsComponent"
        ></event-comments>
      </div>
    `;
        this.attachEventListeners();
        this.initializeCommentsComponent();
    }
    initializeCommentsComponent() {
        const commentsComponent = this.querySelector('#eventCommentsComponent');
        if (commentsComponent) {
            if (this.currentUser) commentsComponent.setCurrentUser(this.currentUser);
            if (this.subscriptionStatus) commentsComponent.setSubscriptionStatus(this.subscriptionStatus);
            // Pass the watch button renderer
            commentsComponent.renderWatchButton = ()=>this.renderWatchButton();
            commentsComponent.onWatchButtonClick = ()=>this.toggleSubscriptionDropdown();
            commentsComponent.onWatchOptionClick = (type)=>this.toggleSubscription(type);
            // Re-render comments component now that watch button is set
            commentsComponent.render();
        }
    }
    renderEventDetails(dateStr, timeStr, endTimeStr) {
        const descriptionContent = this.event.description_html ? this.event.description_html : (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.description);
        return `
      <div class="event-details">
        <div class="detail-row">
          <span class="detail-label">\u{1F4C5} When:</span>
          <span class="detail-value">${dateStr}, ${timeStr}${endTimeStr ? ` - ${endTimeStr}` : ''}</span>
        </div>

        ${this.renderRecurrenceInfo()}
        
        ${this.event.location ? `
          <div class="detail-row">
            <span class="detail-label">\u{1F4CD} Where:</span>
            <span class="detail-value">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.location)}</span>
          </div>
        ` : ''}

        ${descriptionContent ? `
          <div class="detail-row">
            <span class="detail-label">\u{2139}\u{FE0F} Details:</span>
            <span class="detail-value">${descriptionContent}</span>
          </div>
        ` : ''}

        ${this.event.external_links && this.event.external_links.length > 0 ? `
          <div class="detail-row">
            <span class="detail-label">\u{1F517} Links:</span>
            <div class="detail-value">
              <ul class="links-list">
                ${this.event.external_links.map((link)=>`
                  <li>
                    <a class="nobtn" href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(link.url)}" target="_blank" rel="noopener" class="external-link">
                      ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(link.label || link.url)}
                    </a>
                  </li>
                `).join('')}
              </ul>
            </div>
          </div>
        ` : ''}

        <div class="detail-row">
          <span class="detail-label">\u{1F465} Organizers:</span>
          <div class="detail-value">
            ${this.event.organizers.map((org)=>`
              <user-mention class="organizer-name" username="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(org.username)}${org.is_primary ? ' (Primary)' : ''}" real-username="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(org.username)}" user-id=""></user-mention>
            `).join(', ')}
          </div>
        </div>

        ${this.renderAttendeesInline()}
      </div>

      <div class="event-divider"></div>

      ${this.event.is_cancelled ? `
        <p class="cancelled-rsvp-notice">RSVP is closed for this cancelled instance.</p>
      ` : `
      <div class="rsvp-section">
        <div class="rsvp-header">
          <span class="rsvp-label">RSVP</span>
        </div>
        <div class="rsvp-options">
          <button 
            class="btn rsvp-btn ${this.event.user_rsvp === 'yes' ? 'active' : ''}" 
            data-status="yes"
          >
            Yes
          </button>
          <button 
            class="rsvp-btn ${this.event.user_rsvp === 'maybe' ? 'active' : ''}" 
            data-status="maybe"
          >
            Maybe
          </button>
          <button 
            class="btn rsvp-btn ${this.event.user_rsvp === 'no' ? 'active' : ''}" 
            data-status="no"
          >
            No
          </button>
        </div>
        ${this.event.user_rsvp ? `
          <div class="rsvp-status">
            <div>
              <p class="rsvp-current">
                ${this.event.user_rsvp === 'yes' ? 'You\'re attending!' : this.event.user_rsvp === 'maybe' ? 'You might attend' : 'You\'re not attending'}
              </p>
              ${this.renderReminderInfo(this.event.user_rsvp)}
              ${this.renderRsvpReminderOptOut()}
            </div>
            <div class="reminder-button-container">
              <button class="btn-icon-round" id="configureRemindersBtn" 
                      title="Configure Reminders" aria-label="Configure Reminders">
                ${(0, $72156d6136272719$export$10887f604112412)()}
              </button>
            </div>
          </div>
        ` : ''}
      </div>
      `}
    `;
    }
    renderTabContent(dateStr, timeStr, endTimeStr) {
        if (this.activeTab === 'details') return this.renderEventDetails(dateStr, timeStr, endTimeStr);
        else if (this.activeTab === 'invited') return this.renderInvitedTab();
        return '';
    }
    renderInvitedTab() {
        if (this.invitations.length === 0) return `
        <div class="empty-state">
          <p>No one has been invited yet.</p>
        </div>
      `;
        return `
      <div class="invited-list">
        ${this.invitations.map((inv)=>`
          <div class="invited-item">
            <div class="invited-info">
              ${inv.username ? `
                <span class="invited-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(inv.username)}</span>
              ` : `
                <span class="invited-email">${inv.email || inv.phone || 'Unknown'}</span>
              `}
              <span class="invited-rsvp ${inv.rsvp_status}">${this.getRSVPLabel(inv.rsvp_status)}</span>
            </div>
            ${inv.user_id ? `
              <button class="btn btn-sm btn-danger" data-invitation-id="${inv.id}" data-action="revoke">Remove</button>
            ` : ''}
          </div>
        `).join('')}
      </div>
    `;
    }
    getRSVPLabel(status) {
        switch(status){
            case 'yes':
                return "\u2705 Attending";
            case 'maybe':
                return "\uD83E\uDD14 Maybe";
            case 'no':
                return "\u274C Not attending";
            default:
                return "\u23F3 Pending";
        }
    }
    renderAttendeesInline() {
        const yesCount = this.event.yes_count || 0;
        const maybeCount = this.event.maybe_count || 0;
        if (yesCount === 0 && maybeCount === 0) return '';
        return `
      <div class="detail-row">
        <span class="detail-label">\u{1F465} Attendance:</span>
        <div class="detail-value">
          ${yesCount > 0 ? `<span class="attendance-stat"><strong>${yesCount}</strong> attending</span>` : ''}
          ${maybeCount > 0 ? `<span class="attendance-stat"><strong>${maybeCount}</strong> maybe</span>` : ''}
        </div>
      </div>
    `;
    }
    renderCancelledBanner() {
        const reason = this.event.cancellation_reason ? (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.cancellation_reason) : 'This occurrence has been cancelled.';
        return `
      <div class="cancelled-banner">
        <div class="cancelled-banner-content">
          <span class="cancelled-indicator">\u{274C}</span>
          <div>
            <strong>This event instance has been cancelled.</strong>
            <p class="cancelled-reason">${reason}</p>
          </div>
        </div>
      </div>
    `;
    }
    renderInstanceBanner() {
        const eventTimezone = this.event.timezone || 'UTC';
        const originalDate = this.event.original_start_time ? (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.original_start_time, eventTimezone) : null;
        const originalDateStr = originalDate ? (0, $abf83f7e582f4a57$export$3d49a77a0c87c6aa)(originalDate) : null;
        const originalTimeStr = originalDate ? (0, $abf83f7e582f4a57$export$e6fb52c7265a62e5)(originalDate) : null;
        return `
      <div class="instance-banner">
        <div class="instance-banner-content">
          <span class="instance-indicator">\u{1F4C5}</span>
          ${this.event.is_modified_instance && originalDateStr ? `
            <span class="modified-badge">Modified</span>
            <span class="original-date">Originally: ${originalDateStr} at ${originalTimeStr}</span>
            ${this.event.modification_reason ? `
              <span class="modification-reason">Reason: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.modification_reason)}</span>
            ` : ''}
          ` : ''}
          <a href="/events/${this.event.parent_event_id}" class="link-to-parent">View Repeating Configuration \u{2192}</a>
        </div>
      </div>
    `;
    }
    renderOrganizerActions(isInstance = false) {
        // Check if current user is an organizer
        if (!this.currentUser || !this.currentUser.id) return '';
        const isOrganizer = this.event.organizers.some((org)=>org.user_id === this.currentUser.id);
        if (!isOrganizer) return '';
        const isPrimaryOrganizer = this.event.organizers.some((org)=>org.user_id === this.currentUser.id && org.is_primary);
        // For instances, show different buttons
        if (isInstance) return `
        <toolbar-action-bar align="right" spacing="medium" label="Event actions">
          <toolbar-overflow-actions slot="actions">
            <button class="btn btn-primary" slot="primary" id="inviteBtn">\u{1F4E8} Invite People</button>
            <button class="btn btn-secondary" slot="overflow" id="editInstanceBtn">\u{270F}\u{FE0F} Edit Instance</button>
            <button class="btn btn-secondary" slot="overflow" id="editSeriesBtn">\u{2699}\u{FE0F} Edit Series</button>
            ${isPrimaryOrganizer ? `
              <button class="btn btn-warning" slot="overflow" id="cancelInstanceBtn">\u{274C} Cancel This Instance</button>
            ` : ''}
          </toolbar-overflow-actions>
        </toolbar-action-bar>
      `;
        // For parent events, show standard buttons
        return `
      <toolbar-action-bar align="right" spacing="medium" label="Event actions">
        <toolbar-overflow-actions slot="actions">
          <button class="btn btn-primary" slot="primary" id="inviteBtn">\u{1F4E8} Invite People</button>
          <button class="btn btn-secondary" slot="overflow" id="editEventBtn">\u{270F}\u{FE0F} Edit Event</button>
          ${isPrimaryOrganizer ? `
            <button class="btn btn-danger" slot="overflow" id="deleteEventBtn">\u{1F5D1}\u{FE0F} Delete Event</button>
          ` : ''}
        </toolbar-overflow-actions>
      </toolbar-action-bar>
    `;
    }
    renderReminderInfo(status) {
        if (!this.reminders || this.reminders.length === 0) {
            // Show default message if no reminders configured
            if (status === 'yes') return '<p class="reminder-info">\uD83D\uDCE7 You\'ll get a reminder 1 day before</p>';
            else if (status === 'maybe') return '<p class="reminder-info">\uD83D\uDCE7 You\'ll get a reminder 1 week before</p>';
            return '';
        }
        // Display actual configured reminders
        const reminderList = this.reminders.map((reminder)=>{
            const offsetMinutes = reminder.reminder_offset_minutes;
            let timeText;
            if (offsetMinutes < 60) timeText = `${offsetMinutes} minute${offsetMinutes !== 1 ? 's' : ''} before`;
            else if (offsetMinutes < 1440) {
                const hours = Math.floor(offsetMinutes / 60);
                timeText = `${hours} hour${hours !== 1 ? 's' : ''} before`;
            } else {
                const days = Math.floor(offsetMinutes / 1440);
                timeText = `${days} day${days !== 1 ? 's' : ''} before`;
            }
            const icon = reminder.notification_type === 'email' ? "\uD83D\uDCE7" : "\uD83D\uDCF1";
            const type = reminder.notification_type === 'email' ? 'Email' : 'SMS';
            return `<p class="reminder-info">${icon} ${type} reminder ${timeText}</p>`;
        }).join('');
        return reminderList;
    }
    renderRsvpReminderOptOut() {
        // Only show for recurring events (parent or instance)
        if (!this.event.is_recurring && !this.event.parent_event_id) return '';
        // Only show if user has an invitation
        if (!this.userInvitation) return '';
        const isOptedOut = this.userInvitation.opt_out_rsvp_reminders || false;
        return `
      <div class="rsvp-reminder-opt-out">
        <label class="checkbox-label">
          <input 
            type="checkbox" 
            id="optOutRsvpReminders" 
            ${isOptedOut ? 'checked' : ''}
          >
          <span>Opt out of automatic RSVP reminders for this event</span>
        </label>
        <small class="help-text">
          If checked, you won't receive automatic reminders to RSVP for future instances of this recurring event.
          You can still create your own reminders.
        </small>
      </div>
    `;
    }
    renderRecurrenceInfo() {
        if (!this.event.is_recurring || !this.event.recurrence_rule) return '';
        const rule = this.event.recurrence_rule;
        const pattern = this.event.recurrence_pattern || rule.pattern;
        let description = '';
        switch(pattern){
            case 'daily':
                description = `Every ${rule.interval || 1} day(s)`;
                break;
            case 'weekly':
                if (rule.days_of_week && rule.days_of_week.length > 0) {
                    const dayNames = [
                        'Sunday',
                        'Monday',
                        'Tuesday',
                        'Wednesday',
                        'Thursday',
                        'Friday',
                        'Saturday'
                    ];
                    const days = rule.days_of_week.map((d)=>dayNames[d]).join(', ');
                    const interval = rule.interval && rule.interval > 1 ? `every ${rule.interval} weeks` : 'every week';
                    description = `${days} ${interval}`;
                }
                break;
            case 'monthly':
                if (rule.day_of_month) description = `Day ${rule.day_of_month} of every ${rule.interval || 1} month(s)`;
                else if (rule.monthly_relative) {
                    const dayMap = {
                        sunday: 'Sunday',
                        monday: 'Monday',
                        tuesday: 'Tuesday',
                        wednesday: 'Wednesday',
                        thursday: 'Thursday',
                        friday: 'Friday',
                        saturday: 'Saturday'
                    };
                    const parts = rule.monthly_relative.split('-');
                    const position = parts[0]; // first, second, third, fourth, last
                    const dayName = dayMap[parts.slice(1).join('-').toLowerCase()] || parts.slice(1).join(' ');
                    const interval = rule.interval && rule.interval > 1 ? `every ${rule.interval} months` : 'every month';
                    description = `${position} ${dayName} ${interval}`;
                }
                break;
            default:
                description = 'Custom recurrence pattern';
        }
        if (this.event.series_end_date) {
            const endDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.series_end_date, this.event.timezone || 'UTC');
            const endDateStr = (0, $abf83f7e582f4a57$export$3d49a77a0c87c6aa)(endDate, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            description += ` until ${endDateStr}`;
        } else description += ' (continues indefinitely)';
        return `
      <div class="detail-row">
        <span class="detail-label">\u{1F504} Recurring:</span>
        <span class="detail-value">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(description)}</span>
      </div>
    `;
    }
    attachEventListeners() {
        // Back button
        this.querySelector('#backBtn')?.addEventListener('click', ()=>{
            window.router.navigate('/events');
        });
        // Reload reminders when they're saved (listen on document since modal is in body)
        document.addEventListener('reminders-saved', async (e)=>{
            if (this.event && this.event.id && e.detail && e.detail.eventId === this.event.id) try {
                const reminderData = await window.API.request(`/events/${this.event.id}/reminders`);
                this.reminders = reminderData.reminders || [];
                this.render();
            } catch (error) {
                if (error.statusCode !== 404) window.logger.error('Failed to reload reminders:', error);
            }
        });
        // RSVP buttons
        this.querySelectorAll('.rsvp-btn').forEach((btn)=>{
            btn.addEventListener('click', async (e)=>{
                const status = e.target.dataset.status;
                await this.updateRSVP(status);
            });
        });
        // Edit button (for parent events)
        this.querySelector('#editEventBtn')?.addEventListener('click', ()=>{
            window.router.navigate(`/events/${this.event.id}/edit`);
        });
        // Edit Instance button (for instances)
        this.querySelector('#editInstanceBtn')?.addEventListener('click', ()=>{
            window.router.navigate(`/events/${this.event.id}/edit`);
        });
        // Edit Series button (for instances - goes to parent)
        this.querySelector('#editSeriesBtn')?.addEventListener('click', ()=>{
            window.router.navigate(`/events/${this.event.parent_event_id}/edit`);
        });
        // Cancel Instance button (for instances)
        this.querySelector('#cancelInstanceBtn')?.addEventListener('click', ()=>{
            this.confirmCancelInstance();
        });
        // Delete button (for parent events)
        this.querySelector('#deleteEventBtn')?.addEventListener('click', ()=>{
            this.confirmDeleteEvent();
        });
        // Configure reminders button
        this.querySelector('#configureRemindersBtn')?.addEventListener('click', ()=>{
            this.openReminderConfig();
        });
        // RSVP reminder opt-out checkbox
        const optOutCheckbox = this.querySelector('#optOutRsvpReminders');
        if (optOutCheckbox) optOutCheckbox.addEventListener('change', (e)=>{
            this.toggleOptOutRsvpReminders(e.target.checked);
        });
        // Invite button
        this.querySelector('#inviteBtn')?.addEventListener('click', ()=>{
            this.openInviteModal();
        });
        // Tab switching
        this.querySelectorAll('.tab[data-tab]').forEach((tab)=>{
            tab.addEventListener('click', (e)=>{
                this.activeTab = e.target.dataset.tab;
                (0, $ec0e472fc3ccab74$export$19a03c6887cb23d9)(this.activeTab, {
                    omitDefault: $20c8801317818cae$var$EVENT_DETAIL_DEFAULT_TAB
                });
                this.render();
            });
        });
        // Revoke invitation buttons
        this.querySelectorAll('[data-action="revoke"]').forEach((btn)=>{
            btn.addEventListener('click', async (e)=>{
                const invitationId = e.target.dataset.invitationId;
                await this.revokeInvitation(invitationId);
            });
        });
        // Watch button (comment notifications)
        this.querySelector('#watchBtn')?.addEventListener('click', (e)=>{
            e.stopPropagation();
            this.toggleSubscriptionDropdown();
        });
        // Watch dropdown options
        this.querySelectorAll('.watch-option').forEach((option)=>{
            option.addEventListener('click', async (e)=>{
                e.stopPropagation();
                const type = e.currentTarget.dataset.type;
                await this.toggleSubscription(type);
            });
        });
        // Close dropdown when clicking outside
        document.addEventListener('click', (e)=>{
            if (this.showSubscriptionDropdown && !e.target.closest('.watch-button-container')) {
                this.showSubscriptionDropdown = false;
                this.render();
            }
        });
        // Listen for invitations sent to reload list
        document.addEventListener('event-invites-sent', async ()=>{
            if (this.event && this.event.id) await this.loadInvitations(this.event.id);
        });
    }
    async revokeInvitation(invitationId) {
        if (!confirm('Are you sure you want to remove this invitation?')) return;
        try {
            await window.API.request(`/events/${this.event.id}/invite/${invitationId}`, {
                method: 'DELETE'
            });
            // Reload invitations
            await this.loadInvitations(this.event.id);
            // Show success message
            const toast = document.createElement('div');
            toast.className = 'toast-notification';
            toast.textContent = 'Invitation removed';
            document.body.appendChild(toast);
            setTimeout(()=>toast.remove(), 3000);
        } catch (error) {
            alert(error.message || 'Failed to remove invitation');
        }
    }
    isCurrentUserOrganizer() {
        if (!this.currentUser || !this.event || !Array.isArray(this.event.organizers)) return false;
        const currentId = Number(this.currentUser.id);
        return this.event.organizers.some((org)=>Number(org.user_id) === currentId);
    }
    allowedEventTabs() {
        const tabs = [
            'details'
        ];
        if (this.isCurrentUserOrganizer()) tabs.push('invited');
        return tabs;
    }
    resolveActiveTabFromUrl() {
        return (0, $ec0e472fc3ccab74$export$4d96fceac8695298)(this.allowedEventTabs(), {
            defaultTab: $20c8801317818cae$var$EVENT_DETAIL_DEFAULT_TAB
        });
    }
    openInviteModal() {
        let inviteModal = document.querySelector('event-invite-modal');
        if (!inviteModal) {
            inviteModal = document.createElement('event-invite-modal');
            document.body.appendChild(inviteModal);
        }
        inviteModal.open(this.event.id);
    }
    openReminderConfig() {
        let reminderConfig = document.querySelector('reminder-config');
        if (!reminderConfig) {
            reminderConfig = document.createElement('reminder-config');
            document.body.appendChild(reminderConfig);
        }
        reminderConfig.open(this.event.id);
    }
    async toggleOptOutRsvpReminders(optOut) {
        if (!this.event || !this.userInvitation) return;
        try {
            await window.API.request(`/events/${this.event.id}/invitations/${this.userInvitation.id}/opt-out-rsvp-reminders`, {
                method: 'PUT',
                body: JSON.stringify({
                    opt_out: optOut
                })
            });
            // Update local state
            if (this.userInvitation) this.userInvitation.opt_out_rsvp_reminders = optOut;
            // Show success message
            const message = optOut ? 'You\'ve opted out of automatic RSVP reminders' : 'You\'ve opted back in to automatic RSVP reminders';
            // Could show a toast notification here
            window.logger?.info(message);
        } catch (error) {
            window.logger.error('Failed to update opt-out preference:', error);
            alert('Failed to update preference. Please try again.');
            // Revert checkbox state
            const checkbox = this.querySelector('#optOutRsvpReminders');
            if (checkbox) checkbox.checked = !optOut;
        }
    }
    async updateRSVP(status) {
        try {
            const response = await window.API.request(`/events/${this.event.id}/rsvp`, {
                method: 'POST',
                body: JSON.stringify({
                    status: status
                })
            });
            // Update local event data
            this.event.user_rsvp = response.rsvp_status;
            // Check if there's a previous instance with reminders to copy
            if (response.has_previous_instance && response.previous_instance_id && status !== 'no') {
                // Show modal to ask if user wants to copy reminders
                this.showReminderCopyPrompt(response.previous_instance_id, response.previous_instance_start_time);
                return; // Don't reload reminders yet - wait for user's choice
            }
            // Reload reminders (default reminders may have been created)
            if (this.event.user_rsvp) try {
                const reminderData = await window.API.request(`/events/${this.event.id}/reminders`);
                this.reminders = reminderData.reminders || [];
            } catch (error) {
                if (error.statusCode !== 404) window.logger.error('Failed to reload reminders:', error);
                this.reminders = [];
            }
            else this.reminders = [];
            // Reload user invitation to get opt-out status (for recurring events)
            if (this.currentUser && (this.event.is_recurring || this.event.parent_event_id)) try {
                const invitationData = await window.API.request(`/events/${this.event.id}/invitations`);
                this.userInvitation = invitationData.invitations?.find((inv)=>inv.user_id === this.currentUser.id) || null;
            } catch (error) {
                if (error.statusCode !== 403 && error.statusCode !== 404) window.logger.error('Failed to reload user invitation:', error);
                this.userInvitation = null;
            }
            // Show success message
            this.showRSVPSuccess(status);
            // Re-render to update UI
            this.render();
        } catch (error) {
            window.logger.error('Failed to update RSVP:', error);
            alert('Failed to update RSVP. Please try again.');
        }
    }
    showReminderCopyPrompt(previousInstanceId, previousInstanceStartTime) {
        const previousDate = previousInstanceStartTime ? new Date(previousInstanceStartTime).toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }) : 'a previous instance';
        // Create modal overlay
        const modal = document.createElement('div');
        modal.className = 'reminder-copy-modal-overlay';
        modal.innerHTML = `
      <div class="reminder-copy-modal">
        <div class="modal-header">
          <h2>\u{1F4CB} Copy Reminders?</h2>
        </div>
        <div class="modal-body">
          <p>
            You previously RSVPed to <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(previousDate)}</strong>.
            Would you like to copy your reminders from that instance?
          </p>
          <div class="modal-actions">
            <button class="btn btn-primary" id="copyRemindersBtn">
              Yes, copy reminders
            </button>
            <button class="btn btn-secondary" id="setupNewRemindersBtn">
              No, set up new reminders
            </button>
            <button class="btn btn-secondary" id="useDefaultsBtn">
              Use defaults
            </button>
          </div>
        </div>
      </div>
    `;
        document.body.appendChild(modal);
        // Event listeners
        modal.querySelector('#copyRemindersBtn').addEventListener('click', async ()=>{
            modal.remove();
            await this.copyRemindersFromInstance(previousInstanceId);
            this.finishRSVPUpdate();
        });
        modal.querySelector('#setupNewRemindersBtn').addEventListener('click', ()=>{
            modal.remove();
            this.finishRSVPUpdate();
            // Open reminder config modal
            setTimeout(()=>{
                this.openReminderConfig();
            }, 100);
        });
        modal.querySelector('#useDefaultsBtn').addEventListener('click', ()=>{
            modal.remove();
            this.finishRSVPUpdate();
        });
        // Close on overlay click
        modal.addEventListener('click', (e)=>{
            if (e.target === modal) {
                modal.remove();
                this.finishRSVPUpdate();
            }
        });
    }
    async copyRemindersFromInstance(sourceInstanceId) {
        try {
            await window.API.request(`/events/${this.event.id}/reminders/copy-from-instance/${sourceInstanceId}`, {
                method: 'POST'
            });
            // Reload reminders
            try {
                const reminderData = await window.API.request(`/events/${this.event.id}/reminders`);
                this.reminders = reminderData.reminders || [];
            } catch (error) {
                if (error.statusCode !== 404) window.logger.error('Failed to reload reminders:', error);
                this.reminders = [];
            }
            // Show success message
            const toast = document.createElement('div');
            toast.className = 'toast-notification';
            toast.textContent = 'Reminders copied successfully!';
            document.body.appendChild(toast);
            setTimeout(()=>{
                toast.classList.add('show');
            }, 10);
            setTimeout(()=>{
                toast.classList.remove('show');
                setTimeout(()=>toast.remove(), 300);
            }, 3000);
        } catch (error) {
            window.logger.error('Failed to copy reminders:', error);
            alert('Failed to copy reminders. You can set them up manually.');
        }
    }
    finishRSVPUpdate() {
        // Reload reminders (default reminders may have been created)
        if (this.event.user_rsvp) window.API.request(`/events/${this.event.id}/reminders`).then((reminderData)=>{
            this.reminders = reminderData.reminders || [];
        }).catch((error)=>{
            if (error.statusCode !== 404) window.logger.error('Failed to reload reminders:', error);
            this.reminders = [];
        }).finally(()=>{
            this.render();
        });
        else {
            this.reminders = [];
            this.render();
        }
        // Reload user invitation to get opt-out status (for recurring events)
        if (this.currentUser && (this.event.is_recurring || this.event.parent_event_id)) window.API.request(`/events/${this.event.id}/invitations`).then((invitationData)=>{
            this.userInvitation = invitationData.invitations?.find((inv)=>inv.user_id === this.currentUser.id) || null;
            this.render();
        }).catch((error)=>{
            if (error.statusCode !== 403 && error.statusCode !== 404) window.logger.error('Failed to reload user invitation:', error);
            this.userInvitation = null;
            this.render();
        });
        else this.render();
        // Show success message
        this.showRSVPSuccess(this.event.user_rsvp);
    }
    showRSVPSuccess(status) {
        const message = status === 'yes' ? 'Great! See you there!' : status === 'maybe' ? 'Got it, we\'ll remind you!' : 'Thanks for letting us know!';
        // Simple toast notification
        const toast = document.createElement('div');
        toast.className = 'toast-notification';
        toast.textContent = message;
        document.body.appendChild(toast);
        setTimeout(()=>{
            toast.classList.add('show');
        }, 10);
        setTimeout(()=>{
            toast.classList.remove('show');
            setTimeout(()=>toast.remove(), 300);
        }, 3000);
    }
    async confirmCancelInstance() {
        if (!this.event.parent_event_id) return; // Not an instance
        const confirmed = confirm(`Are you sure you want to cancel this instance of "${this.event.title}"?\n\n` + 'This instance will be marked as cancelled and shown greyed out on the calendar. The rest of the series will continue.');
        if (!confirmed) return;
        try {
            await window.API.request(`/events/${this.event.id}/cancel`, {
                method: 'POST',
                body: JSON.stringify({
                    cancellation_reason: 'Instance cancelled'
                })
            });
            await this.loadEvent();
        } catch (error) {
            window.logger.error('Failed to cancel instance:', error);
            alert('Failed to cancel instance. Please try again.');
        }
    }
    async confirmDeleteEvent() {
        const confirmed = confirm(`Are you sure you want to delete "${this.event.title}"?\n\n` + 'This action cannot be undone and will remove the event for all attendees.');
        if (!confirmed) return;
        // Get deletion reason, required if there are attendees
        let deletionReason = 'No attendees.';
        if (this.event.yes_count > 0 || this.event.maybe_count > 0) {
            deletionReason = prompt('Please provide a reason for deletion (e.g., "Event cancelled", "Venue change"):\n\nThis will help attendees understand why the event was cancelled.');
            if (deletionReason === null) // User cancelled
            return;
            if (!deletionReason.trim()) {
                alert('Please provide a reason for deletion.');
                return;
            }
        }
        try {
            await window.API.request(`/events/${this.event.id}`, {
                method: 'DELETE',
                body: JSON.stringify({
                    deletion_reason: deletionReason
                })
            });
            // Show success message
            const toast = document.createElement('div');
            toast.className = 'toast-notification';
            toast.textContent = 'Event deleted successfully';
            document.body.appendChild(toast);
            setTimeout(()=>{
                toast.classList.add('show');
            }, 10);
            setTimeout(()=>{
                toast.classList.remove('show');
                setTimeout(()=>toast.remove(), 300);
            }, 3000);
            // Navigate back to events list
            setTimeout(()=>{
                window.router.navigate('/events');
            }, 1000);
        } catch (error) {
            window.logger.error('Failed to delete event:', error);
            alert('Failed to delete event. Please try again.');
        }
    }
    async loadSubscriptionStatus(eventId) {
        try {
            this.subscriptionStatus = await window.API.events.getSubscriptionStatus(eventId);
        } catch (error) {
            window.logger.error('Failed to load subscription status:', error);
            this.subscriptionStatus = {
                subscribed: false,
                is_organizer: false
            };
        }
    }
    async toggleSubscription(type) {
        try {
            const eventId = this.event.id;
            if (type === 'off') {
                // Unsubscribe
                await window.API.events.unsubscribe(eventId);
                this.subscriptionStatus = {
                    subscribed: false,
                    is_organizer: this.subscriptionStatus?.is_organizer || false
                };
            } else {
                // Subscribe with the selected type
                const result = await window.API.events.subscribe(eventId, type);
                this.subscriptionStatus = {
                    subscribed: true,
                    subscription_type: result.subscription_type,
                    is_organizer: this.subscriptionStatus?.is_organizer || false
                };
            }
            this.showSubscriptionDropdown = false;
            // Update the comments component with new subscription status
            const commentsComponent = this.querySelector('#eventCommentsComponent');
            if (commentsComponent) commentsComponent.setSubscriptionStatus(this.subscriptionStatus);
        } catch (error) {
            window.logger.error('Failed to update subscription:', error);
            alert('Failed to update notification preferences. Please try again.');
        }
    }
    toggleSubscriptionDropdown() {
        this.showSubscriptionDropdown = !this.showSubscriptionDropdown;
        // Re-render the comments component to update the dropdown
        const commentsComponent = this.querySelector('#eventCommentsComponent');
        if (commentsComponent) commentsComponent.render();
    }
    renderWatchButton() {
        if (!this.currentUser || !this.subscriptionStatus) return '';
        const subscribed = this.subscriptionStatus.subscribed;
        const type = this.subscriptionStatus.subscription_type;
        // Button state classes and text
        let buttonClass = 'watch-btn';
        const buttonText = "\uD83D\uDD14";
        if (!subscribed) buttonClass += ' watch-btn-off';
        else if (type === 'all_comments') buttonClass += ' watch-btn-all';
        else if (type === 'my_threads') buttonClass += ' watch-btn-threads';
        return `
      <div class="watch-button-container">
        <button class="${buttonClass}" id="watchBtn" title="Notification preferences">
          ${buttonText} <span class="watch-btn-arrow">\u{25BC}</span>
        </button>
        
        ${this.showSubscriptionDropdown ? `
          <div class="watch-dropdown">
            <button class="watch-option ${!subscribed ? 'active' : ''}" data-type="off">
              \u{26AA} Off (no notifications)
            </button>
            <button class="watch-option ${subscribed && type === 'all_comments' ? 'active' : ''}" data-type="all_comments">
              \u{1F535} All Comments
            </button>
            <button class="watch-option ${subscribed && type === 'my_threads' ? 'active' : ''}" data-type="my_threads">
              \u{1F7E3} My Threads Only
            </button>
          </div>
        ` : ''}
      </div>
    `;
    }
}
customElements.define('event-detail', $20c8801317818cae$var$EventDetail);




// Event Create/Edit Component
class $ce1c389f375ee0e5$var$EventEdit extends HTMLElement {
    constructor(){
        super();
        this.externalLinks = [];
        this.event = null;
        this.loading = false;
        this.isEditMode = false;
        this.eventType = 'one-time'; // 'one-time', 'recurring', or 'multi-day'
        this.recurrencePattern = 'weekly';
        this.occurrences = []; // For multi-day events
        const defaultTimezone = this.getDefaultTimezone();
        this.timezoneOptions = this.getSupportedTimezones(defaultTimezone);
        this.selectedTimezone = this.timezoneOptions.includes(defaultTimezone) ? defaultTimezone : this.timezoneOptions[0] || 'UTC';
        /** @type {{ id: number, name: string }[]} */ this.memberGroups = [];
        /** @type {number|null} */ this.presetGroupId = null;
    }
    getDefaultTimezone() {
        const guessed = typeof dayjs?.tz === 'function' ? dayjs.tz.guess() : null;
        if (guessed) return guessed;
        if (typeof Intl?.DateTimeFormat === 'function') {
            const resolved = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (resolved) return resolved;
        }
        return 'UTC';
    }
    getSupportedTimezones(defaultTimezone) {
        if (typeof Intl.supportedValuesOf === 'function') {
            const zones = Intl.supportedValuesOf('timeZone');
            if (defaultTimezone && !zones.includes(defaultTimezone)) return [
                defaultTimezone,
                ...zones
            ];
            return zones;
        }
        const fallbackZones = [
            defaultTimezone,
            'UTC',
            'America/New_York',
            'America/Chicago',
            'America/Denver',
            'America/Los_Angeles',
            'Europe/London',
            'Europe/Berlin',
            'Asia/Tokyo',
            'Australia/Sydney'
        ].filter(Boolean);
        return [
            ...new Set(fallbackZones)
        ];
    }
    async connectedCallback() {
        await this.loadMemberGroups();
        const presetRaw = this.getAttribute('preset-group-id');
        if (presetRaw) {
            const parsed = parseInt(presetRaw, 10);
            if (!Number.isNaN(parsed)) this.presetGroupId = parsed;
        }
        const eventId = this.getAttribute('event-id');
        if (eventId) {
            this.isEditMode = true;
            await this.loadEvent(eventId);
        }
        this.render();
    }
    async loadMemberGroups() {
        try {
            if (!window.API) return;
            const data = await window.API.request('/groups');
            this.memberGroups = data.groups || [];
        } catch (_e) {
            this.memberGroups = [];
        }
    }
    async loadEvent(eventId) {
        try {
            this.loading = true;
            this.event = await window.API.request(`/events/${eventId}`);
            // Determine event type from loaded data
            if (this.event.is_recurring) {
                this.eventType = 'recurring';
                this.recurrencePattern = this.event.recurrence_pattern || this.event.recurrence_rule?.pattern || this.recurrencePattern;
            } else if (this.event.is_multi_day) this.eventType = 'multi-day';
            else this.eventType = 'one-time';
            if (this.event?.timezone) {
                if (!this.timezoneOptions.includes(this.event.timezone)) this.timezoneOptions = [
                    this.event.timezone,
                    ...this.timezoneOptions
                ];
                this.selectedTimezone = this.event.timezone;
            }
            this.loading = false;
            this.externalLinks = (this.event.external_links || []).map((l)=>({
                    label: l.label || '',
                    url: l.url || ''
                }));
            this.render();
        } catch (error) {
            window.logger.error('Failed to load event:', error);
            this.loading = false;
            this.innerHTML = `
        <div class="event-edit-container">
          <div class="error">Failed to load event. Please try again.</div>
        </div>
      `;
        }
    }
    render() {
        if (this.loading) {
            this.innerHTML = `
        <div class="event-edit-container">
          <div class="loading">Loading event...</div>
        </div>
      `;
            return;
        }
        // Determine if editing instance or recurring parent
        const editingInstance = this.isEditMode && this.event && this.event.parent_event_id;
        const editingRecurringParent = this.isEditMode && this.event && this.event.is_recurring && !this.event.parent_event_id;
        const containerClass = editingInstance ? 'event-edit-container editing-instance' : editingRecurringParent ? 'event-edit-container editing-recurring' : 'event-edit-container';
        const presetGroup = this.presetGroupId ? (this.memberGroups || []).find((g)=>g.id === this.presetGroupId) : null;
        const lockedGroupName = presetGroup?.name || (this.presetGroupId ? `Group #${this.presetGroupId}` : null);
        const groupFieldHtml = this.presetGroupId && !this.isEditMode ? `
            <div class="form-group">
              <label>Group</label>
              <input type="hidden" id="group_id" name="group_id" value="${this.presetGroupId}">
              <p class="group-event-preset-note">
                This event is for <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(lockedGroupName)}</strong>.
              </p>
              <small class="help-text">Only members of this group can see this event.</small>
            </div>
      ` : `
            <div class="form-group">
              <label for="group_id">Group (optional)</label>
              <select id="group_id" name="group_id">
                <option value="">\u{2014} None \u{2014}</option>
                ${(this.memberGroups || []).map((g)=>`
                  <option value="${g.id}"
                    ${this.isEditMode && String(this.event?.group_id ?? '') === String(g.id) ? 'selected' : ''}>
                    ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(g.name)}
                  </option>`).join('')}
              </select>
              <small class="help-text">Members see linked events on the group home.</small>
            </div>
      `;
        const visibilityHtml = this.presetGroupId && !this.isEditMode ? `
            <div class="form-group">
              <label>Event Visibility</label>
              <p class="group-event-preset-note">\u{1F512} Group members only \u{2014} this event will not appear in public listings.</p>
              <input type="hidden" name="is_public" value="false">
            </div>
      ` : `
            <div class="form-group">
              <label>Event Visibility</label>
              <div class="radio-group">
                <label class="radio-label">
                  <input type="radio" name="is_public" value="false" ${!this.isEditMode || !this.event?.is_public ? 'checked' : ''}>
                  <div class="radio-card">
                    <strong>\u{1F512} Private</strong>
                    <small>Only invited people can see this event</small>
                  </div>
                </label>
                <label class="radio-label">
                  <input type="radio" name="is_public" value="true" ${this.isEditMode && this.event?.is_public ? 'checked' : ''}>
                  <div class="radio-card">
                    <strong>\u{1F30D} Public</strong>
                    <small>Anyone can see and RSVP to this event</small>
                  </div>
                </label>
              </div>
            </div>

            <div class="form-group" id="publicOptions" style="display: none;">
              <label class="checkbox-label">
                <input type="checkbox" id="show_rsvp_count" name="show_rsvp_count" ${!this.isEditMode || this.event?.show_rsvp_count ? 'checked' : ''}>
                <span>Show total RSVP count publicly</span>
              </label>
              <small class="help-text">
                When enabled, anyone can see how many people are attending.
                When disabled, only organizers can see the total count.
              </small>
            </div>
      `;
        this.innerHTML = `
      <div class="${containerClass}">
        <!-- Party Panda Helper -->
        <div class="party-panda-helper">
          <div class="panda-avatar">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="100" cy="120" rx="45" ry="50" fill="#f0f0f0" class="panda-body"/>
              <circle cx="100" cy="80" r="40" fill="#f0f0f0" class="panda-head"/>
              <circle cx="70" cy="60" r="15" fill="#2d2d2d" class="ear-left"/>
              <circle cx="130" cy="60" r="15" fill="#2d2d2d" class="ear-right"/>
              <ellipse cx="85" cy="75" rx="12" ry="15" fill="#2d2d2d" class="eye-patch-left"/>
              <ellipse cx="115" cy="75" rx="12" ry="15" fill="#2d2d2d" class="eye-patch-right"/>
              <circle cx="85" cy="75" r="5" fill="white" class="eye-white-left"/>
              <circle cx="115" cy="75" r="5" fill="white" class="eye-white-right"/>
              <circle cx="87" cy="75" r="3" fill="#2d2d2d" class="pupil-left"/>
              <circle cx="117" cy="75" r="3" fill="#2d2d2d" class="pupil-right"/>
              <ellipse cx="100" cy="90" rx="6" ry="8" fill="#2d2d2d"/>
              <path d="M 90 95 Q 100 102 110 95" stroke="#2d2d2d" stroke-width="2" fill="none" stroke-linecap="round"/>
              <ellipse cx="65" cy="120" rx="12" ry="25" fill="#2d2d2d" class="arm-left"/>
              <ellipse cx="135" cy="120" rx="12" ry="25" fill="#2d2d2d" class="arm-right"/>
              <ellipse cx="85" cy="160" rx="15" ry="12" fill="#2d2d2d"/>
              <ellipse cx="115" cy="160" rx="15" ry="12" fill="#2d2d2d"/>
              <g class="party-hat">
                <polygon points="100,30 85,60 115,60" fill="#ff6b9d" stroke="#ffd166" stroke-width="2"/>
                <circle cx="100" cy="28" r="5" fill="#ffd166" class="hat-pom"/>
                <line x1="85" y1="60" x2="115" y2="60" stroke="#ff6b9d" stroke-width="3"/>
                <circle cx="95" cy="45" r="2" fill="#ffd166"/>
                <circle cx="105" cy="50" r="2" fill="#00d9ff"/>
                <circle cx="100" cy="55" r="2" fill="#b388ff"/>
              </g>
            </svg>
          </div>
          <div class="panda-tip">
            <p id="pandaTipText">${this.isEditMode ? "Let's make this event even better! \uD83C\uDF89" : "Let's create something amazing together! \uD83C\uDF89"}</p>
          </div>
        </div>

        <div class="event-edit-header">
          <button class="btn-back" id="backBtn">\u{2190} Back</button>
          <h1>
            ${this.isEditMode ? editingInstance ? 'Edit Event <span class="edit-badge edit-badge-instance">This Event Only</span>' : editingRecurringParent ? 'Edit Repeating Event <span class="edit-badge edit-badge-recurring">All Events</span>' : 'Edit Event' : 'Create Event'}
          </h1>
        </div>

        <div class="alert-container"></div>
        <form id="eventForm" class="event-form">
          <div class="form-section">
            <h2>Event Details</h2>

            <div class="form-group">
              <label for="title">Event Title *</label>
              <input 
                type="text" 
                id="title" 
                name="title" 
                maxlength="200" 
                required 
                placeholder="e.g., Weekly Game Night"
                value="${this.isEditMode ? (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event?.title || '') : ''}"
              >
            </div>

            <div class="form-group">
              <label for="description">Description</label>
              <markdown-preview>
                <textarea 
                  class="form-control" 
                  name="description" 
                  id="description" 
                  placeholder="Write here... (Markdown supported!)"
                  rows="6"
                  required
                >${this.isEditMode ? (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event?.description || '') : ''}</textarea>
              </markdown-preview>
            </div>

            <div class="form-group">
              <label for="location">Location</label>
              <input 
                type="text" 
                id="location" 
                name="location"
                placeholder="e.g., Community Center, 123 Main St"
                value="${this.isEditMode ? (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event?.location || '') : ''}"
              >
            </div>

            ${groupFieldHtml}

            ${visibilityHtml}
          </div>

          <div class="form-section">
            <h2>Date & Time</h2>

            <!-- Event Type Selector -->
            <div class="form-group">
              <label>Event Type${this.isEditMode ? ' (cannot be changed after creation)' : ''}</label>
              <div class="radio-group">
                <label class="radio-label">
                  <input type="radio" name="event_type" value="one-time" ${this.eventType === 'one-time' ? 'checked' : ''} ${this.isEditMode ? 'disabled' : ''}>
                  <div class="radio-card">
                    <strong>\u{1F4C5} One-Time</strong>
                    <small>Single date and time</small>
                  </div>
                </label>
                <label class="radio-label">
                  <input type="radio" name="event_type" value="recurring" ${this.eventType === 'recurring' ? 'checked' : ''} ${this.isEditMode ? 'disabled' : ''}>
                  <div class="radio-card">
                    <strong>\u{1F504} Recurring</strong>
                    <small>Repeats on a pattern</small>
                  </div>
                </label>
                <label class="radio-label">
                  <input type="radio" name="event_type" value="multi-day" ${this.eventType === 'multi-day' ? 'checked' : ''} ${this.isEditMode ? 'disabled' : ''}>
                  <div class="radio-card">
                    <strong>\u{1F3AD} Multi-Day</strong>
                    <small>Multiple specific dates</small>
                  </div>
                </label>
              </div>
            </div>

            <div class="form-group">
              <label for="timezone">Timezone</label>
              <select id="timezone" name="timezone">
                ${this.timezoneOptions.map((timezone)=>`<option value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(timezone)}" ${timezone === this.selectedTimezone ? 'selected' : ''}>
                    ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(timezone.replace(/_/g, ' '))}
                  </option>`).join('')}
              </select>
              <small class="help-text">
                Dates and times are stored using this timezone.
              </small>
            </div>

            <!-- One-Time Event Fields -->
            <div id="oneTimeFields" style="display: ${this.eventType === 'one-time' ? 'block' : 'none'};">
              <div class="form-row">
                <div class="form-group">
                  <label for="start_time">Start Date & Time *</label>
                  <input 
                    type="datetime-local" 
                    id="start_time" 
                    name="start_time" 
                    required
                    value="${this.isEditMode && this.event?.start_time ? (0, $abf83f7e582f4a57$export$913e078cc32e4067)((0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.start_time, this.selectedTimezone), this.selectedTimezone) : ''}"
                  >
                </div>

                <div class="form-group">
                  <label for="end_time">End Date & Time *</label>
                  <input 
                    type="datetime-local" 
                    id="end_time" 
                    name="end_time"
                    required
                  value="${this.isEditMode && this.event?.end_time ? (0, $abf83f7e582f4a57$export$913e078cc32e4067)((0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.end_time, this.selectedTimezone), this.selectedTimezone) : ''}"
                  >
                </div>
              </div>

              <div class="form-group">
                <small class="help-text">
                  \u{1F4CD} Times are saved using the selected timezone.
                </small>
              </div>
            </div>

            <!-- Recurring Event Fields -->
            <div id="recurringFields" style="display: ${this.eventType === 'recurring' ? 'block' : 'none'};">
              ${this.renderRecurringFields()}
            </div>

            <!-- Multi-Day Event Fields -->
            <div id="multiDayFields" style="display: ${this.eventType === 'multi-day' ? 'block' : 'none'};">
              ${this.renderMultiDayFields()}
            </div>
          </div>

          ${editingRecurringParent ? this.renderRsvpReminderSection() : ''}

          <div class="form-section">
            <h2>External Links <small>(optional)</small></h2>
            <p class="help-text">Add links to tickets, venue info, or other relevant websites</p>
            
            <div id="external-links-container">
              ${this.renderExternalLinks()}
            </div>

            <button type="button" class="btn btn-secondary" id="addLinkBtn">
              + Add Link
            </button>
          </div>

          ${this.shouldShowGroupMemberNotify() ? this.renderNotifyGroupMembersSection() : ''}
          ${this.isEditMode && !this.event?.group_id ? this.renderSendUpdateEmailSection() : ''}

          <div class="form-actions">
            <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
            <button type="submit" class="btn btn-primary" id="submitBtn">${this.isEditMode ? 'Update Event' : 'Create Event'}</button>
          </div>
        </form>
      </div>
    `;
        this.attachEventListeners();
        // Set up the correct event type visibility and required attributes
        this.switchEventType();
        if (!this.isEditMode) this.setDefaultDateTime();
        this.setupPandaTips();
    }
    renderExternalLinks() {
        const links = this.externalLinks;
        if (links.length === 0) return '<p class="no-links-msg">No links added yet</p>';
        return links.map((link, index)=>`
      <div class="external-link-input" data-index="${index}">
        <input 
          type="text" 
          placeholder="Label (e.g., Buy Tickets)" 
          value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(link.label || '')}"
          data-field="label"
          data-index="${index}"
        >
        <input 
          type="url" 
          placeholder="https://..." 
          value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(link.url || '')}"
          data-field="url"
          data-index="${index}"
        >
        <button type="button" class="btn-remove" data-index="${index}">\xd7</button>
      </div>
    `).join('');
    }
    setDefaultDateTime() {
        // Set default start time to next hour (only in create mode)
        const now = new Date();
        now.setHours(now.getHours() + 1, 0, 0, 0);
        const dateTimeStr = now.toISOString().slice(0, 16);
        const startTimeInput = this.querySelector('#start_time');
        if (startTimeInput && !startTimeInput.value) startTimeInput.value = dateTimeStr;
    }
    switchEventType() {
        // Toggle visibility of event type fields
        const oneTimeFields = this.querySelector('#oneTimeFields');
        const recurringFields = this.querySelector('#recurringFields');
        const multiDayFields = this.querySelector('#multiDayFields');
        if (oneTimeFields) oneTimeFields.style.display = this.eventType === 'one-time' ? 'block' : 'none';
        if (recurringFields) recurringFields.style.display = this.eventType === 'recurring' ? 'block' : 'none';
        if (multiDayFields) multiDayFields.style.display = this.eventType === 'multi-day' ? 'block' : 'none';
        // Toggle required attributes to prevent HTML5 validation errors on hidden fields
        const oneTimeStart = this.querySelector('#start_time');
        const oneTimeEnd = this.querySelector('#end_time');
        const recurringStart = this.querySelector('#recurring_start_time');
        const recurringEnd = this.querySelector('#recurring_end_time');
        if (oneTimeStart) oneTimeStart.required = this.eventType === 'one-time';
        if (oneTimeEnd) oneTimeEnd.required = this.eventType === 'one-time';
        if (recurringStart) recurringStart.required = this.eventType === 'recurring';
        if (recurringEnd) recurringEnd.required = this.eventType === 'recurring';
        // Toggle required attributes on multi-day occurrence inputs
        const occurrenceInputs = this.querySelectorAll('input[name="occurrence_start_time"]');
        occurrenceInputs.forEach((input)=>{
            input.required = this.eventType === 'multi-day';
        });
        const occurrenceEndInputs = this.querySelectorAll('input[name="occurrence_end_time"]');
        occurrenceEndInputs.forEach((input)=>{
            input.required = this.eventType === 'multi-day';
        });
        if (this.eventType === 'recurring') this.updateRecurrencePatternFields();
    }
    attachEventListeners() {
        // Back button
        this.querySelector('#backBtn').addEventListener('click', ()=>{
            if (this.isEditMode) window.router.navigate(`/events/${this.event.id}`);
            else window.router.navigate('/events');
        });
        // Cancel button
        this.querySelector('#cancelBtn').addEventListener('click', ()=>{
            if (this.isEditMode) window.router.navigate(`/events/${this.event.id}`);
            else if (confirm('Are you sure you want to cancel? Your changes will be lost.')) window.router.navigate('/events');
        });
        // Public/Private toggle
        this.querySelectorAll('input[name="is_public"]').forEach((radio)=>{
            radio.addEventListener('change', (e)=>{
                const publicOptions = this.querySelector('#publicOptions');
                publicOptions.style.display = e.target.value === 'true' ? 'block' : 'none';
            });
        });
        const timezoneSelect = this.querySelector('#timezone');
        if (timezoneSelect) timezoneSelect.addEventListener('change', (e)=>{
            this.selectedTimezone = e.target.value;
        });
        // Add link button
        this.querySelector('#addLinkBtn').addEventListener('click', ()=>{
            this.externalLinks.push({
                label: '',
                url: ''
            });
            this.updateLinksSection();
        });
        // Event type toggle
        this.querySelectorAll('input[name="event_type"]').forEach((radio)=>{
            radio.addEventListener('change', (e)=>{
                this.eventType = e.target.value;
                this.switchEventType();
            });
        });
        // Recurring pattern toggle
        const recurrencePattern = this.querySelector('#recurrence_pattern');
        if (recurrencePattern) recurrencePattern.addEventListener('change', (event)=>{
            this.recurrencePattern = event.target.value;
            this.updateRecurrencePatternFields();
        });
        // RSVP Reminder toggle
        const rsvpReminderEnabled = this.querySelector('#rsvp_reminder_enabled');
        if (rsvpReminderEnabled) rsvpReminderEnabled.addEventListener('change', (e)=>{
            const fields = this.querySelector('#rsvpReminderFields');
            if (fields) fields.style.display = e.target.checked ? 'block' : 'none';
        });
        const sendUpdateEmail = this.querySelector('#send_update_email');
        if (sendUpdateEmail) sendUpdateEmail.addEventListener('change', (e)=>{
            const fields = this.querySelector('#sendUpdateEmailFields');
            if (fields) fields.style.display = e.target.checked ? 'block' : 'none';
        });
        const notifyGroupMembers = this.querySelector('#notify_group_members');
        if (notifyGroupMembers) notifyGroupMembers.addEventListener('change', (e)=>{
            const fields = this.querySelector('#notifyGroupMembersFields');
            if (fields) fields.style.display = e.target.checked ? 'block' : 'none';
        });
        // Monthly pattern type toggle
        this.querySelectorAll('input[name="monthly_pattern_type"]').forEach((radio)=>{
            radio.addEventListener('change', (e)=>{
                const patternType = e.target.value;
                const exactFields = document.getElementById('monthlyExactFields');
                const relativeFields = document.getElementById('monthlyRelativeFields');
                if (exactFields) exactFields.style.display = patternType === 'exact' ? 'block' : 'none';
                if (relativeFields) relativeFields.style.display = patternType === 'relative' ? 'block' : 'none';
            });
        });
        // Multi-day: Add occurrence
        const addOccurrenceBtn = this.querySelector('#addOccurrenceBtn');
        if (addOccurrenceBtn) addOccurrenceBtn.addEventListener('click', ()=>{
            // First sync any existing values
            this.syncOccurrencesFromDOM();
            // Then add a new empty occurrence
            this.occurrences.push({
                start_time: '',
                end_time: ''
            });
            // Finally re-render
            this.updateOccurrencesSection();
        });
        // Multi-day: Remove occurrence (will be reattached by updateOccurrencesSection)
        // Form submission
        this.querySelector('#eventForm').addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handleSubmit();
        });
        // Markdown toolbar setup
        const toolbar = this.querySelector('markdown-toolbar');
        const descriptionTextarea = this.querySelector('#description');
        if (toolbar && descriptionTextarea) toolbar.setTextarea(descriptionTextarea);
        this.updateRecurrencePatternFields();
    }
    syncOccurrencesFromDOM() {
        const container = this.querySelector('#occurrences-container');
        if (!container) return;
        const existingInputs = container.querySelectorAll('.occurrence-input');
        // Build new occurrences array from existing inputs
        const syncedOccurrences = [];
        existingInputs.forEach((occurrenceEl)=>{
            const startInput = occurrenceEl.querySelector('input[name="occurrence_start_time"]');
            const endInput = occurrenceEl.querySelector('input[name="occurrence_end_time"]');
            syncedOccurrences.push({
                start_time: startInput?.value || '',
                end_time: endInput?.value || ''
            });
        });
        this.occurrences = syncedOccurrences;
    }
    updateOccurrencesSection() {
        const container = this.querySelector('#occurrences-container');
        if (container) {
            container.innerHTML = this.renderOccurrences();
            // Reattach remove buttons
            container.querySelectorAll('.btn-remove-occurrence').forEach((btn)=>{
                btn.addEventListener('click', (e)=>{
                    const index = parseInt(e.target.dataset.index);
                    this.occurrences.splice(index, 1);
                    this.updateOccurrencesSection();
                });
            });
        }
    }
    updateRecurrencePatternFields() {
        const recurrencePattern = this.querySelector('#recurrence_pattern');
        if (!recurrencePattern) return;
        const pattern = recurrencePattern.value || 'weekly';
        const weeklyFields = this.querySelector('#weeklyPatternFields');
        const monthlyFields = this.querySelector('#monthlyPatternFields');
        const dailyFields = this.querySelector('#dailyPatternFields');
        if (weeklyFields) weeklyFields.style.display = pattern === 'weekly' ? 'block' : 'none';
        if (monthlyFields) monthlyFields.style.display = pattern === 'monthly' ? 'block' : 'none';
        if (dailyFields) dailyFields.style.display = pattern === 'daily' ? 'block' : 'none';
    }
    updateLinksSection() {
        const container = this.querySelector('#external-links-container');
        container.innerHTML = this.renderExternalLinks();
        // Reattach link-specific event listeners
        container.querySelectorAll('input[data-field]').forEach((input)=>{
            input.addEventListener('input', (e)=>{
                const index = parseInt(e.target.dataset.index);
                const field = e.target.dataset.field;
                if (this.externalLinks[index]) this.externalLinks[index][field] = e.target.value;
            });
        });
        container.querySelectorAll('.btn-remove').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const index = parseInt(e.target.dataset.index);
                this.externalLinks.splice(index, 1);
                this.updateLinksSection();
            });
        });
    }
    async handleSubmit() {
        const form = this.querySelector('#eventForm');
        const formData = new FormData(form);
        // datetime-local gives us the value in the user's local time
        // Format: "2025-10-30T20:00" -> convert to "2025-10-30 20:00:00"
        const startTimeLocal = formData.get('start_time');
        const endTimeLocal = formData.get('end_time');
        // Get external links from form inputs
        const externalLinks = [];
        const linkInputs = this.querySelectorAll('.external-link-input');
        linkInputs.forEach((input)=>{
            const labelInput = input.querySelector('[data-field="label"]');
            const urlInput = input.querySelector('[data-field="url"]');
            if (urlInput && urlInput.value.trim()) externalLinks.push({
                label: labelInput.value.trim() || urlInput.value.trim(),
                url: urlInput.value.trim()
            });
        });
        const eventData = {
            title: formData.get('title'),
            description: formData.get('description') || undefined,
            location: formData.get('location') || undefined,
            is_public: this.presetGroupId && !this.isEditMode ? false : formData.get('is_public') === 'true',
            show_rsvp_count: this.presetGroupId && !this.isEditMode || formData.get('is_public') !== 'true' ? true : formData.get('show_rsvp_count') === 'on',
            external_links: externalLinks,
            timezone: this.selectedTimezone
        };
        const groupIdRaw = formData.get('group_id');
        if (groupIdRaw !== null && String(groupIdRaw).trim() !== '') {
            const parsedG = parseInt(String(groupIdRaw), 10);
            if (!Number.isNaN(parsedG)) eventData.group_id = parsedG;
        } else if (this.isEditMode) eventData.group_id = null;
        // Handle event type-specific data
        if (this.eventType === 'one-time') {
            eventData.start_time = (0, $abf83f7e582f4a57$export$fda5dfd4def5d3a1)(startTimeLocal, this.selectedTimezone);
            eventData.end_time = (0, $abf83f7e582f4a57$export$fda5dfd4def5d3a1)(endTimeLocal, this.selectedTimezone);
            if (!eventData.start_time || !eventData.end_time) {
                alert('Please enter valid start and end dates and times.');
                const submitBtn = this.querySelector('#submitBtn');
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = this.isEditMode ? 'Update Event' : 'Create Event';
                }
                return;
            }
        } else if (this.eventType === 'recurring') {
            eventData.is_recurring = true;
            eventData.recurrence_pattern = formData.get('recurrence_pattern');
            eventData.recurrence_rule = this.buildRecurrenceRule(formData);
            const recurringStartLocal = formData.get('recurring_start_time');
            const recurringEndLocal = formData.get('recurring_end_time');
            eventData.start_time = (0, $abf83f7e582f4a57$export$fda5dfd4def5d3a1)(recurringStartLocal, this.selectedTimezone);
            eventData.end_time = (0, $abf83f7e582f4a57$export$fda5dfd4def5d3a1)(recurringEndLocal, this.selectedTimezone);
            if (!eventData.start_time || !eventData.end_time) {
                alert('Please enter valid start and end dates and times.');
                const submitBtn = this.querySelector('#submitBtn');
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = this.isEditMode ? 'Update Event' : 'Create Event';
                }
                return;
            }
            // Series end date is optional - only include if provided
            // Note: series_end_date is just a date (YYYY-MM-DD), so capture the final second of that day
            const seriesEnd = formData.get('series_end_date');
            if (seriesEnd) {
                // Parse as local date at 23:59:59 so we cover the entire day in the selected timezone
                const seriesEndLocal = `${seriesEnd}T23:59:59`;
                eventData.series_end_date = (0, $abf83f7e582f4a57$export$fda5dfd4def5d3a1)(seriesEndLocal, this.selectedTimezone);
            }
            // RSVP Reminder configuration (only for parent recurring events)
            const rsvpReminderEnabled = formData.get('rsvp_reminder_enabled') === 'on';
            if (rsvpReminderEnabled) {
                const daysBefore = parseInt(formData.get('rsvp_reminder_days') || '0', 10);
                const hoursBefore = parseInt(formData.get('rsvp_reminder_hours') || '0', 10);
                const totalMinutes = daysBefore * 1440 + hoursBefore * 60;
                // Validation
                if (totalMinutes <= 0) {
                    alert('Please specify when to send the reminder (at least one day or hour must be greater than 0).');
                    const submitBtn = this.querySelector('#submitBtn');
                    submitBtn.disabled = false;
                    submitBtn.textContent = this.isEditMode ? 'Update Event' : 'Create Event';
                    return;
                }
                const notificationTypes = [];
                if (formData.get('rsvp_reminder_email') === 'on') notificationTypes.push('email');
                if (formData.get('rsvp_reminder_sms') === 'on') notificationTypes.push('sms');
                if (notificationTypes.length === 0) {
                    alert('Please select at least one notification type (Email or SMS).');
                    const submitBtn = this.querySelector('#submitBtn');
                    submitBtn.disabled = false;
                    submitBtn.textContent = this.isEditMode ? 'Update Event' : 'Create Event';
                    return;
                }
                eventData.rsvp_reminder_offset_minutes = totalMinutes;
                eventData.rsvp_reminder_notification_types = notificationTypes;
                const reminderMessage = formData.get('rsvp_reminder_message')?.trim();
                if (reminderMessage) eventData.rsvp_reminder_message = reminderMessage;
            } else {
                // Explicitly disable if toggle is off
                eventData.rsvp_reminder_offset_minutes = null;
                eventData.rsvp_reminder_notification_types = null;
                eventData.rsvp_reminder_message = null;
            }
        } else if (this.eventType === 'multi-day') {
            eventData.is_multi_day = true;
            eventData.occurrences = this.buildOccurrences();
            // For multi-day, we need to set a parent start_time from the first occurrence
            const firstOccurrence = eventData.occurrences.find((occ)=>occ.start_time);
            eventData.start_time = firstOccurrence ? firstOccurrence.start_time : undefined;
        }
        if (this.shouldShowGroupMemberNotify()) {
            eventData.notify_group_members = formData.get('notify_group_members') === 'on';
            if (eventData.notify_group_members) {
                const groupMessage = formData.get('group_notify_message')?.trim();
                if (groupMessage) eventData.group_notify_message = groupMessage;
            }
        } else if (this.isEditMode) {
            eventData.send_update_email = formData.get('send_update_email') === 'on';
            if (eventData.send_update_email) {
                const message = formData.get('update_message')?.trim();
                if (message) eventData.update_message = message;
            }
        }
        try {
            this.clearAlerts();
            const submitBtn = this.querySelector('#submitBtn');
            submitBtn.disabled = true;
            submitBtn.textContent = this.isEditMode ? 'Updating...' : 'Creating...';
            let event;
            if (this.isEditMode) event = await window.API.request(`/events/${this.event.id}`, {
                method: 'PUT',
                body: JSON.stringify(eventData)
            });
            else event = await window.API.request('/events', {
                method: 'POST',
                body: JSON.stringify(eventData)
            });
            // Show success message
            this.showAlert(this.isEditMode ? 'Event updated successfully!' : 'Event created successfully!', 'success');
            // Navigate after save
            setTimeout(()=>{
                if (this.presetGroupId && !this.isEditMode) window.router.navigate(`/groups/${this.presetGroupId}`);
                else window.router.navigate(`/events/${event.id}`);
            }, 1000);
        } catch (error) {
            window.logger.error(`Failed to ${this.isEditMode ? 'update' : 'create'} event:`, error);
            alert(`Failed to ${this.isEditMode ? 'update' : 'create'} event. Please try again.`);
            const submitBtn = this.querySelector('#submitBtn');
            submitBtn.disabled = false;
            submitBtn.textContent = this.isEditMode ? 'Update Event' : 'Create Event';
        }
    }
    setupPandaTips() {
        const tips = {
            details: [
                "Great titles make people excited! What's the vibe? \uD83C\uDFA8",
                "A catchy title is the first step to an awesome event! \u2728",
                "Tell me about your event - I'm already excited! \uD83C\uDF8A"
            ],
            datetime: [
                "Pick a time that works for everyone! \u23F0",
                "Don't worry, times will show correctly for all your friends! \uD83C\uDF0D",
                "Timing is everything - let's find the perfect moment! \uD83D\uDCC5"
            ],
            links: [
                "Got tickets? A venue website? Add them here! \uD83C\uDF9F\uFE0F",
                "Links help your friends get all the details they need! \uD83D\uDD17",
                "Optional, but super helpful for your guests! \uD83D\uDCA1"
            ]
        };
        let currentSection = 'details';
        const pandaTipText = this.querySelector('#pandaTipText');
        // Function to get a random tip for the current section
        const updateTip = (section)=>{
            if (section !== currentSection) {
                currentSection = section;
                const sectionTips = tips[section] || tips.details;
                const randomTip = sectionTips[Math.floor(Math.random() * sectionTips.length)];
                pandaTipText.textContent = randomTip;
                // Add a little animation to the panda when tip changes
                const pandaHelper = this.querySelector('.party-panda-helper');
                pandaHelper.classList.add('tip-change');
                setTimeout(()=>pandaHelper.classList.remove('tip-change'), 500);
            }
        };
        // Observe which form section is in view
        const formSections = this.querySelectorAll('.form-section');
        const observerOptions = {
            root: null,
            rootMargin: '-50% 0px -50% 0px',
            threshold: 0
        };
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const sectionTitle = entry.target.querySelector('h2')?.textContent.toLowerCase();
                    if (sectionTitle?.includes('event details')) updateTip('details');
                    else if (sectionTitle?.includes('date')) updateTip('datetime');
                    else if (sectionTitle?.includes('link')) updateTip('links');
                }
            });
        }, observerOptions);
        formSections.forEach((section)=>observer.observe(section));
        // Also update on input focus
        const titleInput = this.querySelector('#title');
        const dateInputs = this.querySelectorAll('input[type="datetime-local"]');
        titleInput?.addEventListener('focus', ()=>updateTip('details'));
        dateInputs.forEach((input)=>{
            input.addEventListener('focus', ()=>updateTip('datetime'));
        });
    }
    buildRecurrenceRule(formData) {
        const pattern = formData.get('recurrence_pattern');
        const rule = {
            pattern: pattern,
            timezone: this.selectedTimezone
        };
        if (pattern === 'weekly') {
            const days = formData.getAll('days_of_week');
            rule.days_of_week = days.map((d)=>parseInt(d));
            rule.interval = parseInt(formData.get('weekly_interval') || '1');
        } else if (pattern === 'monthly') {
            const monthlyType = formData.get('monthly_pattern_type');
            if (monthlyType === 'exact') rule.day_of_month = parseInt(formData.get('monthly_day_number') || '1');
            else if (monthlyType === 'relative') rule.day_of_month = formData.get('monthly_relative');
            rule.interval = 1;
        } else if (pattern === 'daily') rule.interval = parseInt(formData.get('daily_interval') || '1');
        return rule;
    }
    buildOccurrences() {
        const occurrences = [];
        const occurrenceInputs = this.querySelectorAll('.occurrence-input');
        occurrenceInputs.forEach((occurrenceEl)=>{
            const startInput = occurrenceEl.querySelector('input[name="occurrence_start_time"]');
            const endInput = occurrenceEl.querySelector('input[name="occurrence_end_time"]');
            if (startInput && startInput.value) occurrences.push({
                start_time: (0, $abf83f7e582f4a57$export$fda5dfd4def5d3a1)(startInput.value, this.selectedTimezone),
                end_time: endInput?.value ? (0, $abf83f7e582f4a57$export$fda5dfd4def5d3a1)(endInput.value, this.selectedTimezone) : undefined
            });
        });
        return occurrences;
    }
    renderRecurringFields() {
        const isEditingRecurring = this.isEditMode && this.eventType === 'recurring' && !!this.event;
        const recurrenceRule = isEditingRecurring ? this.event?.recurrence_rule || {} : {};
        const recurrencePattern = isEditingRecurring ? this.event?.recurrence_pattern || recurrenceRule.pattern || this.recurrencePattern || 'weekly' : this.recurrencePattern || 'weekly';
        const selectedDays = new Set(Array.isArray(recurrenceRule.days_of_week) ? recurrenceRule.days_of_week.map((day)=>String(day)) : []);
        const weeklyInterval = recurrencePattern === 'weekly' ? parseInt(recurrenceRule.interval || 1, 10) : 1;
        const dailyInterval = recurrencePattern === 'daily' ? parseInt(recurrenceRule.interval || 1, 10) : 1;
        let monthlyPatternType = 'exact';
        let monthlyDayNumber = 1;
        if (typeof recurrenceRule.day_of_month === 'number') monthlyDayNumber = recurrenceRule.day_of_month;
        else if (typeof recurrenceRule.day_of_month === 'string' && !isNaN(Number(recurrenceRule.day_of_month))) monthlyDayNumber = parseInt(recurrenceRule.day_of_month, 10);
        let monthlyRelativeValue = recurrenceRule.monthly_relative || 'first-monday';
        if (recurrencePattern === 'monthly') {
            if (typeof recurrenceRule.monthly_relative === 'string') {
                monthlyPatternType = 'relative';
                monthlyRelativeValue = recurrenceRule.monthly_relative;
            } else if (typeof recurrenceRule.day_of_month === 'string' && isNaN(Number(recurrenceRule.day_of_month))) {
                monthlyPatternType = 'relative';
                monthlyRelativeValue = recurrenceRule.day_of_month;
            } else monthlyPatternType = 'exact';
            if (monthlyPatternType === 'exact') monthlyDayNumber = Math.max(1, Math.min(31, monthlyDayNumber || 1));
        }
        const recurringStartValue = isEditingRecurring && this.event?.start_time ? (0, $abf83f7e582f4a57$export$913e078cc32e4067)((0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.start_time, this.selectedTimezone), this.selectedTimezone) : '';
        const recurringEndValue = isEditingRecurring && this.event?.end_time ? (0, $abf83f7e582f4a57$export$913e078cc32e4067)((0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.end_time, this.selectedTimezone), this.selectedTimezone) : '';
        let seriesEndDateValue = '';
        if (isEditingRecurring && this.event?.series_end_date) {
            const formatted = (0, $abf83f7e582f4a57$export$913e078cc32e4067)((0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(this.event.series_end_date, this.selectedTimezone), this.selectedTimezone);
            seriesEndDateValue = formatted ? formatted.slice(0, 10) : '';
        }
        const recurrenceOptions = [
            {
                value: 'weekly',
                label: 'Weekly'
            },
            {
                value: 'monthly',
                label: 'Monthly'
            },
            {
                value: 'daily',
                label: 'Daily'
            },
            {
                value: 'custom',
                label: 'Custom'
            }
        ];
        const weeklyIntervals = [
            {
                value: 1,
                label: 'Every week'
            },
            {
                value: 2,
                label: 'Every 2 weeks'
            },
            {
                value: 3,
                label: 'Every 3 weeks'
            },
            {
                value: 4,
                label: 'Every 4 weeks'
            }
        ];
        const monthlyRelativeOptions = [
            'first-monday',
            'first-tuesday',
            'first-wednesday',
            'first-thursday',
            'first-friday',
            'first-saturday',
            'first-sunday',
            'second-monday',
            'second-tuesday',
            'second-wednesday',
            'second-thursday',
            'second-friday',
            'second-saturday',
            'second-sunday',
            'third-monday',
            'third-tuesday',
            'third-wednesday',
            'third-thursday',
            'third-friday',
            'third-saturday',
            'third-sunday',
            'fourth-monday',
            'fourth-tuesday',
            'fourth-wednesday',
            'fourth-thursday',
            'fourth-friday',
            'fourth-saturday',
            'fourth-sunday',
            'last-monday',
            'last-tuesday',
            'last-wednesday',
            'last-thursday',
            'last-friday',
            'last-saturday',
            'last-sunday'
        ];
        const monthlyPositionMap = {
            first: 'First',
            second: 'Second',
            third: 'Third',
            fourth: 'Fourth',
            last: 'Last'
        };
        const monthlyDayMap = {
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday'
        };
        return `
      <div class="form-group">
        <label for="recurrence_pattern">Repeat</label>
        <select id="recurrence_pattern" name="recurrence_pattern">
          ${recurrenceOptions.map((option)=>`
            <option value="${option.value}" ${recurrencePattern === option.value ? 'selected' : ''}>
              ${option.label}
            </option>
          `).join('')}
        </select>
      </div>

      <div id="weeklyPatternFields" style="display: ${recurrencePattern === 'weekly' ? 'block' : 'none'};">
        <div class="form-group">
          <label>Days of Week</label>
          <div class="checkbox-group">
            <label class="checkbox-label">
              <input type="checkbox" name="days_of_week" value="0" ${selectedDays.has('0') ? 'checked' : ''}>
              <span>Sunday</span>
            </label>
            <label class="checkbox-label">
              <input type="checkbox" name="days_of_week" value="1" ${selectedDays.has('1') ? 'checked' : ''}>
              <span>Monday</span>
            </label>
            <label class="checkbox-label">
              <input type="checkbox" name="days_of_week" value="2" ${selectedDays.has('2') ? 'checked' : ''}>
              <span>Tuesday</span>
            </label>
            <label class="checkbox-label">
              <input type="checkbox" name="days_of_week" value="3" ${selectedDays.has('3') ? 'checked' : ''}>
              <span>Wednesday</span>
            </label>
            <label class="checkbox-label">
              <input type="checkbox" name="days_of_week" value="4" ${selectedDays.has('4') ? 'checked' : ''}>
              <span>Thursday</span>
            </label>
            <label class="checkbox-label">
              <input type="checkbox" name="days_of_week" value="5" ${selectedDays.has('5') ? 'checked' : ''}>
              <span>Friday</span>
            </label>
            <label class="checkbox-label">
              <input type="checkbox" name="days_of_week" value="6" ${selectedDays.has('6') ? 'checked' : ''}>
              <span>Saturday</span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <label for="weekly_interval">Every</label>
          <select id="weekly_interval" name="weekly_interval">
            ${weeklyIntervals.map((option)=>`
              <option value="${option.value}" ${weeklyInterval === option.value ? 'selected' : ''}>
                ${option.label}
              </option>
            `).join('')}
          </select>
        </div>
      </div>

      <div id="monthlyPatternFields" style="display: ${recurrencePattern === 'monthly' ? 'block' : 'none'};">
        <div class="form-group">
          <label>Monthly Pattern</label>
          <div class="radio-group">
            <label class="radio-label">
              <input type="radio" name="monthly_pattern_type" value="exact" ${monthlyPatternType === 'exact' ? 'checked' : ''}>
              <div class="radio-card">
                <strong>\u{1F4C5} Exact Day</strong>
                <small>Always on specific day</small>
              </div>
            </label>
            <label class="radio-label">
              <input type="radio" name="monthly_pattern_type" value="relative" ${monthlyPatternType === 'relative' ? 'checked' : ''}>
              <div class="radio-card">
                <strong>\u{1F5D3}\u{FE0F} Nth Weekday</strong>
                <small>First/Second/etc.</small>
              </div>
            </label>
          </div>
        </div>

        <div id="monthlyExactFields" style="display: ${monthlyPatternType === 'exact' ? 'block' : 'none'};">
          <div class="form-group">
            <label for="monthly_day_number">Day of Month</label>
            <input type="number" id="monthly_day_number" name="monthly_day_number" min="1" max="31" value="${monthlyDayNumber}">
          </div>
        </div>

        <div id="monthlyRelativeFields" style="display: ${monthlyPatternType === 'relative' ? 'block' : 'none'};">
          <div class="form-group">
            <label>Which Weekday</label>
            <select name="monthly_relative">
              ${monthlyRelativeOptions.map((option)=>{
            const [position, day] = option.split('-');
            const label = `${monthlyPositionMap[position] || position} ${monthlyDayMap[day] || day}`;
            return `
                  <option value="${option}" ${monthlyRelativeValue === option ? 'selected' : ''}>
                    ${label}
                  </option>
                `;
        }).join('')}
            </select>
          </div>
        </div>
      </div>

      <div id="dailyPatternFields" style="display: ${recurrencePattern === 'daily' ? 'block' : 'none'};">
        <div class="form-group">
          <label for="daily_interval">Every</label>
          <select id="daily_interval" name="daily_interval">
            <option value="1" ${dailyInterval === 1 ? 'selected' : ''}>Every day</option>
            <option value="2" ${dailyInterval === 2 ? 'selected' : ''}>Every 2 days</option>
            <option value="3" ${dailyInterval === 3 ? 'selected' : ''}>Every 3 days</option>
            <option value="4" ${dailyInterval === 4 ? 'selected' : ''}>Every 4 days</option>
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="recurring_start_time">Start Date & Time *</label>
          <input 
            type="datetime-local" 
            id="recurring_start_time" 
            name="recurring_start_time"
            required
            value="${recurringStartValue}"
          >
        </div>

        <div class="form-group">
          <label for="recurring_end_time">End Date & Time *</label>
          <input 
            type="datetime-local" 
            id="recurring_end_time" 
            name="recurring_end_time"
            required
            value="${recurringEndValue}"
          >
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label for="series_end_date">Series End Date <small>(optional)</small></label>
          <input 
            type="date" 
            id="series_end_date" 
            name="series_end_date"
            value="${seriesEndDateValue}"
          >
          <small class="help-text">
            Leave empty for events that continue indefinitely
          </small>
        </div>
      </div>

      <div class="form-group">
        <small class="help-text">
          \u{1F4CD} Times are saved using the selected timezone.
        </small>
      </div>
    `;
    }
    renderMultiDayFields() {
        return `
      <div class="form-group">
        <label>Event Occurrences</label>
        <p class="help-text">
          Add each date and time for your multi-day event (e.g., theater showtimes)
        </p>

        <div id="occurrences-container">
          ${this.renderOccurrences()}
        </div>

        <button type="button" class="btn btn-secondary" id="addOccurrenceBtn">
          + Add Another Date
        </button>
      </div>

      <div class="form-group">
        <small class="help-text">
          \u{1F4CD} Times are saved using the selected timezone.
        </small>
      </div>
    `;
    }
    renderOccurrences() {
        // If empty, show one empty occurrence to start with
        if (this.occurrences.length === 0) return `
        <div class="occurrence-input" data-index="0">
          <div class="form-row">
            <div class="form-group">
              <label>Start Date & Time *</label>
              <input type="datetime-local" name="occurrence_start_time" required>
            </div>
            <div class="form-group">
              <label>End Date & Time *</label>
              <input type="datetime-local" name="occurrence_end_time" required>
            </div>
            <div class="form-group">
              <button type="button" class="btn-remove-occurrence" data-index="0" style="display: none;">\xd7</button>
            </div>
          </div>
        </div>
      `;
        return this.occurrences.map((occ, index)=>`
      <div class="occurrence-input" data-index="${index}">
        <div class="form-row">
          <div class="form-group">
            <label>Start Date & Time *</label>
            <input type="datetime-local" name="occurrence_start_time" value="${occ.start_time ? (0, $abf83f7e582f4a57$export$913e078cc32e4067)((0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(occ.start_time, this.selectedTimezone), this.selectedTimezone) : ''}" required>
          </div>
          <div class="form-group">
            <label>End Date & Time *</label>
            <input type="datetime-local" name="occurrence_end_time" value="${occ.end_time ? (0, $abf83f7e582f4a57$export$913e078cc32e4067)((0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(occ.end_time, this.selectedTimezone), this.selectedTimezone) : ''}" required>
          </div>
          <div class="form-group">
            <button type="button" class="btn-remove-occurrence" data-index="${index}">\xd7</button>
          </div>
        </div>
      </div>
    `).join('');
    }
    shouldShowGroupMemberNotify() {
        if (this.isEditMode) return Boolean(this.event?.group_id);
        return Boolean(this.presetGroupId);
    }
    renderNotifyGroupMembersSection() {
        const isUpdate = this.isEditMode;
        return `
      <div class="form-section notify-group-members-section">
        <h2>Notify group members <small>(optional)</small></h2>
        <p class="help-text">
          Group members are not emailed automatically when you ${isUpdate ? 'save changes' : 'create this event'}.
          Check the box below to send an email.
        </p>

        <div class="form-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              id="notify_group_members"
              name="notify_group_members"
            >
            <span>Email group members</span>
          </label>
        </div>

        <div id="notifyGroupMembersFields" class="notify-group-members-fields" style="display: none;">
          <div class="form-group">
            <label for="group_notify_message">Message for group members <small>(optional)</small></label>
            <textarea
              id="group_notify_message"
              name="group_notify_message"
              rows="3"
              maxlength="1000"
              placeholder="e.g. Bring a dish to share \u{2014} looking forward to seeing everyone!"
            ></textarea>
            <small class="help-text">Included in the email so members know what to expect.</small>
          </div>
        </div>
      </div>
    `;
    }
    renderSendUpdateEmailSection() {
        return `
      <div class="form-section send-update-email-section">
        <h2>Notify Invitees <small>(optional)</small></h2>
        <p class="help-text">
          Invitees are not emailed automatically when you save changes.
          Check the box below to send an &quot;event has been updated&quot; email.
        </p>

        <div class="form-group">
          <label class="checkbox-label">
            <input
              type="checkbox"
              id="send_update_email"
              name="send_update_email"
            >
            <span>Send update email to invitees</span>
          </label>
        </div>

        <div id="sendUpdateEmailFields" class="send-update-email-fields" style="display: none;">
          <div class="form-group">
            <label for="update_message">Message for invitees <small>(optional)</small></label>
            <textarea
              id="update_message"
              name="update_message"
              rows="3"
              maxlength="1000"
              placeholder="e.g. We moved to the back room \u{2014} same time!"
            ></textarea>
            <small class="help-text">Included in the update email so invitees know what changed.</small>
          </div>
        </div>
      </div>
    `;
    }
    renderRsvpReminderSection() {
        const rsvpReminderEnabled = this.event?.rsvp_reminder_offset_minutes !== null && this.event?.rsvp_reminder_offset_minutes !== undefined;
        const offsetMinutes = this.event?.rsvp_reminder_offset_minutes || 1440; // Default to 1 day
        const daysBefore = Math.floor(offsetMinutes / 1440);
        const hoursBefore = Math.floor(offsetMinutes % 1440 / 60);
        // Parse notification types - could be array, JSON string, or null
        let notificationTypes = this.event?.rsvp_reminder_notification_types || [];
        if (typeof notificationTypes === 'string') try {
            notificationTypes = JSON.parse(notificationTypes);
        } catch (_e) {
            notificationTypes = [];
        }
        if (!Array.isArray(notificationTypes)) notificationTypes = [];
        const hasEmail = notificationTypes.includes('email');
        const hasSms = notificationTypes.includes('sms');
        const reminderMessage = this.event?.rsvp_reminder_message || '';
        return `
      <div class="form-section">
        <h2>RSVP Reminders <small>(optional)</small></h2>
        <p class="help-text">
          Automatically remind invited guests to RSVP for each instance of this recurring event.
          Reminders are only sent to users who haven't already RSVPed.
        </p>

        <div class="form-group">
          <label class="checkbox-label">
            <input 
              type="checkbox" 
              id="rsvp_reminder_enabled" 
              name="rsvp_reminder_enabled"
              ${rsvpReminderEnabled ? 'checked' : ''}
            >
            <span>Send automatic RSVP reminders for each instance</span>
          </label>
        </div>

        <div id="rsvpReminderFields" style="display: ${rsvpReminderEnabled ? 'block' : 'none'};">
          <div class="form-group">
            <label>When to send reminder</label>
            <div class="form-row">
              <div class="form-group">
                <label for="rsvp_reminder_days">Days before</label>
                <input 
                  type="number" 
                  id="rsvp_reminder_days" 
                  name="rsvp_reminder_days" 
                  min="0" 
                  max="365"
                  value="${daysBefore}"
                >
              </div>
              <div class="form-group">
                <label for="rsvp_reminder_hours">Hours before</label>
                <input 
                  type="number" 
                  id="rsvp_reminder_hours" 
                  name="rsvp_reminder_hours" 
                  min="0" 
                  max="23"
                  value="${hoursBefore}"
                >
              </div>
            </div>
            <small class="help-text">
              At least one value must be greater than 0
            </small>
          </div>

          <div class="form-group">
            <label>Notification types</label>
            <div class="checkbox-group">
              <label class="checkbox-label">
                <input 
                  type="checkbox" 
                  id="rsvp_reminder_email" 
                  name="rsvp_reminder_email"
                  ${hasEmail ? 'checked' : ''}
                >
                <span>\u{1F4E7} Email</span>
              </label>
              <label class="checkbox-label">
                <input 
                  type="checkbox" 
                  id="rsvp_reminder_sms" 
                  name="rsvp_reminder_sms"
                  ${hasSms ? 'checked' : ''}
                >
                <span>\u{1F4F1} SMS</span>
              </label>
            </div>
            <small class="help-text">
              At least one notification type must be selected
            </small>
          </div>

          <div class="form-group">
            <label for="rsvp_reminder_message">Custom message <small>(optional)</small></label>
            <textarea 
              id="rsvp_reminder_message" 
              name="rsvp_reminder_message" 
              rows="3"
              placeholder="e.g., Don't forget to RSVP for this week's game night!"
              maxlength="500"
            >${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(reminderMessage)}</textarea>
            <small class="help-text">
              Optional custom message to include in the reminder. If left empty, a default message will be used.
            </small>
          </div>
        </div>
      </div>
    `;
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('.alert-container');
        const alert1 = document.createElement('div');
        alert1.className = `alert alert-${type}`;
        alert1.textContent = message;
        container.appendChild(alert1);
        // Auto-remove after 5 seconds
        setTimeout(()=>{
            if (alert1.parentNode) alert1.remove();
        }, 5000);
    }
    clearAlerts() {
        const container = this.querySelector('.alert-container');
        container.innerHTML = '';
    }
}
customElements.define('event-edit', $ce1c389f375ee0e5$var$EventEdit);


// Event Invite Modal Web Component

class $d5573a35c2b5036a$var$EventInviteModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.isLoading = false;
        this.eventId = null;
        this.activeTab = 'friends'; // friends, external, or lists
        this.friends = [];
        this.inviteLists = [];
        this.selectedFriends = [];
        this.externalEmails = [];
        this.loadingFriends = false;
        this.loadingInviteLists = false;
        this.invitedUserIds = new Set(); // Track which friends are already invited
        this.currentInvitations = [];
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    open(eventId) {
        this.eventId = eventId;
        this.isOpen = true;
        this.activeTab = 'friends';
        this.selectedFriends = [];
        this.externalEmails = [];
        this.invitedUserIds.clear();
        this.currentInvitations = [];
        this.render();
        this.loadInvitations();
        this.loadFriends();
        this.loadInviteLists();
    }
    async loadInvitations() {
        try {
            const response = await window.API.request(`/events/${this.eventId}/invitations`);
            const invitations = response.invitations || [];
            this.currentInvitations = invitations;
            // Build set of invited user IDs
            this.invitedUserIds.clear();
            invitations.forEach((inv)=>{
                if (inv.user_id) this.invitedUserIds.add(inv.user_id);
            });
            this.updateTabContent();
        } catch (error) {
            // 403/404 are OK - means user can't see invites or there are none
            if (error.statusCode !== 403 && error.statusCode !== 404) window.logger.error('Failed to load invitations:', error);
        }
    }
    close() {
        this.isOpen = false;
        this.render();
    }
    async loadFriends() {
        if (this.loadingFriends) return;
        this.loadingFriends = true;
        const tabContent = this.querySelector('.tab-content');
        if (tabContent && this.activeTab === 'friends') tabContent.innerHTML = `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading friends...</p>
        </div>
      `;
        try {
            const response = await window.API.request('/friends');
            this.friends = response.friends || [];
        } catch (error) {
            window.logger.error('Failed to load friends:', error);
            this.friends = [];
        } finally{
            this.loadingFriends = false;
            this.updateTabContent();
        }
    }
    async loadInviteLists() {
        if (this.loadingInviteLists) return;
        this.loadingInviteLists = true;
        const tabContent = this.querySelector('.tab-content');
        if (tabContent && this.activeTab === 'lists') tabContent.innerHTML = `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading invite lists...</p>
        </div>
      `;
        try {
            const response = await window.API.request('/invite-lists');
            this.inviteLists = response.invite_lists || [];
        } catch (error) {
            window.logger.error('Failed to load invite lists:', error);
            this.inviteLists = [];
        } finally{
            this.loadingInviteLists = false;
            this.updateTabContent();
        }
    }
    updateTabContent() {
        const tabContent = this.querySelector('.tab-content');
        if (tabContent) {
            // Show only the active tab's content
            tabContent.innerHTML = this.renderActiveTab();
            this.attachTabListeners();
        }
    }
    renderActiveTab() {
        if (this.activeTab === 'friends') return this.renderFriendsTab();
        if (this.activeTab === 'external') return this.renderExternalTab();
        if (this.activeTab === 'lists') return this.renderListsTab();
        return '';
    }
    attachTabListeners() {
        // Re-attach listeners for the current tab content
        if (this.activeTab === 'friends') {
            const friendCheckboxes = this.querySelectorAll('.friend-checkbox');
            friendCheckboxes.forEach((checkbox)=>{
                checkbox.addEventListener('change', ()=>{
                    this.selectedFriends = Array.from(this.querySelectorAll('.friend-checkbox:checked')).map((cb)=>parseInt(cb.value));
                });
            });
        } else if (this.activeTab === 'external') {
            const emailList = this.querySelector('#emailList');
            if (emailList) emailList.addEventListener('input', (e)=>{
                this.externalEmails = e.target.value.split('\n').map((line)=>line.trim()).filter((line)=>line.length > 0);
            });
        }
    }
    render() {
        this.innerHTML = `
      <div class="event-invite-modal ${this.isOpen ? 'open' : ''}" id="inviteModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>\u{1F4E8} Invite People to Event</h3>
            <button class="close-btn" id="closeBtn">\xd7</button>
          </div>
          
          <div class="modal-body">
            <div class="tabs" id="tabs">
              <button class="tab ${this.activeTab === 'friends' ? 'active' : ''}" data-tab="friends">
                \u{1F465} Friends
              </button>
              <button class="tab ${this.activeTab === 'external' ? 'active' : ''}" data-tab="external">
                \u{1F4E7} Email
              </button>
              <button class="tab ${this.activeTab === 'lists' ? 'active' : ''}" data-tab="lists">
                \u{1F4CB} Invite Lists
              </button>
            </div>

            <div class="tab-content">
              ${this.renderActiveTab()}
            </div>

            <div class="form-actions">
              <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
              <button type="button" class="btn btn-primary" id="sendBtn">
                <span class="btn-text">Send Invitations</span>
                <span class="btn-loading" style="display: none;">\u{23F3} Sending...</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
        this.attachEventListeners();
    }
    renderFriendsTab() {
        if (this.activeTab !== 'friends') return '';
        if (this.loadingFriends) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading friends...</p>
        </div>
      `;
        if (this.friends.length === 0) return `
        <div class="empty-state">
          <p>No friends to invite yet.</p>
        </div>
      `;
        return `
      <div class="friends-list">
        ${this.friends.map((friend)=>{
            const isAlreadyInvited = this.invitedUserIds.has(friend.id);
            return `
            <div class="friend-item ${isAlreadyInvited ? 'disabled' : ''}" data-friend-id="${friend.id}">
              <label class="checkbox-label">
                <input type="checkbox" class="friend-checkbox" value="${friend.id}" 
                  ${this.selectedFriends.includes(friend.id) ? 'checked' : ''}
                  ${isAlreadyInvited ? 'disabled' : ''}>
                <span>${friend.username}${isAlreadyInvited ? " \u2713 (already invited)" : ''}</span>
              </label>
            </div>
          `;
        }).join('')}
      </div>
    `;
    }
    renderExternalTab() {
        if (this.activeTab !== 'external') return '';
        const contactInvitations = this.currentInvitations.filter((inv)=>!inv.user_id && inv.email);
        return `
      <div class="external-invites">
        <div class="form-group">
          <label>Email Addresses (one per line):</label>
          <textarea id="emailList" rows="4" placeholder="friend1@example.com&#10;friend2@example.com">${this.externalEmails.join('\n')}</textarea>
          <small class="input-hint">Enter email addresses, one per line</small>
        </div>

        <div class="existing-invites">
          <div class="existing-invites-header">
            <span>Already invited</span>
            <span class="badge">${contactInvitations.length}</span>
          </div>
          ${contactInvitations.length === 0 ? '<p class="empty-state small">No email invitations have been sent yet.</p>' : `
            <div class="invited-chip-list">
              ${contactInvitations.map((inv)=>`
                <div class="invite-chip">
                  <div class="invite-chip-label">
                    ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(inv.email || '')}
                  </div>
                  <span class="invite-status status-${inv.rsvp_status || 'pending'}">
                    ${(inv.rsvp_status || 'pending').toUpperCase()}
                  </span>
                </div>
              `).join('')}
            </div>
          `}
        </div>
      </div>
    `;
    }
    renderListsTab() {
        if (this.activeTab !== 'lists') return '';
        if (this.loadingInviteLists) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading invite lists...</p>
        </div>
      `;
        if (this.inviteLists.length === 0) return `
        <div class="empty-state">
          <p>No invite lists available. Create one first!</p>
        </div>
      `;
        return `
      <div class="invite-lists">
        ${this.inviteLists.map((list)=>`
          <div class="list-item" data-list-id="${list.id}">
            <label class="checkbox-label">
              <input type="radio" name="inviteList" class="list-radio" value="${list.id}">
              <span>
                <strong>${list.name}</strong>
                <small>${list.member_count || 0} members</small>
              </span>
            </label>
          </div>
        `).join('')}
      </div>
    `;
    }
    attachEventListeners() {
        const backdrop = this.querySelector('#modalBackdrop');
        backdrop?.addEventListener('click', ()=>this.close());
        const closeBtn = this.querySelector('#closeBtn');
        closeBtn?.addEventListener('click', ()=>this.close());
        const cancelBtn = this.querySelector('#cancelBtn');
        cancelBtn?.addEventListener('click', ()=>this.close());
        const sendBtn = this.querySelector('#sendBtn');
        sendBtn?.addEventListener('click', ()=>this.sendInvitations());
        // Tab switching
        const tabs = this.querySelectorAll('.tab');
        tabs.forEach((tab)=>{
            tab.addEventListener('click', (e)=>{
                this.activeTab = e.target.dataset.tab;
                this.updateTabContent();
                // Update tab active states
                tabs.forEach((t)=>t.classList.remove('active'));
                e.target.classList.add('active');
            });
        });
        // Attach listeners for current tab content
        this.attachTabListeners();
    }
    async sendInvitations() {
        if (!this.eventId) return;
        const sendBtn = this.querySelector('#sendBtn');
        sendBtn.classList.add('loading');
        sendBtn.disabled = true;
        try {
            const requestBody = {};
            if (this.activeTab === 'friends') requestBody.user_ids = this.selectedFriends;
            else if (this.activeTab === 'external') {
                const emailText = this.querySelector('#emailList').value;
                requestBody.emails = emailText.split('\n').map((e)=>e.trim()).filter((e)=>e.length > 0);
            } else if (this.activeTab === 'lists') {
                const selectedList = this.querySelector('.list-radio:checked');
                if (selectedList) requestBody.invite_list_id = parseInt(selectedList.value);
            }
            await window.API.request(`/events/${this.eventId}/invite`, {
                method: 'POST',
                body: JSON.stringify(requestBody)
            });
            this.close();
            // Show success notification
            document.dispatchEvent(new CustomEvent('event-invites-sent', {
                detail: {
                    eventId: this.eventId
                }
            }));
            // Show toast after modal closes
            setTimeout(()=>{
                const toast = document.createElement('div');
                toast.className = 'toast-notification';
                toast.textContent = 'Invitations sent successfully!';
                document.body.appendChild(toast);
                setTimeout(()=>toast.remove(), 3000);
            }, 350);
        } catch (error) {
            alert(error.message || 'Failed to send invitations');
        } finally{
            sendBtn.classList.remove('loading');
            sendBtn.disabled = false;
        }
    }
}
customElements.define('event-invite-modal', $d5573a35c2b5036a$var$EventInviteModal);





const $027eb76b2f0b490c$var$EVENTS_CALENDAR_DEFAULT_TAB = 'my';
// Events Calendar Component with Month and Weekly views
class $027eb76b2f0b490c$var$EventsCalendar extends HTMLElement {
    constructor(){
        super();
        this.currentView = 'month'; // 'month' or 'week'
        this.currentTab = 'my'; // 'my' or 'all'
        this.currentDate = new Date(); // Current month/week being viewed
        this.events = [];
        this.loading = true;
        this.showPublic = false; // Toggle for public events in "All Events"
    }
    async connectedCallback() {
        this.currentTab = (0, $ec0e472fc3ccab74$export$4d96fceac8695298)([
            'my',
            'all'
        ], {
            defaultTab: $027eb76b2f0b490c$var$EVENTS_CALENDAR_DEFAULT_TAB
        });
        await this.loadEvents();
        this.render();
    }
    async loadEvents() {
        try {
            this.loading = true;
            // Calculate date range based on current view
            let startDate, endDate;
            if (this.currentView === 'month') {
                // Load entire month
                startDate = dayjs(this.currentDate).startOf('month').toDate();
                endDate = dayjs(this.currentDate).endOf('month').toDate();
            } else {
                // Load entire week
                startDate = dayjs(this.currentDate).startOf('week').toDate();
                endDate = dayjs(this.currentDate).endOf('week').toDate();
            }
            const queryParams = new URLSearchParams({
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });
            // Load my events for the current view range
            const response = await window.API.request(`/events?${queryParams}`);
            // Combine upcoming and past events into single array
            this.events = [
                ...response.upcoming_events || [],
                ...response.past_events || []
            ];
            this.loading = false;
            this.render();
        } catch (error) {
            window.logger.error('Failed to load events:', error);
            this.loading = false;
            this.render();
        }
    }
    render() {
        if (this.loading) {
            this.innerHTML = `
        <div class="calendar-container">
          <div class="loading">Loading calendar...</div>
        </div>
      `;
            return;
        }
        this.innerHTML = `
      <div class="calendar-container">
        ${this.renderHeader()}
        ${this.renderTabs()}
        ${this.renderView()}
      </div>
    `;
        this.attachEventListeners();
    }
    renderHeader() {
        return `
      <div class="calendar-header">
        <h1>Calendar</h1>
        <div class="calendar-controls">
          <div class="header-left">

          </div>
          <div class="header-right">
            <a href="/events" class="btn-view-list">\u{1F4CB} List View</a>
            <button class="btn-create-event" id="createEventBtn">
              \u{1F389} Create Event
            </button>
          </div>
        </div>
      </div>
      <toolbar-action-bar label="Calendar view">
        <div slot="actions" class="actions">
            <div class="view-switcher">
              <button class="view-btn ${this.currentView === 'month' ? 'active' : ''}" data-view="month">
                Month
              </button>
              <button class="view-btn ${this.currentView === 'week' ? 'active' : ''}" data-view="week">
                Week
              </button>
            </div>
            ${this.renderNavigation()}
        </div>
      </toolbar-action-bar>
    `;
    }
    renderTabs() {
        return `
      <div class="events-tabs">
        <button class="tab-btn ${this.currentTab === 'my' ? 'active' : ''}" data-tab="my">
          My Events
        </button>
        <button class="tab-btn ${this.currentTab === 'all' ? 'active' : ''}" data-tab="all">
          All Events
        </button>
        ${this.currentTab === 'all' ? `
          <label class="toggle-checkbox-label" id="publicToggleLabel">
            <input type="checkbox" class="toggle-checkbox" id="showPublicCheckbox" ${this.showPublic ? 'checked' : ''}>
            <span class="toggle-checkbox-custom"></span>
            <span class="toggle-label-text">Show Public Events</span>
          </label>
        ` : ''}
      </div>
    `;
    }
    renderNavigation() {
        if (this.currentView === 'month') {
            const monthYear = dayjs(this.currentDate).format('MMMM YYYY');
            return `
        <div class="calendar-nav">
          <button class="nav-btn" id="prevBtn">
            \u{2039}
          </button>
          <span class="current-period">${monthYear}</span>
          <button class="nav-btn" id="nextBtn">
            \u{203A}
          </button>
        </div>
      `;
        } else if (this.currentView === 'week') {
            const weekStart = dayjs(this.currentDate).startOf('week');
            const weekEnd = dayjs(this.currentDate).endOf('week');
            const weekStr = weekStart.month() === weekEnd.month() ? `${weekStart.format('MMM D')} - ${weekEnd.format('D, YYYY')}` : `${weekStart.format('MMM D')} - ${weekEnd.format('MMM D, YYYY')}`;
            return `
        <div class="calendar-nav">
          <button class="nav-btn" id="prevBtn">
            \u{2039}
          </button>
          <span class="current-period">${weekStr}</span>
          <button class="nav-btn" id="nextBtn">
            \u{203A}
          </button>
        </div>
      `;
        }
        return '';
    }
    renderView() {
        switch(this.currentView){
            case 'month':
                return this.renderMonthView();
            case 'week':
                return this.renderWeekView();
            default:
                return this.renderMonthView();
        }
    }
    renderMonthView() {
        // Get first day of month and days in month
        const startOfMonth = dayjs(this.currentDate).startOf('month');
        const endOfMonth = dayjs(this.currentDate).endOf('month');
        const daysInMonth = endOfMonth.date();
        const firstDayOfWeek = startOfMonth.day(); // 0 = Sunday, 6 = Saturday
        // Filter events based on tab
        const displayEvents = this.getFilteredEvents();
        const monthEvents = this.getEventsInRange(displayEvents, startOfMonth.toDate(), endOfMonth.toDate());
        // Group events by date for display (using event timezone to keep original date)
        const eventsByDate = {};
        monthEvents.forEach((event)=>{
            const parsedDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.start_time, event.timezone || 'UTC');
            if (parsedDate) {
                const eventDay = typeof dayjs?.tz === 'function' ? dayjs(parsedDate).tz(event.timezone || 'UTC') : dayjs(parsedDate);
                const eventDate = eventDay.format('YYYY-MM-DD');
                if (!eventsByDate[eventDate]) eventsByDate[eventDate] = [];
                eventsByDate[eventDate].push(event);
            }
        });
        // Build calendar grid
        const days = [];
        const dayNames = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ];
        // Add empty cells for days before the first of the month
        for(let i = 0; i < firstDayOfWeek; i++)days.push('<div class="calendar-day empty"></div>');
        // Add cells for each day of the month
        for(let day = 1; day <= daysInMonth; day++){
            const dateStr = dayjs(this.currentDate).date(day).format('YYYY-MM-DD');
            const isToday = dayjs(this.currentDate).date(day).isSame(dayjs(), 'day');
            const dayEvents = eventsByDate[dateStr] || [];
            days.push(`
        <div class="calendar-day ${isToday ? 'today' : ''}" data-date="${dateStr}">
          <div class="day-number">${day}</div>
          <div class="day-events">
            ${dayEvents.slice(0, 3).map((event)=>this.renderEventDot(event)).join('')}
            ${dayEvents.length > 3 ? `<div class="event-dot more">+${dayEvents.length - 3}</div>` : ''}
          </div>
        </div>
      `);
        }
        return `
      <div class="calendar-view">
        <div class="calendar-grid">
          ${dayNames.map((day)=>`<div class="day-name">${day}</div>`).join('')}
          ${days.join('')}
        </div>
      </div>
    `;
    }
    renderWeekView() {
        const weekStart = dayjs(this.currentDate).startOf('week');
        const weekEnd = dayjs(this.currentDate).endOf('week');
        // Filter events based on tab
        const displayEvents = this.getFilteredEvents();
        const weekEvents = this.getEventsInRange(displayEvents, weekStart.toDate(), weekEnd.toDate());
        // Group events by date (respecting event timezone to avoid shifting days)
        const eventsByDate = {};
        weekEvents.forEach((event)=>{
            const parsedDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.start_time, event.timezone || 'UTC');
            if (parsedDate) {
                const eventDay = typeof dayjs?.tz === 'function' ? dayjs(parsedDate).tz(event.timezone || 'UTC') : dayjs(parsedDate);
                const eventDate = eventDay.format('YYYY-MM-DD');
                if (!eventsByDate[eventDate]) eventsByDate[eventDate] = [];
                eventsByDate[eventDate].push(event);
            }
        });
        // Create day sections
        const daySections = [];
        for(let i = 0; i < 7; i++){
            const day = weekStart.add(i, 'day');
            const dateStr = day.format('YYYY-MM-DD');
            const dayEvents = eventsByDate[dateStr] || [];
            const isToday = day.isSame(dayjs(), 'day');
            daySections.push(`
        <div class="week-day ${isToday ? 'today' : ''}">
          <div class="week-day-header">
            <div class="week-day-name">${day.format('ddd')}</div>
            <div class="week-day-number">${day.format('D')}</div>
          </div>
          <div class="week-day-events">
            ${dayEvents.length > 0 ? dayEvents.map((event)=>this.renderEventCard(event)).join('') : '<div class="empty-day">No events</div>'}
          </div>
        </div>
      `);
        }
        return `
      <div class="calendar-view">
        <div class="week-view">
          ${daySections.join('')}
        </div>
      </div>
    `;
    }
    renderEventDot(event) {
        const cancelledClass = event.is_cancelled ? 'cancelled' : '';
        const rsvpClass = event.is_cancelled ? '' : this.getRSVPClass(event);
        const eventId = event.id;
        return `
      <div class="event-dot ${cancelledClass} ${rsvpClass}" 
           title="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.title)}${event.is_cancelled ? ' (Cancelled)' : ''}"
           data-event-id="${event.id}"
           onclick="event.stopPropagation(); window.location = '/events/${eventId}'">
        ${event.is_cancelled ? '<span class="cancelled-label">Cancelled</span> ' : ''}${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.title).substring(0, 15)}${event.title.length > 15 ? '...' : ''}
      </div>
    `;
    }
    renderEventCard(event) {
        const startDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.start_time, event.timezone || 'UTC');
        const startTimeStr = (0, $abf83f7e582f4a57$export$e6fb52c7265a62e5)(startDate);
        const isPast = startDate < new Date();
        const cancelledClass = event.is_cancelled ? 'cancelled' : '';
        const rsvpClass = event.is_cancelled ? '' : this.getRSVPClass(event);
        const eventId = event.id;
        return `
      <div data-event-id="${eventId}" class="event-card ${isPast ? 'past' : ''} ${cancelledClass} ${rsvpClass}">
        <div class="event-time">${startTimeStr}</div>
        <div class="event-info">
          <h4>${event.is_cancelled ? '<span class="cancelled-label">Cancelled</span> ' : ''}${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.title)}</h4>
          ${event.location ? `<div class="event-location">\u{1F4CD} ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.location)}</div>` : ''}
        </div>
      </div>
    `;
    }
    getRSVPClass(event) {
        if (!event.user_rsvp) return 'rsvp-none';
        return `rsvp-${event.user_rsvp.toLowerCase()}`;
    }
    getFilteredEvents() {
        // TODO: Filter based on "My Events" vs "All Events" and public toggle
        // For now, just return all events
        return this.events;
    }
    getEventsInRange(events, startDate, endDate) {
        return events.filter((event)=>{
            const eventDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.start_time, event.timezone || 'UTC');
            return eventDate >= startDate && eventDate <= endDate;
        });
    }
    attachEventListeners() {
        // View switcher
        const viewBtns = this.querySelectorAll('.view-btn');
        viewBtns.forEach((btn)=>{
            btn.addEventListener('click', async (e)=>{
                this.currentView = e.target.dataset.view;
                this.loadEvents();
            });
        });
        // Tab switcher
        const tabBtns = this.querySelectorAll('.tab-btn');
        tabBtns.forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                this.currentTab = e.target.dataset.tab;
                (0, $ec0e472fc3ccab74$export$19a03c6887cb23d9)(this.currentTab, {
                    omitDefault: $027eb76b2f0b490c$var$EVENTS_CALENDAR_DEFAULT_TAB
                });
                this.render();
            });
        });
        // Public events toggle
        const publicCheckbox = this.querySelector('#showPublicCheckbox');
        if (publicCheckbox) publicCheckbox.addEventListener('change', (e)=>{
            this.showPublic = e.target.checked;
            this.render();
        });
        // Navigation
        const prevBtn = this.querySelector('#prevBtn');
        const nextBtn = this.querySelector('#nextBtn');
        if (prevBtn) prevBtn.addEventListener('click', async ()=>{
            if (this.currentView === 'month') this.currentDate = dayjs(this.currentDate).subtract(1, 'month').toDate();
            else this.currentDate = dayjs(this.currentDate).subtract(1, 'week').toDate();
            await this.loadEvents();
        });
        if (nextBtn) nextBtn.addEventListener('click', async ()=>{
            if (this.currentView === 'month') this.currentDate = dayjs(this.currentDate).add(1, 'month').toDate();
            else this.currentDate = dayjs(this.currentDate).add(1, 'week').toDate();
            await this.loadEvents();
        });
        // Create event buttons
        const createEventBtns = this.querySelectorAll('#createEventBtn, #createEventBtnEmpty');
        createEventBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                window.location = '/events/new';
            });
        });
        // Click on month calendar day to switch to week view
        const calendarDays = this.querySelectorAll('.calendar-day:not(.empty)');
        calendarDays.forEach((day)=>{
            day.addEventListener('click', (e)=>{
                const dateStr = e.currentTarget.dataset.date;
                if (dateStr) {
                    // Use dayjs to parse date properly to avoid timezone issues
                    this.currentDate = dayjs(dateStr).toDate();
                    this.currentView = 'week';
                    this.loadEvents();
                }
            });
        });
        const events = document.querySelectorAll('[data-event-id]');
        if (events) events.forEach((event)=>{
            const eventId = event.dataset.eventId;
            event.addEventListener('click', async (e)=>{
                e.stopImmediatePropagation();
                window.location = `/events/${eventId}`;
            });
        });
    }
}
customElements.define('events-calendar', $027eb76b2f0b490c$var$EventsCalendar);
var $027eb76b2f0b490c$export$2e2bcd8739ae039 = $027eb76b2f0b490c$var$EventsCalendar;





// Events List Component
class $0dc666c77d8c1225$var$EventsList extends HTMLElement {
    constructor(){
        super();
        this.upcomingEvents = [];
        this.pastEvents = [];
        this.deletedEvents = [];
        this.loading = true;
        this.showDeleted = false; // Show deleted events toggle
        this.showPastOnly = false; // Show only past events toggle (no future)
    }
    async connectedCallback() {
        await this.loadEvents();
        this.render();
    }
    async loadEvents() {
        try {
            this.loading = true;
            // Load regular events with date range: 2 weeks future, 1 week past
            const now = new Date();
            const startDate = new Date(now.getTime() - 604800000); // 1 week ago
            const endDate = new Date(now.getTime() + 1209600000); // 2 weeks from now
            const queryParams = new URLSearchParams({
                startDate: startDate.toISOString(),
                endDate: endDate.toISOString()
            });
            const response = await window.API.request(`/events?${queryParams}`);
            this.upcomingEvents = response.upcoming_events || [];
            this.pastEvents = response.past_events || [];
            // Load deleted events (we'll load on demand)
            this.loading = false;
            this.render();
        } catch (error) {
            window.logger.error('Failed to load events:', error);
            this.loading = false;
            this.render();
        }
    }
    async loadDeletedEvents() {
        try {
            const response = await window.API.request('/events/deleted');
            this.deletedEvents = response.deleted_events || [];
            this.render();
        } catch (error) {
            window.logger.error('Failed to load deleted events:', error);
            this.deletedEvents = [];
        }
    }
    render() {
        if (this.loading) {
            this.innerHTML = `
        <div class="events-container">
          <div class="loading">Loading events...</div>
        </div>
      `;
            return;
        }
        this.innerHTML = `
      <div class="events-container">
        <div class="events-header">
          <h1>My Events</h1>
          <div class="header-actions">
            <a href="/events/calendar" class="btn-view-calendar">\u{1F4C5} Calendar View</a>
            <button class="btn-create-event" id="createEventBtn">
              \u{1F389} Create Event
            </button>
          </div>
        </div>

        <toolbar-action-bar label="Filters">
          <div slot="actions" class="toggle-actions">
              <label class="toggle-checkbox-label icon-only" title="Show deleted events">
                <span class="toggle-icon">\u{1F5D1}\u{FE0F}</span>
                <input type="checkbox" class="toggle-checkbox" id="showDeletedCheckbox" ${this.showDeleted ? 'checked' : ''}>
                <span class="toggle-checkbox-custom"></span>
              </label>
              <label class="toggle-checkbox-label icon-only" title="Show only past events">
                <span class="toggle-icon">\u{1F4C5}</span>
                <input type="checkbox" class="toggle-checkbox" id="showPastCheckbox" ${this.showPastOnly ? 'checked' : ''}>
                <span class="toggle-checkbox-custom"></span>
              </label>
          </div>
        </toolbar-action-bar>


        ${this.renderEvents()}
      </div>
    `;
        this.attachEventListeners();
    }
    renderEmpty() {
        return `
      <div class="empty-state">
        <div class="party-panda">
          ${(0, $72156d6136272719$export$1bb9b41c0ac99906)()}
        </div>
        <h2>Hi there! I'm Party Panda! \u{1F38A}</h2>
        <p class="panda-message">
          I'm SO excited to help you create your first event! 
          Whether it's game night, a backyard BBQ, or a surprise party, 
          I'll be here to make sure it's absolutely amazing!
        </p>
        <p class="panda-encouragement">
          Trust me, your friends are going to LOVE what we create together! 
          Let's get this party started! \u{1F973}
        </p>
        <button class="btn-create-event" id="createEventBtnEmpty">
          \u{2728} Create My First Event \u{2728}
        </button>
      </div>
    `;
    }
    renderEvents() {
        const now = new Date();
        // Determine what to show based on toggle combinations
        let eventsToShow = [];
        const showDeleted = this.showDeleted;
        const showPastOnly = this.showPastOnly;
        if (!showDeleted && !showPastOnly) // Default: Show future events + past from last week
        eventsToShow = [
            ...this.upcomingEvents,
            ...this.pastEvents
        ];
        else if (!showDeleted && showPastOnly) // Show only past events (no future)
        eventsToShow = this.pastEvents;
        else if (showDeleted && !showPastOnly) {
            // Show only deleted events (no past/current)
            const deletedFuture = this.deletedEvents.filter((e)=>new Date(e.start_time) >= now);
            const deletedPast = this.deletedEvents.filter((e)=>new Date(e.start_time) < now);
            if (deletedFuture.length === 0 && deletedPast.length === 0) return this.renderEmpty();
            if (deletedFuture.length > 0 && deletedPast.length > 0) return `
          <div class="events-list">
            <div class="events-section deleted-future">
              <h2 class="events-section-title">Deleted Future Events</h2>
              ${deletedFuture.map((event)=>this.renderDeletedEventCard(event)).join('')}
            </div>
            <hr class="events-divider">
            <div class="events-section deleted-past">
              <h2 class="events-section-title">Deleted Past Events</h2>
              ${deletedPast.map((event)=>this.renderDeletedEventCard(event)).join('')}
            </div>
          </div>
        `;
            else if (deletedFuture.length > 0) return `
          <div class="events-list">
            <div class="events-section deleted-future">
              <h2 class="events-section-title">Deleted Future Events</h2>
              ${deletedFuture.map((event)=>this.renderDeletedEventCard(event)).join('')}
            </div>
          </div>
        `;
            else return `
          <div class="events-list">
            <div class="events-section deleted-past">
              <h2 class="events-section-title">Deleted Past Events</h2>
              ${deletedPast.map((event)=>this.renderDeletedEventCard(event)).join('')}
            </div>
          </div>
        `;
        } else if (showDeleted && showPastOnly) {
            // Show all deleted events
            eventsToShow = this.deletedEvents;
            if (eventsToShow.length === 0) return this.renderEmpty();
            return `
        <div class="events-list">
          <div class="events-section deleted-events">
            ${eventsToShow.map((event)=>this.renderDeletedEventCard(event)).join('')}
          </div>
        </div>
      `;
        }
        if (eventsToShow.length === 0) return this.renderEmpty();
        // Render non-deleted events with sections
        const upcomingEvents = eventsToShow.filter((e)=>new Date(e.start_time) >= now);
        const pastEvents = eventsToShow.filter((e)=>new Date(e.start_time) < now);
        return `
      <div class="events-list">
        ${upcomingEvents.length > 0 ? `
          <div class="events-section upcoming-events">
            ${upcomingEvents.map((event)=>this.renderEventCard(event)).join('')}
          </div>
        ` : ''}
        ${upcomingEvents.length > 0 && pastEvents.length > 0 ? '<hr class="events-divider">' : ''}
        ${pastEvents.length > 0 ? `
          <div class="events-section past-events">
            <h2 class="events-section-title">Past Events</h2>
            ${pastEvents.map((event)=>this.renderEventCard(event)).join('')}
          </div>
        ` : ''}
      </div>
    `;
    }
    renderDeletedEvents() {
        if (this.deletedEvents.length === 0) return `
        <div class="empty-state">
          <div class="party-panda">
            ${(0, $72156d6136272719$export$1bb9b41c0ac99906)()}
          </div>
          <h2>Nothing here! \u{1F389}</h2>
          <p class="panda-message">
            No deleted events found. Party Panda is celebrating because everything is organized!
          </p>
        </div>
      `;
        return `
      <div class="events-grid">
        ${this.deletedEvents.map((event)=>this.renderDeletedEventCard(event)).join('')}
      </div>
    `;
    }
    renderDeletedEventCard(event) {
        const eventTimezone = event.timezone || 'UTC';
        const startDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.start_time, eventTimezone);
        const dateStr = (0, $abf83f7e582f4a57$export$3d49a77a0c87c6aa)(startDate, {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        });
        const timeStr = (0, $abf83f7e582f4a57$export$e6fb52c7265a62e5)(startDate);
        const deletedDate = event.deleted_at ? (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.deleted_at, eventTimezone) : null;
        const deletedDateStr = deletedDate ? (0, $abf83f7e582f4a57$export$3d49a77a0c87c6aa)(deletedDate, {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        }) : '';
        return `
      <div class="event-card deleted" data-event-id="${event.id}">
        <div class="event-card-header">
          <h3>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.title)}</h3>
          <span class="badge-deleted">\u{1F5D1}\u{FE0F} Deleted</span>
        </div>
        <div class="event-card-body">
          <div class="event-date">
            <strong>${dateStr}</strong> at ${timeStr}
          </div>
          <div class="deleted-info">
            <p class="deleted-date">Deleted on ${deletedDateStr}</p>
            ${event.deletion_reason ? `
              <p class="deletion-reason">Reason: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.deletion_reason)}</p>
            ` : ''}
            ${event.attendee_count > 0 ? `
              <p class="attendee-count">Had ${event.attendee_count} attendee${event.attendee_count > 1 ? 's' : ''}</p>
            ` : ''}
          </div>
        </div>
        <div class="event-card-footer">
          ${event.can_restore ? `
            <button class="btn-restore" data-event-id="${event.id}">\u{1F504} Restore Event</button>
          ` : '<span class="restore-disabled">Already restored</span>'}
        </div>
      </div>
    `;
    }
    renderEventCard(event) {
        const eventTimezone = event.timezone || 'UTC';
        // Parse event time and convert to user's local timezone
        const startDate = (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.start_time, eventTimezone);
        const dateStr = (0, $abf83f7e582f4a57$export$3d49a77a0c87c6aa)(startDate, {
            weekday: 'short',
            month: 'short',
            day: 'numeric'
        });
        const timeStr = (0, $abf83f7e582f4a57$export$e6fb52c7265a62e5)(startDate);
        const rsvpBadge = event.user_rsvp ? `
      <span class="rsvp-badge rsvp-${event.user_rsvp}">
        ${event.user_rsvp === 'yes' ? "\u2713 Going" : event.user_rsvp === 'maybe' ? '? Maybe' : "\u2717 Not Going"}
      </span>
    ` : '';
        // Use the instance's own ID
        const eventId = event.id;
        return `
      <div class="event-card${event.is_cancelled ? ' cancelled' : ''}" data-event-id="${event.id}">
        <div class="event-card-header">
          <h3><a href="/events/${eventId}" class="event-title-link">${event.is_cancelled ? '<span class="cancelled-label">Cancelled</span> ' : ''}${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.title)}</a></h3>
          ${event.is_public ? '<span class="badge-public">\uD83C\uDF0D Public</span>' : '<span class="badge-private">\uD83D\uDD12 Private</span>'}
        </div>
        <div class="event-card-body">
          <div class="event-date">
            <strong>${dateStr}</strong> at ${timeStr}
          </div>
          ${event.location ? `
            <div class="event-location">
              \u{1F4CD} ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.location)}
            </div>
          ` : ''}
          ${event.yes_count > 0 ? `
            <div class="event-attendees">
              \u{1F465} ${event.yes_count} attending
              ${event.maybe_count > 0 ? `, ${event.maybe_count} maybe` : ''}
            </div>
          ` : ''}
          ${rsvpBadge}
        </div>
        <div class="event-card-footer">
          <button class="btn-view" data-event-id="${eventId}">View Details</button>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Create event buttons
        const createBtns = this.querySelectorAll('#createEventBtn, #createEventBtnEmpty');
        createBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                window.router.navigate('/events/new');
            });
        });
        // Checkbox toggle for deleted events
        const deletedCheckbox = this.querySelector('#showDeletedCheckbox');
        if (deletedCheckbox) deletedCheckbox.addEventListener('change', async (e)=>{
            this.showDeleted = e.target.checked;
            // Load deleted events if showing them for the first time
            if (this.showDeleted && this.deletedEvents.length === 0) await this.loadDeletedEvents();
            this.render();
        });
        // Checkbox toggle for past events only
        const pastCheckbox = this.querySelector('#showPastCheckbox');
        if (pastCheckbox) pastCheckbox.addEventListener('change', (e)=>{
            this.showPastOnly = e.target.checked;
            this.render();
        });
        // View event buttons
        this.querySelectorAll('.btn-view').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                e.stopPropagation(); // Prevent event bubbling
                const eventId = e.currentTarget.dataset.eventId;
                if (eventId) window.router.navigate(`/events/${eventId}`);
                else window.logger.error('No eventId found on button', e.currentTarget);
            });
        });
        // Event title links
        this.querySelectorAll('.event-title-link').forEach((link)=>{
            link.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                const href = link.getAttribute('href');
                if (href && window.router) window.router.navigate(href);
                else if (href) window.location.href = href;
            });
        });
        // Restore event buttons
        this.querySelectorAll('.btn-restore').forEach((btn)=>{
            btn.addEventListener('click', async (e)=>{
                const eventId = e.target.dataset.eventId;
                const confirmed = confirm('Are you sure you want to restore this event?');
                if (confirmed) await this.restoreEvent(eventId);
            });
        });
    }
    async restoreEvent(eventId) {
        try {
            // Find the event to check attendee count
            const event = this.deletedEvents.find((e)=>e.id === parseInt(eventId));
            // Get restore reason, required if there were attendees
            let restoreReason = 'No attendees.';
            if (event && event.attendee_count > 0) {
                restoreReason = prompt('Please provide a reason for restoring this event (e.g., "Event rescheduled", "New venue secured"):\n\nThis will help attendees understand why the event was restored.');
                if (restoreReason === null) // User cancelled
                return;
                if (!restoreReason.trim()) {
                    alert('Please provide a reason for restoration.');
                    return;
                }
            }
            const response = await window.API.request(`/events/${eventId}/restore`, {
                method: 'POST',
                body: JSON.stringify({
                    restore_reason: restoreReason
                })
            });
            if (response.message) {
                alert('Event restored successfully!');
                // Remove from deleted list and reload active events
                this.deletedEvents = this.deletedEvents.filter((e)=>e.id !== parseInt(eventId));
                await this.loadEvents();
                // Switch back to active events view
                this.showDeleted = false;
                this.render();
            }
        } catch (error) {
            window.logger.error('Failed to restore event:', error);
            alert('Failed to restore event. Please try again.');
        }
    }
}
customElements.define('events-list', $0dc666c77d8c1225$var$EventsList);


// Facebook Import Friends Web Component


/**
 * Google Drive Picker Integration
 * Handles Google Drive file selection using the Google Picker API
 */ /**
 * Google Picker API Loader Utility
 * Handles loading Google API scripts and initializing pickers
 */ let $6ad04eae6c100a40$var$googleAPIsLoaded = false;
let $6ad04eae6c100a40$var$googlePickerAPILoaded = false;
let $6ad04eae6c100a40$var$googlePhotosPickerAPILoaded = false;
async function $6ad04eae6c100a40$export$b21af638de5e3e24() {
    if ($6ad04eae6c100a40$var$googleAPIsLoaded) return Promise.resolve();
    return new Promise((resolve, reject)=>{
        // Load gapi script
        if (!window.gapi) {
            const script = document.createElement('script');
            script.src = 'https://apis.google.com/js/api.js';
            script.onload = ()=>{
                // Load picker API
                window.gapi.load('picker', {
                    callback: ()=>{
                        $6ad04eae6c100a40$var$googleAPIsLoaded = true;
                        $6ad04eae6c100a40$var$googlePickerAPILoaded = true;
                        resolve();
                    },
                    onerror: reject
                });
            };
            script.onerror = reject;
            document.head.appendChild(script);
        } else // gapi already loaded, just load picker
        if ($6ad04eae6c100a40$var$googlePickerAPILoaded) resolve();
        else window.gapi.load('picker', {
            callback: ()=>{
                $6ad04eae6c100a40$var$googlePickerAPILoaded = true;
                resolve();
            },
            onerror: reject
        });
    });
}
async function $6ad04eae6c100a40$export$a6993ee64c6e4e0f() {
    if ($6ad04eae6c100a40$var$googlePhotosPickerAPILoaded) return Promise.resolve();
    // First ensure base Google APIs are loaded
    await $6ad04eae6c100a40$export$b21af638de5e3e24();
    // Google Photos Picker API loading
    // Note: This may need adjustment based on actual API implementation
    // The API might be part of the same picker API or separate
    return new Promise((resolve, reject)=>{
        // For now, assume it's part of the same picker API
        // If separate, we'll need to load additional scripts
        if ($6ad04eae6c100a40$var$googlePickerAPILoaded) {
            $6ad04eae6c100a40$var$googlePhotosPickerAPILoaded = true;
            resolve();
        } else $6ad04eae6c100a40$export$b21af638de5e3e24().then(()=>{
            $6ad04eae6c100a40$var$googlePhotosPickerAPILoaded = true;
            resolve();
        }).catch(reject);
    });
}
async function $6ad04eae6c100a40$export$84773cc9bf7dbe87(provider, accountId) {
    try {
        const response = await fetch(`/api/media-sources/picker/token?provider=${encodeURIComponent(provider)}&accountId=${encodeURIComponent(accountId)}`, {
            credentials: 'include'
        });
        if (!response.ok) throw new Error(`Failed to get access token: ${response.status}`);
        const data = await response.json();
        return data.access_token;
    } catch (error) {
        window.logger?.error('Error getting access token:', error);
        throw error;
    }
}
/**
 * Get Google Picker API key from authenticated API endpoint
 * This is more secure than embedding it in HTML
 */ let $6ad04eae6c100a40$var$cachedApiKey = null;
async function $6ad04eae6c100a40$export$c66ffd2d23780276() {
    // Return cached key if available
    if ($6ad04eae6c100a40$var$cachedApiKey) return $6ad04eae6c100a40$var$cachedApiKey;
    try {
        const response = await fetch('/api/media-sources/picker/api-key', {
            credentials: 'include'
        });
        if (!response.ok) throw new Error(`Failed to get API key: ${response.status}`);
        const data = await response.json();
        $6ad04eae6c100a40$var$cachedApiKey = data.api_key;
        return $6ad04eae6c100a40$var$cachedApiKey;
    } catch (error) {
        window.logger?.error('Error getting Google Picker API key:', error);
        throw new Error('Google Picker API key not available. Please ensure you are logged in.', {
            cause: error
        });
    }
}
/**
 * Get Google Cloud project number (app ID) from authenticated API endpoint
 * Required for drive.file scope
 */ let $6ad04eae6c100a40$var$cachedAppId = null;
async function $6ad04eae6c100a40$export$32a33a8da1c7f022() {
    // Return cached app ID if available
    if ($6ad04eae6c100a40$var$cachedAppId) return $6ad04eae6c100a40$var$cachedAppId;
    try {
        const response = await fetch('/api/media-sources/picker/app-id', {
            credentials: 'include'
        });
        if (!response.ok) throw new Error(`Failed to get app ID: ${response.status}`);
        const data = await response.json();
        $6ad04eae6c100a40$var$cachedAppId = data.app_id;
        return $6ad04eae6c100a40$var$cachedAppId;
    } catch (error) {
        window.logger?.error('Error getting Google Picker app ID:', error);
        throw new Error('Google Cloud project number not available. Please ensure you are logged in.', {
            cause: error
        });
    }
}


async function $340e9f71e9f92c91$export$e486ce152da8ad13(component, provider, accountIdentifier, viewType = 'DOCS', onPickCallback = null, multiselect = false, query = null) {
    try {
        // Load Google APIs
        await (0, $6ad04eae6c100a40$export$b21af638de5e3e24)();
        // Get access token
        const accessToken = await (0, $6ad04eae6c100a40$export$84773cc9bf7dbe87)(provider, accountIdentifier);
        if (!accessToken) throw new Error('No access token received from server');
        window.logger?.debug('Access token received for picker', {
            hasToken: !!accessToken,
            tokenLength: accessToken.length,
            tokenPrefix: accessToken.substring(0, 20) + '...'
        });
        // Get API key (from authenticated endpoint)
        const apiKey = await (0, $6ad04eae6c100a40$export$c66ffd2d23780276)();
        if (!apiKey) throw new Error('Google Picker API key is not available');
        // Get app ID (required for drive.file scope)
        const appId = await (0, $6ad04eae6c100a40$export$32a33a8da1c7f022)();
        if (!appId) throw new Error('Google Cloud project number (app ID) is not available');
        window.logger?.info('Opening Google Drive picker', {
            hasAccessToken: !!accessToken,
            hasApiKey: !!apiKey,
            hasAppId: !!appId,
            apiKeyLength: apiKey?.length,
            origin: window.location.origin
        });
        // Scroll to top to ensure picker appears at top of viewport
        window.scrollTo({
            top: 0,
            behavior: 'instant'
        });
        // Create picker with callback that has access to account info
        const accountInfo = component.pendingPickerAccount;
        // Store access token in closure for use in callback
        // Capture it directly so it's available even if component.pendingPickerAccessToken is cleared
        const pickerAccessToken = accessToken;
        component.pendingPickerAccessToken = accessToken;
        // Create views based on viewType
        let view;
        if (viewType === 'FOLDERS') // For folders, use FOLDERS view and enable folder selection
        view = new google.picker.DocsView(google.picker.ViewId.FOLDERS).setMode(google.picker.DocsViewMode.LIST).setOwnedByMe(true).setIncludeFolders(true).setSelectFolderEnabled(true);
        else // Default to DOCS view (files) - enable folder browsing
        view = new google.picker.DocsView(google.picker.ViewId.DOCS).setMode(google.picker.DocsViewMode.LIST).setOwnedByMe(true).setIncludeFolders(true); // Enable folder browsing so users can navigate into folders
        // Set default search query if provided
        if (query) view.setQuery(query);
        const pickerBuilder = new google.picker.PickerBuilder().setOAuthToken(accessToken).setDeveloperKey(apiKey).setAppId(appId) // Required for drive.file scope
        .addView(view);
        // Enable multiselect if requested
        if (multiselect) pickerBuilder.enableFeature(google.picker.Feature.MULTISELECT_ENABLED);
        const picker = pickerBuilder.setCallback((data)=>{
            // If custom callback provided, use it
            if (onPickCallback) {
                try {
                    onPickCallback(data);
                } catch (error) {
                    window.logger?.error('Error in custom picker callback:', error);
                }
                return;
            }
            // Otherwise use default callback handling
            // Temporarily restore currentAccount and accessToken for callback
            const previousAccount = component.currentAccount;
            component.currentAccount = accountInfo;
            // Use the captured token from closure, not component.pendingPickerAccessToken
            component.pendingPickerAccessToken = pickerAccessToken;
            try {
                $340e9f71e9f92c91$export$79b3633f7d86a215(component, data);
            } finally{
                // Restore previous state (likely null)
                component.currentAccount = previousAccount;
                // Clear pending account and token after callback
                component.pendingPickerAccount = null;
                component.pendingPickerAccessToken = null;
            }
        })//.setOrigin(window.location.origin)
        .build();
        picker.setVisible(true);
        // Ensure Google Picker overlay appears above other elements
        // Google Picker creates its own overlay, but we need to ensure it's above the sidebar (z-index 9999)
        const ensurePickerOnTop = ()=>{
            // Try multiple selectors to find the picker overlay
            const selectors = [
                '[role="dialog"]',
                '.picker-dialog',
                'div[style*="z-index"]',
                'iframe[src*="docs.google.com"]',
                'iframe[src*="picker"]'
            ];
            let pickerOverlay = null;
            for (const selector of selectors){
                const elements = document.querySelectorAll(selector);
                for (const el of elements){
                    // Check if this looks like a Google Picker element
                    const style = window.getComputedStyle(el);
                    if (style.position === 'fixed' || style.position === 'absolute') {
                        // Check if it's likely the picker (has high z-index or contains picker-related content)
                        const zIndex = parseInt(style.zIndex) || 0;
                        if (zIndex > 1000 || el.querySelector('iframe[src*="docs.google.com"]') || el.querySelector('iframe[src*="picker"]')) {
                            pickerOverlay = el;
                            break;
                        }
                    }
                }
                if (pickerOverlay) break;
            }
            // Also check for iframes and their containers
            if (!pickerOverlay) {
                const iframes = document.querySelectorAll('iframe[src*="docs.google.com"], iframe[src*="picker"]');
                for (const iframe of iframes){
                    const container = iframe.closest('div');
                    if (container) {
                        pickerOverlay = container;
                        break;
                    }
                }
            }
            if (pickerOverlay) {
                // Set a very high z-index to ensure it's above everything (sidebar is 9999)
                pickerOverlay.style.zIndex = '999999';
                pickerOverlay.style.position = 'fixed'; // Ensure it's positioned correctly
                // Also ensure all parent elements have proper z-index
                let parent = pickerOverlay.parentElement;
                while(parent && parent !== document.body){
                    const parentStyle = window.getComputedStyle(parent);
                    if (parentStyle.position === 'fixed' || parentStyle.position === 'absolute') {
                        const currentZIndex = parseInt(parentStyle.zIndex) || 0;
                        if (currentZIndex < 999999) parent.style.zIndex = '999999';
                    }
                    parent = parent.parentElement;
                }
                return true;
            }
            return false;
        };
        // Try immediately, then with increasing delays
        let attempts = 0;
        const maxAttempts = 20;
        const checkInterval = setInterval(()=>{
            attempts++;
            if (ensurePickerOnTop() || attempts >= maxAttempts) clearInterval(checkInterval);
        }, 50); // Check every 50ms for up to 1 second
        // Also use MutationObserver to catch dynamically added elements
        const observer = new MutationObserver(()=>{
            if (ensurePickerOnTop()) observer.disconnect();
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'style',
                'class'
            ]
        });
        // Clean up observer after 5 seconds
        setTimeout(()=>{
            observer.disconnect();
            clearInterval(checkInterval);
        }, 5000);
        // Reset guard after picker is shown
        component.isOpeningPicker = false;
    } catch (error) {
        window.logger?.error('Error opening Google Drive picker: ' + error);
        component.showError('Failed to open Google Drive picker. Please try again.');
        // Reset guard on error
        component.isOpeningPicker = false;
    }
}
async function $340e9f71e9f92c91$export$79b3633f7d86a215(component, data) {
    if (data.action === google.picker.Action.PICKED) {
        const files = data.docs.map((doc)=>{
            // Log warning if file doesn't have isShared property or if it's true
            if (doc.isShared === true) window.logger?.warn('WARNING: File selected has isShared=true. This file may not be accessible with drive.file scope!', {
                fileId: doc.id,
                fileName: doc.name,
                mimeType: doc.mimeType,
                serviceId: doc.serviceId
            });
            else if (doc.isShared === undefined) window.logger?.warn('WARNING: File selected does not have isShared property. Cannot verify if file is shared.', {
                fileId: doc.id,
                fileName: doc.name,
                mimeType: doc.mimeType,
                serviceId: doc.serviceId
            });
            // Extract file ID - try doc.id first, fallback to extracting from doc.url if needed
            let fileId = doc.id;
            if (!fileId && doc.url) {
                // Extract file ID from Google Drive URL if doc.id is not available
                const match = doc.url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
                if (match) fileId = match[1];
            }
            if (!fileId) {
                window.logger?.error('Could not extract file ID from picker doc:', doc);
                throw new Error('Invalid file selection: no file ID found');
            }
            // Check if file is shared (might not be accessible with drive.file scope)
            const isShared = doc.isShared === true;
            if (isShared) {
                // Show warning to user about shared files
                component.showError("\u26A0\uFE0F Warning: This file is shared with you. Files shared with you may not be accessible with the current permissions. Please select files you own, or make a copy of the shared file to your Drive.");
                window.logger?.warn('Selected file is shared (not owned by user). With drive.file scope, shared files may not be accessible.', {
                    fileId: fileId,
                    fileName: doc.name,
                    mimeType: doc.mimeType
                });
            }
            return {
                provider: component.currentAccount.provider,
                accountId: component.currentAccount.accountIdentifier,
                fileId: fileId,
                fileUrl: `oauth://${component.currentAccount.provider}/${component.currentAccount.accountIdentifier}/${fileId}`,
                fileName: doc.name || 'File',
                isShared: isShared,
                mimeType: doc.mimeType,
                embedUrl: doc.embedUrl // Store embedUrl for special file types like My Maps
            };
        });
        // For now, dispatch files directly for all providers (including Google Drive)
        // This allows us to test if appId fixes backend access without copying
        window.logger?.info('Dispatching files directly (copying disabled for testing)', {
            provider: component.currentAccount?.provider,
            fileCount: files.length
        });
        component.dispatchEvent(new CustomEvent('files-selected', {
            detail: {
                files: files,
                textarea: component._targetTextarea || null
            },
            bubbles: true
        }));
        // Close picker modal
        component.close();
    } else if (data.action === google.picker.Action.CANCEL) // User cancelled picker - close modal
    component.close();
}
async function $340e9f71e9f92c91$export$b327cae1125622bd(accessToken) {
    const folderName = 'FunOldTimes';
    const apiBaseUrl = 'https://www.googleapis.com/drive/v3';
    try {
        // First, try to find existing folder
        const searchParams = new URLSearchParams({
            q: `name='${folderName}' and mimeType='application/vnd.google-apps.folder' and trashed=false`,
            fields: 'files(id,name)',
            pageSize: '1'
        });
        const searchUrl = `${apiBaseUrl}/files?${searchParams.toString()}`;
        const searchResponse = await fetch(searchUrl, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });
        if (searchResponse.ok) {
            const searchData = await searchResponse.json();
            if (searchData.files && searchData.files.length > 0) {
                window.logger?.debug('Found existing FunOldTimes folder', {
                    folderId: searchData.files[0].id
                });
                return searchData.files[0].id;
            }
        }
        // Folder doesn't exist, create it
        window.logger?.debug('Creating FunOldTimes folder');
        const createResponse = await fetch(`${apiBaseUrl}/files`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: folderName,
                mimeType: 'application/vnd.google-apps.folder'
            })
        });
        if (!createResponse.ok) {
            const errorText = await createResponse.text();
            throw new Error(`Failed to create folder: ${createResponse.status} ${errorText}`);
        }
        const folderData = await createResponse.json();
        window.logger?.info('Created FunOldTimes folder', {
            folderId: folderData.id
        });
        return folderData.id;
    } catch (error) {
        window.logger?.error('Error finding or creating FunOldTimes folder:', error);
        throw error;
    }
}
async function $340e9f71e9f92c91$export$8795d813db91f3ed(sourceFileId, accessToken, appFolderId, fileName = null) {
    const apiBaseUrl = 'https://www.googleapis.com/drive/v3';
    try {
        window.logger?.debug('Copying file to app folder', {
            sourceFileId: sourceFileId,
            appFolderId: appFolderId,
            fileName: fileName
        });
        // Copy the file to the app folder
        const copyBody = {
            parents: [
                appFolderId
            ]
        };
        if (fileName) copyBody.name = fileName;
        const copyUrl = `${apiBaseUrl}/files/${sourceFileId}/copy`;
        const copyResponse = await fetch(copyUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(copyBody)
        });
        if (!copyResponse.ok) {
            const errorText = await copyResponse.text();
            window.logger?.error('Failed to copy file to app folder', {
                sourceFileId: sourceFileId,
                status: copyResponse.status,
                errorText: errorText.substring(0, 500)
            });
            throw new Error(`Failed to copy file: ${copyResponse.status} ${errorText}`);
        }
        const copiedFile = await copyResponse.json();
        window.logger?.info('File copied to app folder', {
            sourceFileId: sourceFileId,
            copiedFileId: copiedFile.id,
            appFolderId: appFolderId
        });
        return copiedFile.id;
    } catch (error) {
        window.logger?.error('Error copying file to app folder:', error);
        throw error;
    }
}



var $eZQHH = parcelRequire("eZQHH");

class $3be010b117351c5f$var$FacebookImportFriends extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.jobs = [];
        this.isLoading = false;
        this.isStartingImport = false;
        this.errorMessage = null;
        this.successMessage = null;
        this.pollingInterval = null;
        this.googleDriveAccounts = [];
        this.isLoadingAccounts = false;
        this.friendsFileId = null;
        this.friendsFileName = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
        this.attachEventListeners();
        this.loadUserAndJobs();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.pollingInterval) clearInterval(this.pollingInterval);
    }
    async loadUserAndJobs() {
        try {
            if (!window.API) throw new Error('API not available');
            const authData = await window.API.request('/auth/status');
            if (!authData.authenticated) throw new Error('User not authenticated');
            this.currentUser = authData.user;
            await Promise.all([
                this.loadJobs(),
                this.loadGoogleDriveAccounts()
            ]);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load user or jobs:', error);
            this.errorMessage = 'Failed to load import jobs';
            this.isLoading = false;
            this.render();
        }
    }
    async loadGoogleDriveAccounts() {
        try {
            if (!window.API || !this.currentUser) return;
            this.isLoadingAccounts = true;
            const data = await window.API.request(`/users/settings/${this.currentUser.id}/media-sources`);
            this.googleDriveAccounts = data.accounts?.['google-drive'] || [];
            this.isLoadingAccounts = false;
            this.render();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load Google Drive accounts:', error);
            this.isLoadingAccounts = false;
        }
    }
    async openFilePicker() {
        if (this.googleDriveAccounts.length === 0) {
            this.errorMessage = 'Please connect a Google Drive account first in Sparkle Sources settings.';
            this.render();
            return;
        }
        const account = this.googleDriveAccounts[0];
        try {
            await (0, $340e9f71e9f92c91$export$e486ce152da8ad13)(this, 'google-drive', account.accountIdentifier, 'DOCS', (data)=>{
                if (data.action === google.picker.Action.PICKED) {
                    const file = data.docs[0];
                    if (file) {
                        this.friendsFileId = file.id;
                        this.friendsFileName = file.name || 'Selected File';
                        this.errorMessage = null;
                        this.render();
                    }
                }
            }, false, 'your_friends.json');
        } catch (error) {
            (0, $eZQHH.default).error('Failed to open file picker:', error);
            this.errorMessage = error.message || 'Failed to open Google Drive file picker. Please try again.';
            this.render();
        }
    }
    async loadJobs() {
        try {
            if (!window.API) throw new Error('API not available');
            const data = await window.API.request('/facebook-import/jobs');
            // Filter to only friends import jobs
            this.jobs = (data.jobs || []).filter((job)=>job.importType === 'friends_only');
            this.isLoading = false;
            this.render();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load import jobs:', error);
            this.errorMessage = 'Failed to load import jobs';
            this.isLoading = false;
            this.render();
        }
    }
    async startImport() {
        if (!this.friendsFileId) {
            this.errorMessage = 'Please select the friends JSON file';
            this.render();
            return;
        }
        this.isStartingImport = true;
        this.errorMessage = null;
        this.successMessage = null;
        this.render();
        try {
            const response = await window.API.request('/facebook-import/start', {
                method: 'POST',
                body: JSON.stringify({
                    importType: 'friends_only',
                    friendsFileId: this.friendsFileId
                })
            });
            this.successMessage = response.message || 'Friends import started successfully';
            this.friendsFileId = null;
            this.friendsFileName = null;
            await this.loadJobs();
            this.startPolling();
            this.isStartingImport = false;
            this.render();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to start friends import:', error);
            this.errorMessage = error.message || 'Failed to start friends import. Please try again.';
            this.isStartingImport = false;
            this.render();
        }
    }
    startPolling() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
        this.pollingInterval = setInterval(async ()=>{
            const hasActiveJobs = this.jobs.some((job)=>job.status === 'pending' || job.status === 'processing');
            if (hasActiveJobs) {
                await this.loadJobs();
                this.render();
            } else {
                if (this.pollingInterval) {
                    clearInterval(this.pollingInterval);
                    this.pollingInterval = null;
                }
                this.render();
            }
        }, 5000);
    }
    hasActiveJob() {
        return this.jobs.some((job)=>job.status === 'pending' || job.status === 'processing');
    }
    attachEventListeners() {
        // Use event delegation on the component itself
        // This works even after re-renders since the listener is on the component, not individual buttons
        if (!this._clickHandler) {
            this._clickHandler = (e)=>{
                const target = e.target.closest('button');
                if (!target) return;
                // Handle pick friends file button
                if (target.id === 'pickFriendsFileBtn' && !target.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openFilePicker();
                    return;
                }
                // Handle start import button
                if (target.id === 'startFriendsImportBtn' && !target.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.startImport();
                    return;
                }
                // Handle clear file button
                if (target.classList.contains('clear-file-btn')) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.friendsFileId = null;
                    this.friendsFileName = null;
                    this.render();
                    return;
                }
                // Handle delete job button
                if (target.classList.contains('delete-job-btn')) {
                    e.preventDefault();
                    e.stopPropagation();
                    const jobId = target.dataset.jobId;
                    if (jobId && confirm('Are you sure you want to delete this import job?')) this.deleteJob(jobId);
                    return;
                }
                // Handle return to settings button
                if (target.id === 'returnToSettingsBtn') {
                    e.preventDefault();
                    e.stopPropagation();
                    window.router.navigate('/settings');
                    return;
                }
            };
            this.addEventListener('click', this._clickHandler);
        }
    }
    async deleteJob(jobId) {
        try {
            await window.API.request(`/facebook-import/jobs/${jobId}`, {
                method: 'DELETE'
            });
            await this.loadJobs();
            this.render();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to delete job:', error);
            this.errorMessage = error.message || 'Failed to delete job';
            this.render();
        }
    }
    render() {
        const hasActiveJobs = this.hasActiveJob();
        const hasConnectedGoogleDrive = this.googleDriveAccounts.length > 0;
        this.innerHTML = `
      <div class="facebook-import">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDC65", 'Import Facebook Friends')}
          <p>Import your Facebook friends from your Facebook export</p>
        </div>

        ${this.errorMessage ? `<div class="alert alert-error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.errorMessage)}</div>` : ''}
        ${this.successMessage ? `<div class="alert alert-success">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.successMessage)}</div>` : ''}

        ${!hasConnectedGoogleDrive ? `
          <div class="help-warning">
            \u{26A0}\u{FE0F} You need to connect a Google Drive account first (if you haven't already).
            <a href="/settings/sparkle-sources">Go to Sparkle Sources settings</a> to connect.
          </div>
        ` : ''}

        <div class="import-section">
          <h3>Select Friends File</h3>
          <p class="section-description">Select your <code>your_friends.json</code> file from your Facebook export.</p>
          
          <div class="form-group">
            <label>Friends JSON File</label>
            ${this.friendsFileId ? `
              <div class="selected-file">
                <span class="file-icon">\u{1F4C4}</span>
                <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.friendsFileName || 'Selected File')}</span>
                <button type="button" class="btn-clear-file clear-file-btn">Change</button>
              </div>
            ` : `
              <button
                type="button"
                id="pickFriendsFileBtn"
                class="btn btn-secondary"
                ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
              >
                ${this.isLoadingAccounts ? 'Loading...' : "\uD83D\uDCC1 Pick Friends JSON File"}
              </button>
            `}
          </div>

          <button 
            type="button"
            id="startFriendsImportBtn"
            class="btn btn-primary"
            ${this.isStartingImport || hasActiveJobs || !this.friendsFileId ? 'disabled' : ''}
          >
            ${this.isStartingImport ? 'Starting Import...' : 'Start Friends Import'}
          </button>
        </div>

        ${hasActiveJobs ? '<p class="active-job-message">An import job is already in progress. Please wait or delete the active job.</p>' : ''}

        <div class="import-jobs-section">
          <h3>Your Import Jobs</h3>
          ${this.isLoading && !hasActiveJobs ? `
            <div class="loading-state">
              <div class="spinner"></div>
              <div>Loading import jobs...</div>
            </div>
          ` : this.jobs.length === 0 ? `
            <p class="empty-state">No import jobs found. Start one above!</p>
          ` : `
            <ul class="job-list">
              ${this.jobs.map((job)=>`
                <li class="job-item">
                  <div class="job-details">
                    <span class="job-id">#${job.id}</span>
                    <span class="job-status status-${job.status}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(job.status)}</span>
                    <span class="job-created-at">${new Date(job.createdAt).toLocaleString()}</span>
                  </div>
                  <div class="job-progress">
                    <span class="progress-text">Friends: ${job.friendsFound || 0}</span>
                    ${job.status === 'processing' ? '<span class="spinner spinner-small"></span>' : ''}
                  </div>
                  ${job.errorMessage ? `<div class="job-error">Error: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(job.errorMessage)}</div>` : ''}
                      <div class="job-actions">
                        <button class="btn btn-sm btn-danger delete-job-btn" data-job-id="${job.id}" title="Delete job">
                          \xd7
                        </button>
                      </div>
                </li>
              `).join('')}
            </ul>
          `}
        </div>

        <div class="settings-footer">
          <button class="btn btn-secondary" id="returnToSettingsBtn">
            \u{2190} Return to Settings
          </button>
        </div>
      </div>
    `;
    }
}
customElements.define('facebook-import-friends', $3be010b117351c5f$var$FacebookImportFriends);


// Facebook Import Posts Web Component




var $eZQHH = parcelRequire("eZQHH");

class $7f6c4d391816047a$var$FacebookImportPosts extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.jobs = [];
        this.isLoading = false;
        this.isStartingImport = false;
        this.errorMessage = null;
        this.successMessage = null;
        this.pollingInterval = null;
        this.googleDriveAccounts = [];
        this.isLoadingAccounts = false;
        // Posts import state
        this.postsFileId = null;
        this.postsFileName = null;
        this.photoFileIds = [];
        this.photoFileNames = [];
        this.videoFileIds = [];
        this.videoFileNames = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
        this.attachEventListeners();
        this.loadUserAndJobs();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.pollingInterval) clearInterval(this.pollingInterval);
    }
    async loadUserAndJobs() {
        try {
            if (!window.API) throw new Error('API not available');
            const authData = await window.API.request('/auth/status');
            if (!authData.authenticated) throw new Error('User not authenticated');
            this.currentUser = authData.user;
            await Promise.all([
                this.loadJobs(),
                this.loadGoogleDriveAccounts()
            ]);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load user or jobs:', error);
            this.errorMessage = 'Failed to load import jobs';
            this.isLoading = false;
            this.render();
        }
    }
    async loadGoogleDriveAccounts() {
        try {
            if (!window.API || !this.currentUser) return;
            this.isLoadingAccounts = true;
            const data = await window.API.request(`/users/settings/${this.currentUser.id}/media-sources`);
            this.googleDriveAccounts = data.accounts?.['google-drive'] || [];
            this.isLoadingAccounts = false;
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load Google Drive accounts:', error);
            this.isLoadingAccounts = false;
        }
    }
    async openFilePicker(fileType, multiselect = false) {
        if (this.googleDriveAccounts.length === 0) {
            this.errorMessage = 'Please connect a Google Drive account first in Sparkle Sources settings.';
            this.render();
            return;
        }
        const account = this.googleDriveAccounts[0];
        // Set default search query based on file type
        let defaultQuery = null;
        if (fileType === 'posts') // Match: your_posts__check_ins__photos_and_videos_1.json
        defaultQuery = 'your_posts__check_ins__photos_and_videos';
        // No default query for photos/videos - let users browse folders freely
        try {
            await (0, $340e9f71e9f92c91$export$e486ce152da8ad13)(this, 'google-drive', account.accountIdentifier, 'DOCS', (data)=>{
                if (data.action === google.picker.Action.PICKED) {
                    const docs = data.docs || [];
                    if (multiselect) {
                        // Handle multiple files - append to existing selections
                        if (fileType === 'photos') {
                            // Append new files, avoiding duplicates
                            for (const doc of docs)if (!this.photoFileIds.includes(doc.id)) {
                                this.photoFileIds.push(doc.id);
                                this.photoFileNames.push(doc.name || 'Unknown');
                            }
                        } else if (fileType === 'videos') {
                            // Append new files, avoiding duplicates
                            for (const doc of docs)if (!this.videoFileIds.includes(doc.id)) {
                                this.videoFileIds.push(doc.id);
                                this.videoFileNames.push(doc.name || 'Unknown');
                            }
                        }
                    } else {
                        // Handle single file
                        const file = docs[0];
                        if (file) {
                            if (fileType === 'posts') {
                                this.postsFileId = file.id;
                                this.postsFileName = file.name || 'Selected File';
                            }
                        }
                    }
                    this.errorMessage = null;
                    this.render();
                    this.attachEventListeners();
                }
            }, multiselect, defaultQuery);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to open file picker:', error);
            this.errorMessage = error.message || 'Failed to open Google Drive file picker. Please try again.';
            this.render();
        }
    }
    async loadJobs() {
        try {
            if (!window.API) throw new Error('API not available');
            const data = await window.API.request('/facebook-import/jobs');
            // Filter to only posts import jobs
            this.jobs = (data.jobs || []).filter((job)=>job.importType === 'posts_only');
            this.isLoading = false;
            this.render();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load import jobs:', error);
            this.errorMessage = 'Failed to load import jobs';
            this.isLoading = false;
            this.render();
        }
    }
    async startImport() {
        if (!this.postsFileId) {
            this.errorMessage = 'Please select the posts JSON file';
            this.render();
            return;
        }
        // Refresh jobs list before starting to catch any stuck jobs
        await this.loadJobs();
        if (this.hasActiveJob()) {
            this.errorMessage = 'An import job is already in progress. Please wait or delete the active job.';
            this.render();
            return;
        }
        this.isStartingImport = true;
        this.errorMessage = null;
        this.successMessage = null;
        this.render();
        try {
            const response = await window.API.request('/facebook-import/start', {
                method: 'POST',
                body: JSON.stringify({
                    importType: 'posts_only',
                    postsFileId: this.postsFileId,
                    photoFileIds: this.photoFileIds,
                    videoFileIds: this.videoFileIds
                })
            });
            this.successMessage = response.message || 'Posts import started successfully';
            // Clear form
            this.postsFileId = null;
            this.postsFileName = null;
            this.photoFileIds = [];
            this.photoFileNames = [];
            this.videoFileIds = [];
            this.videoFileNames = [];
            await this.loadJobs();
            this.startPolling();
            this.isStartingImport = false;
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to start posts import:', error);
            this.errorMessage = error.message || 'Failed to start posts import. Please try again.';
            this.isStartingImport = false;
            this.render();
            this.attachEventListeners();
        }
    }
    startPolling() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
        this.pollingInterval = setInterval(async ()=>{
            const hasActiveJobs = this.jobs.some((job)=>job.status === 'pending' || job.status === 'processing');
            if (hasActiveJobs) {
                await this.loadJobs();
                this.render();
                this.attachEventListeners();
            } else {
                if (this.pollingInterval) {
                    clearInterval(this.pollingInterval);
                    this.pollingInterval = null;
                }
                this.render();
                this.attachEventListeners();
            }
        }, 5000);
    }
    hasActiveJob() {
        return this.jobs.some((job)=>job.status === 'pending' || job.status === 'processing');
    }
    async deleteJob(jobId) {
        try {
            await window.API.request(`/facebook-import/jobs/${jobId}`, {
                method: 'DELETE'
            });
            await this.loadJobs();
            this.render();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to delete job:', error);
            this.errorMessage = error.message || 'Failed to delete job';
            this.render();
        }
    }
    attachEventListeners() {
        // Use event delegation for better performance and to avoid issues with re-rendering
        // Only attach once using a flag
        if (!this.dataset.listenersAttached) {
            // File picker buttons and other interactive elements
            this.addEventListener('click', (e)=>{
                // Find the actual button element (handles clicks on child elements like emojis)
                const pickPostsBtn = e.target.closest('#pickPostsFileBtn');
                const _pickCommentsBtn = e.target.closest('#pickCommentsFileBtn');
                const pickPhotosBtn = e.target.closest('#pickPhotosBtn');
                const pickVideosBtn = e.target.closest('#pickVideosBtn');
                const startBtn = e.target.closest('#startPostsImportBtn');
                const clearBtn = e.target.closest('.clear-file-btn');
                const deleteBtn = e.target.closest('.delete-job-btn');
                const returnBtn = e.target.closest('#returnToSettingsBtn');
                if (pickPostsBtn && !pickPostsBtn.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openFilePicker('posts', false);
                } else if (pickPhotosBtn && !pickPhotosBtn.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openFilePicker('photos', true);
                } else if (pickVideosBtn && !pickVideosBtn.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.openFilePicker('videos', true);
                } else if (startBtn && !startBtn.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.startImport();
                } else if (clearBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    const fileType = clearBtn.dataset.fileType;
                    if (fileType === 'posts') {
                        this.postsFileId = null;
                        this.postsFileName = null;
                    } else if (fileType === 'photos') {
                        this.photoFileIds = [];
                        this.photoFileNames = [];
                    } else if (fileType === 'videos') {
                        this.videoFileIds = [];
                        this.videoFileNames = [];
                    }
                    this.render();
                } else {
                    // Handle individual file removal
                    const removeBtn = e.target.closest('.btn-remove-file');
                    if (removeBtn) {
                        e.preventDefault();
                        e.stopPropagation();
                        const fileType = removeBtn.dataset.fileType;
                        const fileIndex = parseInt(removeBtn.dataset.fileIndex, 10);
                        if (fileType === 'photos' && fileIndex >= 0 && fileIndex < this.photoFileIds.length) {
                            this.photoFileIds.splice(fileIndex, 1);
                            this.photoFileNames.splice(fileIndex, 1);
                        } else if (fileType === 'videos' && fileIndex >= 0 && fileIndex < this.videoFileIds.length) {
                            this.videoFileIds.splice(fileIndex, 1);
                            this.videoFileNames.splice(fileIndex, 1);
                        }
                        this.render();
                    }
                }
                if (deleteBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    const jobId = deleteBtn.dataset.jobId;
                    if (jobId && confirm('Are you sure you want to delete this import job?')) this.deleteJob(jobId);
                } else if (returnBtn) {
                    e.preventDefault();
                    e.stopPropagation();
                    window.router.navigate('/settings');
                }
            });
            this.dataset.listenersAttached = 'true';
        }
    }
    render() {
        const hasActiveJobs = this.hasActiveJob();
        const hasConnectedGoogleDrive = this.googleDriveAccounts.length > 0;
        this.innerHTML = `
      <div class="facebook-import">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDCDD", 'Import Facebook Posts')}
          <p>Import your Facebook posts, comments, photos, and videos from your Facebook export</p>
        </div>

        ${this.errorMessage ? `<div class="alert alert-error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.errorMessage)}</div>` : ''}
        ${this.successMessage ? `<div class="alert alert-success">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.successMessage)}</div>` : ''}

        ${!hasConnectedGoogleDrive ? `
          <div class="help-warning">
            \u{26A0}\u{FE0F} You need to connect a Google Drive account first (if you haven't already).
            <a href="/settings/sparkle-sources">Go to Sparkle Sources settings</a> to connect.
          </div>
        ` : ''}

        <div class="import-section">
          <h3>Select Files</h3>
          <p class="section-description">Select your Facebook posts data files. The posts JSON file is required; comments, photos, and videos are optional.</p>
          
          <div class="form-group">
            <label>Posts JSON File <span class="required">*</span></label>
            ${this.postsFileId ? `
              <div class="selected-file">
                <span class="file-icon">\u{1F4C4}</span>
                <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.postsFileName || 'Selected File')}</span>
                <button type="button" class="btn-clear-file clear-file-btn" data-file-type="posts">Change</button>
              </div>
            ` : `
              <button
                type="button"
                id="pickPostsFileBtn"
                class="btn btn-secondary"
                ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
              >
                ${this.isLoadingAccounts ? 'Loading...' : "\uD83D\uDCC1 Pick Posts JSON File"}
              </button>
            `}
          </div>

          <div class="form-group">
            <label>Photos <span class="optional">(optional, multiselect)</span></label>
            ${this.photoFileIds.length > 0 ? `
              <div class="selected-files">
                <details class="files-collapsible" open="false">
                  <summary class="files-summary">
                    <span class="file-icon">\u{1F5BC}\u{FE0F}</span>
                    <span class="file-count">${this.photoFileIds.length} photo${this.photoFileIds.length === 1 ? '' : 's'} selected</span>
                    <span class="expand-icon">\u{25BC}</span>
                  </summary>
                  <div class="files-list">
                    ${this.photoFileNames.map((name, idx)=>`
                      <div class="file-item">
                        <span class="file-icon">\u{1F4C4}</span>
                        <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(name)}</span>
                        <button type="button" class="btn-remove-file" data-file-type="photos" data-file-index="${idx}" title="Remove this file">\xd7</button>
                      </div>
                    `).join('')}
                  </div>
                </details>
                <div class="file-actions">
                  <button type="button" class="btn btn-secondary btn-sm" id="pickPhotosBtn" ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}>
                    ${this.isLoadingAccounts ? 'Loading...' : "\u2795 Add More Photos"}
                  </button>
                  <button type="button" class="btn-clear-file clear-file-btn" data-file-type="photos">Clear All</button>
                </div>
              </div>
            ` : `
              <button
                type="button"
                id="pickPhotosBtn"
                class="btn btn-secondary"
                ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
              >
                ${this.isLoadingAccounts ? 'Loading...' : "\uD83D\uDDBC\uFE0F Pick Photos (Select Multiple)"}
              </button>
            `}
          </div>

          <div class="form-group">
            <label>Videos <span class="optional">(optional, multiselect)</span></label>
            ${this.videoFileIds.length > 0 ? `
              <div class="selected-files">
                <details class="files-collapsible" open="false">
                  <summary class="files-summary">
                    <span class="file-icon">\u{1F3A5}</span>
                    <span class="file-count">${this.videoFileIds.length} video${this.videoFileIds.length === 1 ? '' : 's'} selected</span>
                    <span class="expand-icon">\u{25BC}</span>
                  </summary>
                  <div class="files-list">
                    ${this.videoFileNames.map((name, idx)=>`
                      <div class="file-item">
                        <span class="file-icon">\u{1F4C4}</span>
                        <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(name)}</span>
                        <button type="button" class="btn-remove-file" data-file-type="videos" data-file-index="${idx}" title="Remove this file">\xd7</button>
                      </div>
                    `).join('')}
                  </div>
                </details>
                <div class="file-actions">
                  <button type="button" class="btn btn-secondary btn-sm" id="pickVideosBtn" ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}>
                    ${this.isLoadingAccounts ? 'Loading...' : "\u2795 Add More Videos"}
                  </button>
                  <button type="button" class="btn-clear-file clear-file-btn" data-file-type="videos">Clear All</button>
                </div>
              </div>
            ` : `
              <button
                type="button"
                id="pickVideosBtn"
                class="btn btn-secondary"
                ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
              >
                ${this.isLoadingAccounts ? 'Loading...' : "\uD83C\uDFA5 Pick Videos (Select Multiple)"}
              </button>
            `}
          </div>

          <button 
            type="button"
            id="startPostsImportBtn"
            class="btn btn-primary"
            ${this.isStartingImport || hasActiveJobs || !this.postsFileId ? 'disabled' : ''}
          >
            ${this.isStartingImport ? 'Starting Import...' : 'Start Posts Import'}
          </button>
        </div>

        ${hasActiveJobs ? '<p class="active-job-message">An import job is already in progress. Please wait or delete the active job.</p>' : ''}

        <div class="import-jobs-section">
          <h3>Your Import Jobs</h3>
          ${this.isLoading && !hasActiveJobs ? `
            <div class="loading-state">
              <div class="spinner"></div>
              <div>Loading import jobs...</div>
            </div>
          ` : this.jobs.length === 0 ? `
            <p class="empty-state">No import jobs found. Start one above!</p>
          ` : `
            <ul class="job-list">
              ${this.jobs.map((job)=>`
                <li class="job-item">
                  <div class="job-details">
                    <span class="job-id">#${job.id}</span>
                    <span class="job-status status-${job.status}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(job.status)}</span>
                    <span class="job-created-at">${new Date(job.createdAt).toLocaleString()}</span>
                  </div>
                  <div class="job-progress">
                    <span class="progress-text">Posts: ${job.postsImported || 0}</span>
                    ${job.status === 'processing' ? '<span class="spinner spinner-small"></span>' : ''}
                  </div>
                  ${job.errorMessage ? `<div class="job-error">Error: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(job.errorMessage)}</div>` : ''}
                  <div class="job-actions">
                    <button class="btn btn-sm btn-danger delete-job-btn" data-job-id="${job.id}" title="Delete job">
                      \xd7
                    </button>
                  </div>
                </li>
              `).join('')}
            </ul>
          `}
        </div>

        <div class="settings-footer">
          <button class="btn btn-secondary" id="returnToSettingsBtn">
            \u{2190} Return to Settings
          </button>
        </div>
      </div>
    `;
    }
}
customElements.define('facebook-import-posts', $7f6c4d391816047a$var$FacebookImportPosts);


// Facebook Import Web Component

var $eZQHH = parcelRequire("eZQHH");



class $110dc075982d1144$var$FacebookImport extends HTMLElement {
    constructor(){
        super();
        this.jobs = [];
        this.isLoading = false;
        this.isStartingImport = false;
        this.errorMessage = null;
        this.successMessage = null;
        this.currentUser = null;
        this.pollingInterval = null;
        this.googleDriveAccounts = [];
        this.isLoadingAccounts = false;
        // Friends import state
        this.friendsFileId = null;
        this.friendsFileName = null;
        // Posts import state
        this.postsFileId = null;
        this.postsFileName = null;
        this.commentsFileId = null;
        this.commentsFileName = null;
        this.photoFileIds = [];
        this.photoFileNames = [];
        this.videoFileIds = [];
        this.videoFileNames = [];
        // Active tab: 'friends' or 'posts'
        this.activeTab = 'friends';
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.loadUserAndJobs();
    }
    disconnectedCallback() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
    }
    async loadUserAndJobs() {
        try {
            if (!window.API) throw new Error('API not available');
            // Get current user
            const authData = await window.API.request('/auth/status');
            if (!authData.authenticated) throw new Error('User not authenticated');
            this.currentUser = authData.user;
            await Promise.all([
                this.loadJobs(),
                this.loadGoogleDriveAccounts()
            ]);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load user or jobs:', error);
            this.errorMessage = 'Failed to load import jobs';
            this.isLoading = false;
            this.render();
        }
    }
    async loadGoogleDriveAccounts() {
        try {
            if (!window.API || !this.currentUser) return;
            this.isLoadingAccounts = true;
            const data = await window.API.request(`/users/settings/${this.currentUser.id}/media-sources`);
            this.googleDriveAccounts = data.accounts?.['google-drive'] || [];
            this.isLoadingAccounts = false;
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load Google Drive accounts:', error);
            this.isLoadingAccounts = false;
        }
    }
    async openFilePicker(fileType, multiselect = false) {
        if (this.googleDriveAccounts.length === 0) {
            this.errorMessage = 'Please connect a Google Drive account first in Sparkle Sources settings.';
            this.render();
            return;
        }
        const account = this.googleDriveAccounts[0];
        try {
            await (0, $340e9f71e9f92c91$export$e486ce152da8ad13)(this, 'google-drive', account.accountIdentifier, 'DOCS', (data)=>{
                if (data.action === google.picker.Action.PICKED) {
                    const docs = data.docs || [];
                    if (multiselect) {
                        // Handle multiple files
                        if (fileType === 'photos') {
                            this.photoFileIds = docs.map((doc)=>doc.id);
                            this.photoFileNames = docs.map((doc)=>doc.name || 'Unknown');
                        } else if (fileType === 'videos') {
                            this.videoFileIds = docs.map((doc)=>doc.id);
                            this.videoFileNames = docs.map((doc)=>doc.name || 'Unknown');
                        }
                    } else {
                        // Handle single file
                        const file = docs[0];
                        if (file) {
                            if (fileType === 'friends') {
                                this.friendsFileId = file.id;
                                this.friendsFileName = file.name || 'Selected File';
                            } else if (fileType === 'posts') {
                                this.postsFileId = file.id;
                                this.postsFileName = file.name || 'Selected File';
                            } else if (fileType === 'comments') {
                                this.commentsFileId = file.id;
                                this.commentsFileName = file.name || 'Selected File';
                            }
                        }
                    }
                    this.errorMessage = null;
                    this.render();
                    this.attachEventListeners();
                }
            }, multiselect);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to open file picker:', error);
            this.errorMessage = error.message || 'Failed to open Google Drive file picker. Please try again.';
            this.render();
        }
    }
    async loadJobs() {
        try {
            if (!window.API) throw new Error('API not available');
            const data = await window.API.request('/facebook-import/jobs');
            this.jobs = data.jobs || [];
            this.isLoading = false;
            this.render();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load import jobs:', error);
            this.errorMessage = 'Failed to load import jobs';
            this.isLoading = false;
            this.render();
        }
    }
    async startFriendsImport() {
        if (!this.friendsFileId) {
            this.errorMessage = 'Please select the friends JSON file';
            this.render();
            return;
        }
        this.isStartingImport = true;
        this.errorMessage = null;
        this.successMessage = null;
        this.render();
        try {
            const response = await window.API.request('/facebook-import/start', {
                method: 'POST',
                body: JSON.stringify({
                    importType: 'friends_only',
                    friendsFileId: this.friendsFileId
                })
            });
            this.successMessage = response.message || 'Friends import started successfully';
            this.friendsFileId = null;
            this.friendsFileName = null;
            await this.loadJobs();
            this.startPolling();
            this.isStartingImport = false;
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to start friends import:', error);
            this.errorMessage = error.message || 'Failed to start friends import. Please try again.';
            this.isStartingImport = false;
            this.render();
            this.attachEventListeners();
        }
    }
    async startPostsImport() {
        if (!this.postsFileId) {
            this.errorMessage = 'Please select the posts JSON file';
            this.render();
            return;
        }
        this.isStartingImport = true;
        this.errorMessage = null;
        this.successMessage = null;
        this.render();
        try {
            const response = await window.API.request('/facebook-import/start', {
                method: 'POST',
                body: JSON.stringify({
                    importType: 'posts_only',
                    postsFileId: this.postsFileId,
                    commentsFileId: this.commentsFileId || null,
                    photoFileIds: this.photoFileIds,
                    videoFileIds: this.videoFileIds
                })
            });
            this.successMessage = response.message || 'Posts import started successfully';
            // Clear form
            this.postsFileId = null;
            this.postsFileName = null;
            this.commentsFileId = null;
            this.commentsFileName = null;
            this.photoFileIds = [];
            this.photoFileNames = [];
            this.videoFileIds = [];
            this.videoFileNames = [];
            await this.loadJobs();
            this.startPolling();
            this.isStartingImport = false;
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to start posts import:', error);
            this.errorMessage = error.message || 'Failed to start posts import. Please try again.';
            this.isStartingImport = false;
            this.render();
            this.attachEventListeners();
        }
    }
    startPolling() {
        if (this.pollingInterval) clearInterval(this.pollingInterval);
        this.pollingInterval = setInterval(async ()=>{
            const hasActiveJobs = this.jobs.some((job)=>job.status === 'pending' || job.status === 'processing');
            if (hasActiveJobs) {
                await this.loadJobs();
                this.render();
                this.attachEventListeners();
            } else {
                if (this.pollingInterval) {
                    clearInterval(this.pollingInterval);
                    this.pollingInterval = null;
                }
                this.render();
                this.attachEventListeners();
            }
        }, 5000);
    }
    hasActiveJob() {
        return this.jobs.some((job)=>job.status === 'pending' || job.status === 'processing');
    }
    switchTab(tab) {
        this.activeTab = tab;
        this.errorMessage = null;
        this.successMessage = null;
        this.render();
        this.attachEventListeners();
    }
    attachEventListeners() {
        // Tab switching
        const friendsTab = this.querySelector('#friendsTab');
        const postsTab = this.querySelector('#postsTab');
        if (friendsTab) friendsTab.addEventListener('click', ()=>this.switchTab('friends'));
        if (postsTab) postsTab.addEventListener('click', ()=>this.switchTab('posts'));
        // Friends import
        const pickFriendsBtn = this.querySelector('#pickFriendsFileBtn');
        if (pickFriendsBtn) pickFriendsBtn.addEventListener('click', ()=>this.openFilePicker('friends', false));
        const startFriendsBtn = this.querySelector('#startFriendsImportBtn');
        if (startFriendsBtn) startFriendsBtn.addEventListener('click', ()=>this.startFriendsImport());
        // Posts import
        const pickPostsBtn = this.querySelector('#pickPostsFileBtn');
        if (pickPostsBtn) pickPostsBtn.addEventListener('click', ()=>this.openFilePicker('posts', false));
        const pickCommentsBtn = this.querySelector('#pickCommentsFileBtn');
        if (pickCommentsBtn) pickCommentsBtn.addEventListener('click', ()=>this.openFilePicker('comments', false));
        const pickPhotosBtn = this.querySelector('#pickPhotosBtn');
        if (pickPhotosBtn) pickPhotosBtn.addEventListener('click', ()=>this.openFilePicker('photos', true));
        const pickVideosBtn = this.querySelector('#pickVideosBtn');
        if (pickVideosBtn) pickVideosBtn.addEventListener('click', ()=>this.openFilePicker('videos', true));
        const startPostsBtn = this.querySelector('#startPostsImportBtn');
        if (startPostsBtn) startPostsBtn.addEventListener('click', ()=>this.startPostsImport());
        // Clear buttons
        this.querySelectorAll('.clear-file-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const fileType = e.target.dataset.fileType;
                if (fileType === 'friends') {
                    this.friendsFileId = null;
                    this.friendsFileName = null;
                } else if (fileType === 'posts') {
                    this.postsFileId = null;
                    this.postsFileName = null;
                } else if (fileType === 'comments') {
                    this.commentsFileId = null;
                    this.commentsFileName = null;
                } else if (fileType === 'photos') {
                    this.photoFileIds = [];
                    this.photoFileNames = [];
                } else if (fileType === 'videos') {
                    this.videoFileIds = [];
                    this.videoFileNames = [];
                }
                this.render();
                this.attachEventListeners();
            });
        });
        // Delete job buttons
        this.querySelectorAll('.delete-job-btn').forEach((btn)=>{
            btn.addEventListener('click', async (e)=>{
                const jobId = e.target.dataset.jobId;
                if (jobId && confirm('Are you sure you want to delete this import job?')) try {
                    await window.API.request(`/facebook-import/jobs/${jobId}`, {
                        method: 'DELETE'
                    });
                    await this.loadJobs();
                    this.render();
                    this.attachEventListeners();
                } catch (error) {
                    (0, $eZQHH.default).error('Failed to delete job:', error);
                    this.errorMessage = error.message || 'Failed to delete job';
                    this.render();
                }
            });
        });
        // Return to settings
        const returnBtn = this.querySelector('#returnToSettingsBtn');
        if (returnBtn) returnBtn.addEventListener('click', ()=>{
            window.router.navigate('/settings');
        });
    }
    render() {
        const hasActiveJobs = this.hasActiveJob();
        const hasConnectedGoogleDrive = this.googleDriveAccounts.length > 0;
        this.innerHTML = `
      <div class="facebook-import">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDCE5", 'Facebook Import')}
          <p>Import your Facebook posts and friends from Google Drive files</p>
        </div>

        ${this.errorMessage ? `<div class="alert alert-error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.errorMessage)}</div>` : ''}
        ${this.successMessage ? `<div class="alert alert-success">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.successMessage)}</div>` : ''}

        ${!hasConnectedGoogleDrive ? `
          <div class="help-warning">
            \u{26A0}\u{FE0F} You need to connect a Google Drive account first (if you haven't already).
            <a href="/settings/sparkle-sources">Go to Sparkle Sources settings</a> to connect.
          </div>
        ` : ''}

        <div class="import-tabs">
          <button class="tab-btn ${this.activeTab === 'friends' ? 'active' : ''}" id="friendsTab">
            \u{1F465} Import Friends
          </button>
          <button class="tab-btn ${this.activeTab === 'posts' ? 'active' : ''}" id="postsTab">
            \u{1F4DD} Import Posts
          </button>
        </div>

        ${this.activeTab === 'friends' ? `
          <div class="import-section">
            <h3>Import Friends</h3>
            <p class="section-description">Select your <code>your_friends.json</code> file from your Facebook export.</p>
            
            <div class="form-group">
              <label>Friends JSON File</label>
              ${this.friendsFileId ? `
                <div class="selected-file">
                  <span class="file-icon">\u{1F4C4}</span>
                  <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.friendsFileName || 'Selected File')}</span>
                  <button type="button" class="btn-clear-file clear-file-btn" data-file-type="friends">Change</button>
                </div>
              ` : `
                <button
                  type="button"
                  id="pickFriendsFileBtn"
                  class="btn btn-secondary"
                  ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
                >
                  ${this.isLoadingAccounts ? 'Loading...' : "\uD83D\uDCC1 Pick Friends JSON File"}
                </button>
              `}
            </div>

            <button 
              type="button"
              id="startFriendsImportBtn"
              class="btn btn-primary"
              ${this.isStartingImport || hasActiveJobs || !this.friendsFileId ? 'disabled' : ''}
            >
              ${this.isStartingImport ? 'Starting Import...' : 'Start Friends Import'}
            </button>
          </div>
        ` : `
          <div class="import-section">
            <h3>Import Posts</h3>
            <p class="section-description">Select your Facebook posts data files. The posts JSON file is required; comments, photos, and videos are optional.</p>
            
            <div class="form-group">
              <label>Posts JSON File <span class="required">*</span></label>
              ${this.postsFileId ? `
                <div class="selected-file">
                  <span class="file-icon">\u{1F4C4}</span>
                  <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.postsFileName || 'Selected File')}</span>
                  <button type="button" class="btn-clear-file clear-file-btn" data-file-type="posts">Change</button>
                </div>
              ` : `
                <button
                  type="button"
                  id="pickPostsFileBtn"
                  class="btn btn-secondary"
                  ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
                >
                  ${this.isLoadingAccounts ? 'Loading...' : "\uD83D\uDCC1 Pick Posts JSON File"}
                </button>
              `}
            </div>

            <div class="form-group">
              <label>Comments JSON File <span class="optional">(optional)</span></label>
              ${this.commentsFileId ? `
                <div class="selected-file">
                  <span class="file-icon">\u{1F4C4}</span>
                  <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.commentsFileName || 'Selected File')}</span>
                  <button type="button" class="btn-clear-file clear-file-btn" data-file-type="comments">Change</button>
                </div>
              ` : `
                <button
                  type="button"
                  id="pickCommentsFileBtn"
                  class="btn btn-secondary"
                  ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
                >
                  ${this.isLoadingAccounts ? 'Loading...' : "\uD83D\uDCC1 Pick Comments JSON File"}
                </button>
              `}
            </div>

            <div class="form-group">
              <label>Photos <span class="optional">(optional, multiselect)</span></label>
              ${this.photoFileIds.length > 0 ? `
                <div class="selected-files">
                  <div class="files-list">
                    ${this.photoFileNames.map((name, _idx)=>`
                      <div class="file-item">
                        <span class="file-icon">\u{1F5BC}\u{FE0F}</span>
                        <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(name)}</span>
                      </div>
                    `).join('')}
                  </div>
                  <button type="button" class="btn-clear-file clear-file-btn" data-file-type="photos">Change</button>
                </div>
              ` : `
                <button
                  type="button"
                  id="pickPhotosBtn"
                  class="btn btn-secondary"
                  ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
                >
                  ${this.isLoadingAccounts ? 'Loading...' : "\uD83D\uDDBC\uFE0F Pick Photos (Select Multiple)"}
                </button>
              `}
            </div>

            <div class="form-group">
              <label>Videos <span class="optional">(optional, multiselect)</span></label>
              ${this.videoFileIds.length > 0 ? `
                <div class="selected-files">
                  <div class="files-list">
                    ${this.videoFileNames.map((name, _idx)=>`
                      <div class="file-item">
                        <span class="file-icon">\u{1F3A5}</span>
                        <span class="file-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(name)}</span>
                      </div>
                    `).join('')}
                  </div>
                  <button type="button" class="btn-clear-file clear-file-btn" data-file-type="videos">Change</button>
                </div>
              ` : `
                <button
                  type="button"
                  id="pickVideosBtn"
                  class="btn btn-secondary"
                  ${this.isStartingImport || this.isLoadingAccounts ? 'disabled' : ''}
                >
                  ${this.isLoadingAccounts ? 'Loading...' : "\uD83C\uDFA5 Pick Videos (Select Multiple)"}
                </button>
              `}
            </div>

            <button 
              type="button"
              id="startPostsImportBtn"
              class="btn btn-primary"
              ${this.isStartingImport || hasActiveJobs || !this.postsFileId ? 'disabled' : ''}
            >
              ${this.isStartingImport ? 'Starting Import...' : 'Start Posts Import'}
            </button>
          </div>
        `}

        ${hasActiveJobs ? '<p class="active-job-message">An import job is already in progress. Please wait or delete the active job.</p>' : ''}

        <div class="import-jobs-section">
          <h3>Your Import Jobs</h3>
          ${this.isLoading && !hasActiveJobs ? `
            <div class="loading-state">
              <div class="spinner"></div>
              <div>Loading import jobs...</div>
            </div>
          ` : this.jobs.length === 0 ? `
            <p class="empty-state">No import jobs found. Start one above!</p>
          ` : `
            <ul class="job-list">
              ${this.jobs.map((job)=>`
                <li class="job-item">
                  <div class="job-details">
                    <span class="job-id">#${job.id}</span>
                    <span class="job-status status-${job.status}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(job.status)}</span>
                    <span class="job-created-at">${new Date(job.createdAt).toLocaleString()}</span>
                  </div>
                  <div class="job-progress">
                    <span class="progress-text">Posts: ${job.postsImported} | Friends: ${job.friendsFound}</span>
                    ${job.status === 'processing' ? '<span class="spinner spinner-small"></span>' : ''}
                  </div>
                  ${job.errorMessage ? `<div class="job-error">Error: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(job.errorMessage)}</div>` : ''}
                  <div class="job-actions">
                    <button class="btn btn-sm btn-danger delete-job-btn" data-job-id="${job.id}"
                            ${job.status === 'processing' ? 'disabled' : ''}>
                      Delete
                    </button>
                  </div>
                </li>
              `).join('')}
            </ul>
          `}
        </div>

        <div class="settings-footer">
          <button class="btn btn-secondary" id="returnToSettingsBtn">
            \u{2190} Return to Settings
          </button>
        </div>
      </div>
    `;
    }
}
customElements.define('facebook-import', $110dc075982d1144$var$FacebookImport);


// Friend Requests Web Component

class $d7201df562bd5082$var$FriendRequests extends HTMLElement {
    constructor(){
        super();
        this.receivedRequests = [];
        this.sentRequests = [];
        this.pendingInvitations = [];
        this.isLoading = true;
        this.currentUser = null;
        this.documentListenersAttached = false;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.attachDocumentListeners();
        this.loadRequests();
    }
    render() {
        this.innerHTML = `
      <div class="friend-requests">
        <div class="requests-header">
          <h3>\u{1F44B} Friend Requests</h3>
          <button class="btn btn-sm btn-outline refresh-btn" id="refreshBtn">
            \u{1F504} Refresh
          </button>
        </div>

        <div class="requests-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading friend requests...</p>
        </div>
      `;
        const hasReceivedRequests = this.receivedRequests.length > 0;
        const hasSentRequests = this.sentRequests.length > 0;
        const hasPendingInvitations = this.pendingInvitations.length > 0;
        if (!hasReceivedRequests && !hasSentRequests && !hasPendingInvitations) return `
        <div class="empty-state">
          <span class="empty-state-icon">\u{1F91D}</span>
          <h4>No friend requests</h4>
          <p>When people send you friend requests, they'll appear here!</p>
        </div>
      `;
        return `
      ${hasPendingInvitations ? `
        <div class="requests-section">
          <div class="section-title">
            \u{1F4E7} Pending Invitations
            <span class="section-count">${this.pendingInvitations.length}</span>
          </div>
          ${this.pendingInvitations.map((invitation)=>this.renderPendingInvitation(invitation)).join('')}
        </div>
      ` : ''}

      ${hasReceivedRequests ? `
        <div class="requests-section">
          <div class="section-title">
            \u{1F4E5} Received Requests
            <span class="section-count">${this.receivedRequests.length}</span>
          </div>
          ${this.receivedRequests.map((request)=>this.renderReceivedRequest(request)).join('')}
        </div>
      ` : ''}

      ${hasSentRequests ? `
        <div class="requests-section">
          <div class="section-title">
            \u{1F4E4} Sent Requests
            <span class="section-count">${this.sentRequests.length}</span>
          </div>
          ${this.sentRequests.map((request)=>this.renderSentRequest(request)).join('')}
        </div>
      ` : ''}
    `;
    }
    renderReceivedRequest(request) {
        return `
      <div class="request-item" data-request-id="${request.request_id}">
        <div class="request-info">
          <div class="avatar">
            ${request.username.charAt(0).toUpperCase()}
          </div>
          <div class="request-details">
            <h4>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(request.username)}</h4>
            <p>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(request.email)}</p>
            <div class="request-date">${this.formatDate(request.request_date)}</div>
          </div>
        </div>
        <div class="request-actions">
          <button 
            class="action-btn accept-btn" 
            data-request-id="${request.request_id}"
            data-action="accept"
          >
            <span>\u{2705}</span>
            Accept
          </button>
          <button 
            class="action-btn decline-btn" 
            data-request-id="${request.request_id}"
            data-action="decline"
          >
            <span>\u{274C}</span>
            Decline
          </button>
        </div>
      </div>
    `;
    }
    renderSentRequest(request) {
        return `
      <div class="request-item" data-request-id="${request.request_id}">
        <div class="request-info">
          <div class="avatar">
            ${request.username.charAt(0).toUpperCase()}
          </div>
          <div class="request-details">
            <h4>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(request.username)}</h4>
            <p>Request pending...</p>
            <div class="request-date">Sent ${this.formatDate(request.request_date)}</div>
          </div>
        </div>
        <div class="request-actions">
          <span style="color: var(--text-muted); font-size: 0.875rem;">\u{23F3} Waiting for response</span>
        </div>
      </div>
    `;
    }
    renderPendingInvitation(invitation) {
        return `
      <div class="request-item" data-invitation-id="${invitation.invitation_id}">
        <div class="request-info">
          <div class="avatar">
            ${invitation.inviter_username.charAt(0).toUpperCase()}
          </div>
          <div class="request-details">
            <h4>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(invitation.inviter_username)}</h4>
            <p>wants to be friends</p>
            <div class="request-date">Requested ${this.formatDate(invitation.invitation_date)}</div>
          </div>
        </div>
        <div class="request-actions">
          <button 
            class="action-btn accept-btn" 
            data-invitation-id="${invitation.invitation_id}"
            data-action="accept-invitation"
          >
            <span>\u{2705}</span>
            Accept
          </button>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Refresh button
        const refreshBtn = this.querySelector('#refreshBtn');
        refreshBtn?.addEventListener('click', ()=>{
            this.loadRequests();
        });
    // Action buttons - use event delegation on the component itself
    // Note: We don't re-add this listener multiple times because
    // we only add it once per component instance
    }
    attachDocumentListeners() {
        // Only attach document-level listeners once
        if (this.documentListenersAttached) return;
        this.documentListenersAttached = true;
        // Action buttons - use event delegation
        this.addEventListener('click', (e)=>{
            if (e.target.closest('.action-btn')) {
                const btn = e.target.closest('.action-btn');
                const requestId = btn.dataset.requestId;
                const invitationId = btn.dataset.invitationId;
                const action = btn.dataset.action;
                if (action === 'accept') this.acceptRequest(requestId, btn);
                else if (action === 'decline') this.declineRequest(requestId, btn);
                else if (action === 'accept-invitation') this.acceptInvitation(invitationId, btn);
            }
        });
        // Listen for friend request events
        document.addEventListener('friend-request-sent', ()=>{
            // Refresh to show new sent request
            setTimeout(()=>this.loadRequests(), 500);
        });
        // Listen for invitation events
        document.addEventListener('invitation-sent', ()=>{
            // Refresh to show new invitation or friend request
            setTimeout(()=>this.loadRequests(), 500);
        });
    }
    async loadRequests() {
        this.isLoading = true;
        this.updateContent();
        try {
            const response = await window.API.request('/friends');
            this.receivedRequests = response.receivedRequests || [];
            this.sentRequests = response.sentRequests || [];
            this.pendingInvitations = response.pendingInvitations || [];
            // Dispatch event with request count for tab indicator
            this.dispatchEvent(new CustomEvent('friend-requests-updated', {
                detail: {
                    receivedCount: this.receivedRequests.length,
                    sentCount: this.sentRequests.length,
                    pendingInvitationsCount: this.pendingInvitations.length
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to load friend requests:', error);
            this.receivedRequests = [];
            this.sentRequests = [];
            this.pendingInvitations = [];
            // Dispatch event with zero counts
            this.dispatchEvent(new CustomEvent('friend-requests-updated', {
                detail: {
                    receivedCount: 0,
                    sentCount: 0,
                    pendingInvitationsCount: 0
                },
                bubbles: true
            }));
        } finally{
            this.isLoading = false;
            this.updateContent();
        }
    }
    async acceptRequest(requestId, btn) {
        const originalContent = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = "<span>\u23F3</span> Accepting...";
        try {
            const response = await window.API.request(`/friends/accept/${requestId}`, {
                method: 'POST'
            });
            // Show success message
            this.showSuccess(response.message);
            // Refresh the requests (this will dispatch friend-requests-updated event)
            await this.loadRequests();
            // Dispatch event for other components
            this.dispatchEvent(new CustomEvent('friend-request-accepted', {
                detail: {
                    requestId: requestId,
                    friendship: response.friendship
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to accept friend request:', error);
            btn.disabled = false;
            btn.innerHTML = originalContent;
            this.showError(error.message || 'Failed to accept friend request');
        }
    }
    async declineRequest(requestId, btn) {
        const originalContent = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = "<span>\u23F3</span> Declining...";
        try {
            await window.API.request(`/friends/decline/${requestId}`, {
                method: 'POST'
            });
            // Refresh the requests (this will dispatch friend-requests-updated event)
            await this.loadRequests();
            // Dispatch event for other components
            this.dispatchEvent(new CustomEvent('friend-request-declined', {
                detail: {
                    requestId: requestId
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to decline friend request:', error);
            btn.disabled = false;
            btn.innerHTML = originalContent;
            this.showError(error.message || 'Failed to decline friend request');
        }
    }
    async acceptInvitation(invitationId, btn) {
        const originalContent = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = "<span>\u23F3</span> Accepting...";
        try {
            const response = await window.API.request(`/friends/accept-invitation/${invitationId}`, {
                method: 'POST'
            });
            // Show success message
            this.showSuccess(response.message);
            // Refresh the requests
            await this.loadRequests();
            // Dispatch event for other components
            this.dispatchEvent(new CustomEvent('invitation-accepted', {
                detail: {
                    invitationId: invitationId,
                    friendship: response.friendship
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to accept invitation:', error);
            btn.disabled = false;
            btn.innerHTML = originalContent;
            this.showError(error.message || 'Failed to accept invitation');
        }
    }
    updateContent() {
        this.render();
        const contentContainer = this.querySelector('.requests-content');
        if (contentContainer) this.attachEventListeners();
    }
    formatDate(dateString) {
        const date = new Date(dateString);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return 'Just now';
        else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes}m ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours}h ago`;
        } else {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days}d ago`;
        }
    }
    showSuccess(message) {
        const successDiv = document.createElement('div');
        successDiv.className = 'alert alert-success';
        successDiv.textContent = message;
        successDiv.style.position = 'fixed';
        successDiv.style.top = '20px';
        successDiv.style.right = '20px';
        successDiv.style.zIndex = '10000';
        successDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(successDiv);
        setTimeout(()=>successDiv.remove(), 4000);
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10000';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
    // Public method to refresh requests
    refresh() {
        this.loadRequests();
    }
}
// Register the custom element
customElements.define('friend-requests', $d7201df562bd5082$var$FriendRequests);


// Friends List Web Component


class $0258c8495880a5ca$var$FriendsList extends HTMLElement {
    constructor(){
        super();
        this.friends = [];
        this.isLoading = true;
        this.currentUser = null;
        this.isLoadingFriends = false; // Prevent multiple simultaneous calls
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.loadFriends();
    }
    disconnectedCallback() {
        // Remove event listeners when component is removed
        if (this.handleSectionShown) document.removeEventListener('section-shown', this.handleSectionShown);
    }
    isVisible() {
        // Check if the parent friends-section is visible
        const friendsSection = document.getElementById('friends-section');
        const sectionVisible = friendsSection && !friendsSection.classList.contains('hidden');
        return sectionVisible;
    }
    render() {
        this.innerHTML = `
      <div class="card friends-list">
        <div class="friends-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83C\uDFAA", 'Your Friends', 'h3')}
          <div class="header-actions">
            <button class="btn-icon refresh-btn" id="refreshBtn" title="Refresh">
              \u{1F504}
            </button>
          </div>
        </div>

        <div class="friends-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading your friends...</p>
        </div>
      `;
        if (this.friends.length === 0) return `
        <div class="empty-state">
          <span class="empty-state-icon">\u{1F3AA}</span>
          <h4>No friends yet</h4>
          <p>When people accept your friend requests, they'll appear here!</p>
        </div>
      `;
        return `
      <div class="friends-grid">
        ${this.friends.map((friend, index)=>`
          <div class="friend-item" data-friend-id="${friend.id}" style="animation-delay: ${index * 0.1}s">
            <div class="friend-info">
              <div class="avatar">
                ${friend.username.charAt(0).toUpperCase()}
              </div>
              <div class="friend-details">
                <h4><a href="/profile/${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(friend.username)}" class="friend-link">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(friend.username)}</a></h4>
                <p>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(friend.email)}</p>
                <div class="friendship-date">
                  Friends since ${this.formatDate(friend.friendship_date)}
                </div>
              </div>
            </div>
            <div class="friend-actions">
              <div class="friend-status">
                \u{2705} Friends
              </div>
              <button 
                class="remove-friend-btn" 
                data-friend-id="${friend.id}"
                data-username="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(friend.username)}"
                title="Remove friend"
              >
                Remove
              </button>
            </div>
          </div>
        `).join('')}
      </div>
    `;
    }
    attachEventListeners() {
        // Listen for section shown events to load friends when Friends section is displayed
        this.handleSectionShown = (event)=>{
            if (event.detail.section === 'friends') // Only load friends if we have a current user and API is available
            {
                if (this.currentUser && window.API && this.isAuthenticated()) this.loadFriends();
            }
        };
        document.addEventListener('section-shown', this.handleSectionShown);
        // Refresh button
        const refreshBtn = this.querySelector('#refreshBtn');
        refreshBtn?.addEventListener('click', ()=>{
            this.loadFriends();
        });
        // Remove friend buttons
        this.addEventListener('click', (e)=>{
            if (e.target.closest('.remove-friend-btn')) {
                const btn = e.target.closest('.remove-friend-btn');
                const friendId = btn.dataset.friendId;
                const username = btn.dataset.username;
                this.removeFriend(friendId, username, btn);
            }
        });
        // Listen for friend request events
        document.addEventListener('friend-request-accepted', ()=>{
            // Refresh friends list when a request is accepted
            setTimeout(()=>this.loadFriends(), 500);
        });
    }
    async loadFriends() {
        // Prevent multiple simultaneous calls
        if (this.isLoadingFriends) return;
        // Only load if component is visible
        if (!this.isVisible()) return;
        this.isLoadingFriends = true;
        this.isLoading = true;
        this.updateContent();
        try {
            const response = await window.API.request('/friends');
            this.friends = response.friends || [];
            // Update header with count
            this.updateFriendsCount();
        } catch (error) {
            window.logger.error('Failed to load friends', error, {
                component: 'friends-list'
            });
            this.friends = [];
            this.showError('Failed to load friends');
        } finally{
            this.isLoading = false;
            this.isLoadingFriends = false;
            this.updateContent();
        }
    }
    async removeFriend(friendId, username, btn) {
        if (!confirm(`Are you sure you want to remove ${username} as a friend? \u{1F622}`)) return;
        const originalContent = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = "\u23F3 Removing...";
        try {
            await window.API.request(`/friends/${friendId}`, {
                method: 'DELETE'
            });
            // Show success message
            this.showSuccess(`${username} has been removed from your friends list`);
            // Remove from local array
            this.friends = this.friends.filter((friend)=>friend.id !== parseInt(friendId));
            // Update display
            this.updateContent();
            this.updateFriendsCount();
            // Dispatch event
            this.dispatchEvent(new CustomEvent('friend-removed', {
                detail: {
                    friendId: friendId,
                    username: username
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to remove friend', error, {
                component: 'friends-list',
                friendId: friendId
            });
            btn.disabled = false;
            btn.innerHTML = originalContent;
            this.showError(error.message || 'Failed to remove friend');
        }
    }
    updateContent() {
        const contentContainer = this.querySelector('.friends-content');
        if (contentContainer) {
            contentContainer.innerHTML = this.renderContent();
            this.attachEventListeners();
        }
    }
    updateFriendsCount() {
        const header = this.querySelector('.friends-header h3');
        if (header) {
            const countSpan = header.querySelector('.friends-count');
            if (countSpan) countSpan.textContent = this.friends.length;
            else if (this.friends.length > 0) header.outerHTML = (0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83C\uDFAA", `Your Friends <span class="friends-count">${this.friends.length}</span>`, 'h3');
            else header.outerHTML = (0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83C\uDFAA", 'Your Friends', 'h3');
        }
    }
    formatDate(dateString) {
        const date = new Date(dateString);
        const now = new Date();
        const diffInDays = Math.floor((now - date) / 86400000);
        if (diffInDays === 0) return 'today';
        else if (diffInDays === 1) return 'yesterday';
        else if (diffInDays < 7) return `${diffInDays} days ago`;
        else if (diffInDays < 30) {
            const weeks = Math.floor(diffInDays / 7);
            return `${weeks} week${weeks > 1 ? 's' : ''} ago`;
        } else if (diffInDays < 365) {
            const months = Math.floor(diffInDays / 30);
            return `${months} month${months > 1 ? 's' : ''} ago`;
        } else return date.toLocaleDateString();
    }
    showSuccess(message) {
        const successDiv = document.createElement('div');
        successDiv.className = 'alert alert-success';
        successDiv.textContent = message;
        successDiv.style.position = 'fixed';
        successDiv.style.top = '20px';
        successDiv.style.right = '20px';
        successDiv.style.zIndex = '10000';
        successDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(successDiv);
        setTimeout(()=>successDiv.remove(), 4000);
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10000';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
    // Public method to refresh friends
    refresh() {
        this.loadFriends();
    }
    // Public method to add a friend (when request is accepted)
    addFriend(friend) {
        if (!this.friends.find((f)=>f.id === friend.id)) {
            this.friends.push(friend);
            this.updateContent();
            this.updateFriendsCount();
        }
    }
    isAuthenticated() {
        return this.currentUser !== null;
    }
    // Public method to remove a friend
    removeFriendById(friendId) {
        this.friends = this.friends.filter((friend)=>friend.id !== parseInt(friendId));
        this.updateContent();
        this.updateFriendsCount();
    }
    // Open the invite friend modal
    openInviteModal() {
        let inviteModal = document.querySelector('invite-friend-modal');
        if (!inviteModal) {
            inviteModal = document.createElement('invite-friend-modal');
            document.body.appendChild(inviteModal);
        }
        inviteModal.open();
    }
}
// Register the custom element
customElements.define('friends-list', $0258c8495880a5ca$var$FriendsList);



/**
 * Google Photos Picker Integration
 * Handles Google Photos selection using the Google Photos Picker API
 * https://developers.google.com/photos/picker/guides/get-started-picker
 */ 
async function $c9548aa4bfe9f9fa$export$d5873a3c7faa463a(component, provider, accountIdentifier) {
    try {
        const accountInfo = component.pendingPickerAccount;
        // Step 1: Get access token from backend
        const accessToken = await (0, $6ad04eae6c100a40$export$84773cc9bf7dbe87)(provider, accountIdentifier);
        if (!accessToken) throw new Error('No access token received from server');
        window.logger?.info('Creating Google Photos picker session', {
            provider: provider,
            accountIdentifier: accountIdentifier,
            hasAccessToken: !!accessToken
        });
        // Step 2: Create a picker session directly with Google Photos Picker API
        const apiUrl = 'https://photospicker.googleapis.com/v1/sessions';
        const sessionResponse = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({})
        });
        if (!sessionResponse.ok) {
            const errorText = await sessionResponse.text();
            window.logger?.error('Failed to create Google Photos picker session', {
                status: sessionResponse.status,
                statusText: sessionResponse.statusText,
                error: errorText
            });
            throw new Error(`Failed to create picker session: ${sessionResponse.status} ${sessionResponse.statusText}`);
        }
        const sessionData = await sessionResponse.json();
        // The API returns 'id' not 'sessionId'
        const sessionId = sessionData.id;
        const pickerUri = sessionData.pickerUri;
        if (!sessionId) {
            window.logger?.error('Session ID is missing from response', {
                sessionData: sessionData
            });
            throw new Error('Session ID not found in picker session response');
        }
        if (!pickerUri) {
            window.logger?.error('Picker URI is missing from response', {
                sessionData: sessionData
            });
            throw new Error('Picker URI not found in picker session response');
        }
        window.logger?.debug('Google Photos picker session created', {
            sessionId: sessionId,
            pickerUri: pickerUri
        });
        // Step 3: Open the picker URI (append /autoclose for web)
        const pickerUrl = `${pickerUri}/autoclose`;
        const pickerWindow = window.open(pickerUrl, 'Google Photos Picker', 'width=800,height=600');
        if (!pickerWindow) throw new Error('Failed to open picker window. Please allow popups for this site.');
        // Step 4: Poll the session until mediaItemsSet is true
        // Capture sessionId in a const to ensure it's available in closure
        const capturedSessionId = sessionId;
        const pollSession = async ()=>{
            try {
                if (!capturedSessionId) {
                    window.logger?.error('Session ID is undefined when polling', {
                        sessionId: sessionId,
                        capturedSessionId: capturedSessionId
                    });
                    throw new Error('Session ID is not available');
                }
                const statusResponse = await fetch(`https://photospicker.googleapis.com/v1/sessions/${capturedSessionId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (!statusResponse.ok) {
                    const errorText = await statusResponse.text();
                    window.logger?.error('Failed to poll Google Photos picker session', {
                        status: statusResponse.status,
                        error: errorText
                    });
                    throw new Error(`Failed to poll session status: ${statusResponse.status}`);
                }
                const statusData = await statusResponse.json();
                // Parse polling interval from response (format: "5s" -> 5000ms)
                const parsePollInterval = (intervalStr)=>{
                    if (!intervalStr) return 1000; // Default to 1 second
                    const match = intervalStr.match(/(\d+)([sm])/);
                    if (match) {
                        const value = parseInt(match[1], 10);
                        const unit = match[2];
                        return unit === 's' ? value * 1000 : value; // Convert seconds to milliseconds
                    }
                    return 1000; // Default fallback
                };
                if (statusData.mediaItemsSet) {
                    // Step 5: Media items are selected, fetch them directly from Google Photos Picker API
                    window.logger?.debug('Media items selected, fetching list', {
                        sessionId: capturedSessionId
                    });
                    // Try the mediaItems endpoint - if this returns 404, the endpoint path might be wrong
                    const mediaItemsUrl = `https://photospicker.googleapis.com/v1/mediaItems?sessionId=${capturedSessionId}`;
                    window.logger?.debug('Fetching media items from', {
                        url: mediaItemsUrl
                    });
                    const itemsResponse = await fetch(mediaItemsUrl, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${accessToken}`
                        }
                    });
                    if (!itemsResponse.ok) {
                        const errorText = await itemsResponse.text();
                        window.logger?.error('Failed to fetch Google Photos picker media items', {
                            status: itemsResponse.status,
                            statusText: itemsResponse.statusText,
                            error: errorText,
                            url: mediaItemsUrl
                        });
                        throw new Error(`Failed to fetch selected media items: ${itemsResponse.status} ${itemsResponse.statusText}`);
                    }
                    const itemsData = await itemsResponse.json();
                    window.logger?.debug('Media items response', {
                        itemsData: itemsData
                    });
                    // Step 6: Transform media items to our internal format
                    const files = (itemsData.mediaItems || []).map((item)=>({
                            provider: 'google-photos',
                            accountId: accountIdentifier,
                            fileId: item.id,
                            fileUrl: `oauth://google-photos/${accountIdentifier}/${item.id}`,
                            fileName: item.filename || item.description || 'Photo',
                            mimeType: item.mimeType || 'image/jpeg',
                            thumbnailUrl: item.baseUrl ? `${item.baseUrl}=w200-h200` : null,
                            originalImageUrl: item.baseUrl || null
                        }));
                    // Step 7: Handle selected files
                    component.currentAccount = accountInfo;
                    try {
                        $c9548aa4bfe9f9fa$export$5e832b79f31d168b(component, {
                            files: files
                        });
                    } finally{
                        component.currentAccount = null;
                        component.pendingPickerAccount = null;
                    }
                    // Close picker window if still open
                    if (pickerWindow && !pickerWindow.closed) pickerWindow.close();
                    // Reset guard
                    component.isOpeningPicker = false;
                } else {
                    // Continue polling using the interval from pollingConfig
                    const pollInterval = statusData.pollingConfig?.pollInterval ? parsePollInterval(statusData.pollingConfig.pollInterval) : 1000; // Default to 1 second
                    setTimeout(pollSession, pollInterval);
                }
            } catch (error) {
                window.logger?.error('Error polling Google Photos picker session:', error);
                component.showError(error.message || 'Failed to check picker status. Please try again.');
                if (pickerWindow && !pickerWindow.closed) pickerWindow.close();
                component.isOpeningPicker = false;
            }
        };
        // Start polling after a short delay
        setTimeout(pollSession, 1000);
        // Also check if window was closed manually
        const checkWindowClosed = setInterval(()=>{
            if (pickerWindow.closed) {
                clearInterval(checkWindowClosed);
                window.logger?.debug('Picker window closed by user');
                component.isOpeningPicker = false;
                component.pendingPickerAccount = null;
            }
        }, 500);
    // Reset guard after picker window is opened
    // Note: isOpeningPicker will be reset when polling completes or window closes
    } catch (error) {
        window.logger?.error('Error opening Google Photos picker: ' + error);
        component.showError(error.message || 'Failed to open Google Photos picker. Please try again.');
        // Reset guard on error
        component.isOpeningPicker = false;
    }
}
function $c9548aa4bfe9f9fa$export$5e832b79f31d168b(component, data) {
    if (data.files && Array.isArray(data.files) && data.files.length > 0) {
        // Files are already in the correct format from the backend
        const files = data.files.map((file)=>({
                provider: file.provider || component.currentAccount?.provider,
                accountId: file.accountId || component.currentAccount?.accountIdentifier,
                fileId: file.fileId,
                fileUrl: file.fileUrl,
                fileName: file.fileName || 'Photo',
                mimeType: file.mimeType,
                thumbnailUrl: file.thumbnailUrl,
                originalImageUrl: file.originalImageUrl
            }));
        // Dispatch files-selected event with textarea reference
        component.dispatchEvent(new CustomEvent('files-selected', {
            detail: {
                files: files,
                textarea: component._targetTextarea || null
            },
            bubbles: true
        }));
        // Close picker modal
        component.close();
    } else window.logger?.warn('Google Photos picker callback received no files', data);
}



const $b94c94f396d640d5$var$STORAGE_KEY = 'add-group-cta-dismissed';
/**
 * Invite users to create a group (mirrors add-friend-cta playful banner).
 */ class $b94c94f396d640d5$var$AddGroupCTA extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.isDismissed = false;
    }
    connectedCallback() {
        super.connectedCallback();
        try {
            this.isDismissed = localStorage.getItem($b94c94f396d640d5$var$STORAGE_KEY) === 'true';
        } catch (_e) {
            this.isDismissed = false;
        }
        if (this.currentUser && !this.isDismissed) {
            this.render();
            this.attachEventListeners();
        }
        this.handleRoute = ()=>{
            if (!this.currentUser || this.isDismissed) return;
            this.render();
            this.attachEventListeners();
        };
        document.addEventListener('route-changed', this.handleRoute);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('route-changed', this.handleRoute);
    }
    setCurrentUser(user) {
        super.setCurrentUser(user);
        if (user && !this.isDismissed) {
            this.render();
            this.attachEventListeners();
        } else if (!user) this.innerHTML = '';
    }
    attachEventListeners() {
        const dismiss = this.querySelector('[data-dismiss-cta]');
        if (dismiss) dismiss.addEventListener('click', ()=>{
            try {
                localStorage.setItem($b94c94f396d640d5$var$STORAGE_KEY, 'true');
            } catch (_e) {}
            this.isDismissed = true;
            this.innerHTML = '';
        });
        const open = this.querySelector('[data-open-create-group]');
        if (open) open.addEventListener('click', ()=>{
            if (window.router?.navigate) window.router.navigate('/groups/new');
            else window.location.href = '/groups/new';
        });
    }
    render() {
        if (!this.currentUser || this.isDismissed) return;
        this.innerHTML = `
      <section class="add-group-cta" aria-label="Create a group">
        <button type="button" class="add-group-cta-dismiss" data-dismiss-cta aria-label="Dismiss">&times;</button>
        <div class="add-group-cta-inner">
          <span class="add-group-cta-mascot" aria-hidden="true">\u{1F331}</span>
          <div class="add-group-cta-text">
            <h2 class="add-group-cta-title">Plant a little community</h2>
            <p class="add-group-cta-desc">Start a group for your garden club, game night crew, or neighborhood pals.</p>
            <button type="button" class="btn btn-primary add-group-cta-btn" data-open-create-group>
              Create a group
            </button>
          </div>
        </div>
      </section>
    `;
    }
}
customElements.define('add-group-cta', $b94c94f396d640d5$var$AddGroupCTA);
var $b94c94f396d640d5$export$2e2bcd8739ae039 = $b94c94f396d640d5$var$AddGroupCTA;




var $eZQHH = parcelRequire("eZQHH");

/**
 * Stack of contextual navigation "layers" rendered inside <taco-menu>.
 * Consumers push/pop/update; taco-menu subscribes via context-nav-stack-changed.
 * No work on import beyond defining functions.
 */ const $22b79cf8d2430b20$export$3e92770d2d7e52b6 = 'context-nav-stack-changed';
/** @typedef {{ href: string, label: string, icon?: string, badge?: string|null, dataRoute?: string, kind?: 'link'|'heading', indent?: boolean }} ContextNavItem */ /** @typedef {{
 *   ownerId: string,
 *   id: string,
 *   title: string,
 *   subtitle?: string|null,
 *   items: ContextNavItem[],
 * }} ContextNavLayerSpec */ /** @type {ContextNavLayerSpec[]} */ let $22b79cf8d2430b20$var$layers = [];
function $22b79cf8d2430b20$export$6f13e3ae52f71c30() {
    return $22b79cf8d2430b20$var$layers.length;
}
function $22b79cf8d2430b20$export$b4c4ef0686a8a0f8() {
    return $22b79cf8d2430b20$var$layers.slice();
}
function $22b79cf8d2430b20$var$normalizeLayer(spec) {
    return {
        ownerId: String(spec.ownerId),
        id: String(spec.id),
        title: spec.title === null || spec.title === undefined ? '' : String(spec.title),
        subtitle: spec.subtitle === null || spec.subtitle === undefined || spec.subtitle === '' ? null : String(spec.subtitle),
        items: Array.isArray(spec.items) ? spec.items : []
    };
}
function $22b79cf8d2430b20$var$notify() {
    document.dispatchEvent(new CustomEvent($22b79cf8d2430b20$export$3e92770d2d7e52b6, {
        bubbles: true,
        detail: {
            depth: $22b79cf8d2430b20$var$layers.length,
            layersSummary: $22b79cf8d2430b20$var$layers.map((l)=>({
                    ownerId: l.ownerId,
                    id: l.id,
                    title: l.title
                }))
        }
    }));
}
function $22b79cf8d2430b20$export$3ebbceb0577223e2(spec) {
    const layer = $22b79cf8d2430b20$var$normalizeLayer(spec);
    const idx = $22b79cf8d2430b20$var$layers.findIndex((l)=>l.ownerId === layer.ownerId && l.id === layer.id);
    if (idx >= 0) $22b79cf8d2430b20$var$layers[idx] = layer;
    else $22b79cf8d2430b20$var$layers.push(layer);
    $22b79cf8d2430b20$var$notify();
}
function $22b79cf8d2430b20$export$17d4598b7b45aac2(ownerId, id = null) {
    if (!$22b79cf8d2430b20$var$layers.length) return false;
    if (id !== null && id !== undefined) {
        const i = $22b79cf8d2430b20$var$layers.findIndex((l)=>l.ownerId === ownerId && l.id === id);
        if (i < 0) return false;
        $22b79cf8d2430b20$var$layers.splice(i, 1);
        $22b79cf8d2430b20$var$notify();
        return true;
    }
    const top = $22b79cf8d2430b20$var$layers[$22b79cf8d2430b20$var$layers.length - 1];
    if (top.ownerId !== ownerId) return false;
    $22b79cf8d2430b20$var$layers.pop();
    $22b79cf8d2430b20$var$notify();
    return true;
}
function $22b79cf8d2430b20$export$c56185e4b7d20e85() {
    if (!$22b79cf8d2430b20$var$layers.length) return false;
    $22b79cf8d2430b20$var$layers.pop();
    $22b79cf8d2430b20$var$notify();
    return true;
}
function $22b79cf8d2430b20$export$221f49138a76d01(ownerId) {
    const before = $22b79cf8d2430b20$var$layers.length;
    $22b79cf8d2430b20$var$layers = $22b79cf8d2430b20$var$layers.filter((l)=>l.ownerId !== ownerId);
    if ($22b79cf8d2430b20$var$layers.length !== before) {
        $22b79cf8d2430b20$var$notify();
        return true;
    }
    return false;
}
function $22b79cf8d2430b20$export$ba4ee88ef1f9f1c6(ownerId, id, patch) {
    const layer = $22b79cf8d2430b20$var$layers.find((l)=>l.ownerId === ownerId && l.id === id);
    if (!layer) return false;
    if (patch.title !== null && patch.title !== undefined) layer.title = String(patch.title);
    if (patch.subtitle !== undefined) layer.subtitle = patch.subtitle === null || patch.subtitle === undefined || patch.subtitle === '' ? null : String(patch.subtitle);
    if (patch.items !== null && patch.items !== undefined) layer.items = Array.isArray(patch.items) ? patch.items : [];
    $22b79cf8d2430b20$var$notify();
    return true;
}
function $22b79cf8d2430b20$export$3f0bc97cf30028ce(spec) {
    if (!$22b79cf8d2430b20$var$layers.length) {
        $22b79cf8d2430b20$export$3ebbceb0577223e2(spec);
        return true;
    }
    const layer = $22b79cf8d2430b20$var$normalizeLayer(spec);
    $22b79cf8d2430b20$var$layers[$22b79cf8d2430b20$var$layers.length - 1] = layer;
    $22b79cf8d2430b20$var$notify();
    return true;
}
function $22b79cf8d2430b20$export$7c0b41a63515e17f() {
    if (!$22b79cf8d2430b20$var$layers.length) return;
    $22b79cf8d2430b20$var$layers = [];
    $22b79cf8d2430b20$var$notify();
}
function $22b79cf8d2430b20$export$c64f546521fe1e9b(listener) {
    const handler = ()=>{
        listener($22b79cf8d2430b20$var$layers.slice());
    };
    document.addEventListener($22b79cf8d2430b20$export$3e92770d2d7e52b6, handler);
    return ()=>document.removeEventListener($22b79cf8d2430b20$export$3e92770d2d7e52b6, handler);
}


const $45c433acd12a8113$export$62296c0d1f0c37bf = 'groups';
const $45c433acd12a8113$var$LAYER_ID = 'group-shell';
function $45c433acd12a8113$export$b25062376eaaf9ed() {
    (0, $22b79cf8d2430b20$export$221f49138a76d01)($45c433acd12a8113$export$62296c0d1f0c37bf);
}
function $45c433acd12a8113$export$b19f449e5f91b32b({ groupId: groupId, groupName: groupName, threads: threads = [] }) {
    const base = `/groups/${groupId}`;
    const name = groupName || 'Group';
    return [
        {
            href: '/',
            label: "\uD83C\uDFE0 Home feed",
            dataRoute: '/'
        },
        {
            href: '/groups',
            label: "\uD83C\uDF31 All groups",
            dataRoute: '/groups'
        },
        {
            kind: 'heading',
            label: name
        },
        {
            href: base,
            label: "\uD83D\uDCF0 Main feed",
            dataRoute: base,
            indent: true
        },
        ...threads.map((t)=>({
                href: `${base}/threads/${t.id}`,
                label: (0, $605b34b4fa47af77$export$ed41c87da8cb7bf4)(t.name),
                dataRoute: `${base}/threads/${t.id}`,
                indent: true
            }))
    ];
}
function $45c433acd12a8113$export$10f673ac6984c3ef({ groupId: groupId, groupName: groupName, roleLabel: roleLabel = null, threads: threads = [] }) {
    (0, $22b79cf8d2430b20$export$3ebbceb0577223e2)({
        ownerId: $45c433acd12a8113$export$62296c0d1f0c37bf,
        id: $45c433acd12a8113$var$LAYER_ID,
        title: '',
        subtitle: roleLabel || null,
        items: $45c433acd12a8113$export$b19f449e5f91b32b({
            groupId: groupId,
            groupName: groupName,
            threads: threads
        })
    });
}
function $45c433acd12a8113$export$e75e12e8a369fec7(groupId, groupName, roleLabel, threads) {
    (0, $22b79cf8d2430b20$export$ba4ee88ef1f9f1c6)($45c433acd12a8113$export$62296c0d1f0c37bf, $45c433acd12a8113$var$LAYER_ID, {
        title: '',
        subtitle: roleLabel || null,
        items: $45c433acd12a8113$export$b19f449e5f91b32b({
            groupId: groupId,
            groupName: groupName,
            threads: threads
        })
    });
}



/**
 * /groups — list memberships, cards with optional upcoming events.
 */ class $1761983801a0603e$var$GroupsHub extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.groups = [];
        this.archivedGroups = [];
        this.pendingInvites = [];
        this.error = null;
        this.loading = true;
        this.showArchived = false;
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $45c433acd12a8113$export$b25062376eaaf9ed)();
        this.load();
    }
    navigateToCreate() {
        if (window.router?.navigate) window.router.navigate('/groups/new');
        else window.location.href = '/groups/new';
    }
    async load() {
        if (!window.API || !this.currentUser) return;
        this.loading = true;
        this.render();
        try {
            const eventsQuery = this.showArchived ? '' : '?include_upcoming_events=1';
            const requests = [
                window.API.request(`/groups${eventsQuery}`)
            ];
            if (!this.showArchived) requests.push(window.API.request('/groups/invites/mine'));
            const results = await Promise.all(requests);
            this.groups = results[0].groups || [];
            this.pendingInvites = this.showArchived ? [] : results[1]?.invites || [];
            this.error = null;
        } catch (e) {
            this.error = e.message || 'Could not load groups';
            (0, $eZQHH.default).warn('GroupsHub load failed', e);
        } finally{
            this.loading = false;
            this.render();
        }
    }
    async loadArchivedGroups() {
        if (!window.API || !this.currentUser) return;
        try {
            const data = await window.API.request('/groups?archived_only=1');
            this.archivedGroups = data.groups || [];
        } catch (e) {
            (0, $eZQHH.default).warn('GroupsHub archived load failed', e);
            this.archivedGroups = [];
        }
        this.render();
    }
    render() {
        if (!this.currentUser) {
            this.innerHTML = '';
            return;
        }
        if (this.loading) {
            this.innerHTML = `
        <div class="groups-container">
          <div class="loading">Loading groups...</div>
        </div>
      `;
            return;
        }
        const showCta = !this.showArchived && this.groups.length > 0;
        this.innerHTML = `
      <div class="groups-container">
        ${showCta ? '<add-group-cta></add-group-cta>' : ''}

        <div class="groups-header">
          <h1>My Groups</h1>
          <div class="header-actions">
            <button type="button" class="btn-create-group" id="createGroupBtn">
              \u{1F331} Create Group
            </button>
          </div>
        </div>

        <toolbar-action-bar label="Filters">
          <div slot="actions" class="toggle-actions">
            <label class="toggle-checkbox-label icon-only" title="Show archived groups">
              <span class="toggle-icon">\u{1F5D1}\u{FE0F}</span>
              <input type="checkbox" class="toggle-checkbox" id="showArchivedCheckbox" ${this.showArchived ? 'checked' : ''}>
              <span class="toggle-checkbox-custom"></span>
            </label>
          </div>
        </toolbar-action-bar>

        <div id="groupsHubError">
          ${this.error ? `<p class="error">${this.escapeHtml(this.error)}</p>` : ''}
        </div>

        ${this.renderPendingInvites()}

        ${this.renderBody()}
      </div>
    `;
        const cta = this.querySelector('add-group-cta');
        if (cta && typeof cta.setCurrentUser === 'function') cta.setCurrentUser(this.currentUser);
        this.attachEventListeners();
    }
    renderPendingInvites() {
        if (this.showArchived || !this.pendingInvites.length) return '';
        return `
      <section class="groups-hub-pending card">
        <h2 class="groups-hub-pending-title">Pending invitations</h2>
        <ul class="groups-hub-pending-list">
          ${this.pendingInvites.map((inv)=>this.renderPendingInvite(inv)).join('')}
        </ul>
      </section>
    `;
    }
    renderPendingInvite(inv) {
        const inviter = inv.inviter?.username || 'Someone';
        const groupName = inv.group?.name || 'a group';
        const token = inv.invite_token;
        return `
      <li class="groups-hub-pending-item">
        <div class="groups-hub-pending-info">
          <strong>${this.escapeHtml(inviter)}</strong>
          invited you to <strong>${this.escapeHtml(groupName)}</strong>
        </div>
        <div class="groups-hub-pending-actions">
          <a class="btn btn-secondary btn-sm" href="/groups/invites/${this.escapeHtml(token)}">View</a>
          <button type="button" class="btn btn-primary btn-sm" data-invite-accept="${this.escapeHtml(token)}">Accept</button>
          <button type="button" class="btn btn-secondary btn-sm" data-invite-decline="${this.escapeHtml(token)}">Decline</button>
        </div>
      </li>
    `;
    }
    renderBody() {
        if (this.showArchived) {
            if (!this.archivedGroups.length) return this.renderEmptyArchived();
            return `
        <div class="groups-hub-grid">
          ${this.archivedGroups.map((g)=>this.renderGroupCard(g, {
                    archived: true
                })).join('')}
        </div>
      `;
        }
        if (!this.groups.length) return this.renderEmpty();
        return `
      <div class="groups-hub-grid">
        ${this.groups.map((g)=>this.renderGroupCard(g)).join('')}
      </div>
    `;
    }
    renderEmpty() {
        return `
      <div class="empty-state">
        <div class="groups-mascot">
          ${(0, $72156d6136272719$export$54881ba96924d965)()}
        </div>
        <h2>Hi there! I'm Society Otter!</h2>
        <p class="groups-mascot-message">
          I'm SO excited to help you start your first group!
          Whether it's a book club, neighborhood pals, or your game night crew,
          we'll build a cozy little community together.
        </p>
        <p class="groups-mascot-encouragement">
          Trust me \u{2014} good groups make Fun Old Times even more fun.
          Let's gather your people! \u{1F331}
        </p>
        <button type="button" class="btn-create-group" id="createGroupBtnEmpty">
          \u{2728} Create My First Group \u{2728}
        </button>
      </div>
    `;
    }
    renderEmptyArchived() {
        return `
      <div class="empty-state">
        <div class="groups-mascot">
          ${(0, $72156d6136272719$export$54881ba96924d965)()}
        </div>
        <h2>Nothing archived here! \u{1F389}</h2>
        <p class="groups-mascot-message">
          No archived groups found. Society Otter is doing a little happy dance
          because everything is still active and swimming along nicely!
        </p>
      </div>
    `;
    }
    renderGroupCard(g, { archived: archived = false } = {}) {
        const archivedBadge = archived ? '<span class="groups-hub-card-archived">\uD83D\uDDD1\uFE0F Archived</span>' : '';
        const eventsStrip = archived ? '' : this.renderEventsStrip(g.upcoming_events);
        return `
      <button type="button"
        class="groups-hub-card${archived ? ' groups-hub-card--archived' : ''}"
        data-groups-nav="${archived ? '' : `/groups/${g.id}`}"
        ${archived ? 'disabled' : ''}>
        <div class="groups-hub-card-head">
          <h3 class="groups-hub-card-name">${this.escapeHtml(g.name)}</h3>
          ${archivedBadge}
        </div>
        <div class="groups-hub-card-role">${this.escapeHtml(g.role)}</div>
        ${g.description ? `<p class="groups-hub-card-desc">${this.escapeHtml(g.description)}</p>` : ''}
        ${eventsStrip}
      </button>
    `;
    }
    renderEventsStrip(evts) {
        if (!evts || !evts.length) return '<p class="groups-hub-events-empty">No upcoming linked events.</p>';
        const items = evts.slice(0, 3).map((e)=>{
            const when = e.start_time ? new Date(e.start_time).toLocaleString(undefined, {
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit'
            }) : '';
            const id = encodeURIComponent(String(e.id));
            return `<li><a href="/events/${id}">${when ? `${when} \xb7 ` : ''}${e.title || 'Event'}</a></li>`;
        }).join('');
        return `
      <div class="groups-hub-events">
        <h4>Upcoming</h4>
        <ul>${items}</ul>
      </div>
    `;
    }
    attachEventListeners() {
        this.querySelectorAll('#createGroupBtn, #createGroupBtnEmpty').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.navigateToCreate());
        });
        const archivedToggle = this.querySelector('#showArchivedCheckbox');
        if (archivedToggle) archivedToggle.addEventListener('change', async (ev)=>{
            this.showArchived = ev.target.checked;
            if (this.showArchived && !this.archivedGroups.length) await this.loadArchivedGroups();
            else if (!this.showArchived) await this.load();
            else this.render();
        });
        this.querySelectorAll('[data-groups-nav]').forEach((el)=>{
            const path = el.getAttribute('data-groups-nav');
            if (!path) return;
            el.addEventListener('click', (ev)=>{
                ev.preventDefault();
                if (window.router?.navigate) window.router.navigate(path);
                else window.location.href = path;
            });
        });
        this.querySelectorAll('[data-invite-accept]').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const token = btn.getAttribute('data-invite-accept');
                try {
                    const result = await window.API.request(`/groups/invites/${token}/accept`, {
                        method: 'POST'
                    });
                    if (window.router?.navigate) window.router.navigate(`/groups/${result.group_id}`);
                } catch (e) {
                    (0, $eZQHH.default).warn('Accept invite from hub failed', e);
                    this.error = e.message || 'Could not accept invitation';
                    this.render();
                }
            });
        });
        this.querySelectorAll('[data-invite-decline]').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const token = btn.getAttribute('data-invite-decline');
                try {
                    await window.API.request(`/groups/invites/${token}/decline`, {
                        method: 'POST'
                    });
                    this.pendingInvites = this.pendingInvites.filter((i)=>i.invite_token !== token);
                    this.render();
                } catch (e) {
                    (0, $eZQHH.default).warn('Decline invite from hub failed', e);
                    this.error = e.message || 'Could not decline invitation';
                    this.render();
                }
            });
        });
        this.querySelectorAll('.groups-hub-pending-actions a[href^="/groups/invites/"]').forEach((link)=>{
            link.addEventListener('click', (ev)=>{
                ev.preventDefault();
                const path = link.getAttribute('href');
                if (window.router?.navigate) window.router.navigate(path);
            });
        });
    }
    setCurrentUser(user) {
        super.setCurrentUser(user);
        if (user) this.load();
        else this.innerHTML = '';
    }
    escapeHtml(s) {
        return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
}
customElements.define('groups-hub', $1761983801a0603e$var$GroupsHub);
var $1761983801a0603e$export$2e2bcd8739ae039 = $1761983801a0603e$var$GroupsHub;




var $eZQHH = parcelRequire("eZQHH");

/**
 * @component group-create
 * @extends ProtectedComponent
 * @css group-create.css
 * @primitives card, btn-primary, btn-secondary
 *
 * /groups/new — create a new group.
 */ class $4053112f74fd1904$var$GroupCreate extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.error = null;
        this.submitting = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
        this.attachEventListeners();
    }
    setCurrentUser(user) {
        super.setCurrentUser(user);
        if (user) {
            this.render();
            this.attachEventListeners();
        } else this.innerHTML = '';
    }
    render() {
        if (!this.currentUser) {
            this.innerHTML = '';
            return;
        }
        const errorBlock = this.error ? `<div class="error-state" role="alert">${this.escapeHtml(this.error)}</div>` : '';
        this.innerHTML = `
      <div class="group-create-container">
        <div class="society-otter-helper">
          <div class="otter-avatar">
            ${(0, $72156d6136272719$export$54881ba96924d965)()}
          </div>
          <div class="otter-tip">
            <p>Let's gather your people! Pick a name and invite policy to get started. \u{1F331}</p>
          </div>
        </div>

        <div class="group-create-header">
          <button type="button" class="btn-back" id="backBtn">\u{2190} Back</button>
          <h1>Create Group</h1>
        </div>

        ${errorBlock}

        <form id="groupCreateForm" class="group-create-form card">
          <div class="form-section">
            <h2>Group Details</h2>

            <div class="form-group">
              <label class="form-label" for="groupName">Name *</label>
              <input
                type="text"
                id="groupName"
                name="name"
                class="form-control"
                maxlength="200"
                required
                placeholder="e.g., Weekly Game Night Crew"
              />
            </div>

            <div class="form-group">
              <label class="form-label" for="groupDescription">Description</label>
              <textarea
                id="groupDescription"
                name="description"
                class="form-control"
                rows="4"
                maxlength="2000"
                placeholder="What's this group about?"
              ></textarea>
            </div>

            <div class="form-group">
              <label class="form-label" for="invitePolicy">Invite policy</label>
              <select id="invitePolicy" name="invite_policy" class="form-control">
                <option value="members_allowed">Members can invite</option>
                <option value="mods_and_admins">Moderators / admins only</option>
                <option value="admins_only">Admins only</option>
              </select>
              <p class="form-text">Who can invite new members to this group.</p>
            </div>

            <div class="form-group">
              <label class="form-label" for="eventCreatePolicy">Event create policy</label>
              <select id="eventCreatePolicy" name="event_create_policy" class="form-control">
                <option value="members_allowed">Members can create events</option>
                <option value="mods_and_admins">Moderators / admins only</option>
                <option value="admins_only">Admins only</option>
              </select>
              <p class="form-text">Who can create events linked to this group.</p>
            </div>

            <div class="form-group">
              <label class="form-label" for="rssAddPolicy">RSS feed policy</label>
              <select id="rssAddPolicy" name="rss_add_policy" class="form-control">
                <option value="members_allowed">Members can add RSS feeds</option>
                <option value="mods_and_admins">Moderators / admins only</option>
                <option value="admins_only">Admins only</option>
              </select>
              <p class="form-text">Who can add external feeds that import into this group.</p>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
            <button type="submit" class="btn btn-primary" id="submitBtn" ${this.submitting ? 'disabled' : ''}>
              ${this.submitting ? 'Creating...' : 'Create Group'}
            </button>
          </div>
        </form>
      </div>
    `;
    }
    attachEventListeners() {
        const backBtn = this.querySelector('#backBtn');
        if (backBtn) backBtn.addEventListener('click', ()=>this.navigateToGroups());
        const cancelBtn = this.querySelector('#cancelBtn');
        if (cancelBtn) cancelBtn.addEventListener('click', ()=>{
            if (confirm('Are you sure you want to cancel? Your changes will be lost.')) this.navigateToGroups();
        });
        const form = this.querySelector('#groupCreateForm');
        if (form) form.addEventListener('submit', (ev)=>this.handleSubmit(ev));
    }
    navigateToGroups() {
        if (window.router?.navigate) window.router.navigate('/groups');
        else window.location.href = '/groups';
    }
    async handleSubmit(ev) {
        ev.preventDefault();
        if (this.submitting || !window.API) return;
        const form = ev.target;
        const name = form.querySelector('[name="name"]')?.value?.trim();
        const description = form.querySelector('[name="description"]')?.value?.trim() || '';
        const invite_policy = form.querySelector('[name="invite_policy"]')?.value || 'members_allowed';
        const event_create_policy = form.querySelector('[name="event_create_policy"]')?.value || 'members_allowed';
        const rss_add_policy = form.querySelector('[name="rss_add_policy"]')?.value || 'members_allowed';
        if (!name) {
            this.error = 'Group name is required';
            this.render();
            this.attachEventListeners();
            return;
        }
        this.error = null;
        this.submitting = true;
        this.render();
        this.attachEventListeners();
        try {
            const group = await window.API.request('/groups', {
                method: 'POST',
                body: JSON.stringify({
                    name: name,
                    description: description,
                    invite_policy: invite_policy,
                    event_create_policy: event_create_policy,
                    rss_add_policy: rss_add_policy
                })
            });
            const path = `/groups/${group.id}`;
            if (window.router?.navigate) window.router.navigate(path);
            else window.location.href = path;
        } catch (e) {
            (0, $eZQHH.default).warn('GroupCreate submit failed', e);
            this.error = e.message || 'Failed to create group';
            this.submitting = false;
            this.render();
            this.attachEventListeners();
        }
    }
    escapeHtml(s) {
        return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
}
customElements.define('group-create', $4053112f74fd1904$var$GroupCreate);
var $4053112f74fd1904$export$2e2bcd8739ae039 = $4053112f74fd1904$var$GroupCreate;


/**
 * @component group-shell
 * @css group-shell.css
 * @primitives toolbar-action-bar, toolbar-overflow-actions, post-writer, posts-feed
 */ 

var $eZQHH = parcelRequire("eZQHH");


var $1L1Fr = parcelRequire("1L1Fr");

const $ef48f05d8e2e06b7$export$bd81979733b14d60 = [
    'owner',
    'admin',
    'moderator',
    'member'
];
const $ef48f05d8e2e06b7$export$9197b939281d3ba5 = [
    'owner',
    'admin',
    'moderator'
];
const $ef48f05d8e2e06b7$export$36f512c5217bae6 = [
    'owner',
    'admin'
];
function $ef48f05d8e2e06b7$var$isAllowedByPolicy(policy, membership) {
    const role = membership?.role;
    if (!role || membership?.status !== 'active') return false;
    const effective = policy || 'members_allowed';
    if (effective === 'members_allowed') return $ef48f05d8e2e06b7$export$bd81979733b14d60.includes(role);
    if (effective === 'mods_and_admins') return $ef48f05d8e2e06b7$export$9197b939281d3ba5.includes(role);
    if (effective === 'admins_only') return $ef48f05d8e2e06b7$export$36f512c5217bae6.includes(role);
    return false;
}
function $ef48f05d8e2e06b7$export$3ca8ce609c5fcaa2(group, membership) {
    return $ef48f05d8e2e06b7$var$isAllowedByPolicy(group?.invite_policy, membership);
}
function $ef48f05d8e2e06b7$export$7320560051b5a26e(group, membership) {
    return $ef48f05d8e2e06b7$var$isAllowedByPolicy(group?.event_create_policy, membership);
}
function $ef48f05d8e2e06b7$export$66e3ea5dff7c210(group, membership) {
    return $ef48f05d8e2e06b7$var$isAllowedByPolicy(group?.rss_add_policy, membership);
}


const $cebb5ae4c784b72c$var$MOD_ROLES = [
    'owner',
    'admin',
    'moderator'
];
const $cebb5ae4c784b72c$var$ADMIN_BRANDING_ROLES = [
    'owner',
    'admin'
];
class $cebb5ae4c784b72c$var$GroupShell extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    static get observedAttributes() {
        return [
            'group-id',
            'thread-id',
            'initial-page'
        ];
    }
    constructor(){
        super();
        this.groupId = null;
        this.threadId = null;
        this.group = null;
        this.threads = [];
        this.error = null;
    }
    attributeChangedCallback() {
        if (!this.isConnected) return;
        this.groupId = parseInt(this.getAttribute('group-id'), 10);
        const tid = this.getAttribute('thread-id');
        this.threadId = tid && tid !== '' ? parseInt(tid, 10) : null;
        if (this.currentUser && !Number.isNaN(this.groupId)) this.refresh();
    }
    connectedCallback() {
        super.connectedCallback();
        this.groupId = parseInt(this.getAttribute('group-id'), 10);
        const tid = this.getAttribute('thread-id');
        this.threadId = tid && tid !== '' ? parseInt(tid, 10) : null;
        this.addEventListener('group-threads-changed', ()=>this.refreshThreads());
        this.addEventListener('group-settings-saved', ()=>this.refresh());
        this.refresh();
    }
    disconnectedCallback() {
        (0, $45c433acd12a8113$export$b25062376eaaf9ed)();
        super.disconnectedCallback();
    }
    setCurrentUser(user) {
        super.setCurrentUser(user);
        if (user && !Number.isNaN(this.groupId)) this.refresh();
    }
    isMod() {
        const r = this.group?.membership?.role;
        return r && $cebb5ae4c784b72c$var$MOD_ROLES.includes(r);
    }
    canBrand() {
        const r = this.group?.membership?.role;
        return r && $cebb5ae4c784b72c$var$ADMIN_BRANDING_ROLES.includes(r);
    }
    activeThreads() {
        return this.threads.filter((t)=>!t.archived_at);
    }
    async refreshThreads() {
        if (!window.API || !this.currentUser || Number.isNaN(this.groupId)) return;
        try {
            const threadsUrl = this.isMod() ? `/groups/${this.groupId}/threads?include_archived=true` : `/groups/${this.groupId}/threads`;
            const threadsData = await window.API.request(threadsUrl);
            this.threads = threadsData.threads || [];
            const roleLabel = this.group.membership?.role ? `You: ${this.group.membership.role}` : null;
            (0, $45c433acd12a8113$export$10f673ac6984c3ef)({
                groupId: this.groupId,
                groupName: this.group.name,
                roleLabel: roleLabel,
                threads: this.activeThreads()
            });
            const writer = this.querySelector('post-writer');
            if (writer && typeof writer.setGroupThreads === 'function') writer.setGroupThreads(this.activeThreads());
        } catch (e) {
            (0, $eZQHH.default).warn('GroupShell refreshThreads failed', e);
        }
    }
    async refresh() {
        if (!window.API || !this.currentUser || Number.isNaN(this.groupId)) return;
        this.error = null;
        try {
            this.group = await window.API.request(`/groups/${this.groupId}`);
            const threadsUrl = this.isMod() ? `/groups/${this.groupId}/threads?include_archived=true` : `/groups/${this.groupId}/threads`;
            const threadsData = await window.API.request(threadsUrl);
            this.threads = threadsData.threads || [];
            const roleLabel = this.group.membership?.role ? `You: ${this.group.membership.role}` : null;
            (0, $45c433acd12a8113$export$10f673ac6984c3ef)({
                groupId: this.groupId,
                groupName: this.group.name,
                roleLabel: roleLabel,
                threads: this.activeThreads()
            });
            await this.applyImageProxies();
        } catch (e) {
            this.error = e.message || 'Could not load group';
            (0, $eZQHH.default).warn('GroupShell refresh failed', e);
            (0, $45c433acd12a8113$export$b25062376eaaf9ed)();
        }
        this.render();
        this.bindEvents();
        this.syncChildComponents();
    }
    async applyImageProxies() {
        const uid = this.currentUser?.id;
        if (!uid || !this.group) return;
        if (this.group.header_image_url) this.group._headerProxy = await (0, $1L1Fr.getProxyUrl)(this.group.header_image_url, uid, null);
        else this.group._headerProxy = null;
        if (this.group.avatar_image_url) this.group._avatarProxy = await (0, $1L1Fr.getProxyUrl)(this.group.avatar_image_url, uid, null);
        else this.group._avatarProxy = null;
    }
    syncChildComponents() {
        const writer = this.querySelector('post-writer');
        if (writer) {
            if (typeof writer.setGroupThreads === 'function') writer.setGroupThreads(this.activeThreads());
        }
        const feed = this.querySelector('posts-feed');
        if (feed) {
            if (typeof feed.setCurrentUser === 'function') feed.setCurrentUser(this.currentUser);
            const feedGroupId = feed.getAttribute('group-id');
            const feedThreadId = feed.getAttribute('thread-id') || '';
            const shellThreadId = this.threadId !== null && this.threadId !== undefined ? String(this.threadId) : '';
            const groupUnchanged = feedGroupId === String(this.groupId);
            const threadUnchanged = feedThreadId === shellThreadId;
            const shouldRefresh = !feed.hasLoadedOnce || !groupUnchanged || !threadUnchanged;
            if (typeof feed.refresh === 'function' && shouldRefresh) feed.refresh();
        }
    }
    bindEvents() {
        this.querySelector('#addThreadBtn')?.addEventListener('click', ()=>{
            const modal = this.querySelector('group-add-thread-modal');
            modal?.open(this.groupId);
        });
        this.querySelector('#groupInviteBtn')?.addEventListener('click', ()=>{
            const modal = this.querySelector('group-invite-modal');
            modal?.open({
                groupId: this.groupId,
                groupName: this.group?.name
            });
        });
        this.querySelector('#groupSettingsBtn')?.addEventListener('click', ()=>{
            const route = `/groups/${this.groupId}/settings`;
            if (window.router?.navigate) window.router.navigate(route);
            else window.location.href = route;
        });
        this.querySelector('#createGroupEventBtn')?.addEventListener('click', ()=>{
            const route = `/events/new?groupId=${this.groupId}`;
            if (window.router?.navigate) window.router.navigate(route);
            else window.location.href = route;
        });
    }
    escapeHtml(s) {
        return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    renderToolbar() {
        const membership = this.group?.membership;
        const isActiveMember = membership?.status === 'active';
        const showInvite = isActiveMember && (0, $ef48f05d8e2e06b7$export$3ca8ce609c5fcaa2)(this.group, membership);
        const inviteBtn = showInvite ? '<button type="button" slot="overflow" class="btn btn-secondary" id="groupInviteBtn">\uD83E\uDD1D Invite</button>' : '';
        const modActions = this.isMod() ? `<button type="button" slot="overflow" class="btn btn-secondary" id="addThreadBtn">${0, $605b34b4fa47af77$export$62e93e481bfe83e0} Add thread</button>` : '';
        const settingsBtn = isActiveMember ? '<button type="button" slot="overflow" class="btn btn-secondary" id="groupSettingsBtn">\u2699\uFE0F Settings</button>' : '';
        const showCreateEvent = (0, $ef48f05d8e2e06b7$export$7320560051b5a26e)(this.group, membership);
        const createEventBtn = showCreateEvent ? '<button type="button" slot="primary" class="btn btn-primary" id="createGroupEventBtn">\uD83D\uDCC5 Create event</button>' : '';
        return `
      <toolbar-action-bar label="Group actions">
        <toolbar-overflow-actions slot="actions">
          ${createEventBtn}
          ${inviteBtn}
          ${modActions}
          ${settingsBtn}
        </toolbar-overflow-actions>
      </toolbar-action-bar>
    `;
    }
    render() {
        if (Number.isNaN(this.groupId)) {
            this.innerHTML = '<p class="error">Invalid group.</p>';
            return;
        }
        if (this.error && !this.group) {
            this.innerHTML = `<p class="error">${this.escapeHtml(this.error)}</p>`;
            return;
        }
        if (!this.group) {
            this.innerHTML = '<div class="loading-state"><div class="spinner"></div><div>Loading group\u2026</div></div>';
            return;
        }
        const suspended = this.group.membership?.status === 'suspended';
        const isActiveMember = this.group.membership?.status === 'active';
        const isParticipatingMember = [
            'active',
            'limited'
        ].includes(this.group.membership?.status);
        const bannerColor = this.group.header_banner_color || '';
        const bannerClass = [
            'group-shell-banner'
        ];
        if (this.group._headerProxy) bannerClass.push('has-image');
        const avatarHtml = this.group._avatarProxy ? `<img class="group-shell-avatar" src="${this.group._avatarProxy}" alt="" />` : '<div class="group-shell-avatar" aria-hidden="true">\uD83C\uDF31</div>';
        const threadAttr = this.threadId ? ` thread-id="${this.threadId}"` : '';
        const initialPage = this.getAttribute('initial-page');
        const feedPageAttr = initialPage && parseInt(initialPage, 10) > 1 ? ` data-initial-page="${initialPage}"` : '';
        const currentThread = this.threadId ? this.activeThreads().find((t)=>t.id === this.threadId) : null;
        const threadNameAttr = currentThread ? ` thread-name="${this.escapeHtml(currentThread.name)}"` : '';
        const showEventsSection = !suspended && !this.threadId && isParticipatingMember;
        const eventsSection = showEventsSection ? `<group-events-section group-id="${this.groupId}"></group-events-section>` : '';
        const composerAndFeed = suspended ? `
        <section class="group-shell-suspended card">
          <h3>Access blocked</h3>
          <p>You are suspended from this group.</p>
        </section>
      ` : `
        <post-writer group-id="${this.groupId}"${threadAttr}${threadNameAttr}></post-writer>
        <posts-feed group-id="${this.groupId}"${threadAttr}${feedPageAttr}></posts-feed>
      `;
        this.innerHTML = `
      <div class="group-shell">
        <header class="group-shell-header">
          <div class="${bannerClass.join(' ')}"></div>
          <div class="group-shell-heading">
            ${avatarHtml}
            <div class="group-shell-title-block">
              <h1>${this.escapeHtml(this.group.name)}</h1>
              <p>${this.escapeHtml(this.group.description || '')}</p>
            </div>
          </div>
        </header>

        ${this.renderToolbar()}

        ${this.error ? `<p class="error">${this.escapeHtml(this.error)}</p>` : ''}
        ${eventsSection}
        ${composerAndFeed}

        <group-add-thread-modal></group-add-thread-modal>
        <group-invite-modal></group-invite-modal>
      </div>
    `;
        const root = this.querySelector('.group-shell');
        if (root && bannerColor.startsWith('#')) root.style.setProperty('--group-header-color', bannerColor);
        const ban = this.querySelector('.group-shell-banner.has-image');
        if (ban && this.group._headerProxy) ban.style.backgroundImage = `linear-gradient(120deg, rgba(0,0,0,.35), transparent), url(${this.group._headerProxy})`;
    }
}
customElements.define('group-shell', $cebb5ae4c784b72c$var$GroupShell);
var $cebb5ae4c784b72c$export$2e2bcd8739ae039 = $cebb5ae4c784b72c$var$GroupShell;


/**
 * @component group-add-thread-modal
 * @css group-add-thread-modal.css
 * @primitives .btn.btn-primary, .btn.btn-secondary
 */ 

class $754acde04f9112f8$var$GroupAddThreadModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.groupId = null;
        this.isSubmitting = false;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    open(groupId) {
        this.groupId = groupId;
        this.isOpen = true;
        this.render();
        document.body.style.overflow = 'hidden';
        const nameInput = this.querySelector('#threadNameInput');
        nameInput?.focus();
    }
    close() {
        this.isOpen = false;
        this.isSubmitting = false;
        this.render();
        document.body.style.overflow = '';
    }
    render() {
        this.innerHTML = `
      <div class="group-add-thread-modal ${this.isOpen ? 'open' : ''}" id="groupAddThreadModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>${0, $605b34b4fa47af77$export$62e93e481bfe83e0} Add Thread</h3>
            <button type="button" class="close-btn" id="closeBtn" aria-label="Close">\xd7</button>
          </div>
          <div class="modal-body">
            <p class="modal-description">Threads are lightweight side conversations inside your group.</p>
            <form id="addThreadForm">
              <div class="form-group">
                <label for="threadNameInput">Thread name</label>
                <input
                  type="text"
                  id="threadNameInput"
                  name="thread_name"
                  maxlength="140"
                  required
                  placeholder="e.g. Seed swaps"
                />
              </div>
              <div class="form-group">
                <label for="threadDescInput">Description (optional)</label>
                <textarea
                  id="threadDescInput"
                  name="thread_description"
                  rows="3"
                  maxlength="500"
                  placeholder="What belongs in this thread?"
                ></textarea>
              </div>
              <div class="form-actions">
                <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
                <button type="submit" class="btn btn-primary" id="submitBtn">
                  <span class="btn-text">Add Thread</span>
                  <span class="btn-loading" style="display: none;">Adding\u{2026}</span>
                </button>
              </div>
            </form>
            <div class="alert-container"></div>
          </div>
        </div>
      </div>
    `;
        if (this.isOpen) this.attachEventListeners();
    }
    attachEventListeners() {
        this.querySelector('#modalBackdrop')?.addEventListener('click', ()=>this.close());
        this.querySelector('#closeBtn')?.addEventListener('click', ()=>this.close());
        this.querySelector('#cancelBtn')?.addEventListener('click', ()=>this.close());
        this.querySelector('#addThreadForm')?.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handleSubmit();
        });
    }
    async handleSubmit() {
        if (this.isSubmitting || !this.groupId) return;
        const form = this.querySelector('#addThreadForm');
        const name = form.querySelector('[name="thread_name"]')?.value?.trim();
        const description = form.querySelector('[name="thread_description"]')?.value?.trim() || '';
        if (!name) return;
        this.isSubmitting = true;
        const submitBtn = this.querySelector('#submitBtn');
        const btnText = submitBtn?.querySelector('.btn-text');
        const btnLoading = submitBtn?.querySelector('.btn-loading');
        if (submitBtn) submitBtn.disabled = true;
        if (btnText) btnText.style.display = 'none';
        if (btnLoading) btnLoading.style.display = 'inline';
        try {
            await window.API.request(`/groups/${this.groupId}/threads`, {
                method: 'POST',
                body: JSON.stringify({
                    name: name,
                    description: description
                })
            });
            this.dispatchEvent(new CustomEvent('group-threads-changed', {
                bubbles: true
            }));
            form.reset();
            this.close();
        } catch (error) {
            const container = this.querySelector('.alert-container');
            if (container) container.innerHTML = `<div class="alert alert-error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(error.message || 'Could not create thread')}</div>`;
        } finally{
            this.isSubmitting = false;
            if (submitBtn) submitBtn.disabled = false;
            if (btnText) btnText.style.display = '';
            if (btnLoading) btnLoading.style.display = 'none';
        }
    }
}
customElements.define('group-add-thread-modal', $754acde04f9112f8$var$GroupAddThreadModal);
var $754acde04f9112f8$export$2e2bcd8739ae039 = $754acde04f9112f8$var$GroupAddThreadModal;


/**
 * @component group-settings-page
 * @css group-settings-page.css
 * @primitives .btn.btn-primary, .btn.btn-secondary, .card
 */ 

var $eZQHH = parcelRequire("eZQHH");




var $1L1Fr = parcelRequire("1L1Fr");


const $5be7de80205ef065$var$GROUP_SETTINGS_TAB_IDS = [
    'members',
    'look',
    'threads',
    'reports',
    'rss'
];
class $5be7de80205ef065$var$GroupSettingsPage extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    static get observedAttributes() {
        return [
            'group-id'
        ];
    }
    constructor(){
        super();
        this.groupId = null;
        this.group = null;
        this.threads = [];
        this.activeTab = 'members';
        this.error = null;
        this.isSavingLook = false;
        this.sparkleTargetField = null;
        this._imageUrlHandler = null;
        this.openReportsCount = 0;
    }
    attributeChangedCallback() {
        if (!this.isConnected) return;
        this.groupId = parseInt(this.getAttribute('group-id'), 10);
        if (this.currentUser && !Number.isNaN(this.groupId)) this.load();
    }
    connectedCallback() {
        super.connectedCallback();
        this.groupId = parseInt(this.getAttribute('group-id'), 10);
        this.activeTab = this.tabFromUrl() || 'members';
        this.load();
    }
    disconnectedCallback() {
        if (this._imageUrlHandler) {
            document.removeEventListener('image-url-selected', this._imageUrlHandler);
            this._imageUrlHandler = null;
        }
        super.disconnectedCallback();
    }
    setCurrentUser(user) {
        super.setCurrentUser(user);
        if (user && !Number.isNaN(this.groupId)) this.load();
    }
    tabFromUrl() {
        return (0, $ec0e472fc3ccab74$export$4d96fceac8695298)($5be7de80205ef065$var$GROUP_SETTINGS_TAB_IDS);
    }
    isMod() {
        const role = this.group?.membership?.role;
        return role && (0, $ef48f05d8e2e06b7$export$9197b939281d3ba5).includes(role);
    }
    canBrand() {
        const role = this.group?.membership?.role;
        return role && (0, $ef48f05d8e2e06b7$export$36f512c5217bae6).includes(role);
    }
    visibleTabs() {
        const tabs = [
            {
                id: 'members',
                label: "\uD83D\uDC65 Members"
            }
        ];
        tabs.push({
            id: 'rss',
            label: "\uD83D\uDCE1 RSS"
        });
        if (this.canBrand()) tabs.push({
            id: 'look',
            label: "\uD83C\uDFA8 Look"
        });
        if (this.isMod()) {
            tabs.push({
                id: 'threads',
                label: "\uD83E\uDDF5 Threads"
            });
            const reportsLabel = this.openReportsCount > 0 ? `\u{1F6A9} Reports (${this.openReportsCount})` : "\uD83D\uDEA9 Reports";
            tabs.push({
                id: 'reports',
                label: reportsLabel
            });
        }
        return tabs;
    }
    defaultTab() {
        return 'members';
    }
    ensureValidTab() {
        const visible = this.visibleTabs().map((t)=>t.id);
        if (!visible.includes(this.activeTab)) this.activeTab = this.defaultTab();
    }
    async load() {
        if (!window.API || !this.currentUser || Number.isNaN(this.groupId)) return;
        this.error = null;
        try {
            this.group = await window.API.request(`/groups/${this.groupId}`);
            const threadsUrl = this.isMod() ? `/groups/${this.groupId}/threads?include_archived=true` : `/groups/${this.groupId}/threads`;
            const threadsData = await window.API.request(threadsUrl);
            this.threads = threadsData.threads || [];
            if (this.isMod()) await this.fetchOpenReportsCount();
            this.ensureValidTab();
            const urlTab = this.tabFromUrl();
            if (urlTab && this.visibleTabs().some((t)=>t.id === urlTab)) this.activeTab = urlTab;
        } catch (e) {
            this.error = e.message || 'Could not load group settings';
            (0, $eZQHH.default).warn('GroupSettingsPage load failed', e);
        }
        this.render();
        this.attachListeners();
        if (this.activeTab === 'look') await this.applyImagePreviews();
        if (this.activeTab === 'members') this.loadMembersPanel();
        if (this.activeTab === 'reports') this.loadModerationPanel();
        if (this.activeTab === 'rss') this.loadRssPanel();
    }
    async fetchOpenReportsCount() {
        try {
            const data = await window.API.request(`/groups/${this.groupId}/reports?status=open`);
            this.openReportsCount = (data.reports || []).length;
        } catch  {
            this.openReportsCount = 0;
        }
    }
    loadModerationPanel() {
        const panel = this.querySelector('group-settings-moderation');
        if (panel && this.group) panel.setContext({
            groupId: this.groupId,
            group: this.group,
            membership: this.group.membership,
            currentUser: this.currentUser
        });
    }
    loadMembersPanel() {
        const panel = this.querySelector('group-settings-members');
        if (panel && this.group) panel.setContext({
            groupId: this.groupId,
            group: this.group,
            membership: this.group.membership,
            currentUser: this.currentUser
        });
    }
    loadRssPanel() {
        const panel = this.querySelector('group-settings-rss');
        if (panel && this.group) panel.setContext({
            groupId: this.groupId,
            group: this.group,
            membership: this.group.membership,
            threads: this.threads
        });
    }
    renderTabs() {
        const tabs = this.visibleTabs();
        return tabs.map((t)=>{
            const active = t.id === this.activeTab ? 'active' : '';
            return `<button type="button" class="group-settings-tab ${active}" data-tab="${t.id}">${t.label}</button>`;
        }).join('');
    }
    renderLookPanel() {
        if (!this.canBrand()) return '';
        const g = this.group || {};
        return `
      <div class="group-settings-tab-panel ${this.activeTab === 'look' ? 'active' : ''}" data-panel="look">
        <section class="settings-group">
          <div class="group-header">
            <h3>Group look</h3>
            <p class="group-description">Customize your group's banner accent, header image, and avatar.</p>
          </div>
          <form id="groupLookForm">
            <div class="settings-fields">
              <div class="settings-field-row">
                <div class="form-group">
                  <label class="form-label" for="bannerColorInput">Banner accent (hex)</label>
                  <p class="form-text">Accent color shown behind your group header</p>
                  <input
                    type="text"
                    class="form-control"
                    id="bannerColorInput"
                    name="header_banner_color"
                    maxlength="32"
                    placeholder="#ff6b9d"
                    value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(g.header_banner_color || '')}"
                  />
                </div>
              </div>
              <div class="settings-field-row">
                <div class="form-group">
                  <label class="form-label" for="headerImageInput">Header image URL</label>
                  <p class="form-text">Wide banner image for the group page</p>
                  <div class="url-field-row">
                    <input
                      type="url"
                      class="form-control"
                      id="headerImageInput"
                      name="header_image_url"
                      value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(g.header_image_url || '')}"
                      placeholder="https://\u{2026} or Sparkle"
                    />
                    <button type="button" class="btn btn-secondary btn-sm sparkle-pick-btn" data-field="header_image_url">
                      \u{2728} Sparkle
                    </button>
                  </div>
                  <div class="image-preview" id="headerImagePreview"></div>
                </div>
              </div>
              <div class="settings-field-row">
                <div class="form-group">
                  <label class="form-label" for="avatarImageInput">Group avatar URL</label>
                  <p class="form-text">Square image shown next to the group name</p>
                  <div class="url-field-row">
                    <input
                      type="url"
                      class="form-control"
                      id="avatarImageInput"
                      name="avatar_image_url"
                      value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(g.avatar_image_url || '')}"
                      placeholder="https://\u{2026} or Sparkle"
                    />
                    <button type="button" class="btn btn-secondary btn-sm sparkle-pick-btn" data-field="avatar_image_url">
                      \u{2728} Sparkle
                    </button>
                  </div>
                  <div class="image-preview" id="avatarImagePreview"></div>
                </div>
              </div>
            </div>
            <div class="settings-panel-actions">
              <button type="submit" class="btn btn-primary" id="saveLookBtn">Save look</button>
            </div>
          </form>
        </section>
      </div>
    `;
    }
    isThreadArchived(thread) {
        return thread?.archived_at !== null && thread?.archived_at !== undefined && thread.archived_at !== '';
    }
    renderThreadRows() {
        return (this.threads || []).map((t)=>`
      <div class="thread-row">
        <span>${this.isThreadArchived(t) ? (0, $605b34b4fa47af77$export$275c9ad96473df21)(t.name, {
                archived: true
            }) : (0, $605b34b4fa47af77$export$275c9ad96473df21)(t.name)}</span>
        <button
          type="button"
          class="btn btn-sm btn-secondary thread-archive-btn"
          data-thread-id="${t.id}"
          data-archived="${this.isThreadArchived(t) ? '1' : '0'}"
        >
          ${this.isThreadArchived(t) ? 'Unarchive' : 'Archive'}
        </button>
      </div>
    `).join('');
    }
    renderThreadsPanel() {
        if (!this.isMod()) return '';
        const rows = this.renderThreadRows();
        return `
      <div class="group-settings-tab-panel ${this.activeTab === 'threads' ? 'active' : ''}" data-panel="threads">
        <section class="settings-group">
          <div class="group-header">
            <h3>Threads</h3>
            <p class="group-description">Manage side conversations inside your group. Use <strong>Add thread</strong> on the group page to create new ones.</p>
          </div>
          <div class="thread-list">${rows || '<p class="empty-hint">No threads yet.</p>'}</div>
        </section>
      </div>
    `;
    }
    renderMembersPanel() {
        return `
      <div class="group-settings-tab-panel ${this.activeTab === 'members' ? 'active' : ''}" data-panel="members">
        <group-settings-members></group-settings-members>
      </div>
    `;
    }
    renderReportsPanel() {
        if (!this.isMod()) return '';
        return `
      <div class="group-settings-tab-panel ${this.activeTab === 'reports' ? 'active' : ''}" data-panel="reports">
        <group-settings-moderation></group-settings-moderation>
      </div>
    `;
    }
    renderRssPanel() {
        return `
      <div class="group-settings-tab-panel ${this.activeTab === 'rss' ? 'active' : ''}" data-panel="rss">
        <group-settings-rss></group-settings-rss>
      </div>
    `;
    }
    render() {
        if (Number.isNaN(this.groupId)) {
            this.innerHTML = '<p class="error">Invalid group.</p>';
            return;
        }
        if (this.error && !this.group) {
            this.innerHTML = `<p class="error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.error)}</p>`;
            return;
        }
        if (!this.group) {
            this.innerHTML = `
        <div class="group-settings-page">
          <div class="loading-state">
            <div class="spinner"></div>
            <div>Loading settings\u{2026}</div>
          </div>
        </div>
      `;
            return;
        }
        const groupName = (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.group.name || 'Group');
        this.innerHTML = `
      <div class="group-settings-page">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\u2699\uFE0F", `${groupName} Settings`, 'h1')}
          <p class="settings-subtitle">Manage your group's look, members, RSS feeds, threads, and reports</p>
        </div>

        <div class="group-settings-tabs" role="tablist">
          ${this.renderTabs()}
        </div>

        <div class="group-settings-panels">
          ${this.renderMembersPanel()}
          ${this.renderRssPanel()}
          ${this.renderLookPanel()}
          ${this.renderThreadsPanel()}
          ${this.renderReportsPanel()}
        </div>

        <div class="alert-container"></div>

        <footer class="group-settings-footer">
          <a href="/groups/${this.groupId}" class="btn btn-secondary" data-route="/groups/${this.groupId}">\u{2190} Back to group</a>
        </footer>
      </div>
    `;
    }
    switchTab(tabId) {
        if (!this.visibleTabs().some((t)=>t.id === tabId)) return;
        this.activeTab = tabId;
        (0, $ec0e472fc3ccab74$export$19a03c6887cb23d9)(tabId);
        this.render();
        this.attachListeners();
        if (tabId === 'look') this.applyImagePreviews();
        if (tabId === 'members') this.loadMembersPanel();
        if (tabId === 'reports') this.loadModerationPanel();
        if (tabId === 'rss') this.loadRssPanel();
    }
    attachListeners() {
        this.querySelectorAll('.group-settings-tab').forEach((tab)=>{
            tab.addEventListener('click', ()=>{
                this.switchTab(tab.getAttribute('data-tab'));
            });
        });
        this.addEventListener('group-settings-saved', (e)=>{
            if (e.detail?.group) this.group = e.detail.group;
        });
        this.addEventListener('group-members-changed', ()=>{
            this.load();
        });
        this.addEventListener('group-reports-count', (e)=>{
            this.openReportsCount = e.detail?.openCount ?? 0;
            this.querySelectorAll('.group-settings-tab[data-tab="reports"]').forEach((tab)=>{
                tab.textContent = this.openReportsCount > 0 ? `\u{1F6A9} Reports (${this.openReportsCount})` : "\uD83D\uDEA9 Reports";
            });
        });
        this.addEventListener('group-moderation-alert', (e)=>{
            const { message: message, type: type } = e.detail || {};
            if (message) this.showAlert(message, type || 'info');
        });
        const lookForm = this.querySelector('#groupLookForm');
        lookForm?.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.saveLook();
        });
        this.querySelectorAll('.sparkle-pick-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.sparkleTargetField = btn.getAttribute('data-field');
                this.openSparklePicker();
            });
        });
        this.attachThreadArchiveListeners();
        if (!this._imageUrlHandler) {
            this._imageUrlHandler = (e)=>{
                if (!this.sparkleTargetField || this.activeTab !== 'look') return;
                const input = this.querySelector(`[name="${this.sparkleTargetField}"]`);
                if (input && e.detail?.fileUrl) {
                    input.value = e.detail.fileUrl;
                    this.applyImagePreviews();
                }
                this.sparkleTargetField = null;
            };
            document.addEventListener('image-url-selected', this._imageUrlHandler);
        }
    }
    attachThreadArchiveListeners() {
        this.querySelectorAll('.thread-archive-btn').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const threadId = parseInt(btn.getAttribute('data-thread-id'), 10);
                const archived = btn.getAttribute('data-archived') === '1';
                const thread = this.threads.find((t)=>Number(t.id) === threadId);
                const previousArchivedAt = thread?.archived_at ?? null;
                if (thread) {
                    thread.archived_at = archived ? null : new Date().toISOString();
                    this.render();
                    this.attachListeners();
                }
                try {
                    await window.API.request(`/groups/${this.groupId}/threads/${threadId}`, {
                        method: 'PUT',
                        body: JSON.stringify({
                            archived: !archived
                        })
                    });
                    const threadsUrl = this.isMod() ? `/groups/${this.groupId}/threads?include_archived=true` : `/groups/${this.groupId}/threads`;
                    const data = await window.API.request(threadsUrl);
                    this.threads = data.threads || [];
                    this.render();
                    this.attachListeners();
                    this.dispatchEvent(new CustomEvent('group-threads-changed', {
                        bubbles: true
                    }));
                } catch (error) {
                    if (thread) {
                        thread.archived_at = previousArchivedAt;
                        this.render();
                        this.attachListeners();
                    }
                    this.showAlert(error.message || 'Thread update failed', 'error');
                }
            });
        });
    }
    openSparklePicker() {
        let picker = document.querySelector('media-source-picker[output-mode="url"]');
        if (!picker) {
            picker = document.createElement('media-source-picker');
            picker.setAttribute('selection-mode', 'single');
            picker.setAttribute('output-mode', 'url');
            document.body.appendChild(picker);
        }
        picker.open();
    }
    async applyImagePreviews() {
        const uid = this.currentUser?.id;
        if (!uid) return;
        const headerInput = this.querySelector('[name="header_image_url"]');
        const avatarInput = this.querySelector('[name="avatar_image_url"]');
        const headerPreview = this.querySelector('#headerImagePreview');
        const avatarPreview = this.querySelector('#avatarImagePreview');
        if (headerPreview && headerInput?.value?.trim()) {
            const url = await (0, $1L1Fr.getProxyUrl)(headerInput.value.trim(), uid, null);
            headerPreview.innerHTML = url ? `<img src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(url)}" alt="" class="preview-thumb banner-preview" />` : '';
        } else if (headerPreview) headerPreview.innerHTML = '';
        if (avatarPreview && avatarInput?.value?.trim()) {
            const url = await (0, $1L1Fr.getProxyUrl)(avatarInput.value.trim(), uid, null);
            avatarPreview.innerHTML = url ? `<img src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(url)}" alt="" class="preview-thumb avatar-preview" />` : '';
        } else if (avatarPreview) avatarPreview.innerHTML = '';
    }
    async saveLook() {
        if (this.isSavingLook || !this.group) return;
        const form = this.querySelector('#groupLookForm');
        if (!form) return;
        this.isSavingLook = true;
        try {
            const body = {
                header_banner_color: form.querySelector('[name="header_banner_color"]')?.value?.trim() || null,
                header_image_url: form.querySelector('[name="header_image_url"]')?.value?.trim() || null,
                avatar_image_url: form.querySelector('[name="avatar_image_url"]')?.value?.trim() || null
            };
            await window.API.request(`/groups/${this.groupId}`, {
                method: 'PUT',
                body: JSON.stringify(body)
            });
            this.group = await window.API.request(`/groups/${this.groupId}`);
            this.dispatchEvent(new CustomEvent('group-settings-saved', {
                detail: {
                    group: this.group
                },
                bubbles: true
            }));
            this.showAlert('Group look saved!', 'success');
            await this.applyImagePreviews();
        } catch (error) {
            this.showAlert(error.message || 'Could not save', 'error');
        } finally{
            this.isSavingLook = false;
        }
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('.alert-container');
        if (!container) return;
        container.innerHTML = `<div class="alert alert-${type}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(message)}</div>`;
        setTimeout(()=>{
            if (container) container.innerHTML = '';
        }, 4000);
    }
}
customElements.define('group-settings-page', $5be7de80205ef065$var$GroupSettingsPage);
var $5be7de80205ef065$export$2e2bcd8739ae039 = $5be7de80205ef065$var$GroupSettingsPage;


/**
 * @component group-settings-members
 * @css group-settings-members.css
 */ 

const $6f533908fb0c3074$var$POLICY_OPTIONS = [
    {
        value: 'members_allowed',
        label: 'Members'
    },
    {
        value: 'mods_and_admins',
        label: 'Moderators / admins only'
    },
    {
        value: 'admins_only',
        label: 'Admins only'
    }
];
const $6f533908fb0c3074$var$ASSIGNABLE_ROLES = [
    'member',
    'moderator',
    'admin'
];
class $6f533908fb0c3074$var$GroupSettingsMembers extends HTMLElement {
    constructor(){
        super();
        this.groupId = null;
        this.group = null;
        this.membership = null;
        this.members = [];
        this.joinRequests = [];
        this.loading = true;
        this.error = null;
        this.savingPolicy = false;
    }
    setContext({ groupId: groupId, group: group, membership: membership, currentUser: currentUser }) {
        this.groupId = groupId;
        this.group = group;
        this.membership = membership;
        this.currentUser = currentUser;
        this.load();
    }
    isMod() {
        const role = this.membership?.role;
        return role && (0, $ef48f05d8e2e06b7$export$9197b939281d3ba5).includes(role);
    }
    isAdmin() {
        const role = this.membership?.role;
        return role && (0, $ef48f05d8e2e06b7$export$36f512c5217bae6).includes(role);
    }
    async load() {
        if (!window.API || !this.groupId) return;
        this.loading = true;
        this.error = null;
        this.render();
        try {
            const membersData = await window.API.request(`/groups/${this.groupId}/members`);
            this.members = membersData.members || [];
            if (this.isMod()) {
                const jrData = await window.API.request(`/groups/${this.groupId}/join-requests`);
                this.joinRequests = jrData.join_requests || [];
            } else this.joinRequests = [];
        } catch (e) {
            this.error = e.message || 'Could not load members';
            this.members = [];
            this.joinRequests = [];
        } finally{
            this.loading = false;
            this.render();
            this.attachListeners();
        }
    }
    formatDate(iso) {
        if (!iso) return "\u2014";
        try {
            return new Date(iso).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            });
        } catch  {
            return iso;
        }
    }
    renderInvitePolicySection() {
        if (!this.isAdmin()) return '';
        const inviteCurrent = this.group?.invite_policy || 'members_allowed';
        const eventCurrent = this.group?.event_create_policy || 'members_allowed';
        const rssCurrent = this.group?.rss_add_policy || 'members_allowed';
        const inviteOptions = $6f533908fb0c3074$var$POLICY_OPTIONS.map((o)=>{
            const selected = o.value === inviteCurrent ? 'selected' : '';
            return `<option value="${o.value}" ${selected}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(o.label)}</option>`;
        }).join('');
        const eventOptions = $6f533908fb0c3074$var$POLICY_OPTIONS.map((o)=>{
            const selected = o.value === eventCurrent ? 'selected' : '';
            return `<option value="${o.value}" ${selected}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(o.label)}</option>`;
        }).join('');
        const rssOptions = $6f533908fb0c3074$var$POLICY_OPTIONS.map((o)=>{
            const selected = o.value === rssCurrent ? 'selected' : '';
            return `<option value="${o.value}" ${selected}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(o.label)}</option>`;
        }).join('');
        return `
      <section class="settings-group">
        <div class="group-header">
          <h3>Group policies</h3>
          <p class="group-description">Control who can invite members, create group events, and add RSS feeds.</p>
        </div>
        <div class="form-group">
          <label class="form-label" for="invitePolicySelect">Who can invite</label>
          <p class="form-text">Who can invite new members to this group.</p>
          <select id="invitePolicySelect" class="form-control" ${this.savingPolicy ? 'disabled' : ''}>
            ${inviteOptions}
          </select>
        </div>
        <div class="form-group">
          <label class="form-label" for="eventCreatePolicySelect">Who can create events</label>
          <p class="form-text">Who can create events linked to this group from the group home.</p>
          <select id="eventCreatePolicySelect" class="form-control" ${this.savingPolicy ? 'disabled' : ''}>
            ${eventOptions}
          </select>
        </div>
        <div class="form-group">
          <label class="form-label" for="rssAddPolicySelect">Who can add RSS feeds</label>
          <p class="form-text">Who can subscribe to external feeds that import into this group.</p>
          <select id="rssAddPolicySelect" class="form-control" ${this.savingPolicy ? 'disabled' : ''}>
            ${rssOptions}
          </select>
        </div>
        <div class="settings-panel-actions">
          <button type="button" class="btn btn-primary" id="saveInvitePolicyBtn" ${this.savingPolicy ? 'disabled' : ''}>
            ${this.savingPolicy ? "Saving\u2026" : 'Save policies'}
          </button>
        </div>
      </section>
    `;
    }
    renderJoinRequests() {
        if (!this.isMod()) return '';
        const rows = this.joinRequests.length ? `<div class="member-roster-list">${this.joinRequests.map((jr)=>`
          <div class="join-request-row" data-request-id="${jr.id}">
            <div class="member-info">
              <span class="member-username">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(jr.username || `User #${jr.requester_user_id}`)}</span>
              <span class="member-meta">Requested ${this.formatDate(jr.created_at)}</span>
            </div>
            <div class="member-actions">
              <button type="button" class="btn btn-primary btn-sm approve-btn" data-request-id="${jr.id}">Approve</button>
              <button type="button" class="btn btn-secondary btn-sm deny-btn" data-request-id="${jr.id}">Deny</button>
            </div>
          </div>
        `).join('')}</div>` : '<p class="empty-hint">No pending join requests.</p>';
        return `
      <section class="settings-group">
        <div class="group-header">
          <h3>Pending join requests</h3>
          <p class="group-description">Review and approve people who want to join your group.</p>
        </div>
        ${rows}
      </section>
    `;
    }
    canManageMember(member) {
        if (!this.isMod()) return false;
        if (member.user_id === this.currentUser?.id) return false;
        if (member.role === 'owner') return false;
        if (!this.isAdmin() && [
            'admin',
            'moderator'
        ].includes(member.role)) return false;
        return true;
    }
    renderMemberActions(member) {
        if (!this.canManageMember(member)) return '';
        const roleSelect = this.isAdmin() && member.role !== 'owner' ? `
        <select class="role-select form-control" data-user-id="${member.user_id}" aria-label="Change role">
          ${$6f533908fb0c3074$var$ASSIGNABLE_ROLES.map((r)=>{
            const selected = member.role === r ? 'selected' : '';
            return `<option value="${r}" ${selected}>${r}</option>`;
        }).join('')}
        </select>
      ` : '';
        const suspendBtn = this.isAdmin() && member.status === 'active' ? `<button type="button" class="btn btn-secondary btn-sm suspend-btn" data-user-id="${member.user_id}">Suspend</button>` : '';
        const restoreBtn = this.isAdmin() && member.status === 'suspended' ? `<button type="button" class="btn btn-secondary btn-sm restore-btn" data-user-id="${member.user_id}">Restore</button>` : '';
        const removeBtn = `<button type="button" class="btn btn-secondary btn-sm remove-btn" data-user-id="${member.user_id}">Remove</button>`;
        return `
      <div class="member-actions">
        ${roleSelect}
        ${suspendBtn}
        ${restoreBtn}
        ${removeBtn}
      </div>
    `;
    }
    renderMemberRow(member) {
        const statusNote = member.status !== 'active' ? ` \xb7 ${member.status}` : '';
        return `
      <div class="member-row" data-user-id="${member.user_id}">
        <div class="member-info">
          <span class="member-username">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(member.username)}</span>
          <span class="member-meta">
            <span class="role-badge">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(member.role)}</span>
            Joined ${this.formatDate(member.joined_at)}${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(statusNote)}
          </span>
        </div>
        ${this.renderMemberActions(member)}
      </div>
    `;
    }
    render() {
        if (this.loading) {
            this.innerHTML = `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading members\u{2026}</div>
        </div>
      `;
            return;
        }
        if (this.error) {
            this.innerHTML = `<p class="error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.error)}</p>`;
            return;
        }
        const roster = this.members.length ? `<div class="member-roster-list">${this.members.map((m)=>this.renderMemberRow(m)).join('')}</div>` : '<p class="empty-hint">No members yet.</p>';
        const singleMemberNudge = this.members.length === 1 && this.isMod() ? '<p class="empty-hint">You\'re the only member \u2014 use <strong>Invite</strong> on the group page to grow the roster!</p>' : '';
        this.innerHTML = `
      <div class="group-settings-members-content">
        <div class="alert-container"></div>
        ${this.renderInvitePolicySection()}
        ${this.renderJoinRequests()}
        <section class="settings-group">
          <div class="group-header">
            <h3>Members (${this.members.length})</h3>
            <p class="group-description">Everyone in this group and their roles.</p>
          </div>
          ${singleMemberNudge}
          ${roster}
        </section>
      </div>
    `;
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('.alert-container');
        if (!container) return;
        container.innerHTML = `<div class="alert alert-${type}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(message)}</div>`;
        setTimeout(()=>{
            if (container) container.innerHTML = '';
        }, 4000);
    }
    attachListeners() {
        this.querySelector('#saveInvitePolicyBtn')?.addEventListener('click', ()=>this.saveInvitePolicy());
        this.querySelectorAll('.approve-btn').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const requestId = btn.getAttribute('data-request-id');
                try {
                    await window.API.request(`/groups/${this.groupId}/join-requests/${requestId}/approve`, {
                        method: 'POST'
                    });
                    this.showAlert('Join request approved', 'success');
                    await this.load();
                    this.dispatchEvent(new CustomEvent('group-members-changed', {
                        bubbles: true
                    }));
                } catch (e) {
                    this.showAlert(e.message || 'Could not approve request', 'error');
                }
            });
        });
        this.querySelectorAll('.deny-btn').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const requestId = btn.getAttribute('data-request-id');
                try {
                    await window.API.request(`/groups/${this.groupId}/join-requests/${requestId}/deny`, {
                        method: 'POST'
                    });
                    this.showAlert('Join request denied', 'success');
                    await this.load();
                } catch (e) {
                    this.showAlert(e.message || 'Could not deny request', 'error');
                }
            });
        });
        this.querySelectorAll('.role-select').forEach((sel)=>{
            sel.addEventListener('change', async ()=>{
                const userId = sel.getAttribute('data-user-id');
                const role = sel.value;
                try {
                    await window.API.request(`/groups/${this.groupId}/members/${userId}/role`, {
                        method: 'PUT',
                        body: JSON.stringify({
                            role: role
                        })
                    });
                    this.showAlert('Role updated', 'success');
                    await this.load();
                    this.dispatchEvent(new CustomEvent('group-members-changed', {
                        bubbles: true
                    }));
                } catch (e) {
                    this.showAlert(e.message || 'Could not update role', 'error');
                    await this.load();
                }
            });
        });
        this.querySelectorAll('.suspend-btn').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const userId = btn.getAttribute('data-user-id');
                if (!window.confirm('Suspend this member?')) return;
                try {
                    await window.API.request(`/groups/${this.groupId}/members/${userId}/role`, {
                        method: 'PUT',
                        body: JSON.stringify({
                            status: 'suspended'
                        })
                    });
                    this.showAlert('Member suspended', 'success');
                    await this.load();
                } catch (e) {
                    this.showAlert(e.message || 'Could not suspend member', 'error');
                }
            });
        });
        this.querySelectorAll('.restore-btn').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const userId = btn.getAttribute('data-user-id');
                try {
                    await window.API.request(`/groups/${this.groupId}/members/${userId}/role`, {
                        method: 'PUT',
                        body: JSON.stringify({
                            status: 'active'
                        })
                    });
                    this.showAlert('Member restored', 'success');
                    await this.load();
                } catch (e) {
                    this.showAlert(e.message || 'Could not restore member', 'error');
                }
            });
        });
        this.querySelectorAll('.remove-btn').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const userId = btn.getAttribute('data-user-id');
                if (!window.confirm('Remove this member from the group?')) return;
                try {
                    await window.API.request(`/groups/${this.groupId}/members/${userId}`, {
                        method: 'DELETE'
                    });
                    this.showAlert('Member removed', 'success');
                    await this.load();
                    this.dispatchEvent(new CustomEvent('group-members-changed', {
                        bubbles: true
                    }));
                } catch (e) {
                    this.showAlert(e.message || 'Could not remove member', 'error');
                }
            });
        });
    }
    async saveInvitePolicy() {
        if (this.savingPolicy || !this.isAdmin()) return;
        const inviteSelect = this.querySelector('#invitePolicySelect');
        const eventSelect = this.querySelector('#eventCreatePolicySelect');
        const rssSelect = this.querySelector('#rssAddPolicySelect');
        if (!inviteSelect || !eventSelect || !rssSelect) return;
        this.savingPolicy = true;
        this.render();
        this.attachListeners();
        try {
            await window.API.request(`/groups/${this.groupId}`, {
                method: 'PUT',
                body: JSON.stringify({
                    invite_policy: inviteSelect.value,
                    event_create_policy: eventSelect.value,
                    rss_add_policy: rssSelect.value
                })
            });
            this.group = await window.API.request(`/groups/${this.groupId}`);
            this.showAlert('Group policies saved', 'success');
            this.dispatchEvent(new CustomEvent('group-settings-saved', {
                detail: {
                    group: this.group
                },
                bubbles: true
            }));
        } catch (e) {
            this.showAlert(e.message || 'Could not save policies', 'error');
        } finally{
            this.savingPolicy = false;
            this.render();
            this.attachListeners();
        }
    }
}
customElements.define('group-settings-members', $6f533908fb0c3074$var$GroupSettingsMembers);
var $6f533908fb0c3074$export$2e2bcd8739ae039 = $6f533908fb0c3074$var$GroupSettingsMembers;


/**
 * @component group-settings-rss
 * @css group-settings-rss.css
 */ 


class $8f5d664c4be0ab83$var$GroupSettingsRss extends HTMLElement {
    constructor(){
        super();
        this.groupId = null;
        this.group = null;
        this.membership = null;
        this.threads = [];
        this.feeds = [];
        this.showAddForm = false;
        this.loading = true;
    }
    setContext({ groupId: groupId, group: group, membership: membership, threads: threads = [] }) {
        this.groupId = groupId;
        this.group = group;
        this.membership = membership;
        this.threads = threads.filter((t)=>!t.archived_at);
        this.load();
    }
    canAdd() {
        return (0, $ef48f05d8e2e06b7$export$66e3ea5dff7c210)(this.group, this.membership);
    }
    isMod() {
        return (0, $ef48f05d8e2e06b7$export$9197b939281d3ba5).includes(this.membership?.role);
    }
    async load() {
        if (!window.API || !this.groupId) return;
        this.loading = true;
        this.render();
        try {
            this.feeds = await window.API.request(`/groups/${this.groupId}/rss`);
        } catch (e) {
            window.logger?.warn('Failed to load group RSS feeds', e);
            this.feeds = [];
        } finally{
            this.loading = false;
            this.render();
            this.attachListeners();
        }
    }
    renderThreadOptions(selectedId) {
        const mainSelected = selectedId === null || selectedId === undefined ? 'selected' : '';
        let html = `<option value="" ${mainSelected}>Main stream</option>`;
        for (const thread of this.threads){
            const sel = String(thread.id) === String(selectedId) ? 'selected' : '';
            html += `<option value="${thread.id}" ${sel}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(thread.name)}</option>`;
        }
        return html;
    }
    renderDestination(feed) {
        if (!feed.topic_id) return "\uD83D\uDCE1 Main stream";
        return `\u{1F9F5} ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(feed.topic_name || 'Thread')}`;
    }
    render() {
        const canAdd = this.canAdd();
        this.innerHTML = `
      <section class="settings-group group-settings-rss">
        <div class="group-header">
          <h3>\u{1F4E1} RSS Feeds</h3>
          <p class="group-description">Import posts from external blogs into this group.
            <a href="${(0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/docs/rss/group-feeds')}">Group RSS help \u{2192}</a></p>
        </div>
        ${canAdd ? '<button type="button" class="btn btn-primary" id="groupRssAddBtn">+ Add Feed</button>' : ''}
        ${this.showAddForm && canAdd ? `
          <form id="groupRssAddForm" class="add-feed-form">
            <div class="form-group">
              <label for="groupFeedUrl">Feed URL</label>
              <input type="url" id="groupFeedUrl" class="form-control" required placeholder="https://example.com/feed.xml" />
            </div>
            <div class="form-group">
              <label for="groupFeedTopic">Post to</label>
              <select id="groupFeedTopic" class="form-control">${this.renderThreadOptions(null)}</select>
            </div>
            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" id="groupFeedNotify" />
                Email group members when this feed updates
              </label>
            </div>
            <div class="form-actions">
              <button type="submit" class="btn btn-primary">Add Feed</button>
              <button type="button" class="btn btn-secondary" id="groupRssCancelBtn">Cancel</button>
            </div>
          </form>
        ` : ''}
        ${this.loading ? '<div class="loading-state"><div class="spinner"></div></div>' : ''}
        ${!this.loading && this.feeds.length === 0 ? '<p class="empty-hint">No RSS feeds yet.</p>' : ''}
        ${!this.loading && this.feeds.length ? `
          <div class="feeds-list">
            ${this.feeds.map((feed)=>`
              <div class="feed-item" data-feed-id="${feed.id}">
                <div class="feed-header">
                  <h4>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(feed.title || feed.feed_url)}</h4>
                  <span class="feed-destination">${this.renderDestination(feed)}</span>
                </div>
                <p class="feed-url">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(feed.discovered_feed_url || feed.feed_url)}</p>
                <div class="feed-actions">
                  ${feed.status === 'active' ? `<button type="button" class="btn btn-sm btn-secondary pause-btn" data-feed-id="${feed.id}">Pause</button>` : `<button type="button" class="btn btn-sm btn-primary resume-btn" data-feed-id="${feed.id}">Resume</button>`}
                  ${this.isMod() ? `<button type="button" class="btn btn-sm btn-danger delete-btn" data-feed-id="${feed.id}">Delete</button>` : ''}
                </div>
              </div>
            `).join('')}
          </div>
        ` : ''}
      </section>
    `;
    }
    attachListeners() {
        this.querySelector('#groupRssAddBtn')?.addEventListener('click', ()=>{
            this.showAddForm = true;
            this.render();
            this.attachListeners();
        });
        this.querySelector('#groupRssCancelBtn')?.addEventListener('click', ()=>{
            this.showAddForm = false;
            this.render();
            this.attachListeners();
        });
        this.querySelector('#groupRssAddForm')?.addEventListener('submit', async (e)=>{
            e.preventDefault();
            const url = this.querySelector('#groupFeedUrl')?.value?.trim();
            const topicVal = this.querySelector('#groupFeedTopic')?.value;
            const notify = this.querySelector('#groupFeedNotify')?.checked;
            if (!url) return;
            try {
                await window.API.request(`/groups/${this.groupId}/rss`, {
                    method: 'POST',
                    body: JSON.stringify({
                        url: url,
                        topic_id: topicVal ? parseInt(topicVal, 10) : null,
                        notify_members_email: Boolean(notify)
                    })
                });
                this.showAddForm = false;
                await this.load();
            } catch (err) {
                window.alert(err.message || 'Failed to add feed');
            }
        });
        this.querySelectorAll('.pause-btn, .resume-btn, .delete-btn').forEach((btn)=>{
            btn.addEventListener('click', async ()=>{
                const feedId = btn.dataset.feedId;
                try {
                    if (btn.classList.contains('delete-btn')) {
                        if (!confirm('Delete this RSS feed?')) return;
                        await window.API.request(`/groups/${this.groupId}/rss/${feedId}`, {
                            method: 'DELETE'
                        });
                    } else {
                        const status = btn.classList.contains('pause-btn') ? 'paused' : 'active';
                        await window.API.request(`/groups/${this.groupId}/rss/${feedId}`, {
                            method: 'PATCH',
                            body: JSON.stringify({
                                status: status
                            })
                        });
                    }
                    await this.load();
                } catch (err) {
                    window.alert(err.message || 'Action failed');
                }
            });
        });
    }
}
customElements.define('group-settings-rss', $8f5d664c4be0ab83$var$GroupSettingsRss);


/**
 * @component group-settings-moderation
 * @css group-settings-moderation.css
 */ 

const $2b110806df4d29cd$var$STATUS_FILTERS = [
    {
        id: 'open',
        label: 'Open'
    },
    {
        id: 'resolved',
        label: 'Resolved'
    },
    {
        id: 'dismissed',
        label: 'Dismissed'
    },
    {
        id: 'all',
        label: 'All'
    }
];
const $2b110806df4d29cd$var$CONTENT_ACTIONS = [
    {
        value: 'warning',
        label: 'Send warning'
    },
    {
        value: 'content_removal',
        label: 'Remove content'
    }
];
const $2b110806df4d29cd$var$MEMBER_ACTIONS = [
    {
        value: 'warning',
        label: 'Send warning'
    },
    {
        value: 'temp_suspend',
        label: 'Suspend member'
    },
    {
        value: 'remove_member',
        label: 'Remove member'
    }
];
const $2b110806df4d29cd$var$DESTRUCTIVE_ACTIONS = new Set([
    'content_removal',
    'temp_suspend',
    'remove_member'
]);
class $2b110806df4d29cd$var$GroupSettingsModeration extends HTMLElement {
    constructor(){
        super();
        this.groupId = null;
        this.group = null;
        this.membership = null;
        this.reports = [];
        this.statusFilter = 'open';
        this.loading = true;
        this.error = null;
        this.openCount = 0;
        this.expandedReportId = null;
        this.actionReasons = {};
        this.submittingReportId = null;
    }
    setContext({ groupId: groupId, group: group, membership: membership, currentUser: currentUser }) {
        this.groupId = groupId;
        this.group = group;
        this.membership = membership;
        this.currentUser = currentUser;
        this.load();
    }
    async load() {
        if (!window.API || !this.groupId) return;
        this.loading = true;
        this.error = null;
        this.render();
        try {
            const data = await window.API.request(`/groups/${this.groupId}/reports?status=${encodeURIComponent(this.statusFilter)}`);
            this.reports = data.reports || [];
            if (this.statusFilter === 'open') {
                this.openCount = this.reports.length;
                this.dispatchEvent(new CustomEvent('group-reports-count', {
                    detail: {
                        openCount: this.openCount
                    },
                    bubbles: true
                }));
            }
        } catch (e) {
            this.error = e.message || 'Could not load reports';
            this.reports = [];
        } finally{
            this.loading = false;
            this.render();
            this.attachListeners();
        }
    }
    formatDateTime(iso) {
        if (!iso) return "\u2014";
        try {
            return new Date(iso).toLocaleString(undefined, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit'
            });
        } catch  {
            return iso;
        }
    }
    targetTypeLabel(type) {
        if (type === 'post') return 'Post';
        if (type === 'comment') return 'Comment';
        if (type === 'member') return 'Member';
        return type;
    }
    buildPermalink(report) {
        if (!report.permalink) return null;
        const { groupId: groupId, postId: postId, commentId: commentId } = report.permalink;
        if (commentId) return (0, $2bb3cd4399004fe3$export$634034df907f30cd)({
            groupId: groupId,
            postId: postId,
            commentId: commentId
        });
        return (0, $2bb3cd4399004fe3$export$611b42c8bf9737ff)({
            groupId: groupId,
            postId: postId
        });
    }
    actionsForReport(report) {
        if (report.target_type === 'member') return $2b110806df4d29cd$var$MEMBER_ACTIONS;
        return $2b110806df4d29cd$var$CONTENT_ACTIONS;
    }
    renderFilters() {
        return $2b110806df4d29cd$var$STATUS_FILTERS.map((f)=>{
            const active = f.id === this.statusFilter ? 'active' : '';
            const badge = f.id === 'open' && this.openCount > 0 && this.statusFilter !== 'open' ? ` (${this.openCount})` : '';
            return `<button type="button" class="filter-btn ${active}" data-filter="${f.id}">${f.label}${badge}</button>`;
        }).join('');
    }
    renderActionPanel(report) {
        if (this.expandedReportId !== report.id) return '';
        const actions = this.actionsForReport(report);
        const options = actions.map((a)=>{
            const selected = this.actionReasons[report.id]?.action === a.value ? 'selected' : '';
            return `<option value="${a.value}" ${selected}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(a.label)}</option>`;
        }).join('');
        const reason = (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.actionReasons[report.id]?.reason || '');
        const disabled = this.submittingReportId === report.id ? 'disabled' : '';
        return `
      <div class="report-action-panel">
        <div class="form-group">
          <label class="form-label" for="action-select-${report.id}">Moderation action</label>
          <select id="action-select-${report.id}" class="form-control action-select" data-report-id="${report.id}" ${disabled}>
            <option value="">Choose an action\u{2026}</option>
            ${options}
          </select>
        </div>
        <div class="form-group">
          <label class="form-label" for="action-reason-${report.id}">Reason (required)</label>
          <textarea id="action-reason-${report.id}" class="form-control action-reason" data-report-id="${report.id}" rows="3" minlength="3" maxlength="5000" placeholder="Explain the decision for the audit log\u{2026}" ${disabled}>${reason}</textarea>
        </div>
        <div class="report-action-buttons">
          <button type="button" class="btn btn-primary btn-sm apply-action-btn" data-report-id="${report.id}" ${disabled}>Apply action</button>
          <button type="button" class="btn btn-secondary btn-sm dismiss-report-btn" data-report-id="${report.id}" ${disabled}>Dismiss report</button>
          <button type="button" class="btn btn-outline btn-sm cancel-action-btn" data-report-id="${report.id}" ${disabled}>Cancel</button>
        </div>
      </div>
    `;
    }
    renderReportCard(report) {
        const permalink = this.buildPermalink(report);
        const viewLink = permalink ? `<a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(permalink)}" class="report-permalink-link" data-route="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(permalink)}">View in group</a>` : '';
        const authorLine = report.target_author_username ? `<div class="report-meta">By @${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(report.target_author_username)}</div>` : '';
        const preview = report.target_preview ? `<blockquote class="report-preview">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(report.target_preview)}</blockquote>` : '<p class="empty-hint">Target content unavailable (may have been removed).</p>';
        return `
      <article class="card report-card" data-report-id="${report.id}">
        <div class="card-body">
          <div class="report-card-header">
            <span class="report-type-badge">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.targetTypeLabel(report.target_type))}</span>
            <span class="report-status-badge status-${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(report.status)}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(report.status)}</span>
            <span class="report-time">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.formatDateTime(report.created_at))}</span>
          </div>
          <div class="report-meta">Reported by @${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(report.reporter_username || 'unknown')}</div>
          <div class="report-reason"><strong>Reason:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(report.reason)}</div>
          ${report.details ? `<div class="report-details">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(report.details)}</div>` : ''}
          ${authorLine}
          ${preview}
          ${viewLink}
          <div class="report-card-actions">
            ${report.status === 'open' || report.status === 'in_review' ? `<button type="button" class="btn btn-sm btn-secondary take-action-btn" data-report-id="${report.id}">Take action</button>` : ''}
          </div>
          ${this.renderActionPanel(report)}
        </div>
      </article>
    `;
    }
    renderContent() {
        if (this.loading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading reports\u{2026}</div>
        </div>
      `;
        if (this.error) return `<div class="alert alert-error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.error)}</div>`;
        if (this.reports.length === 0) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F6A9}</div>
          <h3>No reports</h3>
          <p>There are no reports with the selected status.</p>
        </div>
      `;
        return `<div class="reports-list">${this.reports.map((r)=>this.renderReportCard(r)).join('')}</div>`;
    }
    render() {
        this.innerHTML = `
      <div class="group-settings-moderation-content">
        <section class="settings-group">
          <div class="group-header">
            <h3>Reports queue</h3>
            <p class="group-description">Review member reports and take moderation actions.</p>
          </div>
          <div class="reports-filters">${this.renderFilters()}</div>
          ${this.renderContent()}
        </section>
      </div>
    `;
    }
    attachListeners() {
        this.querySelectorAll('.filter-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.statusFilter = btn.getAttribute('data-filter');
                this.expandedReportId = null;
                this.load();
            });
        });
        this.querySelectorAll('.take-action-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const reportId = parseInt(btn.getAttribute('data-report-id'), 10);
                this.expandedReportId = reportId;
                if (!this.actionReasons[reportId]) this.actionReasons[reportId] = {
                    action: '',
                    reason: ''
                };
                this.render();
                this.attachListeners();
            });
        });
        this.querySelectorAll('.cancel-action-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.expandedReportId = null;
                this.render();
                this.attachListeners();
            });
        });
        this.querySelectorAll('.action-select').forEach((select)=>{
            select.addEventListener('change', ()=>{
                const reportId = parseInt(select.getAttribute('data-report-id'), 10);
                if (!this.actionReasons[reportId]) this.actionReasons[reportId] = {
                    action: '',
                    reason: ''
                };
                this.actionReasons[reportId].action = select.value;
            });
        });
        this.querySelectorAll('.action-reason').forEach((textarea)=>{
            textarea.addEventListener('input', ()=>{
                const reportId = parseInt(textarea.getAttribute('data-report-id'), 10);
                if (!this.actionReasons[reportId]) this.actionReasons[reportId] = {
                    action: '',
                    reason: ''
                };
                this.actionReasons[reportId].reason = textarea.value;
            });
        });
        this.querySelectorAll('.apply-action-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const reportId = parseInt(btn.getAttribute('data-report-id'), 10);
                this.applyAction(reportId);
            });
        });
        this.querySelectorAll('.dismiss-report-btn').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const reportId = parseInt(btn.getAttribute('data-report-id'), 10);
                this.dismissReport(reportId);
            });
        });
    }
    getReport(reportId) {
        return this.reports.find((r)=>Number(r.id) === reportId);
    }
    async applyAction(reportId) {
        const report = this.getReport(reportId);
        if (!report) return;
        const form = this.actionReasons[reportId] || {};
        const actionType = form.action || this.querySelector(`#action-select-${reportId}`)?.value;
        const reason = (form.reason || this.querySelector(`#action-reason-${reportId}`)?.value || '').trim();
        if (!actionType) {
            this.showAlert('Choose an action first.', 'error');
            return;
        }
        if (reason.length < 3) {
            this.showAlert('Please enter a reason (at least 3 characters).', 'error');
            return;
        }
        if ($2b110806df4d29cd$var$DESTRUCTIVE_ACTIONS.has(actionType)) {
            const label = this.actionsForReport(report).find((a)=>a.value === actionType)?.label || actionType;
            if (!window.confirm(`Apply "${label}" to this report? This cannot be undone easily.`)) return;
        }
        this.submittingReportId = reportId;
        this.render();
        this.attachListeners();
        try {
            await window.API.request(`/groups/${this.groupId}/reports/${reportId}/actions`, {
                method: 'POST',
                body: JSON.stringify({
                    action_type: actionType,
                    target_type: report.target_type,
                    target_id: report.target_id,
                    reason: reason,
                    metadata_json: {}
                })
            });
            this.expandedReportId = null;
            delete this.actionReasons[reportId];
            this.showAlert('Moderation action recorded.', 'success');
            await this.load();
            this.dispatchEvent(new CustomEvent('group-members-changed', {
                bubbles: true
            }));
        } catch (e) {
            this.showAlert(e.message || 'Could not apply action', 'error');
        } finally{
            this.submittingReportId = null;
            this.render();
            this.attachListeners();
        }
    }
    async dismissReport(reportId) {
        const form = this.actionReasons[reportId] || {};
        const reason = (form.reason || this.querySelector(`#action-reason-${reportId}`)?.value || '').trim();
        if (!window.confirm('Dismiss this report with no moderation action?')) return;
        this.submittingReportId = reportId;
        this.render();
        this.attachListeners();
        try {
            await window.API.request(`/groups/${this.groupId}/reports/${reportId}/dismiss`, {
                method: 'POST',
                body: JSON.stringify(reason ? {
                    reason: reason
                } : {})
            });
            this.expandedReportId = null;
            delete this.actionReasons[reportId];
            this.showAlert('Report dismissed.', 'success');
            await this.load();
        } catch (e) {
            this.showAlert(e.message || 'Could not dismiss report', 'error');
        } finally{
            this.submittingReportId = null;
            this.render();
            this.attachListeners();
        }
    }
    showAlert(message, type = 'info') {
        this.dispatchEvent(new CustomEvent('group-moderation-alert', {
            detail: {
                message: message,
                type: type
            },
            bubbles: true
        }));
    }
}
customElements.define('group-settings-moderation', $2b110806df4d29cd$var$GroupSettingsModeration);
var $2b110806df4d29cd$export$2e2bcd8739ae039 = $2b110806df4d29cd$var$GroupSettingsModeration;


/**
 * @component group-invite-modal
 * @css group-invite-modal.css
 * @primitives .btn.btn-primary, .btn.btn-secondary
 */ 
class $3d8e3c5ff5ad1c67$var$GroupInviteModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.groupId = null;
        this.groupName = '';
        this.activeTab = 'friends';
        this.friends = [];
        this.selectedFriendId = null;
        this.loadingFriends = false;
        this.isSubmitting = false;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    open({ groupId: groupId, groupName: groupName }) {
        this.groupId = groupId;
        this.groupName = groupName || '';
        this.isOpen = true;
        this.activeTab = 'friends';
        this.selectedFriendId = null;
        this.friends = [];
        this.render();
        document.body.style.overflow = 'hidden';
        this.loadFriends();
        this.attachEventListeners();
    }
    close() {
        this.isOpen = false;
        this.isSubmitting = false;
        this.render();
        document.body.style.overflow = '';
    }
    async loadFriends() {
        if (this.loadingFriends || !this.isOpen) return;
        this.loadingFriends = true;
        this.updateTabContent();
        try {
            const response = await window.API.request('/friends');
            this.friends = response.friends || [];
        } catch  {
            this.friends = [];
        } finally{
            this.loadingFriends = false;
            this.updateTabContent();
        }
    }
    updateTabContent() {
        const content = this.querySelector('.invite-tab-content');
        if (content) {
            content.innerHTML = this.renderActiveTab();
            this.attachTabContentListeners();
        }
    }
    renderActiveTab() {
        if (this.activeTab === 'email') return `
        <form id="emailInviteForm">
          <div class="form-group">
            <label for="inviteEmailInput">Email address</label>
            <input
              type="email"
              id="inviteEmailInput"
              name="invite_email"
              placeholder="friend@example.com"
              required
            />
          </div>
        </form>
      `;
        if (this.loadingFriends) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading friends\u{2026}</p>
        </div>
      `;
        if (this.friends.length === 0) return '<p class="empty-hint">No friends to invite \u2014 try email instead.</p>';
        return `
      <div class="friend-pick-list">
        ${this.friends.map((f)=>{
            const checked = this.selectedFriendId === f.id ? 'checked' : '';
            return `
            <div class="friend-pick-item">
              <label>
                <input type="radio" name="friendPick" class="friend-radio" value="${f.id}" ${checked} />
                <span>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(f.username)}</span>
              </label>
            </div>
          `;
        }).join('')}
      </div>
    `;
    }
    render() {
        this.innerHTML = `
      <div class="group-invite-modal ${this.isOpen ? 'open' : ''}">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>\u{1F91D} Invite to ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.groupName || 'group')}</h3>
            <button type="button" class="close-btn" id="closeBtn" aria-label="Close">\xd7</button>
          </div>
          <div class="modal-body">
            <p class="modal-description">Invite a friend or send an email invitation to join this group.</p>
            <div class="invite-tabs">
              <button type="button" class="invite-tab ${this.activeTab === 'friends' ? 'active' : ''}" data-tab="friends">\u{1F465} Friend</button>
              <button type="button" class="invite-tab ${this.activeTab === 'email' ? 'active' : ''}" data-tab="email">\u{1F4E7} Email</button>
            </div>
            <div class="invite-tab-content">
              ${this.isOpen ? this.renderActiveTab() : ''}
            </div>
            <div class="form-actions">
              <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
              <button type="button" class="btn btn-primary" id="sendInviteBtn" ${this.isSubmitting ? 'disabled' : ''}>
                ${this.isSubmitting ? "Sending\u2026" : 'Send invite'}
              </button>
            </div>
            <div class="alert-container"></div>
          </div>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        if (!this.isOpen) return;
        this.querySelector('#modalBackdrop')?.addEventListener('click', ()=>this.close());
        this.querySelector('#closeBtn')?.addEventListener('click', ()=>this.close());
        this.querySelector('#cancelBtn')?.addEventListener('click', ()=>this.close());
        this.querySelector('#sendInviteBtn')?.addEventListener('click', ()=>this.handleSubmit());
        this.querySelectorAll('.invite-tab').forEach((tab)=>{
            tab.addEventListener('click', ()=>{
                this.activeTab = tab.getAttribute('data-tab');
                this.render();
                this.attachEventListeners();
                if (this.activeTab === 'friends' && this.friends.length === 0) this.loadFriends();
            });
        });
        this.attachTabContentListeners();
    }
    attachTabContentListeners() {
        this.querySelectorAll('.friend-radio').forEach((radio)=>{
            radio.addEventListener('change', ()=>{
                this.selectedFriendId = parseInt(radio.value, 10);
            });
        });
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('.alert-container');
        if (!container) return;
        container.innerHTML = `<div class="alert alert-${type}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(message)}</div>`;
    }
    async handleSubmit() {
        if (this.isSubmitting || !this.groupId) return;
        this.isSubmitting = true;
        const sendBtn = this.querySelector('#sendInviteBtn');
        if (sendBtn) {
            sendBtn.disabled = true;
            sendBtn.textContent = "Sending\u2026";
        }
        try {
            let body = {};
            if (this.activeTab === 'friends') {
                if (!this.selectedFriendId) {
                    this.showAlert('Pick a friend to invite', 'error');
                    return;
                }
                body = {
                    invited_user_id: this.selectedFriendId
                };
            } else {
                const email = this.querySelector('#inviteEmailInput')?.value?.trim();
                if (!email) {
                    this.showAlert('Enter an email address', 'error');
                    return;
                }
                body = {
                    invite_email: email
                };
            }
            await window.API.request(`/groups/${this.groupId}/invites`, {
                method: 'POST',
                body: JSON.stringify(body)
            });
            this.dispatchEvent(new CustomEvent('group-invite-sent', {
                bubbles: true
            }));
            this.close();
        } catch (error) {
            this.showAlert(error.message || 'Could not send invite', 'error');
        } finally{
            this.isSubmitting = false;
            const btn = this.querySelector('#sendInviteBtn');
            if (btn) {
                btn.disabled = false;
                btn.textContent = 'Send invite';
            }
        }
    }
}
customElements.define('group-invite-modal', $3d8e3c5ff5ad1c67$var$GroupInviteModal);
var $3d8e3c5ff5ad1c67$export$2e2bcd8739ae039 = $3d8e3c5ff5ad1c67$var$GroupInviteModal;



var $eZQHH = parcelRequire("eZQHH");

var $1L1Fr = parcelRequire("1L1Fr");

/**
 * /groups/invites/:token — preview and accept/decline group invitations.
 */ class $45699572412bf789$var$GroupInviteAcceptPage extends HTMLElement {
    constructor(){
        super();
        this.token = null;
        this.preview = null;
        this.currentUser = null;
        this.loading = true;
        this.error = null;
        this.submitting = false;
        this._headerProxy = null;
        this._avatarProxy = null;
        this._onAuthSuccess = this.handleAuthSuccess.bind(this);
    }
    static get observedAttributes() {
        return [
            'invite-token'
        ];
    }
    attributeChangedCallback(name, _old, value) {
        if (name === 'invite-token' && value !== this.token) {
            this.token = value;
            this.load();
        }
    }
    connectedCallback() {
        (0, $45c433acd12a8113$export$b25062376eaaf9ed)();
        this.token = this.getAttribute('invite-token');
        document.addEventListener('auth-status-loaded', this._onAuthSuccess);
        document.addEventListener('auth-success', this._onAuthSuccess);
        document.addEventListener('user-logged-out', this._onAuthSuccess);
        this.syncCurrentUser();
        this.load();
    }
    disconnectedCallback() {
        document.removeEventListener('auth-status-loaded', this._onAuthSuccess);
        document.removeEventListener('auth-success', this._onAuthSuccess);
        document.removeEventListener('user-logged-out', this._onAuthSuccess);
    }
    syncCurrentUser() {
        this.currentUser = window.currentUser || null;
    }
    handleAuthSuccess(e) {
        this.currentUser = e?.detail?.user || window.currentUser || null;
        this.load();
    }
    escapeHtml(value) {
        if (!value) return '';
        return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    async load() {
        if (!this.token || !window.API) return;
        this.loading = true;
        this.error = null;
        this.render();
        try {
            this.preview = await window.API.request(`/groups/invites/${this.token}/preview`);
            await this.loadImageProxies();
        } catch (e) {
            this.preview = null;
            this.error = e.message || 'Could not load invitation';
            (0, $eZQHH.default).warn('GroupInviteAcceptPage load failed', e);
        } finally{
            this.loading = false;
            this.render();
            this.attachListeners();
        }
    }
    async loadImageProxies() {
        this._headerProxy = null;
        this._avatarProxy = null;
        const uid = this.currentUser?.id;
        if (!uid || !this.preview?.group) return;
        if (this.preview.group.header_image_url) this._headerProxy = await (0, $1L1Fr.getProxyUrl)(this.preview.group.header_image_url, uid, null);
        if (this.preview.group.avatar_image_url) this._avatarProxy = await (0, $1L1Fr.getProxyUrl)(this.preview.group.avatar_image_url, uid, null);
    }
    setAuthReturnTo() {
        const path = `/groups/invites/${this.token}`;
        if (window.router?.setAuthReturnTo) window.router.setAuthReturnTo(path);
        else sessionStorage.setItem('fotAuthReturnTo', path);
    }
    async openLogin() {
        this.setAuthReturnTo();
        if (window.router?.openAuthModal) await window.router.openAuthModal('login');
    }
    async openRegister() {
        this.setAuthReturnTo();
        if (window.router?.openAuthModal) await window.router.openAuthModal('register', {
            prefillEmail: this.preview?.invite_email || null
        });
    }
    async acceptInvite() {
        if (this.submitting) return;
        this.submitting = true;
        this.render();
        try {
            const result = await window.API.request(`/groups/invites/${this.token}/accept`, {
                method: 'POST'
            });
            if (window.router?.navigate) window.router.navigate(`/groups/${result.group_id}`);
        } catch (e) {
            this.error = e.message || 'Could not accept invitation';
            this.submitting = false;
            this.render();
            this.attachListeners();
        }
    }
    async declineInvite() {
        if (this.submitting) return;
        this.submitting = true;
        this.render();
        try {
            await window.API.request(`/groups/invites/${this.token}/decline`, {
                method: 'POST'
            });
            if (window.router?.navigate) window.router.navigate('/groups');
        } catch (e) {
            this.error = e.message || 'Could not decline invitation';
            this.submitting = false;
            this.render();
            this.attachListeners();
        }
    }
    async logout() {
        try {
            await fetch('/api/auth/logout', {
                method: 'POST',
                credentials: 'include'
            });
        } catch (e) {
            (0, $eZQHH.default).warn('Logout failed on invite page', e);
        }
        this.currentUser = null;
        window.currentUser = null;
        document.dispatchEvent(new CustomEvent('user-logged-out', {
            bubbles: true
        }));
        this.load();
    }
    attachListeners() {
        this.querySelector('[data-action="login"]')?.addEventListener('click', ()=>this.openLogin());
        this.querySelector('[data-action="register"]')?.addEventListener('click', ()=>this.openRegister());
        this.querySelector('[data-action="accept"]')?.addEventListener('click', ()=>this.acceptInvite());
        this.querySelector('[data-action="decline"]')?.addEventListener('click', ()=>this.declineInvite());
        this.querySelector('[data-action="logout"]')?.addEventListener('click', ()=>this.logout());
        const root = this.querySelector('.group-invite-accept');
        const bannerColor = this.preview?.group?.header_banner_color || '';
        if (root && bannerColor.startsWith('#')) root.style.setProperty('--group-header-color', bannerColor);
        const ban = this.querySelector('.group-shell-banner.has-image');
        if (ban && this._headerProxy) ban.style.backgroundImage = `linear-gradient(120deg, rgba(0,0,0,.35), transparent), url(${this._headerProxy})`;
    }
    renderBanner() {
        const group = this.preview?.group;
        if (!group) return '';
        const bannerClass = [
            'group-shell-banner'
        ];
        if (this._headerProxy) bannerClass.push('has-image');
        const avatarHtml = this._avatarProxy ? `<img class="group-shell-avatar" src="${this._avatarProxy}" alt="" />` : '<div class="group-shell-avatar" aria-hidden="true">\uD83C\uDF31</div>';
        return `
      <header class="group-shell-header">
        <div class="${bannerClass.join(' ')}"></div>
        <div class="group-shell-heading">
          ${avatarHtml}
          <div class="group-shell-title-block">
            <h1>${this.escapeHtml(group.name)}</h1>
            ${group.description ? `<p>${this.escapeHtml(group.description)}</p>` : ''}
          </div>
        </div>
      </header>
    `;
    }
    renderActions() {
        if (!this.preview) return '';
        const { status: status, expired: expired, authenticated: authenticated, can_respond: can_respond, mismatch_reason: mismatch_reason, invitee_display: invitee_display } = this.preview;
        const inviter = this.preview.inviter?.username || 'Someone';
        const inviteLead = invitee_display ? `<strong>${this.escapeHtml(inviter)}</strong> invited <strong>${this.escapeHtml(invitee_display)}</strong> to join this group.` : `<strong>${this.escapeHtml(inviter)}</strong> invited someone to join this group.`;
        if (status !== 'pending' || expired) {
            const msg = expired ? 'This invitation has expired.' : `This invitation is ${status}.`;
            return `
        <div class="group-invite-accept-card card">
          <p class="group-invite-accept-lead">${this.escapeHtml(msg)}</p>
          <button type="button" class="btn btn-secondary" data-action="hub">Go to Groups</button>
        </div>
      `;
        }
        if (!authenticated) return `
        <div class="group-invite-accept-card card">
          <p class="group-invite-accept-lead">${inviteLead}</p>
          <p class="group-invite-accept-note">You need a Fun Old Times account to accept or decline.</p>
          <div class="group-invite-accept-actions">
            <button type="button" class="btn btn-primary" data-action="register">Create account</button>
            <button type="button" class="btn btn-secondary" data-action="login">Log in</button>
          </div>
        </div>
      `;
        if (mismatch_reason) return `
        <div class="group-invite-accept-card card">
          <p class="group-invite-accept-lead">${inviteLead}</p>
          <p class="group-invite-accept-note error">${this.escapeHtml(mismatch_reason)}</p>
          <div class="group-invite-accept-actions">
            <button type="button" class="btn btn-secondary" data-action="logout">Log out and switch account</button>
          </div>
        </div>
      `;
        if (can_respond) return `
        <div class="group-invite-accept-card card">
          <p class="group-invite-accept-lead">
            <strong>${this.escapeHtml(inviter)}</strong> invited you to join this group.
          </p>
          <div class="group-invite-accept-actions">
            <button type="button" class="btn btn-primary" data-action="accept" ${this.submitting ? 'disabled' : ''}>
              ${this.submitting ? "Joining\u2026" : 'Accept'}
            </button>
            <button type="button" class="btn btn-secondary" data-action="decline" ${this.submitting ? 'disabled' : ''}>
              Decline
            </button>
          </div>
        </div>
      `;
        return `
      <div class="group-invite-accept-card card">
        <p class="group-invite-accept-note">This invitation cannot be responded to right now.</p>
      </div>
    `;
    }
    render() {
        if (this.loading) {
            this.innerHTML = `
        <div class="group-invite-accept">
          <div class="loading-state"><div class="spinner"></div><div>Loading invitation\u{2026}</div></div>
        </div>
      `;
            return;
        }
        if (this.error && !this.preview) {
            this.innerHTML = `
        <div class="group-invite-accept">
          <p class="error">${this.escapeHtml(this.error)}</p>
        </div>
      `;
            return;
        }
        this.innerHTML = `
      <div class="group-invite-accept">
        ${this.renderBanner()}
        ${this.error ? `<p class="error">${this.escapeHtml(this.error)}</p>` : ''}
        ${this.renderActions()}
      </div>
    `;
        this.querySelector('[data-action="hub"]')?.addEventListener('click', ()=>{
            window.router?.navigate('/groups');
        });
    }
}
customElements.define('group-invite-accept-page', $45699572412bf789$var$GroupInviteAcceptPage);
var $45699572412bf789$export$2e2bcd8739ae039 = $45699572412bf789$var$GroupInviteAcceptPage;





const $9a0f6f620c73462b$var$MASCOTS = [
    {
        name: 'Tiny Party Panda',
        render: (0, $72156d6136272719$export$ecd7744ff94b6c2c)
    },
    {
        name: 'Party Panda',
        render: (0, $72156d6136272719$export$1bb9b41c0ac99906)
    },
    {
        name: 'Party Panda Megaphone',
        render: (0, $72156d6136272719$export$10887f604112412)
    },
    {
        name: 'Disco Capybara',
        render: (0, $72156d6136272719$export$c122825150439c0c)
    },
    {
        name: 'Safety Armadillo',
        render: (0, $72156d6136272719$export$37862db051631868)
    },
    {
        name: 'Taco UFO',
        render: (0, $72156d6136272719$export$49858dd6b5cd22f8)
    },
    {
        name: 'Missing Mole',
        render: (0, $72156d6136272719$export$5b8162d51027501d)
    },
    {
        name: 'Society Otter',
        render: (0, $72156d6136272719$export$54881ba96924d965)
    },
    {
        name: 'Gossip Goose',
        render: (0, $72156d6136272719$export$6d8f7be78b6bb2fb)
    }
];
class $9a0f6f620c73462b$var$MascotParadePage extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.handleFeatureFlagsLoaded = this.onFeatureFlagsLoaded.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
        this.renderContent();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
    }
    onFeatureFlagsLoaded() {
        this.renderContent();
    }
    load() {
        this.renderContent();
    }
    clear() {
        this.innerHTML = '';
    }
    renderContent() {
        if (!this.isAuthenticated()) return;
        if (!(0, $4bd131ffd9e749e2$export$87e0f7dd6dec932f)('mascot_parade')) {
            if (window.router) window.router.navigate('/');
            return;
        }
        this.innerHTML = `
      <div class="mascot-parade-page" data-testid="mascot-parade-page">
        <header class="mascot-parade-header">
          <h1>\u{1F3AA} Mascot Parade</h1>
          <p>Every friend of Fun Old Times, lined up and ready to party!</p>
        </header>
        <div class="mascot-parade-grid">
          ${$9a0f6f620c73462b$var$MASCOTS.map((m)=>`
            <div class="mascot-parade-card">
              <div class="mascot-parade-art">${m.render()}</div>
              <p class="mascot-parade-name">${m.name}</p>
            </div>
          `).join('')}
        </div>
      </div>
    `;
    }
}
customElements.define('mascot-parade-page', $9a0f6f620c73462b$var$MascotParadePage);


// Guest RSVP Component
// Handles the two-step verification flow for guests to RSVP to events

class $67d6a80ef3cc3fdf$var$GuestRSVP extends HTMLElement {
    constructor(){
        super();
        this.token = null;
        this.magicToken = null;
        this.event = null;
        this.invitation = null;
        this.guestInfo = null;
        this.step = 'verify'; // verify, request-link, authenticate, rsvp
        this.loading = false;
        this.errorMessage = null;
        this.successMessage = null;
        this.logger = window.logger || console;
        this.magicTokenProcessed = false;
    }
    connectedCallback() {
        const urlParams = new URLSearchParams(window.location.search);
        this.token = this.getAttribute('token') || urlParams.get('token');
        this.magicToken = urlParams.get('magicToken');
        const isGuestAccessRoute = window.location.pathname.startsWith('/events/guest-access');
        if (!this.token && this.magicToken && isGuestAccessRoute) {
            this.step = 'authenticate';
            this.render();
            return;
        }
        if (this.token) this.verifyToken();
        else this.renderError('No invitation token provided');
    }
    async verifyToken() {
        try {
            if (!this.token) {
                this.renderError('Missing invitation token');
                return;
            }
            this.loading = true;
            this.render();
            const data = await this.apiRequest(`/events/guest-verify/${encodeURIComponent(this.token)}`);
            if (data && data.invitation) {
                this.invitation = data.invitation;
                this.guestInfo = data.guest_info;
                this.event = {
                    id: data.invitation.event_id,
                    title: data.invitation.event_title,
                    start_time: data.invitation.start_time,
                    is_public: data.invitation.is_public,
                    inviter_username: data.invitation.inviter_username
                };
                this.errorMessage = null;
                this.step = 'request-link';
            } else this.renderError(data?.message || 'Invalid invitation token');
        } catch (error) {
            this.logger?.error('Failed to verify token:', error);
            this.renderError('Failed to verify invitation. Please try again.');
        } finally{
            this.loading = false;
            this.render();
        }
    }
    async requestMagicLink(deliveryMethod = 'email') {
        try {
            this.loading = true;
            this.render();
            await this.apiRequest(`/events/guest-verify/${encodeURIComponent(this.token)}`, {
                method: 'POST',
                body: JSON.stringify({
                    delivery_method: deliveryMethod
                })
            });
            this.step = 'authenticate';
            this.successMessage = `Magic link sent via ${deliveryMethod.toUpperCase()}.`;
        } catch (error) {
            this.logger?.error('Failed to request magic link:', error);
            this.renderError(error?.message || 'Failed to send magic link. Please try again.');
        } finally{
            this.loading = false;
            this.render();
        }
    }
    async authenticateGuest(magicToken) {
        try {
            this.loading = true;
            this.render();
            await this.apiRequest(`/events/guest-access/${encodeURIComponent(magicToken)}`);
            this.step = 'rsvp';
            await this.checkGuestSession();
        } catch (error) {
            this.logger?.error('Failed to authenticate guest:', error);
            this.renderError(error?.message || 'Failed to authenticate. Please try again.');
        } finally{
            this.loading = false;
            this.render();
        }
    }
    async checkGuestSession() {
        try {
            const data = await this.apiRequest('/events/guest-session');
            if (data.authenticated && data.event) {
                if (!this.event || this.event.id === data.event.id) this.event = {
                    ...this.event,
                    ...data.event
                };
                this.step = 'rsvp';
            } else this.step = 'request-link';
            this.render();
        } catch (error) {
            this.logger?.error('Failed to check guest session:', error);
        }
    }
    async submitRSVP(status) {
        try {
            this.loading = true;
            this.render();
            const data = await this.apiRequest('/events/guest-rsvp', {
                method: 'POST',
                body: JSON.stringify({
                    status: status
                })
            });
            this.event.user_rsvp = data?.rsvp_status || status;
            this.renderSuccess(`You've RSVP'd ${status === 'yes' ? 'Yes' : status === 'maybe' ? 'Maybe' : 'No'}`);
        } catch (error) {
            this.logger?.error('Failed to submit RSVP:', error);
            this.renderError(error?.message || 'Failed to submit RSVP. Please try again.');
        } finally{
            this.loading = false;
            this.render();
        }
    }
    render() {
        this.innerHTML = `
      <div class="guest-rsvp-container">
        ${this.errorMessage ? this.renderErrorCard(this.errorMessage) : this.renderContent()}
      </div>
    `;
        this.attachEventListeners();
    }
    renderContent() {
        if (this.loading) return `
        <div class="guest-rsvp-loading">
          <div class="spinner"></div>
          <p>Loading...</p>
        </div>
      `;
        if (!this.event && this.step === 'verify') return '';
        const successBanner = this.successMessage ? this.renderSuccessBanner(this.successMessage) : '';
        switch(this.step){
            case 'request-link':
                return `${successBanner}${this.renderRequestLink()}`;
            case 'authenticate':
                return `${successBanner}${this.renderAuthenticate()}`;
            case 'rsvp':
                return `${successBanner}${this.renderRSVP()}`;
            default:
                return '';
        }
    }
    renderRequestLink() {
        if (!this.event || !this.invitation) return this.renderErrorCard('Event invitation not found.');
        const contactOptions = [];
        if (this.guestInfo?.email) contactOptions.push({
            method: 'email',
            label: `Send to ${this.guestInfo.email}`,
            detail: 'Email magic link'
        });
        if (this.guestInfo?.phone) contactOptions.push({
            method: 'sms',
            label: `Text ${this.formatPhone(this.guestInfo.phone)}`,
            detail: 'SMS magic link'
        });
        return `
      <div class="guest-rsvp-card">
        <h2>Verify Your Invitation</h2>
        <div class="event-preview">
          <h3>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.title || 'Upcoming event')}</h3>
          ${this.event.start_time ? `
            <p class="event-date">\u{1F4C5} ${this.formatDate(this.event.start_time)}</p>
          ` : ''}
          <p class="event-description">
            Invited by ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.inviter_username || 'a friend')}
          </p>
        </div>
        <p class="instruction-text">
          To keep invitations secure, we\u{2019}ll send you a one-time magic link.
          Choose how you\u{2019}d like us to deliver it.
        </p>
        ${contactOptions.length ? `
          <button class="btn btn-primary" id="requestLinkBtn" data-method="${contactOptions[0].method}">
            Send Magic Link to ${contactOptions[0].method === 'sms' ? 'Phone' : 'Email'}
          </button>
          ${contactOptions.length > 1 ? `
            <div class="contact-options">
              ${contactOptions.map((option)=>`
                <button class="btn contact-option" data-method="${option.method}">
                  <strong>${option.label}</strong>
                  <span>${option.detail}</span>
                </button>
              `).join('')}
            </div>
          ` : ''}
        ` : `
          <div class="guest-rsvp-card error">
            <p>No contact info on file for this invitation. Please reach out to your host.</p>
          </div>
        `}
      </div>
    `;
    }
    renderAuthenticate() {
        const urlParams = new URLSearchParams(window.location.search);
        const magicToken = urlParams.get('magicToken');
        if (magicToken && !this.magicTokenProcessed) {
            this.magicTokenProcessed = true;
            // Auto-authenticate if magic token is in URL
            this.authenticateGuest(magicToken);
            return `
        <div class="guest-rsvp-loading">
          <div class="spinner"></div>
          <p>Authenticating...</p>
        </div>
      `;
        }
        return `
      <div class="guest-rsvp-card">
        <h2>\u{2705} Magic Link Sent!</h2>
        <p class="instruction-text">
          We've sent a magic link to your email address. 
          Click the link in the email to continue.
        </p>
        <p class="help-text">
          Check your inbox and spam folder. The link will expire in 1 hour.
        </p>
        <button class="btn btn-secondary" id="resendLinkBtn">
          Resend Magic Link
        </button>
      </div>
    `;
    }
    renderRSVP() {
        if (!this.event) return `
        <div class="guest-rsvp-card error">
          <h2>Event Not Available</h2>
          <p>We couldn't load the event details. Please request a new magic link.</p>
        </div>
      `;
        const rsvpStatus = this.event.user_rsvp || 'pending';
        return `
      <div class="guest-rsvp-card">
        <h2>RSVP to Event</h2>
        <div class="event-preview">
          <h3>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.title)}</h3>
          ${this.event.start_time ? `
            <p class="event-date">\u{1F4C5} ${new Date(this.event.start_time).toLocaleString()}</p>
          ` : ''}
          ${this.event.location ? `
            <p class="event-location">\u{1F4CD} ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.event.location)}</p>
          ` : ''}
        </div>
        ${rsvpStatus !== 'pending' ? `
          <div class="current-rsvp">
            <p><strong>Your RSVP:</strong> ${rsvpStatus === 'yes' ? "\u2705 Yes" : rsvpStatus === 'maybe' ? "\uD83E\uDD14 Maybe" : "\u274C No"}</p>
          </div>
        ` : ''}
        <div class="rsvp-buttons">
          <button class="btn rsvp-btn rsvp-yes ${rsvpStatus === 'yes' ? 'active' : ''}" 
                  data-status="yes">
            \u{2705} Yes
          </button>
          <button class="btn rsvp-btn rsvp-maybe ${rsvpStatus === 'maybe' ? 'active' : ''}" 
                  data-status="maybe">
            \u{1F914} Maybe
          </button>
          <button class="btn rsvp-btn rsvp-no ${rsvpStatus === 'no' ? 'active' : ''}" 
                  data-status="no">
            \u{274C} No
          </button>
        </div>
        ${rsvpStatus !== 'pending' ? `
          <p class="help-text">You can change your RSVP at any time.</p>
        ` : ''}
      </div>
    `;
    }
    renderSuccess(message) {
        this.successMessage = message;
        this.errorMessage = null;
        this.render();
    }
    renderError(message) {
        this.errorMessage = message;
        this.render();
    }
    renderErrorCard(message) {
        return `
      <div class="guest-rsvp-card error">
        <h2>Something went wrong</h2>
        <p>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(message)}</p>
        <button class="btn btn-secondary" onclick="window.location.href='/'">
          Go Home
        </button>
      </div>
    `;
    }
    renderSuccessBanner(message) {
        return `
      <div class="guest-rsvp-banner success">
        ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(message)}
      </div>
    `;
    }
    attachEventListeners() {
        const primaryButton = this.querySelector('#requestLinkBtn');
        if (primaryButton) primaryButton.addEventListener('click', (event)=>{
            const method = event.currentTarget.dataset.method || 'email';
            this.requestMagicLink(method);
        });
        const contactButtons = this.querySelectorAll('.contact-option');
        contactButtons.forEach((button)=>{
            button.addEventListener('click', (event)=>{
                const method = event.currentTarget.dataset.method;
                this.requestMagicLink(method);
            });
        });
        const resendBtn = this.querySelector('#resendLinkBtn');
        if (resendBtn) resendBtn.addEventListener('click', ()=>{
            this.step = 'request-link';
            this.render();
        });
        const rsvpBtns = this.querySelectorAll('.rsvp-btn');
        rsvpBtns.forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const status = e.target.dataset.status;
                this.submitRSVP(status);
            });
        });
        // Check for magic token in URL on page load
        if (this.step === 'authenticate' && !this.magicTokenProcessed) {
            const urlParams = new URLSearchParams(window.location.search);
            const magicToken = urlParams.get('magicToken');
            if (magicToken) {
                this.magicTokenProcessed = true;
                this.authenticateGuest(magicToken);
            }
        }
    }
    formatDate(dateString) {
        try {
            return new Date(dateString).toLocaleString();
        } catch (_error) {
            return dateString;
        }
    }
    formatPhone(phone) {
        if (!phone) return '';
        const sanitized = phone.replace(/[^\d]/g, '');
        if (sanitized.length === 10) return `(${sanitized.slice(0, 3)}) ${sanitized.slice(3, 6)}-${sanitized.slice(6)}`;
        return phone;
    }
    async apiRequest(endpoint, options = {}) {
        try {
            if (window.API?.request) return await window.API.request(endpoint, options);
            const response = await fetch(`/api${endpoint}`, {
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers || {}
                },
                ...options
            });
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                const message = errorData.message || errorData.error || 'Request failed';
                const error = new Error(message);
                error.details = errorData.details;
                throw error;
            }
            return await response.json();
        } catch (error) {
            this.logger?.error('Guest RSVP API error', error, {
                endpoint: endpoint
            });
            throw error;
        }
    }
}
customElements.define('guest-rsvp', $67d6a80ef3cc3fdf$var$GuestRSVP);


// Image Flags Web Component


class $d95149006e5275f5$var$ImageFlags extends HTMLElement {
    constructor(){
        super();
        this.flags = [];
        this.isLoading = false;
        this.currentUser = null;
        this.statusFilter = 'pending'; // pending, approved, rejected, or 'all'
        this.isLoadingFlags = false;
        this.actionHandler = null; // Store handler reference for cleanup
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
    }
    disconnectedCallback() {
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        // Remove action handler
        const content = this.querySelector('.flags-content');
        if (content && this.actionHandler) content.removeEventListener('click', this.actionHandler);
    }
    setupAuthListener() {
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user, authenticated: authenticated } = e.detail;
            if (authenticated && user && user.role === 'admin') {
                this.currentUser = user;
                if (this.isVisible()) this.loadFlags();
            } else this.currentUser = null;
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
    }
    isVisible() {
        return this.offsetParent !== null && !this.style.display.includes('none');
    }
    render() {
        this.innerHTML = `
      <div class="moderation-flags">
        <div class="flags-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDDBC\uFE0F", 'Image Flags')}
          <p>Review and moderate flagged images</p>
        </div>

        <div class="flags-filters">
          <button class="filter-btn ${this.statusFilter === 'all' ? 'active' : ''}" data-filter="all">
            All
          </button>
          <button class="filter-btn ${this.statusFilter === 'pending' ? 'active' : ''}" data-filter="pending">
            Pending
          </button>
          <button class="filter-btn ${this.statusFilter === 'approved' ? 'active' : ''}" data-filter="approved">
            Approved
          </button>
          <button class="filter-btn ${this.statusFilter === 'rejected' ? 'active' : ''}" data-filter="rejected">
            Rejected
          </button>
        </div>

        <div class="flags-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
        // Attach filter button listeners
        this.querySelectorAll('.filter-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const filter = e.target.dataset.filter;
                this.statusFilter = filter;
                this.updateFilters();
                this.loadFlags();
            });
        });
    }
    updateFilters() {
        this.querySelectorAll('.filter-btn').forEach((btn)=>{
            btn.classList.toggle('active', btn.dataset.filter === this.statusFilter);
        });
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading image flags...</div>
        </div>
      `;
        if (this.flags.length === 0) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F5BC}\u{FE0F}</div>
          <h3>No flags found</h3>
          <p>There are no image flags with the selected status.</p>
        </div>
      `;
        return `
      <div class="flags-list">
        ${this.flags.map((flag)=>this.renderFlagItem(flag)).join('')}
      </div>
    `;
    }
    renderFlagItem(flag) {
        const statusClass = flag.status || 'pending';
        const canReview = statusClass === 'pending';
        const imageUrl = flag.image_url || '';
        const isBlocked = imageUrl.includes('blocked') || imageUrl.length === 0;
        return `
      <div class="flag-item">
        <div class="flag-header">
          <div class="flag-info">
            <span class="flag-status ${statusClass}">${statusClass}</span>
          </div>
        </div>

        <div class="flag-image-container">
          ${isBlocked ? `
            <div class="flag-image-blocked">[Image blocked or unavailable]</div>
          ` : `
            <img src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(imageUrl)}" 
                 alt="Flagged image" 
                 class="flag-image"
                 loading="lazy"
                 onerror="this.parentElement.innerHTML='<div class=\\'flag-image-blocked\\'>[Image failed to load]</div>'"
                 referrerpolicy="no-referrer"
                 crossorigin="anonymous">
          `}
        </div>

        <div class="flag-details">
          <div class="flag-detail">
            <span class="flag-detail-label">Image URL</span>
            <span class="flag-detail-value" style="word-break: break-all; font-size: 0.875rem;">
              ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(imageUrl.substring(0, 100))}${imageUrl.length > 100 ? '...' : ''}
            </span>
          </div>
          <div class="flag-detail">
            <span class="flag-detail-label">Reason</span>
            <span class="flag-detail-value">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(flag.reason || 'N/A')}</span>
          </div>
          <div class="flag-detail">
            <span class="flag-detail-label">Flagged By</span>
            <span class="flag-detail-value">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(flag.flagged_by_username || 'Unknown')}</span>
          </div>
          <div class="flag-detail">
            <span class="flag-detail-label">Flagged At</span>
            <span class="flag-detail-value">${this.formatDate(flag.created_at)}</span>
          </div>
          ${flag.reviewed_at ? `
            <div class="flag-detail">
              <span class="flag-detail-label">Reviewed At</span>
              <span class="flag-detail-value">${this.formatDate(flag.reviewed_at)}</span>
            </div>
          ` : ''}
          ${flag.post_id ? `
            <div class="flag-detail">
              <span class="flag-detail-label">Post ID</span>
              <span class="flag-detail-value">#${flag.post_id}</span>
            </div>
          ` : ''}
          ${flag.comment_id ? `
            <div class="flag-detail">
              <span class="flag-detail-label">Comment ID</span>
              <span class="flag-detail-value">#${flag.comment_id}</span>
            </div>
          ` : ''}
        </div>

        ${canReview ? `
          <div class="flag-actions">
            <button class="flag-action-btn approve" 
                    data-flag-id="${flag.id}" 
                    data-action="approve">
              \u{2713} Approve
            </button>
            <button class="flag-action-btn reject" 
                    data-flag-id="${flag.id}" 
                    data-action="reject">
              \u{2717} Reject
            </button>
          </div>
        ` : ''}
      </div>
    `;
    }
    async loadFlags() {
        if (this.isLoadingFlags) return;
        if (!this.currentUser || this.currentUser.role !== 'admin') return;
        if (!this.isVisible()) return;
        this.isLoadingFlags = true;
        this.isLoading = true;
        this.updateContent();
        try {
            const url = this.statusFilter === 'all' ? '/admin/image-flags' : `/admin/image-flags?status=${this.statusFilter}`;
            const response = await window.API.request(url);
            if (response && response.flags) this.flags = response.flags;
            else this.flags = [];
        } catch (error) {
            window.logger?.error('Failed to load image flags:', error);
            this.flags = [];
            const content = this.querySelector('.flags-content');
            if (content) {
                const errorDiv = document.createElement('div');
                errorDiv.className = 'error-state';
                errorDiv.textContent = 'Failed to load image flags. Please try again.';
                content.innerHTML = '';
                content.appendChild(errorDiv);
                return;
            }
        } finally{
            this.isLoading = false;
            this.isLoadingFlags = false;
            this.updateContent();
        // attachActionListeners is called in updateContent, no need to call it again
        }
    }
    attachActionListeners() {
        const content = this.querySelector('.flags-content');
        if (!content) return;
        // Remove existing handler if any
        if (this.actionHandler) content.removeEventListener('click', this.actionHandler);
        // Use event delegation - attach one listener to the container
        this.actionHandler = async (e)=>{
            const btn = e.target.closest('.flag-action-btn');
            if (!btn) return;
            const flagId = btn.dataset.flagId;
            const action = btn.dataset.action;
            if (!flagId || !action) return;
            btn.disabled = true;
            try {
                await window.API.request(`/admin/image-flags/${flagId}/review`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        status: action === 'approve' ? 'approved' : 'rejected'
                    })
                });
                // Reload flags after review
                await this.loadFlags();
            } catch (error) {
                window.logger?.error('Failed to review flag:', error);
                btn.disabled = false;
                alert('Failed to review flag. Please try again.');
            }
        };
        content.addEventListener('click', this.actionHandler);
    }
    updateContent() {
        const content = this.querySelector('.flags-content');
        if (content) {
            content.innerHTML = this.renderContent();
            this.attachActionListeners();
        }
    }
    formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleString();
        } catch (_e) {
            return dateString;
        }
    }
    setCurrentUser(user) {
        this.currentUser = user;
        if (this.isVisible() && user && user.role === 'admin') this.loadFlags();
    }
}
// Register the custom element
customElements.define('image-flags', $d95149006e5275f5$var$ImageFlags);


// Widget Flags Web Component


/** @type {string[]|null} */ let $0e9422cfd4c14bfe$var$domains = null;
/** @type {Promise<void>|null} */ let $0e9422cfd4c14bfe$var$loadPromise = null;
function $0e9422cfd4c14bfe$export$56344e971e4bbd75() {
    if ($0e9422cfd4c14bfe$var$domains) return $0e9422cfd4c14bfe$var$loadPromise || Promise.resolve();
    if (!$0e9422cfd4c14bfe$var$loadPromise) $0e9422cfd4c14bfe$var$loadPromise = fetch('/api/blocked-domains').then((res)=>res.ok ? res.json() : {
            domains: []
        }).then((json)=>{
        $0e9422cfd4c14bfe$var$domains = Array.isArray(json.domains) ? json.domains : [];
    }).catch(()=>{
        $0e9422cfd4c14bfe$var$domains = [];
    });
    return $0e9422cfd4c14bfe$var$loadPromise;
}
function $0e9422cfd4c14bfe$export$76d7e403ff6f0ca2() {
    $0e9422cfd4c14bfe$var$domains = null;
    $0e9422cfd4c14bfe$var$loadPromise = null;
}
function $0e9422cfd4c14bfe$export$d140be97aca16ee5(hostname, blockedDomains) {
    if (!hostname || !blockedDomains?.length) return false;
    const host = hostname.toLowerCase();
    for (const blocked of blockedDomains){
        const domain = String(blocked || '').toLowerCase();
        if (!domain) continue;
        if (host === domain || host.endsWith('.' + domain)) return true;
    }
    return false;
}
function $0e9422cfd4c14bfe$export$444fddf1098af982(hostname) {
    return $0e9422cfd4c14bfe$export$d140be97aca16ee5(hostname, $0e9422cfd4c14bfe$var$domains || []);
}
function $0e9422cfd4c14bfe$export$808ad7191f43a9f6(url) {
    try {
        return $0e9422cfd4c14bfe$export$444fddf1098af982(new URL(url).hostname);
    } catch  {
        return true;
    }
}


/**
 * Validates a URL for parent-mediated external navigation from widgets.
 * @param {string} raw
 * @returns {string|null} Normalized https URL or null if unsafe
 */ function $287c0e75d884c56f$export$52e73ac81d7992ba(raw) {
    if (!raw || typeof raw !== 'string') return null;
    const trimmed = raw.trim();
    if (!/^https:\/\//i.test(trimmed)) return null;
    try {
        const url = new URL(trimmed);
        if (url.protocol !== 'https:') return null;
        if (url.username || url.password) return null;
        return url.href;
    } catch  {
        return null;
    }
}



function $a5da319c704aa0ee$export$29ac8f00d0f8fe39(rawUrl) {
    const url = (0, $287c0e75d884c56f$export$52e73ac81d7992ba)(rawUrl);
    if (!url) {
        window.logger?.warn('Blocked unsafe external URL:', rawUrl);
        return false;
    }
    if ((0, $0e9422cfd4c14bfe$export$808ad7191f43a9f6)(url)) {
        window.logger?.warn('Blocked external URL on domain blocklist:', url);
        return false;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
}


const $af08569b79d42cf2$var$PREVIEW_MIN_HEIGHT = 120;
const $af08569b79d42cf2$var$channelCleanups = new WeakMap();
const $af08569b79d42cf2$var$previewConfigGetters = new WeakMap();
const $af08569b79d42cf2$var$WIDGET_HOST_PLACEHOLDER = '__FOT_WIDGET_HOST_DOMAIN__';
const $af08569b79d42cf2$var$DEFAULT_WIDGET_HOST = 'http://localhost:19883';
function $af08569b79d42cf2$export$93120b5c6ce37c17() {
    const raw = window.FOT_WIDGET_HOST_DOMAIN;
    if (!raw || raw === $af08569b79d42cf2$var$WIDGET_HOST_PLACEHOLDER) return $af08569b79d42cf2$var$DEFAULT_WIDGET_HOST;
    try {
        const url = new URL(raw);
        return url.origin;
    } catch  {
        return $af08569b79d42cf2$var$DEFAULT_WIDGET_HOST;
    }
}
function $af08569b79d42cf2$export$5119e0017b458c4e(iframe) {
    const cleanup = $af08569b79d42cf2$var$channelCleanups.get(iframe);
    if (cleanup) cleanup();
    $af08569b79d42cf2$var$channelCleanups.delete(iframe);
}
function $af08569b79d42cf2$export$2f7fbc688f05668a(iframe, getter) {
    if (typeof getter === 'function') $af08569b79d42cf2$var$previewConfigGetters.set(iframe, getter);
    else $af08569b79d42cf2$var$previewConfigGetters.delete(iframe);
}
function $af08569b79d42cf2$export$97536d3e500521ae(iframe, { widgetId: widgetId = '', instanceId: instanceId = '', ownerUserId: ownerUserId = '', onReady: onReady, onResize: onResize, getInstanceConfig: getInstanceConfig } = {}) {
    (0, $0e9422cfd4c14bfe$export$56344e971e4bbd75)();
    $af08569b79d42cf2$export$5119e0017b458c4e(iframe);
    const channel = new MessageChannel();
    const port = channel.port1;
    const onMessage = (event)=>{
        const { type: type, requestId: requestId, height: height, url: url } = event.data || {};
        if (type === 'FOT.READY' || type === 'WIDGET_READY') onReady?.();
        if ((type === 'FOT.RESIZE' || type === 'WIDGET_RESIZE') && height) {
            const h = Math.max($af08569b79d42cf2$var$PREVIEW_MIN_HEIGHT, Number(height));
            onResize?.(h);
            iframe.style.height = `${h}px`;
        }
        if (type === 'FOT.OPEN_EXTERNAL') (0, $a5da319c704aa0ee$export$29ac8f00d0f8fe39)(url);
        if (type === 'FOT.GET_INSTANCE_CONFIG' && requestId) {
            const resolveConfig = ()=>{
                const getter = typeof getInstanceConfig === 'function' ? getInstanceConfig : $af08569b79d42cf2$var$previewConfigGetters.get(iframe);
                if (typeof getter === 'function') return Promise.resolve(getter()).then((config)=>config || {});
                return Promise.resolve({});
            };
            resolveConfig().then((config)=>{
                port.postMessage({
                    type: 'FOT.INSTANCE_CONFIG',
                    requestId: requestId,
                    config: config
                });
            }).catch((err)=>{
                window.logger?.warn('Widget preview config failed:', err);
                port.postMessage({
                    type: 'FOT.ERROR',
                    requestId: requestId,
                    code: 'UPSTREAM_ERROR',
                    message: 'Config request failed'
                });
            });
        }
    };
    port.addEventListener('message', onMessage);
    port.start();
    $af08569b79d42cf2$var$channelCleanups.set(iframe, ()=>{
        port.removeEventListener('message', onMessage);
        port.close();
    });
    const widgetOrigin = new URL($af08569b79d42cf2$export$93120b5c6ce37c17()).origin;
    iframe.contentWindow?.postMessage({
        type: 'WIDGET_CHANNEL_INIT',
        widgetId: String(widgetId),
        instanceId: instanceId ? String(instanceId) : '',
        ownerUserId: ownerUserId ? String(ownerUserId) : ''
    }, widgetOrigin, [
        channel.port2
    ]);
}
function $af08569b79d42cf2$export$539100bde0f3f280(iframe, { onReady: onReady, onError: onError, getInstanceConfig: getInstanceConfig } = {}) {
    if (typeof getInstanceConfig === 'function') $af08569b79d42cf2$export$2f7fbc688f05668a(iframe, getInstanceConfig);
    if (iframe.dataset.widgetHostPreviewBound) return;
    iframe.dataset.widgetHostPreviewBound = '1';
    iframe.style.height = `${$af08569b79d42cf2$var$PREVIEW_MIN_HEIGHT}px`;
    iframe.addEventListener('load', ()=>{
        try {
            $af08569b79d42cf2$export$97536d3e500521ae(iframe, {
                widgetId: iframe.dataset.widgetId || '',
                onReady: onReady,
                onResize: (h)=>{
                    iframe.style.height = `${h}px`;
                }
            });
        } catch (err) {
            window.logger?.warn('Widget preview channel failed:', err);
            onError?.(err);
        }
    });
    iframe.addEventListener('error', ()=>{
        onError?.(new Error('Widget preview iframe failed to load'));
    });
}
function $af08569b79d42cf2$export$2ac4fca7f859164f(iframe, url, { widgetId: widgetId = '', onReady: onReady, onError: onError, getInstanceConfig: getInstanceConfig } = {}) {
    iframe.dataset.widgetId = String(widgetId);
    $af08569b79d42cf2$export$539100bde0f3f280(iframe, {
        onReady: onReady,
        onError: onError,
        getInstanceConfig: getInstanceConfig
    });
    iframe.removeAttribute('srcdoc');
    iframe.src = url;
}
function $af08569b79d42cf2$export$f36cf66c9ae1e093(iframe, token, fields, formHost, { onReady: onReady, onError: onError, getInstanceConfig: getInstanceConfig } = {}) {
    const host = $af08569b79d42cf2$export$93120b5c6ce37c17();
    const container = formHost || iframe.closest('widget-management') || document.body;
    if (!iframe.name) iframe.name = iframe.dataset.previewName || `widget-preview-${Date.now()}`;
    iframe.dataset.widgetId = String(fields.widgetId || '');
    $af08569b79d42cf2$export$539100bde0f3f280(iframe, {
        onReady: onReady,
        onError: onError,
        getInstanceConfig: getInstanceConfig
    });
    let form = container.querySelector('[data-widget-draft-preview-form]');
    if (!form) {
        form = document.createElement('form');
        form.setAttribute('data-widget-draft-preview-form', '');
        form.method = 'POST';
        form.style.display = 'none';
        container.appendChild(form);
    }
    form.action = `${host}/render/preview/draft?token=${encodeURIComponent(token)}`;
    form.target = iframe.name;
    form.innerHTML = '';
    const entries = {
        name: fields.name || 'Widget preview',
        htmlContent: fields.htmlContent || '',
        cssContent: fields.cssContent || '',
        jsContent: fields.jsContent || ''
    };
    if (fields.widgetId) entries.widgetId = String(fields.widgetId);
    for (const [key, val] of Object.entries(entries)){
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = val;
        form.appendChild(input);
    }
    iframe.removeAttribute('srcdoc');
    form.submit();
}
function $af08569b79d42cf2$export$80ae1d8e0ce464c7() {
    return `Widget preview unavailable \u{2014} is widget-host running at ${$af08569b79d42cf2$export$93120b5c6ce37c17()}?`;
}


const $b9e147540244e5de$var$FLAG_REASON_LABELS = {
    inappropriate: 'Inappropriate content',
    copyright: 'Copyright concern',
    spam: 'Spam',
    broken: 'Broken or misleading',
    privacy: 'Privacy concern'
};
class $b9e147540244e5de$var$WidgetFlags extends HTMLElement {
    constructor(){
        super();
        this.flags = [];
        this.isLoading = false;
        this.isLoadingFlags = false;
        this.loadError = null;
        this.currentUser = null;
        this.statusFilter = 'pending';
        this.actionHandler = null;
        this.previewErrors = new Map();
        this.previewLoaded = new Set();
        this.handleSectionShown = null;
        this.handleAuthStatusLoaded = null;
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
        this.setupSectionListener();
        if (this.currentUser?.role === 'admin' && this.isVisible()) this.loadFlags();
    }
    disconnectedCallback() {
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        if (this.handleSectionShown) document.removeEventListener('section-shown', this.handleSectionShown);
        const content = this.querySelector('.flags-content');
        if (content && this.actionHandler) content.removeEventListener('click', this.actionHandler);
    }
    setupAuthListener() {
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user, authenticated: authenticated } = e.detail;
            if (authenticated && user?.role === 'admin') {
                this.currentUser = user;
                if (this.isVisible()) this.loadFlags();
            } else this.currentUser = null;
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
    }
    setupSectionListener() {
        this.handleSectionShown = (e)=>{
            if (e.detail?.section === 'admin-widget-flags' && this.currentUser?.role === 'admin') this.loadFlags();
        };
        document.addEventListener('section-shown', this.handleSectionShown);
    }
    isVisible() {
        return this.offsetParent !== null && !this.style.display.includes('none');
    }
    render() {
        this.innerHTML = `
      <div class="moderation-flags">
        <div class="flags-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83E\uDDE9", 'Widget Flags')}
          <p>Review flagged profile widgets</p>
        </div>
        <div class="flags-filters">
          <button type="button" class="filter-btn ${this.statusFilter === 'all' ? 'active' : ''}" data-filter="all">All</button>
          <button type="button" class="filter-btn ${this.statusFilter === 'pending' ? 'active' : ''}" data-filter="pending">Pending</button>
          <button type="button" class="filter-btn ${this.statusFilter === 'approved' ? 'active' : ''}" data-filter="approved">Approved</button>
          <button type="button" class="filter-btn ${this.statusFilter === 'rejected' ? 'active' : ''}" data-filter="rejected">Rejected</button>
        </div>
        <div class="flags-content">${this.renderContent()}</div>
      </div>
    `;
        this.querySelectorAll('.filter-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                this.statusFilter = e.currentTarget.dataset.filter;
                this.updateFilters();
                this.loadFlags();
            });
        });
    }
    updateFilters() {
        this.querySelectorAll('.filter-btn').forEach((btn)=>{
            btn.classList.toggle('active', btn.dataset.filter === this.statusFilter);
        });
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading widget flags\u{2026}</div>
        </div>
      `;
        if (this.loadError) return `<div class="error-state">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.loadError)}</div>`;
        if (!this.flags.length) {
            const filterLabel = this.statusFilter === 'all' ? '' : ` with status \u{201C}${this.statusFilter}\u{201D}`;
            return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F9E9}</div>
          <h3>No flags found</h3>
          <p>There are no widget flags${filterLabel}.</p>
        </div>
      `;
        }
        return `
      <div class="flags-list">
        ${this.flags.map((flag)=>this.renderFlagItem(flag)).join('')}
      </div>
    `;
    }
    renderFlagItem(flag) {
        const statusClass = flag.status || 'pending';
        const canReview = statusClass === 'pending';
        const widgetName = flag.widget_name || `Widget #${flag.widget_id}`;
        const reasonLabel = $b9e147540244e5de$var$FLAG_REASON_LABELS[flag.reason] || flag.reason || 'N/A';
        const previewError = this.previewErrors.get(flag.id);
        let profileHtml = 'Global (not on a profile)';
        if (flag.profile_owner_username) {
            const sectionSuffix = flag.section_id ? ` \xb7 slot ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(flag.section_id)}` : '';
            profileHtml = `
        <a href="/profile/${encodeURIComponent(flag.profile_owner_username)}" class="flag-profile-link">
          @${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(flag.profile_owner_username)}
        </a>${sectionSuffix}
      `;
        }
        return `
      <div class="flag-item" data-flag-id="${flag.id}" data-widget-id="${flag.widget_id}">
        <div class="flag-header">
          <h3 class="flag-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widgetName)}</h3>
          <span class="flag-status ${statusClass}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(statusClass)}</span>
        </div>

        <div class="flag-widget-preview" data-preview-container="${flag.id}">
          <iframe
            class="flag-widget-preview-frame"
            data-widget-id="${flag.widget_id}"
            data-flag-id="${flag.id}"
            title="Preview of ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widgetName)}"
            sandbox="allow-scripts allow-same-origin"
            loading="lazy"
          ></iframe>
          ${previewError ? `<p class="flag-widget-preview-error" role="status">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(previewError)}</p>` : ''}
        </div>

        <div class="flag-details">
          <div class="flag-detail">
            <span class="flag-detail-label">Reason</span>
            <span class="flag-detail-value">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(reasonLabel)}</span>
          </div>
          <div class="flag-detail">
            <span class="flag-detail-label">Flagged by</span>
            <span class="flag-detail-value">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(flag.flagged_by_username || 'Unknown')}</span>
          </div>
          <div class="flag-detail">
            <span class="flag-detail-label">Flagged at</span>
            <span class="flag-detail-value">${this.formatDate(flag.created_at)}</span>
          </div>
          <div class="flag-detail">
            <span class="flag-detail-label">Profile context</span>
            <span class="flag-detail-value">${profileHtml}</span>
          </div>
          ${flag.reviewed_at ? `
            <div class="flag-detail">
              <span class="flag-detail-label">Reviewed at</span>
              <span class="flag-detail-value">${this.formatDate(flag.reviewed_at)}</span>
            </div>
          ` : ''}
        </div>

        ${canReview ? `
          <div class="flag-actions">
            <button type="button" class="flag-action-btn approve"
                    data-flag-id="${flag.id}" data-action="approve">
              Dismiss flag
            </button>
            <button type="button" class="flag-action-btn reject"
                    data-flag-id="${flag.id}" data-action="reject">
              Uphold flag
            </button>
            <p class="form-text flag-action-hint">
              <strong>Dismiss</strong> means the widget is fine \u{2014} remove this report.
              <strong>Uphold</strong> keeps the widget gated or hidden for viewers.
              This is not the same as community catalog approval.
            </p>
          </div>
        ` : ''}
      </div>
    `;
    }
    async loadFlags() {
        if (this.isLoadingFlags) return;
        if (!this.currentUser || this.currentUser.role !== 'admin') return;
        if (!this.isVisible()) return;
        this.isLoadingFlags = true;
        this.isLoading = true;
        this.loadError = null;
        this.previewErrors = new Map();
        this.previewLoaded = new Set();
        this.updateContent();
        try {
            const url = this.statusFilter === 'all' ? '/admin/widget-flags' : `/admin/widget-flags?status=${this.statusFilter}`;
            const res = await window.API.request(url);
            this.flags = res.flags || [];
        } catch (err) {
            window.logger?.error('Failed to load widget flags:', err);
            this.flags = [];
            this.loadError = 'Failed to load widget flags. Please try again.';
        } finally{
            this.isLoading = false;
            this.isLoadingFlags = false;
            this.updateContent();
        }
    }
    updateContent() {
        const content = this.querySelector('.flags-content');
        if (content) {
            content.innerHTML = this.renderContent();
            this.attachActionListeners();
            this.schedulePreviewLoads();
        }
    }
    schedulePreviewLoads() {
        const frames = this.querySelectorAll('.flag-widget-preview-frame:not([data-preview-scheduled])');
        if (!frames.length) return;
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries)=>{
                for (const entry of entries){
                    if (!entry.isIntersecting) continue;
                    const iframe = entry.target;
                    observer.unobserve(iframe);
                    this.loadPreviewForIframe(iframe);
                }
            }, {
                rootMargin: '100px'
            });
            frames.forEach((frame)=>{
                frame.dataset.previewScheduled = '1';
                observer.observe(frame);
            });
            return;
        }
        frames.forEach((frame)=>{
            frame.dataset.previewScheduled = '1';
            this.loadPreviewForIframe(frame);
        });
    }
    async loadPreviewForIframe(iframe) {
        const widgetId = iframe.dataset.widgetId;
        const flagId = iframe.dataset.flagId;
        if (!widgetId || this.previewLoaded.has(flagId)) return;
        this.previewLoaded.add(flagId);
        try {
            const res = await window.API.request(`/widgets/${widgetId}/preview-token`, {
                method: 'POST'
            });
            const host = (0, $af08569b79d42cf2$export$93120b5c6ce37c17)();
            (0, $af08569b79d42cf2$export$2ac4fca7f859164f)(iframe, `${host}/render/preview/${widgetId}?token=${encodeURIComponent(res.token)}`, {
                widgetId: widgetId,
                onError: ()=>{
                    this.previewErrors.set(Number(flagId), (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)());
                    this.updatePreviewErrorDom(flagId);
                }
            });
        } catch (err) {
            window.logger?.warn('Widget flag preview failed:', err);
            this.previewErrors.set(Number(flagId), (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)());
            this.updatePreviewErrorDom(flagId);
        }
    }
    updatePreviewErrorDom(flagId) {
        const container = this.querySelector(`[data-preview-container="${flagId}"]`);
        if (!container) return;
        const msg = this.previewErrors.get(Number(flagId));
        let el = container.querySelector('.flag-widget-preview-error');
        if (msg) {
            if (!el) {
                el = document.createElement('p');
                el.className = 'flag-widget-preview-error';
                el.setAttribute('role', 'status');
                container.appendChild(el);
            }
            el.textContent = msg;
        } else if (el) el.remove();
    }
    attachActionListeners() {
        const content = this.querySelector('.flags-content');
        if (!content) return;
        if (this.actionHandler) content.removeEventListener('click', this.actionHandler);
        this.actionHandler = async (e)=>{
            const btn = e.target.closest('.flag-action-btn');
            if (!btn) return;
            const flagId = btn.dataset.flagId;
            const action = btn.dataset.action;
            if (!flagId || !action) return;
            btn.disabled = true;
            const status = action === 'approve' ? 'approved' : 'rejected';
            try {
                await window.API.request(`/admin/widget-flags/${flagId}/review`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        status: status
                    })
                });
                await this.loadFlags();
            } catch (err) {
                window.logger?.error('Failed to review widget flag:', err);
                btn.disabled = false;
                alert('Failed to review flag. Please try again.');
            }
        };
        content.addEventListener('click', this.actionHandler);
    }
    formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
            return new Date(dateString).toLocaleString();
        } catch  {
            return dateString;
        }
    }
    setCurrentUser(user) {
        this.currentUser = user;
        if (this.isVisible() && user?.role === 'admin') this.loadFlags();
    }
}
customElements.define('widget-flags', $b9e147540244e5de$var$WidgetFlags);


// Imported Friends Web Component

var $eZQHH = parcelRequire("eZQHH");


class $d68c7aa18191f72d$var$ImportedFriends extends HTMLElement {
    constructor(){
        super();
        this.friends = [];
        this.filteredFriends = [];
        this.isLoading = false;
        this.errorMessage = null;
        this.currentUser = null;
        this.currentStatus = 'pending';
        this.searchQuery = '';
        this.selectedFriendIds = new Set();
        this.currentPage = 1;
        this.pageSize = 50;
        this.totalFriends = 0;
        this._eventHandlersAttached = false;
    }
    connectedCallback() {
        this._eventHandlersAttached = false;
        this.render();
        this.loadUserAndFriends().then(()=>{
            this.attachEventListeners();
        });
    }
    async loadUserAndFriends() {
        try {
            if (!window.API) throw new Error('API not available');
            // Get current user
            const authData = await window.API.request('/auth/status');
            if (!authData.authenticated) throw new Error('User not authenticated');
            this.currentUser = authData.user;
            await this.loadFriends(this.currentStatus);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load user or friends:', error);
            this.errorMessage = 'Failed to load imported friends';
            this.isLoading = false;
            this.render();
        }
    }
    async loadFriends(status = null, page = 1) {
        this.isLoading = true;
        this.errorMessage = null;
        this.render();
        try {
            if (!window.API) throw new Error('API not available');
            const statusParam = status || this.currentStatus;
            const searchParam = this.searchQuery.trim() ? `&search=${encodeURIComponent(this.searchQuery.trim())}` : '';
            const data = await window.API.request(`/imported-friends?status=${statusParam}&page=${page}&limit=${this.pageSize}${searchParam}`);
            this.friends = data.friends || [];
            this.totalFriends = data.total || 0;
            this.currentPage = page;
            this.currentStatus = statusParam;
            this.applyFilters();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load imported friends:', error);
            this.errorMessage = 'Failed to load imported friends';
            this.friends = [];
            this.totalFriends = 0;
        } finally{
            this.isLoading = false;
            this.render();
            this.attachEventListeners();
        }
    }
    applyFilters() {
        // Search is now handled server-side, so just use the friends array directly
        this.filteredFriends = this.friends;
    }
    handleSearch(e) {
        this.searchQuery = e.target.value;
        // Debounce search to avoid too many API calls
        clearTimeout(this._searchTimeout);
        this._searchTimeout = setTimeout(()=>{
            this.currentPage = 1; // Reset to first page on new search
            this.loadFriends(this.currentStatus, 1);
        }, 300);
    }
    handleStatusFilter(e) {
        const status = e.target.value;
        this.currentStatus = status;
        this.selectedFriendIds.clear();
        this.currentPage = 1;
        this.loadFriends(status, 1);
    }
    toggleFriendSelection(friendId) {
        if (this.selectedFriendIds.has(friendId)) this.selectedFriendIds.delete(friendId);
        else this.selectedFriendIds.add(friendId);
        // Only update the UI without full re-render
        this.updateSelectionUI();
    }
    toggleSelectAll() {
        if (this.selectedFriendIds.size === this.filteredFriends.length) this.selectedFriendIds.clear();
        else this.selectedFriendIds = new Set(this.filteredFriends.map((f)=>f.id));
        // Only update the UI without full re-render
        this.updateSelectionUI();
    }
    updateSelectionUI() {
        // Update select all checkbox
        const selectAllCheckbox = this.querySelector('#selectAllCheckbox');
        if (selectAllCheckbox) {
            const allSelected = this.filteredFriends.length > 0 && this.selectedFriendIds.size === this.filteredFriends.length;
            selectAllCheckbox.checked = allSelected;
        }
        // Update individual checkboxes
        this.querySelectorAll('.friend-checkbox').forEach((checkbox)=>{
            const friendId = parseInt(checkbox.dataset.friendId);
            checkbox.checked = this.selectedFriendIds.has(friendId);
        });
        // Update friend item selected state
        this.querySelectorAll('.friend-item').forEach((item)=>{
            const checkbox = item.querySelector('.friend-checkbox');
            if (checkbox) {
                const friendId = parseInt(checkbox.dataset.friendId);
                if (this.selectedFriendIds.has(friendId)) item.classList.add('selected');
                else item.classList.remove('selected');
            }
        });
        // Update bulk action buttons (only ignore, no bulk invite)
        // Note: Event delegation handles clicks, so we don't need to attach listeners here
        const hasSelected = this.selectedFriendIds.size > 0;
        const bulkActions = this.querySelector('.bulk-actions');
        if (bulkActions) {
            const bulkButtons = bulkActions.querySelector('.bulk-buttons');
            if (hasSelected) {
                if (!bulkButtons) {
                    const buttonsDiv = document.createElement('div');
                    buttonsDiv.className = 'bulk-buttons';
                    buttonsDiv.innerHTML = `
            <button id="bulkIgnoreBtn" class="btn btn-secondary btn-sm">
              Ignore Selected (${this.selectedFriendIds.size})
            </button>
          `;
                    bulkActions.appendChild(buttonsDiv);
                } else {
                    const btn = bulkButtons.querySelector('#bulkIgnoreBtn');
                    if (btn) btn.textContent = `Ignore Selected (${this.selectedFriendIds.size})`;
                }
            } else if (bulkButtons) bulkButtons.remove();
        }
    }
    async inviteFriend(friendId) {
        try {
            if (!window.API) throw new Error('API not available');
            // Get email from the input field
            const emailInput = this.querySelector(`#email-input-${friendId}`);
            if (!emailInput) {
                alert('Email input not found. Please refresh the page.');
                return;
            }
            const email = emailInput.value.trim();
            if (!email) {
                alert('Please enter an email address before inviting.');
                emailInput.focus();
                return;
            }
            // Basic email validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                alert('Please enter a valid email address.');
                emailInput.focus();
                return;
            }
            const body = JSON.stringify({
                email: email
            });
            await window.API.request(`/imported-friends/${friendId}/invite`, {
                method: 'POST',
                body: body
            });
            // Optimistically update status instead of full reload
            const friend = this.friends.find((f)=>f.id === friendId);
            if (friend) friend.status = 'invited';
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to invite friend:', error);
            alert(error.message || 'Failed to invite friend. Please try again.');
            // Reload on error to ensure consistency
            await this.loadFriends(this.currentStatus, this.currentPage);
        }
    }
    async ignoreFriend(friendId) {
        // Add confirmation for single ignore
        if (!confirm('Are you sure you want to ignore this friend?')) return;
        try {
            if (!window.API) throw new Error('API not available');
            await window.API.request(`/imported-friends/${friendId}/ignore`, {
                method: 'POST'
            });
            // Optimistically remove from list instead of full reload
            this.friends = this.friends.filter((f)=>f.id !== friendId);
            this.filteredFriends = this.filteredFriends.filter((f)=>f.id !== friendId);
            this.selectedFriendIds.delete(friendId);
            this.totalFriends = Math.max(0, this.totalFriends - 1);
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to ignore friend:', error);
            alert('Failed to ignore friend. Please try again.');
            // Reload on error to ensure consistency
            await this.loadFriends(this.currentStatus, this.currentPage);
        }
    }
    async bulkIgnore() {
        if (this.selectedFriendIds.size === 0) {
            alert('Please select at least one friend to ignore.');
            return;
        }
        if (!confirm(`Ignore ${this.selectedFriendIds.size} friend(s)?`)) return;
        try {
            if (!window.API) throw new Error('API not available');
            await window.API.request('/imported-friends/bulk-ignore', {
                method: 'POST',
                body: JSON.stringify({
                    friendIds: Array.from(this.selectedFriendIds)
                })
            });
            // Optimistically remove from list instead of full reload
            const ignoredCount = this.selectedFriendIds.size;
            this.friends = this.friends.filter((f)=>!this.selectedFriendIds.has(f.id));
            this.filteredFriends = this.filteredFriends.filter((f)=>!this.selectedFriendIds.has(f.id));
            this.selectedFriendIds.clear();
            this.totalFriends = Math.max(0, this.totalFriends - ignoredCount);
            this.render();
            this.attachEventListeners();
        } catch (error) {
            (0, $eZQHH.default).error('Failed to bulk ignore friends:', error);
            alert('Failed to ignore friends. Please try again.');
            // Reload on error to ensure consistency
            await this.loadFriends(this.currentStatus, this.currentPage);
        }
    }
    getStatusBadge(status) {
        const badges = {
            pending: '<span class="status-badge status-pending">Pending</span>',
            invited: '<span class="status-badge status-invited">Invited</span>',
            ignored: '<span class="status-badge status-ignored">Ignored</span>',
            accepted: '<span class="status-badge status-accepted">Accepted</span>'
        };
        return badges[status] || `<span class="status-badge">${status}</span>`;
    }
    attachEventListeners() {
        // Only attach event handlers once
        if (this._eventHandlersAttached) return;
        // Status filter
        const statusFilter = this.querySelector('#statusFilter');
        if (statusFilter) statusFilter.addEventListener('change', (e)=>{
            this.currentPage = 1; // Reset to first page on status change
            this.handleStatusFilter(e);
        });
        // Search input
        const searchInput = this.querySelector('#searchInput');
        if (searchInput) searchInput.addEventListener('input', (e)=>this.handleSearch(e));
        // Select all checkbox
        const selectAllCheckbox = this.querySelector('#selectAllCheckbox');
        if (selectAllCheckbox) selectAllCheckbox.addEventListener('change', ()=>this.toggleSelectAll());
        // Use event delegation for dynamic elements (only attach once)
        this.addEventListener('change', (e)=>{
            if (e.target.classList.contains('friend-checkbox')) {
                const friendId = parseInt(e.target.dataset.friendId);
                this.toggleFriendSelection(friendId);
            }
        });
        this.addEventListener('click', async (e)=>{
            // Prevent double-clicks
            if (e.target.dataset.processing === 'true') {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            // Invite buttons
            if (e.target.classList.contains('invite-btn')) {
                e.preventDefault();
                e.stopPropagation();
                e.target.dataset.processing = 'true';
                const friendId = parseInt(e.target.dataset.friendId);
                await this.inviteFriend(friendId);
                e.target.dataset.processing = 'false';
            } else if (e.target.classList.contains('ignore-btn')) {
                e.preventDefault();
                e.stopPropagation();
                e.target.dataset.processing = 'true';
                const friendId = parseInt(e.target.dataset.friendId);
                await this.ignoreFriend(friendId);
                e.target.dataset.processing = 'false';
            } else if (e.target.id === 'bulkIgnoreBtn') {
                e.preventDefault();
                e.stopPropagation();
                e.target.dataset.processing = 'true';
                await this.bulkIgnore();
                e.target.dataset.processing = 'false';
            } else if (e.target.classList.contains('page-btn')) {
                e.preventDefault();
                e.stopPropagation();
                const page = parseInt(e.target.dataset.page);
                if (page && page !== this.currentPage) this.loadFriends(this.currentStatus, page);
            } else if (e.target.id === 'returnToSettingsBtn') {
                e.preventDefault();
                e.stopPropagation();
                window.router.navigate('/settings');
            }
        });
        // Handle Enter key in email inputs
        this.addEventListener('keydown', async (e)=>{
            if (e.target.classList.contains('email-input') && e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                const friendId = parseInt(e.target.id.replace('email-input-', ''));
                if (friendId) await this.inviteFriend(friendId);
            }
        });
        this._eventHandlersAttached = true;
    }
    render() {
        if (this.isLoading && this.friends.length === 0) {
            this.innerHTML = `
        <div class="imported-friends">
          <div class="loading-state">
            <div class="spinner"></div>
            <div>Loading imported friends...</div>
          </div>
        </div>
      `;
            return;
        }
        const hasSelected = this.selectedFriendIds.size > 0;
        const allSelected = this.filteredFriends.length > 0 && this.selectedFriendIds.size === this.filteredFriends.length;
        this.innerHTML = `
      <div class="imported-friends">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDC65", 'Imported Friends')}
          <p>Manage friends imported from your Facebook export</p>
        </div>

        ${this.errorMessage ? `
          <div class="error-message">
            ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.errorMessage)}
          </div>
        ` : ''}

        <div class="filters-section">
          <div class="filter-group">
            <label for="statusFilter">Filter by Status:</label>
            <select id="statusFilter">
              <option value="pending" ${this.currentStatus === 'pending' ? 'selected' : ''}>Pending</option>
              <option value="invited" ${this.currentStatus === 'invited' ? 'selected' : ''}>Invited</option>
              <option value="ignored" ${this.currentStatus === 'ignored' ? 'selected' : ''}>Ignored</option>
              <option value="accepted" ${this.currentStatus === 'accepted' ? 'selected' : ''}>Accepted</option>
            </select>
          </div>

          <div class="filter-group">
            <label for="searchInput">Search:</label>
            <input 
              type="text" 
              id="searchInput" 
              placeholder="Search by name or email..."
              value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.searchQuery)}"
            />
          </div>
        </div>

        ${this.filteredFriends.length > 0 ? `
          <div class="bulk-actions">
            <label class="checkbox-label">
              <input 
                type="checkbox" 
                id="selectAllCheckbox"
                ${allSelected ? 'checked' : ''}
              />
              <span>Select All (${this.filteredFriends.length})</span>
            </label>
            ${hasSelected ? `
              <div class="bulk-buttons">
                <button id="bulkIgnoreBtn" class="btn btn-secondary btn-sm">
                  Ignore Selected (${this.selectedFriendIds.size})
                </button>
              </div>
            ` : ''}
          </div>
        ` : ''}

        <div class="friends-section">
          ${this.filteredFriends.length === 0 ? `
            <div class="empty-state">
              <p>${this.friends.length === 0 ? 'No imported friends found. Import your Facebook friends first!' : 'No friends match your search criteria.'}</p>
            </div>
          ` : `
            <div class="friends-list">
              ${this.filteredFriends.map((friend)=>{
            const isSelected = this.selectedFriendIds.has(friend.id);
            const canInvite = friend.status === 'pending';
            const canIgnore = friend.status === 'pending' || friend.status === 'invited';
            return `
                  <div class="friend-item ${isSelected ? 'selected' : ''}">
                    <div class="friend-checkbox-container">
                      <input 
                        type="checkbox" 
                        class="friend-checkbox"
                        data-friend-id="${friend.id}"
                        ${isSelected ? 'checked' : ''}
                      />
                    </div>
                    <div class="friend-info">
                      <div class="friend-name">
                        ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(friend.facebookName || 'Unknown')}
                        ${this.getStatusBadge(friend.status)}
                      </div>
                    </div>
                    <div class="friend-email-input">
                      <input 
                        type="email" 
                        id="email-input-${friend.id}"
                        class="email-input"
                        placeholder="Enter email address"
                        value="${friend.email ? (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(friend.email) : ''}"
                        ${friend.status === 'invited' || friend.status === 'accepted' ? 'disabled' : ''}
                      />
                    </div>
                    <div class="friend-actions">
                      ${canInvite ? `
                        <button 
                          class="btn btn-primary btn-sm invite-btn"
                          data-friend-id="${friend.id}"
                        >
                          Invite
                        </button>
                      ` : ''}
                      ${canIgnore ? `
                        <button 
                          class="btn btn-secondary btn-sm ignore-btn"
                          data-friend-id="${friend.id}"
                        >
                          Ignore
                        </button>
                      ` : ''}
                    </div>
                  </div>
                `;
        }).join('')}
            </div>
          `}
        </div>

        ${this.totalFriends > this.pageSize ? `
          <div class="pagination">
            <div class="pagination-info">
              Showing ${(this.currentPage - 1) * this.pageSize + 1} - ${Math.min(this.currentPage * this.pageSize, this.totalFriends)} of ${this.totalFriends}
            </div>
            <div class="pagination-buttons">
              ${this.currentPage > 1 ? `
                <button class="btn btn-secondary btn-sm page-btn" data-page="${this.currentPage - 1}">
                  \u{2190} Previous
                </button>
              ` : ''}
              ${this.currentPage * this.pageSize < this.totalFriends ? `
                <button class="btn btn-secondary btn-sm page-btn" data-page="${this.currentPage + 1}">
                  Next \u{2192}
                </button>
              ` : ''}
            </div>
          </div>
        ` : ''}

        <div class="settings-footer">
          <button class="btn btn-secondary" id="returnToSettingsBtn">
            \u{2190} Return to Settings
          </button>
        </div>
      </div>
    `;
        // Re-attach listeners after render
        this.attachEventListeners();
    }
}
// Register the custom element
customElements.define('imported-friends', $d68c7aa18191f72d$var$ImportedFriends);


// Invitations List Web Component

class $dcd2c399c2890013$var$InvitationsList extends HTMLElement {
    constructor(){
        super();
        this.invitations = [];
        this.isLoading = true;
        this.isLoadingInvitations = false;
        this.currentUser = null;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.loadInvitations();
    }
    isVisible() {
        // Check if the parent friends-section is visible
        const friendsSection = document.getElementById('friends-section');
        const sectionVisible = friendsSection && !friendsSection.classList.contains('hidden');
        return sectionVisible;
    }
    render() {
        this.innerHTML = `
      <div class="invitations-list">
        <div class="invitations-header">
          <h3>\u{1F4E8} Sent Invitations</h3>
          <button class="btn btn-sm btn-outline refresh-btn" id="refreshBtn">
            \u{1F504} Refresh
          </button>
        </div>

        <div class="invitations-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading invitations...</p>
        </div>
      `;
        // Filter out accepted invitations - they're now friends, no need to show them
        const pendingInvitations = (this.invitations || []).filter((inv)=>inv.status !== 'accepted' && !inv.isExpired);
        if (pendingInvitations.length === 0) return `
        <div class="empty-state">
          <span class="empty-state-icon">\u{1F4E8}</span>
          <h4>No invitations sent</h4>
          <p>Invite friends to join Fun Old Times from the home page!</p>
        </div>
      `;
        return `
      <div id="alertContainer"></div>
      ${pendingInvitations.map((inv)=>this.renderInvitation(inv)).join('')}
    `;
    }
    renderInvitation(invitation) {
        const { id: id, email: email, status: status, createdAt: createdAt, lastSentAt: lastSentAt, isExpired: isExpired } = invitation;
        const statusClass = isExpired ? 'expired' : status;
        const displayStatus = isExpired ? 'expired' : status;
        const lastSentDate = new Date(lastSentAt);
        const now = new Date();
        const daysSinceLastSent = (now - lastSentDate) / 86400000;
        // Check if current user is admin
        const isAdmin = this.currentUser && this.currentUser.role === 'admin';
        // Admins can always resend, regular users follow the 1-day rule
        const canResend = isAdmin || status === 'pending' && !isExpired && daysSinceLastSent >= 1 || isExpired;
        const daysUntilResend = canResend ? 0 : Math.ceil(1 - daysSinceLastSent);
        return `
      <div class="invitation-item ${statusClass}" data-invitation-id="${id}">
        <div class="invitation-info">
          <div class="invitation-email">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(email)}</div>
          <div class="invitation-meta">
            Sent ${this.formatDate(createdAt)}
            ${lastSentAt && lastSentAt !== createdAt ? ` \u{2022} Last reminder ${this.formatDate(lastSentAt)}` : ''}
          </div>
          <span class="invitation-status status-${displayStatus}">
            ${displayStatus === 'pending' ? "\u23F3 Pending" : ''}
            ${displayStatus === 'accepted' ? "\u2705 Accepted" : ''}
            ${displayStatus === 'expired' ? "\u23F0 Expired" : ''}
          </span>
        </div>
        <div class="invitation-actions">
          ${status === 'pending' || isExpired ? `
            <button 
              class="resend-btn ${isAdmin ? 'admin-resend' : ''}" 
              data-invitation-id="${id}"
              ${!canResend ? 'disabled' : ''}
              title="${!canResend ? `Can resend in ${daysUntilResend} day${daysUntilResend !== 1 ? 's' : ''}` : isAdmin ? 'Admin: Resend invitation email (no throttling)' : 'Resend invitation email'}"
            >
              ${canResend ? isExpired ? "\uD83D\uDD04 Resend" : isAdmin ? "\u26A1 Resend" : "\uD83D\uDCE7 Resend" : `\u{1F550} ${daysUntilResend}d`}
            </button>
          ` : ''}
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Refresh button
        const refreshBtn = this.querySelector('#refreshBtn');
        refreshBtn?.addEventListener('click', ()=>{
            this.loadInvitations();
        });
        // Resend buttons
        this.addEventListener('click', (e)=>{
            if (e.target.closest('.resend-btn')) {
                const btn = e.target.closest('.resend-btn');
                const invitationId = btn.dataset.invitationId;
                if (!btn.disabled) this.resendInvitation(invitationId, btn);
            }
        });
        // Listen for section shown events to load invitations when Friends section is displayed
        this.handleSectionShown = (event)=>{
            if (event.detail.section === 'friends') // Only load invitations if we have a current user and API is available
            {
                if (this.currentUser && window.API && this.isAuthenticated()) this.loadInvitations();
            }
        };
        document.addEventListener('section-shown', this.handleSectionShown);
        // Listen for invitation events
        this.handleInvitationSent = ()=>{
            // Refresh to show new invitation
            setTimeout(()=>this.loadInvitations(), 500);
        };
        document.addEventListener('invitation-sent', this.handleInvitationSent);
        // Listen for invitation accepted events to refresh the list
        this.handleInvitationAccepted = ()=>{
            // Refresh to remove accepted invitation from list
            setTimeout(()=>this.loadInvitations(), 500);
        };
        document.addEventListener('invitation-accepted', this.handleInvitationAccepted);
    }
    async loadInvitations() {
        // Prevent multiple simultaneous calls
        if (this.isLoadingInvitations) return;
        this.isLoadingInvitations = true;
        this.isLoading = true;
        this.updateContent();
        try {
            const response = await window.API.request('/invitations');
            this.invitations = response.invitations || [];
        } catch (error) {
            window.logger.error('Failed to load invitations:', error);
            this.invitations = [];
            this.showError('Failed to load invitations');
        } finally{
            this.isLoading = false;
            this.isLoadingInvitations = false;
            this.updateContent();
        }
    }
    isAuthenticated() {
        return this.currentUser && this.currentUser.id;
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10000';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
    updateContent() {
        const contentContainer = this.querySelector('.invitations-content');
        if (contentContainer) {
            contentContainer.innerHTML = this.renderContent();
            this.attachEventListeners();
        }
    }
    async resendInvitation(invitationId, btn) {
        const originalContent = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = "\u23F3 Sending...";
        try {
            const response = await window.API.request(`/invitations/resend/${invitationId}`, {
                method: 'POST'
            });
            // Show success message
            this.showAlert(response.message, 'success');
            // Refresh the invitations
            await this.loadInvitations();
        } catch (error) {
            window.logger.error('Failed to resend invitation:', error);
            btn.disabled = false;
            btn.innerHTML = originalContent;
            this.showAlert(error.message || 'Failed to resend invitation', 'error');
        }
    }
    formatDate(dateString) {
        const date = new Date(dateString);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return 'just now';
        else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes}m ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours}h ago`;
        } else {
            const days = Math.floor(diffInSeconds / 86400);
            if (days < 7) return `${days}d ago`;
            else return date.toLocaleDateString();
        }
    }
    showAlert(message, type = 'success') {
        const alertContainer = this.querySelector('#alertContainer');
        if (!alertContainer) return;
        const alert = document.createElement('div');
        alert.className = `alert alert-${type}`;
        alert.textContent = message;
        alertContainer.innerHTML = '';
        alertContainer.appendChild(alert);
        // Auto-dismiss after 4 seconds
        setTimeout(()=>{
            alert.remove();
        }, 4000);
    }
    // Public method to refresh invitations
    refresh() {
        this.loadInvitations();
    }
    disconnectedCallback() {
        // Clean up event listeners to prevent memory leaks
        if (this.handleSectionShown) document.removeEventListener('section-shown', this.handleSectionShown);
        if (this.handleInvitationSent) document.removeEventListener('invitation-sent', this.handleInvitationSent);
        if (this.handleInvitationAccepted) document.removeEventListener('invitation-accepted', this.handleInvitationAccepted);
    }
}
// Register the custom element
customElements.define('invitations-list', $dcd2c399c2890013$var$InvitationsList);


// Invite Friend Modal Web Component
class $73220af24ab72320$var$InviteFriendModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.isLoading = false;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="invite-modal ${this.isOpen ? 'open' : ''}" id="inviteModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>\u{1F91D} Invite a Friend</h3>
            <button class="close-btn" id="closeBtn">\xd7</button>
          </div>
          
          <div class="modal-body">
            <p class="modal-description">
              Invite someone to join Fun Old Times! They'll automatically become your friend when they sign up.
            </p>
            
            <form class="invite-form" id="inviteForm">
              <div class="form-group">
                <label for="email">Email address:</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  placeholder="friend@example.com"
                  required
                >
                <div class="input-hint">
                  Enter the email address where you'd like to send the invitation
                </div>
              </div>
              
              <div class="form-actions">
                <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
                <button type="submit" class="btn btn-primary" id="sendBtn">
                  <span class="btn-text">Send Invitation</span>
                  <span class="btn-loading" style="display: none;">\u{23F3} Sending...</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Close modal handlers
        const closeBtn = this.querySelector('#closeBtn');
        const cancelBtn = this.querySelector('#cancelBtn');
        const backdrop = this.querySelector('#modalBackdrop');
        const form = this.querySelector('#inviteForm');
        const closeModal = ()=>{
            this.close();
        };
        closeBtn?.addEventListener('click', closeModal);
        cancelBtn?.addEventListener('click', closeModal);
        backdrop?.addEventListener('click', closeModal);
        // Form submission
        form?.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handleSubmit();
        });
        // Keyboard handlers
        document.addEventListener('keydown', (e)=>{
            if (this.isOpen && e.key === 'Escape') closeModal();
        });
    }
    async handleSubmit() {
        if (this.isLoading) return;
        const form = this.querySelector('#inviteForm');
        const formData = new FormData(form);
        const email = formData.get('email').trim();
        if (!email) {
            this.showError('Please enter an email address');
            return;
        }
        this.setLoading(true);
        try {
            await window.API.request('/invitations/send', {
                method: 'POST',
                body: JSON.stringify({
                    email: email
                })
            });
            this.showSuccess(`Invitation sent successfully to ${email}!`);
            this.close();
            // Dispatch event for other components
            this.dispatchEvent(new CustomEvent('invitation-sent', {
                detail: {
                    email: email
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to send invitation:', error);
            this.showError(error.message || 'Failed to send invitation');
        } finally{
            this.setLoading(false);
        }
    }
    setLoading(loading) {
        this.isLoading = loading;
        const sendBtn = this.querySelector('#sendBtn');
        if (loading) {
            sendBtn.classList.add('loading');
            sendBtn.disabled = true;
        } else {
            sendBtn.classList.remove('loading');
            sendBtn.disabled = false;
        }
    }
    showSuccess(message) {
        const successDiv = document.createElement('div');
        successDiv.className = 'alert alert-success';
        successDiv.textContent = message;
        successDiv.style.position = 'fixed';
        successDiv.style.top = '20px';
        successDiv.style.right = '20px';
        successDiv.style.zIndex = '10001';
        successDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(successDiv);
        setTimeout(()=>successDiv.remove(), 4000);
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10001';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
    open() {
        this.isOpen = true;
        this.render();
        this.attachEventListeners();
        // Focus the email input
        setTimeout(()=>{
            const emailInput = this.querySelector('#email');
            emailInput?.focus();
        }, 100);
    }
    close() {
        this.isOpen = false;
        this.render();
        this.attachEventListeners();
    }
}
// Register the custom element
customElements.define('invite-friend-modal', $73220af24ab72320$var$InviteFriendModal);


class $b38f9eb4f68e0524$var$LandingPage extends HTMLElement {
    constructor(){
        super();
        this.hasRendered = false;
        this.ethos = [
            {
                title: 'Radical Friend Privacy',
                copy: 'Your posts stop with your friends. No feeds, no FOMO roulette, no growth hacks.'
            },
            {
                title: 'Intentional Mischief',
                copy: 'Events, prompts, GIF duels, and mood music that reward the people who actually show up.'
            },
            {
                title: 'Kindness Guardrails',
                copy: 'Audit logs, human review, and friend-of-friend invitations only.'
            }
        ];
        this.checklist = [
            {
                title: 'You remember AIM away messages',
                copy: 'and maybe still have your favorite CSS glitter text saved somewhere.'
            },
            {
                title: 'You send playlists at 2 AM',
                copy: 'because vulnerability tastes better with a lo-fi beat drop.'
            },
            {
                title: 'You want fewer algorithms',
                copy: 'and more tiny celebrations from the 6 people who actually know you.'
            },
            {
                title: 'You treat safety seriously',
                copy: 'and want a team obsessed with monitoring before monetizing.'
            },
            {
                title: 'You spin the writing prompt washing machine',
                copy: 'and let it spit out delightful chaos when your brain needs a nudge.'
            }
        ];
        this.carousel = [
            {
                label: 'Posts',
                title: 'Moody Monday Zines',
                copy: 'Friends build collaborative zines with scanned doodles and shared photos.'
            },
            {
                label: 'Events',
                title: 'Midnight Snack Club',
                copy: 'Recurring invite where everyone shares weird recipes + polls the raccoon.'
            },
            {
                label: 'Prompts',
                title: 'Washing Machine Inspiration',
                copy: 'Push the big button, get a random writing prompt, then share it with friends.'
            }
        ];
        this.funFacts = [
            'Your posts could include handmade doodles or polaroids.',
            'The prompt washing machine keeps generating weird ideas and you can add to them.',
            'You can create your bi-weekly game night and keep folks up to date.',
            'Share those jams you\'re currently vibing to.'
        ];
        this.factIndex = 0;
    }
    connectedCallback() {
        if (this.hasRendered) return;
        this.render();
        this.startFunFactTicker();
        this.hasRendered = true;
    }
    disconnectedCallback() {
        if (this.tickerInterval) clearInterval(this.tickerInterval);
    }
    render() {
        this.innerHTML = `
      <section class="landing-page" aria-label="Fun Old Times public welcome">
        ${this.renderHero()}
        ${this.renderEthos()}
        ${this.renderChecklist()}
        ${this.renderCarousel()}
        ${this.renderSecondaryCTA()}
      </section>
    `;
        this.bindCTAButtons();
    }
    renderHero() {
        return `
      <div class="landing-hero">
        <div>
          <p class="landing-hero__eyebrow">Friends first \u{2022} Weird always</p>
          <h1 class="landing-hero__title">
            A cozy internet clubhouse where <span>only your friends</span> see your best chaos.
          </h1>
          <p class="landing-hero__copy">
            No algorithms. No infinite scroll. Just bright colors, silly prompts, and the six people who still laugh at your AIM away messages.
          </p>
          <div class="landing-hero__cta" role="group" aria-label="Get started">
            <button class="primary" data-auth-mode="register" data-surface="hero_primary">Sign up free</button>
            <button class="secondary" data-auth-mode="login" data-surface="hero_secondary">Already a member? Log in</button>
          </div>
          <div class="landing-ticker" aria-live="polite">
            <span>\u{2728}</span>
            <p id="landingFact">Fun fact loading\u{2026}</p>
          </div>
        </div>
      </div>
    `;
    }
    renderEthos() {
        return `
      <section class="landing-ethos" aria-label="Platform ethos promises">
        ${this.ethos.map((item)=>`
          <article class="landing-ethos__card">
            <h3>${item.title}</h3>
            <p>${item.copy}</p>
          </article>
        `).join('')}
      </section>
    `;
    }
    renderChecklist() {
        return `
      <section class="landing-checklist" aria-label="Is this your vibe checklist">
        <h2>Is this your vibe?</h2>
        <div class="landing-checklist__items">
          ${this.checklist.map((item)=>`
            <article class="landing-checklist__item">
              <span aria-hidden="true">\u{1F496}</span>
              <div>
                <strong>${item.title}</strong>
                <p>${item.copy}</p>
              </div>
            </article>
          `).join('')}
        </div>
      </section>
    `;
    }
    renderCarousel() {
        return `
      <section class="landing-carousel" aria-label="Peeks at the community">
        <h2>Here\u{2019}s what you could be building inside</h2>
        <div class="landing-carousel__items">
          ${this.carousel.map((item)=>`
            <article class="landing-carousel__card">
              <span>${item.label}</span>
              <h4>${item.title}</h4>
              <p>${item.copy}</p>
            </article>
          `).join('')}
        </div>
      </section>
    `;
    }
    renderSecondaryCTA() {
        return `
      <section class="landing-secondary-cta" aria-label="Ready to jump in">
        <button data-auth-mode="register" data-surface="secondary_primary">Start a cozy profile</button>
      </section>
    `;
    }
    bindCTAButtons() {
        const buttons = this.querySelectorAll('[data-auth-mode]');
        buttons.forEach((button)=>{
            button.addEventListener('click', ()=>{
                const mode = button.dataset.authMode || 'login';
                const surface = button.dataset.surface || 'landing';
                this.handleAuthRequest(mode, surface);
            });
        });
    }
    handleAuthRequest(mode, surface) {
        try {
            if (window.logger?.ui) window.logger.ui('landing_cta_click', 'landing-page', {
                mode: mode,
                surface: surface
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Landing CTA logging failed', error);
        }
        this.dispatchEvent(new CustomEvent('landing-auth-request', {
            bubbles: true,
            composed: true,
            detail: {
                mode: mode
            }
        }));
    }
    startFunFactTicker() {
        const factEl = this.querySelector('#landingFact');
        if (!factEl) return;
        const updateFact = ()=>{
            factEl.textContent = this.funFacts[this.factIndex];
            this.factIndex = (this.factIndex + 1) % this.funFacts.length;
        };
        updateFact();
        this.tickerInterval = window.setInterval(updateFact, 6000);
    }
}
customElements.define('landing-page', $b38f9eb4f68e0524$var$LandingPage);


// MainContent component - dynamically renders content based on route

var $eZQHH = parcelRequire("eZQHH");




const $ee071de92541520e$var$PUBLIC_CONTENT_ROUTES = [
    '/privacy',
    '/terms',
    '/release-notes'
];
const $ee071de92541520e$var$FRIENDS_TABS = [
    'friends',
    'requests',
    'invitations'
];
const $ee071de92541520e$var$FRIENDS_DEFAULT_TAB = 'friends';
class $ee071de92541520e$var$MainContent extends HTMLElement {
    constructor(){
        super();
        this.currentSection = null;
        this.currentContent = null;
        this.currentUser = null;
        this._pendingGroupCommentFocus = null;
        this._pendingGroupPostFocus = null;
    }
    connectedCallback() {
        this.render();
        this.setupEventListeners();
    }
    disconnectedCallback() {
        // Remove event listeners when component is removed
        document.removeEventListener('route-changed', this.handleRouteChange);
        document.removeEventListener('auth-success', this.handleAuthSuccess);
        document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        document.removeEventListener('user-logged-out', this.handleUserLoggedOut);
        document.removeEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
    }
    handleAuthSuccess(e) {
        const user = e.detail?.user || {};
        this.updateCurrentUser(user);
        this.render();
    }
    handleAuthStatusLoaded(e) {
        const { authenticated: authenticated, user: user } = e.detail;
        if (authenticated) {
            this.updateCurrentUser(user);
            this.render();
        }
    }
    handleUserLoggedOut() {
        this.updateCurrentUser(null);
        this.render();
    }
    setupEventListeners() {
        this.handleRouteChange = this.handleRouteChange.bind(this);
        this.handleAuthSuccess = this.handleAuthSuccess.bind(this);
        this.handleAuthStatusLoaded = this.handleAuthStatusLoaded.bind(this);
        this.handleUserLoggedOut = this.handleUserLoggedOut.bind(this);
        this.handleFeatureFlagsLoaded = this.handleFeatureFlagsLoaded.bind(this);
        document.addEventListener('route-changed', this.handleRouteChange);
        document.addEventListener('auth-success', this.handleAuthSuccess);
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        document.addEventListener('user-logged-out', this.handleUserLoggedOut);
        document.addEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
    }
    handleFeatureFlagsLoaded() {
        const route = window.router?.getCurrentRoute() || window.location.pathname;
        this.handleRouteChange(route);
    }
    render() {
        // Get current route from router
        const currentRoute = window.router?.getCurrentRoute() || window.location.pathname;
        this.handleRouteChange(currentRoute);
    }
    async handleRouteChange(routeEvent) {
        (0, $eZQHH.default).info(`MainContent: Handling route change to ${routeEvent}`);
        const route = routeEvent?.detail?.route || routeEvent;
        // Clear current content
        this.clearContent();
        if ($ee071de92541520e$var$PUBLIC_CONTENT_ROUTES.includes(route)) return;
        const groupInviteToken = (0, $0c1c38b6cb0e7c6b$export$73a9120728e69f79)(route);
        if (groupInviteToken) {
            await this.renderGroupInviteAccept(groupInviteToken);
            return;
        }
        if (!this.currentUser) // eventually we should probably have some static information about the site
        return;
        // Determine which content to show based on route
        if (route === '/' || route === '/home') await this.renderHome();
        else if (route === '/friends') await this.renderFriends();
        else if (route === '/profile') await this.renderProfile();
        else if (route === '/profile/me') await this.renderUserProfile('me');
        else if (route.startsWith('/profile/')) {
            const username = route.split('/')[2];
            await this.renderUserProfile(username);
        } else if (route === '/oauth2/authorize') await this.renderOAuthAuthorize();
        else if (route === '/admin') await this.renderAdminSettings();
        else if (route === '/admin/audit-logs') await this.renderAdminAuditLogs();
        else if (route === '/admin/users') await this.renderAdminUsers();
        else if (route === '/admin/prompts') await this.renderAdminPrompts();
        else if (route === '/admin/widgets') await this.renderAdminWidgets();
        else if (route === '/admin/stats') await this.renderAdminStats();
        else if (route === '/admin/image-flags') await this.renderAdminImageFlags();
        else if (route === '/admin/widget-flags') await this.renderAdminWidgetFlags();
        else if (route === '/admin/blocked-domains') await this.renderAdminBlockedDomains();
        else if (route === '/admin/oauth-clients') await this.renderAdminOAuthClients();
        else if (route === '/admin/feature-flags') await this.renderAdminFeatureFlags();
        else if (route === '/settings') await this.renderSettings();
        else if (route === '/settings/security') await this.renderTwoFactorSettings();
        else if (route === '/settings/notifications') await this.renderNotificationSettings();
        else if (route === '/settings/sparkle-sources') await this.renderMediaSourcesSettings();
        else if (route === '/settings/facebook-import-friends') await this.renderFacebookImportFriends();
        else if (route === '/settings/facebook-import-posts') await this.renderFacebookImportPosts();
        else if (route === '/settings/imported-friends') await this.renderImportedFriends();
        else if (route === '/settings/rss-feeds') await this.renderRssFeeds();
        else if (route === '/settings/widgets') await this.renderWidgetSettings();
        else if (route === '/memories' || route.startsWith('/memories/')) {
            const dateMatch = route.match(/^\/memories\/(\d{1,2}-\d{1,2})$/);
            const dateParam = dateMatch ? dateMatch[1] : null;
            await this.renderMemories(dateParam);
        } else if (route === '/events') await this.renderEventsList();
        else if (route === '/events/calendar') await this.renderEventsCalendar();
        else if (route === '/events/new') {
            const params = new URLSearchParams(window.location.search);
            const presetGroupId = params.get('groupId');
            await this.renderEventEdit(null, presetGroupId);
        } else if (route === '/mascot-parade') {
            if (!(0, $4bd131ffd9e749e2$export$87e0f7dd6dec932f)('mascot_parade')) {
                window.router.navigate('/');
                return;
            }
            await this.renderMascotParade();
        } else if (route === '/widget-demo') await this.renderWidgetDemo();
        else if (route.match(/^\/group\/(\d+)\/post\/(\d+)\/comment\/(\d+)$/)) {
            const m = route.match(/^\/group\/(\d+)\/post\/(\d+)\/comment\/(\d+)$/);
            await this.renderGroupComment(m[1], m[2], m[3]);
        } else if (route.match(/^\/group\/(\d+)\/post\/(\d+)$/)) {
            const m = route.match(/^\/group\/(\d+)\/post\/(\d+)$/);
            await this.renderGroupPost(m[1], m[2]);
        } else if (route === '/groups') await this.renderGroupsHub();
        else if (route === '/groups/new') await this.renderGroupCreate();
        else if (route.match(/^\/groups\/(\d+)\/settings$/)) {
            const m = route.match(/^\/groups\/(\d+)\/settings$/);
            await this.renderGroupSettings(m[1]);
        } else if (route.match(/^\/groups\/(\d+)\/threads\/(\d+)$/)) {
            const m = route.match(/^\/groups\/(\d+)\/threads\/(\d+)$/);
            await this.renderGroupShell(m[1], m[2]);
        } else if (route.match(/^\/groups\/(\d+)$/)) {
            const m = route.match(/^\/groups\/(\d+)$/);
            await this.renderGroupShell(m[1], null);
        } else if (route.startsWith('/groups/')) await this.renderNotFound();
        else if (route.match(/^\/events\/\d+\/edit$/)) {
            const eventId = route.split('/')[2];
            await this.renderEventEdit(eventId);
        } else if (route.startsWith('/events/')) {
            const eventId = route.split('/')[2];
            await this.renderEventDetail(eventId);
        } else if (route.match(/^\/post\/\d+\/comment\/\d+$/)) {
            // Handle comment permalinks: /post/123/comment/456
            const pathParts = route.split('/');
            const postId = pathParts[2];
            const commentId = pathParts[4];
            await this.renderComment(postId, commentId);
        } else if (route.startsWith('/post/')) {
            const postId = route.split('/')[2];
            // Check if there's a hash fragment for a comment
            const hash = window.location.hash;
            if (hash && hash.startsWith('#comment-')) {
                const commentId = hash.replace('#comment-', '');
                await this.renderComment(postId, commentId);
            } else await this.renderPost(postId);
        } else // Unknown route - show 404
        await this.renderNotFound();
        this.setCurrentUserOnChildComponents(this.currentUser);
        await this.flushPendingGroupPermalinkFocus();
    }
    clearContent() {
        // Clean up event listeners before clearing content
        if (this.handleFriendRequestsUpdated) document.removeEventListener('friend-requests-updated', this.handleFriendRequestsUpdated);
        if (this.handleRequestAction) {
            document.removeEventListener('friend-request-accepted', this.handleRequestAction);
            document.removeEventListener('friend-request-declined', this.handleRequestAction);
        }
        this.innerHTML = '';
        this.currentSection = null;
        this.currentContent = null;
        this._pendingGroupCommentFocus = null;
        this._pendingGroupPostFocus = null;
    }
    async renderHome() {
        (0, $eZQHH.default).debug('MainContent: Rendering home section');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="home-section">
          <div class="post-area">
            <home-promo-banner></home-promo-banner>
            <post-writer></post-writer>
          </div>
          <div class="posts-container">
            <upcoming-events-banner></upcoming-events-banner>
            <posts-feed></posts-feed>
          </div>
        </section>
      </div>
    `;
        this.currentSection = 'home';
        this.dispatchSectionShown('home');
    }
    async renderFriends() {
        (0, $eZQHH.default).debug('MainContent: Rendering friends section');
        const activeTab = (0, $ec0e472fc3ccab74$export$4d96fceac8695298)($ee071de92541520e$var$FRIENDS_TABS, {
            defaultTab: $ee071de92541520e$var$FRIENDS_DEFAULT_TAB
        });
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="friends-section">
          <div class="friends-page">
            <add-friend-cta></add-friend-cta>
            <div class="friends-tabs">
              <button class="friends-tab ${activeTab === 'friends' ? 'active' : ''}" data-tab="friends">
                \u{1F3AA} Friends
              </button>
              <button class="friends-tab ${activeTab === 'requests' ? 'active' : ''}" data-tab="requests">
                \u{1F4E5} Requests
              </button>
              <button class="friends-tab ${activeTab === 'invitations' ? 'active' : ''}" data-tab="invitations">
                \u{1F4E8} Invitations
              </button>
            </div>
            <div class="friends-tab-content">
              <div class="tab-panel ${activeTab === 'friends' ? 'active' : ''}" data-panel="friends">
                <friends-list></friends-list>
              </div>
              <div class="tab-panel ${activeTab === 'requests' ? 'active' : ''}" data-panel="requests">
                <friend-requests></friend-requests>
              </div>
              <div class="tab-panel ${activeTab === 'invitations' ? 'active' : ''}" data-panel="invitations">
                <invitations-list></invitations-list>
              </div>
            </div>
          </div>
        </section>
      </div>
    `;
        this.currentSection = 'friends';
        this.dispatchSectionShown('friends');
        this.attachFriendsTabListeners();
        this.attachFriendsRequestListeners();
    }
    switchFriendsTab(targetTab) {
        if (!$ee071de92541520e$var$FRIENDS_TABS.includes(targetTab)) return;
        (0, $ec0e472fc3ccab74$export$19a03c6887cb23d9)(targetTab, {
            omitDefault: $ee071de92541520e$var$FRIENDS_DEFAULT_TAB
        });
        const tabs = this.querySelectorAll('.friends-tab');
        const panels = this.querySelectorAll('.tab-panel');
        tabs.forEach((tab)=>{
            tab.classList.toggle('active', tab.dataset.tab === targetTab);
        });
        panels.forEach((panel)=>{
            panel.classList.toggle('active', panel.dataset.panel === targetTab);
        });
    }
    attachFriendsTabListeners() {
        const tabs = this.querySelectorAll('.friends-tab');
        tabs.forEach((tab)=>{
            tab.addEventListener('click', ()=>{
                this.switchFriendsTab(tab.dataset.tab);
            });
        });
    }
    attachFriendsRequestListeners() {
        // Listen for friend request updates to show star indicator
        this.handleFriendRequestsUpdated = (event)=>{
            const receivedCount = event.detail?.receivedCount || 0;
            this.updateRequestsTabIndicator(receivedCount);
        };
        document.addEventListener('friend-requests-updated', this.handleFriendRequestsUpdated);
        // Also listen for request acceptance/decline events to ensure we catch updates
        // even if the friend-requests-updated event was missed
        this.handleRequestAction = ()=>{
            // Wait a bit for the loadRequests() to complete, then check the count
            setTimeout(()=>{
                this.checkFriendRequestsCount();
            }, 300);
        };
        document.addEventListener('friend-request-accepted', this.handleRequestAction);
        document.addEventListener('friend-request-declined', this.handleRequestAction);
        document.addEventListener('invitation-accepted', this.handleRequestAction);
        // Manually check for requests after a short delay to catch initial load
        // This handles the case where the event fires before the listener is attached
        setTimeout(()=>{
            this.checkFriendRequestsCount();
        }, 1000);
    }
    updateRequestsTabIndicator(receivedCount) {
        const requestsTab = this.querySelector('.friends-tab[data-tab="requests"]');
        if (requestsTab) {
            if (receivedCount > 0) // Add star if not already present
            {
                if (!requestsTab.querySelector('.request-indicator')) requestsTab.innerHTML = '\uD83D\uDCE5 Requests <span class="request-indicator">\u2B50</span>';
            } else {
                // Remove star if present
                const indicator = requestsTab.querySelector('.request-indicator');
                if (indicator) requestsTab.innerHTML = "\uD83D\uDCE5 Requests";
            }
        }
    }
    async checkFriendRequestsCount() {
        try {
            const response = await window.API.request('/friends');
            const receivedCount = response.receivedRequests?.length || 0;
            this.updateRequestsTabIndicator(receivedCount);
        } catch (error) {
            window.logger.error('Failed to check friend requests count:', error);
        }
    }
    async renderProfile() {
        (0, $eZQHH.default).debug('MainContent: Rendering profile section');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="profile-section">
          <user-profile></user-profile>
        </section>
      </div>
    `;
        this.currentSection = 'profile';
        this.dispatchSectionShown('profile');
    }
    async renderUserProfile(username) {
        (0, $eZQHH.default).debug(`MainContent: Rendering user profile for ${username}`);
        // Use the same profile section but trigger the load event
        await this.renderProfile();
        // Give the component a moment to set up event listeners
        await new Promise((resolve)=>setTimeout(resolve, 10));
        const userProfile = this.querySelector('user-profile');
        if (userProfile && this.currentUser) userProfile.setCurrentUser(this.currentUser);
        // Trigger event to load the specific user profile
        const event = new CustomEvent('profile-load', {
            detail: {
                username: username
            }
        });
        document.dispatchEvent(event);
    }
    async renderAdminSettings() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin settings page');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-settings-section">
          <admin-settings-page></admin-settings-page>
        </section>
      </div>
    `;
        this.currentSection = 'admin-settings';
        this.dispatchSectionShown('admin-settings');
    }
    async renderAdminAuditLogs() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin audit logs');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-audit-logs-section">
          <audit-logs></audit-logs>
        </section>
      </div>
    `;
        this.currentSection = 'admin-audit-logs';
        this.dispatchSectionShown('admin-audit-logs');
    }
    async renderAdminUsers() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin user management');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-users-section">
          <user-management></user-management>
        </section>
      </div>
    `;
        this.currentSection = 'admin-users';
        this.dispatchSectionShown('admin-users');
        await new Promise((resolve)=>setTimeout(resolve, 10));
        const component = this.querySelector('user-management');
        if (component && this.currentUser) component.setCurrentUser(this.currentUser);
    }
    async renderAdminWidgets() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin widget management');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-widgets-section">
          <admin-widget-management></admin-widget-management>
        </section>
      </div>
    `;
        this.currentSection = 'admin-widgets';
        this.dispatchSectionShown('admin-widgets');
    }
    async renderAdminPrompts() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin prompt management');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-prompts-section">
          <prompt-management></prompt-management>
        </section>
      </div>
    `;
        this.currentSection = 'admin-prompts';
        this.dispatchSectionShown('admin-prompts');
    }
    async renderAdminStats() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin site stats');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-stats-section">
          <site-stats></site-stats>
        </section>
      </div>
    `;
        this.currentSection = 'admin-stats';
        this.dispatchSectionShown('admin-stats');
    }
    async renderAdminImageFlags() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin image flags');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-image-flags-section">
          <image-flags></image-flags>
        </section>
      </div>
    `;
        this.currentSection = 'admin-image-flags';
        this.dispatchSectionShown('admin-image-flags');
    }
    async renderAdminWidgetFlags() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin widget flags');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-widget-flags-section">
          <widget-flags></widget-flags>
        </section>
      </div>
    `;
        this.currentSection = 'admin-widget-flags';
        this.dispatchSectionShown('admin-widget-flags');
    }
    async renderAdminBlockedDomains() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin blocked domains');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-blocked-domains-section">
          <blocked-domains></blocked-domains>
        </section>
      </div>
    `;
        this.currentSection = 'admin-blocked-domains';
        this.dispatchSectionShown('admin-blocked-domains');
    }
    async renderAdminOAuthClients() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin OAuth clients');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-oauth-clients-section">
          <oauth-clients></oauth-clients>
        </section>
      </div>
    `;
        this.currentSection = 'admin-oauth-clients';
        this.dispatchSectionShown('admin-oauth-clients');
    }
    async renderAdminFeatureFlags() {
        (0, $eZQHH.default).debug('MainContent: Rendering admin feature flags');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="admin-feature-flags-section">
          <admin-feature-flags></admin-feature-flags>
        </section>
      </div>
    `;
        this.currentSection = 'admin-feature-flags';
        this.dispatchSectionShown('admin-feature-flags');
    }
    async renderMascotParade() {
        (0, $eZQHH.default).debug('MainContent: Rendering mascot parade');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="mascot-parade-section">
          <mascot-parade-page></mascot-parade-page>
        </section>
      </div>
    `;
        this.currentSection = 'mascot-parade';
        this.dispatchSectionShown('mascot-parade');
    }
    async renderWidgetDemo() {
        (0, $eZQHH.default).debug('MainContent: Rendering widget demo');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="widget-demo-section">
          <widget-demo-page></widget-demo-page>
        </section>
      </div>
    `;
        this.currentSection = 'widget-demo';
        this.dispatchSectionShown('widget-demo');
    }
    async renderOAuthAuthorize() {
        (0, $eZQHH.default).debug('MainContent: Rendering OAuth authorization page');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="oauth-authorize-section">
          <oauth-authorize></oauth-authorize>
        </section>
      </div>
    `;
    }
    async renderTwoFactorSettings() {
        (0, $eZQHH.default).debug('MainContent: Rendering 2FA settings section');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="two-factor-settings-section">
          <two-factor-settings></two-factor-settings>
        </section>
      </div>
    `;
        this.currentSection = 'two-factor-settings';
        this.dispatchSectionShown('two-factor-settings');
    }
    async renderNotificationSettings() {
        (0, $eZQHH.default).debug('MainContent: Rendering notification settings');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="notification-settings-section">
          <notification-settings></notification-settings>
        </section>
      </div>
    `;
        this.currentSection = 'notification-settings';
        this.dispatchSectionShown('notification-settings');
    }
    async renderMediaSourcesSettings() {
        (0, $eZQHH.default).debug('MainContent: Rendering media sources settings');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="media-sources-settings-section">
          <media-sources-settings></media-sources-settings>
        </section>
      </div>
    `;
        this.currentSection = 'media-sources-settings';
        this.dispatchSectionShown('media-sources-settings');
    }
    async renderFacebookImportFriends() {
        (0, $eZQHH.default).debug('MainContent: Rendering Facebook import friends');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="facebook-import-friends-section">
          <facebook-import-friends></facebook-import-friends>
        </section>
      </div>
    `;
        this.currentSection = 'facebook-import-friends';
        this.dispatchSectionShown('facebook-import-friends');
        await new Promise((resolve)=>setTimeout(resolve, 10));
        const component = this.querySelector('facebook-import-friends');
        if (component && this.currentUser) component.setCurrentUser(this.currentUser);
    }
    async renderFacebookImportPosts() {
        (0, $eZQHH.default).debug('MainContent: Rendering Facebook import posts');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="facebook-import-posts-section">
          <facebook-import-posts></facebook-import-posts>
        </section>
      </div>
    `;
        this.currentSection = 'facebook-import-posts';
        this.dispatchSectionShown('facebook-import-posts');
        await new Promise((resolve)=>setTimeout(resolve, 10));
        const component = this.querySelector('facebook-import-posts');
        if (component && this.currentUser) component.setCurrentUser(this.currentUser);
    }
    async renderImportedFriends() {
        (0, $eZQHH.default).debug('MainContent: Rendering imported friends');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="imported-friends-section">
          <imported-friends></imported-friends>
        </section>
      </div>
    `;
        this.currentSection = 'imported-friends';
        this.dispatchSectionShown('imported-friends');
    }
    async renderWidgetSettings() {
        (0, $eZQHH.default).debug('MainContent: Rendering widget settings');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="widget-settings-section">
          <widget-management></widget-management>
        </section>
      </div>
    `;
        this.currentSection = 'widget-settings';
        this.dispatchSectionShown('widget-settings');
    }
    async renderRssFeeds() {
        (0, $eZQHH.default).debug('MainContent: Rendering RSS feeds settings');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="rss-feeds-section">
          <rss-feeds></rss-feeds>
        </section>
      </div>
    `;
        this.currentSection = 'rss-feeds';
        this.dispatchSectionShown('rss-feeds');
    }
    async renderSettings() {
        (0, $eZQHH.default).debug('MainContent: Rendering settings page');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="settings-section">
          <settings-page></settings-page>
        </section>
      </div>
    `;
        this.currentSection = 'settings';
        this.dispatchSectionShown('settings');
    }
    async renderMemories(dateParam = null) {
        (0, $eZQHH.default).debug('MainContent: Rendering memories section', {
            dateParam: dateParam
        });
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="memories-section">
          <memories-view ${dateParam ? `date="${dateParam}"` : ''}></memories-view>
        </section>
      </div>
    `;
        this.currentSection = 'memories';
        this.dispatchSectionShown('memories');
    }
    async renderPost(postId) {
        (0, $eZQHH.default).debug(`MainContent: Rendering post ${postId}`);
        // For post view, we show the home section but with post detail
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="home-section">
          <div class="post-area" style="display: none;">
            <post-writer></post-writer>
          </div>
          <div class="posts-container">
            <posts-feed style="display: none;"></posts-feed>
            <post-detail post-id="${postId}" style="display: block;"></post-detail>
          </div>
        </section>
      </div>
    `;
        this.currentSection = 'home';
        this.dispatchSectionShown('home');
    }
    async renderComment(postId, commentId) {
        (0, $eZQHH.default).debug(`MainContent: Rendering comment ${commentId} in post ${postId}`);
        try {
            // Show the post first
            await this.renderPost(postId);
            // Wait for the comments section to be available
            const commentsSection = await this.waitForElement('comments-section');
            if (!commentsSection) {
                (0, $eZQHH.default).warn('Comments section not found');
                return;
            }
            // Trigger comment loading if not already loaded
            if (!commentsSection.commentsLoaded) await commentsSection.loadComments();
            // Wait for the specific comment element to be available
            const commentElement = await this.waitForElement(`[data-comment-id="${commentId}"]`);
            if (!commentElement) {
                (0, $eZQHH.default).warn(`Comment ${commentId} not found in post ${postId}`);
                return;
            }
            // Scroll to the comment
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            // Add a highlight effect
            this.highlightComment(commentElement);
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load comment:', error);
        }
    }
    // Helper to wait for an element to appear in the DOM
    waitForElement(selector, timeout = 5000) {
        return new Promise((resolve)=>{
            const element = document.querySelector(selector);
            if (element) {
                resolve(element);
                return;
            }
            const observer = new MutationObserver(()=>{
                const element = document.querySelector(selector);
                if (element) {
                    observer.disconnect();
                    resolve(element);
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            // Timeout fallback
            setTimeout(()=>{
                observer.disconnect();
                resolve(null);
            }, timeout);
        });
    }
    // Helper to highlight a comment
    highlightComment(commentElement) {
        commentElement.classList.add('comment-highlight');
        setTimeout(()=>{
            commentElement.classList.remove('comment-highlight');
        }, 3000);
    }
    dispatchSectionShown(sectionName) {
        const event = new CustomEvent('section-shown', {
            detail: {
                section: sectionName
            }
        });
        document.dispatchEvent(event);
    }
    // Public method to get current section
    getCurrentSection() {
        return this.currentSection;
    }
    // Public method to reset home view (for router compatibility)
    resetHomeView() {
        if (this.currentSection === 'home') {
            const postsFeed = document.querySelector('posts-feed');
            const postWriter = document.querySelector('post-writer');
            const postDetail = document.querySelector('post-detail');
            if (postsFeed) postsFeed.style.display = 'block';
            if (postWriter) postWriter.style.display = 'block';
            if (postDetail) postDetail.style.display = 'none';
        }
    }
    // Public method to hide post detail (for router compatibility)
    hidePostDetail() {
        const postDetail = document.querySelector('post-detail');
        if (postDetail) postDetail.style.display = 'none';
    }
    // Update current user on the currently visible component
    updateCurrentUser(user) {
        this.currentUser = user;
        (0, $eZQHH.default).debug('MainContent: Updating current user', user);
        this.setCurrentUserOnChildComponents(user);
    }
    setCurrentUserOnChildComponents(user) {
        const componentNames = [
            'post-writer',
            'posts-feed',
            'upcoming-events-banner',
            'home-promo-banner',
            'add-friend-cta',
            'friends-list',
            'friend-requests',
            'admin-settings-page',
            'audit-logs',
            'user-management',
            'prompt-management',
            'admin-widget-management',
            'widget-management',
            'site-stats',
            'image-flags',
            'blocked-domains',
            'oauth-clients',
            'admin-feature-flags',
            'two-factor-settings',
            'notification-settings',
            'media-sources-settings',
            'settings-page',
            'event-detail',
            'event-edit',
            'events-calendar',
            'events-list',
            'groups-hub',
            'group-create',
            'group-shell',
            'add-group-cta',
            'user-profile'
        ];
        componentNames.forEach((name)=>{
            this.querySelectorAll(name).forEach((component)=>{
                if (typeof component.setCurrentUser === 'function') component.setCurrentUser(user);
            });
        });
        const visibleComponent = this.findVisibleComponent();
        if (visibleComponent && typeof visibleComponent.setCurrentUser === 'function') visibleComponent.setCurrentUser(user);
    }
    async renderEventsList() {
        (0, $eZQHH.default).debug('MainContent: Rendering events list');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="events-section">
          <events-list></events-list>
        </section>
      </div>
    `;
        this.currentSection = 'events';
        this.dispatchSectionShown('events');
    }
    async renderEventsCalendar() {
        (0, $eZQHH.default).debug('MainContent: Rendering events calendar');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="events-calendar-section">
          <events-calendar></events-calendar>
        </section>
      </div>
    `;
        this.currentSection = 'events-calendar';
        this.dispatchSectionShown('events-calendar');
    }
    async renderGroupsHub() {
        (0, $eZQHH.default).debug('MainContent: Rendering groups hub');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="groups-section">
          <groups-hub></groups-hub>
        </section>
      </div>
    `;
        this.currentSection = 'groups';
        this.dispatchSectionShown('groups');
    }
    async renderGroupCreate() {
        (0, $eZQHH.default).debug('MainContent: Rendering group create');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="group-create-section">
          <group-create></group-create>
        </section>
      </div>
    `;
        this.currentSection = 'group-create';
        this.dispatchSectionShown('group-create');
    }
    async renderGroupInviteAccept(token) {
        (0, $eZQHH.default).debug(`MainContent: Rendering group invite accept ${token}`);
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="group-invite-accept-section">
          <group-invite-accept-page invite-token="${token}"></group-invite-accept-page>
        </section>
      </div>
    `;
        this.currentSection = 'group-invite-accept';
        this.dispatchSectionShown('group-invite-accept');
    }
    async renderGroupSettings(groupId) {
        (0, $eZQHH.default).debug(`MainContent: Rendering group settings ${groupId}`);
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="group-settings-section">
          <group-settings-page group-id="${groupId}"></group-settings-page>
        </section>
      </div>
    `;
        this.currentSection = 'group-settings';
        this.dispatchSectionShown('group-settings');
    }
    async renderGroupComment(groupId, postId, commentId) {
        (0, $eZQHH.default).debug(`MainContent: Setting up group comment permalink ${commentId} on post ${postId} in group ${groupId}`);
        try {
            const gid = Number(groupId);
            const pid = Number(postId);
            const cid = Number(commentId);
            const location = await (0, $2bb3cd4399004fe3$export$82a8941476802fd8)(gid, pid);
            await this.renderGroupShell(gid, location.threadId, {
                initialPage: location.page
            });
            this._pendingGroupCommentFocus = {
                groupId: gid,
                postId: pid,
                commentId: cid,
                location: location
            };
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load group comment:', error);
        }
    }
    async renderGroupPost(groupId, postId) {
        (0, $eZQHH.default).debug(`MainContent: Setting up group post permalink ${postId} in group ${groupId}`);
        try {
            const gid = Number(groupId);
            const pid = Number(postId);
            const location = await (0, $2bb3cd4399004fe3$export$82a8941476802fd8)(gid, pid);
            await this.renderGroupShell(gid, location.threadId, {
                initialPage: location.page
            });
            this._pendingGroupPostFocus = {
                groupId: gid,
                postId: pid,
                location: location
            };
        } catch (error) {
            (0, $eZQHH.default).error('Failed to load group post:', error);
        }
    }
    async flushPendingGroupPermalinkFocus() {
        if (this._pendingGroupCommentFocus) {
            const pending = this._pendingGroupCommentFocus;
            this._pendingGroupCommentFocus = null;
            try {
                await (0, $2bb3cd4399004fe3$export$28826d3e6e972258)();
                await (0, $2bb3cd4399004fe3$export$fb46a8b6495eaff5)(pending);
            } catch (error) {
                (0, $eZQHH.default).error('Failed to focus group comment:', error);
            }
        }
        if (this._pendingGroupPostFocus) {
            const pending = this._pendingGroupPostFocus;
            this._pendingGroupPostFocus = null;
            try {
                await (0, $2bb3cd4399004fe3$export$28826d3e6e972258)();
                await (0, $2bb3cd4399004fe3$export$9930b3e2d246d9fc)(pending);
            } catch (error) {
                (0, $eZQHH.default).error('Failed to focus group post:', error);
            }
        }
    }
    async renderGroupShell(groupId, threadId, { initialPage: initialPage } = {}) {
        (0, $eZQHH.default).debug(`MainContent: Rendering group shell ${groupId} thread ${threadId}`);
        const threadAttr = threadId !== null && threadId !== undefined && threadId !== '' ? ` thread-id="${threadId}"` : '';
        const pageAttr = initialPage && initialPage > 1 ? ` initial-page="${initialPage}"` : '';
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="group-shell-section">
          <group-shell group-id="${groupId}"${threadAttr}${pageAttr}></group-shell>
        </section>
      </div>
    `;
        this.currentSection = 'group-shell';
        this.dispatchSectionShown('group-shell');
    }
    async renderEventDetail(eventId) {
        (0, $eZQHH.default).debug(`MainContent: Rendering event detail ${eventId}`);
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="event-detail-section">
          <event-detail event-id="${eventId}"></event-detail>
        </section>
      </div>
    `;
        this.currentSection = 'event-detail';
        this.dispatchSectionShown('event-detail');
    }
    async renderEventEdit(eventId = null, presetGroupId = null) {
        (0, $eZQHH.default).debug(`MainContent: Rendering event ${eventId ? 'edit' : 'create'}`);
        const presetAttr = presetGroupId ? ` preset-group-id="${presetGroupId}"` : '';
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="event-edit-section">
          <event-edit${eventId ? ` event-id="${eventId}"` : ''}${presetAttr}></event-edit>
        </section>
      </div>
    `;
        this.currentSection = 'event-edit';
        this.dispatchSectionShown('event-edit');
    }
    async renderNotFound() {
        (0, $eZQHH.default).debug('MainContent: Rendering 404 not found page');
        this.innerHTML = `
      <div class="container">
        <section class="content-section" id="not-found-section">
          <not-found></not-found>
        </section>
      </div>
    `;
        this.currentSection = 'not-found';
        this.dispatchSectionShown('not-found');
    }
    // Find the currently visible component that might need user updates
    findVisibleComponent() {
        // Look for common components that might need user updates
        const components = [
            'user-profile',
            'posts-feed',
            'post-writer',
            'friends-list',
            'friend-requests',
            'admin-dashboard',
            'admin-feature-flags',
            'two-factor-settings',
            'notification-settings',
            'settings-page',
            'event-detail',
            'event-edit',
            'events-calendar',
            'groups-hub',
            'group-create',
            'group-shell'
        ];
        for (const componentName of components){
            const component = this.querySelector(componentName);
            if (component && component.offsetParent !== null) return component;
        }
        // Fallback: return the first visible component
        const allComponents = this.querySelectorAll('*');
        for (const component of allComponents){
            if (component.offsetParent !== null && component.tagName.includes('-')) return component;
        }
        return null;
    }
}
// Register the custom element
customElements.define('main-content', $ee071de92541520e$var$MainContent);
var $ee071de92541520e$export$2e2bcd8739ae039 = $ee071de92541520e$var$MainContent;


// Markdown Preview Wrapper Component
// Wraps a textarea and adds Preview/Raw tabs
function $162c50354e6ab33d$export$138a840241174bc2(textarea, text, options = {}) {
    if (!textarea) return;
    const { ensureTrailingNewline: ensureTrailingNewline = true } = options;
    const start = textarea.selectionStart ?? textarea.value.length;
    const end = textarea.selectionEnd ?? textarea.value.length;
    const value = textarea.value;
    const before = value.slice(0, start);
    const after = value.slice(end);
    let insertion = text;
    if (ensureTrailingNewline && !text.endsWith('\n')) insertion += '\n';
    const newValue = `${before}${insertion}${after}`;
    textarea.value = newValue;
    const caret = before.length + insertion.length;
    textarea.selectionStart = caret;
    textarea.selectionEnd = caret;
}


/**
 * Maps sanitized post style objects to CSS classes and inline custom properties.
 * Mirrors server/server/utils/style-sanitize.js styleToRenderTokens().
 */ /**
 * WCAG contrast helpers for post-style-picker preview hints.
 * Mirrors server/server/utils/style-sanitize.js contrast logic.
 */ const $21e114b4db6ffc58$var$HEX_COLOR = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
const $21e114b4db6ffc58$var$RGB_COLOR = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
const $21e114b4db6ffc58$var$HSL_COLOR = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
function $21e114b4db6ffc58$var$clampComponent(value, max = 255) {
    const n = Number(value);
    if (Number.isNaN(n)) return null;
    return Math.min(max, Math.max(0, n));
}
function $21e114b4db6ffc58$var$hexToRgb(hex) {
    let normalized = hex.replace('#', '');
    if (normalized.length === 3) normalized = normalized.split('').map((c)=>c + c).join('');
    return {
        r: parseInt(normalized.slice(0, 2), 16),
        g: parseInt(normalized.slice(2, 4), 16),
        b: parseInt(normalized.slice(4, 6), 16)
    };
}
function $21e114b4db6ffc58$var$parseColorToRgb(color) {
    if (!color || typeof color !== 'string') return null;
    const trimmed = color.trim();
    if ($21e114b4db6ffc58$var$HEX_COLOR.test(trimmed)) return $21e114b4db6ffc58$var$hexToRgb(trimmed);
    const rgbMatch = trimmed.match($21e114b4db6ffc58$var$RGB_COLOR);
    if (rgbMatch) {
        const r = $21e114b4db6ffc58$var$clampComponent(rgbMatch[1]);
        const g = $21e114b4db6ffc58$var$clampComponent(rgbMatch[2]);
        const b = $21e114b4db6ffc58$var$clampComponent(rgbMatch[3]);
        if (r === null || g === null || b === null) return null;
        return {
            r: r,
            g: g,
            b: b
        };
    }
    const hslMatch = trimmed.match($21e114b4db6ffc58$var$HSL_COLOR);
    if (hslMatch) {
        const h = $21e114b4db6ffc58$var$clampComponent(hslMatch[1], 360);
        const s = $21e114b4db6ffc58$var$clampComponent(hslMatch[2], 100);
        const l = $21e114b4db6ffc58$var$clampComponent(hslMatch[3], 100);
        if (h === null || s === null || l === null) return null;
        const sNorm = s / 100;
        const lNorm = l / 100;
        const c = (1 - Math.abs(2 * lNorm - 1)) * sNorm;
        const x = c * (1 - Math.abs(h / 60 % 2 - 1));
        const m = lNorm - c / 2;
        let r1 = 0;
        let g1 = 0;
        let b1 = 0;
        if (h < 60) {
            r1 = c;
            g1 = x;
        } else if (h < 120) {
            r1 = x;
            g1 = c;
        } else if (h < 180) {
            g1 = c;
            b1 = x;
        } else if (h < 240) {
            g1 = x;
            b1 = c;
        } else if (h < 300) {
            r1 = x;
            b1 = c;
        } else {
            r1 = c;
            b1 = x;
        }
        return {
            r: Math.round((r1 + m) * 255),
            g: Math.round((g1 + m) * 255),
            b: Math.round((b1 + m) * 255)
        };
    }
    return null;
}
function $21e114b4db6ffc58$var$relativeLuminance({ r: r, g: g, b: b }) {
    const transform = (c)=>{
        const s = c / 255;
        return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
    };
    return 0.2126 * transform(r) + 0.7152 * transform(g) + 0.0722 * transform(b);
}
function $21e114b4db6ffc58$export$e73df0c08bfd3ec3(fgRgb, bgRgb) {
    const l1 = $21e114b4db6ffc58$var$relativeLuminance(fgRgb);
    const l2 = $21e114b4db6ffc58$var$relativeLuminance(bgRgb);
    const lighter = Math.max(l1, l2);
    const darker = Math.min(l1, l2);
    return (lighter + 0.05) / (darker + 0.05);
}
function $21e114b4db6ffc58$export$d13f49e3eef12be8(fgColor, bgColor) {
    const fgRgb = $21e114b4db6ffc58$var$parseColorToRgb(fgColor);
    const bgRgb = $21e114b4db6ffc58$var$parseColorToRgb(bgColor);
    if (!fgRgb || !bgRgb) return false;
    return $21e114b4db6ffc58$export$e73df0c08bfd3ec3(fgRgb, bgRgb) >= 4.5;
}
const $21e114b4db6ffc58$export$30ad063b1803c51b = {
    'retro-terminal': {
        fgColor: '#00ff00',
        bgColor: '#1a1a1a'
    },
    'pastel-dreams': {
        fgColor: '#5c4d7a',
        bgColor: '#fce4ec'
    },
    'neon-nights': {
        fgColor: '#f0f0ff',
        bgColor: '#1a0a2e'
    },
    'fourth-of-july': {
        fgColor: '#010238',
        bgColor: '#FCFBFF'
    }
};
function $21e114b4db6ffc58$export$3ff6a9d2b4e7f83e(style) {
    if (!style) return {
        fgColor: '#000000',
        bgColor: '#ffffff'
    };
    const preset = style.preset ? $21e114b4db6ffc58$export$30ad063b1803c51b[style.preset] : null;
    return {
        fgColor: style.fgColor || preset?.fgColor || '#000000',
        bgColor: style.bgColor || preset?.bgColor || '#ffffff'
    };
}


const $19885f1e2e093566$var$STYLE_FONTS = {
    arial: 'Arial, Helvetica Neue, Helvetica, sans-serif',
    georgia: 'Georgia, Times New Roman, serif',
    courier: 'Courier New, Courier, monospace',
    comic: 'Comic Sans MS, Comic Sans, cursive',
    trebuchet: 'Trebuchet MS, Helvetica, sans-serif',
    verdana: 'Verdana, Geneva, sans-serif',
    impact: 'Impact, Haettenschweiler, Arial Narrow Bold, sans-serif',
    palatino: 'Palatino Linotype, Palatino, serif'
};
const $19885f1e2e093566$var$STYLE_FONT_SIZES = {
    small: '0.875rem',
    normal: '1rem',
    large: '1.25rem'
};
const $19885f1e2e093566$var$STYLE_BORDERS = {
    none: '',
    soft: 'post-border-soft',
    dashed: 'post-border-dashed',
    neon: 'post-border-neon',
    retro: 'post-border-retro'
};
const $19885f1e2e093566$export$1824581b2cf1f105 = [
    'post-styled',
    'post-style-retro-terminal',
    'post-style-pastel-dreams',
    'post-style-neon-nights',
    'post-style-fourth-of-july',
    'post-font-arial',
    'post-font-georgia',
    'post-font-courier',
    'post-font-comic',
    'post-font-trebuchet',
    'post-font-verdana',
    'post-font-impact',
    'post-font-palatino',
    'post-size-small',
    'post-size-normal',
    'post-size-large',
    'post-border-soft',
    'post-border-dashed',
    'post-border-neon',
    'post-border-retro'
];
function $19885f1e2e093566$export$5e06d84ee9ea817c(style) {
    if (!style || typeof style !== 'object') return {
        classes: [],
        cssVars: {},
        inlineStyle: ''
    };
    const classes = [
        'post-styled'
    ];
    if (style.preset) classes.push(`post-style-${style.preset}`);
    if (style.font) classes.push(`post-font-${style.font}`);
    if (style.fontSize) classes.push(`post-size-${style.fontSize}`);
    if (style.border && style.border !== 'none' && $19885f1e2e093566$var$STYLE_BORDERS[style.border]) classes.push($19885f1e2e093566$var$STYLE_BORDERS[style.border]);
    const { fgColor: fgColor, bgColor: bgColor } = (0, $21e114b4db6ffc58$export$3ff6a9d2b4e7f83e)(style);
    const cssVars = {};
    if (style.fgColor || style.preset) cssVars['--post-fg'] = fgColor;
    if (style.bgColor || style.preset) cssVars['--post-bg'] = bgColor;
    if (style.font && $19885f1e2e093566$var$STYLE_FONTS[style.font]) cssVars['--post-font-family'] = $19885f1e2e093566$var$STYLE_FONTS[style.font];
    if (style.fontSize && $19885f1e2e093566$var$STYLE_FONT_SIZES[style.fontSize]) cssVars['--post-font-size'] = $19885f1e2e093566$var$STYLE_FONT_SIZES[style.fontSize];
    const inlineStyle = Object.entries(cssVars).map(([key, val])=>`${key}: ${val}`).join('; ');
    return {
        classes: classes,
        cssVars: cssVars,
        inlineStyle: inlineStyle
    };
}


const $7346618887d6de45$var$POST_STYLE_CSS_VAR_KEYS = [
    '--post-fg',
    '--post-bg',
    '--post-font-family',
    '--post-font-size'
];
function $7346618887d6de45$var$stripTokenClasses(className) {
    const tokens = new Set((0, $19885f1e2e093566$export$1824581b2cf1f105));
    return className.split(/\s+/).filter((cls)=>cls && !tokens.has(cls)).join(' ');
}
function $7346618887d6de45$var$setPostStyleCssVars(element, cssVars = {}) {
    for (const key of $7346618887d6de45$var$POST_STYLE_CSS_VAR_KEYS)if (cssVars[key]) element.style.setProperty(key, cssVars[key]);
    else element.style.removeProperty(key);
}
function $7346618887d6de45$var$clearPostStyleCssVars(element) {
    for (const key of $7346618887d6de45$var$POST_STYLE_CSS_VAR_KEYS)element.style.removeProperty(key);
}
function $7346618887d6de45$export$d2fad7ce6a2a6489(element, style) {
    if (!element) return;
    if (element.dataset.postStyleBase === undefined) element.dataset.postStyleBase = $7346618887d6de45$var$stripTokenClasses(element.className);
    const base = element.dataset.postStyleBase || '';
    const { classes: classes, cssVars: cssVars } = (0, $19885f1e2e093566$export$5e06d84ee9ea817c)(style);
    if (!style) {
        element.className = base;
        $7346618887d6de45$var$clearPostStyleCssVars(element);
        return;
    }
    element.className = [
        base,
        'post-item',
        ...classes
    ].filter(Boolean).join(' ');
    $7346618887d6de45$var$setPostStyleCssVars(element, cssVars);
}
function $7346618887d6de45$export$63f9f7d3280584f2(element) {
    if (!element) return;
    const base = element.dataset.postStyleBase;
    if (base !== undefined) {
        element.className = base;
        delete element.dataset.postStyleBase;
    }
    $7346618887d6de45$var$clearPostStyleCssVars(element);
}



// Media Attachment Web Component
// Displays OAuth-protected media files with appropriate viewers and reconnection support


class $2094d79e59e7b7ae$var$MediaAttachment extends HTMLElement {
    constructor(){
        super();
        this.fileUrl = null;
        this.provider = null;
        this.accountId = null;
        this.fileId = null;
        this.contentType = null;
        this.fileName = null;
        this.isLoading = false;
        this.hasError = false;
        this.errorMessage = null;
        this.requiresReconnect = false;
        this.proxyUrl = null;
    }
    static get observedAttributes() {
        return [
            'file-url',
            'provider',
            'account-id',
            'file-id',
            'content-type',
            'file-name'
        ];
    }
    connectedCallback() {
        this.parseAttributes();
        this.render();
        this.loadMedia();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.parseAttributes();
            this.render();
            if (name === 'file-url' || name === 'file-id') this.loadMedia();
        }
    }
    parseAttributes() {
        this.fileUrl = this.getAttribute('file-url') || '';
        this.provider = this.getAttribute('provider') || '';
        this.accountId = this.getAttribute('account-id') || '';
        this.fileId = this.getAttribute('file-id') || '';
        this.contentType = this.getAttribute('content-type') || '';
        this.fileName = this.getAttribute('file-name') || '';
        // Normalize contentType if it's just a file extension (e.g., "JPG" -> "image/jpeg")
        this.contentType = $2094d79e59e7b7ae$var$MediaAttachment.normalizeContentType(this.contentType);
        // If fileUrl is an OAuth URL, parse it
        if (this.fileUrl.startsWith('oauth://')) {
            const parts = this.fileUrl.substring(8).split('/');
            if (parts.length >= 3) {
                this.provider = this.provider || parts[0];
                this.accountId = this.accountId || parts[1];
                this.fileId = this.fileId || parts.slice(2).join('/');
            }
        }
    }
    static normalizeContentType(contentType) {
        if (!contentType) return '';
        // If it already looks like a MIME type (contains a slash), return as-is
        if (contentType.includes('/')) return contentType;
        // Otherwise, treat it as a file extension and convert to MIME type
        const ext = contentType.toLowerCase();
        const extensionToMimeType = {
            // Images
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'webp': 'image/webp',
            'svg': 'image/svg+xml',
            // Video
            'mp4': 'video/mp4',
            'webm': 'video/webm',
            'ogv': 'video/ogg',
            'mov': 'video/quicktime',
            // Audio
            'mp3': 'audio/mpeg',
            'wav': 'audio/wav',
            'ogg': 'audio/ogg',
            'flac': 'audio/flac',
            // Documents
            'pdf': 'application/pdf',
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'txt': 'text/plain',
            'md': 'text/markdown'
        };
        return extensionToMimeType[ext] || contentType;
    }
    render() {
        this.innerHTML = `
      <div class="media-attachment" data-content-type="${this.contentType || 'unknown'}">
        ${this.renderContent()}
      </div>
    `;
        this.attachEventListeners();
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="media-loading">
          <div class="spinner"></div>
          <p>Loading media...</p>
        </div>
      `;
        if (this.hasError) return this.renderError();
        if (!this.proxyUrl) return `
        <div class="media-placeholder">
          <p>Media not available</p>
        </div>
      `;
        return this.renderMedia();
    }
    renderError() {
        return `
      <div class="media-error">
        <div class="error-icon">\u{26A0}\u{FE0F}</div>
        <div class="error-content">
          <p class="error-message">${this.errorMessage || 'Failed to load media'}</p>
          ${this.requiresReconnect ? `
            <button class="btn btn-primary reconnect-btn">
              \u{1F517} Reconnect Account
            </button>
            <p class="error-hint">Your connection to ${this.provider} has expired. Please reconnect to view this media.</p>
          ` : `
            <button class="btn btn-secondary retry-btn">
              \u{1F504} Retry
            </button>
          `}
        </div>
      </div>
    `;
    }
    renderMedia() {
        const mimeType = this.contentType || this.detectContentType();
        if (mimeType.startsWith('image/')) return this.renderImage();
        else if (mimeType.startsWith('video/')) return this.renderVideo();
        else if (mimeType.startsWith('audio/')) return this.renderAudio();
        else if (mimeType.includes('pdf')) return this.renderPDF();
        else if (mimeType.includes('text/') || mimeType.includes('document')) return this.renderDocument();
        else return this.renderGeneric();
    }
    renderImage() {
        return `
      <div class="media-image-container">
        <img 
          src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.proxyUrl)}" 
          alt="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName || 'Image')}"
          class="media-image"
          loading="lazy"
          onerror="this.closest('media-attachment').handleImageError()"
        />
        ${this.fileName ? `<div class="media-caption">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName)}</div>` : ''}
      </div>
    `;
    }
    renderVideo() {
        return `
      <div class="media-video-container">
        <video 
          src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.proxyUrl)}"
          controls
          class="media-video"
          preload="metadata"
        >
          Your browser does not support the video tag.
        </video>
        ${this.fileName ? `<div class="media-caption">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName)}</div>` : ''}
      </div>
    `;
    }
    renderAudio() {
        return `
      <div class="media-audio-container">
        <div class="media-audio-player">
          <div class="audio-icon">\u{1F3B5}</div>
          <audio 
            src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.proxyUrl)}"
            controls
            class="media-audio"
            preload="metadata"
          >
            Your browser does not support the audio tag.
          </audio>
        </div>
        ${this.fileName ? `<div class="media-caption">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName)}</div>` : ''}
      </div>
    `;
    }
    renderPDF() {
        return `
      <div class="media-pdf-container">
        <div class="pdf-viewer">
          <iframe 
            src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.proxyUrl)}"
            class="media-pdf"
            title="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName || 'PDF Document')}"
          ></iframe>
        </div>
        <div class="media-actions">
          <a 
            href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.proxyUrl)}" 
            target="_blank" 
            rel="noopener noreferrer"
            class="btn btn-secondary"
          >
            \u{1F4C4} Open in New Tab
          </a>
          ${this.fileName ? `<div class="media-caption">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName)}</div>` : ''}
        </div>
      </div>
    `;
    }
    renderDocument() {
        return `
      <div class="media-document-container">
        <div class="document-preview">
          <div class="document-icon">\u{1F4C4}</div>
          <div class="document-info">
            <div class="document-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName || 'Document')}</div>
            <div class="document-type">${this.contentType || 'Document'}</div>
          </div>
        </div>
        <div class="media-actions">
          <a 
            href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.proxyUrl)}" 
            target="_blank" 
            rel="noopener noreferrer"
            class="btn btn-primary"
          >
            \u{1F4E5} Download
          </a>
        </div>
      </div>
    `;
    }
    renderGeneric() {
        return `
      <div class="media-generic-container">
        <div class="generic-preview">
          <div class="generic-icon">${(0, $72156d6136272719$export$5b8162d51027501d)()}</div>
          <div class="generic-info">
            <div class="generic-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.fileName || 'File')}</div>
            <div class="generic-type">${this.contentType || 'Unknown type'}</div>
          </div>
        </div>
        <div class="media-actions">
          <a 
            href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.proxyUrl)}" 
            target="_blank" 
            rel="noopener noreferrer"
            class="btn btn-primary"
          >
            \u{1F4E5} Download
          </a>
        </div>
      </div>
    `;
    }
    detectContentType() {
        if (!this.fileName && !this.fileId) return 'application/octet-stream';
        const name = this.fileName || this.fileId;
        const ext = name.split('.').pop()?.toLowerCase();
        const mimeTypes = {
            // Images
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'png': 'image/png',
            'gif': 'image/gif',
            'webp': 'image/webp',
            'svg': 'image/svg+xml',
            // Video
            'mp4': 'video/mp4',
            'webm': 'video/webm',
            'ogv': 'video/ogg',
            'mov': 'video/quicktime',
            // Audio
            'mp3': 'audio/mpeg',
            'wav': 'audio/wav',
            'ogg': 'audio/ogg',
            'flac': 'audio/flac',
            // Documents
            'pdf': 'application/pdf',
            'doc': 'application/msword',
            'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'xls': 'application/vnd.ms-excel',
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'txt': 'text/plain',
            'md': 'text/markdown'
        };
        return mimeTypes[ext] || 'application/octet-stream';
    }
    async loadMedia() {
        if (!this.fileUrl && !this.fileId) {
            this.hasError = true;
            this.errorMessage = 'No file URL or ID provided';
            this.render();
            return;
        }
        // If it's already a proxy URL, use it directly
        if (this.fileUrl && !this.fileUrl.startsWith('oauth://')) {
            this.proxyUrl = this.fileUrl;
            this.render();
            return;
        }
        // For OAuth URLs, we need to get a proxy URL
        this.isLoading = true;
        this.hasError = false;
        this.errorMessage = null;
        this.requiresReconnect = false;
        this.render();
        try {
            // Get proxy URL from the API
            const response = await fetch('/api/images/proxy-urls', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    image_urls: [
                        this.fileUrl || `oauth://${this.provider}/${this.accountId}/${this.fileId}`
                    ],
                    post_id: null // Could be passed as attribute if needed
                })
            });
            if (!response.ok) {
                const errorData = await response.json().catch(()=>({}));
                if (errorData.requiresReconnect) {
                    this.requiresReconnect = true;
                    this.errorMessage = 'Your connection has expired. Please reconnect your account.';
                } else this.errorMessage = 'Failed to load media';
                throw new Error(this.errorMessage);
            }
            const data = await response.json();
            const proxyUrlItem = data.proxy_urls?.[0];
            if (!proxyUrlItem || !proxyUrlItem.proxy_url) throw new Error('No proxy URL returned');
            this.proxyUrl = proxyUrlItem.proxy_url;
            this.isLoading = false;
            this.render();
        } catch (error) {
            window.logger.error('Error loading media:', error);
            this.isLoading = false;
            this.hasError = true;
            if (!this.errorMessage) this.errorMessage = error.message || 'Failed to load media';
            this.render();
        }
    }
    handleImageError() {
        this.hasError = true;
        this.errorMessage = 'Failed to load image';
        this.render();
    }
    attachEventListeners() {
        const reconnectBtn = this.querySelector('.reconnect-btn');
        reconnectBtn?.addEventListener('click', ()=>{
            window.location.href = '/settings/sparkle-sources';
        });
        const retryBtn = this.querySelector('.retry-btn');
        retryBtn?.addEventListener('click', ()=>{
            this.loadMedia();
        });
    }
}
customElements.define('media-attachment', $2094d79e59e7b7ae$var$MediaAttachment);
var $2094d79e59e7b7ae$export$2e2bcd8739ae039 = $2094d79e59e7b7ae$var$MediaAttachment;


class $2342ff2672d5c563$var$MarkdownPreview extends HTMLElement {
    constructor(){
        super();
        this.mode = 'raw'; // 'raw' or 'preview'
        this.textarea = null;
        this.previewContainer = null;
        this._titleInput = null;
        this._onTitleInput = null;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    disconnectedCallback() {
        // Clean up event listener
        if (this._filesSelectedHandler) {
            document.removeEventListener('files-selected', this._filesSelectedHandler);
            this._filesSelectedHandler = null;
        }
        if (this._titleInput && this._onTitleInput) {
            this._titleInput.removeEventListener('input', this._onTitleInput);
            this._titleInput = null;
            this._onTitleInput = null;
        }
    }
    bindTitleInput(inputElement) {
        if (this._titleInput && this._onTitleInput) this._titleInput.removeEventListener('input', this._onTitleInput);
        this._titleInput = inputElement || null;
        if (!this._titleInput) {
            this._onTitleInput = null;
            return;
        }
        this._onTitleInput = ()=>{
            if (this.mode === 'preview') this.updatePreview();
        };
        this._titleInput.addEventListener('input', this._onTitleInput);
    }
    _getPreviewTitleHtml() {
        const title = this._titleInput?.value?.trim() || '';
        if (!title || title === 'Untitled Post') return '';
        return `<div class="markdown-preview-title post-title"><h2>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(title)}</h2></div>`;
    }
    render() {
        // Find the textarea (should be a child)
        this.textarea = this.querySelector('textarea');
        if (!this.textarea) {
            window.logger.warn('markdown-preview: No textarea found');
            return;
        }
        // Store original textarea attributes and value
        const originalClass = this.textarea.className;
        const originalId = this.textarea.id;
        const originalName = this.textarea.name;
        const originalPlaceholder = this.textarea.placeholder;
        const originalRows = this.textarea.rows;
        const originalRequired = this.textarea.required;
        const originalValue = this.textarea.value;
        // Store all other attributes
        const otherAttributes = {};
        Array.from(this.textarea.attributes).forEach((attr)=>{
            if (![
                'class',
                'id',
                'name',
                'placeholder',
                'rows',
                'required',
                'value'
            ].includes(attr.name)) otherAttributes[attr.name] = attr.value;
        });
        // Create wrapper structure
        const wrapper = document.createElement('div');
        wrapper.className = 'markdown-preview-wrapper';
        wrapper.innerHTML = `
      <div class="markdown-preview-tabs">
        <button type="button" class="preview-tab active" data-mode="raw">Raw</button>
        <button type="button" class="preview-tab" data-mode="preview">Preview</button>
      </div>
      <div class="markdown-toolbar-container">
        <markdown-toolbar show-sparkle="true"></markdown-toolbar>
      </div>
      <div class="markdown-preview-content">
        <div class="markdown-textarea-container">
          <textarea 
            class="${originalClass}" 
            id="${originalId}"
            name="${originalName}"
            placeholder="${originalPlaceholder}"
            rows="${originalRows}"
            ${originalRequired ? 'required' : ''}
          >${originalValue}</textarea>
        </div>
        <div class="markdown-preview-container" style="display: none;"></div>
      </div>
    `;
        // Replace textarea with wrapper
        this.textarea.replaceWith(wrapper);
        // Get references
        this.textarea = wrapper.querySelector('textarea');
        this.previewContainer = wrapper.querySelector('.markdown-preview-container');
        this.rawTab = wrapper.querySelector('[data-mode="raw"]');
        this.previewTab = wrapper.querySelector('[data-mode="preview"]');
        this.toolbar = wrapper.querySelector('markdown-toolbar');
        // Copy any additional attributes
        Object.entries(otherAttributes).forEach(([name, value])=>{
            this.textarea.setAttribute(name, value);
        });
    }
    attachEventListeners() {
        if (!this.rawTab || !this.previewTab) return;
        this.rawTab.addEventListener('click', ()=>{
            this.setMode('raw');
        });
        this.previewTab.addEventListener('click', ()=>{
            this.setMode('preview');
        });
        // Handle Sparkle button click
        this.addEventListener('toolbar-sparkle-click', ()=>{
            this.openMediaSourcePicker();
        });
        // Listen for files-selected event from media source picker
        // Store handler reference for cleanup
        this._filesSelectedHandler = (e)=>{
            // Use textarea from event detail if provided and it's within this component
            // Otherwise, use this component's textarea if no textarea was specified
            let targetTextarea;
            if (e.detail?.textarea) {
                // If event has a textarea, only use it if it's within this component
                if (this.contains(e.detail.textarea)) targetTextarea = e.detail.textarea;
                else // Textarea is for a different component, ignore this event
                return;
            } else // No textarea in event, use this component's textarea
            targetTextarea = this.textarea;
            if (targetTextarea) this.handleFilesSelected(e.detail.files, targetTextarea);
        };
        document.addEventListener('files-selected', this._filesSelectedHandler);
        // Update preview when textarea content changes
        if (this.textarea) this.textarea.addEventListener('input', ()=>{
            if (this.mode === 'preview') this.updatePreview();
        });
    }
    setMode(mode) {
        if (this.mode === mode) return;
        this.mode = mode;
        const textareaContainer = this.querySelector('.markdown-textarea-container');
        const previewContainer = this.querySelector('.markdown-preview-container');
        const toolbarContainer = this.querySelector('.markdown-toolbar-container');
        // Hide/show the toolbar
        if (toolbarContainer) {
            if (mode === 'preview') toolbarContainer.style.display = 'none';
            else toolbarContainer.style.display = 'block';
        }
        if (mode === 'raw') {
            this.rawTab.classList.add('active');
            this.previewTab.classList.remove('active');
            if (textareaContainer) textareaContainer.style.display = 'block';
            if (previewContainer) previewContainer.style.display = 'none';
        } else {
            this.rawTab.classList.remove('active');
            this.previewTab.classList.add('active');
            if (textareaContainer) textareaContainer.style.display = 'none';
            if (previewContainer) {
                previewContainer.style.display = 'block';
                this.updatePreview();
            }
        }
    }
    async updatePreview() {
        if (!this.textarea || !this.previewContainer) return;
        const markdown = this.textarea.value;
        const titleHtml = this._getPreviewTitleHtml();
        if (!markdown.trim() && !titleHtml) {
            this.previewContainer.innerHTML = '<p class="markdown-empty">Start typing to see preview...</p>';
            return;
        }
        if (!markdown.trim()) {
            this.previewContainer.innerHTML = titleHtml;
            return;
        }
        // Show loading state
        this.previewContainer.innerHTML = `${titleHtml}<p class="markdown-loading">Rendering preview...</p>`;
        try {
            // Call backend API to render markdown
            const response = await window.API.request('/markdown/preview', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    markdown: markdown
                })
            });
            const bodyHtml = response.html || '<p class="markdown-empty">No preview available</p>';
            this.previewContainer.innerHTML = titleHtml + bodyHtml;
        } catch (error) {
            window.logger?.error('Error rendering markdown preview:', error);
            this.previewContainer.innerHTML = `${titleHtml}<p class="markdown-error">Error rendering preview. Please try again.</p>`;
        }
    }
    applyPostStyle(style) {
        if (!this.previewContainer) return;
        (0, $7346618887d6de45$export$d2fad7ce6a2a6489)(this.previewContainer, style);
        if (this.mode === 'preview') this.updatePreview();
    }
    clearPostStyle() {
        if (!this.previewContainer) return;
        (0, $7346618887d6de45$export$63f9f7d3280584f2)(this.previewContainer);
    }
    getTextarea() {
        return this.textarea;
    }
    getToolbar() {
        return this.toolbar;
    }
    openMediaSourcePicker() {
        // Get or create the media source picker component
        let picker = document.querySelector('media-source-picker');
        if (!picker) {
            picker = document.createElement('media-source-picker');
            document.body.appendChild(picker);
        }
        picker._targetTextarea = this.textarea;
        picker.open();
    }
    handleFilesSelected(files, textarea) {
        if (!files || files.length === 0) return;
        // Insert markdown syntax for each selected file
        files.forEach((file, index)=>{
            // Convert OAuth URL to markdown syntax
            // file.fileUrl is in format: oauth://provider/accountId/fileId
            const fileUrl = file.fileUrl || `oauth://${file.provider}/${file.accountId}/${file.fileId}`;
            const fileName = file.fileName || file.name || `File from ${file.provider}`;
            // Check if file is an image based on mimeType
            const mimeType = (0, $2094d79e59e7b7ae$export$2e2bcd8739ae039).normalizeContentType(file.mimeType);
            const isImage = mimeType && mimeType.startsWith('image/');
            let markdown;
            if (isImage) // Use image markdown syntax for images
            markdown = `![${fileName}](${fileUrl})`;
            else {
                // Use custom syntax for non-image files that will be rendered as media-attachment
                // Format: [file:filename](oauth://provider/account/fileId?mimeType=...)
                const urlWithMimeType = file.mimeType ? `${fileUrl}?mimeType=${encodeURIComponent(file.mimeType)}` : fileUrl;
                markdown = `[file:${fileName}](${urlWithMimeType})`;
            }
            // Insert with spacing
            const prefix = index === 0 ? '\n\n' : '\n';
            (0, $162c50354e6ab33d$export$138a840241174bc2)(textarea, `${prefix}${markdown}`, {
                ensureTrailingNewline: false
            });
        });
        // Focus the textarea and trigger input event
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
}
customElements.define('markdown-preview', $2342ff2672d5c563$var$MarkdownPreview);


// Markdown Toolbar Web Component

class $ddb3b4c2d1a1c6bd$var$MarkdownToolbar extends HTMLElement {
    constructor(){
        super();
        this.targetTextarea = null;
        this.boundHandleKeydown = this.handleKeydown.bind(this);
        this.helpPaneOpen = false;
    }
    static get observedAttributes() {
        return [
            'target',
            'show-sparkle'
        ];
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.findTargetTextarea();
    }
    disconnectedCallback() {
        if (this.targetTextarea) this.targetTextarea.removeEventListener('keydown', this.boundHandleKeydown);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === 'target' && this.isConnected) this.findTargetTextarea();
    }
    findTargetTextarea() {
        const targetAttr = this.getAttribute('target');
        if (targetAttr) {
            // If target is specified, find it
            const targetElement = document.querySelector(targetAttr) || document.getElementById(targetAttr);
            if (targetElement && targetElement.tagName === 'TEXTAREA') this.targetTextarea = targetElement;
        } else {
            // If we're inside markdown-preview, find textarea in the preview component
            const previewWrapper = this.closest('markdown-preview');
            if (previewWrapper) {
                const textarea = previewWrapper.querySelector('.markdown-textarea-container textarea');
                if (textarea) this.targetTextarea = textarea;
            } else {
                // Otherwise, find the next textarea sibling or parent's textarea
                let current = this.nextElementSibling;
                while(current){
                    if (current.tagName === 'TEXTAREA') {
                        this.targetTextarea = current;
                        break;
                    }
                    current = current.nextElementSibling;
                }
                // If not found, look in parent
                if (!this.targetTextarea && this.parentElement) {
                    const textarea = this.parentElement.querySelector('textarea');
                    if (textarea) this.targetTextarea = textarea;
                }
            }
        }
        // Attach keyboard shortcuts to textarea
        if (this.targetTextarea) this.targetTextarea.addEventListener('keydown', this.boundHandleKeydown);
    }
    render() {
        const showSparkle = this.getAttribute('show-sparkle') !== 'false';
        const helpOpen = this.helpPaneOpen || false;
        this.innerHTML = `
      <div class="markdown-toolbar">
        <button type="button" class="toolbar-btn toolbar-btn-bold" title="Bold (Ctrl+B)">
          <span class="material-symbols-outlined bold-icon">format_bold</span>
        </button>
        <button type="button" class="toolbar-btn toolbar-btn-italic" title="Italic (Ctrl+I)">
          <span class="material-symbols-outlined italic-icon">format_italic</span>
        </button>
        <div class="toolbar-divider"></div>
        <button type="button" class="toolbar-btn toolbar-btn-blockquote" title="Blockquote">
          <span class="material-symbols-outlined dance-icon">format_quote</span>
        </button>
        <button type="button" class="toolbar-btn toolbar-btn-code" title="Code">
          <span class="material-symbols-outlined dance-icon">code</span>
        </button>
        <div class="toolbar-divider"></div>
        <button type="button" class="toolbar-btn toolbar-btn-unordered-list" title="Unordered List">
          <span class="material-symbols-outlined list-icon">format_list_bulleted</span>
        </button>
        <button type="button" class="toolbar-btn toolbar-btn-ordered-list" title="Ordered List">
          <span class="material-symbols-outlined list-icon">format_list_numbered</span>
        </button>
        <div class="toolbar-divider"></div>
        <button type="button" class="toolbar-btn toolbar-btn-img" title="Image">
          <span class="material-symbols-outlined image-icon">image</span>
        </button>
        <button type="button" class="toolbar-btn toolbar-btn-link" title="Link">
          <span class="material-symbols-outlined link-icon">link</span>
        </button>
        ${showSparkle ? '<div class="toolbar-divider"></div>' : ''}
        ${showSparkle ? `
          <button type="button" class="toolbar-btn toolbar-btn-sparkle" title="Add a Sparkle">
            <span class="material-symbols-outlined sparkle-icon">attach_file</span>
          </button>
        ` : ''}
        <div class="toolbar-divider"></div>
        <button type="button" class="toolbar-btn toolbar-btn-help ${helpOpen ? 'active' : ''}" title="Help">
          <span class="material-symbols-outlined help-icon">help_outline</span>
        </button>
      </div>
      <div class="markdown-help-pane ${helpOpen ? 'open' : ''}">
        <div class="help-pane-content">
          <div class="close-help">Click the help button again to close the help pane. \u{2197}\u{FE0F}</div>
          <details class="help-section" open="true">
            <summary>\u{1F4DD} Formatting Help</summary>
            <div class="help-section-content">
              <p>Fun Old Times uses Markdown for formatting. Markdown is a simple, human-readable text format that converts to beautifully formatted posts.</p>
              <ul class="markdown-examples">
                <li>You can wrap text in <code>**bold**</code> or <code>*italic*</code> to make it <strong>bold</strong> or <em>italic</em>.</li>
                <li>You can also use <code>&gt;</code> to make text a blockquote.</li>
                <li>You can use <code>\`\`\`</code> to make text a code block.</li>
                <li>You can use <code>-</code> to make text a list item.</li>
                <li>You can use <code>1.</code> to make text a numbered list item.</li>
                <li>You can use <code>![caption](url)</code> to insert an image.</li>
                <li>You can use <code>[text](url)</code> to insert a link.</li>
              </ul>
              <p>You can also use the buttons defined below.</p>
            </div>
          </details>
          <details class="help-section" open="true">
            <summary>\u{1F3A8} Toolbar Buttons</summary>
            <div class="help-section-content">
              <div class="help-button-grid">
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon bold-icon">format_bold</span>
                  <strong>Bold</strong> <kbd>Ctrl+B</kbd> - Makes text <strong>bold</strong> by wrapping it in double asterisks
                </div>
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon italic-icon">format_italic</span>
                  <strong>Italic</strong> <kbd>Ctrl+I</kbd> - Makes text <em>italic</em> by wrapping it in single asterisks
                </div>
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon dance-icon">format_quote</span>
                  <strong>Blockquote</strong> - Formats text as a quote by adding <code>&gt;</code> at the start of each line
                </div>
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon dance-icon">code</span>
                  <strong>Code</strong> - Wraps text in backticks for inline code or triple backticks for code blocks
                </div>
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon list-icon">format_list_bulleted</span>
                  <strong>Unordered List</strong> - Creates a bulleted list with dashes (<code>-</code>)
                </div>
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon list-icon">format_list_numbered</span>
                  <strong>Ordered List</strong> - Creates a numbered list (<code>1.</code>, <code>2.</code>, <code>3.</code>)
                </div>
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon image-icon">image</span>
                  <strong>Image</strong> - Inserts an image using <code>![caption](url)</code> format
                </div>
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon link-icon">link</span>
                  <strong>Link</strong> - Inserts a link using <code>[text](url)</code> format
                </div>
                ${showSparkle ? `
                <div class="help-button-item">
                  <span class="material-symbols-outlined help-button-icon sparkle-icon">attach_file</span>
                  <strong>Sparkle</strong> \u{2728} - Add photos and files from your connected cloud storage accounts (SmugMug, Google Drive)
                </div>
                ` : ''}
              </div>
            </div>
          </details>
          ${showSparkle ? `
          <details class="help-section" open="true">
            <summary>\u{2728} Sparkle Sources</summary>
            <div class="help-section-content">
              <p>Sparkle is a feature that allows you to add photos and files from your connected cloud storage accounts directly into your posts. Fun
              Old Times only has access to the files you select to share with it. This prevents most ad trackers. 
              You can revoke access and all of your previously shared files will no longer be available in the app. 
              We value your privacy and security.</p>

              <p>To use the Sparkle button, you'll need to connect your cloud storage accounts first. This allows you to easily add photos and files from your SmugMug or Google Drive directly into your posts.</p>
              <a href="/settings/sparkle-sources" class="help-link-btn">\u{2699}\u{FE0F} Go to Sparkle Sources Settings</a>
            </div>
          </details>
          ` : ''}
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        const boldBtn = this.querySelector('.toolbar-btn-bold');
        const italicBtn = this.querySelector('.toolbar-btn-italic');
        const blockquoteBtn = this.querySelector('.toolbar-btn-blockquote');
        const codeBtn = this.querySelector('.toolbar-btn-code');
        const unorderedListBtn = this.querySelector('.toolbar-btn-unordered-list');
        const orderedListBtn = this.querySelector('.toolbar-btn-ordered-list');
        const imgBtn = this.querySelector('.toolbar-btn-img');
        const linkBtn = this.querySelector('.toolbar-btn-link');
        const sparkleBtn = this.querySelector('.toolbar-btn-sparkle');
        const helpBtn = this.querySelector('.toolbar-btn-help');
        if (boldBtn) boldBtn.addEventListener('click', ()=>{
            this.insertBold();
        });
        if (italicBtn) italicBtn.addEventListener('click', ()=>{
            this.insertItalic();
        });
        if (blockquoteBtn) blockquoteBtn.addEventListener('click', ()=>{
            this.insertBlockquote();
        });
        if (codeBtn) codeBtn.addEventListener('click', ()=>{
            this.insertCode();
        });
        if (unorderedListBtn) unorderedListBtn.addEventListener('click', ()=>{
            this.insertUnorderedList();
        });
        if (orderedListBtn) orderedListBtn.addEventListener('click', ()=>{
            this.insertOrderedList();
        });
        if (imgBtn) imgBtn.addEventListener('click', ()=>{
            this.insertImg();
        });
        if (linkBtn) linkBtn.addEventListener('click', ()=>{
            this.insertLink();
        });
        if (sparkleBtn) sparkleBtn.addEventListener('click', ()=>{
            this.handleSparkleClick();
        });
        if (helpBtn) helpBtn.addEventListener('click', ()=>{
            this.handleHelpClick();
        });
    }
    handleKeydown(e) {
        // Ctrl/Cmd + B for bold
        if ((e.ctrlKey || e.metaKey) && e.key === 'b') {
            e.preventDefault();
            this.insertBold();
        }
        // Ctrl/Cmd + I for italic
        if ((e.ctrlKey || e.metaKey) && e.key === 'i') {
            e.preventDefault();
            this.insertItalic();
        }
    }
    insertBold() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = textarea.value.substring(start, end);
        const textToInsert = `**${selectedText}**`;
        (0, $162c50354e6ab33d$export$138a840241174bc2)(textarea, textToInsert, {
            ensureTrailingNewline: false
        });
        // If no text was selected, position cursor between the markers
        const newPositionIncrement = 2;
        if (selectedText) // Position cursor after the inserted text
        textToInsert.length;
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    insertItalic() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = textarea.value.substring(start, end);
        let textToInsert;
        if (selectedText) // If text is selected, wrap it in italic markers
        textToInsert = `*${selectedText}*`;
        else // If no text selected, insert italic markers with cursor in between
        textToInsert = '**';
        (0, $162c50354e6ab33d$export$138a840241174bc2)(textarea, textToInsert, {
            ensureTrailingNewline: false
        });
        // If no text was selected, position cursor between the markers
        if (!selectedText) {
            const newPosition = start + 1;
            textarea.setSelectionRange(newPosition, newPosition);
        } else {
            // Position cursor after the inserted text
            const newPosition = start + textToInsert.length;
            textarea.setSelectionRange(newPosition, newPosition);
        }
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    insertBlockquote() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = textarea.value.substring(start, end);
        const lines = selectedText.split('\n');
        const value = textarea.value;
        const beforeText = value.substring(0, start);
        const afterText = value.substring(end);
        // Get the line start position
        const lineStart = beforeText.lastIndexOf('\n') + 1;
        const currentLine = beforeText.substring(lineStart);
        let textToInsert;
        if (selectedText) {
            // If text is selected, wrap each line with >
            const quotedLines = lines.map((line)=>line ? `> ${line}` : '>').join('\n');
            textToInsert = quotedLines;
        } else // If no text selected, insert blockquote marker
        if (currentLine.trim() === '') // Empty line - insert > with space
        textToInsert = '> ';
        else {
            // Non-empty line - insert > at start of line
            const beforeLine = beforeText.substring(0, lineStart);
            const newLineStart = beforeLine + '> ';
            textarea.value = newLineStart + currentLine + afterText;
            const newPosition = newLineStart.length + currentLine.length;
            textarea.setSelectionRange(newPosition, newPosition);
            textarea.focus();
            textarea.dispatchEvent(new Event('input', {
                bubbles: true
            }));
            return;
        }
        // Replace selected text
        textarea.value = beforeText + textToInsert + afterText;
        const newPosition = start + textToInsert.length;
        textarea.setSelectionRange(newPosition, newPosition);
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    insertCode() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = textarea.value.substring(start, end);
        let textToInsert;
        if (selectedText) {
            // If text is selected, check if it contains newlines
            if (selectedText.includes('\n')) // Multi-line code block
            textToInsert = `\`\`\`\n${selectedText}\n\`\`\``;
            else // Inline code
            textToInsert = `\`${selectedText}\``;
        } else // If no text selected, insert inline code markers
        textToInsert = '``';
        (0, $162c50354e6ab33d$export$138a840241174bc2)(textarea, textToInsert, {
            ensureTrailingNewline: false
        });
        // If no text was selected, position cursor between the markers
        if (!selectedText) {
            const newPosition = start + 1;
            textarea.setSelectionRange(newPosition, newPosition);
        } else {
            // Position cursor after the inserted text
            const newPosition = start + textToInsert.length;
            textarea.setSelectionRange(newPosition, newPosition);
        }
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    insertUnorderedList() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = textarea.value.substring(start, end);
        const value = textarea.value;
        const beforeText = value.substring(0, start);
        const afterText = value.substring(end);
        let textToInsert;
        if (selectedText) {
            // If text is selected, convert each line to a list item
            const lines = selectedText.split('\n');
            const listItems = lines.filter((line)=>line.trim()).map((line)=>`- ${line.trim()}`).join('\n');
            textToInsert = listItems;
        } else // If no text selected, insert a list item
        textToInsert = '- ';
        // Replace selected text
        textarea.value = beforeText + textToInsert + afterText;
        const newPosition = start + textToInsert.length;
        textarea.setSelectionRange(newPosition, newPosition);
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    insertOrderedList() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = textarea.value.substring(start, end);
        const value = textarea.value;
        const beforeText = value.substring(0, start);
        const afterText = value.substring(end);
        let textToInsert;
        if (selectedText) {
            // If text is selected, convert each line to a numbered list item
            const lines = selectedText.split('\n');
            let itemNumber = 1;
            const listItems = lines.filter((line)=>line.trim()).map((line)=>{
                const item = `${itemNumber}. ${line.trim()}`;
                itemNumber++;
                return item;
            }).join('\n');
            textToInsert = listItems;
        } else // If no text selected, insert a numbered list item
        textToInsert = '1. ';
        // Replace selected text
        textarea.value = beforeText + textToInsert + afterText;
        const newPosition = start + textToInsert.length;
        textarea.setSelectionRange(newPosition, newPosition);
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    insertImg() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        let selectedText = textarea.value.substring(start, end);
        if (!selectedText) selectedText = 'Enter Image Caption Here';
        const imgUrl = prompt('Enter a URL for this image:');
        if (!imgUrl) return;
        const textToInsert = `![${selectedText}](${imgUrl})`;
        (0, $162c50354e6ab33d$export$138a840241174bc2)(textarea, textToInsert, {
            ensureTrailingNewline: false
        });
        // Position cursor after the inserted text
        const newPosition = start + textToInsert.length;
        textarea.setSelectionRange(newPosition, newPosition);
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    insertLink() {
        const textarea = this.getTextarea();
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        let selectedText = textarea.value.substring(start, end);
        if (!selectedText) selectedText = 'Enter Link Text Here';
        const linkUrl = prompt('Enter a URL for this link:');
        if (!linkUrl) return;
        const textToInsert = `[${selectedText}](${linkUrl})`;
        (0, $162c50354e6ab33d$export$138a840241174bc2)(textarea, textToInsert, {
            ensureTrailingNewline: false
        });
        // Position cursor after the inserted text
        const newPosition = start + textToInsert.length;
        textarea.setSelectionRange(newPosition, newPosition);
        textarea.focus();
        textarea.dispatchEvent(new Event('input', {
            bubbles: true
        }));
    }
    handleSparkleClick() {
        // Dispatch event for parent component to handle
        this.dispatchEvent(new CustomEvent('toolbar-sparkle-click', {
            bubbles: true,
            detail: {
                textarea: this.getTextarea()
            }
        }));
    }
    handleHelpClick() {
        this.helpPaneOpen = !this.helpPaneOpen;
        this.render();
        this.attachEventListeners();
    }
    getTextarea() {
        if (!this.targetTextarea) this.findTargetTextarea();
        return this.targetTextarea;
    }
    setTextarea(textarea) {
        // Remove old listener
        if (this.targetTextarea) this.targetTextarea.removeEventListener('keydown', this.boundHandleKeydown);
        // Set new textarea
        this.targetTextarea = textarea;
        // Add new listener
        if (this.targetTextarea) this.targetTextarea.addEventListener('keydown', this.boundHandleKeydown);
    }
}
// Register the custom element
customElements.define('markdown-toolbar', $ddb3b4c2d1a1c6bd$var$MarkdownToolbar);



// Media Source Picker Web Component
// Allows users to browse and select files from OAuth-connected media sources



class $9cc1d01a4595998f$var$MediaSourcePicker extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.isLoading = false;
        this.isLoadingMore = false;
        this.accounts = [];
        this.providers = [];
        this.currentAccount = null;
        this.currentPath = 'root';
        this.pathHistory = [];
        this.entries = [];
        this.selectedFiles = [];
        this.searchQuery = '';
        this.searchResults = [];
        this.isSearching = false;
        // Pagination state
        this.currentPage = 1;
        this.hasMore = false;
        this.nextPageToken = null;
        this.searchHasMore = false;
        this.searchNextPageToken = null;
        this.isOpeningPicker = false; // Guard to prevent multiple picker opens
        this.pendingPickerAccount = null; // Store account info for picker callbacks
        this.pendingPickerAccessToken = null; // Store access token for picker callbacks
    }
    isSingleSelect() {
        return this.getAttribute('selection-mode') === 'single';
    }
    isUrlOutput() {
        return this.getAttribute('output-mode') === 'url';
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        // Set up event delegation for connect account link (persists across re-renders)
        this._connectAccountHandler = (e)=>{
            const connectLink = e.target.closest('#connectAccountLink');
            if (connectLink) {
                e.preventDefault();
                e.stopPropagation();
                this.close();
                // Small delay to allow modal to close, then navigate
                setTimeout(()=>{
                    window.location.href = '/settings/sparkle-sources';
                }, 100);
            }
        };
        this.addEventListener('click', this._connectAccountHandler);
    }
    disconnectedCallback() {
        // Clean up event listener
        if (this._connectAccountHandler) this.removeEventListener('click', this._connectAccountHandler);
    }
    render() {
        // Determine if current account uses picker or filesystem browser
        const usesPicker = this.isGoogleProvider(this.currentAccount?.provider);
        this.innerHTML = `
      <div class="media-picker-modal ${this.isOpen ? 'open' : ''}" id="mediaPickerModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>\u{2728} Share Sparkle from Elsewhere</h3>
            <button class="close-btn" id="closeBtn">\xd7</button>
          </div>
          
          <div class="modal-body">
            ${this.renderAccountSelector()}
            ${usesPicker ? this.renderPickerMode() : this.renderFilesystemMode()}
          </div>
          
          ${!usesPicker ? `
          <div class="modal-footer">
            <div class="selected-count">${this.selectedFiles.length} selected</div>
            <div class="footer-actions">
              <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
              <button type="button" class="btn btn-primary" id="selectBtn" disabled>
                Select Files
              </button>
            </div>
          </div>
          ` : ''}
        </div>
      </div>
    `;
        this.cacheDom();
        if (this.isOpen) this.loadPickerData();
        else // Still attach event listeners even when closed (for close/cancel buttons)
        this.attachEventListeners();
    }
    cacheDom() {
        this.backdrop = this.querySelector('#modalBackdrop');
        this.closeBtn = this.querySelector('#closeBtn');
        this.cancelBtn = this.querySelector('#cancelBtn');
        this.selectBtn = this.querySelector('#selectBtn');
        this.accountSelect = this.querySelector('#accountSelect');
        this.breadcrumb = this.querySelector('.breadcrumb');
        this.searchInput = this.querySelector('#searchInput');
        this.searchBtn = this.querySelector('#searchBtn');
        this.contentArea = this.querySelector('.picker-content');
        // Attach event listeners after caching DOM elements
        this.attachEventListeners();
    }
    /**
   * Check if provider uses Google Picker (instead of filesystem browser)
   */ isGoogleProvider(provider) {
        return provider === 'google-drive' || provider === 'google-photos';
    }
    /**
   * Render picker mode UI (for Google providers)
   */ renderPickerMode() {
        if (!this.currentAccount) return '<div class="picker-loading"><p>Select an account to open picker</p></div>';
        return `
      <div class="picker-loading">
        <div class="spinner"></div>
        <p>Opening ${this.currentAccount.providerDisplayName || this.currentAccount.provider} picker...</p>
      </div>
    `;
    }
    /**
   * Render filesystem browser mode UI (for non-Google providers)
   */ renderFilesystemMode() {
        return `
      ${this.renderBreadcrumb()}
      ${this.renderSearch()}
      ${this.renderContent()}
    `;
    }
    renderAccountSelector() {
        if (this.accounts.length === 0 && !this.isLoading) return `
        <div class="account-selector">
          <div class="empty-state">
            <p>No connected accounts yet.</p>
            <a href="/settings/sparkle-sources" class="btn btn-primary" id="connectAccountLink">Connect an Account</a>
          </div>
        </div>
      `;
        // Determine which account should be selected
        const selectedAccountId = this.currentAccount?.id || '';
        return `
      <div class="account-selector">
        <label for="accountSelect">Account:</label>
        <select id="accountSelect" class="form-control">
          <option value="">Select an account...</option>
          ${this.accounts.map((account)=>`
            <option value="${account.id}" 
                    data-provider="${account.provider}" 
                    data-account-id="${account.accountIdentifier}"
                    ${account.id === selectedAccountId ? 'selected' : ''}>
              ${account.providerDisplayName} - ${account.accountLabel}
              ${account.isExpired ? ' (Expired)' : ''}
            </option>
          `).join('')}
        </select>
      </div>
    `;
    }
    renderBreadcrumb() {
        if (!this.currentAccount) return '<div class="breadcrumb"></div>';
        const canGoBack = this.pathHistory.length > 0;
        const breadcrumbItems = [
            {
                name: 'Home',
                path: 'root'
            },
            ...this.pathHistory.map((item)=>({
                    name: item.name,
                    path: item.path
                }))
        ];
        return `
      <div class="breadcrumb">
        ${canGoBack ? `
          <button type="button" class="back-btn" id="backBtn" title="Go back">
            \u{2190} Back
          </button>
        ` : ''}
        <div class="breadcrumb-items">
          ${breadcrumbItems.map((item, idx)=>`
            <button type="button" class="breadcrumb-item" data-path="${item.path}">
              ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(item.name)}
            </button>
            ${idx < breadcrumbItems.length - 1 ? '<span class="breadcrumb-separator">/</span>' : ''}
          `).join('')}
        </div>
      </div>
    `;
    }
    renderSearch() {
        if (!this.currentAccount) return '<div class="search-bar" style="display: none;"></div>';
        return `
      <div class="search-bar">
        <input 
          type="search" 
          id="searchInput" 
          class="form-control" 
          placeholder="Search files..."
          value="${this.searchQuery}"
        />
        <button type="button" id="searchBtn" class="btn btn-secondary">\u{1F50D} Search</button>
        ${this.searchQuery ? '<button type="button" id="clearSearchBtn" class="btn btn-text">Clear</button>' : ''}
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="picker-content">
          <div class="loading-state">
            <div class="spinner"></div>
            <p>Loading...</p>
          </div>
        </div>
      `;
        if (!this.currentAccount) return `
        <div class="picker-content">
          <div class="empty-state">
            <p>Select an account to browse files</p>
          </div>
        </div>
      `;
        if (this.isSearching) return this.renderSearchResults();
        if (this.entries.length === 0) return `
        <div class="picker-content">
          <div class="empty-state">
            <p>This folder is empty</p>
          </div>
        </div>
      `;
        return `
      <div class="picker-content">
        <div class="file-grid">
          ${this.entries.map((entry)=>this.renderEntry(entry)).join('')}
        </div>
        ${this.hasMore ? `
          <div class="pagination-controls">
            <button type="button" class="btn btn-secondary" id="loadMoreBtn" ${this.isLoadingMore ? 'disabled' : ''}>
              ${this.isLoadingMore ? 'Loading...' : 'Load More'}
            </button>
          </div>
        ` : ''}
      </div>
    `;
    }
    renderEntry(entry) {
        const isSelected = this.selectedFiles.some((f)=>f.provider === this.currentAccount.provider && f.accountId === this.currentAccount.accountIdentifier && f.fileId === entry.id);
        const icon = entry.type === 'directory' ? "\uD83D\uDCC1" : this.getFileIcon(entry.contentType);
        // Use thumbnail if available, otherwise use icon
        const thumbnailHtml = entry.thumbnailUrl ? `<img src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(entry.thumbnailUrl)}" alt="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(entry.name)}" class="file-thumbnail" loading="lazy" onerror="this.style.display='none'; this.nextElementSibling.style.display='block';" />` : '';
        const iconHtml = entry.thumbnailUrl ? `<div class="file-icon" style="display: none;">${icon}</div>` : `<div class="file-icon">${icon}</div>`;
        return `
      <div class="file-item ${entry.type === 'directory' ? 'directory' : 'file'} ${isSelected ? 'selected' : ''}" 
           data-entry-id="${entry.id}" 
           data-entry-type="${entry.type}">
        <div class="file-checkbox">
          <input type="checkbox" ${isSelected ? 'checked' : ''} />
        </div>
        ${thumbnailHtml}
        ${iconHtml}
        <div class="file-info">
          <div class="file-name" title="${entry.name}">${entry.name}</div>
          ${entry.size ? `<div class="file-size">${this.formatFileSize(entry.size)}</div>` : ''}
        </div>
      </div>
    `;
    }
    renderSearchResults() {
        if (this.searchResults.length === 0 && !this.isLoading) return `
        <div class="picker-content">
          <div class="empty-state">
            <p>No files found matching "${this.searchQuery}"</p>
          </div>
        </div>
      `;
        return `
      <div class="picker-content">
        <div class="file-grid">
          ${this.searchResults.map((entry)=>this.renderEntry(entry)).join('')}
        </div>
        ${this.searchHasMore ? `
          <div class="pagination-controls">
            <button type="button" class="btn btn-secondary" id="loadMoreSearchBtn" ${this.isLoadingMore ? 'disabled' : ''}>
              ${this.isLoadingMore ? 'Loading...' : 'Load More'}
            </button>
          </div>
        ` : ''}
      </div>
    `;
    }
    getFileIcon(contentType) {
        if (!contentType) return "\uD83D\uDCC4";
        if (contentType.startsWith('image/')) return "\uD83D\uDDBC\uFE0F";
        if (contentType.startsWith('video/')) return "\uD83C\uDFA5";
        if (contentType.startsWith('audio/')) return "\uD83C\uDFB5";
        if (contentType.includes('pdf')) return "\uD83D\uDCD5";
        if (contentType.includes('word') || contentType.includes('document')) return "\uD83D\uDCDD";
        if (contentType.includes('spreadsheet') || contentType.includes('excel')) return "\uD83D\uDCCA";
        return "\uD83D\uDCC4";
    }
    formatFileSize(bytes) {
        if (!bytes) return '';
        const units = [
            'B',
            'KB',
            'MB',
            'GB'
        ];
        let size = bytes;
        let unitIndex = 0;
        while(size >= 1024 && unitIndex < units.length - 1){
            size /= 1024;
            unitIndex++;
        }
        return `${size.toFixed(1)} ${units[unitIndex]}`;
    }
    attachEventListeners() {
        // Remove existing listeners to prevent duplicates
        if (this._backdropHandler) this.backdrop?.removeEventListener('click', this._backdropHandler);
        if (this._closeBtnHandler) this.closeBtn?.removeEventListener('click', this._closeBtnHandler);
        if (this._cancelBtnHandler) this.cancelBtn?.removeEventListener('click', this._cancelBtnHandler);
        if (this._selectBtnHandler) this.selectBtn?.removeEventListener('click', this._selectBtnHandler);
        if (this._accountSelectHandler) this.accountSelect?.removeEventListener('change', this._accountSelectHandler);
        if (this._searchBtnHandler) this.searchBtn?.removeEventListener('click', this._searchBtnHandler);
        if (this._searchInputHandler) this.searchInput?.removeEventListener('keypress', this._searchInputHandler);
        if (this._clearSearchBtnHandler) {
            const clearSearchBtn = this.querySelector('#clearSearchBtn');
            clearSearchBtn?.removeEventListener('click', this._clearSearchBtnHandler);
        }
        // Create new handler functions and store references
        this._backdropHandler = ()=>this.close();
        this._closeBtnHandler = ()=>this.close();
        this._cancelBtnHandler = ()=>this.close();
        this._selectBtnHandler = ()=>this.handleSelect();
        this._accountSelectHandler = (e)=>this.handleAccountChange(e);
        this._searchBtnHandler = ()=>this.handleSearch();
        this._searchInputHandler = (e)=>{
            if (e.key === 'Enter') this.handleSearch();
        };
        this._clearSearchBtnHandler = ()=>this.clearSearch();
        // Attach new listeners
        this.backdrop?.addEventListener('click', this._backdropHandler);
        this.closeBtn?.addEventListener('click', this._closeBtnHandler);
        this.cancelBtn?.addEventListener('click', this._cancelBtnHandler);
        this.selectBtn?.addEventListener('click', this._selectBtnHandler);
        this.accountSelect?.addEventListener('change', this._accountSelectHandler);
        this.searchBtn?.addEventListener('click', this._searchBtnHandler);
        this.searchInput?.addEventListener('keypress', this._searchInputHandler);
        const clearSearchBtn = this.querySelector('#clearSearchBtn');
        clearSearchBtn?.addEventListener('click', this._clearSearchBtnHandler);
        // Load More button handlers
        const loadMoreBtn = this.querySelector('#loadMoreBtn');
        if (loadMoreBtn) loadMoreBtn.addEventListener('click', ()=>this.loadMoreDirectory());
        const loadMoreSearchBtn = this.querySelector('#loadMoreSearchBtn');
        if (loadMoreSearchBtn) loadMoreSearchBtn.addEventListener('click', ()=>this.loadMoreSearch());
        // Delegate events for file items
        this.contentArea?.addEventListener('click', (e)=>{
            const fileItem = e.target.closest('.file-item');
            if (!fileItem) return;
            const entryId = fileItem.dataset.entryId;
            const entryType = fileItem.dataset.entryType;
            if (e.target.type === 'checkbox' || e.target.closest('.file-checkbox')) this.toggleFileSelection(entryId, entryType, fileItem);
            else if (entryType === 'directory') this.navigateToDirectory(entryId);
        });
        // Back button handler
        const backBtn = this.querySelector('#backBtn');
        if (backBtn) backBtn.addEventListener('click', ()=>{
            this.goBack();
        });
        // Breadcrumb navigation
        this.breadcrumb?.addEventListener('click', (e)=>{
            const breadcrumbItem = e.target.closest('.breadcrumb-item');
            if (breadcrumbItem) {
                const path = breadcrumbItem.dataset.path;
                this.navigateToPath(path);
            }
        });
    }
    async loadPickerData() {
        this.isLoading = true;
        this.updateContent();
        try {
            const response = await fetch('/api/media-sources/picker', {
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Failed to load picker data');
            const data = await response.json();
            this.accounts = data.accounts || [];
            this.providers = data.providers || [];
            this.isLoading = false;
            this.updateContent();
        } catch (error) {
            window.logger.error('Error loading picker data:', error);
            this.isLoading = false;
            this.updateContent();
            this.showError('Failed to load accounts. Please try again.');
        }
    }
    async handleAccountChange(e) {
        const option = e.target.selectedOptions[0];
        if (!option || !option.value) {
            this.currentAccount = null;
            this.currentPath = 'root';
            this.pathHistory = [];
            this.entries = [];
            this.updateContent();
            return;
        }
        this.currentAccount = {
            id: option.value,
            provider: option.dataset.provider,
            accountIdentifier: option.dataset.accountId,
            providerDisplayName: this.accounts.find((a)=>a.id === option.value)?.providerDisplayName
        };
        // Check if this is a Google provider
        if (this.isGoogleProvider(this.currentAccount.provider)) {
            // Prevent multiple simultaneous picker opens
            if (this.isOpeningPicker) return;
            // For Google providers, close the modal first, then open picker
            const provider = this.currentAccount.provider;
            const accountIdentifier = this.currentAccount.accountIdentifier;
            // Store account info for picker callbacks (since close() clears currentAccount)
            this.pendingPickerAccount = {
                provider: this.currentAccount.provider,
                accountIdentifier: this.currentAccount.accountIdentifier,
                id: this.currentAccount.id,
                providerDisplayName: this.currentAccount.providerDisplayName
            };
            this.isOpeningPicker = true;
            this.close();
            // Small delay to allow modal to close before opening Google picker
            setTimeout(async ()=>{
                try {
                    // Open appropriate picker
                    if (provider === 'google-drive') await (0, $340e9f71e9f92c91$export$e486ce152da8ad13)(this, provider, accountIdentifier);
                    else if (provider === 'google-photos') await (0, $c9548aa4bfe9f9fa$export$d5873a3c7faa463a)(this, provider, accountIdentifier);
                } catch (error) {
                    // Error already handled in openGoogleDrivePicker/openGooglePhotosPicker
                    // Guard will be reset there
                    window.logger.debug('Error opening picker:', {
                        error: error
                    });
                }
            }, 100);
        } else {
            // For other providers, use filesystem browser
            this.currentPath = 'root';
            this.pathHistory = [];
            this.selectedFiles = [];
            this.updateSelectButton();
            await this.loadDirectory('root');
        }
    }
    async loadDirectory(path, append = false) {
        if (!this.currentAccount) return;
        // If not appending, reset pagination state
        if (!append) {
            this.isLoading = true;
            this.currentPage = 1;
            this.hasMore = false;
            this.nextPageToken = null;
            this.entries = [];
        } else this.isLoadingMore = true;
        this.updateContent();
        try {
            const url = new URL(`/api/media-sources/${this.currentAccount.provider}/${this.currentAccount.accountIdentifier}/list`, window.location.origin);
            url.searchParams.set('path', path);
            url.searchParams.set('limit', '50');
            // When appending (loading more), use pageToken if available
            // Otherwise, use page number for initial load
            if (append && this.nextPageToken) url.searchParams.set('pageToken', this.nextPageToken);
            else if (!append) url.searchParams.set('page', this.currentPage.toString());
            const response = await fetch(url.toString(), {
                credentials: 'include'
            });
            if (!response.ok) {
                if (response.status === 403) {
                    const data = await response.json();
                    if (data.requiresReconnect) {
                        this.showError('Your connection has expired. Please reconnect your account.');
                        return;
                    }
                }
                throw new Error('Failed to load directory');
            }
            const data = await response.json();
            if (append) // Append new entries to existing ones
            this.entries = [
                ...this.entries,
                ...data.entries || []
            ];
            else // Replace entries
            this.entries = data.entries || [];
            this.currentPath = path;
            this.hasMore = data.hasMore || false;
            this.nextPageToken = data.nextPageToken || null;
            this.isSearching = false;
            this.searchQuery = '';
            this.isLoading = false;
            this.isLoadingMore = false;
            this.updateContent();
        } catch (error) {
            window.logger.error('Error loading directory:', error);
            this.isLoading = false;
            this.isLoadingMore = false;
            this.updateContent();
            this.showError('Failed to load directory. Please try again.');
        }
    }
    async loadMoreDirectory() {
        if (!this.hasMore || this.isLoadingMore || !this.nextPageToken) return;
        // Don't increment currentPage - use nextPageToken instead
        await this.loadDirectory(this.currentPath, true);
    }
    async navigateToDirectory(entryId) {
        const entry = this.entries.find((e)=>e.id === entryId);
        if (!entry || entry.type !== 'directory') return;
        this.pathHistory.push({
            name: entry.name,
            path: this.currentPath
        });
        await this.loadDirectory(entry.path || entryId);
    }
    navigateToPath(path) {
        if (path === 'root') {
            this.pathHistory = [];
            this.loadDirectory('root');
        } else {
            const pathIndex = this.pathHistory.findIndex((item)=>item.path === path);
            if (pathIndex >= 0) {
                this.pathHistory = this.pathHistory.slice(0, pathIndex + 1);
                this.loadDirectory(path);
            }
        }
    }
    goBack() {
        if (this.pathHistory.length === 0) {
            // Already at root, go to root anyway
            this.pathHistory = [];
            this.loadDirectory('root');
            return;
        }
        // Remove the last item from history and navigate to the previous path
        this.pathHistory.pop();
        // Navigate to the previous path (or root if no history left)
        const targetPath = this.pathHistory.length > 0 ? this.pathHistory[this.pathHistory.length - 1].path : 'root';
        if (targetPath === 'root') this.pathHistory = [];
        this.loadDirectory(targetPath);
    }
    async handleSearch(append = false) {
        if (!this.currentAccount || !this.searchInput?.value.trim()) return;
        const query = this.searchInput.value.trim();
        // If not appending, reset search state
        if (!append) {
            this.searchQuery = query;
            this.isSearching = true;
            this.isLoading = true;
            this.searchResults = [];
            this.searchHasMore = false;
            this.searchNextPageToken = null;
        } else this.isLoadingMore = true;
        this.updateContent();
        try {
            const requestBody = {
                query: this.searchQuery,
                maxResults: 50
            };
            // Add pagination token if loading more
            if (append && this.searchNextPageToken) requestBody.pageToken = this.searchNextPageToken;
            const response = await fetch(`/api/media-sources/${this.currentAccount.provider}/${this.currentAccount.accountIdentifier}/search`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(requestBody)
            });
            if (!response.ok) throw new Error('Search failed');
            const data = await response.json();
            if (append) // Append new results to existing ones
            this.searchResults = [
                ...this.searchResults,
                ...data.results || []
            ];
            else // Replace results
            this.searchResults = data.results || [];
            this.searchHasMore = data.hasMore || false;
            this.searchNextPageToken = data.nextPageToken || null;
            this.isLoading = false;
            this.isLoadingMore = false;
            this.updateContent();
        } catch (error) {
            window.logger.error('Error searching:', error);
            this.isLoading = false;
            this.isLoadingMore = false;
            this.updateContent();
            this.showError('Search failed. Please try again.');
        }
    }
    async loadMoreSearch() {
        if (!this.searchHasMore || this.isLoadingMore || !this.searchNextPageToken) return;
        await this.handleSearch(true);
    }
    clearSearch() {
        this.searchQuery = '';
        this.isSearching = false;
        this.searchResults = [];
        if (this.searchInput) this.searchInput.value = '';
        this.updateContent();
        if (this.currentAccount) this.loadDirectory(this.currentPath);
    }
    toggleFileSelection(entryId, entryType, fileItem) {
        if (entryType === 'directory') return;
        const entry = (this.isSearching ? this.searchResults : this.entries).find((e)=>e.id === entryId);
        if (!entry) return;
        const index = this.selectedFiles.findIndex((f)=>f.provider === this.currentAccount.provider && f.accountId === this.currentAccount.accountIdentifier && f.fileId === entryId);
        if (index >= 0) {
            this.selectedFiles.splice(index, 1);
            fileItem.classList.remove('selected');
        } else {
            if (this.isSingleSelect()) {
                this.selectedFiles = [];
                this.querySelectorAll('.file-item.selected').forEach((el)=>el.classList.remove('selected'));
            }
            this.selectedFiles.push({
                provider: this.currentAccount.provider,
                accountId: this.currentAccount.accountIdentifier,
                fileId: entryId,
                fileUrl: entry.url || `oauth://${this.currentAccount.provider}/${this.currentAccount.accountIdentifier}/${entryId}`,
                fileName: entry.name,
                mimeType: entry.mimeType || entry.mime_type || null
            });
            fileItem.classList.add('selected');
        }
        this.updateSelectButton();
    }
    updateSelectButton() {
        if (this.selectBtn) {
            this.selectBtn.disabled = this.selectedFiles.length === 0;
            if (this.isUrlOutput()) this.selectBtn.textContent = this.selectedFiles.length === 0 ? 'Use Image' : 'Use Selected Image';
            else this.selectBtn.textContent = this.selectedFiles.length === 0 ? 'Select Files' : `Select ${this.selectedFiles.length} File${this.selectedFiles.length !== 1 ? 's' : ''}`;
        }
        const selectedCount = this.querySelector('.selected-count');
        if (selectedCount) selectedCount.textContent = `${this.selectedFiles.length} selected`;
    }
    async handleSelect() {
        if (this.selectedFiles.length === 0) return;
        try {
            const response = await fetch('/api/media-sources/picker/select', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    files: this.selectedFiles
                })
            });
            if (!response.ok) throw new Error('Failed to select files');
            const data = await response.json();
            if (this.isUrlOutput()) {
                const file = (data.files || this.selectedFiles)[0];
                if (!file) throw new Error('No file selected');
                this.dispatchEvent(new CustomEvent('image-url-selected', {
                    detail: {
                        fileUrl: file.fileUrl || file.url
                    },
                    bubbles: true
                }));
                this.close();
                return;
            }
            // Dispatch event with selected files and textarea reference
            this.dispatchEvent(new CustomEvent('files-selected', {
                detail: {
                    files: data.files,
                    textarea: this._targetTextarea || null
                },
                bubbles: true
            }));
            this.close();
        } catch (error) {
            window.logger.error('Error selecting files:', error);
            this.showError('Failed to select files. Please try again.');
        }
    }
    showError(message) {
        // Simple error display - could be enhanced
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        this.querySelector('.modal-body').prepend(errorDiv);
        setTimeout(()=>{
            errorDiv.remove();
        }, 5000);
    }
    updateContent() {
        // Update specific parts of the UI without full re-render
        const accountSelector = this.querySelector('.account-selector');
        if (accountSelector) {
            // Remove old event listener if it exists
            if (this.accountSelect && this._accountSelectHandler) this.accountSelect.removeEventListener('change', this._accountSelectHandler);
            accountSelector.outerHTML = this.renderAccountSelector();
            this.accountSelect = this.querySelector('#accountSelect');
            // Set the selected value explicitly to ensure it's preserved
            // Do this BEFORE attaching the event listener to prevent triggering change event
            if (this.accountSelect && this.currentAccount?.id) this.accountSelect.value = this.currentAccount.id;
            // Reattach event listener AFTER setting value to prevent triggering on programmatic change
            this._accountSelectHandler = (e)=>this.handleAccountChange(e);
            this.accountSelect?.addEventListener('change', this._accountSelectHandler);
        }
        const breadcrumb = this.querySelector('.breadcrumb');
        if (breadcrumb) {
            breadcrumb.outerHTML = this.renderBreadcrumb();
            this.breadcrumb = this.querySelector('.breadcrumb');
            // Back button handler
            const backBtn = this.querySelector('#backBtn');
            if (backBtn) backBtn.addEventListener('click', ()=>{
                this.goBack();
            });
            // Breadcrumb click handler
            this.breadcrumb?.addEventListener('click', (e)=>{
                const breadcrumbItem = e.target.closest('.breadcrumb-item');
                if (breadcrumbItem) {
                    const path = breadcrumbItem.dataset.path;
                    this.navigateToPath(path);
                }
            });
        }
        const searchBar = this.querySelector('.search-bar');
        if (searchBar) {
            searchBar.outerHTML = this.renderSearch();
            this.searchInput = this.querySelector('#searchInput');
            this.searchBtn = this.querySelector('#searchBtn');
            this.searchBtn?.addEventListener('click', ()=>this.handleSearch());
            this.searchInput?.addEventListener('keypress', (e)=>{
                if (e.key === 'Enter') this.handleSearch();
            });
            const clearSearchBtn = this.querySelector('#clearSearchBtn');
            clearSearchBtn?.addEventListener('click', ()=>this.clearSearch());
        }
        const contentArea = this.querySelector('.picker-content');
        if (contentArea) {
            contentArea.outerHTML = this.renderContent();
            this.contentArea = this.querySelector('.picker-content');
            // Re-attach file item listeners
            this.contentArea?.addEventListener('click', (e)=>{
                const fileItem = e.target.closest('.file-item');
                if (!fileItem) return;
                const entryId = fileItem.dataset.entryId;
                const entryType = fileItem.dataset.entryType;
                if (e.target.type === 'checkbox' || e.target.closest('.file-checkbox')) this.toggleFileSelection(entryId, entryType, fileItem);
                else if (entryType === 'directory') this.navigateToDirectory(entryId);
            });
            // Re-attach Load More button handlers
            const loadMoreBtn = this.querySelector('#loadMoreBtn');
            if (loadMoreBtn) loadMoreBtn.addEventListener('click', ()=>this.loadMoreDirectory());
            const loadMoreSearchBtn = this.querySelector('#loadMoreSearchBtn');
            if (loadMoreSearchBtn) loadMoreSearchBtn.addEventListener('click', ()=>this.loadMoreSearch());
        }
        this.updateSelectButton();
    }
    open() {
        this.isOpen = true;
        this.render();
        document.body.style.overflow = 'hidden';
    }
    close() {
        this.isOpen = false;
        this.render();
        document.body.style.overflow = '';
        this.selectedFiles = [];
        this.currentAccount = null;
        this.currentPath = 'root';
        this.pathHistory = [];
        this.entries = [];
        this.searchQuery = '';
        this.searchResults = [];
        this.isSearching = false;
        // Reset pagination state
        this.currentPage = 1;
        this.hasMore = false;
        this.nextPageToken = null;
        this.searchHasMore = false;
        this.searchNextPageToken = null;
    }
}
customElements.define('media-source-picker', $9cc1d01a4595998f$var$MediaSourcePicker);
var $9cc1d01a4595998f$export$2e2bcd8739ae039 = $9cc1d01a4595998f$var$MediaSourcePicker;


// Media Sources Settings Web Component


class $bb235d67c878280b$var$MediaSourcesSettings extends HTMLElement {
    constructor(){
        super();
        this.accounts = {};
        this.availableProviders = [];
        this.isLoading = true;
        this.errorMessage = null;
        this.currentUser = null;
    }
    connectedCallback() {
        this.render();
    // Wait for setCurrentUser to be called before loading accounts
    }
    setCurrentUser(user) {
        this.currentUser = user;
        if (this.currentUser) this.loadAccounts().then(()=>{
            this.attachEventListeners();
        });
    }
    async loadAccounts() {
        if (!this.currentUser || !this.currentUser.id) {
            this.errorMessage = 'User not authenticated';
            this.isLoading = false;
            this.render();
            return;
        }
        try {
            if (!window.API) throw new Error('API not available');
            const data = await window.API.request(`/users/settings/${this.currentUser.id}/media-sources`);
            this.accounts = data.accounts || {};
            this.availableProviders = data.availableProviders || [];
        } catch (error) {
            window.logger.error('Failed to load media source accounts:', error);
            this.errorMessage = 'Failed to load media source accounts';
        } finally{
            this.isLoading = false;
            this.render();
        }
    }
    async disconnectAccount(accountId) {
        if (!confirm('Are you sure you want to disconnect this account?')) return;
        try {
            await window.API.request(`/users/settings/${this.currentUser.id}/media-sources/${accountId}`, {
                method: 'DELETE'
            });
            // Reload accounts
            await this.loadAccounts();
        } catch (error) {
            window.logger.error('Failed to disconnect account:', error);
            alert('Failed to disconnect account. Please try again.');
        }
    }
    connectProvider(provider) {
        window.location.href = `/api/media-sources/authorize/${provider}`;
    }
    render() {
        if (this.isLoading) {
            this.innerHTML = `
        <div class="media-sources-settings">
          <div class="loading-state">
            <div class="spinner"></div>
            <div>Loading media sources...</div>
          </div>
        </div>
      `;
            return;
        }
        if (this.errorMessage) {
            this.innerHTML = `
        <div class="media-sources-settings">
          <div class="error-state">
            <p>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.errorMessage)}</p>
            <button class="btn btn-primary retry-btn">Retry</button>
          </div>
        </div>
      `;
            // Attach retry button listener
            const retryBtn = this.querySelector('.retry-btn');
            if (retryBtn) retryBtn.addEventListener('click', ()=>{
                this.errorMessage = null;
                this.isLoading = true;
                this.render();
                this.loadAccounts();
            });
            return;
        }
        this.innerHTML = `
      <div class="media-sources-settings">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\u2728", 'Sparkle Sources')}
          <p>Connect your cloud storage accounts to embed files in your posts</p>
        </div>

        <div class="settings-content">
          ${this.renderAvailableProviders()}
          ${this.renderConnectedAccounts()}
        </div>

        <div class="settings-footer">
          <button class="btn btn-secondary" id="returnToSettingsBtn">
            \u{2190} Return to Settings
          </button>
        </div>
      </div>
    `;
    }
    renderAvailableProviders() {
        if (this.availableProviders.length === 0) return `
        <div class="providers-section">
          <h3>Available Providers</h3>
          <p class="no-providers">No providers are currently enabled.</p>
        </div>
      `;
        return `
      <div class="providers-section">
        <h3>Available Providers</h3>
        <div class="providers-grid">
          ${this.availableProviders.map((provider)=>`
            <div class="provider-card">
              <div class="provider-header">
                <h4>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(provider.displayName)}</h4>
                ${provider.pricingInfo?.hasFreeTier ? '<span class="badge badge-free">Free Tier Available</span>' : ''}
              </div>
              <p class="provider-description">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(provider.description || '')}</p>
              <div class="provider-actions">
                <button class="btn btn-primary connect-btn" data-provider="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(provider.name)}">
                  Connect ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(provider.displayName)}
                </button>
                ${provider.learnMoreUrl ? `<a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(provider.learnMoreUrl)}" target="_blank" class="btn btn-secondary">Learn More</a>` : ''}
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    `;
    }
    renderConnectedAccounts() {
        const accountCount = Object.values(this.accounts).reduce((sum, accounts)=>sum + accounts.length, 0);
        if (accountCount === 0) return `
        <div class="accounts-section">
          <h3>Connected Accounts</h3>
          <p class="no-accounts">No accounts connected yet. Connect a provider above to get started.</p>
        </div>
      `;
        return `
      <div class="accounts-section">
        <h3>Connected Accounts</h3>
        ${Object.entries(this.accounts).map(([provider, accounts])=>`
          <div class="provider-accounts">
            <h4>${this.getProviderDisplayName(provider)}</h4>
            <div class="accounts-list">
              ${accounts.map((account)=>`
                <div class="account-item ${account.isExpired ? 'expired' : ''}">
                  <div class="account-info">
                    <div class="account-identifier">
                      <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(account.accountIdentifier || 'Unknown')}</strong>
                      ${account.accountLabel ? `<span class="account-label">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(account.accountLabel)}</span>` : ''}
                    </div>
                    <div class="account-meta">
                      ${account.isExpired ? '<span class="badge badge-warning">Expired</span>' : '<span class="badge badge-success">Active</span>'}
                      ${account.lastUsedAt ? `<span class="last-used">Last used: ${this.formatDate(account.lastUsedAt)}</span>` : ''}
                      ${account.expiresAt ? `<span class="expires-at">Expires: ${this.formatDate(account.expiresAt)}</span>` : ''}
                    </div>
                  </div>
                  <button class="btn btn-danger disconnect-btn" data-account-id="${account.id}">
                    Disconnect
                  </button>
                </div>
              `).join('')}
            </div>
          </div>
        `).join('')}
      </div>
    `;
    }
    getProviderDisplayName(providerName) {
        const provider = this.availableProviders.find((p)=>p.name === providerName);
        return provider ? provider.displayName : providerName;
    }
    formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
        });
    }
    attachEventListeners() {
        // Connect provider buttons
        this.querySelectorAll('.connect-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const provider = e.target.dataset.provider;
                this.connectProvider(provider);
            });
        });
        // Disconnect account buttons
        this.querySelectorAll('.disconnect-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const accountId = parseInt(e.target.dataset.accountId, 10);
                this.disconnectAccount(accountId);
            });
        });
        // Return to settings button
        const returnBtn = this.querySelector('#returnToSettingsBtn');
        if (returnBtn) returnBtn.addEventListener('click', ()=>{
            if (window.router) window.router.navigate('/settings');
        });
    }
}
// Register the custom element
customElements.define('media-sources-settings', $bb235d67c878280b$var$MediaSourcesSettings);


// Memories Web Component


var $eZQHH = parcelRequire("eZQHH");

class $f1c5fcdb680cc778$var$Memories extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    static get observedAttributes() {
        return [
            'date'
        ];
    }
    constructor(){
        super();
        this.memories = [];
        this.isLoading = false;
        this.error = null;
        this.currentDate = new Date();
        this.selectedMonth = this.currentDate.getMonth() + 1;
        this.selectedDay = this.currentDate.getDate();
        this.clickHandler = null; // Store reference to click handler for cleanup
        // Store references to other handlers for cleanup (though elements are recreated, this is safer)
        this.monthChangeHandler = null;
        this.dayChangeHandler = null;
        this.loadBtnHandler = null;
        this.retryBtnHandler = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.parseDateFromAttribute();
        this.render();
        this.loadMemories();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'date' && newValue !== oldValue) {
            this.parseDateFromAttribute();
            this.render();
            this.loadMemories();
        }
    }
    parseDateFromAttribute() {
        const dateAttr = this.getAttribute('date');
        if (dateAttr) {
            const dateMatch = dateAttr.match(/^(\d{1,2})-(\d{1,2})$/);
            if (dateMatch) {
                this.selectedMonth = parseInt(dateMatch[1], 10);
                this.selectedDay = parseInt(dateMatch[2], 10);
                return;
            }
        }
        // Default to today if no valid date attribute
        this.selectedMonth = this.currentDate.getMonth() + 1;
        this.selectedDay = this.currentDate.getDate();
    }
    render() {
        this.innerHTML = `
      <div class="memories-container">
        <div class="memories-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDD70\uFE0F", 'Memories')}
          <p class="memories-subtitle">Posts from this day in previous years</p>
        </div>

        <div class="memories-controls">
          <div class="date-selector">
            <label for="memory-month">Month:</label>
            <select id="memory-month" class="date-input">
              ${this.renderMonthOptions()}
            </select>
            <label for="memory-day">Day:</label>
            <select id="memory-day" class="date-input">
              ${this.renderDayOptions()}
            </select>
            <button class="btn btn-primary load-date-btn">Load Memories</button>
          </div>
        </div>

        <div class="memories-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
        this.attachEventListeners();
    }
    renderMonthOptions() {
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        return months.map((month, index)=>{
            const monthNum = index + 1;
            return `<option value="${monthNum}" ${monthNum === this.selectedMonth ? 'selected' : ''}>${month}</option>`;
        }).join('');
    }
    renderDayOptions() {
        const daysInMonth = new Date(2024, this.selectedMonth, 0).getDate();
        const options = [];
        for(let day = 1; day <= daysInMonth; day++)options.push(`<option value="${day}" ${day === this.selectedDay ? 'selected' : ''}>${day}</option>`);
        return options.join('');
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading memories...</p>
        </div>
      `;
        if (this.error) return `
        <div class="error-state">
          <p class="error-message">${this.error}</p>
          <button class="btn btn-secondary retry-btn">Try Again</button>
        </div>
      `;
        if (this.memories.length === 0) {
            const formattedDate = `${String(this.selectedMonth).padStart(2, '0')}-${String(this.selectedDay).padStart(2, '0')}`;
            return `
        <div class="empty-state">
          <p>No memories found for ${formattedDate}</p>
          <p class="empty-subtitle">Check back next year!</p>
        </div>
      `;
        }
        return `
      <div class="memories-list">
        ${this.memories.map((memory, index)=>this.renderMemory(memory, index)).join('')}
      </div>
    `;
    }
    renderMemory(memory, index) {
        const postDate = new Date(memory.post_date);
        const year = memory.memory_year;
        const formattedDate = postDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
        return `
      <div class="memory-wrapper" data-memory-index="${index}" data-post-id="${memory.post_id}">
        <div class="memory-header-badge">
          <div class="memory-date-info">
            <span class="memory-year">${year}</span>
            <span class="memory-date">${formattedDate}</span>
          </div>
          <div class="memory-actions">
            <button class="btn btn-sm btn-outline share-memory-btn" 
                    data-post-id="${memory.post_id}" 
                    title="Share to main feed">
              \u{1F4E4} Share
            </button>
            <button class="btn btn-sm btn-outline hide-memory-btn" 
                    data-post-id="${memory.post_id}" 
                    title="Hide from memories">
              \u{1F441}\u{FE0F} Hide
            </button>
          </div>
        </div>
        <post-item data-memory-index="${index}"></post-item>
      </div>
    `;
    }
    attachEventListeners() {
        // Remove existing click handler if it exists to prevent duplicate listeners
        if (this.clickHandler) this.removeEventListener('click', this.clickHandler);
        const monthSelect = this.querySelector('#memory-month');
        const daySelect = this.querySelector('#memory-day');
        const loadBtn = this.querySelector('.load-date-btn');
        const retryBtn = this.querySelector('.retry-btn');
        // Remove old handlers if they exist (elements are recreated, but this is safer)
        if (monthSelect && this.monthChangeHandler) monthSelect.removeEventListener('change', this.monthChangeHandler);
        if (daySelect && this.dayChangeHandler) daySelect.removeEventListener('change', this.dayChangeHandler);
        if (loadBtn && this.loadBtnHandler) loadBtn.removeEventListener('click', this.loadBtnHandler);
        if (retryBtn && this.retryBtnHandler) retryBtn.removeEventListener('click', this.retryBtnHandler);
        if (monthSelect) {
            this.monthChangeHandler = ()=>{
                this.selectedMonth = parseInt(monthSelect.value, 10);
                this.updateDayOptions();
            };
            monthSelect.addEventListener('change', this.monthChangeHandler);
        }
        if (daySelect) {
            this.dayChangeHandler = ()=>{
                this.selectedDay = parseInt(daySelect.value, 10);
            };
            daySelect.addEventListener('change', this.dayChangeHandler);
        }
        if (loadBtn) {
            this.loadBtnHandler = ()=>{
                // Update URL when date changes
                const dateStr = `${this.selectedMonth}-${this.selectedDay}`;
                window.history.pushState({}, '', `/memories/${dateStr}`);
                this.setAttribute('date', dateStr);
                this.loadMemories();
            };
            loadBtn.addEventListener('click', this.loadBtnHandler);
        }
        if (retryBtn) {
            this.retryBtnHandler = ()=>{
                this.loadMemories();
            };
            retryBtn.addEventListener('click', this.retryBtnHandler);
        }
        // Add event listener for share and hide buttons (store reference for cleanup)
        this.clickHandler = (e)=>{
            if (e.target.classList.contains('share-memory-btn') || e.target.closest('.share-memory-btn')) {
                const btn = e.target.classList.contains('share-memory-btn') ? e.target : e.target.closest('.share-memory-btn');
                const postId = btn.getAttribute('data-post-id');
                this.shareMemoryToFeed(postId, btn);
            } else if (e.target.classList.contains('hide-memory-btn') || e.target.closest('.hide-memory-btn')) {
                const btn = e.target.classList.contains('hide-memory-btn') ? e.target : e.target.closest('.hide-memory-btn');
                const postId = btn.getAttribute('data-post-id');
                this.hideMemory(postId, btn);
            }
        };
        this.addEventListener('click', this.clickHandler);
    }
    updateDayOptions() {
        const daySelect = this.querySelector('#memory-day');
        if (!daySelect) return;
        const daysInMonth = new Date(2024, this.selectedMonth, 0).getDate();
        const currentDay = parseInt(daySelect.value, 10);
        daySelect.innerHTML = '';
        for(let day = 1; day <= daysInMonth; day++){
            const option = document.createElement('option');
            option.value = day;
            option.textContent = day;
            if (day === currentDay || day === this.selectedDay && day <= daysInMonth) {
                option.selected = true;
                this.selectedDay = day;
            }
            daySelect.appendChild(option);
        }
    }
    async loadMemories() {
        this.isLoading = true;
        this.error = null;
        this.render();
        try {
            const dateStr = `${this.selectedMonth}-${this.selectedDay}`;
            const response = await window.API.request(`/memories?date=${dateStr}`, {
                method: 'GET'
            });
            if (response.memories) this.memories = response.memories;
            else this.memories = [];
            this.isLoading = false;
            this.render();
            // Set current user on post-item components and initialize them
            // Use multiple strategies to ensure custom elements are ready
            // First, try immediately (in case elements are already upgraded)
            this.initializePostItems();
            // Also try after a short delay to catch elements that upgrade later
            requestAnimationFrame(()=>{
                this.initializePostItems();
            });
            // And try once more after a longer delay as a fallback
            setTimeout(()=>{
                this.initializePostItems();
            }, 100);
        } catch (error) {
            (0, $eZQHH.default).error('Error loading memories:', error);
            this.error = error.message || 'Failed to load memories';
            this.isLoading = false;
            this.render();
        }
    }
    initializePostItems() {
        // Set current user and post data on all post-item components
        // post-item will handle all image processing, gating, moderation, and missing image detection
        (0, $eZQHH.default).debug('initializePostItems called', {
            hasCurrentUser: !!this.currentUser,
            memoriesCount: this.memories.length
        });
        if (!this.currentUser) {
            (0, $eZQHH.default).warn('initializePostItems: No current user, skipping');
            return;
        }
        const postItems = this.querySelectorAll('post-item');
        (0, $eZQHH.default).debug('Found post-item elements', {
            count: postItems.length
        });
        postItems.forEach((postItem, itemIndex)=>{
            (0, $eZQHH.default).debug(`Processing post-item ${itemIndex}`, {
                isConnected: postItem.isConnected,
                hasPostData: !!postItem._post,
                hasSetCurrentUser: typeof postItem.setCurrentUser === 'function',
                hasPostDataProperty: typeof postItem.postData !== 'undefined'
            });
            // Get the memory index from the data attribute first
            const memoryIndex = parseInt(postItem.getAttribute('data-memory-index'), 10);
            (0, $eZQHH.default).debug(`post-item ${itemIndex} memory index:`, memoryIndex);
            if (isNaN(memoryIndex) || !this.memories[memoryIndex]) {
                (0, $eZQHH.default).warn('post-item missing valid memory index or memory not found', {
                    memoryIndex: memoryIndex,
                    memoriesLength: this.memories.length,
                    memories: this.memories.map((m)=>({
                            id: m.post_id,
                            title: m.title
                        }))
                });
                return;
            }
            // Get post data directly from memories array (more reliable than parsing attribute)
            const memory = this.memories[memoryIndex];
            (0, $eZQHH.default).debug(`post-item ${itemIndex} memory data:`, {
                post_id: memory.post_id,
                title: memory.title,
                hasContentHtml: !!memory.content_html,
                hasContent: !!memory.content,
                contentHtmlLength: memory.content_html?.length || 0,
                contentLength: memory.content?.length || 0
            });
            const postData = {
                id: memory.post_id,
                title: memory.title || null,
                content: memory.content || '',
                content_html: memory.content_html || memory.content || '',
                username: memory.username,
                created_at: memory.post_date,
                is_owner: true,
                post_type: memory.post_type || 'text',
                source: memory.source || null,
                comment_count: 0,
                mood_icon: memory.mood_icon || null,
                mood_status: memory.mood_status || null,
                music_url: memory.music_url || null,
                imported: memory.imported || false,
                import_source: memory.import_source || null,
                import_source_site: memory.import_source_site || null,
                import_source_url: memory.import_source_url || null
            };
            (0, $eZQHH.default).debug(`post-item ${itemIndex} constructed postData:`, {
                id: postData.id,
                title: postData.title,
                hasContentHtml: !!postData.content_html,
                contentHtmlLength: postData.content_html?.length || 0,
                username: postData.username,
                post_type: postData.post_type
            });
            // Wait for element to be upgraded, then set both user and post data
            const setupPostItem = ()=>{
                (0, $eZQHH.default).debug(`setupPostItem called for post-item ${itemIndex}`);
                if (!postItem) {
                    (0, $eZQHH.default).warn(`post-item ${itemIndex} is null`);
                    return;
                }
                // Ensure element is in the DOM and upgraded
                if (!postItem.isConnected) {
                    (0, $eZQHH.default).warn(`post-item ${itemIndex} not connected to DOM yet`);
                    return;
                }
                (0, $eZQHH.default).debug(`post-item ${itemIndex} before setup:`, {
                    hasPost: !!postItem._post,
                    postId: postItem._post?.id,
                    innerHTML: postItem.innerHTML.substring(0, 100)
                });
                // Set current user first (needed for image processing, gating, etc.)
                if (typeof postItem.setCurrentUser === 'function') {
                    (0, $eZQHH.default).debug(`Setting currentUser on post-item ${itemIndex}`);
                    postItem.setCurrentUser(this.currentUser);
                } else (0, $eZQHH.default).warn(`post-item ${itemIndex} does not have setCurrentUser method`);
                // Set post data via property (like posts-feed does) - this triggers render automatically
                // The property setter will call render() automatically
                try {
                    (0, $eZQHH.default).debug(`Setting postData on post-item ${itemIndex}`, {
                        postId: postData.id
                    });
                    postItem.postData = postData;
                    // Verify it was set
                    const verifyPost = postItem._post || postItem.postData;
                    (0, $eZQHH.default).debug(`post-item ${itemIndex} after setting postData:`, {
                        hasPost: !!verifyPost,
                        postId: verifyPost?.id,
                        matches: verifyPost?.id === postData.id,
                        innerHTML: postItem.innerHTML.substring(0, 200)
                    });
                    if (!verifyPost || verifyPost.id !== postData.id) {
                        (0, $eZQHH.default).warn('postData was not set correctly, trying fallback', {
                            expectedId: postData.id,
                            actualId: verifyPost?.id,
                            hasPost: !!verifyPost
                        });
                        // Fallback: set directly and trigger render
                        postItem.postData = postData;
                        if (typeof postItem.render === 'function') {
                            (0, $eZQHH.default).debug(`Manually calling render on post-item ${itemIndex}`);
                            postItem.render().then(()=>{
                                (0, $eZQHH.default).debug(`post-item ${itemIndex} render completed`, {
                                    innerHTML: postItem.innerHTML.substring(0, 200)
                                });
                            }).catch((err)=>{
                                (0, $eZQHH.default).error('Error rendering post-item after fallback:', err);
                            });
                        } else (0, $eZQHH.default).warn(`post-item ${itemIndex} does not have render method`);
                    } else (0, $eZQHH.default).debug(`post-item ${itemIndex} postData set successfully`);
                } catch (error) {
                    (0, $eZQHH.default).error('Error setting postData:', error, {
                        postItemIndex: itemIndex,
                        postId: postData.id,
                        errorMessage: error.message,
                        errorStack: error.stack
                    });
                    // Fallback: set directly and trigger render
                    postItem._post = postData;
                    if (typeof postItem.render === 'function') {
                        (0, $eZQHH.default).debug(`Calling render after error on post-item ${itemIndex}`);
                        postItem.render().then(()=>{
                            (0, $eZQHH.default).debug(`post-item ${itemIndex} render completed after error`, {
                                innerHTML: postItem.innerHTML.substring(0, 200)
                            });
                        }).catch((err)=>{
                            (0, $eZQHH.default).error('Error rendering post-item after error fallback:', err);
                        });
                    }
                }
            };
            // Always wait for element to be defined to ensure it's fully upgraded
            // This ensures both connectedCallback and attributeChangedCallback have run
            (0, $eZQHH.default).debug(`Waiting for post-item ${itemIndex} to be defined`);
            customElements.whenDefined('post-item').then(()=>{
                (0, $eZQHH.default).debug(`post-item ${itemIndex} is defined, scheduling setup`);
                // Use requestAnimationFrame to ensure the element is fully initialized
                requestAnimationFrame(()=>{
                    (0, $eZQHH.default).debug(`requestAnimationFrame callback for post-item ${itemIndex}`);
                    setupPostItem();
                });
            }).catch((error)=>{
                (0, $eZQHH.default).warn('Error waiting for post-item to be defined:', error);
                // Fallback: try to set up anyway after a delay
                setTimeout(()=>{
                    (0, $eZQHH.default).debug(`Fallback timeout for post-item ${itemIndex}`);
                    setupPostItem();
                }, 100);
            });
        });
    }
    async shareMemoryToFeed(postId, button) {
        if (!postId) return;
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Sharing...';
        try {
            const response = await window.API.request(`/memories/share/${postId}`, {
                method: 'POST'
            });
            if (response) {
                button.textContent = "\u2713 Shared";
                button.classList.add('shared');
                // Show success message
                this.showMessage('Memory shared to feed!', 'success');
            }
        } catch (error) {
            (0, $eZQHH.default).error('Error sharing memory:', error);
            button.textContent = originalText;
            button.disabled = false;
            this.showMessage(error.message || 'Failed to share memory', 'error');
        }
    }
    async hideMemory(postId, button) {
        if (!postId) return;
        const originalText = button.textContent;
        button.disabled = true;
        button.textContent = 'Hiding...';
        try {
            const response = await window.API.request(`/memories/hide/${postId}`, {
                method: 'POST'
            });
            if (response) {
                // Remove the memory from the list
                const memoryWrapper = button.closest('.memory-wrapper');
                if (memoryWrapper) {
                    memoryWrapper.style.opacity = '0';
                    memoryWrapper.style.transition = 'opacity 0.3s';
                    setTimeout(()=>{
                        memoryWrapper.remove();
                        // Update memories array to reflect removal (no need to reload from server)
                        const postIdInt = parseInt(postId, 10);
                        this.memories = this.memories.filter((m)=>m.post_id !== postIdInt);
                    }, 300);
                }
                this.showMessage('Memory hidden from memories', 'success');
            }
        } catch (error) {
            (0, $eZQHH.default).error('Error hiding memory:', error);
            button.textContent = originalText;
            button.disabled = false;
            this.showMessage(error.message || 'Failed to hide memory', 'error');
        }
    }
    showMessage(message, type = 'info') {
        // Create a temporary message element
        const messageEl = document.createElement('div');
        messageEl.className = `memory-message memory-message-${type}`;
        messageEl.textContent = message;
        messageEl.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 1rem 1.5rem;
      background: ${type === 'success' ? 'var(--success-color, #4caf50)' : 'var(--error-color, #f44336)'};
      color: white;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      z-index: 10000;
      animation: slideIn 0.3s ease-out;
    `;
        document.body.appendChild(messageEl);
        setTimeout(()=>{
            messageEl.style.animation = 'slideOut 0.3s ease-out';
            setTimeout(()=>{
                messageEl.remove();
            }, 300);
        }, 3000);
    }
}
customElements.define('memories-view', $f1c5fcdb680cc778$var$Memories);
var $f1c5fcdb680cc778$export$2e2bcd8739ae039 = $f1c5fcdb680cc778$var$Memories;


// Mood Selector Web Component
class $973358ba81686713$var$MoodSelector extends HTMLElement {
    constructor(){
        super();
        this.selectedMood = null;
        this.moodStatus = '';
        this.postText = '';
        // Define mood icons - 5 standard moods + extra shuffle options
        this.standardMoods = [
            {
                id: 'happy',
                icon: "\uD83D\uDE0A",
                label: 'Happy'
            },
            {
                id: 'excited',
                icon: "\uD83E\uDD29",
                label: 'Excited'
            },
            {
                id: 'chill',
                icon: "\uD83D\uDE0E",
                label: 'Chill'
            },
            {
                id: 'thoughtful',
                icon: "\uD83E\uDD14",
                label: 'Thoughtful'
            },
            {
                id: 'grateful',
                icon: "\uD83D\uDE4F",
                label: 'Grateful'
            }
        ];
        this.shuffleMoods = [
            {
                id: 'love',
                icon: "\uD83D\uDE0D",
                label: 'In Love'
            },
            {
                id: 'silly',
                icon: "\uD83E\uDD2A",
                label: 'Silly'
            },
            {
                id: 'sleepy',
                icon: "\uD83D\uDE34",
                label: 'Sleepy'
            },
            {
                id: 'hungry',
                icon: "\uD83E\uDD24",
                label: 'Hungry'
            },
            {
                id: 'creative',
                icon: "\uD83C\uDFA8",
                label: 'Creative'
            },
            {
                id: 'adventurous',
                icon: "\uD83C\uDFD4\uFE0F",
                label: 'Adventurous'
            },
            {
                id: 'cozy',
                icon: "\u2615",
                label: 'Cozy'
            },
            {
                id: 'motivated',
                icon: "\uD83D\uDCAA",
                label: 'Motivated'
            },
            {
                id: 'peaceful',
                icon: "\uD83E\uDDD8",
                label: 'Peaceful'
            },
            {
                id: 'curious',
                icon: "\uD83D\uDD0D",
                label: 'Curious'
            },
            {
                id: 'festive',
                icon: "\uD83C\uDF89",
                label: 'Festive'
            },
            {
                id: 'nostalgic',
                icon: "\uD83D\uDCF8",
                label: 'Nostalgic'
            }
        ];
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="mood-selector">
        <div class="mood-header">
          <post-type-selector selected-type="mood" id="moodPostTypeSelector"></post-type-selector>
        </div>
        
        <div class="mood-icons">
          ${this.standardMoods.map((mood)=>`
            <button class="mood-icon ${this.selectedMood?.id === mood.id ? 'selected' : ''}" 
                    data-mood-id="${mood.id}" 
                    data-mood-icon="${mood.icon}" 
                    data-mood-label="${mood.label}"
                    title="${mood.label}">
              ${mood.icon}
            </button>
          `).join('')}
          
          <!-- Shuffle button (washing machine) -->
          <button class="mood-icon shuffle-btn" id="shuffleBtn" title="Shuffle for more moods">
            \u{1F300}
          </button>
        </div>
        
        <div class="mood-status-input" style="display: ${this.selectedMood ? 'block' : 'none'};">
          <textarea 
            id="moodStatusText"
            placeholder="What's happening? (optional)"
            maxlength="200"
            rows="2"
          >${this.moodStatus}</textarea>
          <div class="char-count">
            <span id="charCount">${this.moodStatus.length}</span>/200
          </div>
        </div>
        
        <div class="mood-post-text" style="display: ${this.selectedMood ? 'block' : 'none'};">
          <textarea 
            id="moodPostText"
            placeholder="Add your thoughts... (optional)"
            rows="3"
          >${this.postText}</textarea>
        </div>
        
        <div class="mood-actions" style="display: ${this.selectedMood ? 'flex' : 'none'};">
          <button class="clear-mood-btn" id="clearMoodBtn">Clear</button>
          <button class="share-mood-btn" id="shareMoodBtn">Share Mood</button>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Post type selector
        const postTypeSelector = this.querySelector('#moodPostTypeSelector');
        if (postTypeSelector) postTypeSelector.addEventListener('post-type-selected', (e)=>{
            // Dispatch event to parent post-writer to switch types
            this.dispatchEvent(new CustomEvent('switch-post-type', {
                detail: {
                    type: e.detail.type
                },
                bubbles: true
            }));
        });
        // Mood icon selection
        this.querySelectorAll('.mood-icon:not(.shuffle-btn)').forEach((icon)=>{
            icon.addEventListener('click', (e)=>{
                const moodId = e.target.dataset.moodId;
                const moodIcon = e.target.dataset.moodIcon;
                const moodLabel = e.target.dataset.moodLabel;
                this.selectMood({
                    id: moodId,
                    icon: moodIcon,
                    label: moodLabel
                });
            });
        });
        // Shuffle button
        const shuffleBtn = this.querySelector('#shuffleBtn');
        shuffleBtn.addEventListener('click', ()=>{
            this.shuffleMoodIcons();
        });
        // Status text input
        const statusText = this.querySelector('#moodStatusText');
        statusText.addEventListener('input', (e)=>{
            this.moodStatus = e.target.value;
            this.updateCharCount();
        });
        // Post text input
        const postTextArea = this.querySelector('#moodPostText');
        if (postTextArea) postTextArea.addEventListener('input', (e)=>{
            this.postText = e.target.value;
        });
        // Clear button
        const clearBtn = this.querySelector('#clearMoodBtn');
        clearBtn.addEventListener('click', ()=>{
            this.clearMood();
        });
        // Share button
        const shareBtn = this.querySelector('#shareMoodBtn');
        shareBtn.addEventListener('click', ()=>{
            this.shareMood();
        });
    }
    selectMood(mood) {
        this.selectedMood = mood;
        this.render();
        this.attachEventListeners();
        // Focus the status input
        setTimeout(()=>{
            const statusInput = this.querySelector('#moodStatusText');
            if (statusInput) statusInput.focus();
        }, 100);
    }
    shuffleMoodIcons() {
        // Get random moods from shuffle pool
        const shuffled = [
            ...this.shuffleMoods
        ].sort(()=>Math.random() - 0.5);
        const newMoods = shuffled.slice(0, 5);
        // Replace standard moods temporarily
        const originalMoods = [
            ...this.standardMoods
        ];
        this.standardMoods = newMoods;
        this.render();
        this.attachEventListeners();
        // Restore original moods after 10 seconds
        setTimeout(()=>{
            this.standardMoods = originalMoods;
            this.render();
            this.attachEventListeners();
        }, 10000);
    }
    clearMood() {
        this.selectedMood = null;
        this.moodStatus = '';
        this.postText = '';
        this.render();
        this.attachEventListeners();
    }
    updateCharCount() {
        const charCount = this.querySelector('#charCount');
        if (charCount) {
            charCount.textContent = this.moodStatus.length;
            charCount.classList.remove('char-count-ok', 'char-count-warning', 'char-count-error');
            if (this.moodStatus.length > 180) charCount.classList.add('char-count-error');
            else if (this.moodStatus.length > 150) charCount.classList.add('char-count-warning');
            else charCount.classList.add('char-count-ok');
        }
    }
    async shareMood() {
        if (!this.selectedMood) return;
        try {
            const shareBtn = this.querySelector('#shareMoodBtn');
            shareBtn.disabled = true;
            shareBtn.textContent = 'Sharing...';
            // Create mood post
            const postContent = this.postText.trim() || `Feeling ${this.selectedMood.label.toLowerCase()}${this.moodStatus ? ` - ${this.moodStatus}` : ''}`;
            const postData = {
                post_type: 'mood',
                mood_icon: this.selectedMood.icon,
                title: `${this.selectedMood.label} Mood`,
                content: postContent
            };
            // Only include mood_status if it has a value
            const trimmedStatus = this.moodStatus.trim();
            if (trimmedStatus) postData.mood_status = trimmedStatus;
            Object.assign(postData, this.closest('post-writer')?.getPostStylePayload?.() || {});
            const post = await window.API.posts.create(postData);
            // Clear the mood selector
            this.clearMood();
            // Dispatch event to notify other components
            this.dispatchEvent(new CustomEvent('mood-shared', {
                detail: {
                    moodPost: post
                },
                bubbles: true
            }));
            // Show success feedback
            this.showFeedback("Mood shared! \uD83C\uDF08", 'success');
        } catch (error) {
            window.logger.error('Error sharing mood:', error);
            const message = error.message || 'Failed to share mood. Please try again.';
            const stylePicker = this.closest('post-writer')?.querySelector('#postStylePicker');
            if (stylePicker?.getStyle?.() && stylePicker.showError) stylePicker.showError(message);
            this.showFeedback(message, 'error');
        } finally{
            // Re-enable the share button
            const shareBtn = this.querySelector('#shareMoodBtn');
            if (shareBtn) {
                shareBtn.disabled = false;
                shareBtn.textContent = 'Share Mood';
            }
        }
    }
    showFeedback(message, type = 'info') {
        // Create temporary feedback element
        const feedback = document.createElement('div');
        feedback.className = `mood-feedback ${type}`;
        feedback.textContent = message;
        feedback.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 0.75rem 1rem;
      border-radius: 6px;
      color: white;
      font-weight: 500;
      z-index: 10000;
      animation: slideIn 0.3s ease;
      background: ${type === 'success' ? 'var(--success-color)' : type === 'error' ? 'var(--error-color)' : 'var(--info-color)'};
    `;
        document.body.appendChild(feedback);
        // Remove after 3 seconds
        setTimeout(()=>{
            feedback.style.animation = 'slideOut 0.3s ease';
            setTimeout(()=>feedback.remove(), 300);
        }, 3000);
    }
    // Public method to get current mood data
    getMoodData() {
        return {
            selectedMood: this.selectedMood,
            moodStatus: this.moodStatus
        };
    }
    // Public method to reset the selector
    reset() {
        this.clearMood();
    }
    // Refresh the posts feed
    refreshPostsFeed() {
        // Find and refresh the posts feed component
        const postsFeed = document.querySelector('posts-feed');
        if (postsFeed && postsFeed.load) postsFeed.load();
        // Also refresh activity panel if it exists
        const activityPanel = document.querySelector('activity-panel');
        if (activityPanel && activityPanel.loadFriendActivities) activityPanel.loadFriendActivities();
    }
}
// Register the component
customElements.define('mood-selector', $973358ba81686713$var$MoodSelector);
var $973358ba81686713$export$2e2bcd8739ae039 = $973358ba81686713$var$MoodSelector;


// Music Player Web Component

class $675968a1c0c8c927$var$MusicPlayer extends HTMLElement {
    constructor(){
        super();
        this.platform = null;
        this.embedId = null;
        this.embedUrl = null;
        this.contentType = null;
        this.country = null;
        this.title = null;
        this.artist = null;
        this.image = null;
    }
    static get observedAttributes() {
        return [
            'platform',
            'embed-id',
            'embed-url',
            'content-type',
            'country',
            'title',
            'artist',
            'image'
        ];
    }
    connectedCallback() {
        this.syncFromAttributes();
        this.render();
    }
    syncFromAttributes() {
        this.platform = this.platform ?? this.getAttribute('platform');
        this.embedId = this.embedId ?? this.getAttribute('embed-id');
        this.embedUrl = this.embedUrl ?? this.getAttribute('embed-url');
        this.contentType = this.contentType ?? this.getAttribute('content-type');
        this.country = this.country ?? this.getAttribute('country');
        this.title = this.title ?? this.getAttribute('title');
        this.artist = this.artist ?? this.getAttribute('artist');
        this.image = this.image ?? this.getAttribute('image');
    }
    attributeChangedCallback(name, oldValue, newValue) {
        // Only update if the value actually changed
        if (oldValue === newValue) return;
        switch(name){
            case 'platform':
                this.platform = newValue;
                break;
            case 'embed-id':
                this.embedId = newValue;
                break;
            case 'embed-url':
                this.embedUrl = newValue;
                break;
            case 'content-type':
                this.contentType = newValue;
                break;
            case 'country':
                this.country = newValue;
                break;
            case 'title':
                this.title = newValue;
                break;
            case 'artist':
                this.artist = newValue;
                break;
            case 'image':
                this.image = newValue;
                break;
        }
        // Only render if connected and this is a meaningful change
        if (this.isConnected && oldValue !== newValue) // Use requestAnimationFrame to avoid render loops
        {
            if (!this._renderScheduled) {
                this._renderScheduled = true;
                requestAnimationFrame(()=>{
                    this.render();
                    this._renderScheduled = false;
                });
            }
        }
    }
    render() {
        if (!this.platform || !this.embedId) {
            this.innerHTML = this.renderFallback();
            return;
        }
        this.innerHTML = `
      <div class="music-player">
        ${this.renderPlayer()}
      </div>
    `;
    }
    renderPlayer() {
        switch(this.platform){
            case 'youtube':
                return this.renderYouTube();
            case 'spotify':
                return this.renderSpotify();
            case 'tidal':
                return this.renderTidal();
            case 'apple-music':
                return this.renderAppleMusic();
            case 'soundcloud':
                return this.renderSoundCloud();
            case 'amazon-music':
                return this.renderAmazonMusic();
            default:
                return this.renderFallback();
        }
    }
    renderYouTube() {
        const embedUrl = `https://www.youtube.com/embed/${this.embedId}?rel=0&showinfo=0`;
        return `
      <iframe 
        class="music-embed youtube" 
        src="${embedUrl}" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen
        loading="lazy"
        title="YouTube Music Player">
      </iframe>
    `;
    }
    renderSpotify() {
        const embedUrl = `https://open.spotify.com/embed/${this.contentType}/${this.embedId}?utm_source=generator&theme=0`;
        return `
      <iframe 
        class="music-embed spotify ${this.contentType}" 
        src="${embedUrl}" 
        frameborder="0" 
        allowfullscreen 
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
        loading="lazy"
        title="Spotify Music Player">
      </iframe>
    `;
    }
    renderTidal() {
        const contentType = this.contentType || 'track';
        const embedUrl = `https://embed.tidal.com/${contentType}s/${this.embedId}`;
        return `
      <iframe 
        class="music-embed tidal ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(contentType)}" 
        src="${embedUrl}" 
        frameborder="0" 
        allowfullscreen
        loading="lazy"
        title="Tidal Music Player">
      </iframe>
    `;
    }
    renderAppleMusic() {
        const embedUrl = `https://embed.music.apple.com/${this.country}/${this.contentType}/${this.embedId}`;
        return `
      <iframe 
        class="music-embed apple-music" 
        src="${embedUrl}" 
        frameborder="0" 
        allow="autoplay *; encrypted-media *; fullscreen *" 
        sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
        loading="lazy"
        title="Apple Music Player">
      </iframe>
    `;
    }
    renderSoundCloud() {
        const embedUrl = `https://w.soundcloud.com/player/?url=${encodeURIComponent(this.embedUrl)}&color=%23ff6b9d&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true`;
        return `
      <iframe 
        class="music-embed soundcloud" 
        src="${embedUrl}" 
        frameborder="no" 
        scrolling="no" 
        allow="autoplay"
        loading="lazy"
        title="SoundCloud Music Player">
      </iframe>
    `;
    }
    renderAmazonMusic() {
        // Amazon Music doesn't support embeds, so show a fallback
        return this.renderFallback();
    }
    renderFallback() {
        const platformInfo = this.getPlatformInfo();
        return `
      <div class="music-fallback">
        <div class="fallback-content">
          ${this.image ? `
            <img src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.image)}" alt="Album Art" class="fallback-image" />
          ` : `
            <div class="fallback-image" style="display: flex; align-items: center; justify-content: center; color: var(--text-muted);">
              ${platformInfo.icon}
            </div>
          `}
          <div class="fallback-details">
            ${this.title ? `
              <h4 class="fallback-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.title)}</h4>
            ` : ''}
            ${this.artist ? `
              <p class="fallback-artist">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.artist)}</p>
            ` : ''}
            <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.embedUrl || '#')}" 
               class="fallback-platform" 
               target="_blank" 
               rel="noopener noreferrer">
              <span class="platform-icon">${platformInfo.icon}</span>
              <span>Listen on ${platformInfo.name}</span>
            </a>
          </div>
        </div>
      </div>
    `;
    }
    getPlatformInfo() {
        const platforms = {
            'youtube': {
                name: 'YouTube',
                icon: "\uD83D\uDCFA"
            },
            'spotify': {
                name: 'Spotify',
                icon: "\uD83C\uDFB5"
            },
            'tidal': {
                name: 'Tidal',
                icon: "\uD83C\uDF0A"
            },
            'apple-music': {
                name: 'Apple Music',
                icon: "\uD83C\uDF4E"
            },
            'amazon-music': {
                name: 'Amazon Music',
                icon: "\uD83D\uDCE6"
            },
            'soundcloud': {
                name: 'SoundCloud',
                icon: "\u2601\uFE0F"
            },
            'deezer': {
                name: 'Deezer',
                icon: "\uD83C\uDFB6"
            },
            'bandcamp': {
                name: 'Bandcamp',
                icon: "\uD83C\uDFAA"
            }
        };
        return platforms[this.platform] || {
            name: 'Music Platform',
            icon: "\uD83C\uDFB5"
        };
    }
    // Public method to set all music data at once
    setMusicData(data) {
        this.platform = data.platform;
        this.embedId = data.embedId;
        this.embedUrl = data.embedUrl;
        this.contentType = data.contentType;
        this.country = data.country;
        this.title = data.title;
        this.artist = data.artist;
        this.image = data.image;
        this.render();
    }
}
// Register the component
customElements.define('music-player', $675968a1c0c8c927$var$MusicPlayer);
var $675968a1c0c8c927$export$2e2bcd8739ae039 = $675968a1c0c8c927$var$MusicPlayer;


// Music Selector Web Component

class $2e7ed4921ff1bbc2$var$MusicSelector extends HTMLElement {
    constructor(){
        super();
        this.musicUrl = '';
        this.urlMetadata = null;
        this.currentJobId = null;
        this.statusCheckInterval = null;
        this.isLoading = false;
        this.debounceTimer = null;
        this.postText = '';
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="music-selector">
        <div class="music-header">
          <post-type-selector selected-type="music" id="musicPostTypeSelector"></post-type-selector>
          <p>Paste a link to a song, album, or playlist</p>
        </div>
        
        <div class="music-input-group">
          <input 
            type="url" 
            id="musicUrlInput"
            class="music-url-input"
            placeholder="https://open.spotify.com/track/... or any music URL"
            value="${this.musicUrl}"
          />
          <button 
            type="button" 
            class="clear-url-btn" 
            id="clearUrlBtn"
            title="Clear URL"
            style="display: ${this.musicUrl ? 'block' : 'none'};"
          >
            \u{2715}
          </button>
        </div>
        
        <div class="url-status" id="urlStatus" style="display: none;">
          <div class="loading-indicator" id="loadingIndicator" style="display: none;">
            <div class="spinner"></div>
            <span>Loading preview...</span>
          </div>
          <div class="generating-indicator" id="generatingIndicator" style="display: none;">
            <div class="spinner"></div>
            <span>Generating preview...</span>
            <button class="refresh-btn" id="refreshBtn" title="Refresh status">
              \u{1F504}
            </button>
          </div>
          <div class="error-message" id="errorMessage" style="display: none;"></div>
        </div>
        
        <div class="music-preview" id="musicPreview" style="display: none;">
          <!-- Preview will be populated here -->
        </div>
        
        <div class="music-post-text" style="display: ${this.urlMetadata ? 'block' : 'none'};">
          <textarea 
            id="musicPostText"
            placeholder="Add your thoughts about this music... (optional)"
            rows="3"
          >${this.postText}</textarea>
        </div>
        
        <div class="music-actions" style="display: ${this.urlMetadata ? 'flex' : 'none'};">
          <button class="clear-music-btn" id="clearMusicBtn">Clear</button>
          <button class="share-music-btn" id="shareMusicBtn">Share Music</button>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Post type selector
        const postTypeSelector = this.querySelector('#musicPostTypeSelector');
        if (postTypeSelector) postTypeSelector.addEventListener('post-type-selected', (e)=>{
            // Dispatch event to parent post-writer to switch types
            this.dispatchEvent(new CustomEvent('switch-post-type', {
                detail: {
                    type: e.detail.type
                },
                bubbles: true
            }));
        });
        const urlInput = this.querySelector('#musicUrlInput');
        const clearUrlBtn = this.querySelector('#clearUrlBtn');
        const clearMusicBtn = this.querySelector('#clearMusicBtn');
        const shareMusicBtn = this.querySelector('#shareMusicBtn');
        const refreshBtn = this.querySelector('#refreshBtn');
        const postTextArea = this.querySelector('#musicPostText');
        // Post text input
        if (postTextArea) postTextArea.addEventListener('input', (e)=>{
            this.postText = e.target.value;
        });
        // URL input with debounced validation
        urlInput.addEventListener('input', (e)=>{
            this.musicUrl = e.target.value.trim();
            this.updateClearButtonVisibility();
            // Clear previous timer
            if (this.debounceTimer) clearTimeout(this.debounceTimer);
            // Debounce URL processing
            this.debounceTimer = setTimeout(()=>{
                this.processUrl();
            }, 500);
        });
        // Clear URL button
        clearUrlBtn.addEventListener('click', ()=>{
            this.clearUrl();
        });
        // Clear music button
        clearMusicBtn.addEventListener('click', ()=>{
            this.clearMusic();
        });
        // Share music button
        shareMusicBtn.addEventListener('click', ()=>{
            this.shareMusic();
        });
        // Refresh button
        refreshBtn.addEventListener('click', ()=>{
            this.checkJobStatus();
        });
    }
    updateClearButtonVisibility() {
        const clearUrlBtn = this.querySelector('#clearUrlBtn');
        if (clearUrlBtn) clearUrlBtn.style.display = this.musicUrl ? 'block' : 'none';
    }
    async processUrl() {
        if (!this.musicUrl) {
            this.hideStatus();
            this.hidePreview();
            this.clearJobStatus();
            return;
        }
        // Basic URL validation
        if (!this.isValidUrl(this.musicUrl)) {
            this.showError('Please enter a valid URL');
            this.hidePreview();
            this.clearJobStatus();
            return;
        }
        this.showGenerating();
        this.hidePreview();
        try {
            // Queue metadata generation job
            const response = await fetch('/api/url-metadata', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    url: this.musicUrl,
                    type: 'music'
                })
            });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const result = await response.json();
            if (result.success && result.jobId) {
                this.currentJobId = result.jobId;
                this.startStatusPolling();
            } else throw new Error('Failed to queue metadata generation');
        } catch (error) {
            window.logger.error('Error queuing URL metadata generation:', error);
            this.showError('Could not start metadata generation');
            this.hidePreview();
            this.urlMetadata = null;
            this.clearJobStatus();
            this.updateActions();
        }
    }
    isValidUrl(string) {
        try {
            const url = new URL(string);
            return url.protocol === 'http:' || url.protocol === 'https:';
        } catch (error) {
            window.logger.error('Error validating URL:', error);
            return false;
        }
    }
    showLoading() {
        const urlStatus = this.querySelector('#urlStatus');
        const loadingIndicator = this.querySelector('#loadingIndicator');
        const generatingIndicator = this.querySelector('#generatingIndicator');
        const errorMessage = this.querySelector('#errorMessage');
        urlStatus.style.display = 'block';
        loadingIndicator.style.display = 'flex';
        generatingIndicator.style.display = 'none';
        errorMessage.style.display = 'none';
    }
    showGenerating() {
        const urlStatus = this.querySelector('#urlStatus');
        const loadingIndicator = this.querySelector('#loadingIndicator');
        const generatingIndicator = this.querySelector('#generatingIndicator');
        const errorMessage = this.querySelector('#errorMessage');
        urlStatus.style.display = 'block';
        loadingIndicator.style.display = 'none';
        generatingIndicator.style.display = 'flex';
        errorMessage.style.display = 'none';
    }
    showError(message) {
        const urlStatus = this.querySelector('#urlStatus');
        const loadingIndicator = this.querySelector('#loadingIndicator');
        const errorMessage = this.querySelector('#errorMessage');
        urlStatus.style.display = 'block';
        loadingIndicator.style.display = 'none';
        errorMessage.style.display = 'block';
        errorMessage.textContent = message;
    }
    hideStatus() {
        const urlStatus = this.querySelector('#urlStatus');
        urlStatus.style.display = 'none';
    }
    showPreview(metadata) {
        const musicPreview = this.querySelector('#musicPreview');
        const siteIcon = this.getSiteIcon(metadata.siteName, metadata.type);
        musicPreview.innerHTML = `
      <div class="preview-content">
        ${metadata.image ? `
          <img src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(metadata.image)}" alt="Preview" class="preview-image" />
        ` : `
          <div class="preview-image" style="display: flex; align-items: center; justify-content: center; color: var(--text-muted);">
            ${siteIcon}
          </div>
        `}
        <div class="preview-details">
          <h4 class="preview-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(metadata.title || 'Untitled')}</h4>
          ${metadata.description ? `
            <p class="preview-description">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(metadata.description)}</p>
          ` : ''}
          <div class="preview-site">
            <span class="site-icon">${siteIcon}</span>
            <span>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(metadata.siteName || 'Unknown Site')}</span>
          </div>
        </div>
      </div>
    `;
        musicPreview.style.display = 'block';
        this.dispatchEvent(new CustomEvent('music-preview-shown', {
            bubbles: true
        }));
    }
    hidePreview() {
        const musicPreview = this.querySelector('#musicPreview');
        musicPreview.style.display = 'none';
    }
    getSiteIcon(siteName, type) {
        if (type && type.startsWith('music.')) {
            const platform = type.split('.')[1];
            const musicIcons = {
                'spotify': "\uD83C\uDFB5",
                'apple-music': "\uD83C\uDF4E",
                'youtube': "\uD83D\uDCFA",
                'youtube-music': "\uD83C\uDFB5",
                'soundcloud': "\u2601\uFE0F",
                'tidal': "\uD83C\uDF0A",
                'deezer': "\uD83C\uDFB6",
                'bandcamp': "\uD83C\uDFAA"
            };
            return musicIcons[platform] || "\uD83C\uDFB5";
        }
        return "\uD83D\uDD17";
    }
    updateActions() {
        const musicActions = this.querySelector('.music-actions');
        const musicPostText = this.querySelector('.music-post-text');
        musicActions.style.display = this.urlMetadata ? 'flex' : 'none';
        if (musicPostText) musicPostText.style.display = this.urlMetadata ? 'block' : 'none';
    }
    clearUrl() {
        const urlInput = this.querySelector('#musicUrlInput');
        const postTextArea = this.querySelector('#musicPostText');
        urlInput.value = '';
        this.musicUrl = '';
        this.urlMetadata = null;
        this.postText = '';
        if (postTextArea) postTextArea.value = '';
        this.updateClearButtonVisibility();
        this.hideStatus();
        this.hidePreview();
        this.updateActions();
        urlInput.focus();
    }
    clearMusic() {
        this.clearUrl();
    }
    async shareMusic() {
        if (!this.musicUrl || !this.urlMetadata) return;
        try {
            const shareBtn = this.querySelector('#shareMusicBtn');
            shareBtn.disabled = true;
            shareBtn.textContent = 'Sharing...';
            // Create music post
            const postContent = this.postText.trim() || this.urlMetadata.description || `Sharing music: ${this.urlMetadata.title}`;
            const postData = {
                post_type: 'music',
                music_url: this.musicUrl,
                title: `\u{1F3B5} ${this.urlMetadata.title}`,
                content: postContent
            };
            Object.assign(postData, this.closest('post-writer')?.getPostStylePayload?.() || {});
            const post = await window.API.posts.create(postData);
            // Clear the music selector
            this.clearMusic();
            // Dispatch event to notify other components
            this.dispatchEvent(new CustomEvent('music-shared', {
                detail: {
                    musicPost: post
                },
                bubbles: true
            }));
            // Show success feedback
            this.showFeedback("Music shared! \uD83C\uDFB5", 'success');
        } catch (error) {
            window.logger.error('Error sharing music:', error);
            const message = error.message || 'Failed to share music. Please try again.';
            const stylePicker = this.closest('post-writer')?.querySelector('#postStylePicker');
            if (stylePicker?.getStyle?.() && stylePicker.showError) stylePicker.showError(message);
            this.showFeedback(message, 'error');
        } finally{
            // Re-enable the share button
            const shareBtn = this.querySelector('#shareMusicBtn');
            if (shareBtn) {
                shareBtn.disabled = false;
                shareBtn.textContent = 'Share Music';
            }
        }
    }
    refreshPostsFeed() {
        // Find and refresh the posts feed component
        const postsFeed = document.querySelector('posts-feed');
        if (postsFeed && postsFeed.load) postsFeed.load();
        // Also refresh activity panel if it exists
        const activityPanel = document.querySelector('activity-panel');
        if (activityPanel && activityPanel.loadFriendActivities) activityPanel.loadFriendActivities();
    }
    showFeedback(message, type = 'info') {
        // Create temporary feedback element
        const feedback = document.createElement('div');
        feedback.className = `music-feedback ${type}`;
        feedback.textContent = message;
        feedback.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 0.75rem 1rem;
      border-radius: 6px;
      color: white;
      font-weight: 500;
      z-index: 10000;
      animation: slideIn 0.3s ease;
      background: ${type === 'success' ? 'var(--success-color)' : type === 'error' ? 'var(--error-color)' : 'var(--info-color)'};
    `;
        document.body.appendChild(feedback);
        // Remove after 3 seconds
        setTimeout(()=>{
            feedback.style.animation = 'slideOut 0.3s ease';
            setTimeout(()=>feedback.remove(), 300);
        }, 3000);
    }
    // Public method to get current music data
    getMusicData() {
        return {
            musicUrl: this.musicUrl,
            urlMetadata: this.urlMetadata
        };
    }
    // Public method to reset the selector
    reset() {
        this.clearMusic();
    }
    // Job status management methods
    startStatusPolling() {
        // Clear any existing interval
        if (this.statusCheckInterval) clearInterval(this.statusCheckInterval);
        // Check status immediately
        this.checkJobStatus();
        // Then check every 2 seconds
        this.statusCheckInterval = setInterval(()=>{
            this.checkJobStatus();
        }, 2000);
    }
    stopStatusPolling() {
        if (this.statusCheckInterval) {
            clearInterval(this.statusCheckInterval);
            this.statusCheckInterval = null;
        }
    }
    async checkJobStatus() {
        if (!this.currentJobId) return;
        try {
            const response = await fetch(`/api/url-metadata/status/${this.currentJobId}`);
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const result = await response.json();
            if (result.status === 'completed' && result.metadata) {
                // Job completed successfully
                this.stopStatusPolling();
                this.urlMetadata = result.metadata;
                this.hideStatus();
                this.showPreview(result.metadata);
                this.updateActions();
                this.clearJobStatus();
            } else if (result.status === 'completed' && !result.metadata) {
                // Job completed but metadata is missing (shouldn't happen, but handle gracefully)
                this.stopStatusPolling();
                this.showError(result.error || 'Metadata generation completed but result is unavailable. Please try again.');
                this.urlMetadata = null;
                this.updateActions();
                this.clearJobStatus();
            } else if (result.status === 'failed') {
                // Job failed
                this.stopStatusPolling();
                this.showError(result.error || 'Metadata generation failed');
                this.urlMetadata = null;
                this.updateActions();
                this.clearJobStatus();
            }
        // If status is 'processing', 'waiting', etc., we continue polling
        } catch (error) {
            window.logger.error('Error checking job status:', error);
        // Don't show error immediately, let it retry
        }
    }
    clearJobStatus() {
        this.currentJobId = null;
        this.stopStatusPolling();
    }
    // Cleanup when component is disconnected
    disconnectedCallback() {
        this.stopStatusPolling();
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
    }
}
// Register the component
customElements.define('music-selector', $2e7ed4921ff1bbc2$var$MusicSelector);
var $2e7ed4921ff1bbc2$export$2e2bcd8739ae039 = $2e7ed4921ff1bbc2$var$MusicSelector;


// Post Type Selector Web Component
// Accessible dropdown for selecting post types
/**
 * Positions a dropdown menu with fixed viewport coordinates and portals the
 * menu to document.body so it escapes overflow clipping, transform/backdrop-filter
 * containing blocks, and ancestor z-index stacking traps.
 */ const $b4aba70cea4dadba$var$PORTAL_CLASS = 'popup-menu-portaled';
function $b4aba70cea4dadba$export$b13eaba63895f49c(_host, options) {
    const { openClass: openClass = 'open', align: align = 'left', gap: gap = 8, onClose: onClose } = options;
    let isOpen = false;
    let currentTrigger = null;
    let currentMenu = null;
    /** @type {Record<string, string>} */ let styleSnapshot = null;
    /** @type {{ parent: HTMLElement, nextSibling: ChildNode | null } | null} */ let portalSnapshot = null;
    let outsideHandler = null;
    let scrollHandler = null;
    let resizeHandler = null;
    function position() {
        if (!currentTrigger || !currentMenu) return;
        const rect = currentTrigger.getBoundingClientRect();
        let left = rect.left;
        if (align === 'right') left = rect.right - currentMenu.offsetWidth;
        currentMenu.style.position = 'fixed';
        currentMenu.style.top = `${rect.bottom + gap}px`;
        currentMenu.style.left = `${left}px`;
        currentMenu.style.zIndex = '10000';
    }
    function portalMenuToBody(menu) {
        if (menu.parentElement === document.body) return;
        portalSnapshot = {
            parent: menu.parentElement,
            nextSibling: menu.nextSibling
        };
        menu.classList.add($b4aba70cea4dadba$var$PORTAL_CLASS);
        document.body.appendChild(menu);
    }
    function restoreMenuToHost(menu) {
        menu.classList.remove($b4aba70cea4dadba$var$PORTAL_CLASS);
        if (portalSnapshot?.parent) {
            portalSnapshot.parent.insertBefore(menu, portalSnapshot.nextSibling);
            portalSnapshot = null;
        }
    }
    function removeGlobalListeners() {
        if (outsideHandler) {
            document.removeEventListener('mousedown', outsideHandler, true);
            outsideHandler = null;
        }
        if (scrollHandler) {
            window.removeEventListener('scroll', scrollHandler, true);
            scrollHandler = null;
        }
        if (resizeHandler) {
            window.removeEventListener('resize', resizeHandler);
            resizeHandler = null;
        }
    }
    function restoreMenuStyles(menu) {
        if (styleSnapshot) {
            for (const key of [
                'position',
                'top',
                'left',
                'right',
                'zIndex'
            ])menu.style[key] = styleSnapshot[key] ?? '';
            styleSnapshot = null;
        } else {
            menu.style.position = '';
            menu.style.top = '';
            menu.style.left = '';
            menu.style.right = '';
            menu.style.zIndex = '';
        }
    }
    function close() {
        if (!isOpen || !currentMenu) {
            removeGlobalListeners();
            return;
        }
        isOpen = false;
        const menuEl = currentMenu;
        removeGlobalListeners();
        restoreMenuStyles(menuEl);
        menuEl.classList.remove(openClass);
        restoreMenuToHost(menuEl);
        currentTrigger = null;
        currentMenu = null;
        onClose?.();
    }
    function open(trigger, menu) {
        if (!trigger || !menu) return;
        // If already open (unlikely), tear down without onClose — parent is reopening.
        if (isOpen && currentMenu) {
            removeGlobalListeners();
            restoreMenuStyles(currentMenu);
            currentMenu.classList.remove(openClass);
            restoreMenuToHost(currentMenu);
            currentTrigger = null;
            currentMenu = null;
            styleSnapshot = null;
            portalSnapshot = null;
            isOpen = false;
        }
        isOpen = true;
        currentTrigger = trigger;
        currentMenu = menu;
        styleSnapshot = {
            position: menu.style.position,
            top: menu.style.top,
            left: menu.style.left,
            right: menu.style.right,
            zIndex: menu.style.zIndex
        };
        portalMenuToBody(menu);
        // Set coordinates before the open class so transitions don't animate from (0,0).
        position();
        menu.classList.add(openClass);
        requestAnimationFrame(()=>{
            if (currentMenu !== menu || !isOpen) return;
            position();
        });
        scrollHandler = ()=>position();
        resizeHandler = ()=>position();
        window.addEventListener('scroll', scrollHandler, true);
        window.addEventListener('resize', resizeHandler);
        outsideHandler = (e)=>{
            const target = /** @type {Node} */ e.target;
            if (!trigger.contains(target) && !menu.contains(target)) close();
        };
        document.addEventListener('mousedown', outsideHandler, true);
    }
    function getMenu() {
        return currentMenu ?? null;
    }
    return {
        open: open,
        close: close,
        getMenu: getMenu
    };
}


class $0f6d0eb6eb380a03$var$PostTypeSelector extends HTMLElement {
    constructor(){
        super();
        this.selectedType = 'text';
        this.isDropdownOpen = false;
        this.focusedIndex = -1;
        this._popupPortal = null;
        this.postTypes = [
            {
                type: 'text',
                icon: "\uD83D\uDCDD",
                label: 'Write Post'
            },
            {
                type: 'mood',
                icon: "\uD83C\uDF08",
                label: 'Share Mood'
            },
            {
                type: 'music',
                icon: "\uD83C\uDFB5",
                label: 'Share Music'
            },
            {
                type: 'poll',
                icon: "\uD83D\uDCCA",
                label: 'Poll'
            }
        ];
    }
    static get observedAttributes() {
        return [
            'selected-type'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'selected-type' && newValue !== oldValue) {
            this.selectedType = newValue || 'text';
            this.updateDisplay();
        }
    }
    connectedCallback() {
        const selectedTypeAttr = this.getAttribute('selected-type');
        if (selectedTypeAttr) this.selectedType = selectedTypeAttr;
        this.render();
        this.attachEventListeners();
    }
    getCurrentPostType() {
        return this.postTypes.find((pt)=>pt.type === this.selectedType) || this.postTypes[0];
    }
    render() {
        const currentType = this.getCurrentPostType();
        const menuId = `post-type-menu-${this.generateId()}`;
        const buttonId = `post-type-button-${this.generateId()}`;
        this.innerHTML = `
      <button 
        type="button" 
        id="${buttonId}"
        class="post-type-dropdown-btn active" 
        aria-haspopup="listbox"
        aria-expanded="${this.isDropdownOpen}"
        aria-controls="${menuId}"
        aria-label="Select post type. Current: ${currentType?.label || 'Write Post'}"
      >
        <span class="post-type-label">
          ${currentType?.icon || "\uD83D\uDCDD"} ${currentType?.label || 'Write Post'}
        </span>
        <span class="dropdown-arrow" aria-hidden="true">\u{25BC}</span>
      </button>
      <ul 
        id="${menuId}"
        class="post-type-menu ${this.isDropdownOpen ? 'open' : ''}"
        role="listbox"
        aria-label="Post type options"
      >
        ${this.postTypes.map((pt, index)=>`
          <li 
            role="option"
            class="post-type-menu-item ${this.selectedType === pt.type ? 'selected' : ''} ${index === this.focusedIndex ? 'focused' : ''}"
            data-type="${pt.type}"
            data-index="${index}"
            aria-selected="${this.selectedType === pt.type}"
            tabindex="-1"
          >
            ${pt.icon} ${pt.label}
          </li>
        `).join('')}
      </ul>
    `;
    }
    generateId() {
        return Math.random().toString(36).substring(2, 9);
    }
    attachEventListeners() {
        const dropdownButton = this.querySelector('.post-type-dropdown-btn');
        const menu = this.querySelector('.post-type-menu');
        const menuItems = this.getMenuItems();
        if (!dropdownButton || !menu) return;
        if (!this._popupPortal) this._popupPortal = (0, $b4aba70cea4dadba$export$b13eaba63895f49c)(this, {
            getMenuContainer: ()=>this,
            menuSelector: '.post-type-menu',
            openClass: 'open',
            align: 'left',
            gap: 8,
            onClose: ()=>{
                this.isDropdownOpen = false;
                this.focusedIndex = -1;
                this.updateDropdownState();
            }
        });
        // Dropdown button click
        dropdownButton.addEventListener('click', (e)=>{
            e.stopPropagation();
            this.toggleDropdown();
        });
        // Keyboard navigation on button
        dropdownButton.addEventListener('keydown', (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.openDropdown();
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                this.openDropdown();
                this.focusMenuItem(0);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                this.openDropdown();
                this.focusMenuItem(menuItems.length - 1);
            }
        });
        // Menu item click
        menuItems.forEach((item, index)=>{
            item.addEventListener('click', (e)=>{
                e.stopPropagation();
                const type = item.dataset.type;
                this.selectPostType(type);
            });
            // Keyboard navigation on menu items
            item.addEventListener('keydown', (e)=>{
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    const type = item.dataset.type;
                    this.selectPostType(type);
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    const nextIndex = (index + 1) % menuItems.length;
                    this.focusMenuItem(nextIndex);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    const prevIndex = (index - 1 + menuItems.length) % menuItems.length;
                    this.focusMenuItem(prevIndex);
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    this.focusMenuItem(0);
                } else if (e.key === 'End') {
                    e.preventDefault();
                    this.focusMenuItem(menuItems.length - 1);
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    this.closeDropdown();
                    dropdownButton?.focus();
                }
            });
        });
        // Close dropdown on Escape key (outside click is handled by portal)
        const handleEscape = (e)=>{
            if (e.key === 'Escape' && this.isDropdownOpen) {
                this.closeDropdown();
                dropdownButton?.focus();
            }
        };
        this._escapeHandler = handleEscape;
        document.addEventListener('keydown', handleEscape);
    }
    disconnectedCallback() {
        this._popupPortal?.close();
        if (this._escapeHandler) document.removeEventListener('keydown', this._escapeHandler);
    }
    toggleDropdown() {
        if (this.isDropdownOpen) this.closeDropdown();
        else this.openDropdown();
    }
    openDropdown() {
        const dropdownButton = this.querySelector('.post-type-dropdown-btn');
        const menu = this.querySelector('.post-type-menu');
        if (!dropdownButton || !menu || !this._popupPortal) return;
        this.isDropdownOpen = true;
        this.focusedIndex = -1;
        this._popupPortal.open(dropdownButton, menu);
        this.updateDropdownState();
    }
    closeDropdown() {
        this._popupPortal?.close();
    }
    /** Menu may be in host or portaled to body; use portal.getMenu() when open. */ getMenu() {
        return this._popupPortal?.getMenu() ?? this.querySelector('.post-type-menu');
    }
    getMenuItems() {
        const menu = this.getMenu();
        return menu ? Array.from(menu.querySelectorAll('.post-type-menu-item')) : [];
    }
    updateDropdownState() {
        const button = this.querySelector('.post-type-dropdown-btn');
        const menu = this.getMenu();
        const currentType = this.getCurrentPostType();
        if (button) {
            button.setAttribute('aria-expanded', this.isDropdownOpen);
            button.setAttribute('aria-label', `Select post type. Current: ${currentType?.label || 'Write Post'}`);
        }
        if (menu) menu.classList.toggle('open', this.isDropdownOpen);
        const menuItems = this.getMenuItems();
        menuItems.forEach((item, index)=>{
            item.classList.toggle('focused', index === this.focusedIndex);
        });
    }
    focusMenuItem(index) {
        const menuItems = this.getMenuItems();
        if (index >= 0 && index < menuItems.length) {
            this.focusedIndex = index;
            menuItems[index].focus({
                preventScroll: true
            });
            this.updateDropdownState();
        }
    }
    selectPostType(type) {
        this.selectedType = type;
        this.setAttribute('selected-type', type);
        this.closeDropdown();
        this.updateDisplay();
        // Dispatch custom event
        this.dispatchEvent(new CustomEvent('post-type-selected', {
            detail: {
                type: type
            },
            bubbles: true
        }));
        // Return focus to button
        const button = this.querySelector('.post-type-dropdown-btn');
        button?.focus();
    }
    updateDisplay() {
        const currentType = this.getCurrentPostType();
        const button = this.querySelector('.post-type-dropdown-btn');
        const label = this.querySelector('.post-type-label');
        if (button) button.setAttribute('aria-label', `Select post type. Current: ${currentType?.label || 'Write Post'}`);
        if (label) label.innerHTML = `${currentType?.icon || "\uD83D\uDCDD"} ${currentType?.label || 'Write Post'}`;
        // Update selected state in menu
        const menuItems = this.getMenuItems();
        menuItems.forEach((item)=>{
            const isSelected = item.dataset.type === this.selectedType;
            item.classList.toggle('selected', isSelected);
            item.setAttribute('aria-selected', isSelected);
        });
    }
    setSelectedType(type) {
        this.selectedType = type;
        this.setAttribute('selected-type', type);
        this.updateDisplay();
    }
}
// Register the custom element
customElements.define('post-type-selector', $0f6d0eb6eb380a03$var$PostTypeSelector);


// Edit Poll Web Component
// Encapsulated component for creating/editing polls in post-writer
class $1bb88e5b75909809$var$EditPoll extends HTMLElement {
    constructor(){
        super();
        this.pollQuestion = '';
        this.pollOptions = [
            '',
            ''
        ]; // Start with 2 empty options
        this.pollType = 'single'; // Default to single-selection
        this.selectedPrompt = null;
        this.isSubmitting = false;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    static get observedAttributes() {
        return [
            'prompt-data'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'prompt-data' && newValue) try {
            const prompt = JSON.parse(newValue);
            this.loadPromptData(prompt);
        } catch (error) {
            window.logger?.error('Invalid prompt data in edit-poll:', error);
        }
    }
    loadPromptData(prompt) {
        if (prompt.prompt_type === 'poll') {
            this.selectedPrompt = prompt;
            this.pollQuestion = prompt.title || '';
            if (prompt.poll_options && Array.isArray(prompt.poll_options)) {
                this.pollOptions = [
                    ...prompt.poll_options
                ];
                // Ensure we have at least 2 options
                while(this.pollOptions.length < 2)this.pollOptions.push('');
            }
            this.render();
            this.attachEventListeners();
        }
    }
    setPromptData(prompt) {
        this.loadPromptData(prompt);
    }
    render() {
        this.innerHTML = `
      <div class="edit-poll">
        <div class="poll-header">
          <post-type-selector selected-type="poll" id="pollPostTypeSelector"></post-type-selector>
          <div class="poll-prompt-actions">
            <washing-machine-icon 
              id="pollWashBtn" 
              size="medium" 
              interactive="true"
              title="Get a random poll prompt"
            ></washing-machine-icon>
            <button type="button" class="propose-prompt-btn" id="pollProposeBtn" title="Propose a new poll prompt">
              \u{1F4A1}
            </button>
          </div>
        </div>
        
        <div class="form-group">
          <label for="pollType">Poll Type</label>
          <div class="poll-type-selector">
            <label class="poll-type-option">
              <input 
                type="radio" 
                name="pollType" 
                value="single" 
                ${this.pollType === 'single' ? 'checked' : ''}
              />
              <span>Single</span>
            </label>
            <label class="poll-type-option">
              <input 
                type="radio" 
                name="pollType" 
                value="multi" 
                ${this.pollType === 'multi' ? 'checked' : ''}
              />
              <span>Multi-Select</span>
            </label>
            <label class="poll-type-option">
              <input 
                type="radio" 
                name="pollType" 
                value="toggle" 
                ${this.pollType === 'toggle' ? 'checked' : ''}
              />
              <span>Toggle</span>
            </label>
          </div>
        </div>
        
        <div class="form-group">
          <label for="pollQuestion">Poll Question</label>
          <textarea 
            id="pollQuestion"
            class="form-control"
            placeholder="What's your favorite season?"
            maxlength="500"
            rows="2"
            required
          >${this.escapeHtml(this.pollQuestion)}</textarea>
          <div class="char-count">
            <span id="questionCharCount">${this.pollQuestion.length}</span>/500
          </div>
        </div>

        <div class="form-group">
          <label>Poll Options <span class="option-count">(${this.pollOptions.length}/10)</span></label>
          <div class="poll-options-list" id="pollOptionsList">
            ${this.pollOptions.map((option, index)=>`
              <div class="poll-option-item" data-index="${index}">
                <input 
                  type="text"
                  class="form-control poll-option-input"
                  data-index="${index}"
                  placeholder="Option ${index + 1}"
                  value="${this.escapeHtml(option)}"
                  maxlength="500"
                  required
                />
                ${this.pollOptions.length > 2 ? `
                  <button 
                    type="button" 
                    class="btn btn-icon remove-option-btn"
                    data-index="${index}"
                    title="Remove option"
                  >
                    \u{2715}
                  </button>
                ` : ''}
              </div>
            `).join('')}
          </div>
          ${this.pollOptions.length < 10 ? `
            <button type="button" class="btn btn-secondary add-option-btn" id="addOptionBtn">
              + Add Option
            </button>
          ` : ''}
        </div>

        <div class="poll-actions">
          <button type="button" class="btn btn-secondary" id="clearPollBtn">Clear</button>
          <button type="button" class="btn btn-primary" id="createPollBtn">
            <span class="btn-text">Create Poll</span>
            <span class="spinner hidden"></span>
          </button>
        </div>

        <div class="alert-container"></div>
      </div>
    `;
    }
    attachEventListeners() {
        // Post type selector
        const postTypeSelector = this.querySelector('#pollPostTypeSelector');
        if (postTypeSelector) postTypeSelector.addEventListener('post-type-selected', (e)=>{
            // Dispatch event to parent post-writer to switch types
            this.dispatchEvent(new CustomEvent('switch-post-type', {
                detail: {
                    type: e.detail.type
                },
                bubbles: true
            }));
        });
        // Poll type selector
        this.querySelectorAll('input[name="pollType"]').forEach((radio)=>{
            radio.addEventListener('change', (e)=>{
                this.pollType = e.target.value;
            });
        });
        // Question input
        const questionInput = this.querySelector('#pollQuestion');
        questionInput.addEventListener('input', (e)=>{
            this.pollQuestion = e.target.value;
            this.updateQuestionCharCount();
        });
        // Option inputs
        this.querySelectorAll('.poll-option-input').forEach((input)=>{
            input.addEventListener('input', (e)=>{
                const index = parseInt(e.target.dataset.index, 10);
                this.pollOptions[index] = e.target.value;
                this.validateOptions();
            });
        });
        // Remove option buttons
        this.querySelectorAll('.remove-option-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const index = parseInt(e.target.dataset.index, 10);
                this.removeOption(index);
            });
        });
        // Add option button
        const addOptionBtn = this.querySelector('#addOptionBtn');
        if (addOptionBtn) addOptionBtn.addEventListener('click', ()=>{
            this.addOption();
        });
        // Clear button
        const clearBtn = this.querySelector('#clearPollBtn');
        clearBtn.addEventListener('click', ()=>{
            this.clearPoll();
        });
        // Create poll button
        const createBtn = this.querySelector('#createPollBtn');
        createBtn.addEventListener('click', ()=>{
            this.createPoll();
        });
        // Washing machine: random poll prompt
        const washBtn = this.querySelector('#pollWashBtn');
        if (washBtn) washBtn.addEventListener('click', ()=>{
            this.getRandomPollPrompt();
        });
        // Propose poll prompt
        const proposeBtn = this.querySelector('#pollProposeBtn');
        if (proposeBtn) proposeBtn.addEventListener('click', ()=>{
            document.dispatchEvent(new CustomEvent('open-propose-prompt', {
                detail: {
                    presetType: 'poll'
                },
                bubbles: true
            }));
        });
    }
    async getRandomPollPrompt() {
        const washBtn = this.querySelector('#pollWashBtn');
        if (washBtn && washBtn.spin) washBtn.spin();
        try {
            const res = await window.API.prompts.getPublic();
            const all = res.prompts || [];
            const pollPrompts = all.filter((p)=>p.prompt_type === 'poll');
            if (pollPrompts.length === 0) {
                this.showAlert("No poll prompts yet. Propose one with \uD83D\uDCA1!", 'info');
                return;
            }
            const prompt = pollPrompts[Math.floor(Math.random() * pollPrompts.length)];
            setTimeout(()=>{
                this.setPromptData(prompt);
            }, 600);
        } catch (err) {
            window.logger?.error('Failed to fetch poll prompts:', err);
            this.showAlert('Could not load poll prompts. Try again.', 'error');
        }
    }
    updateQuestionCharCount() {
        const charCount = this.querySelector('#questionCharCount');
        if (charCount) {
            charCount.textContent = this.pollQuestion.length;
            charCount.classList.remove('char-count-ok', 'char-count-warning', 'char-count-error');
            if (this.pollQuestion.length > 450) charCount.classList.add('char-count-error');
            else if (this.pollQuestion.length > 400) charCount.classList.add('char-count-warning');
            else charCount.classList.add('char-count-ok');
        }
    }
    addOption() {
        if (this.pollOptions.length >= 10) {
            this.showAlert('Maximum 10 options allowed', 'error');
            return;
        }
        this.pollOptions.push('');
        this.render();
        this.attachEventListeners();
        // Focus the new input
        const newInput = this.querySelector(`.poll-option-input[data-index="${this.pollOptions.length - 1}"]`);
        if (newInput) setTimeout(()=>newInput.focus(), 100);
    }
    removeOption(index) {
        if (this.pollOptions.length <= 2) {
            this.showAlert('Polls must have at least 2 options', 'error');
            return;
        }
        this.pollOptions.splice(index, 1);
        this.render();
        this.attachEventListeners();
    }
    validateOptions() {
        // Check for duplicates (case-insensitive)
        const optionTexts = this.pollOptions.map((opt)=>opt.trim().toLowerCase()).filter((opt)=>opt.length > 0);
        const uniqueOptions = new Set(optionTexts);
        if (optionTexts.length !== uniqueOptions.size) {
            // Duplicate found - highlight inputs
            this.highlightDuplicates();
            return false;
        }
        this.clearDuplicateHighlights();
        return true;
    }
    highlightDuplicates() {
        const optionInputs = this.querySelectorAll('.poll-option-input');
        const optionTexts = this.pollOptions.map((opt)=>opt.trim().toLowerCase());
        optionInputs.forEach((input, index)=>{
            const text = this.pollOptions[index].trim().toLowerCase();
            if (text && optionTexts.filter((t)=>t === text).length > 1) input.classList.add('duplicate');
        });
    }
    clearDuplicateHighlights() {
        this.querySelectorAll('.poll-option-input').forEach((input)=>{
            input.classList.remove('duplicate');
        });
    }
    clearPoll() {
        this.pollQuestion = '';
        this.pollOptions = [
            '',
            ''
        ];
        this.pollType = 'single';
        this.selectedPrompt = null;
        this.render();
        this.attachEventListeners();
        // Focus question input
        setTimeout(()=>{
            const questionInput = this.querySelector('#pollQuestion');
            if (questionInput) questionInput.focus();
        }, 100);
    }
    async createPoll() {
        if (this.isSubmitting) return;
        // Validate question
        const trimmedQuestion = this.pollQuestion.trim();
        if (!trimmedQuestion || trimmedQuestion.length === 0) {
            this.showAlert('Please enter a poll question', 'error');
            return;
        }
        if (trimmedQuestion.length > 500) {
            this.showAlert('Poll question must be 500 characters or less', 'error');
            return;
        }
        // Validate options
        const validOptions = this.pollOptions.map((opt)=>opt.trim()).filter((opt)=>opt.length > 0);
        if (validOptions.length < 2) {
            this.showAlert('Polls must have at least 2 options', 'error');
            return;
        }
        if (validOptions.length > 10) {
            this.showAlert('Polls can have at most 10 options', 'error');
            return;
        }
        // Check for duplicates
        const optionTexts = validOptions.map((opt)=>opt.toLowerCase());
        const uniqueOptions = new Set(optionTexts);
        if (optionTexts.length !== uniqueOptions.size) {
            this.showAlert('Poll options must be unique', 'error');
            this.highlightDuplicates();
            return;
        }
        // Check option length
        for (const option of validOptions)if (option.length > 500) {
            this.showAlert('Each option must be 500 characters or less', 'error');
            return;
        }
        this.setSubmitting(true);
        this.clearAlerts();
        try {
            const postData = {
                post_type: 'poll',
                poll_question: trimmedQuestion,
                poll_options: validOptions,
                poll_type: this.pollType
            };
            if (this.selectedPrompt) postData.promptId = this.selectedPrompt.id;
            Object.assign(postData, this.closest('post-writer')?.getPostStylePayload?.() || {});
            const post = await window.API.posts.create(postData);
            // Clear the form
            this.clearPoll();
            // Dispatch event to notify parent component
            this.dispatchEvent(new CustomEvent('poll-created', {
                detail: {
                    pollPost: post
                },
                bubbles: true
            }));
            // Show success feedback
            this.showAlert("Poll created successfully! \uD83C\uDF89", 'success');
        } catch (error) {
            window.logger.error('Error creating poll:', error);
            let errorMessage = 'Failed to create poll. Please try again.';
            if (error.message) errorMessage = error.message;
            else if (error.details && Array.isArray(error.details)) errorMessage = error.details.map((d)=>d.message).join(', ');
            this.showAlert(errorMessage, 'error');
            const stylePicker = this.closest('post-writer')?.querySelector('#postStylePicker');
            if (stylePicker?.getStyle?.() && stylePicker.showError) stylePicker.showError(errorMessage);
        } finally{
            this.setSubmitting(false);
        }
    }
    setSubmitting(isSubmitting) {
        this.isSubmitting = isSubmitting;
        const createBtn = this.querySelector('#createPollBtn');
        const btnText = this.querySelector('.btn-text');
        const spinner = this.querySelector('.spinner');
        if (isSubmitting) {
            createBtn.disabled = true;
            btnText.textContent = 'Creating...';
            spinner.classList.remove('hidden');
        } else {
            createBtn.disabled = false;
            btnText.textContent = 'Create Poll';
            spinner.classList.add('hidden');
        }
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('.alert-container');
        const alert = document.createElement('div');
        alert.className = `alert alert-${type}`;
        alert.textContent = message;
        container.appendChild(alert);
        // Auto-remove after 5 seconds
        setTimeout(()=>{
            if (alert.parentNode) alert.remove();
        }, 5000);
    }
    clearAlerts() {
        const container = this.querySelector('.alert-container');
        container.innerHTML = '';
    }
    escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}
// Register the custom element
customElements.define('edit-poll', $1bb88e5b75909809$var$EditPoll);


// View Poll Web Component
// Encapsulated component for displaying polls to end users
class $876db55b69b0bf1f$var$ViewPoll extends HTMLElement {
    constructor(){
        super();
        this.pollData = null;
        this.currentUser = null;
        this.isVoting = false;
        this.isClosing = false;
    }
    static get observedAttributes() {
        return [
            'poll-data',
            'current-user'
        ];
    }
    connectedCallback() {
        const pollDataAttr = this.getAttribute('poll-data');
        const currentUserAttr = this.getAttribute('current-user');
        if (pollDataAttr) try {
            this.pollData = JSON.parse(pollDataAttr);
        } catch (error) {
            window.logger?.error('Invalid poll data in view-poll:', error);
        }
        if (currentUserAttr) try {
            this.currentUser = JSON.parse(currentUserAttr);
        } catch (error) {
            window.logger?.error('Invalid current user data in view-poll:', error);
        }
        this.render();
        this.attachEventListeners();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'poll-data' && newValue) try {
            this.pollData = JSON.parse(newValue);
            this.render();
            this.attachEventListeners();
        } catch (error) {
            window.logger?.error('Invalid poll data:', error);
        }
        else if (name === 'current-user' && newValue) try {
            this.currentUser = JSON.parse(newValue);
            this.render();
            this.attachEventListeners();
        } catch (error) {
            window.logger?.error('Invalid current user data:', error);
        }
    }
    setPollData(data) {
        this.pollData = data;
        this.render();
        this.attachEventListeners();
    }
    setCurrentUser(user) {
        this.currentUser = user;
        this.render();
        this.attachEventListeners();
    }
    render() {
        if (!this.pollData) {
            this.innerHTML = '<div class="loading">Loading poll...</div>';
            return;
        }
        const { poll_question: poll_question, poll_options: poll_options = [], poll_closed: poll_closed, poll_closed_at: poll_closed_at, poll_type: poll_type = 'single', total_votes: total_votes, user_voted: user_voted, can_see_results: can_see_results, is_owner: is_owner } = this.pollData;
        const showResults = can_see_results || poll_closed;
        const canVote = !poll_closed && !user_voted;
        const canChangeVote = !poll_closed && user_voted;
        const canClose = !poll_closed && (is_owner === true || is_owner === 1);
        // Get selected option IDs for multi-select
        const selectedOptionIds = poll_options.filter((opt)=>opt.user_voted === true).map((opt)=>opt.id);
        this.innerHTML = `
      <div class="view-poll">
        <div class="poll-header">
          <div class="poll-title-row">
            <h3 class="poll-question">${this.escapeHtml(poll_question || 'Poll')}</h3>
            <span class="poll-type-badge poll-type-${poll_type}">
              ${poll_type === 'single' ? 'Single Selection' : poll_type === 'multi' ? 'Multi-Select' : 'Toggle'}
            </span>
          </div>
          ${poll_closed ? `
            <div class="poll-status closed">
              <span class="status-icon">\u{1F512}</span>
              <span class="status-text">Poll Closed</span>
              ${poll_closed_at ? `
                <span class="closed-date">${this.formatDate(poll_closed_at)}</span>
              ` : ''}
            </div>
          ` : ''}
        </div>

        <div class="poll-options-container poll-type-${poll_type}">
          ${poll_options.map((option)=>{
            const isUserVote = option.user_voted === true;
            const userVoteState = option.user_vote_state; // 'yes', 'no', or null for toggle
            const voteCount = showResults ? option.vote_count || 0 : null;
            const yesCount = showResults && poll_type === 'toggle' ? option.yes_count || 0 : null;
            const noCount = showResults && poll_type === 'toggle' ? option.no_count || 0 : null;
            const percentage = showResults && total_votes > 0 && poll_type !== 'toggle' ? option.percentage || 0 : null;
            const isSelected = selectedOptionIds.includes(option.id);
            if (poll_type === 'multi') // Multi-select: render as checkboxes
            return `
              <div class="poll-option poll-option-multi ${isSelected ? 'selected' : ''} ${poll_closed ? 'closed' : ''}" 
                   data-option-id="${option.id}">
                <div class="option-content">
                  ${!poll_closed && (canVote || canChangeVote) ? `
                    <label class="multi-select-option">
                      <input 
                        type="checkbox" 
                        class="poll-checkbox"
                        data-option-id="${option.id}"
                        ${isSelected ? 'checked' : ''}
                        ${this.isVoting ? 'disabled' : ''}
                      />
                      <span class="option-text">${this.escapeHtml(option.option_text)}</span>
                    </label>
                  ` : `
                    <div class="option-display ${showResults ? 'has-results' : ''}">
                      <span class="option-text">${this.escapeHtml(option.option_text)}</span>
                      ${showResults ? `
                        <span class="vote-stats-inline">
                          <span class="vote-count">${voteCount} ${voteCount === 1 ? 'vote' : 'votes'}</span>
                          ${percentage !== null ? `<span class="vote-percentage">${percentage}%</span>` : ''}
                          ${isSelected ? '<span class="vote-indicator">\u2713 Your selection</span>' : ''}
                        </span>
                      ` : isSelected ? '<span class="vote-indicator">\u2713 Your selection</span>' : ''}
                    </div>
                  `}
                  
                  ${showResults ? `
                    <div class="option-results">
                      <div class="vote-bar-container">
                        <div 
                          class="vote-bar" 
                          style="width: ${percentage || 0}%"
                          role="progressbar"
                          aria-valuenow="${percentage || 0}"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  ` : ''}
                </div>
              </div>
            `;
            else if (poll_type === 'toggle') {
                // Toggle: explicit Yes / No buttons per option
                const toggleState = userVoteState || null; // 'yes', 'no', or null
                const isYes = toggleState === 'yes';
                const isNo = toggleState === 'no';
                return `
              <div class="poll-option poll-option-toggle ${poll_closed ? 'closed' : ''}" 
                   data-option-id="${option.id}">
                <div class="option-content">
                  ${!poll_closed && (canVote || canChangeVote) ? `
                    <div class="toggle-option-row">
                      <span class="option-text">${this.escapeHtml(option.option_text)}</span>
                      <div class="toggle-yes-no-buttons">
                        <button 
                          type="button" 
                          class="toggle-yes-btn ${isYes ? 'selected' : ''}"
                          data-option-id="${option.id}"
                          data-vote-state="yes"
                          ${this.isVoting ? 'disabled' : ''}
                          title="Yes"
                        >\u{2713} Yes</button>
                        <button 
                          type="button" 
                          class="toggle-no-btn ${isNo ? 'selected' : ''}"
                          data-option-id="${option.id}"
                          data-vote-state="no"
                          ${this.isVoting ? 'disabled' : ''}
                          title="No"
                        >\u{2717} No</button>
                      </div>
                    </div>
                  ` : `
                    <div class="option-display ${showResults ? 'has-results' : ''}">
                      <span class="option-text">${this.escapeHtml(option.option_text)}</span>
                      ${toggleState ? `<span class="vote-indicator vote-indicator-${toggleState}">${isYes ? "\u2713" : "\u2717"} Your ${toggleState === 'yes' ? 'yes' : 'no'}</span>` : ''}
                    </div>
                  `}
                </div>
                ${showResults ? `
                  <div class="toggle-count-row">
                    ( <span class="toggle-count-yes">${yesCount}</span> / <span class="toggle-count-no">${noCount}</span> )
                  </div>
                ` : ''}
              </div>
            `;
            } else // Single-select: render as buttons (existing behavior)
            return `
              <div class="poll-option poll-option-single ${isUserVote ? 'user-voted' : ''} ${poll_closed ? 'closed' : ''}" 
                   data-option-id="${option.id}">
                <div class="option-content">
                  ${!poll_closed && (canVote || canChangeVote) ? `
                    <button 
                      type="button" 
                      class="option-button ${isUserVote ? 'selected' : ''}"
                      data-option-id="${option.id}"
                      ${this.isVoting ? 'disabled' : ''}
                    >
                      <span class="option-text">${this.escapeHtml(option.option_text)}</span>
                      ${isUserVote ? '<span class="vote-indicator">\u2713</span>' : ''}
                    </button>
                  ` : `
                    <div class="option-display ${showResults ? 'has-results' : ''}">
                      <span class="option-text">${this.escapeHtml(option.option_text)}</span>
                      ${showResults ? `
                        <span class="vote-stats-inline">
                          <span class="vote-count">${voteCount} ${voteCount === 1 ? 'vote' : 'votes'}</span>
                          ${percentage !== null ? `<span class="vote-percentage">${percentage}%</span>` : ''}
                          ${isUserVote ? '<span class="vote-indicator">\u2713 Your vote</span>' : ''}
                        </span>
                      ` : isUserVote ? '<span class="vote-indicator">\u2713 Your vote</span>' : ''}
                    </div>
                  `}
                  
                  ${showResults ? `
                    <div class="option-results">
                      <div class="vote-bar-container">
                        <div 
                          class="vote-bar" 
                          style="width: ${percentage || 0}%"
                          role="progressbar"
                          aria-valuenow="${percentage || 0}"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  ` : ''}
                </div>
              </div>
            `;
        }).join('')}
        </div>

        ${showResults && poll_type !== 'toggle' && total_votes !== null ? `
          <div class="poll-footer">
            <div class="total-votes">
              <strong>${total_votes}</strong> ${total_votes === 1 ? 'vote' : 'total votes'}
            </div>
            ${poll_type === 'multi' && selectedOptionIds.length > 0 ? `
              <div class="selected-count">
                You selected <strong>${selectedOptionIds.length}</strong> ${selectedOptionIds.length === 1 ? 'option' : 'options'}
              </div>
            ` : ''}
          </div>
        ` : ''}

        ${canChangeVote && poll_type === 'single' ? `
          <div class="poll-note">
            <span class="note-icon">\u{1F4A1}</span>
            <span class="note-text">Click another option to change your vote</span>
          </div>
        ` : ''}
        ${poll_type === 'multi' && !poll_closed ? `
          <div class="poll-note">
            <span class="note-icon">\u{1F4A1}</span>
            <span class="note-text">Select multiple options, then click "Submit Vote"</span>
          </div>
        ` : ''}
        ${poll_type === 'multi' && selectedOptionIds.length === 0 && !poll_closed && (canVote || canChangeVote) ? `
          <div class="poll-note poll-note-warning">
            <span class="note-icon">\u{26A0}\u{FE0F}</span>
            <span class="note-text">Please select at least one option</span>
          </div>
        ` : ''}
        ${poll_type === 'toggle' && !poll_closed && (canVote || canChangeVote) ? `
          <div class="poll-note">
            <span class="note-icon">\u{1F4A1}</span>
            <span class="note-text">Click <strong>Yes</strong> or <strong>No</strong> for each option. Click the same button again to clear.</span>
          </div>
        ` : ''}

        ${canClose ? `
          <div class="poll-actions">
            <button 
              type="button" 
              class="btn btn-secondary close-poll-btn"
              ${this.isClosing ? 'disabled' : ''}
            >
              ${this.isClosing ? 'Closing...' : 'Close Poll'}
            </button>
          </div>
        ` : ''}

        <div class="alert-container"></div>
      </div>
    `;
    }
    attachEventListeners() {
        const pollType = this.pollData?.poll_type || 'single';
        if (pollType === 'multi') {
            // Multi-select: handle checkbox changes
            this.querySelectorAll('.poll-checkbox').forEach((checkbox)=>{
                checkbox.addEventListener('change', ()=>{
                    this.handleMultiSelectChange();
                });
            });
            // Add submit button for multi-select if not closed
            const canVote = !this.pollData?.poll_closed && !this.pollData?.user_voted;
            const canChangeVote = !this.pollData?.poll_closed && this.pollData?.user_voted;
            if (!this.pollData?.poll_closed && (canVote || canChangeVote)) {
                const existingSubmit = this.querySelector('.submit-multi-vote-btn');
                if (!existingSubmit) {
                    const submitBtn = document.createElement('button');
                    submitBtn.type = 'button';
                    submitBtn.className = 'btn btn-primary submit-multi-vote-btn';
                    submitBtn.textContent = 'Submit Vote';
                    submitBtn.disabled = this.isVoting;
                    submitBtn.addEventListener('click', ()=>{
                        this.submitMultiSelectVote();
                    });
                    const actionsDiv = this.querySelector('.poll-actions') || this.querySelector('.poll-footer');
                    if (actionsDiv) actionsDiv.insertBefore(submitBtn, actionsDiv.firstChild);
                    else this.querySelector('.poll-options-container').insertAdjacentElement('afterend', submitBtn);
                }
            }
        } else if (pollType === 'toggle') // Toggle: handle Yes / No button clicks
        this.querySelectorAll('.toggle-yes-btn, .toggle-no-btn').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const b = e.currentTarget;
                const optionId = parseInt(b.dataset.optionId, 10);
                const clickState = b.dataset.voteState;
                if (!optionId || !clickState) return;
                const option = this.pollData?.poll_options?.find((o)=>o.id === optionId);
                const currentState = option?.user_vote_state ?? null;
                const newState = currentState === clickState ? null : clickState;
                this.toggleOption(optionId, newState);
            });
        });
        else // Single-select: handle button clicks (existing behavior)
        this.querySelectorAll('.option-button').forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const optionId = parseInt(e.target.closest('[data-option-id]').dataset.optionId, 10);
                this.voteOnPoll(optionId);
            });
        });
        // Close poll button
        const closeBtn = this.querySelector('.close-poll-btn');
        if (closeBtn) closeBtn.addEventListener('click', ()=>{
            this.closePoll();
        });
    }
    async voteOnPoll(optionId) {
        if (this.isVoting || !this.pollData) return;
        this.isVoting = true;
        this.clearAlerts();
        this.updateVotingState(true);
        try {
            const updatedPoll = await window.API.polls.vote(this.pollData.id, optionId);
            // Update poll data
            this.pollData = updatedPoll;
            this.render();
            this.attachEventListeners();
            // Show success feedback
            this.showAlert("Vote recorded! \uD83C\uDF89", 'success');
        } catch (error) {
            window.logger.error('Error voting on poll:', error);
            let errorMessage = 'Failed to vote. Please try again.';
            if (error.message) errorMessage = error.message;
            this.showAlert(errorMessage, 'error');
        } finally{
            this.isVoting = false;
            this.updateVotingState(false);
        }
    }
    /**
   * Handle checkbox changes for multi-select polls
   * Updates UI state and validation messages
   */ handleMultiSelectChange() {
        const selectedOptionIds = this.getSelectedOptionIds();
        const submitBtn = this.querySelector('.submit-multi-vote-btn');
        // Enable/disable submit button based on selection
        if (submitBtn) submitBtn.disabled = selectedOptionIds.length === 0 || this.isVoting;
        // Update warning message visibility
        const warningNote = this.querySelector('.poll-note-warning');
        if (selectedOptionIds.length === 0 && !this.pollData?.poll_closed) warningNote;
        else if (warningNote) warningNote.remove();
    }
    /**
   * Get currently selected option IDs from checkboxes
   */ getSelectedOptionIds() {
        const checkboxes = this.querySelectorAll('.poll-checkbox:checked');
        return Array.from(checkboxes).map((cb)=>parseInt(cb.dataset.optionId, 10));
    }
    /**
   * Submit vote for multi-select poll
   */ async submitMultiSelectVote() {
        if (this.isVoting || !this.pollData) return;
        const selectedOptionIds = this.getSelectedOptionIds();
        // Validate at least one option is selected
        if (selectedOptionIds.length === 0) {
            this.showAlert('Please select at least one option', 'error');
            return;
        }
        this.isVoting = true;
        this.clearAlerts();
        this.updateVotingState(true);
        try {
            // Submit vote with array of option IDs
            const updatedPoll = await window.API.polls.vote(this.pollData.id, selectedOptionIds);
            // Update poll data
            this.pollData = updatedPoll;
            this.render();
            this.attachEventListeners();
            // Show success feedback
            this.showAlert("Vote recorded! \uD83C\uDF89", 'success');
        } catch (error) {
            window.logger.error('Error voting on multi-select poll:', error);
            let errorMessage = 'Failed to vote. Please try again.';
            if (error.message) errorMessage = error.message;
            this.showAlert(errorMessage, 'error');
        } finally{
            this.isVoting = false;
            this.updateVotingState(false);
        }
    }
    /**
   * Vote on a toggle poll: set Yes, No, or clear (null) for an option.
   * Clicking the same button again clears your vote.
   */ async toggleOption(optionId, voteState) {
        if (this.isVoting || !this.pollData) return;
        this.isVoting = true;
        this.clearAlerts();
        this.updateVotingState(true);
        try {
            const updatedPoll = await window.API.polls.vote(this.pollData.id, {
                option_id: optionId,
                vote_state: voteState
            });
            this.pollData = updatedPoll;
            this.render();
            this.attachEventListeners();
            const msg = voteState === null ? 'Vote cleared' : `Marked ${voteState === 'yes' ? 'Yes' : 'No'}! \u{1F389}`;
            this.showAlert(msg, 'success');
        } catch (error) {
            window.logger.error('Error voting on toggle poll:', error);
            const errorMessage = error?.message ?? 'Failed to vote. Please try again.';
            this.showAlert(errorMessage, 'error');
        } finally{
            this.isVoting = false;
            this.updateVotingState(false);
        }
    }
    async closePoll() {
        if (this.isClosing || !this.pollData) return;
        // Confirm before closing
        if (!confirm('Are you sure you want to close this poll? It cannot be reopened.')) return;
        this.isClosing = true;
        this.clearAlerts();
        this.updateClosingState(true);
        try {
            const updatedPoll = await window.API.polls.close(this.pollData.id);
            // Update poll data
            this.pollData = updatedPoll;
            this.render();
            this.attachEventListeners();
            // Show success feedback
            this.showAlert('Poll closed successfully', 'success');
            // Dispatch event to notify parent
            this.dispatchEvent(new CustomEvent('poll-closed', {
                detail: {
                    poll: updatedPoll
                },
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Error closing poll:', error);
            let errorMessage = 'Failed to close poll. Please try again.';
            if (error.message) errorMessage = error.message;
            this.showAlert(errorMessage, 'error');
        } finally{
            this.isClosing = false;
            this.updateClosingState(false);
        }
    }
    updateVotingState(isVoting) {
        const buttons = this.querySelectorAll('.option-button, .toggle-button, .toggle-yes-btn, .toggle-no-btn');
        buttons.forEach((btn)=>{
            btn.disabled = isVoting;
        });
        const checkboxes = this.querySelectorAll('.poll-checkbox');
        checkboxes.forEach((cb)=>{
            cb.disabled = isVoting;
        });
        const submitBtn = this.querySelector('.submit-multi-vote-btn');
        if (submitBtn) submitBtn.disabled = isVoting;
    }
    updateClosingState(isClosing) {
        const closeBtn = this.querySelector('.close-poll-btn');
        if (closeBtn) {
            closeBtn.disabled = isClosing;
            closeBtn.textContent = isClosing ? 'Closing...' : 'Close Poll';
        }
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('.alert-container');
        if (!container) return;
        const alert = document.createElement('div');
        alert.className = `alert alert-${type}`;
        alert.textContent = message;
        container.appendChild(alert);
        // Auto-remove after 5 seconds
        setTimeout(()=>{
            if (alert.parentNode) alert.remove();
        }, 5000);
    }
    clearAlerts() {
        const container = this.querySelector('.alert-container');
        if (container) container.innerHTML = '';
    }
    formatDate(dateString) {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit'
            });
        } catch (_error) {
            return dateString;
        }
    }
    escapeHtml(text) {
        if (text === null || text === undefined) return '';
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}
// Register the custom element
customElements.define('view-poll', $876db55b69b0bf1f$var$ViewPoll);


// Not Found (404) Web Component
class $57ef4e448fb3d760$var$NotFound extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.innerHTML = `
      <div class="not-found-container">
        <div class="not-found-content">
          <div class="not-found-icon">\u{1F50D}</div>
          <h1>404 - Page Not Found</h1>
          <p class="not-found-message">
            Oops! Looks like this page took a wrong turn somewhere. 
            It might have wandered off to join the circus! \u{1F3AA}
          </p>
          <div class="not-found-actions">
            <a href="/" class="btn btn-primary">\u{1F3E0} Go Home</a>
          </div>
        </div>
      </div>
    `;
    }
}
// Register the custom element
customElements.define('not-found', $57ef4e448fb3d760$var$NotFound);
var $57ef4e448fb3d760$export$2e2bcd8739ae039 = $57ef4e448fb3d760$var$NotFound;


// Notification Settings Web Component

class $2635c9bf2b92ef51$var$NotificationSettings extends HTMLElement {
    constructor(){
        super();
        this.settings = null;
        this.deliveryPreview = null;
        this.isLoading = true;
        this.isSaving = false;
        this.currentUser = null;
    }
    connectedCallback() {
        this.render();
        this.loadSettings().then(()=>{
            this.attachEventListeners();
        });
    }
    async loadSettings() {
        try {
            if (!window.API) throw new Error('API not available');
            const authData = await window.API.request('/auth/status');
            if (!authData.authenticated) throw new Error('User not authenticated');
            this.currentUser = authData.user;
            const [settingsData, feedFiltersData] = await Promise.all([
                window.API.request(`/users/settings/${this.currentUser.id}`),
                window.API.feedFilters.get(this.currentUser.id)
            ]);
            this.settings = settingsData;
            this.deliveryPreview = feedFiltersData?.deliveryPreview || null;
        } catch (error) {
            window.logger.error('Failed to load notification settings:', error);
            this.showError('Failed to load notification settings');
        } finally{
            this.isLoading = false;
            this.render();
        }
    }
    render() {
        if (this.isLoading) {
            this.innerHTML = `
        <div class="notification-settings">
          <div class="loading-state">
            <div class="spinner"></div>
            <div>Loading notification settings...</div>
          </div>
        </div>
      `;
            return;
        }
        this.innerHTML = `
      <div class="notification-settings">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDD14", 'Notification Settings')}
          <p>Choose how you want to be notified about different activities</p>
        </div>

        <div class="settings-content">
          ${this.renderNotificationGroup('Friend Requests', 'friend_request', 'When someone sends you a friend request')}
          ${this.renderNotificationGroup('Friend Accepts', 'friend_accept', 'When someone accepts your friend request')}
          ${this.renderNotificationGroup('New Posts from Friends', 'new_post', 'When a friend creates a new post', 'new_post')}
          ${this.renderNotificationGroup('Comments on My Posts', 'new_comment', 'When someone comments on your posts')}
          ${this.renderNotificationGroup('Replies to My Comments', 'new_reply', 'When someone replies to your comments')}
          ${this.renderNotificationGroup('New Posts in Groups', 'group_post', 'When someone posts in a group you belong to', 'group_post')}
          ${this.renderNotificationGroup('Comments on My Group Posts', 'group_comment', 'When someone comments on your posts in a group')}
          ${this.renderNotificationGroup('Replies to My Group Comments', 'group_reply', 'When someone replies to your comments in a group')}
        </div>

        <p class="feed-filter-note">Feed filters on your home feed also affect new-post emails. Comment notifications are not filtered yet.</p>

        <div class="settings-footer">
          <div class="save-status" id="save-status"></div>
          <button class="btn btn-secondary" id="returnToSettingsBtn">
            \u{2190} Return to Settings
          </button>
        </div>
      </div>
    `;
    }
    renderDeliveryPreview(previewKey) {
        const preview = this.deliveryPreview?.[previewKey];
        if (!preview || !preview.emailEnabled) return '';
        const categories = preview.categories || [];
        if (categories.length === 0) return '';
        return `
      <div class="delivery-preview">
        <p class="delivery-preview-title">What you&apos;ll receive:</p>
        <ul class="delivery-preview-list">
          ${categories.map((cat)=>`
            <li class="delivery-preview-item ${cat.willDeliver ? 'will-deliver' : 'blocked'}">
              <span class="delivery-preview-icon">${cat.willDeliver ? "\u2713" : "\u2717"}</span>
              <span class="delivery-preview-label">${cat.label}</span>
              ${!cat.willDeliver && cat.blockedBy === 'feed_filter' ? '<span class="delivery-preview-reason">Hidden by feed filter</span>' : ''}
            </li>
          `).join('')}
        </ul>
        <a href="/" class="delivery-preview-link" data-route="/">Edit feed filters on home feed \u{2192}</a>
      </div>
    `;
    }
    renderNotificationGroup(title, type, description, previewKey = null) {
        const emailEnabled = this.settings ? this.settings[`${type}_email`] : false;
        const smsEnabled = this.settings ? this.settings[`${type}_sms`] : false;
        return `
      <div class="notification-group">
        <div class="group-header">
          <h3>${title}</h3>
          <p class="group-description">${description}</p>
        </div>
        
        <div class="notification-options">
          <div class="option-row">
            <div class="option-info">
              <span class="option-label">\u{1F4E7} Email Notifications</span>
              <span class="option-description">Receive notifications via email</span>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" 
                     data-type="${type}_email" 
                     ${emailEnabled ? 'checked' : ''}
                     ${this.isSaving ? 'disabled' : ''}>
              <span class="toggle-slider"></span>
            </label>
          </div>

          <!--div class="option-row">
            <div class="option-info">
              <span class="option-label">\u{1F4F1} SMS Notifications</span>
              <span class="option-description">Receive notifications via text message</span>
            </div>
            <label class="toggle-switch">
              <input type="checkbox" 
                     data-type="${type}_sms" 
                     ${smsEnabled ? 'checked' : ''}
                     ${this.isSaving ? 'disabled' : ''}>
              <span class="toggle-slider"></span>
            </label>
          </div-->
        </div>
        ${previewKey ? this.renderDeliveryPreview(previewKey) : ''}
      </div>
    `;
    }
    attachEventListeners() {
        this.addEventListener('change', async (e)=>{
            if (e.target.type === 'checkbox' && e.target.dataset.type) await this.handleSettingChange(e.target);
        });
        const returnBtn = this.querySelector('#returnToSettingsBtn');
        if (returnBtn) returnBtn.addEventListener('click', ()=>{
            if (window.router) window.router.navigate('/settings');
        });
        this.querySelectorAll('.delivery-preview-link[data-route]').forEach((link)=>{
            link.addEventListener('click', (e)=>{
                e.preventDefault();
                if (window.router) window.router.navigate(link.dataset.route);
            });
        });
    }
    async handleSettingChange(checkbox) {
        if (this.isSaving) return;
        const settingType = checkbox.dataset.type;
        const isEnabled = checkbox.checked;
        try {
            this.isSaving = true;
            this.updateSaveStatus('Saving...', 'saving');
            if (this.settings) this.settings[settingType] = isEnabled;
            const updateData = {
                [settingType]: isEnabled
            };
            await window.API.request(`/users/settings/${this.currentUser.id}`, {
                method: 'PUT',
                body: JSON.stringify(updateData)
            });
            const feedFiltersData = await window.API.feedFilters.get(this.currentUser.id);
            this.deliveryPreview = feedFiltersData?.deliveryPreview || null;
            this.render();
            this.attachEventListeners();
            this.updateSaveStatus('Settings saved!', 'success');
            setTimeout(()=>{
                this.updateSaveStatus('', '');
            }, 2000);
        } catch (error) {
            window.logger.error('Failed to update notification setting:', error);
            checkbox.checked = !isEnabled;
            if (this.settings) this.settings[settingType] = !isEnabled;
            this.updateSaveStatus('Failed to save settings', 'error');
            setTimeout(()=>{
                this.updateSaveStatus('', '');
            }, 3000);
        } finally{
            this.isSaving = false;
        }
    }
    updateSaveStatus(message, type) {
        const statusElement = this.querySelector('#save-status');
        if (statusElement) {
            statusElement.textContent = message;
            statusElement.className = `save-status ${type}`;
        }
    }
    showError(message) {
        this.innerHTML = `
      <div class="notification-settings">
        <div class="error-state">
          <div class="error-icon">\u{26A0}\u{FE0F}</div>
          <h3>Error Loading Settings</h3>
          <p>${message}</p>
          <button class="retry-button" onclick="this.parentElement.parentElement.loadSettings()">
            Try Again
          </button>
        </div>
      </div>
    `;
    }
}
customElements.define('notification-settings', $2635c9bf2b92ef51$var$NotificationSettings);


// OAuth2 Authorization Page Component

class $6f6ce23de7a99ca5$var$OAuthAuthorize extends HTMLElement {
    constructor(){
        super();
        this.clientInfo = null;
        this.scopes = [];
    }
    connectedCallback() {
        this.loadAuthorizationRequest();
    }
    async loadAuthorizationRequest() {
        try {
            // Get authorization request from session (set by backend)
            const response = await fetch('/api/oauth2/authorize/request', {
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Failed to load authorization request');
            const data = await response.json();
            this.clientInfo = data.client;
            this.scopes = data.scopes;
            this.render();
        } catch (error) {
            window.logger?.error('Error loading authorization request:', error);
            this.renderError();
        }
    }
    render() {
        if (!this.clientInfo) return;
        this.innerHTML = `
      <div class="oauth-authorize-container">
        <div class="oauth-authorize-card">
          <div class="oauth-authorize-header">
            <h1>Authorize Application</h1>
            <p class="oauth-authorize-subtitle">An application wants to access your Fun Old Times account</p>
          </div>

          <div class="oauth-authorize-client">
            <div class="oauth-authorize-client-info">
              <h2>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.clientInfo.name)}</h2>
              <p class="oauth-authorize-client-id">Client ID: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.clientInfo.client_id)}</p>
            </div>
          </div>

          <div class="oauth-authorize-scopes">
            <h3>This application will be able to:</h3>
            ${this.scopes && this.scopes.length > 0 ? `
              <ul class="oauth-authorize-scope-list">
                ${this.scopes.map((scope)=>this.renderScope(scope)).join('')}
              </ul>
            ` : `
              <p class="oauth-authorize-no-scopes">No specific permissions requested.</p>
            `}
          </div>

          <div class="oauth-authorize-actions">
            <button class="oauth-authorize-btn oauth-authorize-btn-deny" id="deny-btn">
              Deny
            </button>
            <button class="oauth-authorize-btn oauth-authorize-btn-approve" id="approve-btn">
              Authorize
            </button>
          </div>
        </div>
      </div>
    `;
        // Attach event listeners after rendering
        const approveBtn = this.querySelector('#approve-btn');
        const denyBtn = this.querySelector('#deny-btn');
        if (approveBtn) approveBtn.addEventListener('click', ()=>this.handleApprove());
        if (denyBtn) denyBtn.addEventListener('click', ()=>this.handleDeny());
    }
    renderScope(scope) {
        const scopeDescriptions = {
            'profile': 'View your profile information (username)',
            'email': 'View your email address',
            'read': 'Read your data',
            'write': 'Modify your data'
        };
        return `
      <li class="oauth-authorize-scope-item">
        <span class="oauth-authorize-scope-icon">\u{2713}</span>
        <span class="oauth-authorize-scope-text">${scopeDescriptions[scope] || scope}</span>
      </li>
    `;
    }
    renderError() {
        this.innerHTML = `
      <div class="oauth-authorize-container">
        <div class="oauth-authorize-card">
          <div class="oauth-authorize-error">
            <h2>Error</h2>
            <p>Unable to load authorization request. Please try again.</p>
            <button class="oauth-authorize-btn" onclick="window.location.href='/'">Go Home</button>
          </div>
        </div>
      </div>
    `;
    }
    async handleApprove() {
        try {
            // Submit form to trigger redirect
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/oauth2/authorize/approve';
            document.body.appendChild(form);
            form.submit();
        } catch (error) {
            window.logger?.error('Error approving authorization:', error);
            alert('An error occurred while approving the authorization. Please try again.');
        }
    }
    async handleDeny() {
        try {
            // Submit form to trigger redirect
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = '/api/oauth2/authorize/deny';
            document.body.appendChild(form);
            form.submit();
        } catch (error) {
            window.logger?.error('Error denying authorization:', error);
            alert('An error occurred while denying the authorization. Please try again.');
        }
    }
}
customElements.define('oauth-authorize', $6f6ce23de7a99ca5$var$OAuthAuthorize);


// OAuth Clients Management Web Component


class $7ae1958736141e9a$var$OAuthClients extends HTMLElement {
    constructor(){
        super();
        this.clients = [];
        this.isLoadingClients = false;
        this.showAddForm = false;
        this.editingClient = null;
        this.newClient = {
            name: '',
            redirect_uris: [
                ''
            ],
            scopes: [
                'profile',
                'email'
            ]
        };
        this.actionHandler = null;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.loadClients();
    }
    disconnectedCallback() {
        if (this.actionHandler) this.removeEventListener('click', this.actionHandler);
    }
    render() {
        this.innerHTML = `
      <div class="oauth-clients">
        <div class="clients-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDD10", 'OAuth Clients')}
          <p>Manage OAuth2 client applications for SSO integration</p>
        </div>

        <div class="clients-actions">
          <button class="btn btn-primary" id="addClientBtn">
            + Create OAuth Client
          </button>
        </div>

        ${this.renderAddForm()}
        ${this.renderEditForm()}

        <div class="clients-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        this.actionHandler = (e)=>{
            // Use closest() to handle clicks on child elements (like text nodes inside buttons)
            // For ID selector, check if target is the element or find it via closest
            const clickedElement = e.target.nodeType === Node.TEXT_NODE ? e.target.parentElement : e.target;
            const addBtn = clickedElement?.id === 'addClientBtn' || clickedElement?.closest('#addClientBtn');
            const editBtn = clickedElement?.closest('.btn-edit');
            const deleteBtn = clickedElement?.closest('.btn-delete');
            const copySecretBtn = clickedElement?.closest('.btn-copy-secret');
            const addUriBtn = clickedElement?.closest('.btn-add-uri');
            const removeUriBtn = clickedElement?.closest('.btn-remove-uri');
            const saveBtn = clickedElement?.closest('.btn-save');
            const cancelBtn = clickedElement?.closest('.btn-cancel');
            if (addBtn) {
                this.showAddForm = !this.showAddForm;
                this.editingClient = null;
                this.render();
            } else if (editBtn) {
                const clientId = parseInt(editBtn.dataset.clientId);
                this.editClient(clientId);
            } else if (deleteBtn) {
                const clientId = parseInt(deleteBtn.dataset.clientId);
                this.deleteClient(clientId);
            } else if (copySecretBtn) {
                const secret = copySecretBtn.dataset.secret;
                this.copyToClipboard(secret);
            } else if (addUriBtn) this.addRedirectUri();
            else if (removeUriBtn) {
                const index = parseInt(removeUriBtn.dataset.index);
                this.removeRedirectUri(index);
            } else if (saveBtn) {
                if (this.editingClient) this.updateClient();
                else this.createClient();
            } else if (cancelBtn) this.cancelForm();
        };
        // Attach to the component itself so it persists across re-renders
        // Remove any existing listener first to avoid duplicates
        this.removeEventListener('click', this.actionHandler);
        this.addEventListener('click', this.actionHandler);
        // Handle form inputs
        const nameInput = this.querySelector('#clientName');
        if (nameInput) nameInput.addEventListener('input', (e)=>{
            if (this.editingClient) this.editingClient.name = e.target.value;
            else this.newClient.name = e.target.value;
        });
        // Handle redirect URI inputs
        this.querySelectorAll('.redirect-uri-input').forEach((input, index)=>{
            input.addEventListener('input', (e)=>{
                if (this.editingClient) this.editingClient.redirect_uris[index] = e.target.value;
                else this.newClient.redirect_uris[index] = e.target.value;
            });
        });
        // Handle scope checkboxes
        this.querySelectorAll('.scope-checkbox').forEach((checkbox)=>{
            checkbox.addEventListener('change', (e)=>{
                const scope = e.target.value;
                const checked = e.target.checked;
                if (this.editingClient) {
                    if (checked && !this.editingClient.scopes.includes(scope)) this.editingClient.scopes.push(scope);
                    else if (!checked) this.editingClient.scopes = this.editingClient.scopes.filter((s)=>s !== scope);
                } else {
                    if (checked && !this.newClient.scopes.includes(scope)) this.newClient.scopes.push(scope);
                    else if (!checked) this.newClient.scopes = this.newClient.scopes.filter((s)=>s !== scope);
                }
            });
        });
    }
    renderContent() {
        if (this.isLoadingClients) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading OAuth clients...</p>
        </div>
      `;
        if (this.clients.length === 0) return `
        <div class="empty-state">
          <div class="empty-icon">\u{1F510}</div>
          <h3>No OAuth Clients</h3>
          <p>Create your first OAuth client to enable SSO integration</p>
        </div>
      `;
        return `
      <div class="clients-list">
        ${this.clients.map((client)=>this.renderClient(client)).join('')}
      </div>
    `;
    }
    renderClient(client) {
        const isRevoked = client.revoked;
        const createdDate = new Date(client.created_at).toLocaleDateString();
        return `
      <div class="client-card ${isRevoked ? 'revoked' : ''}">
        <div class="client-header">
          <div class="client-info">
            <h3>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(client.name)}</h3>
            <p class="client-id">Client ID: <code>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(client.client_id)}</code></p>
            <p class="client-meta">Created: ${createdDate}</p>
            ${isRevoked ? '<span class="revoked-badge">Revoked</span>' : ''}
          </div>
          <div class="client-actions">
            ${!isRevoked ? `
              <button class="btn btn-secondary btn-edit" data-client-id="${client.id}">
                Edit
              </button>
            ` : ''}
            <button class="btn btn-danger btn-delete" data-client-id="${client.id}">
              ${isRevoked ? 'Delete' : 'Revoke'}
            </button>
          </div>
        </div>
        <div class="client-details">
          <div class="detail-group">
            <label>Redirect URIs:</label>
            <ul class="uri-list">
              ${client.redirect_uris.map((uri)=>`
                <li><code>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(uri)}</code></li>
              `).join('')}
            </ul>
          </div>
          <div class="detail-group">
            <label>Scopes:</label>
            <div class="scopes-list">
              ${client.scopes.map((scope)=>`
                <span class="scope-badge">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(scope)}</span>
              `).join('')}
            </div>
          </div>
        </div>
      </div>
    `;
    }
    renderAddForm() {
        if (!this.showAddForm || this.editingClient) return '';
        return `
      <div class="add-form">
        <h3>Create New OAuth Client</h3>
        <form id="addClientForm">
          <div class="form-group">
            <label for="clientName">Client Name *</label>
            <input 
              type="text" 
              id="clientName" 
              class="form-input" 
              placeholder="e.g., FreeScout"
              value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.newClient.name)}"
              required
            />
          </div>

          <div class="form-group">
            <label>Redirect URIs *</label>
            <div id="redirectUrisContainer">
              ${this.newClient.redirect_uris.map((uri, index)=>`
                <div class="uri-input-group">
                  <input 
                    type="url" 
                    class="form-input redirect-uri-input" 
                    placeholder="https://example.com/callback"
                    value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(uri)}"
                    required
                  />
                  ${this.newClient.redirect_uris.length > 1 ? `
                    <button type="button" class="btn btn-danger btn-remove-uri" data-index="${index}">
                      Remove
                    </button>
                  ` : ''}
                </div>
              `).join('')}
            </div>
            <button type="button" class="btn btn-secondary btn-add-uri">
              + Add Redirect URI
            </button>
          </div>

          <div class="form-group">
            <label>Scopes</label>
            <div class="scopes-checkboxes">
              ${[
            'profile',
            'email',
            'read',
            'write'
        ].map((scope)=>`
                <label class="checkbox-label">
                  <input 
                    type="checkbox" 
                    class="scope-checkbox" 
                    value="${scope}"
                    ${this.newClient.scopes.includes(scope) ? 'checked' : ''}
                  />
                  <span>${scope}</span>
                </label>
              `).join('')}
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-primary btn-save">Create Client</button>
            <button type="button" class="btn btn-secondary btn-cancel">Cancel</button>
          </div>
        </form>
      </div>
    `;
    }
    renderEditForm() {
        if (!this.editingClient) return '';
        return `
      <div class="edit-form">
        <h3>Edit OAuth Client</h3>
        <form id="editClientForm">
          <div class="form-group">
            <label>Client ID</label>
            <input 
              type="text" 
              class="form-input" 
              value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.editingClient.client_id)}"
              disabled
            />
            <p class="form-help">Client ID cannot be changed</p>
          </div>

          <div class="form-group">
            <label for="editClientName">Client Name *</label>
            <input 
              type="text" 
              id="editClientName" 
              class="form-input" 
              value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.editingClient.name)}"
              required
            />
          </div>

          <div class="form-group">
            <label>Redirect URIs *</label>
            <div id="editRedirectUrisContainer">
              ${this.editingClient.redirect_uris.map((uri, index)=>`
                <div class="uri-input-group">
                  <input 
                    type="url" 
                    class="form-input redirect-uri-input" 
                    placeholder="https://example.com/callback"
                    value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(uri)}"
                    required
                  />
                  ${this.editingClient.redirect_uris.length > 1 ? `
                    <button type="button" class="btn btn-danger btn-remove-uri" data-index="${index}">
                      Remove
                    </button>
                  ` : ''}
                </div>
              `).join('')}
            </div>
            <button type="button" class="btn btn-secondary btn-add-uri">
              + Add Redirect URI
            </button>
          </div>

          <div class="form-group">
            <label>Scopes</label>
            <div class="scopes-checkboxes">
              ${[
            'profile',
            'email',
            'read',
            'write'
        ].map((scope)=>`
                <label class="checkbox-label">
                  <input 
                    type="checkbox" 
                    class="scope-checkbox" 
                    value="${scope}"
                    ${this.editingClient.scopes.includes(scope) ? 'checked' : ''}
                  />
                  <span>${scope}</span>
                </label>
              `).join('')}
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-primary btn-save">Save Changes</button>
            <button type="button" class="btn btn-secondary btn-cancel">Cancel</button>
          </div>
        </form>
      </div>
    `;
    }
    async loadClients() {
        if (this.isLoadingClients) return;
        this.isLoadingClients = true;
        this.render();
        try {
            const response = await fetch('/api/admin/oauth-clients', {
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Failed to load OAuth clients');
            const data = await response.json();
            this.clients = data.clients || [];
        } catch (error) {
            window.logger?.error('Error loading OAuth clients:', error);
            this.clients = [];
        } finally{
            this.isLoadingClients = false;
            this.render();
        }
    }
    async createClient() {
        // Read values directly from the DOM instead of relying on event listeners
        const nameInput = this.querySelector('#clientName');
        const name = nameInput ? nameInput.value.trim() : this.newClient.name.trim();
        // Read redirect URIs from all input fields
        const redirectUriInputs = this.querySelectorAll('.redirect-uri-input');
        const redirectUris = Array.from(redirectUriInputs).map((input)=>input.value.trim()).filter((uri)=>uri.length > 0);
        if (!name || redirectUris.length === 0) {
            alert('Please fill in all required fields');
            return;
        }
        // Read scopes from checkboxes
        const scopeCheckboxes = this.querySelectorAll('.scope-checkbox');
        const scopes = Array.from(scopeCheckboxes).filter((checkbox)=>checkbox.checked).map((checkbox)=>checkbox.value);
        try {
            const response = await fetch('/api/admin/oauth-clients', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    name: name,
                    redirect_uris: redirectUris,
                    scopes: scopes
                })
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Failed to create OAuth client');
            }
            const client = await response.json();
            // Show client secret in a modal/alert (only shown once)
            const secretMessage = `OAuth Client created successfully!\n\nClient ID: ${client.client_id}\nClient Secret: ${client.client_secret}

\u{26A0}\u{FE0F} IMPORTANT: Save this client secret now. It will not be shown again!`;
            alert(secretMessage);
            // Reset form
            this.showAddForm = false;
            this.newClient = {
                name: '',
                redirect_uris: [
                    ''
                ],
                scopes: [
                    'profile',
                    'email'
                ]
            };
            // Reload clients
            await this.loadClients();
        } catch (error) {
            window.logger?.error('Error creating OAuth client:', error);
            alert(`Error: ${error.message}`);
        }
    }
    editClient(clientId) {
        const client = this.clients.find((c)=>c.id === clientId);
        if (!client) return;
        this.editingClient = {
            id: client.id,
            client_id: client.client_id,
            name: client.name,
            redirect_uris: [
                ...client.redirect_uris
            ],
            scopes: [
                ...client.scopes
            ]
        };
        this.showAddForm = false;
        this.render();
    }
    async updateClient() {
        // Read values directly from the DOM instead of relying on event listeners
        // This ensures we get the current form values even after re-renders
        const nameInput = this.querySelector('#editClientName');
        const name = nameInput ? nameInput.value.trim() : this.editingClient.name.trim();
        // Read redirect URIs from all input fields
        const redirectUriInputs = this.querySelectorAll('.redirect-uri-input');
        const redirectUris = Array.from(redirectUriInputs).map((input)=>input.value.trim()).filter((uri)=>uri.length > 0);
        if (!name || redirectUris.length === 0) {
            alert('Please fill in all required fields');
            return;
        }
        // Read scopes from checkboxes
        const scopeCheckboxes = this.querySelectorAll('.scope-checkbox');
        const scopes = Array.from(scopeCheckboxes).filter((checkbox)=>checkbox.checked).map((checkbox)=>checkbox.value);
        try {
            const response = await fetch(`/api/admin/oauth-clients/${this.editingClient.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({
                    name: name,
                    redirect_uris: redirectUris,
                    scopes: scopes
                })
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Failed to update OAuth client');
            }
            // Reset form
            this.editingClient = null;
            this.showAddForm = false;
            // Reload clients
            await this.loadClients();
        } catch (error) {
            window.logger?.error('Error updating OAuth client:', error);
            alert(`Error: ${error.message}`);
        }
    }
    async deleteClient(clientId) {
        const client = this.clients.find((c)=>c.id === clientId);
        if (!client) return;
        const action = client.revoked ? 'permanently delete' : 'revoke';
        if (!confirm(`Are you sure you want to ${action} "${client.name}"?`)) return;
        try {
            const response = await fetch(`/api/admin/oauth-clients/${clientId}`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (!response.ok) {
                const error = await response.json();
                throw new Error(error.message || 'Failed to delete OAuth client');
            }
            // Reload clients
            await this.loadClients();
        } catch (error) {
            window.logger?.error('Error deleting OAuth client:', error);
            alert(`Error: ${error.message}`);
        }
    }
    addRedirectUri() {
        // Read current form values from DOM before re-rendering
        this.syncFormDataFromDOM();
        if (this.editingClient) this.editingClient.redirect_uris.push('');
        else this.newClient.redirect_uris.push('');
        this.render();
    }
    removeRedirectUri(index) {
        // Read current form values from DOM before re-rendering
        this.syncFormDataFromDOM();
        if (this.editingClient) this.editingClient.redirect_uris.splice(index, 1);
        else this.newClient.redirect_uris.splice(index, 1);
        this.render();
    }
    syncFormDataFromDOM() {
        // Sync form data from DOM to component state before re-rendering
        if (this.editingClient) {
            // Sync edit form
            const nameInput = this.querySelector('#editClientName');
            if (nameInput) this.editingClient.name = nameInput.value;
            const redirectUriInputs = this.querySelectorAll('.redirect-uri-input');
            this.editingClient.redirect_uris = Array.from(redirectUriInputs).map((input)=>input.value.trim());
            const scopeCheckboxes = this.querySelectorAll('.scope-checkbox');
            this.editingClient.scopes = Array.from(scopeCheckboxes).filter((checkbox)=>checkbox.checked).map((checkbox)=>checkbox.value);
        } else if (this.showAddForm) {
            // Sync add form
            const nameInput = this.querySelector('#clientName');
            if (nameInput) this.newClient.name = nameInput.value;
            const redirectUriInputs = this.querySelectorAll('.redirect-uri-input');
            this.newClient.redirect_uris = Array.from(redirectUriInputs).map((input)=>input.value.trim());
            const scopeCheckboxes = this.querySelectorAll('.scope-checkbox');
            this.newClient.scopes = Array.from(scopeCheckboxes).filter((checkbox)=>checkbox.checked).map((checkbox)=>checkbox.value);
        }
    }
    cancelForm() {
        this.showAddForm = false;
        this.editingClient = null;
        this.newClient = {
            name: '',
            redirect_uris: [
                ''
            ],
            scopes: [
                'profile',
                'email'
            ]
        };
        this.render();
    }
    copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(()=>{
            alert('Copied to clipboard!');
        }).catch((err)=>{
            window.logger?.error('Failed to copy to clipboard:', err);
        });
    }
}
customElements.define('oauth-clients', $7ae1958736141e9a$var$OAuthClients);


// Photocopy Machine Icon Web Component
class $f06993ca9c727ef8$var$PhotocopyIcon extends HTMLElement {
    constructor(){
        super();
        this.size = 'medium';
        this.interactive = 'true';
    }
    static get observedAttributes() {
        return [
            'size',
            'interactive'
        ];
    }
    connectedCallback() {
        this.render();
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this[name] = newValue;
            if (this.isConnected) this.render();
        }
    }
    render() {
        const isInteractive = this.interactive === 'true';
        const sizeClass = `photocopy-${this.size}`;
        this.innerHTML = `
      <div class="photocopy-icon ${sizeClass} ${isInteractive ? 'interactive' : ''}">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Photocopy machine body -->
          <rect x="3" y="8" width="18" height="12" rx="2" fill="currentColor" opacity="0.8"/>
          
          <!-- Paper input tray -->
          <rect x="5" y="6" width="14" height="2" rx="1" fill="currentColor" opacity="0.6"/>
          
          <!-- Control panel -->
          <rect x="6" y="10" width="4" height="2" rx="1" fill="currentColor" opacity="0.4"/>
          
          <!-- Paper output -->
          <rect x="4" y="20" width="16" height="1" rx="0.5" fill="currentColor" opacity="0.6"/>
          
          <!-- Copy indicator -->
          <circle cx="16" cy="11" r="1" fill="currentColor" opacity="0.9"/>
          
          <!-- Paper being copied -->
          <rect x="8" y="4" width="8" height="6" rx="1" fill="none" stroke="currentColor" stroke-width="1" opacity="0.7"/>
          <rect x="9" y="5" width="6" height="1" fill="currentColor" opacity="0.5"/>
          <rect x="9" y="6.5" width="4" height="1" fill="currentColor" opacity="0.5"/>
          <rect x="9" y="8" width="5" height="1" fill="currentColor" opacity="0.5"/>
        </svg>
      </div>
    `;
    }
    // Public method to trigger copy animation
    triggerCopyAnimation() {
        this.classList.add('copying');
        setTimeout(()=>{
            this.classList.remove('copying');
        }, 600);
    }
    // Public method to set disabled state
    setDisabled(disabled) {
        if (disabled) this.classList.add('disabled');
        else this.classList.remove('disabled');
    }
}
// Register the component
customElements.define('photocopy-icon', $f06993ca9c727ef8$var$PhotocopyIcon);
var $f06993ca9c727ef8$export$2e2bcd8739ae039 = $f06993ca9c727ef8$var$PhotocopyIcon;


/*
  component: post-detail
  title: Post Detail Web Component - for viewing individual posts
  methods:
    - setCurrentUser: set the current user
  deps:
    - post-item
*/ class $b1468dbc0c800b44$var$PostDetail extends HTMLElement {
    constructor(){
        super();
        this.postId = null;
        this.post = null;
        this.isLoading = true;
        this.error = null;
        this._currentUser = null;
    }
    connectedCallback() {
        this.render();
        this.loadPost();
        this.attachEventListeners();
    }
    setCurrentUser(data) {
        this._currentUser = data;
    }
    static get observedAttributes() {
        return [
            'post-id'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'post-id' && newValue !== oldValue) {
            this.postId = newValue;
            this.loadPost();
        }
    }
    render() {
        this.innerHTML = `
      <div class="post-detail">
        <div class="post-detail-header">
          <button class="btn btn-outline back-btn" id="backBtn">
            \u{2190} Back to Feed
          </button>
          <h2>Post Details</h2>
        </div>

        <div class="post-detail-content">
        </div>        
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading post...</p>
        </div>
      `;
        return '<post-item></post-item>';
    }
    attachEventListeners() {
        // Back button
        const backBtn = this.querySelector('#backBtn');
        backBtn?.addEventListener('click', (e)=>{
            e.preventDefault(); // Prevent any default behavior
            // Always go to main feed, not browser back
            if (window.router) window.router.navigate('/');
            else // Fallback to direct navigation
            window.location.href = '/';
        });
    }
    async loadPost() {
        if (!this.postId) return;
        this.isLoading = true;
        this.error = null;
        await this.updateContent();
        try {
            const response = await window.API.request(`/posts/${this.postId}`);
            this.post = response;
            this.error = null;
        } catch (error) {
            window.logger.error('Failed to load post:', error);
            this.post = null;
            if (error.status === 404) this.error = 'This post doesn\'t exist or you don\'t have permission to view it.';
            else this.error = 'Failed to load the post. Please try again.';
        } finally{
            this.isLoading = false;
            await this.updateContent();
        }
    }
    async updateContent() {
        const contentContainer = this.querySelector('.post-detail-content');
        if (contentContainer) {
            contentContainer.innerHTML = this.renderContent();
            const postItem = contentContainer.querySelector('post-item');
            if (!postItem) return;
            if (typeof postItem.setCurrentUser === 'function') {
                window.logger.debug('Setting currentUser on post-item');
                postItem.setCurrentUser(this._currentUser);
            } else window.logger.warn('post-item does not have setCurrentUser method');
            postItem.postData = this.post;
            postItem.expandComments = true;
        }
    }
    copyPermalink() {
        const permalinkUrl = `${window.location.origin}/post/${this.postId}`;
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(permalinkUrl).then(()=>{
            this.showSuccess('Permalink copied to clipboard!');
        }).catch(()=>{
            this.fallbackCopyToClipboard(permalinkUrl);
        });
        else this.fallbackCopyToClipboard(permalinkUrl);
    }
    fallbackCopyToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand('copy');
            this.showSuccess('Permalink copied to clipboard!');
        } catch (err) {
            window.logger.error('Failed to copy permalink.', err);
            this.showError('Failed to copy permalink. Please copy manually: ' + text);
        }
        document.body.removeChild(textArea);
    }
    editPost() {
        this.handleEdit();
    }
    async reportPost() {
        const postId = this.postId || this.post?.id;
        if (!postId) {
            window.logger.error('Cannot report post: no post ID');
            return;
        }
        // Show report modal
        const reason = prompt('Why are you reporting this post?\n\nPlease provide a brief reason (e.g., "Inappropriate content", "Spam", "Harassment", etc.):');
        if (!reason || reason.trim().length === 0) return; // User cancelled or didn't provide reason
        const description = prompt('Additional details (optional):\n\nProvide any additional context that might help us understand the issue:') || '';
        try {
            const response = await window.API.request('/support/flag-post', {
                method: 'POST',
                body: JSON.stringify({
                    post_id: postId,
                    reason: reason.trim(),
                    description: description.trim()
                })
            });
            this.showSuccess('Thank you for reporting this post. Our team will review it shortly.');
            // Optionally open the safety armadillo to show the created ticket
            const safetyArmadillo = document.querySelector('safety-armadillo');
            if (safetyArmadillo && response.ticket) {
                safetyArmadillo.open();
                setTimeout(()=>{
                    safetyArmadillo.viewTicket(response.ticket.id || response.ticket.conversation_id);
                }, 500);
            }
        } catch (error) {
            window.logger.error('Failed to report post:', error);
            this.showError(`Failed to report post: ${error.message || 'Please try again later.'}`);
        }
    }
    formatTimeAgo(date) {
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return 'Just now';
        else if (diffInSeconds < 3600) {
            const minutes = Math.floor(diffInSeconds / 60);
            return `${minutes}m ago`;
        } else if (diffInSeconds < 86400) {
            const hours = Math.floor(diffInSeconds / 3600);
            return `${hours}h ago`;
        } else if (diffInSeconds < 2592000) {
            const days = Math.floor(diffInSeconds / 86400);
            return `${days}d ago`;
        } else return date.toLocaleDateString();
    }
    showSuccess(message) {
        const successDiv = document.createElement('div');
        successDiv.className = 'alert alert-success';
        successDiv.textContent = message;
        successDiv.style.position = 'fixed';
        successDiv.style.top = '20px';
        successDiv.style.right = '20px';
        successDiv.style.zIndex = '10000';
        successDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(successDiv);
        setTimeout(()=>successDiv.remove(), 4000);
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10000';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
}
// Register the custom element
customElements.define('post-detail', $b1468dbc0c800b44$var$PostDetail);


/*
  component: post-item
  title: Post Item Web Component
  props:
    - postData: set the post data
  methods:
    - setCurrentUser: set the current user
  deps:
    - washing-machine-icon
    - photocopy-icon
    - comments-section
    - markdown-preview
    - music-player
*/ // Image gating utility: converts images marked as gated into a click-to-view UI.
// This is a frontend-only hook; a future integration can mark images as gated by
// setting data-gated="true" or by populating window.GATED_IMAGE_URLS (Set or array).
function $743d35dd0c1060e8$export$9bee0fd82991ea89(rootElement = document) {
    try {
        // Collect images rendered by markdown with data-image-url
        const images = rootElement.querySelectorAll('img.user-image[data-image-url]');
        const gatedSet = $743d35dd0c1060e8$var$normalizeGatedSet(window.GATED_IMAGE_URLS);
        images.forEach((img)=>{
            const url = img.getAttribute('data-image-url') || '';
            const explicitlyGated = img.getAttribute('data-gated') === 'true';
            const shouldGate = explicitlyGated || gatedSet && gatedSet.has(url);
            if (!shouldGate) return;
            // Skip if already wrapped
            if (img.closest('.gated-image')) return;
            const wrapper = document.createElement('div');
            wrapper.className = 'gated-image';
            wrapper.style.display = 'inline-block';
            wrapper.style.maxWidth = img.style.maxWidth || '100%';
            const gate = document.createElement('div');
            gate.className = 'gated-image-placeholder';
            gate.style.cursor = 'pointer';
            gate.style.color = 'var(--text-muted)';
            gate.style.fontStyle = 'italic';
            gate.style.padding = '8px 0';
            gate.textContent = '[Image has been flagged by another user. Click to view]';
            // Hide actual image initially
            img.style.display = 'none';
            gate.addEventListener('click', ()=>{
                gate.remove();
                img.style.display = '';
            });
            // Insert wrapper
            const parent = img.closest('.user-image-container');
            const imageLink = img.closest('a');
            parent.insertBefore(wrapper, imageLink);
            wrapper.appendChild(gate);
            wrapper.appendChild(imageLink);
        });
    } catch (_e) {
    // Best-effort; ignore failures to avoid breaking rendering
    }
}
async function $743d35dd0c1060e8$export$8bcad1a717b3183a(rootElement = document) {
    try {
        const imgs = Array.from(rootElement.querySelectorAll('img.user-image[data-image-url]'));
        if (imgs.length === 0) return;
        const urls = Array.from(new Set(imgs.map((img)=>img.getAttribute('data-image-url')).filter(Boolean)));
        if (urls.length === 0) return;
        const query = encodeURIComponent(urls.join(','));
        let results = [];
        try {
            const response = await window.API.request(`/images/status?urls=${query}`, {
                silent: true
            });
            results = response?.results || [];
        } catch (_error) {
            // Best-effort: skip when endpoint unavailable (503 during deploy, etc.)
            return;
        }
        const gated = new Set();
        const hidden = new Map(); // Map URL to hideReason
        for (const r of results){
            if (r.hidden) hidden.set(r.url, r.hideReason || 'pending_review');
            else if (r.gated) gated.add(r.url);
        }
        // Hide fully hidden images
        imgs.forEach((img)=>{
            const url = img.getAttribute('data-image-url');
            if (hidden.has(url)) {
                const hideReason = hidden.get(url);
                const placeholder = document.createElement('span');
                placeholder.className = 'image-blocked';
                placeholder.style.color = 'var(--text-muted)';
                placeholder.style.fontStyle = 'italic';
                // Set message based on reason
                if (hideReason === 'rejected') placeholder.textContent = '[Image blocked by admins]';
                else if (hideReason === 'blocked_domain') placeholder.textContent = '[Image from blocked domain]';
                else placeholder.textContent = '[Image under review]';
                img.replaceWith(placeholder);
            } else if (gated.has(url)) img.setAttribute('data-gated', 'true');
        });
        // Apply gating wrappers after attributes are set
        $743d35dd0c1060e8$export$9bee0fd82991ea89(rootElement);
        // Attach flagging UI on visible images
        $743d35dd0c1060e8$export$93da74f5b33a409e(rootElement);
    } catch (_e) {
    // No-op on failure
    }
}
function $743d35dd0c1060e8$export$93da74f5b33a409e(rootElement = document) {
    try {
        const images = rootElement.querySelectorAll('img.user-image[data-image-url]');
        images.forEach((img)=>{
            if (img.nextElementSibling && img.nextElementSibling.classList?.contains('flag-image-btn')) return;
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'flag-image-btn';
            btn.textContent = "\uD83D\uDEA9 Flag image";
            btn.style.margin = '0.25rem 0';
            btn.style.display = 'inline-block';
            btn.style.fontSize = '0.75rem';
            btn.style.background = 'transparent';
            btn.style.border = '1px solid var(--border-color)';
            btn.style.borderRadius = '4px';
            btn.style.color = 'var(--text-secondary)';
            btn.style.cursor = 'pointer';
            btn.style.width = '100%';
            btn.style.height = '100%';
            btn.addEventListener('click', async (evt)=>{
                try {
                    evt.stopImmediatePropagation();
                    const reason = await $743d35dd0c1060e8$var$promptForReason();
                    if (!reason) return;
                    const imageUrl = img.getAttribute('data-image-url');
                    const postId = $743d35dd0c1060e8$var$findNearestPostId(img);
                    const commentId = $743d35dd0c1060e8$var$findNearestCommentId(img);
                    // Build request body, only including IDs if they're valid numbers
                    const body = {
                        image_url: imageUrl,
                        reason: reason
                    };
                    if (postId && !isNaN(Number(postId))) body.post_id = Number(postId);
                    if (commentId && !isNaN(Number(commentId))) body.comment_id = Number(commentId);
                    await window.API.request('/images/flag', {
                        method: 'POST',
                        body: JSON.stringify(body)
                    });
                    img.setAttribute('data-gated', 'true');
                    // If image is already in a gated wrapper, re-show the placeholder
                    const existingWrapper = img.closest('.gated-image');
                    if (existingWrapper) {
                        // Check if placeholder already exists
                        let placeholder = existingWrapper.querySelector('.gated-image-placeholder');
                        if (!placeholder) {
                            // Create and show placeholder
                            placeholder = document.createElement('div');
                            placeholder.className = 'gated-image-placeholder';
                            placeholder.style.cursor = 'pointer';
                            placeholder.style.color = 'var(--text-muted)';
                            placeholder.style.fontStyle = 'italic';
                            placeholder.style.padding = '8px 0';
                            placeholder.textContent = '[Image has been flagged by another user. Click to view]';
                            placeholder.addEventListener('click', ()=>{
                                placeholder.remove();
                                img.style.display = '';
                            });
                            existingWrapper.insertBefore(placeholder, img);
                        }
                        // Hide the image
                        img.style.display = 'none';
                    } else // Not wrapped yet, apply gating normally
                    $743d35dd0c1060e8$export$9bee0fd82991ea89(rootElement);
                    $743d35dd0c1060e8$var$showToast('Thanks for your report. This image will be reviewed.');
                } catch (_e) {
                    $743d35dd0c1060e8$var$showToast('Failed to submit flag. Please try again.');
                }
            });
            const parent = img.closest('.user-image-container');
            parent.insertAdjacentElement('afterend', btn);
        });
    } catch (_e) {
    // Ignore errors when adding flag buttons
    }
}
function $743d35dd0c1060e8$var$promptForReason() {
    const options = [
        'inappropriate',
        'copyright',
        'spam',
        'broken'
    ];
    const choice = window.prompt('Flag image for: (inappropriate | copyright | spam | broken)', 'inappropriate');
    if (!choice) return null;
    const normalized = choice.trim().toLowerCase();
    return options.includes(normalized) ? normalized : null;
}
function $743d35dd0c1060e8$var$findNearestPostId(node) {
    let el = node;
    while(el){
        if (el instanceof HTMLElement) {
            const pid = el.getAttribute('data-post-id');
            if (pid) return pid;
        }
        el = el.parentNode;
    }
    return null;
}
function $743d35dd0c1060e8$var$findNearestCommentId(node) {
    let el = node;
    while(el){
        if (el instanceof HTMLElement) {
            const cid = el.getAttribute('data-comment-id');
            if (cid) return cid;
        }
        el = el.parentNode;
    }
    return null;
}
function $743d35dd0c1060e8$var$showToast(message) {
    const div = document.createElement('div');
    div.textContent = message;
    div.style.position = 'fixed';
    div.style.bottom = '20px';
    div.style.right = '20px';
    div.style.padding = '0.5rem 0.75rem';
    div.style.background = 'var(--surface-color)';
    div.style.border = '1px solid var(--border-color)';
    div.style.borderRadius = '6px';
    div.style.boxShadow = 'var(--shadow)';
    div.style.zIndex = '10000';
    document.body.appendChild(div);
    setTimeout(()=>div.remove(), 2500);
}
function $743d35dd0c1060e8$var$normalizeGatedSet(value) {
    if (!value) return null;
    if (value instanceof Set) return value;
    if (Array.isArray(value)) return new Set(value);
    return null;
}



var $1L1Fr = parcelRequire("1L1Fr");



class $0a501e7a9e147a3a$var$PostItem extends HTMLElement {
    constructor(){
        super();
        this._post = null;
        this._currentUser = null;
        this._keepCommentsOpen = false;
    }
    static get observedAttributes() {
        return [
            'post-data',
            'group-id'
        ];
    }
    connectedCallback() {
        // Check if post-data attribute is already set (it might be set before connection)
        const postDataAttr = this.getAttribute('post-data');
        if (postDataAttr && !this._post) try {
            this._post = JSON.parse(postDataAttr);
            window.logger?.component('post-item connected with post data', this._post?.id);
        } catch (error) {
            window.logger?.error('Invalid post data in connectedCallback:', error, postDataAttr?.substring(0, 100));
        }
        else if (!postDataAttr) window.logger?.component('post-item connected without post-data attribute');
        this.render().catch((err)=>{
            window.logger?.error('Error rendering post-item:', err);
        });
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'post-data' && newValue) try {
            this._post = JSON.parse(newValue);
            this.render().catch((err)=>{
                window.logger?.error('Error rendering post-item:', {
                    err: err
                });
            });
        } catch (error) {
            window.logger.error('Invalid post data:', error);
        }
    }
    setCurrentUser(data) {
        this._currentUser = data;
    }
    set postData(data) {
        this._post = data;
        this.render().catch((err)=>{
            window.logger?.error('Error rendering post-item:', {
                err: err
            });
        });
        // Set comment count for lazy loading
        const commentsSection = this.querySelector('comments-section');
        if (commentsSection && data.comment_count !== undefined) {
            commentsSection.setCurrentUser(this._currentUser);
            commentsSection.setCommentCount(data.comment_count);
        }
    }
    set expandComments(data) {
        if (!data) return;
        if (this.querySelector('.post-comments')) this.openComments();
        else this._expandCommentsWhenReady = true;
    }
    get postData() {
        return this._post;
    }
    get groupId() {
        const raw = this.getAttribute('group-id');
        if (!raw) return null;
        const id = parseInt(raw, 10);
        return Number.isNaN(id) ? null : id;
    }
    isGroupPost() {
        return this.groupId !== null;
    }
    async render() {
        if (!this._post) {
            this.innerHTML = '<div class="loading">Loading post...</div>';
            return;
        }
        const { id: id, title: title, content_html: content_html, username: username, created_at: created_at, is_owner: is_owner, prompt_title: prompt_title, prompt_body: _promptBody, prompt_template_type: prompt_template_type, prompt_template_structure: prompt_template_structure, post_type: post_type, mood_icon: mood_icon, mood_status: mood_status, music_url: _musicUrl, resolved_url: resolved_url, embed_platform: embed_platform, embed_id: embed_id, embed_url: embed_url, embed_content_type: embed_content_type, embed_country: embed_country, url_title: url_title, url_description: url_description, url_image: url_image, import_source_site: import_source_site, import_source_url: import_source_url, source: source, group_name: groupName, url_site_name: url_site_name, rss_feed_id: rss_feed_id, notify_friends_email: notify_friends_email } = this._post;
        const imported = source === 'rss' || source === 'facebook';
        const import_source = source;
        const isRssPost = import_source === 'rss';
        const rssBlogName = url_site_name || import_source_site || 'RSS';
        const createdDate = new Date(created_at);
        const timeAgo = this.formatTimeAgo(createdDate);
        const inGroupShell = this.closest('group-shell') !== null;
        const showGroupBadge = this.isGroupPost() && groupName && !inGroupShell;
        const groupIdAttr = this.isGroupPost() ? ` group-id="${this.groupId}"` : '';
        const permalink = this.isGroupPost() ? inGroupShell ? `#post-${id}` : (0, $2bb3cd4399004fe3$export$611b42c8bf9737ff)({
            groupId: this.groupId,
            postId: id
        }) : `/post/${id}`;
        const isMemoryShare = source === 'memory_share';
        const memoryClass = isMemoryShare ? ' memory-share' : '';
        const postAnchorId = inGroupShell ? ` id="post-${id}"` : '';
        const commentsOpen = this._keepCommentsOpen || this.getAttribute('data-comments-open') === 'true';
        const commentsDisplayStyle = commentsOpen ? '' : ' style="display: none;"';
        const commentsToggleLabel = commentsOpen ? '\uD83D\uDCAC <span class="comments-count">Hide Comments</span>' : `\u{1F4AC} <span class="comments-count" id="comments-count-${id}">Comments (${this._post.comment_count || 0})</span>`;
        const styleClasses = (this._post.style_classes || []).join(' ');
        const styleInline = this._post.style_inline || '';
        const styledClass = styleClasses ? ` ${styleClasses}` : '';
        const styleAttr = styleInline ? ` style="${styleInline}"` : '';
        this.innerHTML = `
      <article class="card post-item${memoryClass}${styledClass}" data-post-id="${id}"${postAnchorId}${styleAttr}>
        <div class="card-body">
          <div class="post-header">
            <div class="post-author">
              <div class="avatar">
                ${username ? username.charAt(0).toUpperCase() : '?'}
              </div>
              <div class="author-info">
                <div class="author-name">
                  <user-mention username="${username}" real-username="${username}" user-id="${this._currentUser?.id}" class="author-link"></user-mention>
                </div>
                <div class="post-time" title="${createdDate.toLocaleString()}">
                  ${timeAgo}
                </div>
                ${isRssPost ? `
                <div class="rss-shared-subtitle">
                  shared from ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(rssBlogName)}${this.isGroupPost() && groupName ? ` in ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(groupName)}` : ''}
                </div>
                ` : ''}
                ${showGroupBadge ? `
                <div class="post-group-context">
                  <a href="/groups/${this.groupId}" class="post-group-link">in ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(groupName)}</a>
                </div>
                ` : ''}
              </div>
            </div>
            <div class="post-actions">
              ${is_owner && isRssPost && rss_feed_id ? `
                <button class="btn btn-sm btn-outline rss-email-toggle-btn"
                        title="Friend emails for ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(rssBlogName)}"
                        data-feed-id="${rss_feed_id}"
                        data-notify="${this._post.notify_friends_email ? '1' : '0'}">
                  ${this._post.notify_friends_email ? "\uD83D\uDD14" : "\uD83D\uDD15"}
                </button>
              ` : ''}
              ${is_owner ? `
                ${post_type !== 'poll' || (this._post.total_votes || 0) === 0 ? `
                <button class="btn btn-sm btn-outline edit-btn" title="Edit post">
                  \u{270F}\u{FE0F}
                </button>
                ` : ''}
                <button class="btn btn-sm btn-outline delete-btn" title="Delete post">
                  \u{1F5D1}\u{FE0F}
                </button>
              ` : `
                <button class="btn btn-sm btn-outline report-btn" title="Report this post" data-post-id="${id}">
                  \u{1F6A9}
                </button>
              `}
            </div>
          </div>
          
          ${prompt_title ? `
            <div class="prompt-context">
              <div class="prompt-indicator">
                <washing-machine-icon size="small" interactive="false"></washing-machine-icon>
                <span class="prompt-label">Writing Prompt:</span>
                <button class="prompt-reuse-btn" 
                        data-prompt-id="${this._post.prompt_id || ''}" 
                        data-prompt-title="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(prompt_title)}"
                        data-prompt-body="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this._post.prompt_body || '')}"
                        data-prompt-type="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this._post.prompt_type || 'text')}"
                        data-template-type="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this._post.prompt_template_type || 'simple')}"
                        title="Create a new post with this prompt">
                  <photocopy-icon size="small" interactive="true"></photocopy-icon>
                  <span>Use This Prompt</span>
                </button>
              </div>
              <div class="prompt-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(prompt_title)}</div>
            </div>
          ` : ''}
          
          ${imported && import_source === 'facebook' && import_source_site ? `
            <div class="import-badge">
              <span class="import-icon">\u{1F4E1}</span>
              <span class="import-text">Auto-imported from ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(import_source_site)}</span>
              ${import_source_url ? `<a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(import_source_url)}" target="_blank" rel="noopener noreferrer" class="import-link">View original</a>` : ''}
            </div>
          ` : ''}
          
          ${title && title !== 'Untitled Post' ? `
            <div class="post-title">
              <h2>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(title)}</h2>
            </div>
          ` : ''}
          
          <div class="post-content">
            ${this.renderPostContent(post_type, content_html, mood_icon, mood_status, embed_platform, embed_id, embed_url, embed_content_type, embed_country, url_title, url_description, url_image, resolved_url, this._post)}
          </div>

          ${isRssPost && import_source_url ? `
            <div class="rss-attribution-cta">
              <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(import_source_url)}" target="_blank" rel="noopener noreferrer ugc" class="btn-cta">
                Read on ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(rssBlogName)} \u{2192}
              </a>
            </div>
          ` : ''}
          
          <div class="post-footer">
            <div class="post-stats">
              <a href="${permalink}" class="post-permalink" title="View post details">
                Post #${id}
              </a>
            </div>
            <div class="post-actions-footer">
              <button class="btn btn-sm btn-outline comments-toggle-btn" data-post-id="${id}">
                ${commentsToggleLabel}
              </button>
            </div>
          </div>
          
          <div class="post-comments" id="post-comments-${id}"${commentsDisplayStyle}>
            <comments-section post-id="${id}" lazy-load="true"${groupIdAttr}></comments-section>
          </div>
        </div>
      </article>
    `;
        this.attachEventListeners();
        const postContext = this.isGroupPost() ? 'group' : 'friend';
        // Note: Images already have proxy URLs from backend (content_html field)
        // Only process if content_html is missing (fallback for old data)
        if (this._currentUser?.id && !this._post?.content_html) try {
            const postContent = this.querySelector('.post-content');
            if (postContent) {
                const processedHtml = await (0, $1L1Fr.processImageProxyUrls)(postContent.innerHTML, this._currentUser.id, this._post?.id || null, postContext);
                postContent.innerHTML = processedHtml;
            }
        } catch (error) {
            // If proxy processing fails, continue with original URLs
            window.logger.warn('Failed to process image proxy URLs:', error);
        }
        // Convert video/audio img tags to proper video/audio elements
        this.convertMediaImgTags();
        // Remint expired signed proxy tokens while the SPA stays open
        if (this._currentUser?.id) (0, $1L1Fr.attachProxyImageRemintHandlers)(this, {
            postId: this._post?.id || null,
            postContext: postContext
        });
        // Skip moderation/flagging in layout editor previews (read-only slot, no API noise)
        if (!this._isLayoutEditorPreview()) {
            try {
                await (0, $743d35dd0c1060e8$export$8bcad1a717b3183a)(this);
            } catch (_e) {
                try {
                    (0, $743d35dd0c1060e8$export$9bee0fd82991ea89)(this);
                } catch (_e2) {}
            }
            // Detect and handle unresolved Google Drive images
            setTimeout(()=>{
                this.detectUnresolvedImages().catch((err)=>{
                    window.logger.warn('Error detecting unresolved images:', err);
                });
            }, 100);
        }
        if (this._expandCommentsWhenReady) {
            this._expandCommentsWhenReady = false;
            this.openComments(true);
        }
    }
    _isLayoutEditorPreview() {
        return Boolean(this.closest('.layout-split-editor-preview'));
    }
    /**
   * Convert img tags that represent videos/audio to proper video/audio elements
   */ convertMediaImgTags(container = null) {
        const postContent = container || this.querySelector('.post-content');
        if (!postContent) {
            window.logger.debug('convertMediaImgTags: No post-content found');
            return;
        }
        const images = postContent.querySelectorAll('img');
        window.logger.debug('convertMediaImgTags: Found images', {
            count: images.length,
            postId: this._post?.id
        });
        images.forEach((img, index)=>{
            // Check if this is actually a video or audio file based on filename
            // Check alt attribute, data-image-url, or src for file extension
            const alt = img.getAttribute('alt') || '';
            const dataImageUrl = img.getAttribute('data-image-url') || '';
            const src = img.getAttribute('src') || '';
            // Extract filename from any of these sources
            const filename = alt || dataImageUrl.split('/').pop() || src.split('/').pop() || '';
            // Check video extensions
            const videoExtensions = [
                '.mp4',
                '.webm',
                '.ogv',
                '.mov',
                '.avi',
                '.mkv'
            ];
            const isVideo = videoExtensions.some((ext)=>filename.toLowerCase().endsWith(ext));
            // Check audio extensions
            const audioExtensions = [
                '.mp3',
                '.wav',
                '.ogg',
                '.flac',
                '.m4a',
                '.aac'
            ];
            const isAudio = audioExtensions.some((ext)=>filename.toLowerCase().endsWith(ext));
            if (!isVideo && !isAudio) {
                window.logger.debug(`convertMediaImgTags: Image ${index} is not video/audio`, {
                    filename: filename,
                    alt: alt,
                    src: src.substring(0, 100),
                    dataImageUrl: dataImageUrl.substring(0, 100)
                });
                return; // Not a video or audio file
            }
            // Get the source URL - use src (which has the proxy URL) rather than data-image-url (which has oauth://)
            // The src attribute will have the proxy URL after processImageProxyUrls runs
            const sourceUrl = src || dataImageUrl;
            if (!sourceUrl) {
                window.logger.warn('convertMediaImgTags: No source URL found for media', {
                    filename: filename,
                    isVideo: isVideo,
                    isAudio: isAudio
                });
                return; // No URL to use
            }
            window.logger.debug('convertMediaImgTags: Converting to media element', {
                index: index,
                filename: filename,
                isVideo: isVideo,
                isAudio: isAudio,
                sourceUrl: sourceUrl.substring(0, 100),
                postId: this._post?.id
            });
            // Create the appropriate element
            let newElement;
            let errorWrapper = null;
            if (isVideo) {
                newElement = document.createElement('video');
                newElement.setAttribute('controls', '');
                newElement.setAttribute('preload', 'metadata');
                newElement.className = 'user-video';
                newElement.style.maxWidth = '100%';
                newElement.style.height = 'auto';
                newElement.style.borderRadius = '8px';
                const source = document.createElement('source');
                source.setAttribute('src', sourceUrl);
                // Try to detect MIME type from extension
                if (filename.toLowerCase().endsWith('.webm')) source.setAttribute('type', 'video/webm');
                else if (filename.toLowerCase().endsWith('.ogv')) source.setAttribute('type', 'video/ogg');
                else if (filename.toLowerCase().endsWith('.mov')) source.setAttribute('type', 'video/quicktime');
                else source.setAttribute('type', 'video/mp4');
                newElement.appendChild(source);
                // Copy over relevant attributes
                if (img.getAttribute('loading')) newElement.setAttribute('loading', img.getAttribute('loading'));
                if (img.getAttribute('referrerpolicy')) newElement.setAttribute('referrerpolicy', img.getAttribute('referrerpolicy'));
                if (img.getAttribute('crossorigin')) newElement.setAttribute('crossorigin', img.getAttribute('crossorigin'));
                if (img.getAttribute('data-image-url')) newElement.setAttribute('data-video-url', img.getAttribute('data-image-url'));
                // Add error display wrapper (create before event listeners)
                errorWrapper = document.createElement('div');
                errorWrapper.className = 'video-error-wrapper';
                errorWrapper.style.display = 'none';
                errorWrapper.innerHTML = `
          <div class="video-error-message">
            <span class="error-icon">\u{26A0}\u{FE0F}</span>
            <span class="error-text">Video failed to load</span>
            <button class="btn btn-sm btn-secondary retry-video-btn" data-video-src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(sourceUrl)}">Retry</button>
          </div>
        `;
                // Add error handling and debugging for video elements
                newElement.addEventListener('error', (e)=>{
                    const video = e.target;
                    const error = video.error;
                    let errorMessage = 'Video failed to load';
                    if (error) switch(error.code){
                        case error.MEDIA_ERR_ABORTED:
                            errorMessage = 'Video loading aborted';
                            break;
                        case error.MEDIA_ERR_NETWORK:
                            errorMessage = 'Network error while loading video';
                            break;
                        case error.MEDIA_ERR_DECODE:
                            errorMessage = 'Video decoding error';
                            break;
                        case error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                            errorMessage = 'Video format not supported';
                            break;
                    }
                    window.logger.error('Video element error', {
                        errorCode: error?.code,
                        errorMessage: errorMessage,
                        src: sourceUrl,
                        sourceType: source.getAttribute('type'),
                        networkState: video.networkState,
                        readyState: video.readyState,
                        postId: this._post?.id
                    });
                    // Show error wrapper
                    if (errorWrapper) {
                        errorWrapper.style.display = 'block';
                        newElement.style.display = 'none';
                    }
                    // Try to fetch the URL to check what's actually being returned
                    fetch(sourceUrl, {
                        method: 'HEAD'
                    }).then((response)=>{
                        window.logger.debug('Video URL HEAD request', {
                            url: sourceUrl,
                            status: response.status,
                            statusText: response.statusText,
                            contentType: response.headers.get('content-type'),
                            contentLength: response.headers.get('content-length'),
                            xImageError: response.headers.get('x-image-error'),
                            xOriginalError: response.headers.get('x-original-error'),
                            cacheControl: response.headers.get('cache-control')
                        });
                    }).catch((fetchError)=>{
                        window.logger.error('Failed to fetch video URL for debugging', {
                            url: sourceUrl,
                            error: fetchError.message
                        });
                    });
                });
                // Log initial state immediately after creation
                window.logger.debug('Video element created', {
                    src: sourceUrl,
                    sourceType: source.getAttribute('type'),
                    hasControls: newElement.hasAttribute('controls'),
                    preload: newElement.getAttribute('preload'),
                    className: newElement.className,
                    postId: this._post?.id
                });
                newElement.addEventListener('loadstart', ()=>{
                    window.logger.debug('Video load started', {
                        src: sourceUrl,
                        networkState: newElement.networkState,
                        readyState: newElement.readyState,
                        postId: this._post?.id
                    });
                });
                newElement.addEventListener('loadedmetadata', ()=>{
                    window.logger.debug('Video metadata loaded', {
                        src: sourceUrl,
                        duration: newElement.duration,
                        videoWidth: newElement.videoWidth,
                        videoHeight: newElement.videoHeight,
                        postId: this._post?.id
                    });
                });
                newElement.addEventListener('canplay', ()=>{
                    window.logger.debug('Video can play', {
                        src: sourceUrl,
                        postId: this._post?.id
                    });
                });
                newElement.addEventListener('stalled', ()=>{
                    window.logger.warn('Video loading stalled', {
                        src: sourceUrl,
                        networkState: newElement.networkState,
                        postId: this._post?.id
                    });
                });
                // Retry button handler
                const retryBtn = errorWrapper.querySelector('.retry-video-btn');
                if (retryBtn) retryBtn.addEventListener('click', (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    window.logger.debug('Retrying video load', {
                        src: sourceUrl
                    });
                    errorWrapper.style.display = 'none';
                    newElement.style.display = 'block';
                    newElement.load(); // Reload the video
                });
            } else if (isAudio) {
                newElement = document.createElement('audio');
                newElement.setAttribute('controls', '');
                newElement.setAttribute('preload', 'metadata');
                newElement.className = 'user-audio';
                newElement.style.width = '100%';
                newElement.style.maxWidth = '100%';
                const source = document.createElement('source');
                source.setAttribute('src', sourceUrl);
                // Try to detect MIME type from extension
                if (filename.toLowerCase().endsWith('.ogg')) source.setAttribute('type', 'audio/ogg');
                else if (filename.toLowerCase().endsWith('.wav')) source.setAttribute('type', 'audio/wav');
                else if (filename.toLowerCase().endsWith('.flac')) source.setAttribute('type', 'audio/flac');
                else if (filename.toLowerCase().endsWith('.m4a') || filename.toLowerCase().endsWith('.aac')) source.setAttribute('type', 'audio/mp4');
                else source.setAttribute('type', 'audio/mpeg');
                newElement.appendChild(source);
                // Copy over relevant attributes
                if (img.getAttribute('data-image-url')) newElement.setAttribute('data-audio-url', img.getAttribute('data-image-url'));
            }
            if (newElement) {
                window.logger.debug('convertMediaImgTags: Replacing img with media element', {
                    filename: filename,
                    elementType: newElement.tagName,
                    sourceUrl: sourceUrl.substring(0, 100),
                    postId: this._post?.id
                });
                // For videos, wrap in container to include error display
                if (isVideo && errorWrapper) {
                    const container = document.createElement('div');
                    container.className = 'video-container';
                    container.appendChild(newElement);
                    container.appendChild(errorWrapper);
                    img.parentNode.replaceChild(container, img);
                    // Check video element state after it's in the DOM
                    setTimeout(()=>{
                        const videoInDom = container.querySelector('video');
                        if (videoInDom) window.logger.debug('convertMediaImgTags: Video element in DOM', {
                            filename: filename,
                            networkState: videoInDom.networkState,
                            readyState: videoInDom.readyState,
                            currentSrc: videoInDom.currentSrc?.substring(0, 100),
                            error: videoInDom.error ? {
                                code: videoInDom.error.code,
                                message: videoInDom.error.message
                            } : null,
                            postId: this._post?.id
                        });
                        else window.logger.warn('convertMediaImgTags: Video element not found in DOM after creation');
                    }, 100);
                    window.logger.debug('convertMediaImgTags: Video element created and wrapped', {
                        filename: filename,
                        videoSrc: newElement.querySelector('source')?.getAttribute('src')?.substring(0, 100),
                        hasErrorWrapper: !!errorWrapper,
                        postId: this._post?.id
                    });
                } else {
                    // Replace the img tag with the video/audio element
                    img.parentNode.replaceChild(newElement, img);
                    window.logger.debug('convertMediaImgTags: Media element created', {
                        filename: filename,
                        elementType: newElement.tagName,
                        postId: this._post?.id
                    });
                }
            } else window.logger.warn('convertMediaImgTags: Failed to create media element', {
                filename: filename,
                isVideo: isVideo,
                isAudio: isAudio
            });
        });
    }
    /**
   * Detect unresolved Google Drive images/videos/audio and add UI for reimport
   */ async detectUnresolvedImages() {
        if (!this._post || !this._currentUser) return;
        // Only show reimport UI for Facebook-imported posts owned by the user
        if (this._post.source !== 'facebook' || !this._post.is_owner) {
            window.logger.debug('Skipping unresolved media detection', {
                source: this._post.source,
                is_owner: this._post.is_owner,
                postId: this._post.id
            });
            return;
        }
        const postContent = this.querySelector('.post-content');
        if (!postContent) return;
        /**
     * Helper function to get the URL from a media element
     * Checks appropriate attributes based on element type
     */ const getMediaUrl = (element)=>{
            if (element.tagName === 'IMG') // For images, check data-image-url first, then src
            return element.getAttribute('data-image-url') || element.getAttribute('src') || '';
            else if (element.tagName === 'VIDEO') {
                // For videos, check data-video-url first, then source src, then video src
                const dataVideoUrl = element.getAttribute('data-video-url') || '';
                if (dataVideoUrl) return dataVideoUrl;
                const source = element.querySelector('source');
                if (source) return source.getAttribute('src') || '';
                return element.getAttribute('src') || '';
            } else if (element.tagName === 'AUDIO') {
                // For audio, check data-audio-url first, then source src, then audio src
                const dataAudioUrl = element.getAttribute('data-audio-url') || '';
                if (dataAudioUrl) return dataAudioUrl;
                const source = element.querySelector('source');
                if (source) return source.getAttribute('src') || '';
                return element.getAttribute('src') || '';
            }
            return '';
        };
        /**
     * Helper function to check if a URL indicates unresolved/error state
     */ const isUnresolvedUrl = (url)=>{
            return url.includes('oauth://google-drive') && (url.includes('unresolved') || url.includes('error'));
        };
        // Find all media elements (images, videos, audio) with unresolved/error URLs
        const allImages = postContent.querySelectorAll('img');
        const allVideos = postContent.querySelectorAll('video');
        const allAudio = postContent.querySelectorAll('audio');
        const unresolvedMedia = [];
        // Check images
        for (const img of allImages){
            const url = getMediaUrl(img);
            if (isUnresolvedUrl(url)) unresolvedMedia.push({
                element: img,
                url: url,
                type: 'image'
            });
        }
        // Check videos
        for (const video of allVideos){
            const url = getMediaUrl(video);
            if (isUnresolvedUrl(url)) unresolvedMedia.push({
                element: video,
                url: url,
                type: 'video'
            });
        }
        // Check audio
        for (const audio of allAudio){
            const url = getMediaUrl(audio);
            if (isUnresolvedUrl(url)) unresolvedMedia.push({
                element: audio,
                url: url,
                type: 'audio'
            });
        }
        if (unresolvedMedia.length === 0) {
            window.logger.debug('No unresolved media found', {
                postId: this._post.id
            });
            return;
        }
        window.logger.debug('Found unresolved media', {
            postId: this._post.id,
            count: unresolvedMedia.length
        });
        // Get Google Drive accounts
        let googleDriveAccounts = [];
        try {
            const data = await window.API.request(`/users/settings/${this._currentUser.id}/media-sources`);
            googleDriveAccounts = data.accounts?.['google-drive'] || [];
        } catch (error) {
            window.logger.warn('Failed to load Google Drive accounts for unresolved media reimport', error);
            return;
        }
        if (googleDriveAccounts.length === 0) return;
        // Process each unresolved media element
        for (const { element: element, url: urlToCheck, type: detectedType } of unresolvedMedia){
            // Extract original filename from URL
            // Format: oauth://google-drive/{accountIdentifier}/unresolved-{encodedURI} or error-{encodedURI}
            const match = urlToCheck.match(/oauth:\/\/google-drive\/[^/]+\/(?:unresolved|error)-(.+)/);
            if (!match) {
                window.logger.debug('No match for unresolved URL pattern', {
                    urlToCheck: urlToCheck,
                    elementType: element.tagName
                });
                continue;
            }
            try {
                const encodedUri = decodeURIComponent(match[1]);
                const originalFileName = encodedUri.split('/').pop() || encodedUri;
                // Determine media type: use detected type from element, or check file extension
                let mediaType = detectedType;
                let mediaTypeLabel = detectedType.charAt(0).toUpperCase() + detectedType.slice(1);
                // If type wasn't detected from element, check file extension
                if (mediaType === 'image') {
                    const videoExtensions = [
                        '.mp4',
                        '.webm',
                        '.ogv',
                        '.mov',
                        '.avi',
                        '.mkv'
                    ];
                    const audioExtensions = [
                        '.mp3',
                        '.wav',
                        '.ogg',
                        '.flac',
                        '.m4a',
                        '.aac'
                    ];
                    const isVideo = videoExtensions.some((ext)=>originalFileName.toLowerCase().endsWith(ext));
                    const isAudio = audioExtensions.some((ext)=>originalFileName.toLowerCase().endsWith(ext));
                    if (isVideo) {
                        mediaType = 'video';
                        mediaTypeLabel = 'Video';
                    } else if (isAudio) {
                        mediaType = 'audio';
                        mediaTypeLabel = 'Audio';
                    }
                }
                // Create wrapper for the media with reimport button
                const wrapper = document.createElement('div');
                wrapper.className = `unresolved-${mediaType}-wrapper`;
                // For videos/audio that are already converted, use the existing element
                // For images, use the img tag HTML
                let mediaElement;
                if (mediaType === 'video' && element.tagName === 'VIDEO') {
                    // Video is already a video element, clone it and update src
                    const videoClone = element.cloneNode(true);
                    const source = videoClone.querySelector('source');
                    if (source) source.setAttribute('src', urlToCheck);
                    else videoClone.setAttribute('src', urlToCheck);
                    videoClone.className = 'unresolved-media';
                    mediaElement = videoClone.outerHTML;
                } else if (mediaType === 'audio' && element.tagName === 'AUDIO') {
                    // Audio is already an audio element, clone it and update src
                    const audioClone = element.cloneNode(true);
                    const source = audioClone.querySelector('source');
                    if (source) source.setAttribute('src', urlToCheck);
                    else audioClone.setAttribute('src', urlToCheck);
                    audioClone.className = 'unresolved-media';
                    mediaElement = audioClone.outerHTML;
                } else if (mediaType === 'video') // Image that should be a video - create video element
                mediaElement = `<video class="unresolved-media" controls>
            <source src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlToCheck)}" type="video/mp4">
            Your browser does not support the video tag.
          </video>`;
                else if (mediaType === 'audio') // Image that should be audio - create audio element
                mediaElement = `<audio class="unresolved-media" controls>
            <source src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlToCheck)}" type="audio/mpeg">
            Your browser does not support the audio tag.
          </audio>`;
                else // Image - use existing img element HTML
                mediaElement = element.outerHTML;
                wrapper.innerHTML = `
          <div class="unresolved-media-container">
            ${mediaElement}
            <div class="unresolved-media-block">
              <div class="unresolved-media-message">
                <span class="unresolved-icon">\u{26A0}\u{FE0F}</span>
                <span class="unresolved-text">${mediaTypeLabel} not found</span>
              </div>
              <button class="btn btn-sm btn-primary resolve-media-btn" 
                      data-post-id="${this._post.id}"
                      data-original-filename="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(originalFileName)}"
                      data-original-uri="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(encodedUri)}"
                      data-media-type="${mediaType}"
                      title="Select ${mediaTypeLabel.toLowerCase()} file from Google Drive">
                \u{1F4C1} Select ${mediaTypeLabel} File
              </button>
            </div>
          </div>
        `;
                // Replace the element with the wrapper
                element.parentNode.replaceChild(wrapper, element);
                // Attach click handler
                const resolveBtn = wrapper.querySelector('.resolve-media-btn');
                if (resolveBtn) resolveBtn.addEventListener('click', async (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    await this.handleResolveImage(e.target, googleDriveAccounts[0], originalFileName);
                });
            } catch (error) {
                window.logger.warn('Error processing unresolved media', {
                    error: error.message,
                    urlToCheck: urlToCheck,
                    elementType: element.tagName
                });
            }
        }
    }
    /**
   * Handle resolving an unresolved image by opening Google Drive picker
   */ async handleResolveImage(button, googleDriveAccount, searchFileName) {
        if (!this._post || !this._currentUser) return;
        button.disabled = true;
        button.textContent = 'Opening picker...';
        try {
            await (0, $340e9f71e9f92c91$export$e486ce152da8ad13)(this, 'google-drive', googleDriveAccount.accountIdentifier, 'DOCS', async (data)=>{
                if (data.action === google.picker.Action.PICKED) {
                    const file = data.docs[0];
                    if (!file) return;
                    button.disabled = true;
                    button.textContent = 'Reimporting...';
                    try {
                        // Submit reimport job
                        const _response = await window.API.request('/facebook-import/reimport-post', {
                            method: 'POST',
                            body: JSON.stringify({
                                postId: this._post.id,
                                imageFileId: file.id,
                                imageFileName: file.name
                            })
                        });
                        // Show success message
                        button.textContent = "\u2713 Reimporting...";
                        button.classList.add('btn-success-flash');
                        // Reload post after a delay to show updated content
                        setTimeout(async ()=>{
                            await this.loadPost();
                        }, 2000);
                    } catch (error) {
                        window.logger.error('Failed to submit reimport job:', error);
                        alert(`Failed to start reimport: ${error.message || 'Please try again.'}`);
                        button.disabled = false;
                        button.textContent = "\uD83D\uDCC1 Select Image File";
                    }
                }
            }, false, searchFileName // pre-populate search with filename
            );
        } catch (error) {
            window.logger.error('Failed to open Google Drive picker:', error);
            alert(`Failed to open file picker: ${error.message || 'Please try again.'}`);
            button.disabled = false;
            button.textContent = "\uD83D\uDCC1 Select Image File";
        }
    }
    /**
   * Load post data (for re-rendering after reimport)
   */ async loadPost() {
        if (!this._post?.id) return;
        try {
            const post = await window.API.request(`/posts/${this._post.id}`);
            this._post = post;
            await this.render();
        } catch (error) {
            window.logger.error('Failed to reload post:', error);
        }
    }
    attachEventListeners() {
        const editBtn = this.querySelector('.edit-btn');
        const deleteBtn = this.querySelector('.delete-btn');
        const reportBtn = this.querySelector('.report-btn');
        const commentsToggleBtn = this.querySelector('.comments-toggle-btn');
        const promptReuseBtn = this.querySelector('.prompt-reuse-btn');
        editBtn?.addEventListener('click', ()=>{
            this.handleEdit();
        });
        deleteBtn?.addEventListener('click', ()=>{
            this.handleDelete();
        });
        reportBtn?.addEventListener('click', ()=>{
            this.handleReport();
        });
        commentsToggleBtn?.addEventListener('click', ()=>{
            this.toggleComments();
        });
        promptReuseBtn?.addEventListener('click', (e)=>{
            e.preventDefault();
            this.handlePromptReuse(e.target.closest('.prompt-reuse-btn'));
        });
        const rssEmailBtn = this.querySelector('.rss-email-toggle-btn');
        rssEmailBtn?.addEventListener('click', ()=>this.handleRssEmailToggle(rssEmailBtn));
    }
    async handleRssEmailToggle(btn) {
        const feedId = parseInt(btn.dataset.feedId, 10);
        const currentlyOn = btn.dataset.notify === '1';
        try {
            await window.API.rss.update(feedId, {
                notify_friends_email: !currentlyOn
            });
            if (this._post) this._post.notify_friends_email = !currentlyOn;
            btn.dataset.notify = currentlyOn ? '0' : '1';
            btn.textContent = currentlyOn ? "\uD83D\uDD15" : "\uD83D\uDD14";
        } catch (error) {
            window.logger.error('Failed to toggle RSS email notifications:', error);
            this.showError('Could not update email setting for this feed');
        }
    }
    async handleReport() {
        const postId = this._post.id;
        if (!postId) {
            window.logger.error('Cannot report post: no post ID');
            return;
        }
        // Show report modal
        const reason = prompt('Why are you reporting this post?\n\nPlease provide a brief reason (e.g., "Inappropriate content", "Spam", "Harassment", etc.):');
        if (!reason || reason.trim().length === 0) return; // User cancelled or didn't provide reason
        const description = prompt('Additional details (optional):\n\nProvide any additional context that might help us understand the issue:') || '';
        try {
            if (this.isGroupPost()) {
                await window.API.request(`/groups/${this.groupId}/reports`, {
                    method: 'POST',
                    body: JSON.stringify({
                        target_type: 'post',
                        target_id: postId,
                        reason: reason.trim(),
                        details: description.trim()
                    })
                });
                alert('Thank you for reporting this post. Group moderators will review it.');
                return;
            }
            const response = await window.API.request('/support/flag-post', {
                method: 'POST',
                body: JSON.stringify({
                    post_id: postId,
                    reason: reason.trim(),
                    description: description.trim()
                })
            });
            alert('Thank you for reporting this post. Our team will review it shortly.');
            // Optionally open the safety armadillo to show the created ticket
            const safetyArmadillo = document.querySelector('safety-armadillo');
            if (safetyArmadillo && response.ticket) {
                safetyArmadillo.open();
                setTimeout(()=>{
                    safetyArmadillo.viewTicket(response.ticket.id || response.ticket.conversation_id);
                }, 500);
            }
        } catch (error) {
            window.logger.error('Failed to report post:', error);
            alert(`Failed to report post: ${error.message || 'Please try again later.'}`);
        }
    }
    handleEdit() {
        if (this._post.post_type === 'poll') {
            this.handleEditPoll();
            return;
        }
        const postTextElement = this.querySelector('.post-text');
        const postTitleElement = this.querySelector('.post-title');
        if (!postTextElement) {
            window.logger?.warn('handleEdit: no .post-text element (post_type may not support editing)');
            alert('Editing is not supported for this post type.');
            return;
        }
        const currentContent = this._post.content || this._post.content_markdown || '';
        const currentTitle = this._post.title || '';
        const currentStyle = this._post.post_style || null;
        const showStylePicker = !this.isGroupPost();
        const styleField = showStylePicker ? '<post-style-picker class="edit-style-picker"></post-style-picker>' : '';
        // Create edit form
        const editForm = document.createElement('div');
        editForm.className = 'edit-form';
        const titleField = this.isGroupPost() ? '' : `
      <input type="text" class="edit-title-input" placeholder="Post title..." maxlength="255" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(currentTitle)}">
    `;
        editForm.innerHTML = `
      ${titleField}
      <markdown-preview>
          <textarea class="edit-textarea" rows="4">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(currentContent)}</textarea>
      </markdown-preview>
      ${styleField}
      <div class="edit-actions">
        <button type="button" class="btn btn-sm btn-primary save-edit-btn">Save</button>
        <button type="button" class="btn btn-sm btn-secondary cancel-edit-btn">Cancel</button>
      </div>
    `;
        // Replace post content with edit form
        postTextElement.style.display = 'none';
        if (postTitleElement) postTitleElement.style.display = 'none';
        postTextElement.parentNode.insertBefore(editForm, postTextElement.nextSibling);
        const stylePicker = showStylePicker ? editForm.querySelector('post-style-picker') : null;
        const markdownPreview = editForm.querySelector('markdown-preview');
        if (stylePicker) {
            stylePicker.setStyle(currentStyle);
            const applyEditStylePreview = (style, flipPreview = false)=>{
                if (!markdownPreview) return;
                if (flipPreview) markdownPreview.setMode('preview');
                if (style) markdownPreview.applyPostStyle(style);
                else markdownPreview.clearPostStyle();
            };
            editForm.addEventListener('post-style-preview-request', ()=>{
                applyEditStylePreview(stylePicker.getStyle(), true);
            });
            editForm.addEventListener('post-style-change', (e)=>{
                applyEditStylePreview(e.detail?.style ?? null);
            });
        }
        // Focus on title input and select all text
        const titleInput = editForm.querySelector('.edit-title-input');
        const textarea = editForm.querySelector('.edit-textarea');
        if (markdownPreview?.bindTitleInput && titleInput) markdownPreview.bindTitleInput(titleInput);
        if (titleInput) {
            titleInput.focus();
            titleInput.setSelectionRange(0, titleInput.value.length);
        } else {
            textarea.focus();
            textarea.setSelectionRange(0, textarea.value.length);
        }
        // Hide edit/delete buttons during editing
        const postActions = this.querySelector('.post-actions');
        if (postActions) postActions.style.display = 'none';
        // Handle save
        editForm.querySelector('.save-edit-btn').addEventListener('click', async ()=>{
            const newTitle = titleInput ? titleInput.value.trim() : '';
            const newContent = textarea.value.trim();
            if (!newContent) {
                alert('Post content cannot be empty');
                return;
            }
            const newStyle = stylePicker ? stylePicker.getStyle() : null;
            const stylesEqual = JSON.stringify(currentStyle || null) === JSON.stringify(newStyle || null);
            if (newContent === currentContent && newTitle === currentTitle && stylesEqual) {
                // No changes, just cancel
                this.cancelEdit(editForm, postTextElement, postTitleElement, postActions);
                return;
            }
            try {
                // Disable buttons during save
                const saveBtn = editForm.querySelector('.save-edit-btn');
                const cancelBtn = editForm.querySelector('.cancel-edit-btn');
                saveBtn.disabled = true;
                cancelBtn.disabled = true;
                saveBtn.textContent = 'Saving...';
                let updatedPost;
                if (this.isGroupPost()) updatedPost = await window.API.request(`/groups/${this.groupId}/posts/${this._post.id}`, {
                    method: 'PUT',
                    body: JSON.stringify({
                        content_markdown: newContent
                    })
                });
                else {
                    const updatePayload = {
                        title: newTitle,
                        content: newContent
                    };
                    if (stylePicker) {
                        updatePayload.postStyle = newStyle;
                        const lastUsedStyleId = stylePicker.getLastUsedStyleId?.();
                        if (lastUsedStyleId) updatePayload.lastUsedStyleId = lastUsedStyleId;
                    }
                    updatedPost = await window.API.posts.update(this._post.id, updatePayload);
                }
                // Update the post data and re-render
                this._post = {
                    ...this._post,
                    ...updatedPost
                };
                this.render();
                // Dispatch custom event to notify parent components
                this.dispatchEvent(new CustomEvent('post-updated', {
                    detail: {
                        postId: this._post.id,
                        updatedPost: this._post
                    },
                    bubbles: true
                }));
            } catch (error) {
                window.logger.error('Failed to update post:', error);
                const message = error.message || 'Failed to update post. Please try again.';
                if (stylePicker?.showError) stylePicker.showError(message);
                else alert(message);
                // Re-enable buttons
                const saveBtn = editForm.querySelector('.save-edit-btn');
                const cancelBtn = editForm.querySelector('.cancel-edit-btn');
                saveBtn.disabled = false;
                cancelBtn.disabled = false;
                saveBtn.textContent = 'Save';
            }
        });
        // Handle cancel
        editForm.querySelector('.cancel-edit-btn').addEventListener('click', ()=>{
            this.cancelEdit(editForm, postTextElement, postTitleElement, postActions);
        });
        // Handle Escape key to cancel
        textarea.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape') this.cancelEdit(editForm, postTextElement, postTitleElement, postActions);
        });
    }
    cancelEdit(editForm, postTextElement, postTitleElement, postActions) {
        editForm.remove();
        postTextElement.style.display = 'block';
        if (postTitleElement) postTitleElement.style.display = 'block';
        if (postActions) postActions.style.display = 'flex';
    }
    handleEditPoll() {
        const postContent = this.querySelector('.post-content');
        const postTitle = this.querySelector('.post-title');
        const postActions = this.querySelector('.post-actions');
        if (!postContent) return;
        const question = this._post.poll_question || '';
        const options = (this._post.poll_options || []).map((o)=>typeof o === 'string' ? o : o.option_text || '');
        const optionsHtml = options.map((opt, i)=>`
      <div class="poll-option-item" data-index="${i}">
        <input type="text" class="poll-option-input form-control" data-index="${i}"
          placeholder="Option ${i + 1}" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(opt)}" maxlength="500" />
        <button type="button" class="btn btn-icon remove-option-btn" data-index="${i}" title="Remove option"
          style="${options.length <= 2 ? 'display:none' : ''}">\u{2715}</button>
      </div>
    `).join('');
        if (postTitle) postTitle.style.display = 'none';
        if (postActions) postActions.style.display = 'none';
        postContent.innerHTML = `
      <div class="edit-form poll-edit-form">
        <div class="form-group">
          <label for="poll-edit-question">Poll Question</label>
          <textarea id="poll-edit-question" class="form-control poll-question-input" rows="2"
            maxlength="500" placeholder="What's your question?">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(question)}</textarea>
          <div class="char-count"><span id="poll-edit-char-count">${question.length}</span>/500</div>
        </div>
        <div class="form-group">
          <label>Poll Options <span class="option-count">(${options.length}/10)</span></label>
          <div class="poll-options-list" id="poll-edit-options"></div>
          ${options.length < 10 ? '<button type="button" class="btn btn-secondary add-option-btn" id="poll-edit-add">+ Add Option</button>' : ''}
        </div>
        <div class="edit-actions">
          <button type="button" class="btn btn-sm btn-primary save-edit-btn">Save</button>
          <button type="button" class="btn btn-sm btn-secondary cancel-edit-btn">Cancel</button>
        </div>
      </div>
    `;
        const list = postContent.querySelector('#poll-edit-options');
        list.innerHTML = optionsHtml;
        const questionInput = postContent.querySelector('#poll-edit-question');
        const charCount = postContent.querySelector('#poll-edit-char-count');
        const optionCountLabel = postContent.querySelector('.option-count');
        const addBtn = postContent.querySelector('#poll-edit-add');
        const getOptionInputs = ()=>postContent.querySelectorAll('.poll-option-input');
        const getOptionCount = ()=>getOptionInputs().length;
        const updateOptionCount = ()=>{
            const n = getOptionCount();
            if (optionCountLabel) optionCountLabel.textContent = `(${n}/10)`;
            const addEl = postContent.querySelector('#poll-edit-add');
            if (addEl) addEl.style.display = n >= 10 ? 'none' : 'inline-block';
        };
        questionInput.addEventListener('input', ()=>{
            if (charCount) charCount.textContent = questionInput.value.length;
        });
        const addOption = ()=>{
            if (getOptionCount() >= 10) return;
            const idx = getOptionCount();
            const item = document.createElement('div');
            item.className = 'poll-option-item';
            item.dataset.index = String(idx);
            const showRemove = getOptionCount() >= 2;
            item.innerHTML = `
        <input type="text" class="poll-option-input form-control" data-index="${idx}"
          placeholder="Option ${idx + 1}" maxlength="500" />
        <button type="button" class="btn btn-icon remove-option-btn" data-index="${idx}" title="Remove option"
          style="${showRemove ? '' : 'display:none'}">\u{2715}</button>
      `;
            list.appendChild(item);
            item.querySelector('.poll-option-input').focus();
            reindexOptions();
            updateOptionCount();
            attachOptionListeners();
        };
        const removeOption = (index)=>{
            const items = list.querySelectorAll('.poll-option-item');
            if (items.length <= 2) return;
            items[index]?.remove();
            reindexOptions();
            updateOptionCount();
            attachOptionListeners();
        };
        const reindexOptions = ()=>{
            const items = list.querySelectorAll('.poll-option-item');
            items.forEach((item, i)=>{
                item.dataset.index = String(i);
                const input = item.querySelector('.poll-option-input');
                const removeBtn = item.querySelector('.remove-option-btn');
                if (input) {
                    input.dataset.index = String(i);
                    input.placeholder = `Option ${i + 1}`;
                }
                if (removeBtn) {
                    removeBtn.dataset.index = String(i);
                    removeBtn.style.display = items.length > 2 ? '' : 'none';
                }
            });
        };
        const attachOptionListeners = ()=>{
            list.querySelectorAll('.remove-option-btn').forEach((btn)=>{
                btn.replaceWith(btn.cloneNode(true));
            });
            list.querySelectorAll('.remove-option-btn').forEach((btn)=>{
                btn.addEventListener('click', ()=>removeOption(parseInt(btn.dataset.index, 10)));
            });
        };
        attachOptionListeners();
        if (addBtn) addBtn.addEventListener('click', addOption);
        postContent.querySelector('.cancel-edit-btn').addEventListener('click', ()=>{
            this.render().catch((e)=>window.logger?.error('Poll edit cancel render', e));
        });
        postContent.querySelector('.save-edit-btn').addEventListener('click', async ()=>{
            const trimmedQuestion = questionInput.value.trim();
            if (!trimmedQuestion) {
                alert('Please enter a poll question.');
                return;
            }
            const rawOptions = Array.from(getOptionInputs()).map((inp)=>inp.value.trim()).filter(Boolean);
            if (rawOptions.length < 2) {
                alert('Polls must have at least 2 options.');
                return;
            }
            if (rawOptions.length > 10) {
                alert('Polls can have at most 10 options.');
                return;
            }
            const seen = new Set();
            for (const o of rawOptions){
                const lower = o.toLowerCase();
                if (seen.has(lower)) {
                    alert('Poll options must be unique (case-insensitive).');
                    return;
                }
                seen.add(lower);
            }
            const saveBtn = postContent.querySelector('.save-edit-btn');
            const cancelBtn = postContent.querySelector('.cancel-edit-btn');
            saveBtn.disabled = true;
            cancelBtn.disabled = true;
            saveBtn.textContent = 'Saving...';
            try {
                const updated = await window.API.polls.update(this._post.id, {
                    poll_question: trimmedQuestion,
                    poll_options: rawOptions
                });
                this._post = {
                    ...this._post,
                    ...updated
                };
                await this.render();
                this.dispatchEvent(new CustomEvent('post-updated', {
                    detail: {
                        postId: this._post.id,
                        updatedPost: this._post
                    },
                    bubbles: true
                }));
            } catch (err) {
                window.logger?.error('Failed to update poll', err);
                const msg = err.message || err.error || err.details && err.details.map((d)=>d.message).join(', ') || 'Failed to update poll. Please try again.';
                alert(msg);
                saveBtn.disabled = false;
                cancelBtn.disabled = false;
                saveBtn.textContent = 'Save';
            }
        });
        questionInput.focus();
    }
    async handleDelete() {
        if (!confirm('Are you sure you want to delete this post?')) return;
        try {
            if (this.isGroupPost()) await window.API.request(`/groups/${this.groupId}/posts/${this._post.id}`, {
                method: 'DELETE'
            });
            else await window.API.posts.delete(this._post.id);
            // Dispatch custom event to notify parent components
            this.dispatchEvent(new CustomEvent('post-deleted', {
                detail: {
                    postId: this._post.id
                },
                bubbles: true
            }));
            // Remove the element with animation
            this.style.transition = 'all 0.3s ease-out';
            this.style.transform = 'translateX(-100%)';
            this.style.opacity = '0';
            setTimeout(()=>{
                this.remove();
            }, 300);
        } catch (error) {
            window.logger.error('Failed to delete post:', error);
            alert('Failed to delete post. Please try again.');
        }
    }
    openComments(force = false) {
        const commentsContainer = this.querySelector('.post-comments');
        const toggleBtn = this.querySelector('.comments-toggle-btn');
        if (!commentsContainer || !toggleBtn) return;
        const isHidden = commentsContainer.style.display === 'none' || window.getComputedStyle(commentsContainer).display === 'none';
        if (!force && !isHidden) return;
        commentsContainer.style.display = 'block';
        toggleBtn.innerHTML = '\uD83D\uDCAC <span class="comments-count">Hide Comments</span>';
        this._keepCommentsOpen = true;
        this.setAttribute('data-comments-open', 'true');
        const commentsSection = commentsContainer.querySelector('comments-section');
        if (commentsSection && !commentsSection.commentsLoaded) commentsSection.loadCommentsLazy();
    }
    toggleComments() {
        const commentsContainer = this.querySelector('.post-comments');
        const toggleBtn = this.querySelector('.comments-toggle-btn');
        if (commentsContainer && toggleBtn) {
            const isVisible = commentsContainer.style.display !== 'none';
            if (isVisible) {
                commentsContainer.style.display = 'none';
                toggleBtn.innerHTML = `\u{1F4AC} <span class="comments-count">Comments (${this._post.comment_count || 0})</span>`;
                this._keepCommentsOpen = false;
                this.removeAttribute('data-comments-open');
            } else this.openComments();
        }
    }
    handlePromptReuse(btn) {
        if (!btn) return;
        const promptId = btn.dataset.promptId;
        const promptTitle = btn.dataset.promptTitle;
        const promptBody = btn.dataset.promptBody;
        // Trigger photocopy animation
        const photocopyIcon = btn.querySelector('photocopy-icon');
        if (photocopyIcon && photocopyIcon.triggerCopyAnimation) photocopyIcon.triggerCopyAnimation();
        // Navigate to home and set the prompt in the post writer
        if (window.router) window.router.navigate('/');
        // Dispatch event to set the prompt in the post writer
        setTimeout(()=>{
            document.dispatchEvent(new CustomEvent('prompt-selected', {
                detail: {
                    id: promptId,
                    title: promptTitle,
                    body: promptBody,
                    prompt_type: btn.dataset.promptType || 'text',
                    template_type: btn.dataset.templateType || 'simple'
                }
            }));
        }, 100);
        // Show feedback
        this.showPromptReuseSuccess(promptTitle);
    }
    showPromptReuseSuccess(promptTitle) {
        // Create temporary success notification
        const notification = document.createElement('div');
        notification.className = 'prompt-reuse-notification';
        notification.innerHTML = `
      <div class="notification-content">
        <photocopy-icon size="small"></photocopy-icon>
        <span>Prompt copied! Ready to write with "${promptTitle}"</span>
      </div>
    `;
        notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: var(--success-color);
      color: white;
      padding: 0.75rem 1rem;
      border-radius: 6px;
      font-weight: 500;
      z-index: 10000;
      animation: slideIn 0.3s ease;
      max-width: 300px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    `;
        document.body.appendChild(notification);
        // Remove after 3 seconds
        setTimeout(()=>{
            notification.style.animation = 'slideOut 0.3s ease';
            setTimeout(()=>notification.remove(), 300);
        }, 3000);
    }
    formatTimeAgo(date) {
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return 'just now';
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return `${diffInHours}h ago`;
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7) return `${diffInDays}d ago`;
        // For older posts, show the actual date
        return date.toLocaleDateString();
    }
    renderPostContent(postType, contentHtml, moodIcon, moodStatus, embedPlatform, embedId, embedUrl, embedContentType, embedCountry, urlTitle, urlDescription, urlImage, resolvedUrl, postData) {
        switch(postType){
            case 'mood':
                return this.renderMoodPost(moodIcon, moodStatus, contentHtml);
            case 'music':
                return this.renderMusicPost(embedPlatform, embedId, embedUrl, embedContentType, embedCountry, urlTitle, urlDescription, urlImage, contentHtml);
            case 'poll':
                return this.renderPollPost(postData || this._post);
            default:
                return this.renderTextPost(contentHtml, embedPlatform, embedId, embedUrl, embedContentType, embedCountry, urlTitle, urlDescription, urlImage, resolvedUrl, postData?.source === 'rss', postData?.prompt_template_type);
        }
    }
    renderPollPost(postData) {
        // Prepare poll data for view-poll component
        const pollData = {
            id: postData.id,
            poll_question: postData.poll_question || '',
            poll_options: postData.poll_options || [],
            poll_type: postData.poll_type || 'single',
            poll_closed: postData.poll_closed || false,
            poll_closed_at: postData.poll_closed_at || null,
            total_votes: postData.total_votes,
            total_yes_votes: postData.total_yes_votes,
            total_no_votes: postData.total_no_votes,
            user_voted: postData.user_voted || false,
            can_see_results: postData.can_see_results || false,
            is_owner: postData.is_owner || false
        };
        // Escape JSON for HTML attribute
        const pollDataJson = JSON.stringify(pollData).replace(/"/g, '&quot;');
        const currentUserJson = this._currentUser ? JSON.stringify(this._currentUser).replace(/"/g, '&quot;') : '';
        return `
      <view-poll 
        poll-data="${pollDataJson}"
        ${currentUserJson ? `current-user="${currentUserJson}"` : ''}
      ></view-poll>
    `;
    }
    renderMoodPost(moodIcon, moodStatus, contentHtml) {
        return `
      <div class="mood-post">
        <div class="mood-display">
          <div class="mood-icon-large">${moodIcon}</div>
          ${moodStatus ? `
            <div class="mood-status">
              ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(moodStatus)}
            </div>
          ` : ''}
        </div>
        ${contentHtml ? `
          <div class="post-text">
            ${contentHtml}
          </div>
        ` : ''}
      </div>
    `;
    }
    renderMusicPost(embedPlatform, embedId, embedUrl, embedContentType, embedCountry, urlTitle, urlDescription, urlImage, contentHtml) {
        return `
      <div class="music-post">
        ${embedPlatform && embedId ? `
          <music-player 
            platform="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedPlatform)}"
            embed-id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedId)}"
            embed-url="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedUrl || '')}"
            content-type="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedContentType || '')}"
            country="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedCountry || '')}"
            title="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlTitle || '')}"
            image="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlImage || '')}">
          </music-player>
        ` : `
          <div class="music-fallback">
            <p>\u{1F3B5} Music link: <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedUrl)}" target="_blank" rel="noopener noreferrer">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlTitle || embedUrl)}</a></p>
          </div>
        `}
        ${contentHtml ? `
          <div class="post-text">
            ${contentHtml}
          </div>
        ` : ''}
      </div>
    `;
    }
    renderTextPost(contentHtml, embedPlatform, embedId, embedUrl, embedContentType, embedCountry, urlTitle, urlDescription, urlImage, resolvedUrl, isRssImport = false, promptTemplateType = 'simple') {
        const postContent = contentHtml || '';
        const isStructuredTemplate = promptTemplateType && promptTemplateType !== 'simple';
        const templateClass = isStructuredTemplate ? ' post-text-template' : '';
        let html = `<div class="post-text${templateClass}">${postContent}</div>`;
        if (embedPlatform && embedId) // Show embedded music player for music URLs
        html += `
        <div class="url-preview">
          <music-player 
            platform="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedPlatform)}"
            embed-id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedId)}"
            embed-url="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedUrl || '')}"
            content-type="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedContentType || '')}"
            country="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(embedCountry || '')}"
            title="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlTitle || '')}"
            image="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlImage || '')}">
          </music-player>
        </div>
      `;
        else if (urlTitle && resolvedUrl && (!isRssImport || urlImage)) html += `
        <div class="url-preview">
          <div class="url-preview-card">
            ${urlImage ? `<img src="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlImage)}" alt="Preview" class="url-preview-image" />` : ''}
            <div class="url-preview-content">
              <h4 class="url-preview-title">
                <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(resolvedUrl)}" target="_blank" rel="noopener noreferrer">
                  ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlTitle)}
                </a>
              </h4>
              ${urlDescription ? `<p class="url-preview-description">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlDescription)}</p>` : ''}
            </div>
          </div>
        </div>
      `;
        else if (isRssImport && urlTitle && !urlImage) html += `
        <div class="rss-preview-title-only">
          <h4>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(urlTitle)}</h4>
        </div>
      `;
        return html;
    }
    showError(message) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'alert alert-error';
        errorDiv.textContent = message;
        errorDiv.style.position = 'fixed';
        errorDiv.style.top = '20px';
        errorDiv.style.right = '20px';
        errorDiv.style.zIndex = '10000';
        errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';
        document.body.appendChild(errorDiv);
        setTimeout(()=>errorDiv.remove(), 4000);
    }
}
// Register the custom element
customElements.define('post-item', $0a501e7a9e147a3a$var$PostItem);


/*
  component: template-editor
  title: Structured Writing Prompt Editor
  props:
    - template-type: sections | list
    - template-structure: JSON structure
  methods:
    - getContent: returns assembled markdown
    - setTemplate: configure template
  deps: none
*/ class $391775edcc3ff006$var$TemplateEditor extends HTMLElement {
    constructor(){
        super();
        this.templateType = 'simple';
        this.templateStructure = null;
        this.values = {};
    }
    static get observedAttributes() {
        return [
            'template-type',
            'template-structure'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue) return;
        if (name === 'template-type') this.templateType = newValue || 'simple';
        if (name === 'template-structure') try {
            this.templateStructure = newValue ? JSON.parse(newValue) : null;
        } catch  {
            this.templateStructure = null;
        }
        if (this.isConnected) this.render();
    }
    connectedCallback() {
        this.render();
    }
    setTemplate(type, structure) {
        this.templateType = type || 'simple';
        this.templateStructure = structure ? this.normalizeStructure(structure) : null;
        this.values = {};
        this.render();
    }
    normalizeStructure(structure) {
        if (!structure || typeof structure !== 'object') return structure;
        if (Array.isArray(structure.sections)) return structure;
        const count = Number(structure.count);
        if (Number.isInteger(count) && count >= 2) return {
            ...structure,
            count: count
        };
        return structure;
    }
    getContent() {
        if (this.templateType === 'sections' && this.templateStructure?.sections) return this.templateStructure.sections.map((label)=>{
            const textarea = this.querySelector(`textarea[data-section="${CSS.escape(label)}"]`);
            const content = textarea?.value.trim() || '';
            return `**${label}:**\n${content}`;
        }).join('\n\n');
        if (this.templateType === 'list' && this.templateStructure?.count) {
            const count = Number(this.templateStructure.count);
            const lines = [];
            for(let i = 1; i <= count; i += 1){
                const textarea = this.querySelector(`textarea[data-item="${i}"]`);
                const content = textarea?.value.trim() || '';
                lines.push(`${i}. ${content}`);
            }
            return lines.join('\n');
        }
        return '';
    }
    hasAnyContent() {
        return this.getContent().replace(/[*#\d.\s]/g, '').length > 0;
    }
    render() {
        if (this.templateType === 'sections' && this.templateStructure?.sections) {
            this.innerHTML = `
        <div class="template-editor">
          ${this.templateStructure.sections.map((label)=>`
            <div class="form-group">
              <label class="form-label" for="section-${this.escapeAttr(label)}">${this.escapeHtml(label)}</label>
              <textarea
                class="form-control"
                data-section="${this.escapeAttr(label)}"
                id="section-${this.escapeAttr(label)}"
                placeholder="Write about ${this.escapeHtml(label.toLowerCase())}..."
                rows="3"
              ></textarea>
            </div>
          `).join('')}
        </div>
      `;
            return;
        }
        if (this.templateType === 'list' && this.templateStructure?.count) {
            const count = Number(this.templateStructure.count);
            if (!Number.isInteger(count) || count < 2) {
                this.innerHTML = '';
                return;
            }
            const label = this.templateStructure.label || 'List items';
            this.innerHTML = `
        <div class="template-editor">
          <div class="template-editor-list">
            ${Array.from({
                length: count
            }, (_, i)=>i + 1).map((num)=>`
              <div class="form-group">
                <label class="form-label" for="item-${num}">${this.escapeHtml(label)} #${num}</label>
                <textarea
                  class="form-control"
                  data-item="${num}"
                  id="item-${num}"
                  placeholder="Item ${num}..."
                  rows="2"
                ></textarea>
              </div>
            `).join('')}
          </div>
        </div>
      `;
            return;
        }
        this.innerHTML = '';
    }
    escapeHtml(value) {
        return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    escapeAttr(value) {
        return this.escapeHtml(value).replace(/'/g, '&#39;');
    }
}
customElements.define('template-editor', $391775edcc3ff006$var$TemplateEditor);


/*
  component: collapsible-section
  title: Collapsible Section
  props:
    - summary: header label (required)
    - hint: optional form-text shown at top of body
    - open: expand on load when present
  events:
    - collapsible-toggle: detail { open: boolean }
  deps: none
*/ class $7ef7bd30dfb2b38d$var$CollapsibleSection extends HTMLElement {
    constructor(){
        super();
        this._built = false;
        this._onToggle = this._onToggle.bind(this);
        this._onArrowAnimationEnd = this._onArrowAnimationEnd.bind(this);
    }
    static get observedAttributes() {
        return [
            'summary',
            'hint',
            'open'
        ];
    }
    connectedCallback() {
        if (!this._built) this._build();
        else this._syncFromAttributes();
    }
    disconnectedCallback() {
        this._details?.removeEventListener('toggle', this._onToggle);
        this._arrow?.removeEventListener('animationend', this._onArrowAnimationEnd);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue || !this._built) return;
        this._syncFromAttributes();
    }
    _build() {
        const childNodes = Array.from(this.childNodes);
        this._details = document.createElement('details');
        this._details.className = 'collapsible-section-panel';
        const summaryEl = document.createElement('summary');
        summaryEl.className = 'collapsible-section-summary';
        this._arrow = document.createElement('span');
        this._arrow.className = 'collapsible-section-arrow';
        this._arrow.setAttribute('aria-hidden', 'true');
        this._arrow.textContent = "\u25B8";
        this._arrow.addEventListener('animationend', this._onArrowAnimationEnd);
        this._label = document.createElement('span');
        this._label.className = 'collapsible-section-label';
        summaryEl.appendChild(this._arrow);
        summaryEl.appendChild(this._label);
        this._body = document.createElement('div');
        this._body.className = 'collapsible-section-body';
        this._bodyInner = document.createElement('div');
        this._bodyInner.className = 'collapsible-section-body-inner';
        childNodes.forEach((node)=>{
            this._bodyInner.appendChild(node);
        });
        this._body.appendChild(this._bodyInner);
        this._details.appendChild(summaryEl);
        this._details.appendChild(this._body);
        this.replaceChildren(this._details);
        this._details.addEventListener('toggle', this._onToggle);
        this._built = true;
        this._syncFromAttributes();
    }
    _syncFromAttributes() {
        if (!this._built) return;
        const summaryText = this.getAttribute('summary') || 'Section';
        if (this._label) this._label.textContent = summaryText;
        this._syncHint();
        const shouldOpen = this.hasAttribute('open');
        if (this._details.open !== shouldOpen) this._details.open = shouldOpen;
        this._syncOpenState();
    }
    _syncHint() {
        const hint = this.getAttribute('hint') || '';
        if (!hint) {
            if (this._hintEl) {
                this._hintEl.remove();
                this._hintEl = null;
            }
            return;
        }
        if (!this._hintEl) {
            this._hintEl = document.createElement('p');
            this._hintEl.className = 'form-text collapsible-section-hint';
            this._bodyInner.prepend(this._hintEl);
        }
        this._hintEl.textContent = hint;
    }
    _onToggle() {
        const open = this._details.open;
        if (open) {
            this.setAttribute('open', '');
            this._arrow?.classList.add('collapsible-section-arrow-wiggle');
        } else this.removeAttribute('open');
        this._syncOpenState();
        this.dispatchEvent(new CustomEvent('collapsible-toggle', {
            bubbles: true,
            detail: {
                open: open
            }
        }));
    }
    _onArrowAnimationEnd(event) {
        if (event.animationName === 'collapsible-arrow-wiggle') this._arrow?.classList.remove('collapsible-section-arrow-wiggle');
    }
    _syncOpenState() {
        if (!this._details) return;
        const open = this._details.open;
        this.dataset.open = open ? 'true' : 'false';
        this._details.dataset.open = open ? 'true' : 'false';
    }
}
customElements.define('collapsible-section', $7ef7bd30dfb2b38d$var$CollapsibleSection);


/*
  component: post-style-picker
  title: Post Style Picker
  methods:
    - getStyle: returns selected style object or null
    - getStylePayload: returns { postStyle, lastUsedStyleId } for create calls
    - getLastUsedStyleId: returns saved style id when a named style is loaded
    - setStyle: hydrate picker from saved style object
    - clearStyle: reset selection
    - showError: display inline error message
    - clearError: clear inline error message
  deps: collapsible-section
  events:
    - post-style-change: detail { style }
    - post-style-preview-request: when section expands
*/ 
class $37e6231877ec5668$var$PostStylePicker extends HTMLElement {
    constructor(){
        super();
        this.selectedStyle = null;
        this.lastUsedStyleId = null;
        this.savedStyles = [];
        this._colorsTouched = false;
        this._onClick = this._onClick.bind(this);
        this._onChange = ()=>this.applyCustomStyle();
        this._onColorInput = ()=>{
            this._colorsTouched = true;
            this.applyCustomStyle();
        };
        this._onCollapsibleToggle = this._onCollapsibleToggle.bind(this);
    }
    connectedCallback() {
        this.render();
        this.attachListeners();
        this.updateContrastHint();
        this.loadSavedStylesAndDefault();
    }
    getStyle() {
        return this.selectedStyle;
    }
    getLastUsedStyleId() {
        return this.lastUsedStyleId;
    }
    getStylePayload() {
        const style = this.getStyle();
        if (!style) return {};
        const payload = {
            postStyle: style
        };
        if (this.lastUsedStyleId) payload.lastUsedStyleId = this.lastUsedStyleId;
        return payload;
    }
    showError(message) {
        const el = this.querySelector('.post-style-error');
        if (!el) return;
        el.textContent = message;
        el.hidden = false;
        el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
    }
    clearError() {
        const el = this.querySelector('.post-style-error');
        if (el) {
            el.textContent = '';
            el.hidden = true;
        }
    }
    async loadSavedStylesAndDefault() {
        try {
            const authData = await window.API.request('/auth/status');
            if (!authData.authenticated || !authData.user?.id) return;
            const [stylesRes, settingsRes] = await Promise.all([
                window.API.postStyles.list(),
                window.API.request(`/users/settings/${authData.user.id}`)
            ]);
            this.savedStyles = stylesRes.post_styles || [];
            this._renderSavedStylesList();
            const lastStyle = settingsRes?.last_post_style;
            const lastStyleId = settingsRes?.last_post_style_id;
            if (lastStyle && typeof lastStyle === 'object' && Object.keys(lastStyle).length > 0) this.setStyle(lastStyle, lastStyleId || null);
        } catch (error) {
            window.logger?.debug?.('Could not load saved post styles', error);
        }
    }
    setStyle(style, savedStyleId = null) {
        if (typeof style === 'string') try {
            style = JSON.parse(style);
        } catch  {
            style = null;
        }
        if (!style || typeof style !== 'object' || Object.keys(style).length === 0) {
            this.selectedStyle = null;
            this.lastUsedStyleId = null;
        } else {
            this.selectedStyle = {
                ...style
            };
            this.lastUsedStyleId = savedStyleId;
        }
        this._colorsTouched = Boolean(style?.fgColor || style?.bgColor);
        this.clearError();
        this.render();
        this.attachListeners();
        this._hydrateControls();
        this._emitStyleChange();
        this._renderSavedStylesList();
    }
    clearStyle() {
        this.selectedStyle = null;
        this.lastUsedStyleId = null;
        this._colorsTouched = false;
        this.clearError();
        this.querySelectorAll('.post-style-preset-btn').forEach((btn)=>btn.classList.remove('selected'));
        const fg = this.querySelector('#customFg');
        const bg = this.querySelector('#customBg');
        if (fg) fg.value = '#000000';
        if (bg) bg.value = '#ffffff';
        this._emitStyleChange();
        this._renderSavedStylesList();
    }
    _hydrateControls() {
        if (!this.selectedStyle) return;
        const style = this.selectedStyle;
        const presetColors = style.preset ? (0, $21e114b4db6ffc58$export$30ad063b1803c51b)[style.preset] : null;
        if (style.preset) {
            const presetBtn = this.querySelector(`.post-style-preset-btn[data-preset="${style.preset}"]`);
            if (presetBtn) presetBtn.classList.add('selected');
        }
        const font = this.querySelector('#styleFont');
        if (font) font.value = style.font || '';
        const fontSize = this.querySelector('#styleFontSize');
        if (fontSize) fontSize.value = style.fontSize || '';
        const border = this.querySelector('#styleBorder');
        if (border) border.value = style.border || 'none';
        const fg = this.querySelector('#customFg');
        if (fg) fg.value = style.fgColor || presetColors?.fgColor || '#000000';
        const bg = this.querySelector('#customBg');
        if (bg) bg.value = style.bgColor || presetColors?.bgColor || '#ffffff';
    }
    attachListeners() {
        this.removeEventListener('click', this._onClick);
        this.addEventListener('click', this._onClick);
        this.querySelectorAll('select.form-control').forEach((el)=>{
            el.removeEventListener('change', this._onChange);
            el.addEventListener('change', this._onChange);
        });
        this.querySelectorAll('input.form-control-color').forEach((el)=>{
            el.removeEventListener('input', this._onColorInput);
            el.addEventListener('input', this._onColorInput);
        });
        const saveBtn = this.querySelector('#saveStyleBtn');
        if (saveBtn) {
            saveBtn.removeEventListener('click', this._onSaveStyle);
            this._onSaveStyle = this._onSaveStyle || this.handleSaveStyle.bind(this);
            saveBtn.addEventListener('click', this._onSaveStyle);
        }
        const section = this.querySelector('collapsible-section');
        if (section) {
            section.removeEventListener('collapsible-toggle', this._onCollapsibleToggle);
            section.addEventListener('collapsible-toggle', this._onCollapsibleToggle);
        }
    }
    _onCollapsibleToggle(e) {
        if (e.detail?.open) this.dispatchEvent(new CustomEvent('post-style-preview-request', {
            bubbles: true
        }));
    }
    _emitStyleChange() {
        this.updateContrastHint();
        this.dispatchEvent(new CustomEvent('post-style-change', {
            bubbles: true,
            detail: {
                style: this.selectedStyle
            }
        }));
    }
    updateContrastHint() {
        const contrastHint = this.querySelector('.post-style-contrast-hint');
        if (!contrastHint) return;
        if (!this.selectedStyle) {
            contrastHint.hidden = true;
            return;
        }
        const { fgColor: fgColor, bgColor: bgColor } = (0, $21e114b4db6ffc58$export$3ff6a9d2b4e7f83e)(this.selectedStyle);
        contrastHint.hidden = (0, $21e114b4db6ffc58$export$d13f49e3eef12be8)(fgColor, bgColor);
    }
    async handleSaveStyle() {
        const nameInput = this.querySelector('#saveStyleName');
        const name = nameInput?.value?.trim();
        if (!name) {
            this.showError('Give your style a name before saving.');
            return;
        }
        if (!this.selectedStyle) {
            this.showError('Pick a style to save first.');
            return;
        }
        const saveBtn = this.querySelector('#saveStyleBtn');
        if (saveBtn) saveBtn.disabled = true;
        try {
            const created = await window.API.postStyles.create({
                name: name,
                style: this.selectedStyle
            });
            this.savedStyles.unshift(created.post_style);
            if (nameInput) nameInput.value = '';
            this.lastUsedStyleId = created.post_style.id;
            this.clearError();
            this._renderSavedStylesList();
        } catch (error) {
            this.showError(error.message || 'Could not save style.');
        } finally{
            if (saveBtn) saveBtn.disabled = false;
        }
    }
    async handleDeleteSavedStyle(id) {
        if (!window.confirm('Delete this saved style?')) return;
        try {
            await window.API.postStyles.delete(id);
            this.savedStyles = this.savedStyles.filter((s)=>s.id !== id);
            if (this.lastUsedStyleId === id) this.lastUsedStyleId = null;
            this._renderSavedStylesList();
        } catch (error) {
            this.showError(error.message || 'Could not delete style.');
        }
    }
    _renderSavedStylesList() {
        const list = this.querySelector('#savedStylesList');
        const section = this.querySelector('.post-style-saved-load-section');
        if (!list) return;
        if (this.savedStyles.length === 0) {
            list.innerHTML = '';
            list.hidden = true;
            if (section) section.hidden = true;
            return;
        }
        if (section) section.hidden = false;
        list.hidden = false;
        list.innerHTML = this.savedStyles.map((s)=>`
      <div class="post-style-saved-item">
        <button type="button" class="btn btn-secondary btn-sm post-style-saved-load${this.lastUsedStyleId === s.id ? ' selected' : ''}" data-id="${s.id}">
          ${this.escapeHtml(s.name)}
        </button>
        <button type="button" class="btn btn-secondary btn-sm post-style-saved-delete" data-id="${s.id}" aria-label="Delete ${this.escapeHtml(s.name)}">
          \u{1F5D1}\u{FE0F}
        </button>
      </div>
    `).join('');
        list.querySelectorAll('.post-style-saved-load').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const saved = this.savedStyles.find((s)=>s.id === parseInt(btn.dataset.id, 10));
                if (saved) {
                    const style = typeof saved.style === 'string' ? JSON.parse(saved.style) : saved.style;
                    this.setStyle(style, saved.id);
                }
            });
        });
        list.querySelectorAll('.post-style-saved-delete').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.handleDeleteSavedStyle(parseInt(btn.dataset.id, 10));
            });
        });
    }
    escapeHtml(s) {
        return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    _onClick(e) {
        const presetBtn = e.target.closest('.post-style-preset-btn');
        if (presetBtn) {
            this.querySelectorAll('.post-style-preset-btn').forEach((btn)=>btn.classList.remove('selected'));
            presetBtn.classList.add('selected');
            const preset = presetBtn.dataset.preset;
            this.selectedStyle = {
                preset: preset
            };
            this.lastUsedStyleId = null;
            this._colorsTouched = false;
            this.clearError();
            const presetColors = (0, $21e114b4db6ffc58$export$30ad063b1803c51b)[preset];
            const fg = this.querySelector('#customFg');
            const bg = this.querySelector('#customBg');
            if (fg && presetColors) fg.value = presetColors.fgColor;
            if (bg && presetColors) bg.value = presetColors.bgColor;
            this._emitStyleChange();
            this._renderSavedStylesList();
        }
    }
    applyCustomStyle() {
        const preset = this.querySelector('.post-style-preset-btn.selected')?.dataset.preset;
        const font = this.querySelector('#styleFont')?.value;
        const fontSize = this.querySelector('#styleFontSize')?.value;
        const border = this.querySelector('#styleBorder')?.value;
        const fgColor = this.querySelector('#customFg')?.value;
        const bgColor = this.querySelector('#customBg')?.value;
        this.selectedStyle = {};
        if (preset) this.selectedStyle.preset = preset;
        if (font) this.selectedStyle.font = font;
        if (fontSize) this.selectedStyle.fontSize = fontSize;
        if (border && border !== 'none') this.selectedStyle.border = border;
        const includeColors = this._colorsTouched || !preset;
        if (includeColors && fgColor) this.selectedStyle.fgColor = fgColor;
        if (includeColors && bgColor) this.selectedStyle.bgColor = bgColor;
        if (Object.keys(this.selectedStyle).length === 0) this.selectedStyle = null;
        this.lastUsedStyleId = null;
        this.clearError();
        this._emitStyleChange();
        this._renderSavedStylesList();
    }
    render() {
        this.innerHTML = `
      <collapsible-section
        summary="\u{1F3A8} Post Style (optional)"
        hint="Expand to customize how this post looks. Leave collapsed for the default style."
      >
        <div class="post-style-picker-body">
          <div class="post-style-error alert alert-error" hidden role="alert"></div>
          <div class="post-style-saved-load-section" hidden>
            <div id="savedStylesList" class="post-style-saved-list" hidden></div>
          </div>
          <div class="post-style-presets" role="group" aria-label="Style presets">
            <button type="button" class="btn btn-secondary btn-sm post-style-preset-btn" data-preset="retro-terminal">Retro Terminal</button>
            <button type="button" class="btn btn-secondary btn-sm post-style-preset-btn" data-preset="pastel-dreams">Pastel Dreams</button>
            <button type="button" class="btn btn-secondary btn-sm post-style-preset-btn" data-preset="neon-nights">Neon Nights</button>
            <button type="button" class="btn btn-secondary btn-sm post-style-preset-btn" data-preset="fourth-of-july">\u{1F386} Fourth of July</button>
          </div>
          <div class="form-group">
            <label class="form-label" for="styleFont">Font</label>
            <select id="styleFont" class="form-control">
              <option value="">Default</option>
              <option value="arial">Arial</option>
              <option value="georgia">Georgia</option>
              <option value="courier">Courier</option>
              <option value="comic">Comic Sans</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label" for="styleFontSize">Size</label>
            <select id="styleFontSize" class="form-control">
              <option value="">Normal</option>
              <option value="small">Small</option>
              <option value="large">Large</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label" for="styleBorder">Border</label>
            <select id="styleBorder" class="form-control">
              <option value="none">None</option>
              <option value="soft">Soft</option>
              <option value="dashed">Dashed</option>
              <option value="neon">Neon</option>
              <option value="retro">Retro</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label" for="customFg">Text color</label>
            <input type="color" id="customFg" class="form-control form-control-color" value="#000000" />
          </div>
          <div class="form-group">
            <label class="form-label" for="customBg">Background</label>
            <input type="color" id="customBg" class="form-control form-control-color" value="#ffffff" />
          </div>
          <p class="form-text post-style-contrast-hint" hidden>
            Heads up: these colors may be hard to read for some viewers.
          </p>
          <div class="post-style-save-row">
            <input type="text" id="saveStyleName" class="form-control" placeholder="Style name\u{2026}" maxlength="100" />
            <button type="button" id="saveStyleBtn" class="btn btn-secondary btn-sm">Save style</button>
          </div>
        </div>
      </collapsible-section>
    `;
    }
}
customElements.define('post-style-picker', $37e6231877ec5668$var$PostStylePicker);


/**
 * @component layout-component-picker-modal
 * @css layout-component-picker-modal.css
 * @primitives .btn.btn-secondary, .card
 */ 

/**
 * Unified layout component catalog helpers.
 * Built-ins (Rich Text, Recent Posts) and widgets share one picker catalog.
 */ /**
 * Client-side split-tree layout helpers (mirrors server profile-layout rules).
 */ const $db8fbdb30433d4e7$export$e26138d1506a2c1b = 3;
const $db8fbdb30433d4e7$export$4030221cfc1fb63c = 10;
const $db8fbdb30433d4e7$export$9a5e91d2a719f03 = 1;
const $db8fbdb30433d4e7$export$cdc84a745230c8bc = 8;
const $db8fbdb30433d4e7$export$8086b7ddc3e8b2ca = new Set([
    'posts',
    'widget'
]);
function $db8fbdb30433d4e7$export$33d3cad1d04a6dd1(section = null) {
    return {
        type: 'leaf',
        section: section
    };
}
function $db8fbdb30433d4e7$export$2ee1c5f70f645873(direction, first, second) {
    return {
        type: 'split',
        direction: direction,
        children: [
            first,
            second
        ]
    };
}
function $db8fbdb30433d4e7$export$4891b0a220eddd5e(richTextWidgetId = null) {
    if (richTextWidgetId) return {
        version: 2,
        root: $db8fbdb30433d4e7$export$2ee1c5f70f645873('col', $db8fbdb30433d4e7$export$33d3cad1d04a6dd1({
            id: 'richtext',
            type: 'widget',
            widgetId: richTextWidgetId
        }), $db8fbdb30433d4e7$export$33d3cad1d04a6dd1({
            id: 'posts',
            type: 'posts'
        }))
    };
    return {
        version: 2,
        root: $db8fbdb30433d4e7$export$2ee1c5f70f645873('col', $db8fbdb30433d4e7$export$33d3cad1d04a6dd1({
            id: 'posts',
            type: 'posts'
        }), $db8fbdb30433d4e7$export$33d3cad1d04a6dd1(null))
    };
}
function $db8fbdb30433d4e7$export$874c24d959cd4878(doc) {
    if (doc?.version === 2 && doc.root) {
        const sections = $db8fbdb30433d4e7$export$2d43a298984e547a(doc.root);
        if (sections.some((s)=>s.type === 'about')) return $db8fbdb30433d4e7$export$4891b0a220eddd5e();
        return structuredClone(doc);
    }
    return $db8fbdb30433d4e7$export$4891b0a220eddd5e();
}
function $db8fbdb30433d4e7$export$200587cdebf5a090(doc) {
    return $db8fbdb30433d4e7$export$874c24d959cd4878(doc);
}
function $db8fbdb30433d4e7$export$2d43a298984e547a(root) {
    const sections = [];
    function walk(node) {
        if (!node) return;
        if (node.type === 'leaf') {
            if (node.section) sections.push(node.section);
            return;
        }
        if (node.type === 'split' && Array.isArray(node.children)) node.children.forEach(walk);
    }
    walk(root);
    return sections;
}
function $db8fbdb30433d4e7$export$1d14e1d8187b9aad(path) {
    return path.join('.');
}
function $db8fbdb30433d4e7$export$f54925b846e1a657(root, path) {
    let node = root;
    for (const index of path){
        if (!node || node.type !== 'split' || !node.children?.[index]) return null;
        node = node.children[index];
    }
    return node;
}
function $db8fbdb30433d4e7$var$cloneNode(node) {
    if (!node) return null;
    if (node.type === 'leaf') return $db8fbdb30433d4e7$export$33d3cad1d04a6dd1(node.section ? {
        ...node.section
    } : null);
    return $db8fbdb30433d4e7$export$2ee1c5f70f645873(node.direction, $db8fbdb30433d4e7$var$cloneNode(node.children[0]), $db8fbdb30433d4e7$var$cloneNode(node.children[1]));
}
function $db8fbdb30433d4e7$export$bbde29348c76220b(layout) {
    return {
        version: 2,
        root: $db8fbdb30433d4e7$var$cloneNode(layout.root)
    };
}
function $db8fbdb30433d4e7$var$setNodeAt(root, path, newNode) {
    if (!path.length) return newNode;
    const cloned = $db8fbdb30433d4e7$var$cloneNode(root);
    let parent = cloned;
    for(let i = 0; i < path.length - 1; i += 1)parent = parent.children[path[i]];
    parent.children[path[path.length - 1]] = newNode;
    return cloned;
}
function $db8fbdb30433d4e7$export$16a96228c388a21c(root, path, direction) {
    const node = $db8fbdb30433d4e7$export$f54925b846e1a657(root, path);
    if (!node || node.type !== 'leaf') return null;
    const split = $db8fbdb30433d4e7$export$2ee1c5f70f645873(direction, $db8fbdb30433d4e7$var$cloneNode(node), $db8fbdb30433d4e7$export$33d3cad1d04a6dd1(null));
    return $db8fbdb30433d4e7$var$setNodeAt(root, path, split);
}
function $db8fbdb30433d4e7$export$5cb7859c86013843(root, path, section) {
    const node = $db8fbdb30433d4e7$export$f54925b846e1a657(root, path);
    if (!node || node.type !== 'leaf') return null;
    return $db8fbdb30433d4e7$var$setNodeAt(root, path, $db8fbdb30433d4e7$export$33d3cad1d04a6dd1({
        ...section
    }));
}
function $db8fbdb30433d4e7$export$9eaeb132619b6fc(root, path) {
    const node = $db8fbdb30433d4e7$export$f54925b846e1a657(root, path);
    if (!node || node.type !== 'leaf') return null;
    return $db8fbdb30433d4e7$var$setNodeAt(root, path, $db8fbdb30433d4e7$export$33d3cad1d04a6dd1(null));
}
function $db8fbdb30433d4e7$export$fe02f52ab4cab149(root, path, patch) {
    const node = $db8fbdb30433d4e7$export$f54925b846e1a657(root, path);
    if (!node || node.type !== 'leaf' || !node.section) return null;
    return $db8fbdb30433d4e7$var$setNodeAt(root, path, $db8fbdb30433d4e7$export$33d3cad1d04a6dd1({
        ...node.section,
        ...patch
    }));
}
function $db8fbdb30433d4e7$export$62c6d56246ff2aa6(root, path) {
    const node = $db8fbdb30433d4e7$export$f54925b846e1a657(root, path);
    if (!node || node.type !== 'split') return null;
    const [first, second] = node.children;
    const pick = first.section ? first : second.section ? second : first;
    return $db8fbdb30433d4e7$var$setNodeAt(root, path, $db8fbdb30433d4e7$var$cloneNode(pick));
}
function $db8fbdb30433d4e7$export$db016022cbc16cd3(root, type) {
    return $db8fbdb30433d4e7$export$2d43a298984e547a(root).filter((s)=>s.type === type).length;
}
function $db8fbdb30433d4e7$export$533d69f7c84f09b0(root) {
    const widgets = $db8fbdb30433d4e7$export$2d43a298984e547a(root).filter((s)=>s.type === 'widget');
    return `widget-${widgets.length + 1}`;
}
function $db8fbdb30433d4e7$export$f8a41e52c2de4004(layout) {
    const sections = $db8fbdb30433d4e7$export$2d43a298984e547a(layout.root);
    if (sections.length > $db8fbdb30433d4e7$export$4030221cfc1fb63c) return {
        valid: false,
        error: `At most ${$db8fbdb30433d4e7$export$4030221cfc1fb63c} blocks allowed`
    };
    const widgets = sections.filter((s)=>s.type === 'widget');
    if (widgets.length > $db8fbdb30433d4e7$export$e26138d1506a2c1b) return {
        valid: false,
        error: `At most ${$db8fbdb30433d4e7$export$e26138d1506a2c1b} widgets allowed`
    };
    const ids = new Set();
    for (const section of sections){
        if (ids.has(section.id)) return {
            valid: false,
            error: `Duplicate block id: ${section.id}`
        };
        ids.add(section.id);
    }
    return {
        valid: true
    };
}
function $db8fbdb30433d4e7$export$f2d09b223834d387(type, palette) {
    const entry = palette.find((p)=>p.type === type);
    return entry ? `${entry.icon || ''} ${entry.label}`.trim() : type;
}


const $52a42ad6d68b93da$export$177df1e1128146b5 = 'richtext';
const $52a42ad6d68b93da$export$642fcd2656b6a0df = [
    'Rich Text',
    'About Me'
];
const $52a42ad6d68b93da$export$2453bc9a3c35a846 = [
    {
        key: 'posts',
        name: 'Recent Posts',
        icon: "\uD83D\uDCF0",
        description: 'Your latest posts for friends to browse.',
        maxCount: 1,
        sectionType: 'posts',
        kind: 'builtin'
    }
];
function $52a42ad6d68b93da$export$97a15bca120bacc9(widgets = []) {
    return widgets.find((w)=>$52a42ad6d68b93da$export$642fcd2656b6a0df.includes(w.name));
}
function $52a42ad6d68b93da$export$640d4fa5d3ca0b9(widget) {
    const id = parseInt(widget.id, 10);
    return {
        key: $52a42ad6d68b93da$export$177df1e1128146b5,
        name: 'Rich Text',
        icon: "\uD83D\uDCDD",
        description: widget.description || "Formatted text with markdown \u2014 links, lists, bold, and more.",
        maxCount: 1,
        sectionType: 'widget',
        widgetId: id,
        kind: 'builtin',
        status: 'approved',
        configSchema: widget.configSchema,
        requiresOAuth: false,
        oauthConfig: null,
        oauthClientId: null,
        hasOAuthClientSecret: false
    };
}
function $52a42ad6d68b93da$export$33fcb4a3ab162a5b(widget, catalogGroup = 'widget') {
    const id = parseInt(widget.id, 10);
    const group = widget.catalogGroup || catalogGroup;
    return {
        key: `widget-${id}`,
        name: widget.name,
        icon: "\uD83E\uDDE9",
        description: widget.description || null,
        maxCount: (0, $db8fbdb30433d4e7$export$e26138d1506a2c1b),
        sectionType: 'widget',
        widgetId: id,
        kind: group === 'community' && widget.isPlatform ? 'builtin' : 'widget',
        catalogGroup: group,
        status: widget.status || 'active',
        systemCatalogStatus: widget.systemCatalogStatus || widget.system_catalog_status || 'none',
        configSchema: widget.configSchema,
        requiresOAuth: widget.requiresOAuth,
        oauthConfig: widget.oauthConfig,
        oauthClientId: widget.oauthClientId || null,
        hasOAuthClientSecret: widget.hasOAuthClientSecret === true,
        isPlatform: Boolean(widget.isPlatform)
    };
}
function $52a42ad6d68b93da$export$2fd4d96047f2d97d(catalogInput = [], builtins = $52a42ad6d68b93da$export$2453bc9a3c35a846) {
    const catalog = [];
    let myWidgets = [];
    let communityWidgets = [];
    if (catalogInput && !Array.isArray(catalogInput)) {
        myWidgets = catalogInput.myWidgets || [];
        communityWidgets = catalogInput.communityWidgets || catalogInput.widgets || [];
    } else if (Array.isArray(catalogInput)) communityWidgets = catalogInput;
    const stockRichText = $52a42ad6d68b93da$export$97a15bca120bacc9(communityWidgets) || $52a42ad6d68b93da$export$97a15bca120bacc9(myWidgets);
    if (stockRichText) catalog.push({
        ...$52a42ad6d68b93da$export$640d4fa5d3ca0b9(stockRichText),
        catalogGroup: 'community'
    });
    catalog.push(...builtins.map((entry)=>({
            ...entry,
            catalogGroup: 'community'
        })));
    for (const widget of myWidgets){
        if (!widget?.id) continue;
        if (stockRichText && parseInt(widget.id, 10) === parseInt(stockRichText.id, 10)) continue;
        catalog.push($52a42ad6d68b93da$export$33fcb4a3ab162a5b(widget, 'my'));
    }
    for (const widget of communityWidgets){
        if (!widget?.id) continue;
        if (stockRichText && parseInt(widget.id, 10) === parseInt(stockRichText.id, 10)) continue;
        if (myWidgets.some((m)=>parseInt(m.id, 10) === parseInt(widget.id, 10))) continue;
        catalog.push($52a42ad6d68b93da$export$33fcb4a3ab162a5b(widget, 'community'));
    }
    return catalog;
}
function $52a42ad6d68b93da$export$95d956164f341839(section, stockRichTextWidgetId = null) {
    if (!section) return null;
    if (section.type === 'posts') return 'posts';
    if (section.type === 'widget' && section.widgetId) {
        const wid = parseInt(section.widgetId, 10);
        if (stockRichTextWidgetId && wid === stockRichTextWidgetId) return $52a42ad6d68b93da$export$177df1e1128146b5;
        if (section.id === 'richtext' || section.id === 'about') return $52a42ad6d68b93da$export$177df1e1128146b5;
        return `widget-${section.widgetId}`;
    }
    return null;
}
function $52a42ad6d68b93da$export$50ffe30bcbf3d9a4(entry, layoutRoot, currentSection = null) {
    if (entry.sectionType === 'posts') return {
        id: 'posts',
        type: 'posts'
    };
    if (entry.sectionType === 'widget') {
        const widgetId = parseInt(entry.widgetId, 10);
        if (Number.isNaN(widgetId) || widgetId < 1) throw new Error('Widget catalog entry requires a valid widgetId');
        let id;
        if (entry.key === $52a42ad6d68b93da$export$177df1e1128146b5) id = currentSection?.id === 'about' || currentSection?.id === 'richtext' ? currentSection.id : 'richtext';
        else id = currentSection?.type === 'widget' ? currentSection.id : (0, $db8fbdb30433d4e7$export$533d69f7c84f09b0)(layoutRoot);
        return {
            id: id,
            type: 'widget',
            widgetId: widgetId
        };
    }
    throw new Error(`Unknown catalog sectionType: ${entry.sectionType}`);
}
function $52a42ad6d68b93da$export$55e1dd9111014355(entry, layoutRoot, options = {}) {
    const { excludeSectionId: excludeSectionId = null, mode: mode = 'add' } = options;
    const sections = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layoutRoot);
    if (mode === 'add' && sections.length >= (0, $db8fbdb30433d4e7$export$4030221cfc1fb63c)) return false;
    if (entry.sectionType === 'widget') {
        let widgetCount = (0, $db8fbdb30433d4e7$export$db016022cbc16cd3)(layoutRoot, 'widget');
        if (excludeSectionId) {
            const excluded = sections.find((s)=>s.id === excludeSectionId);
            if (excluded?.type === 'widget') widgetCount -= 1;
        }
        if (mode === 'add' && widgetCount >= (0, $db8fbdb30433d4e7$export$e26138d1506a2c1b)) return false;
        if (mode === 'change' && widgetCount >= (0, $db8fbdb30433d4e7$export$e26138d1506a2c1b)) {
            const excluded = sections.find((s)=>s.id === excludeSectionId);
            if (!(excluded?.type === 'widget')) return false;
        }
        return true;
    }
    const max = entry.maxCount ?? 1;
    let typeCount = (0, $db8fbdb30433d4e7$export$db016022cbc16cd3)(layoutRoot, entry.sectionType);
    if (excludeSectionId) {
        const excluded = sections.find((s)=>s.id === excludeSectionId);
        if (excluded?.type === entry.sectionType) typeCount -= 1;
    }
    return typeCount < max;
}
function $52a42ad6d68b93da$export$8e11f19e114aa3b3(entry) {
    if (entry.systemCatalogStatus && entry.systemCatalogStatus !== 'none' && entry.systemCatalogStatus !== 'approved') return `${entry.name} (${entry.systemCatalogStatus})`;
    return entry.name;
}


class $1b31182e9ea93b23$export$4942467471b90503 extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this._title = 'Choose a component';
        this._mode = 'add';
        this._catalog = [];
        this._canAdd = ()=>true;
        this._currentKey = null;
        this._keydownHandler = this._keydownHandler.bind(this);
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    open(options = {}) {
        this._title = options.title || 'Choose a component';
        this._mode = options.mode === 'change' ? 'change' : 'add';
        this._catalog = Array.isArray(options.catalog) ? options.catalog : [];
        this._canAdd = typeof options.canAdd === 'function' ? options.canAdd : ()=>true;
        this._currentKey = options.currentKey ?? null;
        this.isOpen = true;
        document.body.style.overflow = 'hidden';
        document.removeEventListener('keydown', this._keydownHandler);
        this.render();
        this.attachEventListeners();
        document.addEventListener('keydown', this._keydownHandler);
        requestAnimationFrame(()=>{
            const first = this.querySelector('.layout-component-picker-card:not([disabled])');
            first?.focus();
        });
    }
    close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this._keydownHandler);
        this.render();
        this.attachEventListeners();
        this.dispatchEvent(new CustomEvent('component-picker-close', {
            bubbles: true
        }));
    }
    _keydownHandler(event) {
        if (this.isOpen && event.key === 'Escape') {
            event.preventDefault();
            this.close();
        }
    }
    _visibleEntries() {
        if (this._mode === 'change') return this._catalog.filter((entry)=>this._canAdd(entry));
        return this._catalog.filter((entry)=>this._canAdd(entry));
    }
    _renderCard(entry) {
        const isCurrent = entry.key === this._currentKey;
        const statusBadge = entry.systemCatalogStatus && entry.systemCatalogStatus !== 'none' && entry.systemCatalogStatus !== 'approved' ? `<span class="layout-component-picker-status">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(entry.systemCatalogStatus)}</span>` : '';
        const description = entry.description ? `<p class="layout-component-picker-card-desc">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(entry.description)}</p>` : '';
        return `
      <button
        type="button"
        class="layout-component-picker-card card${isCurrent ? ' is-current' : ''}"
        data-catalog-key="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(entry.key)}"
        aria-pressed="${isCurrent}"
        ${isCurrent ? 'aria-label="' + (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)((0, $52a42ad6d68b93da$export$8e11f19e114aa3b3)(entry)) + ' (current)"' : ''}
      >
        <span class="layout-component-picker-card-icon" aria-hidden="true">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(entry.icon || "\uD83E\uDDE9")}</span>
        <span class="layout-component-picker-card-body">
          <span class="layout-component-picker-card-name">
            ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)((0, $52a42ad6d68b93da$export$8e11f19e114aa3b3)(entry))}
            ${statusBadge}
          </span>
          ${description}
        </span>
      </button>
    `;
    }
    _renderBody() {
        const entries = this._visibleEntries();
        if (!this._catalog.length) return `
        <div class="layout-component-picker-empty">
          <p class="form-text">No components are available for this page.</p>
        </div>
      `;
        if (!entries.length) return `
        <div class="layout-component-picker-empty">
          <p class="form-text">All available components are already on this layout.</p>
        </div>
      `;
        const hint = this._mode === 'change' ? 'Pick a different component for this region.' : 'Pick a component to fill this empty region.';
        const widgetHint = !this._catalog.some((e)=>e.catalogGroup === 'my' || e.kind === 'widget') ? `<p class="form-text layout-component-picker-widget-hint">Want more? <a href="${(0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/settings/widgets')}">Create widgets in Settings</a>.</p>` : '';
        const myEntries = entries.filter((e)=>e.catalogGroup === 'my');
        const communityEntries = entries.filter((e)=>e.catalogGroup !== 'my');
        const renderGroup = (title, groupEntries)=>{
            if (!groupEntries.length) return '';
            return `
        <div class="layout-component-picker-group">
          <h4 class="layout-component-picker-group-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(title)}</h4>
          <div class="layout-component-picker-grid" role="listbox" aria-label="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(title)}">
            ${groupEntries.map((entry)=>this._renderCard(entry)).join('')}
          </div>
        </div>
      `;
        };
        return `
      <p class="modal-description">${hint}</p>
      ${widgetHint}
      ${renderGroup('My widgets', myEntries)}
      ${renderGroup('Community widgets', communityEntries)}
    `;
    }
    render() {
        this.innerHTML = `
      <div class="layout-component-picker-modal ${this.isOpen ? 'open' : ''}" id="layoutComponentPickerModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container" role="dialog" aria-modal="true" aria-labelledby="layoutComponentPickerTitle">
          <div class="modal-header">
            <h3 id="layoutComponentPickerTitle">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this._title)}</h3>
            <button type="button" class="close-btn" id="closeBtn" aria-label="Close">\xd7</button>
          </div>
          <div class="modal-body">
            ${this.isOpen ? this._renderBody() : ''}
          </div>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        this.querySelector('#modalBackdrop')?.addEventListener('click', ()=>this.close());
        this.querySelector('#closeBtn')?.addEventListener('click', ()=>this.close());
        this.querySelectorAll('.layout-component-picker-card').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const key = btn.dataset.catalogKey;
                const entry = this._catalog.find((e)=>e.key === key);
                if (!entry || entry.key === this._currentKey) {
                    this.close();
                    return;
                }
                this.dispatchEvent(new CustomEvent('component-pick', {
                    bubbles: true,
                    detail: {
                        entry: entry
                    }
                }));
                this.close();
            });
        });
    }
    disconnectedCallback() {
        document.removeEventListener('keydown', this._keydownHandler);
        if (this.isOpen) document.body.style.overflow = '';
    }
}
customElements.define('layout-component-picker-modal', $1b31182e9ea93b23$export$4942467471b90503);


/*
  component: layout-split-editor
  title: Layout Split Editor
  props: inline
  methods: setLayout, getLayout, setComponentCatalog, setSectionContent
  events: layout-change, layout-widget-change, layout-section-added
  deps: layout-split utils, layout-component-picker-modal
*/ 



class $96b0573500ad7035$var$LayoutSplitEditor extends HTMLElement {
    constructor(){
        super();
        this._layout = (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(null);
        this._componentCatalog = [];
        this._content = new Map();
        this._instanceConfigValues = new Map();
        this._oauthStatus = new Map();
        this._inline = false;
        this._openMenuPath = null;
        this._pickerPath = null;
        this._pickerMode = null;
        this._mountListenersBound = false;
        this._suppressOutsideClick = false;
        this._outsideClickBound = null;
    }
    connectedCallback() {
        this._inline = this.hasAttribute('inline');
        this.render();
        this._bindMountListeners();
        this._stripOAuthQueryParams();
    }
    _stripOAuthQueryParams() {
        const params = new URLSearchParams(window.location.search);
        if (!params.has('widget_oauth') && !params.has('widget_oauth_error')) return;
        const url = new URL(window.location.href);
        url.searchParams.delete('widget_oauth');
        url.searchParams.delete('widget_oauth_error');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    }
    setLayout(doc) {
        this._layout = (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(doc);
        this.render();
        this._emitChange();
    }
    getLayout() {
        return (0, $db8fbdb30433d4e7$export$bbde29348c76220b)(this._layout);
    }
    setComponentCatalog(entries) {
        this._componentCatalog = Array.isArray(entries) ? entries : [];
        this.render();
        this.refreshOAuthStatuses();
    }
    async refreshOAuthStatuses() {
        const userId = document.querySelector('user-profile')?.profileData?.user?.id;
        if (!userId) return;
        const sections = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(this._layout.root).filter((s)=>s.type === 'widget' && s.widgetId);
        await Promise.all(sections.map(async (section)=>{
            const widget = this._getWidgetMeta(section.widgetId);
            if (!widget?.requiresOAuth && !widget?.oauthConfig) return;
            try {
                const res = await fetch(`/api/widget-instances/${encodeURIComponent(userId)}/${encodeURIComponent(section.id)}/oauth/status`, {
                    credentials: 'include'
                });
                if (res.ok) this._oauthStatus.set(section.id, await res.json());
            } catch  {
                this._oauthStatus.set(section.id, {
                    connected: false
                });
            }
        }));
        this.querySelectorAll('[data-oauth-section]').forEach((el)=>{
            const sectionId = el.dataset.oauthSection;
            const section = sections.find((s)=>s.id === sectionId);
            if (!section) return;
            const widget = this._getWidgetMeta(section.widgetId);
            el.outerHTML = this._renderWidgetOAuthPanel(section, widget);
        });
        this._stripOAuthQueryParams();
    }
    setSectionContent(sectionId, html) {
        this._content.set(sectionId, html);
        const slot = this.querySelector(`[data-section-id="${sectionId}"] .layout-split-editor-preview`);
        if (slot) slot.innerHTML = html;
    }
    clearSectionContent() {
        this._content.clear();
    }
    _emitChange() {
        const validation = (0, $db8fbdb30433d4e7$export$f8a41e52c2de4004)(this._layout);
        this.dispatchEvent(new CustomEvent('layout-change', {
            bubbles: true,
            detail: {
                layout: this.getLayout(),
                valid: validation.valid,
                error: validation.error || null
            }
        }));
    }
    _parsePath(raw) {
        if (!raw) return [];
        return raw.split(',').map((n)=>parseInt(n, 10)).filter((n)=>!Number.isNaN(n));
    }
    getInstanceConfigs() {
        this._syncInstanceConfigFromDom();
        const layout = this.getLayout();
        const configs = [];
        for (const section of (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layout.root)){
            if (section.type !== 'widget' || !section.widgetId) continue;
            const values = this._instanceConfigValues.get(section.id);
            if (!values) continue;
            const config = Object.fromEntries(Object.entries(values).filter(([, v])=>v !== null && v !== undefined && String(v).trim() !== ''));
            if (Object.keys(config).length === 0) continue;
            configs.push({
                sectionId: section.id,
                widgetId: section.widgetId,
                config: config
            });
        }
        return configs;
    }
    _syncInstanceConfigFromDom() {
        this.querySelectorAll('[data-widget-config-field]').forEach((input)=>{
            const sectionId = input.dataset.sectionId;
            const field = input.dataset.widgetConfigField;
            if (!sectionId || !field) return;
            if (!this._instanceConfigValues.has(sectionId)) this._instanceConfigValues.set(sectionId, {});
            const bag = this._instanceConfigValues.get(sectionId);
            bag[field] = input.value;
        });
    }
    _getWidgetMeta(widgetId) {
        const wid = parseInt(widgetId, 10);
        const entry = this._componentCatalog.find((e)=>e.sectionType === 'widget' && parseInt(e.widgetId, 10) === wid);
        if (!entry) return null;
        return {
            id: entry.widgetId,
            name: entry.name,
            status: entry.status,
            configSchema: entry.configSchema,
            requiresOAuth: entry.requiresOAuth,
            oauthConfig: entry.oauthConfig,
            oauthClientId: entry.oauthClientId || null,
            hasOAuthClientSecret: entry.hasOAuthClientSecret === true
        };
    }
    /**
   * Prefill widget instance config before render (e.g. when entering profile edit mode).
   * @param {Map<string, object>} configMap sectionId → public config fields
   */ setInstanceConfigValues(configMap) {
        if (!(configMap instanceof Map)) return;
        for (const [sectionId, config] of configMap.entries())if (config && typeof config === 'object') this._instanceConfigValues.set(sectionId, {
            ...config
        });
    }
    _renderWidgetConfigForm(section) {
        const widget = this._getWidgetMeta(section.widgetId);
        const schema = widget?.configSchema;
        const props = schema?.properties;
        if (!props || typeof props !== 'object') return '';
        const values = this._instanceConfigValues.get(section.id) || {};
        const fields = Object.entries(props).map(([key, def])=>{
            const title = def.title || key;
            const isSecret = def.secret === true;
            const isMarkdown = def.format === 'markdown';
            const val = values[key] !== null && values[key] !== undefined ? values[key] : '';
            const autocomplete = isSecret ? 'new-password' : 'off';
            if (isMarkdown && !isSecret) return `
        <div class="form-group layout-widget-config-field">
          <label class="form-label" for="widget-cfg-${section.id}-${key}">${this._escapeHtml(title)}</label>
          <markdown-preview>
            <textarea
              id="widget-cfg-${section.id}-${key}"
              class="form-control"
              rows="6"
              maxlength="5000"
              placeholder="Write markdown\u{2026}"
              autocomplete="${autocomplete}"
              data-section-id="${this._escapeHtml(section.id)}"
              data-widget-config-field="${this._escapeHtml(key)}"
            >${this._escapeHtml(val)}</textarea>
          </markdown-preview>
          ${def.description ? `<p class="form-text">${this._escapeHtml(def.description)}</p>` : ''}
        </div>
      `;
            const inputType = isSecret ? 'password' : 'text';
            return `
        <div class="form-group layout-widget-config-field">
          <label class="form-label" for="widget-cfg-${section.id}-${key}">${this._escapeHtml(title)}</label>
          <input
            id="widget-cfg-${section.id}-${key}"
            class="form-control"
            type="${inputType}"
            autocomplete="${autocomplete}"
            data-section-id="${this._escapeHtml(section.id)}"
            data-widget-config-field="${this._escapeHtml(key)}"
            value="${this._escapeHtml(val)}"
          />
          ${def.description ? `<p class="form-text">${this._escapeHtml(def.description)}</p>` : ''}
        </div>
      `;
        }).join('');
        return `
      <div class="layout-widget-config card-body" data-widget-config-section="${this._escapeHtml(section.id)}">
        <p class="form-text">Configure this widget for your profile:</p>
        ${fields}
      </div>
    `;
    }
    _renderWidgetOAuthPanel(section, widget) {
        if (!widget?.requiresOAuth && !widget?.oauthConfig) return '';
        const status = this._oauthStatus.get(section.id) || {
            connected: false
        };
        const label = widget.oauthConfig?.serviceLabel || widget.name || 'service';
        if (status.connected) {
            const who = status.accountIdentifier ? ` as <strong>${this._escapeHtml(status.accountIdentifier)}</strong>` : '';
            return `
        <div class="layout-widget-oauth card-body" data-oauth-section="${this._escapeHtml(section.id)}">
          <p class="form-text">Connected${who}.</p>
          <button type="button" class="btn btn-secondary" data-action="oauth-disconnect" data-section-id="${this._escapeHtml(section.id)}">Disconnect</button>
        </div>
      `;
        }
        if (!widget.oauthClientId) return `
        <div class="layout-widget-oauth card-body" data-oauth-section="${this._escapeHtml(section.id)}">
          <p class="form-text layout-widget-oauth-warn" role="alert">OAuth credentials are not configured for this widget yet. A site admin can add the client ID and secret in My Widgets or Admin \u{2192} Profile Widgets.</p>
        </div>
      `;
        const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
        const connectUrl = `/api/widgets/oauth/authorize?widgetId=${section.widgetId}&sectionId=${encodeURIComponent(section.id)}&returnTo=${returnTo}`;
        return `
      <div class="layout-widget-oauth card-body" data-oauth-section="${this._escapeHtml(section.id)}">
        <p class="form-text">Connect your ${this._escapeHtml(label)} account to use this widget.</p>
        <p class="form-text layout-widget-oauth-save-hint">We'll save your layout first, then connect.</p>
        <button
          type="button"
          class="btn btn-primary"
          data-action="oauth-connect"
          data-widget-id="${section.widgetId}"
          data-section-id="${this._escapeHtml(section.id)}"
          data-connect-url="${connectUrl}"
        >Connect with ${this._escapeHtml(label)}</button>
      </div>
    `;
    }
    _applyLayout(nextRoot) {
        if (!nextRoot) return;
        this._layout = {
            version: 2,
            root: nextRoot
        };
        this._openMenuPath = null;
        this.render();
        this._emitChange();
    }
    _handleSplit(path, direction) {
        this._applyLayout((0, $db8fbdb30433d4e7$export$16a96228c388a21c)(this._layout.root, path, direction));
    }
    _handleClear(path) {
        this._applyLayout((0, $db8fbdb30433d4e7$export$9eaeb132619b6fc)(this._layout.root, path));
    }
    _handleMerge(path) {
        this._applyLayout((0, $db8fbdb30433d4e7$export$62c6d56246ff2aa6)(this._layout.root, path));
    }
    _mountPicker() {
        let picker = this.querySelector('layout-component-picker-modal');
        if (!picker) {
            picker = document.createElement('layout-component-picker-modal');
            this.appendChild(picker);
            picker.addEventListener('component-pick', (e)=>{
                this._handleComponentPick(e.detail.entry);
            });
        }
        return picker;
    }
    _openPicker(path, mode) {
        this._pickerPath = path;
        this._pickerMode = mode;
        this._openMenuPath = null;
        const leaf = (0, $db8fbdb30433d4e7$export$f54925b846e1a657)(this._layout.root, path);
        const currentSection = leaf?.section || null;
        const picker = this._mountPicker();
        picker.open({
            title: mode === 'change' ? 'Change component' : 'Add a component',
            mode: mode,
            catalog: this._componentCatalog,
            currentKey: (0, $52a42ad6d68b93da$export$95d956164f341839)(currentSection),
            canAdd: (entry)=>(0, $52a42ad6d68b93da$export$55e1dd9111014355)(entry, this._layout.root, {
                    excludeSectionId: currentSection?.id || null,
                    mode: mode
                })
        });
    }
    _handleComponentPick(entry) {
        const path = this._pickerPath;
        if (!path || !entry) return;
        const leaf = (0, $db8fbdb30433d4e7$export$f54925b846e1a657)(this._layout.root, path);
        const currentSection = leaf?.section || null;
        let section;
        try {
            section = (0, $52a42ad6d68b93da$export$50ffe30bcbf3d9a4)(entry, this._layout.root, currentSection);
        } catch  {
            return;
        }
        const wasAdd = !currentSection;
        const prevSectionId = currentSection?.id ?? null;
        const prevWidgetId = currentSection?.widgetId ?? null;
        this._pickerPath = null;
        this._pickerMode = null;
        if (prevSectionId && prevSectionId !== section.id) {
            this._content.delete(prevSectionId);
            this._instanceConfigValues.delete(prevSectionId);
            this._oauthStatus.delete(prevSectionId);
        }
        this._applyLayout((0, $db8fbdb30433d4e7$export$5cb7859c86013843)(this._layout.root, path, section));
        if (wasAdd) {
            this.dispatchEvent(new CustomEvent('layout-section-added', {
                bubbles: true,
                detail: {
                    sectionId: section.id,
                    type: section.type,
                    widgetId: section.widgetId ?? null
                }
            }));
            return;
        }
        this.dispatchEvent(new CustomEvent('layout-section-added', {
            bubbles: true,
            detail: {
                sectionId: section.id,
                type: section.type,
                widgetId: section.widgetId ?? null
            }
        }));
        if (section.type === 'widget' && section.widgetId !== prevWidgetId) this.dispatchEvent(new CustomEvent('layout-widget-change', {
            bubbles: true,
            detail: {
                sectionId: section.id,
                widgetId: section.widgetId
            }
        }));
    }
    _hasAddableComponents() {
        return this._componentCatalog.some((entry)=>(0, $52a42ad6d68b93da$export$55e1dd9111014355)(entry, this._layout.root, {
                mode: 'add'
            }));
    }
    _renderMenu(path, node) {
        const pathStr = path.join(',');
        const isOpen = this._openMenuPath === pathStr;
        const menuItems = [];
        if (node.type === 'leaf') {
            if (!node.section) {
                if (this._hasAddableComponents()) menuItems.push(`
            <button type="button" class="layout-split-menu-item" data-action="open-picker" data-path="${pathStr}" data-picker-mode="add">
              Add component
            </button>
          `);
                else menuItems.push('<span class="layout-split-menu-empty">No components available</span>');
            } else menuItems.push(`
          <button type="button" class="layout-split-menu-item" data-action="open-picker" data-path="${pathStr}" data-picker-mode="change">
            Change component
          </button>
          <button type="button" class="layout-split-menu-item" data-action="split" data-path="${pathStr}" data-direction="row">
            Split horizontally
          </button>
          <button type="button" class="layout-split-menu-item" data-action="split" data-path="${pathStr}" data-direction="col">
            Split vertically
          </button>
          <button type="button" class="layout-split-menu-item layout-split-menu-item--danger" data-action="clear" data-path="${pathStr}">
            Remove block
          </button>
        `);
            if (path.length > 0) {
                const parentPath = path.slice(0, -1).join(',');
                menuItems.push(`
          <button type="button" class="layout-split-menu-item layout-split-menu-item--danger" data-action="merge" data-path="${parentPath}">
            Remove split
          </button>
        `);
            }
        }
        return `
      <div class="layout-split-region-menu">
        <button
          type="button"
          class="layout-split-menu-toggle"
          data-action="toggle-menu"
          data-path="${pathStr}"
          aria-expanded="${isOpen}"
          aria-haspopup="true"
          aria-label="Layout options"
        >
          <span class="material-symbols-outlined" aria-hidden="true">menu</span>
        </button>
        <div class="layout-split-menu-panel${isOpen ? ' is-open' : ''}" ${isOpen ? '' : 'hidden'}>
          ${menuItems.join('')}
        </div>
      </div>
    `;
    }
    _renderLeafEditor(node, path) {
        const pathStr = path.join(',');
        if (!node.section) {
            const addDisabled = this._hasAddableComponents() ? '' : 'disabled';
            return `
        <div class="layout-split-leaf layout-split-leaf--empty card" data-path="${pathStr}">
          <div class="layout-split-leaf-toolbar">
            ${this._renderMenu(path, node)}
          </div>
          <div class="layout-split-empty-placeholder">
            <button type="button" class="btn-cta layout-split-add-component-btn" data-action="open-picker" data-path="${pathStr}" data-picker-mode="add" ${addDisabled}>
              Add a component
            </button>
            <p class="form-text">Or use the menu to split this region. <a href="${(0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/docs/widgets/add-to-profile')}">Layout docs</a></p>
          </div>
        </div>
      `;
        }
        const { section: section } = node;
        const widget = section.type === 'widget' ? this._getWidgetMeta(section.widgetId) : null;
        const widgetOAuth = section.type === 'widget' ? this._renderWidgetOAuthPanel(section, widget) : '';
        const widgetConfig = section.type === 'widget' && widget?.configSchema?.properties ? this._renderWidgetConfigForm(section) : '';
        return `
      <div class="layout-split-leaf card" data-path="${pathStr}" data-section-id="${section.id}">
        <div class="layout-split-leaf-toolbar">
          ${this._renderMenu(path, node)}
        </div>
        ${widgetOAuth}
        ${widgetConfig}
        <div class="layout-split-editor-preview">${this._content.get(section.id) || ''}</div>
      </div>
    `;
    }
    _renderNodeEditor(node, path = []) {
        if (!node) return '';
        if (node.type === 'leaf') return this._renderLeafEditor(node, path);
        if (node.type === 'split') {
            const dirClass = node.direction === 'row' ? 'layout-split-node--row' : 'layout-split-node--col';
            return `
        <div class="layout-split-node ${dirClass}" data-path="${path.join(',')}">
          ${node.children.map((child, index)=>`
            <div class="layout-split-pane">
              ${this._renderNodeEditor(child, [
                    ...path,
                    index
                ])}
            </div>
          `).join('')}
        </div>
      `;
        }
        return '';
    }
    render() {
        const hint = this._inline ? 'Use the menu on each block to split or swap components.' : 'Use the menu on each block to split regions or change components.';
        const editorClass = this._inline ? 'layout-split-editor layout-split-editor--inline' : 'layout-split-editor';
        let mount = this.querySelector('.layout-split-editor-mount');
        if (!mount) {
            this.innerHTML = '<div class="layout-split-editor-mount"></div>';
            mount = this.querySelector('.layout-split-editor-mount');
            this._mountPicker();
        }
        mount.innerHTML = `
      <div class="${editorClass}">
        <p class="form-text layout-split-editor-hint">${hint}</p>
        <div class="layout-split-editor-root">
          ${this._renderNodeEditor(this._layout.root)}
        </div>
        <p class="layout-split-editor-error form-text" role="alert"></p>
      </div>
    `;
    }
    _bindMountListeners() {
        const mount = this.querySelector('.layout-split-editor-mount');
        if (!mount || this._mountListenersBound) return;
        this._mountListenersBound = true;
        mount.addEventListener('click', (e)=>{
            const toggle = e.target.closest('[data-action="toggle-menu"]');
            if (toggle) {
                e.stopPropagation();
                const path = toggle.dataset.path;
                this._openMenuPath = this._openMenuPath === path ? null : path;
                if (this._openMenuPath) {
                    this._suppressOutsideClick = true;
                    queueMicrotask(()=>{
                        this._suppressOutsideClick = false;
                    });
                }
                this.render();
                return;
            }
            const pickerBtn = e.target.closest('[data-action="open-picker"]');
            if (pickerBtn) {
                e.stopPropagation();
                if (pickerBtn.disabled) return;
                this._openMenuPath = null;
                this._openPicker(this._parsePath(pickerBtn.dataset.path), pickerBtn.dataset.pickerMode || 'add');
                return;
            }
            const splitBtn = e.target.closest('[data-action="split"]');
            if (splitBtn) {
                this._handleSplit(this._parsePath(splitBtn.dataset.path), splitBtn.dataset.direction);
                return;
            }
            const clearBtn = e.target.closest('[data-action="clear"]');
            if (clearBtn) {
                this._handleClear(this._parsePath(clearBtn.dataset.path));
                return;
            }
            const mergeBtn = e.target.closest('[data-action="merge"]');
            if (mergeBtn) {
                this._handleMerge(this._parsePath(mergeBtn.dataset.path));
                return;
            }
            const disconnectBtn = e.target.closest('[data-action="oauth-disconnect"]');
            if (disconnectBtn) {
                e.preventDefault();
                this._handleOAuthDisconnect(disconnectBtn.dataset.sectionId);
                return;
            }
            const connectBtn = e.target.closest('[data-action="oauth-connect"]');
            if (connectBtn) {
                e.preventDefault();
                e.stopPropagation();
                if (connectBtn.disabled) return;
                this.dispatchEvent(new CustomEvent('layout-oauth-connect', {
                    bubbles: true,
                    detail: {
                        widgetId: parseInt(connectBtn.dataset.widgetId, 10),
                        sectionId: connectBtn.dataset.sectionId,
                        connectUrl: connectBtn.dataset.connectUrl
                    }
                }));
            }
        });
        mount.addEventListener('input', (e)=>{
            const input = e.target.closest('[data-widget-config-field]');
            if (!input) return;
            const sectionId = input.dataset.sectionId;
            const field = input.dataset.widgetConfigField;
            if (!sectionId || !field) return;
            if (!this._instanceConfigValues.has(sectionId)) this._instanceConfigValues.set(sectionId, {});
            this._instanceConfigValues.get(sectionId)[field] = input.value;
        });
        if (!this._outsideClickBound) {
            this._outsideClickBound = (e)=>{
                if (this._suppressOutsideClick) return;
                if (!this._openMenuPath) return;
                if (!this.contains(e.target)) {
                    this._openMenuPath = null;
                    this.render();
                }
            };
            document.addEventListener('click', this._outsideClickBound);
        }
    }
    async _handleOAuthDisconnect(sectionId) {
        if (!sectionId) return;
        try {
            const res = await fetch(`/api/users/me/widget-instances/${encodeURIComponent(sectionId)}/oauth`, {
                method: 'DELETE',
                credentials: 'include'
            });
            if (!res.ok) throw new Error('Disconnect failed');
            this._oauthStatus.set(sectionId, {
                connected: false
            });
            await this.refreshOAuthStatuses();
        } catch (err) {
            window.logger?.warn('OAuth disconnect failed:', err);
        }
    }
    disconnectedCallback() {
        if (this._outsideClickBound) {
            document.removeEventListener('click', this._outsideClickBound);
            this._outsideClickBound = null;
        }
    }
    _escapeHtml(value) {
        return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
}
customElements.define('layout-split-editor', $96b0573500ad7035$var$LayoutSplitEditor);


/*
  component: layout-split-view
  title: Layout Split View
  methods: setLayout(doc), setSectionContent(id, html)
  deps: layout-split utils
*/ 
class $c4bfa571a709c7bf$var$LayoutSplitView extends HTMLElement {
    constructor(){
        super();
        this._layout = null;
        this._content = new Map();
    }
    connectedCallback() {
        this.render();
    }
    setLayout(doc) {
        this._layout = doc ? (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(doc) : null;
        this.render();
    }
    setSectionContent(sectionId, html) {
        this._content.set(sectionId, html);
        const slot = this.querySelector(`[data-section-id="${sectionId}"] .layout-split-view-slot`);
        if (slot) slot.innerHTML = html;
    }
    _renderNode(node) {
        if (!node) return '';
        if (node.type === 'leaf') {
            if (!node.section) return '';
            const { id: id } = node.section;
            return `
        <div class="layout-split-leaf" data-section-id="${id}">
          <div class="layout-split-view-slot">${this._content.get(id) || ''}</div>
        </div>
      `;
        }
        if (node.type === 'split') {
            const dirClass = node.direction === 'row' ? 'layout-split-node--row' : 'layout-split-node--col';
            return `
        <div class="layout-split-node ${dirClass}">
          ${node.children.map((child)=>`
            <div class="layout-split-pane">${this._renderNode(child)}</div>
          `).join('')}
        </div>
      `;
        }
        return '';
    }
    render() {
        if (!this._layout?.root) {
            this.innerHTML = '';
            return;
        }
        const sections = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(this._layout.root);
        if (!sections.length) {
            this.innerHTML = '';
            return;
        }
        this.innerHTML = `
      <div class="layout-split-view-root">
        ${this._renderNode(this._layout.root)}
      </div>
    `;
    }
}
customElements.define('layout-split-view', $c4bfa571a709c7bf$var$LayoutSplitView);


/*
  component: layout-grid-surface
  title: Layout Grid Surface
  props:
    - edit-label
  methods:
    - setLayout, getLayout, setComponentCatalog, setSectionRenderer
    - enterEditMode, exitEditMode, isEditMode
  events:
    - layout-surface-save, layout-surface-cancel, layout-change, layout-widget-change
  deps: layout-split-view, layout-split-editor, layout-split utils
*/ 
class $136ee53e128cff1f$var$LayoutGridSurface extends HTMLElement {
    constructor(){
        super();
        this._layout = (0, $db8fbdb30433d4e7$export$4891b0a220eddd5e)();
        this._layoutSnapshot = null;
        this._componentCatalog = [];
        this._sectionRenderer = null;
        this._editMode = false;
        this._pendingInstanceConfigs = null;
    }
    connectedCallback() {
        this.render();
        this._attachToolbarListeners();
    }
    isEditMode() {
        return this._editMode;
    }
    setLayout(doc) {
        this._layout = (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(doc);
        this._renderGrid();
    }
    getLayout() {
        if (this._editMode) {
            const editor = this.querySelector('layout-split-editor');
            return editor ? editor.getLayout() : structuredClone(this._layout);
        }
        return structuredClone(this._layout);
    }
    setComponentCatalog(entries) {
        this._componentCatalog = Array.isArray(entries) ? entries : [];
        const editor = this.querySelector('layout-split-editor');
        if (editor) editor.setComponentCatalog(this._componentCatalog);
    }
    setSectionRenderer(fn) {
        this._sectionRenderer = typeof fn === 'function' ? fn : null;
        this._mountSectionContent();
    }
    setPendingInstanceConfigs(configMap) {
        this._pendingInstanceConfigs = configMap instanceof Map ? configMap : null;
    }
    enterEditMode() {
        if (this._editMode) return;
        this._layoutSnapshot = structuredClone(this.getLayout());
        this._editMode = true;
        this.classList.add('is-editing');
        this.render();
        this._attachToolbarListeners();
        this._mountSectionContent();
    }
    exitEditMode(restore = false) {
        if (!this._editMode) return;
        if (restore && this._layoutSnapshot) this._layout = structuredClone(this._layoutSnapshot);
        this._editMode = false;
        this._layoutSnapshot = null;
        this.classList.remove('is-editing');
        this.render();
        this._mountSectionContent();
        if (restore) this.dispatchEvent(new CustomEvent('layout-surface-cancel', {
            bubbles: true
        }));
    }
    render() {
        const editLabel = this.getAttribute('edit-label') || 'Editing layout';
        const toolbarHidden = this._editMode ? '' : 'hidden';
        this.innerHTML = `
      <div class="layout-grid-surface-inner">
        <div class="layout-grid-surface-toolbar card" ${toolbarHidden}>
          <span class="layout-grid-surface-toolbar-label">${this._escapeHtml(editLabel)}</span>
          <div class="layout-grid-surface-toolbar-actions">
            <button type="button" class="btn btn-secondary" data-action="surface-cancel">Cancel</button>
            <button type="button" class="btn btn-primary" data-action="surface-save">Save</button>
          </div>
        </div>
        <div class="layout-grid-surface-grid"></div>
      </div>
    `;
        this._renderGrid();
    }
    _renderGrid() {
        const container = this.querySelector('.layout-grid-surface-grid');
        if (!container) return;
        if (this._editMode) {
            container.innerHTML = '<layout-split-editor inline></layout-split-editor>';
            const editor = container.querySelector('layout-split-editor');
            editor.setComponentCatalog(this._componentCatalog);
            if (this._pendingInstanceConfigs?.size) {
                editor.setInstanceConfigValues(this._pendingInstanceConfigs);
                this._pendingInstanceConfigs = null;
            }
            editor.setLayout(this._layout);
            editor.addEventListener('layout-change', (e)=>{
                this._layout = e.detail.layout;
                this._mountSectionContent();
            });
            editor.addEventListener('layout-widget-change', (e)=>{
                this._refreshSectionPreview(e.detail.sectionId);
            });
            editor.addEventListener('layout-section-added', ()=>{
                this._mountSectionContent();
            });
        } else {
            container.innerHTML = '<layout-split-view></layout-split-view>';
            const view = container.querySelector('layout-split-view');
            view.setLayout(this._layout);
        }
    }
    _mountSectionContent() {
        if (!this._sectionRenderer) return;
        const mode = this._editMode ? 'edit' : 'view';
        const layout = this.getLayout();
        const sections = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layout.root);
        sections.forEach((section)=>{
            const html = this._sectionRenderer(section, {
                mode: mode
            }) ?? '';
            if (this._editMode) {
                const editor = this.querySelector('layout-split-editor');
                if (editor) {
                    editor.setSectionContent(section.id, html);
                    const slot = editor.querySelector(`[data-section-id="${section.id}"] .layout-split-editor-preview`);
                    slot?.classList.add('layout-read-only');
                }
            } else {
                const view = this.querySelector('layout-split-view');
                view?.setSectionContent(section.id, html);
            }
        });
    }
    _refreshSectionPreview(sectionId) {
        if (!this._sectionRenderer || !this._editMode) return;
        const layout = this.getLayout();
        const section = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layout.root).find((s)=>s.id === sectionId);
        if (!section) return;
        const editor = this.querySelector('layout-split-editor');
        if (!editor) return;
        const html = this._sectionRenderer(section, {
            mode: 'edit'
        }) ?? '';
        editor.setSectionContent(sectionId, html);
        const slot = editor.querySelector(`[data-section-id="${sectionId}"] .layout-split-editor-preview`);
        slot?.classList.add('layout-read-only');
    }
    _attachToolbarListeners() {
        this.querySelector('[data-action="surface-cancel"]')?.addEventListener('click', ()=>{
            this.exitEditMode(true);
        });
        this.querySelector('[data-action="surface-save"]')?.addEventListener('click', ()=>{
            const layout = this.getLayout();
            const validation = (0, $db8fbdb30433d4e7$export$f8a41e52c2de4004)(layout);
            const sections = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layout.root);
            if (!validation.valid || sections.length < (0, $db8fbdb30433d4e7$export$9a5e91d2a719f03)) {
                const errEl = this.querySelector('.layout-split-editor-error');
                if (errEl) errEl.textContent = validation.error || 'Layout is invalid.';
                return;
            }
            this._layout = layout;
            const editor = this.querySelector('layout-split-editor');
            const instanceConfigs = editor?.getInstanceConfigs?.() || [];
            this.dispatchEvent(new CustomEvent('layout-surface-save', {
                bubbles: true,
                detail: {
                    layout: layout,
                    instanceConfigs: instanceConfigs
                }
            }));
        });
    }
    _escapeHtml(value) {
        return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
}
customElements.define('layout-grid-surface', $136ee53e128cff1f$var$LayoutGridSurface);


/*
  component: fot-widget
  title: Sandboxed Widget Embed
  props:
    - widget-id: widget ID to load
    - instance-id: layout section id
    - owner-user-id: profile owner user id
  deps: none
*/ 


class $3547b7b615bb802f$var$FotWidget extends HTMLElement {
    constructor(){
        super();
        this.port = null;
        this.onMessageHandler = null;
        this.pendingFetches = new Map();
        this._flagStatus = null;
        this._revealed = false;
    }
    static get observedAttributes() {
        return [
            'widget-id',
            'instance-id',
            'owner-user-id'
        ];
    }
    connectedCallback() {
        (0, $0e9422cfd4c14bfe$export$56344e971e4bbd75)();
        this.render();
        this.loadWidget();
    }
    disconnectedCallback() {
        this.cleanupChannel();
    }
    get widgetId() {
        return this.getAttribute('widget-id');
    }
    get instanceId() {
        return this.getAttribute('instance-id');
    }
    get ownerUserId() {
        return this.getAttribute('owner-user-id');
    }
    get widgetHostDomain() {
        return (0, $af08569b79d42cf2$export$93120b5c6ce37c17)();
    }
    cleanupChannel() {
        if (this.port && this.onMessageHandler) {
            this.port.removeEventListener('message', this.onMessageHandler);
            this.port.close();
        }
        this.port = null;
        this.onMessageHandler = null;
        this.pendingFetches.clear();
    }
    async fetchFlagStatus() {
        const ownerId = this.ownerUserId;
        const sectionId = this.instanceId;
        const widgetId = this.widgetId;
        if (!ownerId || !sectionId || !widgetId) return null;
        try {
            const params = new URLSearchParams({
                widgetId: String(widgetId),
                profileOwnerUserId: String(ownerId),
                sectionId: String(sectionId)
            });
            const res = await fetch(`/api/widgets/flag-status?${params}`, {
                credentials: 'include'
            });
            if (!res.ok) return null;
            return res.json();
        } catch (err) {
            window.logger?.warn('Widget flag status check failed:', err);
            return null;
        }
    }
    async handlePortMessage(event, iframe) {
        const data = event.data || {};
        const { type: type, requestId: requestId, height: height } = data;
        const reply = (payload)=>{
            if (!this.port) return;
            this.port.postMessage(payload);
        };
        const replyError = (code, message)=>{
            if (!requestId) return;
            reply({
                type: 'FOT.ERROR',
                requestId: requestId,
                code: code,
                message: message
            });
        };
        if (type === 'FOT.READY') {
            this.querySelector('.fot-widget-loading')?.remove();
            return;
        }
        if (type === 'FOT.RESIZE' && height) {
            iframe.style.height = `${Math.max(80, Number(height))}px`;
            return;
        }
        if (type === 'FOT.OPEN_EXTERNAL') {
            (0, $a5da319c704aa0ee$export$29ac8f00d0f8fe39)(data.url);
            return;
        }
        if (type === 'FOT.RENDER_MARKDOWN') {
            try {
                const ownerId = this.ownerUserId;
                const sectionId = this.instanceId;
                if (!ownerId || !sectionId) {
                    replyError('PREVIEW_UNSUPPORTED', 'Markdown render requires profile widget instance');
                    return;
                }
                const res = await fetch(`/api/widget-instances/${encodeURIComponent(ownerId)}/${encodeURIComponent(sectionId)}/render-markdown`, {
                    credentials: 'include'
                });
                const json = await res.json();
                if (!res.ok) {
                    replyError(json.code || 'UPSTREAM_ERROR', json.error || 'Markdown render failed');
                    return;
                }
                reply({
                    type: 'FOT.RENDER_MARKDOWN_RESPONSE',
                    requestId: requestId,
                    html: json.html || ''
                });
            } catch (err) {
                window.logger?.error('FOT.RENDER_MARKDOWN failed:', err);
                replyError('UPSTREAM_ERROR', 'Markdown render failed');
            }
            return;
        }
        if (!requestId) return;
        if (type === 'FOT.GET_INSTANCE_CONFIG') {
            try {
                const ownerId = this.ownerUserId;
                const sectionId = this.instanceId;
                if (!ownerId || !sectionId) {
                    replyError('NOT_CONFIGURED', 'Widget instance context missing');
                    return;
                }
                const res = await fetch(`/api/widget-instances/${encodeURIComponent(ownerId)}/${encodeURIComponent(sectionId)}/config`, {
                    credentials: 'include'
                });
                if (!res.ok) {
                    replyError('FORBIDDEN', 'Could not load config');
                    return;
                }
                const json = await res.json();
                reply({
                    type: 'FOT.INSTANCE_CONFIG',
                    requestId: requestId,
                    config: json.config || {}
                });
            } catch (err) {
                window.logger?.error('FOT.GET_INSTANCE_CONFIG failed:', err);
                replyError('UPSTREAM_ERROR', 'Config request failed');
            }
            return;
        }
        if (type === 'FOT.FETCH') try {
            const ownerId = this.ownerUserId;
            const sectionId = this.instanceId;
            if (!ownerId || !sectionId) {
                replyError('PREVIEW_UNSUPPORTED', 'Fetch requires profile widget instance');
                return;
            }
            const res = await fetch(`/api/widget-instances/${encodeURIComponent(ownerId)}/${encodeURIComponent(sectionId)}/fetch`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    url: data.url,
                    init: data.init
                })
            });
            const json = await res.json();
            if (!res.ok) {
                replyError(json.code || 'UPSTREAM_ERROR', json.error || 'Fetch failed');
                return;
            }
            reply({
                type: 'FOT.FETCH_RESPONSE',
                requestId: requestId,
                ok: json.ok,
                status: json.status,
                headers: json.headers,
                body: json.body
            });
        } catch (err) {
            window.logger?.error('FOT.FETCH failed:', err);
            replyError('UPSTREAM_ERROR', 'Fetch request failed');
        }
    }
    setupMessageChannel(iframe) {
        this.cleanupChannel();
        const channel = new MessageChannel();
        this.port = channel.port1;
        this.onMessageHandler = (event)=>{
            this.handlePortMessage(event, iframe);
        };
        this.port.addEventListener('message', this.onMessageHandler);
        this.port.start();
        const widgetOrigin = new URL(this.widgetHostDomain).origin;
        iframe.contentWindow.postMessage({
            type: 'WIDGET_CHANNEL_INIT',
            widgetId: this.widgetId,
            instanceId: this.instanceId,
            ownerUserId: this.ownerUserId
        }, widgetOrigin, [
            channel.port2
        ]);
    }
    shouldShowWidget() {
        if (!this._flagStatus) return true;
        if (this._flagStatus.hidden) return false;
        if (this._flagStatus.gated && !this._revealed) return false;
        return true;
    }
    updateGateOverlay() {
        const gate = this.querySelector('.fot-widget-gate');
        const iframe = this.querySelector('iframe');
        if (!gate) return;
        if (!this._flagStatus) {
            gate.hidden = true;
            if (iframe) iframe.hidden = false;
            return;
        }
        if (this._flagStatus.hidden) {
            gate.hidden = false;
            gate.innerHTML = '<p class="fot-widget-gate-message">This widget is under review.</p>';
            if (iframe) iframe.hidden = true;
            return;
        }
        if (this._flagStatus.gated && !this._revealed) {
            gate.hidden = false;
            gate.innerHTML = `
        <p class="fot-widget-gate-message">This widget was flagged by another user.</p>
        <button type="button" class="btn btn-secondary btn-sm fot-widget-reveal-btn">Show anyway</button>
      `;
            gate.querySelector('.fot-widget-reveal-btn')?.addEventListener('click', async ()=>{
                this._revealed = true;
                const iframe = this.querySelector('iframe');
                if (iframe?.src) {
                    this.updateGateOverlay();
                    return;
                }
                await this.loadWidget();
            }, {
                once: true
            });
            if (iframe) iframe.hidden = true;
            return;
        }
        gate.hidden = true;
        if (iframe) iframe.hidden = false;
    }
    async refreshFlagStatus() {
        this._flagStatus = await this.fetchFlagStatus();
        this.updateGateOverlay();
    }
    async loadWidget() {
        const iframe = this.querySelector('iframe');
        if (!iframe || !this.widgetId) return;
        this._flagStatus = await this.fetchFlagStatus();
        this.updateGateOverlay();
        if (!this.shouldShowWidget()) {
            this.querySelector('.fot-widget-loading')?.remove();
            return;
        }
        let src = `${this.widgetHostDomain}/render/${encodeURIComponent(this.widgetId)}`;
        const ownerId = this.ownerUserId;
        const sectionId = this.instanceId;
        if (ownerId && sectionId) try {
            const res = await fetch(`/api/widget-instances/${encodeURIComponent(ownerId)}/${encodeURIComponent(sectionId)}/render-token`, {
                credentials: 'include'
            });
            if (res.ok) {
                const { token: token } = await res.json();
                if (token) src += `?profileToken=${encodeURIComponent(token)}`;
            }
        } catch (err) {
            window.logger?.warn('Widget render token fetch failed:', err);
        }
        iframe.src = src;
        iframe.addEventListener('load', ()=>{
            try {
                this.setupMessageChannel(iframe);
            } catch (error) {
                window.logger?.error('Failed to setup widget MessageChannel:', error);
            }
        }, {
            once: true
        });
        iframe.addEventListener('error', ()=>{
            this.innerHTML = '<div class="fot-widget-error">Widget failed to load.</div>';
        }, {
            once: true
        });
    }
    render() {
        if (!this.widgetId) {
            this.innerHTML = '<div class="fot-widget-error">No widget specified.</div>';
            return;
        }
        this.innerHTML = `
      <div class="fot-widget">
        <div class="fot-widget-gate" hidden></div>
        <div class="fot-widget-loading loading-state"><span class="spinner"></span></div>
        <iframe
          title="Widget ${this.widgetId}"
          sandbox="allow-scripts allow-same-origin"
          loading="lazy"
        ></iframe>
      </div>
    `;
    }
}
customElements.define('fot-widget', $3547b7b615bb802f$var$FotWidget);


/**
 * @component widget-flag-picker-modal
 * @css profile-widget-flag-bar.css
 * @primitives .btn.btn-primary, .btn.btn-secondary, .form-group, .form-control
 */ 
const $2653946ebd0210be$var$FLAG_REASONS = [
    'inappropriate',
    'copyright',
    'spam',
    'broken',
    'privacy'
];
const $2653946ebd0210be$var$FLAG_REASON_LABELS = {
    inappropriate: 'Inappropriate content',
    copyright: 'Copyright concern',
    spam: 'Spam',
    broken: 'Broken or misleading',
    privacy: 'Privacy concern'
};
class $2653946ebd0210be$export$f2a288a7cb26c6dc extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this._step = 'widgets';
        this._widgets = [];
        this._selectedWidget = null;
        this._onSelect = null;
        this._keydownHandler = this._keydownHandler.bind(this);
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    disconnectedCallback() {
        document.removeEventListener('keydown', this._keydownHandler);
        if (this.isOpen) document.body.style.overflow = '';
    }
    open(options = {}) {
        this._widgets = Array.isArray(options.widgets) ? options.widgets : [];
        this._onSelect = typeof options.onSelect === 'function' ? options.onSelect : null;
        this._step = 'widgets';
        this._selectedWidget = null;
        this.isOpen = true;
        document.body.style.overflow = 'hidden';
        document.removeEventListener('keydown', this._keydownHandler);
        this.render();
        this.attachEventListeners();
        document.addEventListener('keydown', this._keydownHandler);
        requestAnimationFrame(()=>{
            this._focusInitialControl();
        });
    }
    close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this._step = 'widgets';
        this._widgets = [];
        this._selectedWidget = null;
        this._onSelect = null;
        document.body.style.overflow = '';
        document.removeEventListener('keydown', this._keydownHandler);
        this.render();
        this.attachEventListeners();
        this.dispatchEvent(new CustomEvent('widget-flag-picker-close', {
            bubbles: true
        }));
    }
    _focusInitialControl() {
        if (this._step === 'reason') {
            this.querySelector('#widgetFlagReason')?.focus();
            return;
        }
        this.querySelector('.widget-flag-picker-item')?.focus();
    }
    _goToReasonStep(widget) {
        this._selectedWidget = widget;
        this._step = 'reason';
        this.render();
        this.attachEventListeners();
        requestAnimationFrame(()=>this._focusInitialControl());
    }
    _goToWidgetStep() {
        this._selectedWidget = null;
        this._step = 'widgets';
        this.render();
        this.attachEventListeners();
        requestAnimationFrame(()=>this._focusInitialControl());
    }
    _keydownHandler(event) {
        if (!this.isOpen) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            if (this._step === 'reason') {
                this._goToWidgetStep();
                return;
            }
            this.close();
        }
    }
    _getTitle() {
        if (this._step === 'reason' && this._selectedWidget) return `Flag \u{201C}${this._selectedWidget.name}\u{201D}`;
        return 'Which widget do you want to flag?';
    }
    _renderWidgetStep() {
        if (!this._widgets.length) return `
        <div class="widget-flag-picker-empty">
          <p class="form-text">No widgets are available to flag.</p>
        </div>
      `;
        return `
      <p class="modal-description">Pick the widget you want to report.</p>
      <div class="widget-flag-picker-list" role="listbox" aria-label="Widgets on this profile">
        ${this._widgets.map((widget)=>`
          <button
            type="button"
            class="widget-flag-picker-item card"
            data-section-id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.sectionId)}"
            role="option"
          >
            <span class="widget-flag-picker-item-icon" aria-hidden="true">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.icon || "\uD83E\uDDE9")}</span>
            <span class="widget-flag-picker-item-name">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.name)}</span>
          </button>
        `).join('')}
      </div>
    `;
    }
    _renderReasonStep() {
        const options = $2653946ebd0210be$var$FLAG_REASONS.map((reason)=>`
      <option value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(reason)}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)($2653946ebd0210be$var$FLAG_REASON_LABELS[reason])}</option>
    `).join('');
        return `
      <p class="modal-description">Tell us why you are flagging this widget.</p>
      <form class="widget-flag-reason-form" id="widgetFlagReasonForm">
        <div class="form-group">
          <label class="form-label" for="widgetFlagReason">Reason</label>
          <select id="widgetFlagReason" class="form-control" required>
            <option value="" disabled selected>Select a reason\u{2026}</option>
            ${options}
          </select>
        </div>
        <div class="widget-flag-picker-actions">
          <button type="button" class="btn btn-secondary" data-action="reason-back">Back</button>
          <button type="submit" class="btn btn-primary">Submit flag</button>
        </div>
      </form>
    `;
    }
    _renderBody() {
        if (this._step === 'reason') return this._renderReasonStep();
        return this._renderWidgetStep();
    }
    render() {
        this.innerHTML = `
      <div class="widget-flag-picker-modal ${this.isOpen ? 'open' : ''}" id="widgetFlagPickerModal">
        <div class="modal-backdrop" id="widgetFlagPickerBackdrop"></div>
        <div class="modal-container" role="dialog" aria-modal="true" aria-labelledby="widgetFlagPickerTitle">
          <div class="modal-header">
            <h3 id="widgetFlagPickerTitle">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this._getTitle())}</h3>
            <button type="button" class="close-btn" id="widgetFlagPickerCloseBtn" aria-label="Close">\xd7</button>
          </div>
          <div class="modal-body">
            ${this.isOpen ? this._renderBody() : ''}
          </div>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        this.querySelector('#widgetFlagPickerBackdrop')?.addEventListener('click', ()=>this.close());
        this.querySelector('#widgetFlagPickerCloseBtn')?.addEventListener('click', ()=>this.close());
        this.querySelectorAll('.widget-flag-picker-item').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const sectionId = btn.dataset.sectionId;
                const widget = this._widgets.find((w)=>w.sectionId === sectionId);
                if (!widget) return;
                this._goToReasonStep(widget);
            });
        });
        this.querySelector('[data-action="reason-back"]')?.addEventListener('click', ()=>{
            this._goToWidgetStep();
        });
        this.querySelector('#widgetFlagReasonForm')?.addEventListener('submit', async (event)=>{
            event.preventDefault();
            const select = this.querySelector('#widgetFlagReason');
            const reason = select?.value;
            if (!reason || !$2653946ebd0210be$var$FLAG_REASONS.includes(reason) || !this._selectedWidget || !this._onSelect) return;
            try {
                await this._onSelect(this._selectedWidget, reason);
                this.close();
            } catch (err) {
                alert(err.message || 'Could not submit flag');
            }
        });
    }
}
customElements.define('widget-flag-picker-modal', $2653946ebd0210be$export$f2a288a7cb26c6dc);


/*
  component: widget-demo-page
  title: Widget Demo Canary Page
  deps: fot-widget
*/ 
class $1977974b0d05b9d4$var$WidgetDemoPage extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.innerHTML = `
      <div class="card">
        <div class="card-body">
          <h2>\u{1F9E9} Widget Demo</h2>
          <p>Sandboxed iframe from the widget host with MessageChannel communication.
            <a href="${(0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/docs/widgets')}">Widget docs</a> \xb7
            <a href="${(0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/docs/widgets/message-channel')}">MessageChannel protocol</a>
          </p>
          <fot-widget widget-id="1"></fot-widget>
        </div>
      </div>
    `;
    }
}
customElements.define('widget-demo-page', $1977974b0d05b9d4$var$WidgetDemoPage);


// Post Writer Web Component

class $3670c14bfa67d55a$var$PostWriter extends HTMLElement {
    constructor(){
        super();
        this.isSubmitting = false;
        this.selectedPrompt = null;
        this.postType = 'text'; // 'text', 'mood', 'music', or 'poll'
        this.groupThreads = [];
        this.usingTemplateEditor = false;
    }
    static get observedAttributes() {
        return [
            'group-id',
            'thread-id'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue && this.isConnected) {
            if (name === 'thread-id' || name === 'thread-name') this.updateGroupStreamHint();
            this.updateGroupModeVisibility();
        }
    }
    get groupId() {
        const raw = this.getAttribute('group-id');
        if (!raw) return null;
        const id = parseInt(raw, 10);
        return Number.isNaN(id) ? null : id;
    }
    get threadId() {
        const raw = this.getAttribute('thread-id');
        if (!raw) return null;
        const id = parseInt(raw, 10);
        return Number.isNaN(id) ? null : id;
    }
    isGroupMode() {
        return this.groupId !== null;
    }
    setGroupThreads(threads) {
        this.groupThreads = Array.isArray(threads) ? threads.filter((t)=>!t.archived_at) : [];
        if (this.isConnected) this.updateGroupStreamHint();
    }
    getThreadDisplayName() {
        if (!this.threadId) return "\uD83D\uDCF0 Main feed";
        const attrName = this.getAttribute('thread-name');
        if (attrName) return `\u{1F9F5} ${attrName}`;
        const thread = this.groupThreads.find((t)=>t.id === this.threadId);
        return thread ? `\u{1F9F5} ${thread.name}` : "\uD83E\uDDF5 This thread";
    }
    renderGroupStreamHint() {
        if (!this.isGroupMode()) return '';
        return `
      <p class="group-stream-hint" aria-live="polite">
        Posting to <strong>${this.escapeHtml(this.getThreadDisplayName())}</strong>
        <span class="group-stream-hint-detail">Use the feed menu above to switch streams.</span>
      </p>
    `;
    }
    updateGroupStreamHint() {
        const hint = this.querySelector('.group-stream-hint strong');
        if (hint) hint.textContent = this.getThreadDisplayName();
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.updateGroupModeVisibility();
        this.updateCustomizationVisibility();
    }
    escapeHtml(s) {
        return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    render() {
        this.innerHTML = `
      <div class="card">
        <div class="card-body">
          <!-- Mood Selector (shown when mood type is selected) -->
          <div class="mood-section">
            <mood-selector id="moodSelector"></mood-selector>
          </div>
          
          <!-- Music Selector (shown when music type is selected) -->
          <div class="music-section">
            <music-selector id="musicSelector"></music-selector>
          </div>
          
          <!-- Poll Editor (shown when poll type is selected) -->
          <div class="poll-section">
            <edit-poll id="editPoll"></edit-poll>
          </div>
          
          <!-- Text Post Form (shown when text type is selected) -->
          <form id="postWriterForm" class="post-form" novalidate>
            <div class="form-group">
              <prompt-picker id="promptPicker"></prompt-picker>
              ${this.renderGroupStreamHint()}
              <input 
                type="text" 
                class="form-control title-input" 
                name="title" 
                placeholder="Post title..."
                maxlength="255"
              />
              <markdown-preview>
                <textarea 
                  class="form-control" 
                  name="content" 
                  placeholder="Write here... (Markdown supported!)"
                  rows="6"
                ></textarea>
              </markdown-preview>
              <div class="template-editor-container" hidden>
                <template-editor id="templateEditor"></template-editor>
              </div>
            </div>
            <div class="alert-container"></div>
          </form>

          <post-style-picker id="postStylePicker" hidden></post-style-picker>

          <div class="form-actions post-form-actions">
            <button type="submit" form="postWriterForm" class="btn btn-primary">
              <span class="btn-text">${this.isGroupMode() ? 'Post' : 'Share Post'}</span>
              <span class="spinner hidden"></span>
            </button>
            <button type="button" class="btn btn-secondary clear-btn">
              Clear
            </button>
          </div>
        </div>
      </div>
    `;
        this.updatePostTypeVisibility();
        this.updateGroupModeVisibility();
        this.updateCustomizationVisibility();
    }
    updateCustomizationVisibility() {
        const stylePicker = this.querySelector('#postStylePicker');
        if (stylePicker) stylePicker.hidden = this.isGroupMode();
    }
    updateGroupModeVisibility() {
        const inGroup = this.isGroupMode();
        const promptPicker = this.querySelector('#promptPicker');
        const titleInput = this.querySelector('.title-input');
        const moodSection = this.querySelector('.mood-section');
        const musicSection = this.querySelector('.music-section');
        const pollSection = this.querySelector('.poll-section');
        const streamHint = this.querySelector('.group-stream-hint');
        if (promptPicker) promptPicker.style.display = inGroup ? 'none' : '';
        if (titleInput) titleInput.style.display = inGroup ? 'none' : '';
        if (streamHint) streamHint.style.display = inGroup ? '' : 'none';
        if (moodSection) moodSection.style.display = inGroup ? 'none' : moodSection.style.display;
        if (musicSection) musicSection.style.display = inGroup ? 'none' : musicSection.style.display;
        if (pollSection) pollSection.style.display = inGroup ? 'none' : pollSection.style.display;
        if (inGroup) {
            this.postType = 'text';
            this.updatePostTypeVisibility();
        }
    }
    attachEventListeners() {
        const form = this.querySelector('.post-form');
        const titleInput = this.querySelector('input[name="title"]');
        const textarea = this.querySelector('textarea[name="content"]');
        const submitBtn = this.querySelector('button[type="submit"]');
        const clearBtn = this.querySelector('.clear-btn');
        const promptPicker = this.querySelector('#promptPicker');
        const markdownPreview = this.querySelector('.post-form markdown-preview');
        if (markdownPreview?.bindTitleInput && titleInput) markdownPreview.bindTitleInput(titleInput);
        // Listen for post type switch requests from child components
        this.addEventListener('switch-post-type', (e)=>{
            const type = e.detail.type;
            if (type !== this.postType) this.switchPostType(type);
        });
        // Listen for mood shared events
        const moodSelector = this.querySelector('#moodSelector');
        if (moodSelector) moodSelector.addEventListener('mood-shared', (e)=>{
            // Switch back to text mode and refresh the feed
            this.switchPostType('text');
            this.dispatchEvent(new CustomEvent('post-created', {
                detail: e.detail.moodPost,
                bubbles: true
            }));
        });
        // Listen for music shared events
        const musicSelector = this.querySelector('#musicSelector');
        if (musicSelector) musicSelector.addEventListener('music-shared', (e)=>{
            // Switch back to text mode and refresh the feed
            this.switchPostType('text');
            this.dispatchEvent(new CustomEvent('post-created', {
                detail: e.detail.musicPost,
                bubbles: true
            }));
        });
        // Listen for poll created events
        const editPoll = this.querySelector('#editPoll');
        if (editPoll) editPoll.addEventListener('poll-created', (e)=>{
            // Switch back to text mode and refresh the feed
            this.switchPostType('text');
            this.dispatchEvent(new CustomEvent('post-created', {
                detail: e.detail.pollPost,
                bubbles: true
            }));
        });
        // Enable/disable submit button based on content
        textarea.addEventListener('input', ()=>{
            const content = textarea.value.trim();
            submitBtn.disabled = content.length === 0;
        });
        // Auto-resize textarea
        textarea.addEventListener('input', ()=>{
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 'px';
        });
        // Form submission
        form.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handleSubmit();
        });
        // Clear button
        clearBtn.addEventListener('click', ()=>{
            this.clearForm();
        });
        // Keyboard shortcuts
        textarea.addEventListener('keydown', (e)=>{
            // Ctrl/Cmd + Enter to submit
            if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
                e.preventDefault();
                if (!submitBtn.disabled) this.handleSubmit();
            }
        });
        // Handle prompt selection
        if (promptPicker) promptPicker.addEventListener('prompt-selected', async (e)=>{
            const prompt = await this.loadPromptDetails(e.detail.prompt);
            this.selectedPrompt = prompt;
            // If it's a poll prompt, switch to poll mode
            if (prompt.prompt_type === 'poll') {
                this.switchPostType('poll');
                const editPoll = this.querySelector('#editPoll');
                if (editPoll) editPoll.setPromptData(prompt);
                return;
            }
            // For text prompts, populate the form
            this.applyTextPrompt(prompt);
        });
        if (promptPicker) promptPicker.addEventListener('prompt-cleared', ()=>{
            this.selectedPrompt = null;
            // Clear both title and textarea when prompt is cleared
            titleInput.value = '';
            textarea.value = '';
            textarea.dispatchEvent(new Event('input'));
        });
        // Listen for prompt reuse from other components
        document.addEventListener('prompt-selected', (e)=>{
            this.handlePromptReuse(e.detail);
        });
        this._bindPostStylePreview();
    }
    getPostStylePayload() {
        const stylePicker = this.querySelector('#postStylePicker');
        if (!stylePicker || stylePicker.hidden) return {};
        return stylePicker.getStylePayload?.() || {};
    }
    _getPostStylePreviewTarget() {
        switch(this.postType){
            case 'text':
                {
                    if (this.usingTemplateEditor) return null;
                    const markdownPreview = this.querySelector('.post-form markdown-preview');
                    return markdownPreview ? {
                        type: 'markdown',
                        el: markdownPreview
                    } : null;
                }
            case 'mood':
                return {
                    type: 'element',
                    el: this.querySelector('#moodSelector .mood-selector') || this.querySelector('#moodSelector')
                };
            case 'music':
                return {
                    type: 'element',
                    el: this.querySelector('#musicSelector .music-selector') || this.querySelector('#musicSelector')
                };
            case 'poll':
                return {
                    type: 'element',
                    el: this.querySelector('#editPoll .edit-poll') || this.querySelector('#editPoll')
                };
            default:
                return null;
        }
    }
    _applyPostStylePreview(style, { flipTextPreview: flipTextPreview = false } = {}) {
        const target = this._getPostStylePreviewTarget();
        if (!target) return;
        if (target.type === 'markdown') {
            if (flipTextPreview) target.el.setMode('preview');
            if (style) target.el.applyPostStyle(style);
            else target.el.clearPostStyle();
            return;
        }
        if (!target.el) return;
        if (style) (0, $7346618887d6de45$export$d2fad7ce6a2a6489)(target.el, style);
        else (0, $7346618887d6de45$export$63f9f7d3280584f2)(target.el);
        if (this.postType === 'music') {
            const musicPreview = this.querySelector('#musicSelector #musicPreview');
            if (musicPreview && musicPreview.style.display !== 'none') musicPreview.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }
    }
    _bindPostStylePreview() {
        this.addEventListener('post-style-preview-request', ()=>{
            const stylePicker = this.querySelector('#postStylePicker');
            const style = stylePicker?.getStyle?.() ?? null;
            this._applyPostStylePreview(style, {
                flipTextPreview: true
            });
        });
        this.addEventListener('post-style-change', (e)=>{
            this._applyPostStylePreview(e.detail?.style ?? null);
        });
        const musicSelector = this.querySelector('#musicSelector');
        if (musicSelector) musicSelector.addEventListener('music-preview-shown', ()=>{
            const stylePicker = this.querySelector('#postStylePicker');
            const style = stylePicker?.getStyle?.() ?? null;
            if (style) this._applyPostStylePreview(style);
        });
    }
    async handleSubmit() {
        if (this.isSubmitting) return;
        const titleInput = this.querySelector('input[name="title"]');
        const textarea = this.querySelector('textarea[name="content"]');
        const title = titleInput.value.trim();
        const templateEditor = this.querySelector('#templateEditor');
        let content;
        if (this.usingTemplateEditor && templateEditor) {
            if (!templateEditor.hasAnyContent()) {
                this.showAlert('Please write something before posting.', 'error');
                return;
            }
            content = templateEditor.getContent().trim();
        } else {
            content = textarea.value.trim();
            if (!content) {
                this.showAlert('Please write something before posting.', 'error');
                return;
            }
        }
        this.setSubmitting(true);
        this.clearAlerts();
        try {
            let post;
            if (this.isGroupMode()) {
                const thread_id = this.threadId ?? null;
                post = await window.API.request(`/groups/${this.groupId}/posts`, {
                    method: 'POST',
                    body: JSON.stringify({
                        content_markdown: content,
                        thread_id: thread_id
                    })
                });
            } else {
                const postData = {
                    title: title || '',
                    content: content
                };
                if (this.selectedPrompt) postData.promptId = this.selectedPrompt.id;
                Object.assign(postData, this.getPostStylePayload());
                post = await window.API.posts.create(postData);
            }
            // Clear form but keep last-used post style for the next write
            this.clearForm(false);
            // Show success message
            this.showAlert(this.isGroupMode() ? "Posted! \uD83C\uDF89" : "Post shared successfully! \uD83C\uDF89", 'success');
            // Notify feeds (document listener; bubbling alone is unreliable across re-renders)
            document.dispatchEvent(new CustomEvent('post-created', {
                detail: post,
                bubbles: true
            }));
        } catch (error) {
            window.logger.error('Failed to create post:', error);
            const message = error.message || 'Failed to share post. Please try again.';
            this.showAlert(message, 'error');
            const stylePicker = this.querySelector('#postStylePicker');
            if (stylePicker?.getStyle?.() && stylePicker.showError) stylePicker.showError(message);
        } finally{
            this.setSubmitting(false);
        }
    }
    setSubmitting(isSubmitting) {
        this.isSubmitting = isSubmitting;
        const submitBtn = this.querySelector('button[type="submit"]');
        const btnText = this.querySelector('.btn-text');
        const spinner = this.querySelector('.spinner');
        const textarea = this.querySelector('textarea');
        if (isSubmitting) {
            submitBtn.disabled = true;
            btnText.textContent = 'Sharing...';
            spinner.classList.remove('hidden');
            textarea.disabled = true;
        } else {
            submitBtn.disabled = textarea.value.trim().length === 0;
            btnText.textContent = this.isGroupMode() ? 'Post' : 'Share Post';
            spinner.classList.add('hidden');
            textarea.disabled = false;
        }
    }
    switchPostType(type) {
        if (type === this.postType) return;
        this.postType = type;
        this.updatePostTypeVisibility();
    }
    updatePostTypeVisibility() {
        const sections = {
            text: this.querySelector('.post-form'),
            mood: this.querySelector('.mood-section'),
            music: this.querySelector('.music-section'),
            poll: this.querySelector('.poll-section')
        };
        for (const [type, section] of Object.entries(sections))if (section) section.style.display = type === this.postType ? 'block' : 'none';
        const formActions = this.querySelector('.post-form-actions');
        if (formActions) formActions.style.display = this.postType === 'text' ? 'flex' : 'none';
        this.querySelectorAll('post-type-selector').forEach((selector)=>{
            if (selector.setSelectedType) selector.setSelectedType(this.postType);
            else selector.setAttribute('selected-type', this.postType);
        });
    }
    refreshPostsFeed() {
        // Find and refresh the posts feed component
        const postsFeed = document.querySelector('posts-feed');
        if (postsFeed && postsFeed.load) postsFeed.load();
        // Also refresh activity panel if it exists
        const activityPanel = document.querySelector('activity-panel');
        if (activityPanel && activityPanel.loadFriendActivities) activityPanel.loadFriendActivities();
    }
    async loadPromptDetails(promptData) {
        if (!promptData) return promptData;
        let prompt = promptData;
        if (prompt.id && window.API?.prompts?.getById) try {
            const response = await window.API.prompts.getById(prompt.id);
            if (response?.prompt) prompt = response.prompt;
        } catch (error) {
            window.logger?.warn('Could not fetch full prompt details:', error);
        }
        return {
            id: prompt.id,
            title: prompt.title,
            body: prompt.body,
            prompt_type: prompt.prompt_type || 'text',
            template_type: prompt.template_type || 'simple',
            template_structure: prompt.template_structure || null
        };
    }
    async handlePromptReuse(promptData) {
        // If it's a poll prompt, switch to poll mode
        if (promptData.prompt_type === 'poll') {
            this.switchPostType('poll');
            this.selectedPrompt = promptData;
            // Update the prompt picker to show the selected prompt
            const promptPicker = this.querySelector('#promptPicker');
            if (promptPicker && promptPicker.setSelectedPrompt) promptPicker.setSelectedPrompt(this.selectedPrompt);
            // Set prompt data in edit-poll component
            const editPoll = this.querySelector('#editPoll');
            if (editPoll) editPoll.setPromptData(promptData);
            return;
        }
        promptData = await this.loadPromptDetails(promptData);
        // For text prompts, switch to text mode if not already
        if (this.postType !== 'text') this.switchPostType('text');
        // Set the selected prompt
        this.selectedPrompt = promptData;
        // Update the prompt picker to show the selected prompt
        const promptPicker = this.querySelector('#promptPicker');
        if (promptPicker && promptPicker.setSelectedPrompt) promptPicker.setSelectedPrompt(this.selectedPrompt);
        this.applyTextPrompt(this.selectedPrompt);
    }
    applyTextPrompt(prompt) {
        const titleInput = this.querySelector('input[name="title"]');
        const textarea = this.querySelector('textarea[name="content"]');
        const markdownPreview = this.querySelector('markdown-preview');
        const templateContainer = this.querySelector('.template-editor-container');
        const templateEditor = this.querySelector('#templateEditor');
        const submitBtn = this.querySelector('button[type="submit"]');
        if (titleInput && prompt.title) titleInput.value = prompt.title;
        const useStructured = prompt.template_type && prompt.template_type !== 'simple' && prompt.template_structure;
        this.usingTemplateEditor = Boolean(useStructured);
        if (useStructured && templateEditor && templateContainer) {
            templateContainer.hidden = false;
            if (markdownPreview) markdownPreview.hidden = true;
            if (textarea) textarea.disabled = true;
            templateEditor.setTemplate(prompt.template_type, prompt.template_structure);
            if (submitBtn) submitBtn.disabled = false;
            return;
        }
        if (templateContainer) templateContainer.hidden = true;
        if (markdownPreview) markdownPreview.hidden = false;
        if (textarea) textarea.disabled = false;
        if (textarea && prompt.body) {
            textarea.value = prompt.body;
            textarea.dispatchEvent(new Event('input'));
            textarea.focus();
            textarea.setSelectionRange(textarea.value.length, textarea.value.length);
        } else if (textarea) textarea.focus();
    }
    clearForm(clearStyle = true) {
        const titleInput = this.querySelector('input[name="title"]');
        const textarea = this.querySelector('textarea[name="content"]');
        const promptPicker = this.querySelector('#promptPicker');
        const moodSelector = this.querySelector('#moodSelector');
        const musicSelector = this.querySelector('#musicSelector');
        const editPoll = this.querySelector('#editPoll');
        // Clear text post fields
        if (titleInput) titleInput.value = '';
        if (textarea) {
            textarea.value = '';
            textarea.style.height = 'auto';
            textarea.disabled = false;
        }
        if (promptPicker && promptPicker.clearPrompt) promptPicker.clearPrompt();
        this.selectedPrompt = null;
        this.usingTemplateEditor = false;
        const templateContainer = this.querySelector('.template-editor-container');
        const markdownPreview = this.querySelector('markdown-preview');
        const templateEditor = this.querySelector('#templateEditor');
        const stylePicker = this.querySelector('#postStylePicker');
        if (templateContainer) templateContainer.hidden = true;
        if (markdownPreview) markdownPreview.hidden = false;
        if (templateEditor) templateEditor.setTemplate('simple', null);
        if (clearStyle && stylePicker?.clearStyle) stylePicker.clearStyle();
        if (!clearStyle && stylePicker?.loadSavedStylesAndDefault) stylePicker.loadSavedStylesAndDefault();
        // Clear mood selector if in mood mode
        if (moodSelector && moodSelector.reset) moodSelector.reset();
        // Clear music selector if in music mode
        if (musicSelector && musicSelector.reset) musicSelector.reset();
        // Clear poll editor if in poll mode
        if (editPoll && editPoll.clearPoll) editPoll.clearPoll();
        // Reset submit button state
        const submitBtn = this.querySelector('button[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        // Focus appropriate input
        if (this.postType === 'text' && textarea) textarea.focus();
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('.alert-container');
        const alert = document.createElement('div');
        alert.className = `alert alert-${type}`;
        alert.textContent = message;
        container.appendChild(alert);
        alert.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
        });
        const dismissMs = type === 'error' ? 10000 : 5000;
        setTimeout(()=>{
            if (alert.parentNode) alert.remove();
        }, dismissMs);
    }
    clearAlerts() {
        const container = this.querySelector('.alert-container');
        container.innerHTML = '';
    }
}
// Register the custom element
customElements.define('post-writer', $3670c14bfa67d55a$var$PostWriter);


/**
 * @component feed-filters
 * @css feed-filters.css
 * @primitives btn btn-secondary
 */ class $a2e49cefb424e3ca$var$FeedFilters extends HTMLElement {
    constructor(){
        super();
        this.filters = null;
        this.currentUser = null;
        this.isLoading = true;
        this.isSaving = false;
        this.error = null;
        this._onFiltersChanged = this._onFiltersChanged.bind(this);
    }
    connectedCallback() {
        this.render();
        this.loadFilters().then(()=>{
            this.attachEventListeners();
        });
    }
    disconnectedCallback() {
        document.removeEventListener('feed-filters-changed', this._onFiltersChanged);
    }
    _onFiltersChanged(event) {
        if (event.detail?.source === this) return;
        this.loadFilters();
    }
    async loadFilters() {
        try {
            this.isLoading = true;
            this.error = null;
            this.render();
            const authData = await window.API.request('/auth/status');
            if (!authData.authenticated) {
                this.filters = null;
                return;
            }
            this.currentUser = authData.user;
            this.filters = await window.API.feedFilters.get(this.currentUser.id);
        } catch (err) {
            window.logger.error('Failed to load feed filters', err, {
                component: 'feed-filters'
            });
            this.error = err.message || 'Failed to load feed filters';
        } finally{
            this.isLoading = false;
            this.render();
            this.attachEventListeners();
        }
    }
    render() {
        if (this.isLoading) {
            this.innerHTML = `
        <div class="feed-filters-panel">
          <div class="loading-state">
            <div class="spinner"></div>
            <div>Loading filters...</div>
          </div>
        </div>
      `;
            return;
        }
        if (this.error) {
            this.innerHTML = `
        <div class="feed-filters-panel">
          <div class="error-state">
            <p>${this.error}</p>
            <button type="button" class="btn btn-secondary retry-btn">Try again</button>
          </div>
        </div>
      `;
            return;
        }
        if (!this.filters) {
            this.innerHTML = '';
            return;
        }
        this.innerHTML = `
      <div class="feed-filters-panel">
        <div class="filter-group">
          <span class="filter-group-label">Sources</span>
          <div class="filter-chips">
            ${this.renderChip('feed_show_rss', 'RSS imports')}
            ${this.renderChip('feed_show_facebook', 'Facebook imports')}
            ${this.renderChip('feed_show_memory_share', 'Memory shares')}
          </div>
        </div>

        <div class="filter-group">
          <span class="filter-group-label">Groups</span>
          <div class="filter-chips">
            ${this.renderChip('feed_show_groups', 'Group posts')}
          </div>
        </div>

        <div class="filter-group">
          <span class="filter-group-label">Post types</span>
          <div class="filter-chips">
            ${this.renderChip('feed_show_text', 'Text')}
            ${this.renderChip('feed_show_mood', 'Mood')}
            ${this.renderChip('feed_show_music', 'Music')}
            ${this.renderChip('feed_show_poll', 'Polls')}
          </div>
        </div>

        ${this.isSaving ? '<p class="feed-filters-saving">Saving\u2026</p>' : ''}
      </div>
    `;
    }
    renderChip(field, label) {
        const enabled = Boolean(this.filters[field]);
        return `
      <button type="button"
              class="filter-chip ${enabled ? 'is-on' : 'is-off'}"
              data-field="${field}"
              aria-pressed="${enabled ? 'true' : 'false'}"
              ${this.isSaving ? 'disabled' : ''}>
        ${label}
      </button>
    `;
    }
    attachEventListeners() {
        document.addEventListener('feed-filters-changed', this._onFiltersChanged);
        this.querySelector('.retry-btn')?.addEventListener('click', ()=>{
            this.loadFilters();
        });
        this.querySelectorAll('.filter-chip').forEach((chip)=>{
            chip.addEventListener('click', ()=>{
                this.handleChipToggle(chip);
            });
        });
    }
    async handleChipToggle(chip) {
        if (this.isSaving || !this.currentUser || !this.filters) return;
        const field = chip.dataset.field;
        const nextValue = !this.filters[field];
        const previous = this.filters[field];
        this.filters[field] = nextValue;
        this.isSaving = true;
        this.render();
        this.attachEventListeners();
        try {
            const updated = await window.API.feedFilters.update(this.currentUser.id, {
                [field]: nextValue
            });
            this.filters = updated;
            document.dispatchEvent(new CustomEvent('feed-filters-changed', {
                detail: {
                    source: this
                }
            }));
        } catch (err) {
            window.logger.error('Failed to update feed filter', err, {
                component: 'feed-filters',
                field: field
            });
            this.filters[field] = previous;
            this.error = err.message || 'Failed to save filter';
        } finally{
            this.isSaving = false;
            this.render();
            this.attachEventListeners();
        }
    }
}
customElements.define('feed-filters', $a2e49cefb424e3ca$var$FeedFilters);


/**
 * @component feed-filters-modal
 * @css feed-filters-modal.css
 * @primitives btn btn-secondary, feed-filters
 */ class $4b109ca20f89c046$var$FeedFiltersModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this._keydownHandler = this._keydownHandler.bind(this);
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="feed-filters-modal ${this.isOpen ? 'open' : ''}" id="feedFiltersModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>\u{1F50D} Feed filters</h3>
            <button type="button" class="close-btn" id="closeBtn" aria-label="Close">\xd7</button>
          </div>

          <div class="modal-body">
            <p class="modal-description">
              Hide categories from your home feed and new-post emails.
            </p>
            ${this.isOpen ? '<feed-filters></feed-filters>' : ''}
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" id="doneBtn">Done</button>
          </div>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        const closeBtn = this.querySelector('#closeBtn');
        const doneBtn = this.querySelector('#doneBtn');
        const backdrop = this.querySelector('#modalBackdrop');
        const closeModal = ()=>{
            this.close();
        };
        closeBtn?.addEventListener('click', closeModal);
        doneBtn?.addEventListener('click', closeModal);
        backdrop?.addEventListener('click', closeModal);
    }
    _keydownHandler(event) {
        if (this.isOpen && event.key === 'Escape') this.close();
    }
    open() {
        this.isOpen = true;
        document.removeEventListener('keydown', this._keydownHandler);
        this.render();
        this.attachEventListeners();
        document.addEventListener('keydown', this._keydownHandler);
        setTimeout(()=>{
            this.querySelector('#doneBtn')?.focus();
        }, 100);
    }
    close() {
        this.isOpen = false;
        document.removeEventListener('keydown', this._keydownHandler);
        this.render();
        this.attachEventListeners();
    }
}
customElements.define('feed-filters-modal', $4b109ca20f89c046$var$FeedFiltersModal);


// Posts Feed Web Component

// Utility for checking component visibility and lazy-loading
// Components can use this to only load data when they're actually visible
/**
 * Check if an element is currently visible in the DOM
 * @param {HTMLElement} element - The element to check
 * @returns {boolean} - True if the element is visible
 */ function $df142e7fab527392$export$795910f5f15a9633(element) {
    if (!element) return false;
    // Check if element has display: none or is not in the layout
    return element.offsetParent !== null && !element.style.display?.includes('none') && element.offsetWidth > 0 && element.offsetHeight > 0;
}
function $df142e7fab527392$export$7c347855cb535aff(element, callback, options = {}) {
    if (!element || typeof callback !== 'function') return null;
    // If already visible, call callback immediately
    if ($df142e7fab527392$export$795910f5f15a9633(element)) {
        callback();
        return null;
    }
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '50px',
        ...options
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting && $df142e7fab527392$export$795910f5f15a9633(element)) {
                callback();
                observer.disconnect(); // Only trigger once
            }
        });
    }, observerOptions);
    observer.observe(element);
    return observer;
}



class $d3db3142a9f285b6$var$PostsFeed extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.posts = [];
        this.isLoading = false;
        this.isLoadingMore = false;
        this.error = null;
        this.currentUser = null;
        this.currentPage = 1;
        this.pagination = null;
        this.isLoadingPosts = false; // Prevent multiple simultaneous calls
        this.visibilityObserver = null;
        this.hasLoadedOnce = false; // Track if we've loaded data at least once
        // Ensure posts is always an array
        if (!this.posts) this.posts = [];
    }
    static get observedAttributes() {
        return [
            'group-id',
            'thread-id'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue && this.isConnected && (name === 'group-id' || name === 'thread-id')) {
            this.hasLoadedOnce = false;
            this.currentPage = 1;
            this.loadIfVisible();
        }
    }
    get groupId() {
        const raw = this.getAttribute('group-id');
        if (!raw) return null;
        const id = parseInt(raw, 10);
        return Number.isNaN(id) ? null : id;
    }
    get threadId() {
        const raw = this.getAttribute('thread-id');
        if (!raw) return null;
        const id = parseInt(raw, 10);
        return Number.isNaN(id) ? null : id;
    }
    isGroupMode() {
        return this.groupId !== null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
        this.attachDocumentListeners();
        // Read page from URL if present
        const urlParams = new URLSearchParams(window.location.search);
        const pageParam = urlParams.get('page');
        if (pageParam) {
            const page = parseInt(pageParam, 10);
            if (!isNaN(page) && page > 0) this.currentPage = page;
        }
        const initialPageAttr = this.getAttribute('data-initial-page');
        if (initialPageAttr) {
            const page = parseInt(initialPageAttr, 10);
            if (!isNaN(page) && page > 0) this.currentPage = page;
        }
        // Only load if visible, otherwise wait for visibility
        this.loadIfVisible();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // Clean up visibility observer
        if (this.visibilityObserver) {
            this.visibilityObserver.disconnect();
            this.visibilityObserver = null;
        }
    }
    /**
   * Load data only if component is visible, otherwise observe for visibility
   */ loadIfVisible() {
        if ((0, $df142e7fab527392$export$795910f5f15a9633)(this)) {
            this.load();
            this.hasLoadedOnce = true;
        } else // Component is hidden, wait for it to become visible
        this.visibilityObserver = (0, $df142e7fab527392$export$7c347855cb535aff)(this, ()=>{
            if (!this.hasLoadedOnce) {
                this.load();
                this.hasLoadedOnce = true;
            }
        });
    }
    renderHeaderActions() {
        if (this.isGroupMode()) return `
        <button class="btn btn-secondary refresh-btn">
          <span class="refresh-icon">\u{1F504}</span>
          Refresh
        </button>
      `;
        return `
      <div class="feed-header-actions">
        <button class="btn btn-secondary refresh-btn">
          <span class="refresh-icon">\u{1F504}</span>
          Refresh
        </button>
        <toolbar-overflow-actions>
          <button slot="overflow" class="btn btn-secondary" id="openFeedFiltersBtn">\u{1F50D} Filter</button>
        </toolbar-overflow-actions>
      </div>
    `;
    }
    render() {
        const feedTitle = this.isGroupMode() ? 'Group Posts' : 'Recent Posts';
        this.innerHTML = `
      <div class="posts-feed">
        <div class="feed-header">
          <h2>${feedTitle}</h2>
          ${this.renderHeaderActions()}
        </div>

        <div class="feed-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
    }
    openFeedFiltersModal() {
        let modal = document.querySelector('feed-filters-modal');
        if (!modal) {
            modal = document.createElement('feed-filters-modal');
            document.body.appendChild(modal);
        }
        modal.open();
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading posts...</div>
        </div>
      `;
        if (this.error) return `
        <div class="error-state">
          <div class="error-message">\u{274C} ${this.error}</div>
          <button class="btn btn-primary retry-btn">Try Again</button>
        </div>
      `;
        if (!this.posts || this.posts.length === 0) {
            let emptyMessage = 'Be the first to share something with your friends!';
            if (this.isGroupMode()) emptyMessage = this.threadId ? 'Be the first to post in this thread!' : 'Be the first to post in this group!';
            return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F4DD}</div>
          <h3>No posts yet</h3>
          <p>${emptyMessage}</p>
        </div>
      `;
        }
        const groupAttr = this.isGroupMode() ? ` group-id="${this.groupId}"` : '';
        return `
      <div class="posts-container">
        ${this.posts.map((post, index)=>{
            const itemGroupAttr = this.isGroupMode() ? groupAttr : post.group_id ? ` group-id="${post.group_id}"` : '';
            return `
          <post-item data-post-index="${index}"${itemGroupAttr}></post-item>
        `;
        }).join('')}
      </div>
      ${this.renderLoadMoreButton()}
    `;
    }
    renderLoadMoreButton() {
        const hasNext = this.pagination && this.pagination.hasNext;
        const hasPrevious = this.currentPage > 1;
        const showPagination = hasNext || hasPrevious;
        if (!showPagination) return '';
        if (this.isLoadingMore || this.isLoading) return `
        <div class="load-more-container">
          <button class="load-more-btn loading" disabled>
            <span class="spinner-small"></span>
            Loading posts...
          </button>
        </div>
      `;
        return `
      <div class="load-more-container">
        <div class="pagination-buttons">
          ${hasPrevious ? `
            <button class="load-previous-btn">
              <span class="load-more-arrow">\u{2B06}\u{FE0F}</span>
              <span class="load-more-text">Previous Page</span>
            </button>
          ` : ''}
          ${hasNext ? `
            <button class="load-more-btn">
              <span class="load-more-icon">\u{2728}</span>
              <span class="load-more-text">Next Page</span>
              <span class="load-more-arrow">\u{2B07}\u{FE0F}</span>
            </button>
          ` : ''}
        </div>
        <div class="pagination-info">
          Page ${this.currentPage}${this.pagination ? ` of ${this.pagination.totalPages || Math.ceil(this.pagination.total / 10)}` : ''} 
          (${this.posts.length}${this.pagination ? ` of ${this.pagination.total}` : ''} posts)
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Refresh button
        const refreshBtn = this.querySelector('.refresh-btn');
        refreshBtn?.addEventListener('click', ()=>{
            this.load();
        });
        const openFeedFiltersBtn = this.querySelector('#openFeedFiltersBtn');
        openFeedFiltersBtn?.addEventListener('click', ()=>{
            this.openFeedFiltersModal();
        });
        // Retry button (appears when there's an error)
        const retryBtn = this.querySelector('.retry-btn');
        retryBtn?.addEventListener('click', ()=>{
            this.load();
        });
        // Load More button
        const loadMoreBtn = this.querySelector('.load-more-btn');
        loadMoreBtn?.addEventListener('click', ()=>{
            this.loadMore();
        });
        // Load Previous button
        const loadPreviousBtn = this.querySelector('.load-previous-btn');
        loadPreviousBtn?.addEventListener('click', ()=>{
            this.loadPrevious();
        });
    }
    attachDocumentListeners() {
        // Only attach document-level listeners once
        if (this.documentListenersAttached) return;
        this.documentListenersAttached = true;
        // Listen for new posts
        document.addEventListener('post-created', (event)=>{
            if (!this.isConnected) return;
            const post = event.detail;
            if (this.isGroupMode()) {
                const postGroupId = Number(post?.group_id);
                if (!postGroupId || postGroupId !== Number(this.groupId)) return;
                const postThreadId = post?.thread_id !== null && post?.thread_id !== undefined && post.thread_id !== '' ? Number(post.thread_id) : null;
                const feedThreadId = this.threadId !== null && this.threadId !== undefined ? Number(this.threadId) : null;
                if (postThreadId !== feedThreadId) return;
            } else if (post?.group_id) {
                const postThreadId = post?.thread_id !== null && post?.thread_id !== undefined && post.thread_id !== '' ? Number(post.thread_id) : null;
                if (postThreadId !== null) return;
            }
            this.handleNewPost(post);
        });
        // Listen for feed filter changes (home feed only)
        document.addEventListener('feed-filters-changed', (event)=>{
            if (!this.isConnected || this.isGroupMode()) return;
            this.currentPage = 1;
            this.updatePageInUrl(1, true);
            this.load(true);
        });
        // Listen for deleted posts
        document.addEventListener('post-deleted', (event)=>{
            this.handleDeletedPost(event.detail.postId);
        });
    }
    updatePageInUrl(page, replace = false) {
        const url = new URL(window.location.href);
        if (page === 1) url.searchParams.delete('page');
        else url.searchParams.set('page', String(page));
        const nextUrl = `${url.pathname}${url.search}${url.hash}`;
        if (replace) window.history.replaceState({
            page: page
        }, '', nextUrl);
        else window.history.pushState({
            page: page
        }, '', nextUrl);
    }
    buildGroupPostsQuery() {
        const params = new URLSearchParams();
        params.set('page', String(this.currentPage));
        params.set('limit', '10');
        if (this.threadId) params.set('thread_id', String(this.threadId));
        return params.toString();
    }
    async load(reset = true) {
        // Don't load if component is not visible (unless forced)
        // Allow loading if we're already loaded (for refresh, pagination, etc.)
        if (!this.hasLoadedOnce && !(0, $df142e7fab527392$export$795910f5f15a9633)(this)) {
            // Not visible and never loaded, wait for visibility
            this.loadIfVisible();
            return;
        }
        // Prevent multiple simultaneous calls
        if (this.isLoadingPosts) return;
        this.isLoadingPosts = true;
        if (reset) {
            this.isLoading = true;
            if (!new URLSearchParams(window.location.search).get('page')) this.currentPage = 1;
            this.posts = [];
            if (this.currentPage === 1) this.updatePageInUrl(1, true);
        } else this.isLoadingMore = true;
        // Ensure posts is always an array
        if (!this.posts) this.posts = [];
        this.error = null;
        this.updateContent();
        try {
            if (this.isGroupMode()) {
                const response = await window.API.request(`/groups/${this.groupId}/posts?${this.buildGroupPostsQuery()}`);
                this.posts = response.posts || [];
                this.pagination = response.pagination || null;
            } else {
                const response = await window.API.posts.getAll(this.currentPage, 10);
                this.posts = response.posts;
                this.pagination = response.pagination;
            }
            this.error = null;
        } catch (error) {
            window.logger.error('Failed to load posts', error, {
                component: 'posts-feed'
            });
            this.error = error.message || 'Failed to load posts';
            if (reset) this.posts = [];
        } finally{
            this.isLoading = false;
            this.isLoadingMore = false;
            this.isLoadingPosts = false;
            this.updateContent();
            if (this.isGroupMode()) queueMicrotask(()=>{
                (0, $243ef812260567e0$export$593b75043823fc36)({
                    root: this,
                    feed: this
                }).catch((err)=>{
                    window.logger?.warn('Failed to focus group post from hash', err);
                });
            });
        }
    }
    async loadMore() {
        if (this.pagination && this.pagination.hasNext && !this.isLoadingMore && !this.isLoadingPosts) {
            this.currentPage++;
            this.updatePageInUrl(this.currentPage);
            await this.load(true);
        }
    }
    async loadPrevious() {
        if (this.currentPage > 1 && !this.isLoadingMore && !this.isLoadingPosts) {
            this.currentPage--;
            this.updatePageInUrl(this.currentPage);
            await this.load(true);
        }
    }
    handleNewPost(newPost) {
        // Add the new post to the beginning of the array
        this.posts.unshift(newPost);
        this.updateContent();
        // Add fade-in animation to the new post
        setTimeout(()=>{
            const firstPost = this.querySelector('post-item');
            if (firstPost) firstPost.classList.add('fade-in');
        }, 100);
    }
    handleDeletedPost(postId) {
        // Remove the post from the array
        this.posts = this.posts.filter((post)=>post.id !== parseInt(postId));
        this.updateContent();
    }
    updateContent() {
        const feedContent = this.querySelector('.feed-content');
        if (feedContent) {
            feedContent.innerHTML = this.renderContent();
            // Set post data via JavaScript properties instead of HTML attributes
            const postItems = feedContent.querySelectorAll('post-item');
            postItems.forEach((postItem)=>{
                const postIndex = parseInt(postItem.dataset.postIndex);
                if (this.posts && this.posts[postIndex]) {
                    postItem.setCurrentUser(this.currentUser);
                    if (this.isGroupMode()) postItem.setAttribute('group-id', String(this.groupId));
                    else if (this.posts[postIndex].group_id) postItem.setAttribute('group-id', String(this.posts[postIndex].group_id));
                    else postItem.removeAttribute('group-id');
                    postItem.postData = this.posts[postIndex];
                }
            });
            this.attachEventListeners();
        }
    }
    // Public method to refresh posts
    refresh() {
        this.load();
    }
    // Public method to add a post
    addPost(post) {
        this.handleNewPost(post);
    }
    isAuthenticated() {
        return this.currentUser !== null;
    }
}
// Register the custom element
customElements.define('posts-feed', $d3db3142a9f285b6$var$PostsFeed);


class $0358f847218663eb$var$PrivacyPolicy extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.innerHTML = `
      <article class="public-page" aria-label="Privacy Policy">
        <header>
          <p>Accountable whimsy, zero surveillance capitalism.</p>
          <h1>Privacy Policy</h1>
          <p>Last updated: ${new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        })}</p>
        </header>

        <section>
          <h2>What we collect</h2>
          <div class="card">
            <strong>Account basics</strong>
            <p>Username, email, and the friends you decide to keep close. If you enable SMS or 2FA we store the necessary numbers/tokens (encrypted, of course).</p>
          </div>
          <div class="card">
            <strong>Posts, events, and prompts</strong>
            <p>Everything you share stays scoped to your intended audience. We keep copies so you, your friends, and future you (hi!) can revisit them.</p>
          </div>
          <div class="card">
            <strong>Guest RSVP info</strong>
            <p>Event hosts can invite people who don\u{2019}t have Fun Old Times accounts. We store their RSVP name + email strictly so hosts can plan snacks and seating.</p>
          </div>
        </section>

        <section>
          <h2>What we never do</h2>
          <ul>
            <li>We do not use your data to train AI models. If that ever changes, we will explain why and ask you to opt in before any future content is involved.</li>
            <li>We do not sell ads, rent lists, or plug third-party trackers into your friend space.</li>
            <li>We do not secretly make your posts public. Friends-only is a forever feature.</li>
          </ul>
        </section>

        <section>
          <h2>How we use your info</h2>
          <p>Mostly to keep the lights blinking in fun colors:</p>
          <ul>
            <li>Delivering the upcoming-events board so you always know what\u{2019}s next.</li>
            <li>Sending invitations, reminders, and prompt nudges that you explicitly request.</li>
            <li>Running audit logs so we can spot bugs or bad actors before they ruin the vibe.</li>
          </ul>
        </section>

        <section>
          <h2>Your choices</h2>
          <ul>
            <li>Download or delete your content by asking support@funoldtimes.com (self-serve tools are on our roadmap, we promise).</li>
            <li>Opt out of SMS or email notifications any time in settings.</li>
            <li>Remove guests from events; their RSVP data disappears with the invite.</li>
          </ul>
        </section>

        <section>
          <h2>Security</h2>
          <p>We encrypt data in transit and at rest, require unique session cookies, and audit log critical actions so we can catch bugs or bad behavior before it spreads.</p>
        </section>

        <section>
          <p class="note">Questions? Ping support@funoldtimes.com.</p>
        </section>
      </article>
    `;
    }
}
customElements.define('privacy-policy', $0358f847218663eb$var$PrivacyPolicy);


// Prompt Management Admin Component

class $d19a3f87559ee845$var$PromptManagement extends HTMLElement {
    constructor(){
        super();
        this.prompts = [];
        this.isLoading = true;
    }
    connectedCallback() {
        this.render();
        this.loadPrompts();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="prompt-management">
        <div class="prompt-header">
          <h2>
            <washing-machine-icon size="medium" interactive="false"></washing-machine-icon>
            Writing Prompts Management
          </h2>
          <p class="prompt-description">
            Manage writing prompts that users can select when creating posts. 
            Approve user-submitted prompts to make them available in the global pool.
          </p>
          <button class="btn btn-primary add-prompt-btn" id="addPromptBtn">
            \u{2795} Add New Prompt
          </button>
        </div>

        <div class="prompt-stats">
          <div class="stat-card">
            <div class="stat-number" id="totalPrompts">-</div>
            <div class="stat-label">Total Prompts</div>
          </div>
          <div class="stat-card">
            <div class="stat-number" id="publicPrompts">-</div>
            <div class="stat-label">Public Prompts</div>
          </div>
          <div class="stat-card">
            <div class="stat-number" id="privatePrompts">-</div>
            <div class="stat-label">Private Prompts</div>
          </div>
        </div>

        <div class="prompt-content">
          <div class="loading-state" id="loadingState">
            <div class="spinner"></div>
            <div>Loading prompts...</div>
          </div>
          
          <div class="prompt-list" id="promptList" style="display: none;">
            <!-- Prompts will be loaded here -->
          </div>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Add new prompt button
        const addPromptBtn = this.querySelector('#addPromptBtn');
        addPromptBtn.addEventListener('click', ()=>{
            this.openAdminPromptModal();
        });
        // Event delegation for prompt actions
        this.addEventListener('click', (e)=>{
            const actionBtn = e.target.closest('.action-btn');
            if (!actionBtn) return;
            const promptId = actionBtn.dataset.promptId;
            const action = actionBtn.dataset.action;
            if (action === 'promote') this.updatePromptStatus(promptId, 'public');
            else if (action === 'demote') this.updatePromptStatus(promptId, 'private');
        });
    }
    async loadPrompts() {
        this.isLoading = true;
        const loadingState = this.querySelector('#loadingState');
        const promptList = this.querySelector('#promptList');
        loadingState.style.display = 'block';
        promptList.style.display = 'none';
        try {
            const response = await window.API.request('/prompts/admin/all');
            this.prompts = response.prompts || [];
            this.renderPrompts();
            this.updateStats();
        } catch (error) {
            window.logger.error('Failed to load prompts:', error);
            this.renderError();
        } finally{
            this.isLoading = false;
            loadingState.style.display = 'none';
            promptList.style.display = 'block';
        }
    }
    renderPrompts() {
        const promptList = this.querySelector('#promptList');
        if (this.prompts.length === 0) {
            promptList.innerHTML = `
        <div style="text-align: center; padding: 3rem; color: var(--text-secondary);">
          <div style="font-size: 3rem; margin-bottom: 1rem;">\u{1F9FA}</div>
          <h3>No prompts found</h3>
          <p>Users haven't submitted any writing prompts yet.</p>
        </div>
      `;
            return;
        }
        promptList.innerHTML = this.prompts.map((prompt)=>`
      <div class="prompt-item">
        <div class="prompt-item-header">
          <div class="prompt-item-info">
            <h3 class="prompt-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(prompt.title)}</h3>
            <div class="prompt-meta">
              <span>Created by: <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(prompt.createdBy)}</strong></span>
              <span>\u{2022}</span>
              <span>${new Date(prompt.createdAt).toLocaleDateString()}</span>
            </div>
            ${prompt.body ? `
              <div class="prompt-body">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(prompt.body)}</div>
            ` : ''}
          </div>
          <div class="prompt-actions">
            <div class="status-badge ${prompt.status}">
              ${prompt.status}
            </div>
            ${prompt.status === 'private' ? `
              <button class="action-btn promote" data-prompt-id="${prompt.id}" data-action="promote">
                \u{2705} Approve
              </button>
            ` : `
              <button class="action-btn demote" data-prompt-id="${prompt.id}" data-action="demote">
                \u{274C} Unapprove
              </button>
            `}
          </div>
        </div>
      </div>
    `).join('');
    }
    updateStats() {
        const totalPrompts = this.prompts.length;
        const publicPrompts = this.prompts.filter((p)=>p.status === 'public').length;
        const privatePrompts = this.prompts.filter((p)=>p.status === 'private').length;
        this.querySelector('#totalPrompts').textContent = totalPrompts;
        this.querySelector('#publicPrompts').textContent = publicPrompts;
        this.querySelector('#privatePrompts').textContent = privatePrompts;
    }
    async updatePromptStatus(promptId, newStatus) {
        try {
            await window.API.request(`/prompts/admin/${promptId}/status`, {
                method: 'PUT',
                body: JSON.stringify({
                    status: newStatus
                })
            });
            // Update local data (convert promptId to number for comparison)
            const prompt = this.prompts.find((p)=>p.id === parseInt(promptId));
            if (prompt) prompt.status = newStatus;
            // Re-render
            this.renderPrompts();
            this.updateStats();
            // Show success message
            this.showMessage(`Prompt ${newStatus === 'public' ? 'approved' : 'unapproved'} successfully!`, 'success');
        } catch (error) {
            window.logger.error('Failed to update prompt status:', error);
            this.showMessage('Failed to update prompt status. Please try again.', 'error');
        }
    }
    renderError() {
        const promptList = this.querySelector('#promptList');
        promptList.innerHTML = `
      <div style="text-align: center; padding: 3rem; color: var(--text-secondary);">
        <div style="font-size: 3rem; margin-bottom: 1rem;">\u{1F61E}</div>
        <h3>Failed to load prompts</h3>
        <p>There was an error loading the writing prompts. Please refresh the page to try again.</p>
      </div>
    `;
    }
    showMessage(message, type = 'info') {
        // Create a temporary message element
        const messageEl = document.createElement('div');
        messageEl.style.cssText = `
      position: fixed;
      top: 2rem;
      right: 2rem;
      background: ${type === 'success' ? '#10b981' : '#ef4444'};
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      font-weight: 500;
      z-index: 10000;
      animation: slideIn 0.3s ease-out;
    `;
        messageEl.textContent = message;
        // Add animation styles
        const style = document.createElement('style');
        style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
    `;
        document.head.appendChild(style);
        document.body.appendChild(messageEl);
        // Remove after 3 seconds
        setTimeout(()=>{
            messageEl.remove();
            style.remove();
        }, 3000);
    }
    openAdminPromptModal() {
        // Create modal dynamically
        const modal = document.createElement('div');
        modal.className = 'admin-prompt-modal';
        modal.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h3>\u{2795} Create New Writing Prompt</h3>
            <button class="close-btn" id="closeAdminModal">&times;</button>
          </div>
          <form class="admin-prompt-form" id="adminPromptForm">
            <div class="form-group">
              <label for="adminPromptTitle">Prompt Title *</label>
              <input 
                type="text" 
                id="adminPromptTitle" 
                name="title" 
                placeholder="e.g., What's your favorite childhood memory?"
                maxlength="255"
                required
              />
            </div>
            <div class="form-group">
              <label for="adminPromptBody">
                Optional Instructions
                <span class="help-text">(Additional context or template)</span>
              </label>
              <textarea 
                id="adminPromptBody" 
                name="body" 
                placeholder="e.g., Describe the memory in detail and explain why it's special to you..."
                rows="3"
                maxlength="1000"
              ></textarea>
            </div>
            <div class="form-group">
              <label for="adminPromptStatus">Initial Status</label>
              <select id="adminPromptStatus" name="status">
                <option value="private">Private (review later)</option>
                <option value="public" selected>Public (available immediately)</option>
              </select>
            </div>
            <div class="form-actions">
              <button type="button" class="btn btn-secondary" id="cancelAdminPrompt">Cancel</button>
              <button type="submit" class="btn btn-primary" id="submitAdminPrompt">
                <span class="btn-text">Create Prompt</span>
                <span class="btn-loading" style="display: none;">\u{23F3} Creating...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    `;
        document.body.appendChild(modal);
        // Add event listeners
        modal.querySelector('#closeAdminModal').addEventListener('click', ()=>{
            this.closeAdminModal(modal);
        });
        modal.querySelector('#cancelAdminPrompt').addEventListener('click', ()=>{
            this.closeAdminModal(modal);
        });
        modal.querySelector('.modal-backdrop').addEventListener('click', (e)=>{
            if (e.target.classList.contains('modal-backdrop')) this.closeAdminModal(modal);
        });
        modal.querySelector('#adminPromptForm').addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handleAdminPromptSubmission(modal);
        });
        // Focus on title input
        setTimeout(()=>{
            modal.querySelector('#adminPromptTitle').focus();
        }, 100);
    }
    closeAdminModal(modal) {
        modal.remove();
    }
    async handleAdminPromptSubmission(modal) {
        const titleInput = modal.querySelector('#adminPromptTitle');
        const bodyInput = modal.querySelector('#adminPromptBody');
        const statusSelect = modal.querySelector('#adminPromptStatus');
        const submitBtn = modal.querySelector('#submitAdminPrompt');
        const btnText = submitBtn.querySelector('.btn-text');
        const btnLoading = submitBtn.querySelector('.btn-loading');
        const title = titleInput.value.trim();
        const body = bodyInput.value.trim();
        const status = statusSelect.value;
        if (!title) {
            alert('Please enter a prompt title');
            titleInput.focus();
            return;
        }
        // Set loading state
        submitBtn.disabled = true;
        btnText.style.display = 'none';
        btnLoading.style.display = 'inline';
        try {
            // Create the prompt
            const response = await window.API.prompts.create({
                title: title,
                body: body || null
            });
            // If admin wants it public immediately, update status
            if (status === 'public') await window.API.prompts.updateStatus(response.prompt.id, 'public');
            // Show success message
            this.showMessage(`Prompt created and set to ${status}!`, 'success');
            // Close modal and reload
            this.closeAdminModal(modal);
            await this.loadPrompts();
        } catch (error) {
            window.logger.error('Failed to create admin prompt:', error);
            alert('Failed to create prompt. Please try again.');
            // Reset button state
            submitBtn.disabled = false;
            btnText.style.display = 'inline';
            btnLoading.style.display = 'none';
        }
    }
}
// Register the custom element
customElements.define('prompt-management', $d19a3f87559ee845$var$PromptManagement);





/**
 * Client-side mirror of server/server/utils/widget-fetch-hosts.js
 */ const $7ba36a01d015ebb8$var$FOT_FETCH_URL_RE = /fot\.fetch\s*\(\s*(['"`])(https:\/\/[^'"`\s]+)\1/g;
function $7ba36a01d015ebb8$var$hostnameFromUrl(urlString) {
    try {
        return new URL(urlString).hostname.toLowerCase() || null;
    } catch  {
        return null;
    }
}
function $7ba36a01d015ebb8$export$cf21550e9bab74a5(jsContent) {
    if (!jsContent || typeof jsContent !== 'string') return [];
    const hosts = new Set();
    let match;
    const re = new RegExp($7ba36a01d015ebb8$var$FOT_FETCH_URL_RE.source, 'g');
    while((match = re.exec(jsContent)) !== null){
        const host = $7ba36a01d015ebb8$var$hostnameFromUrl(match[2]);
        if (host) hosts.add(host);
    }
    return [
        ...hosts
    ].sort();
}
function $7ba36a01d015ebb8$export$4352fe9587dec65c(raw) {
    if (!raw || typeof raw !== 'string') return [];
    return [
        ...new Set(raw.split(/[\s,;]+/).map((h)=>h.trim().toLowerCase()).filter(Boolean))
    ];
}
function $7ba36a01d015ebb8$export$7fb50f25b17a502e(existingRaw, extractedHosts) {
    const merged = new Set([
        ...$7ba36a01d015ebb8$export$4352fe9587dec65c(existingRaw),
        ...extractedHosts.map((h)=>h.toLowerCase())
    ]);
    return [
        ...merged
    ].join(', ');
}


const $61c94ba0ac9cf2b2$var$KEY_PATTERN = /^[a-zA-Z_][a-zA-Z0-9_]*$/;
let $61c94ba0ac9cf2b2$var$nextRowId = 1;
function $61c94ba0ac9cf2b2$export$9bc42d86b2f89c92(overrides = {}) {
    return {
        rowId: overrides.rowId ?? `cfg-${$61c94ba0ac9cf2b2$var$nextRowId++}`,
        key: overrides.key ?? '',
        title: overrides.title ?? '',
        description: overrides.description ?? '',
        required: Boolean(overrides.required),
        secret: Boolean(overrides.secret),
        markdown: Boolean(overrides.markdown)
    };
}
function $61c94ba0ac9cf2b2$export$8480e9329f21d3ad(schema) {
    if (!schema || typeof schema !== 'object') return [];
    const props = schema.properties;
    if (!props || typeof props !== 'object') return [];
    const required = new Set(Array.isArray(schema.required) ? schema.required : []);
    return Object.entries(props).map(([key, def])=>$61c94ba0ac9cf2b2$export$9bc42d86b2f89c92({
            key: key,
            title: def?.title || '',
            description: def?.description || '',
            required: required.has(key),
            secret: def?.secret === true,
            markdown: def?.format === 'markdown'
        }));
}
function $61c94ba0ac9cf2b2$var$isBlankRow(field) {
    return !field.key?.trim() && !field.title?.trim() && !field.description?.trim() && !field.required && !field.secret && !field.markdown;
}
function $61c94ba0ac9cf2b2$export$3866e6ba6b4fd7ad(fields) {
    const rows = Array.isArray(fields) ? fields : [];
    const activeRows = rows.filter((row)=>!$61c94ba0ac9cf2b2$var$isBlankRow(row));
    if (activeRows.length === 0) return {
        valid: true
    };
    const seenKeys = new Set();
    for(let i = 0; i < activeRows.length; i += 1){
        const row = activeRows[i];
        const key = String(row.key || '').trim();
        const title = String(row.title || '').trim();
        const rowLabel = `Variable ${i + 1}`;
        if (!key) return {
            valid: false,
            error: `${rowLabel}: variable name is required`
        };
        if (!$61c94ba0ac9cf2b2$var$KEY_PATTERN.test(key)) return {
            valid: false,
            error: `${rowLabel}: variable name must start with a letter or underscore and contain only letters, numbers, and underscores`
        };
        if (!title) return {
            valid: false,
            error: `${rowLabel}: label is required`
        };
        if (row.secret && row.markdown) return {
            valid: false,
            error: `${rowLabel}: a field cannot be both secret and markdown`
        };
        if (seenKeys.has(key)) return {
            valid: false,
            error: `Duplicate variable name: ${key}`
        };
        seenKeys.add(key);
    }
    return {
        valid: true
    };
}
function $61c94ba0ac9cf2b2$export$14915c2b0a2caf48(fields) {
    const rows = Array.isArray(fields) ? fields : [];
    const activeRows = rows.filter((row)=>!$61c94ba0ac9cf2b2$var$isBlankRow(row));
    if (activeRows.length === 0) return null;
    const validation = $61c94ba0ac9cf2b2$export$3866e6ba6b4fd7ad(activeRows);
    if (!validation.valid) throw new Error(validation.error);
    const properties = {};
    const required = [];
    for (const row of activeRows){
        const key = row.key.trim();
        const prop = {
            type: 'string',
            title: row.title.trim()
        };
        const description = String(row.description || '').trim();
        if (description) prop.description = description;
        if (row.secret) prop.secret = true;
        if (row.markdown) prop.format = 'markdown';
        properties[key] = prop;
        if (row.required) required.push(key);
    }
    const schema = {
        type: 'object',
        properties: properties
    };
    if (required.length) schema.required = required;
    return schema;
}



function $562e457696e077d0$var$schemaProperties(schema) {
    if (!schema?.properties || typeof schema.properties !== 'object') return [];
    return Object.entries(schema.properties);
}
function $562e457696e077d0$var$fieldRowsFromConfigFields(configFields) {
    return (configFields || []).filter((row)=>row?.key?.trim()).map((row)=>[
            row.key.trim(),
            {
                title: row.title?.trim() || row.key.trim(),
                description: row.description?.trim() || '',
                secret: Boolean(row.secret),
                format: row.markdown ? 'markdown' : undefined
            }
        ]);
}
function $562e457696e077d0$export$8529b77ed36cd9cb(schema, configFields) {
    const fromSchema = $562e457696e077d0$var$schemaProperties(schema);
    if (fromSchema.length) return fromSchema;
    return $562e457696e077d0$var$fieldRowsFromConfigFields(configFields);
}
function $562e457696e077d0$export$ef89630dc9a46e69(schema, contextKey, values = {}, configFields = null) {
    const entries = $562e457696e077d0$export$8529b77ed36cd9cb(schema, configFields);
    if (!entries.length) return '';
    const fields = entries.map(([key, def])=>{
        const title = def.title || key;
        const isSecret = def.secret === true;
        const isMarkdown = def.format === 'markdown';
        const val = values[key] !== null && values[key] !== undefined ? String(values[key]) : '';
        const fieldId = `widget-preview-cfg-${contextKey}-${key}`;
        const autocomplete = isSecret ? 'new-password' : 'off';
        if (isMarkdown && !isSecret) return `
        <div class="form-group widget-preview-config-field">
          <label class="form-label" for="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(fieldId)}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(title)}</label>
          <textarea
            id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(fieldId)}"
            class="form-control"
            rows="4"
            autocomplete="${autocomplete}"
            data-preview-config-field="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(key)}"
          >${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(val)}</textarea>
          ${def.description ? `<p class="form-text">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(def.description)}</p>` : ''}
        </div>
      `;
        const inputType = isSecret ? 'password' : 'text';
        return `
      <div class="form-group widget-preview-config-field">
        <label class="form-label" for="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(fieldId)}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(title)}</label>
        <input
          id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(fieldId)}"
          class="form-control"
          type="${inputType}"
          autocomplete="${autocomplete}"
          data-preview-config-field="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(key)}"
          value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(val)}"
        />
        ${def.description ? `<p class="form-text">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(def.description)}</p>` : ''}
      </div>
    `;
    }).join('');
    return `
    <div class="widget-preview-config" data-preview-config="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(contextKey)}">
      <h4 class="widget-preview-config-title">Preview settings</h4>
      <p class="form-text">Fill these in to test <code>fot.getConfig()</code> \u{2014} the same fields profile owners set when adding your widget.</p>
      ${fields}
    </div>
  `;
}
function $562e457696e077d0$export$fd5ef8e3c4fdafdf(root, contextKey) {
    const section = root?.querySelector?.(`[data-preview-config="${contextKey}"]`);
    if (!section) return {};
    const config = {};
    section.querySelectorAll('[data-preview-config-field]').forEach((el)=>{
        const key = el.dataset.previewConfigField;
        if (!key) return;
        config[key] = el.value ?? '';
    });
    return config;
}


const $4511425752c95c4f$var$PREVIEW_DEBOUNCE_MS = 300;
class $4511425752c95c4f$var$WidgetManagement extends HTMLElement {
    constructor(){
        super();
        this.widgets = [];
        this.editingId = null;
        this.form = {
            name: '',
            description: '',
            htmlContent: '',
            cssContent: '',
            jsContent: '',
            allowedHosts: '',
            oauthAuthUrl: '',
            oauthTokenUrl: '',
            oauthScopes: '',
            oauthServiceLabel: '',
            oauthClientId: '',
            oauthClientSecret: '',
            oauthPkce: false,
            configFields: []
        };
        this.configSchemaError = '';
        this.previewRowId = null;
        this.rowPreviewCache = {};
        this.loading = true;
        this.saving = false;
        this.message = '';
        this._showNew = false;
        this._previewDebounceTimer = null;
        this.previewToken = null;
        this.previewTokenExpiresAt = 0;
        this.editorPreviewError = '';
        this.rowPreviewError = null;
        this.adminEditMeta = null;
        this._editingWidgetMeta = null;
        this._configSectionOpen = false;
        this.previewConfigValues = {};
    }
    connectedCallback() {
        this.render();
        this.loadWidgets();
    }
    disconnectedCallback() {
        if (this._previewDebounceTimer) {
            clearTimeout(this._previewDebounceTimer);
            this._previewDebounceTimer = null;
        }
    }
    async loadWidgets() {
        try {
            const res = await window.API.request('/widgets/mine');
            this.widgets = res.widgets || [];
            this.loading = false;
            this.render();
            this.attachListeners();
            await this.tryOpenEditFromQuery();
        } catch (err) {
            window.logger.error('Failed to load widgets:', err);
            this.loading = false;
            this.message = 'Failed to load widgets.';
            this.render();
        }
    }
    async tryOpenEditFromQuery() {
        const params = new URLSearchParams(window.location.search);
        const editId = parseInt(params.get('edit'), 10);
        if (Number.isNaN(editId) || editId < 1) return;
        const inMine = this.widgets.some((w)=>w.id === editId);
        if (!inMine) try {
            const res = await window.API.request(`/widgets/${editId}`);
            this.adminEditMeta = {
                name: res.widget.name,
                ownerUsername: res.widget.ownerUsername || `user #${res.widget.ownerUserId}`
            };
        } catch (err) {
            window.logger.warn('Could not open widget for admin edit:', err);
            return;
        }
        await this.openEdit(editId);
    }
    capturePreviewConfigState() {
        if (this.previewRowId) {
            const key = `row-${this.previewRowId}`;
            this.previewConfigValues[key] = (0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, key);
        }
        if (this.editingId || this._showNew) this.previewConfigValues.editor = (0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, 'editor');
    }
    hideEditor() {
        this.capturePreviewConfigState();
        this.editingId = null;
        this._showNew = false;
        this.configSchemaError = '';
        this._configSectionOpen = false;
        this.previewToken = null;
        this.previewTokenExpiresAt = 0;
        this.editorPreviewError = '';
        this.adminEditMeta = null;
        this._editingWidgetMeta = null;
        this.form = {
            name: '',
            description: '',
            htmlContent: '',
            cssContent: '',
            jsContent: '',
            allowedHosts: '',
            oauthAuthUrl: '',
            oauthTokenUrl: '',
            oauthScopes: '',
            oauthServiceLabel: '',
            oauthClientId: '',
            oauthClientSecret: '',
            oauthPkce: false,
            configFields: []
        };
        if (this._previewDebounceTimer) {
            clearTimeout(this._previewDebounceTimer);
            this._previewDebounceTimer = null;
        }
    }
    resetForm() {
        this.editingId = null;
        this.form = {
            name: '',
            description: '',
            htmlContent: '',
            cssContent: '',
            jsContent: '',
            allowedHosts: '',
            oauthAuthUrl: '',
            oauthTokenUrl: '',
            oauthScopes: '',
            oauthServiceLabel: '',
            oauthClientId: '',
            oauthClientSecret: '',
            oauthPkce: false,
            configFields: []
        };
        this.configSchemaError = '';
        this._configSectionOpen = false;
        this._showNew = false;
        this.previewToken = null;
        this.previewTokenExpiresAt = 0;
        this.editorPreviewError = '';
        this.adminEditMeta = null;
        this._editingWidgetMeta = null;
        if (this._previewDebounceTimer) {
            clearTimeout(this._previewDebounceTimer);
            this._previewDebounceTimer = null;
        }
    }
    syncFormFromDom() {
        this.form.name = this.querySelector('[data-field="name"]')?.value || '';
        this.form.description = this.querySelector('[data-field="description"]')?.value || '';
        this.form.htmlContent = this.querySelector('[data-field="htmlContent"]')?.value || '';
        this.form.cssContent = this.querySelector('[data-field="cssContent"]')?.value || '';
        this.form.jsContent = this.querySelector('[data-field="jsContent"]')?.value || '';
        this.form.allowedHosts = this.querySelector('[data-field="allowedHosts"]')?.value || '';
        this.form.oauthAuthUrl = this.querySelector('[data-field="oauthAuthUrl"]')?.value || '';
        this.form.oauthTokenUrl = this.querySelector('[data-field="oauthTokenUrl"]')?.value || '';
        this.form.oauthScopes = this.querySelector('[data-field="oauthScopes"]')?.value || '';
        this.form.oauthServiceLabel = this.querySelector('[data-field="oauthServiceLabel"]')?.value || '';
        this.form.oauthClientId = this.querySelector('[data-field="oauthClientId"]')?.value || '';
        this.form.oauthClientSecret = this.querySelector('[data-field="oauthClientSecret"]')?.value || '';
        this.form.oauthPkce = Boolean(this.querySelector('[data-field="oauthPkce"]')?.checked);
        this.syncConfigFieldsFromDom();
    }
    syncConfigFieldsFromDom() {
        const rows = this.querySelectorAll('[data-config-row]');
        if (!rows.length) return;
        this.form.configFields = Array.from(rows).map((rowEl)=>{
            const rowId = rowEl.dataset.configRow;
            const existing = this.form.configFields.find((row)=>row.rowId === rowId);
            return {
                rowId: rowId || existing?.rowId || (0, $61c94ba0ac9cf2b2$export$9bc42d86b2f89c92)().rowId,
                key: rowEl.querySelector('[data-config-field="key"]')?.value || '',
                title: rowEl.querySelector('[data-config-field="title"]')?.value || '',
                description: rowEl.querySelector('[data-config-field="description"]')?.value || '',
                required: Boolean(rowEl.querySelector('[data-config-field="required"]')?.checked),
                secret: Boolean(rowEl.querySelector('[data-config-field="secret"]')?.checked),
                markdown: Boolean(rowEl.querySelector('[data-config-field="markdown"]')?.checked)
            };
        });
    }
    captureConfigSectionOpen() {
        const el = this.querySelector('[data-config-section]');
        if (el) this._configSectionOpen = el.dataset.open === 'true';
    }
    addConfigField() {
        this.syncFormFromDom();
        this.captureConfigSectionOpen();
        this._configSectionOpen = true;
        this.form.configFields.push((0, $61c94ba0ac9cf2b2$export$9bc42d86b2f89c92)());
        this.configSchemaError = '';
        this.render();
        this.attachListeners();
    }
    removeConfigField(rowId) {
        this.syncFormFromDom();
        this.captureConfigSectionOpen();
        this.form.configFields = this.form.configFields.filter((row)=>row.rowId !== rowId);
        this.configSchemaError = '';
        this.render();
        this.attachListeners();
    }
    buildConfigSchemaPayload() {
        const validation = (0, $61c94ba0ac9cf2b2$export$3866e6ba6b4fd7ad)(this.form.configFields);
        if (!validation.valid) throw new Error(validation.error);
        return {
            configSchema: (0, $61c94ba0ac9cf2b2$export$14915c2b0a2caf48)(this.form.configFields)
        };
    }
    buildOAuthPayload() {
        const authUrl = this.form.oauthAuthUrl.trim();
        const tokenUrl = this.form.oauthTokenUrl.trim();
        if (!authUrl && !tokenUrl && !this.form.oauthClientId.trim()) return {};
        const scopes = this.form.oauthScopes.split(/[\s,]+/).filter(Boolean);
        const payload = {
            oauthConfig: {
                authorizationUrl: authUrl,
                tokenUrl: tokenUrl,
                scopes: scopes,
                pkce: this.form.oauthPkce,
                serviceLabel: this.form.oauthServiceLabel.trim() || 'service'
            },
            oauthClientId: this.form.oauthClientId.trim() || null
        };
        if (this.form.oauthClientSecret.trim()) payload.oauthClientSecret = this.form.oauthClientSecret.trim();
        return payload;
    }
    getOAuthCallbackDisplayUrl() {
        return `${window.location.origin}/api/widgets/oauth/callback`;
    }
    getPreviewFieldsFromForm() {
        return {
            name: this.querySelector('[data-field="name"]')?.value || this.form.name || 'Widget preview',
            htmlContent: this.querySelector('[data-field="htmlContent"]')?.value ?? this.form.htmlContent,
            cssContent: this.querySelector('[data-field="cssContent"]')?.value ?? this.form.cssContent,
            jsContent: this.querySelector('[data-field="jsContent"]')?.value ?? this.form.jsContent,
            widgetId: this.editingId || ''
        };
    }
    async ensurePreviewToken() {
        const now = Date.now();
        if (this.previewToken && this.previewTokenExpiresAt > now + 5000) return this.previewToken;
        const res = this.editingId ? await window.API.request(`/widgets/${this.editingId}/preview-token`, {
            method: 'POST'
        }) : await window.API.request('/widgets/preview/draft-token', {
            method: 'POST'
        });
        this.previewToken = res.token;
        this.previewTokenExpiresAt = now + (res.expiresInSeconds || 300) * 1000;
        return this.previewToken;
    }
    async ensureRowPreviewToken(widgetId) {
        const res = await window.API.request(`/widgets/${widgetId}/preview-token`, {
            method: 'POST'
        });
        return res.token;
    }
    async updateEditorPreview() {
        const iframe = this.querySelector('.widget-editor-preview-frame');
        if (!iframe) return;
        try {
            const token = await this.ensurePreviewToken();
            this.editorPreviewError = '';
            (0, $af08569b79d42cf2$export$f36cf66c9ae1e093)(iframe, token, this.getPreviewFieldsFromForm(), this, {
                getInstanceConfig: ()=>(0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, 'editor'),
                onError: ()=>{
                    this.editorPreviewError = (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)();
                    this.updatePreviewErrorDom('editor');
                }
            });
        } catch (err) {
            window.logger.warn('Editor preview failed:', err);
            this.editorPreviewError = (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)();
            this.updatePreviewErrorDom('editor');
        }
    }
    updatePreviewErrorDom(scope) {
        if (scope === 'editor') {
            const el = this.querySelector('[data-preview-error="editor"]');
            if (el) {
                el.textContent = this.editorPreviewError;
                el.hidden = !this.editorPreviewError;
            }
        }
        if (scope === 'row' && this.previewRowId) {
            const el = this.querySelector(`[data-preview-error="row-${this.previewRowId}"]`);
            if (el) {
                el.textContent = this.rowPreviewError || '';
                el.hidden = !this.rowPreviewError;
            }
        }
    }
    scheduleEditorPreviewUpdate() {
        if (this._previewDebounceTimer) clearTimeout(this._previewDebounceTimer);
        this._previewDebounceTimer = setTimeout(()=>{
            this._previewDebounceTimer = null;
            this.updateEditorPreview();
        }, $4511425752c95c4f$var$PREVIEW_DEBOUNCE_MS);
    }
    async updateRowPreviewIframe(widgetId) {
        const iframe = this.querySelector(`.widget-row-preview-frame[data-widget-id="${widgetId}"]`);
        if (!iframe) return;
        try {
            const token = await this.ensureRowPreviewToken(widgetId);
            this.rowPreviewError = null;
            const host = (0, $af08569b79d42cf2$export$93120b5c6ce37c17)();
            (0, $af08569b79d42cf2$export$2ac4fca7f859164f)(iframe, `${host}/render/preview/${widgetId}?token=${encodeURIComponent(token)}`, {
                widgetId: widgetId,
                getInstanceConfig: ()=>(0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, `row-${widgetId}`),
                onError: ()=>{
                    this.rowPreviewError = (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)();
                    this.updatePreviewErrorDom('row');
                }
            });
            this.updatePreviewErrorDom('row');
        } catch (err) {
            window.logger.warn('Row preview failed:', err);
            this.rowPreviewError = (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)();
            this.updatePreviewErrorDom('row');
        }
    }
    async toggleRowPreview(id) {
        if (this.previewRowId === id) {
            this.capturePreviewConfigState();
            this.previewRowId = null;
            this.rowPreviewError = null;
            this.render();
            this.attachListeners();
            return;
        }
        this.hideEditor();
        this.previewRowId = id;
        this.rowPreviewError = null;
        if (!this.rowPreviewCache[id]) try {
            const res = await window.API.request(`/widgets/${id}`);
            const w = res.widget;
            this.rowPreviewCache[id] = {
                name: w.name,
                htmlContent: w.htmlContent || '',
                cssContent: w.cssContent || '',
                jsContent: w.jsContent || '',
                configSchema: w.configSchema || null
            };
        } catch (err) {
            window.logger.error(err);
            alert('Could not load widget preview');
            this.previewRowId = null;
            return;
        }
        this.render();
        this.attachListeners();
        await this.updateRowPreviewIframe(id);
    }
    async openEdit(id) {
        try {
            this.previewRowId = null;
            this.previewToken = null;
            this.previewTokenExpiresAt = 0;
            this.editorPreviewError = '';
            this.configSchemaError = '';
            const res = await window.API.request(`/widgets/${id}`);
            const w = res.widget;
            this.editingId = id;
            this._editingWidgetMeta = {
                hasOAuthClientSecret: Boolean(w.hasOAuthClientSecret),
                rejectionReason: w.rejectionReason || null
            };
            this._showNew = true;
            this.form = {
                name: w.name,
                description: w.description || '',
                htmlContent: w.htmlContent || '',
                cssContent: w.cssContent || '',
                jsContent: w.jsContent || '',
                allowedHosts: (w.allowedHosts || []).join(', '),
                oauthAuthUrl: w.oauthConfig?.authorizationUrl || '',
                oauthTokenUrl: w.oauthConfig?.tokenUrl || '',
                oauthScopes: (w.oauthConfig?.scopes || []).join(' '),
                oauthServiceLabel: w.oauthConfig?.serviceLabel || '',
                oauthClientId: w.oauthClientId || '',
                oauthClientSecret: '',
                oauthPkce: Boolean(w.oauthConfig?.pkce),
                configFields: (0, $61c94ba0ac9cf2b2$export$8480e9329f21d3ad)(w.configSchema)
            };
            this.rowPreviewCache[id] = {
                name: w.name,
                htmlContent: w.htmlContent || '',
                cssContent: w.cssContent || '',
                jsContent: w.jsContent || '',
                configSchema: w.configSchema || null
            };
            this.render();
            this.attachListeners();
            await this.updateEditorPreview();
        } catch (err) {
            window.logger.error(err);
            alert('Could not load widget');
        }
    }
    async saveDraft() {
        this.syncFormFromDom();
        this.configSchemaError = '';
        try {
            this.buildConfigSchemaPayload();
        } catch (err) {
            this.configSchemaError = err.message || 'Invalid config variables';
            this.render();
            this.attachListeners();
            return;
        }
        this.saving = true;
        this.render();
        this.attachListeners();
        try {
            const body = {
                name: this.form.name,
                description: this.form.description,
                htmlContent: this.form.htmlContent,
                cssContent: this.form.cssContent,
                jsContent: this.form.jsContent,
                allowedHosts: this.form.allowedHosts,
                ...this.buildOAuthPayload(),
                ...this.buildConfigSchemaPayload()
            };
            if (this.editingId) {
                await window.API.request(`/widgets/${this.editingId}`, {
                    method: 'PUT',
                    body: JSON.stringify(body)
                });
                this.rowPreviewCache[this.editingId] = {
                    name: this.form.name,
                    htmlContent: this.form.htmlContent,
                    cssContent: this.form.cssContent,
                    jsContent: this.form.jsContent,
                    configSchema: this.buildConfigSchemaPayload().configSchema || null
                };
            } else {
                const res = await window.API.request('/widgets', {
                    method: 'POST',
                    body: JSON.stringify(body)
                });
                this.editingId = res.widget.id;
                this.previewToken = null;
                this.previewTokenExpiresAt = 0;
                this.rowPreviewCache[this.editingId] = {
                    name: this.form.name,
                    htmlContent: this.form.htmlContent,
                    cssContent: this.form.cssContent,
                    jsContent: this.form.jsContent,
                    configSchema: this.buildConfigSchemaPayload().configSchema || null
                };
            }
            this.message = 'Saved.';
            this.hideEditor();
            await this.loadWidgets();
        } catch (err) {
            alert(err.message || 'Save failed');
        } finally{
            this.saving = false;
            this.render();
            this.attachListeners();
        }
    }
    async shareToCommunityCatalog() {
        if (!this.editingId) await this.saveDraft();
        if (!this.editingId) return;
        try {
            await window.API.request(`/widgets/${this.editingId}/submit-to-catalog`, {
                method: 'POST'
            });
            this.message = 'Submitted to community catalog!';
            this.resetForm();
            await this.loadWidgets();
        } catch (err) {
            alert(err.message || 'Submit failed');
        }
    }
    async submitForReview() {
        return this.shareToCommunityCatalog();
    }
    async deleteWidget(id) {
        if (!confirm('Delete this widget?')) return;
        try {
            await window.API.request(`/widgets/${id}`, {
                method: 'DELETE'
            });
            if (this.editingId === id) this.resetForm();
            if (this.previewRowId === id) this.previewRowId = null;
            delete this.rowPreviewCache[id];
            await this.loadWidgets();
        } catch (err) {
            alert(err.message || 'Delete failed');
        }
    }
    systemCatalogBadge(widget) {
        const sc = widget.systemCatalogStatus || 'none';
        if (sc === 'none') return '<span class="widget-status-badge widget-status-personal">personal</span>';
        return this.statusBadge(sc);
    }
    canDeleteWidget(widget) {
        const sc = widget.systemCatalogStatus || 'none';
        return sc === 'none' || sc === 'rejected';
    }
    canShareToCatalog(widget) {
        const sc = widget.systemCatalogStatus || 'none';
        return sc === 'none' || sc === 'rejected';
    }
    statusBadge(status) {
        return `<span class="widget-status-badge widget-status-${status}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(status)}</span>`;
    }
    renderRejectionReason(widget) {
        if (!widget.rejectionReason) return '';
        return `
      <div class="widget-rejection-bubble" role="status">
        <p class="widget-rejection-bubble-label">Rejected Reason</p>
        <p class="widget-rejection-bubble-body">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.rejectionReason)}</p>
      </div>
    `;
    }
    renderWidgetDetails(widget) {
        const lines = [];
        if (widget.description) lines.push(`<div class="form-text">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.description)}</div>`);
        if (widget.rejectionReason) lines.push(this.renderRejectionReason(widget));
        return lines.join('');
    }
    docHref(path) {
        return (0, $82c5ec211b0f131c$export$7be6c6c696c8413b)(path);
    }
    docLink(path, innerHtml, className = '') {
        const classAttr = className ? ` class="${className}"` : '';
        return `<a href="${this.docHref(path)}"${classAttr} target="_docs" rel="noopener noreferrer">${innerHtml}</a>`;
    }
    renderConfigFieldRow(row, index) {
        const rowTitle = row.title?.trim() || row.key?.trim() || `Variable ${index + 1}`;
        const markdownDisabled = row.secret ? 'disabled' : '';
        const secretDisabled = row.markdown ? 'disabled' : '';
        return `
      <div class="widget-config-field-row card" data-config-row="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}">
        <div class="widget-config-field-row-header">
          <span class="form-label">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(rowTitle)}</span>
          <button type="button" class="btn btn-secondary btn-sm" data-action="remove-config-field" data-row-id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}">Remove</button>
        </div>
        <div class="form-group">
          <label class="form-label" for="config-key-${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}">Variable name</label>
          <input
            id="config-key-${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}"
            type="text"
            class="form-control"
            data-config-field="key"
            placeholder="apikey"
            autocomplete="off"
            value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.key)}"
          />
          <p class="form-text">Used in <code>fot.getConfig()</code> and <code>{ $secret: 'name' }</code>.</p>
        </div>
        <div class="form-group">
          <label class="form-label" for="config-title-${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}">Label</label>
          <input
            id="config-title-${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}"
            type="text"
            class="form-control"
            data-config-field="title"
            placeholder="Last.fm API key"
            autocomplete="off"
            value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.title)}"
          />
        </div>
        <div class="form-group">
          <label class="form-label" for="config-desc-${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}">Help text</label>
          <input
            id="config-desc-${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.rowId)}"
            type="text"
            class="form-control"
            data-config-field="description"
            placeholder="Optional hint for profile owners"
            autocomplete="off"
            value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(row.description)}"
          />
        </div>
        <div class="widget-config-field-flags">
          <label class="widget-config-flag">
            <input type="checkbox" data-config-field="required" ${row.required ? 'checked' : ''} />
            Required
          </label>
          <label class="widget-config-flag">
            <input type="checkbox" data-config-field="secret" ${row.secret ? 'checked' : ''} ${secretDisabled} />
            Secret
          </label>
          <label class="widget-config-flag">
            <input type="checkbox" data-config-field="markdown" ${row.markdown ? 'checked' : ''} ${markdownDisabled} />
            Markdown
          </label>
        </div>
      </div>
    `;
    }
    renderConfigFieldsSection() {
        const rows = this.form.configFields || [];
        const rowsHtml = rows.length ? rows.map((row, index)=>this.renderConfigFieldRow(row, index)).join('') : '<p class="form-text widget-config-empty">No config variables yet. Add one if profile owners need to supply settings at install time.</p>';
        return `
      <collapsible-section data-config-section summary="Config variables (optional)" hint="Install-time settings for profile owners"${this._configSectionOpen ? ' open' : ''}>
        <p class="form-text">Profile owners fill these in when they add your widget to their layout. Secret values are encrypted server-side. See ${this.docLink('/docs/widgets/config-and-secrets', 'Config &amp; secrets')}.</p>
        <p class="form-text widget-config-schema-error" data-config-schema-error role="alert"${this.configSchemaError ? '' : ' hidden'}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.configSchemaError)}</p>
        <div class="widget-config-fields">
          ${rowsHtml}
        </div>
        <button type="button" class="btn btn-secondary widget-add-config-field-btn" data-action="add-config-field">Add variable</button>
      </collapsible-section>
    `;
    }
    renderList() {
        if (this.loading) return '<div class="loading-state"><span class="spinner"></span></div>';
        if (this.widgets.length === 0) return `<p class="form-text">No widgets yet. ${this.docLink('/docs/widgets/getting-started', 'Read the guide')}</p>`;
        return this.widgets.map((w)=>{
            const isExpanded = this.previewRowId === w.id;
            const rowError = isExpanded && this.rowPreviewError ? this.rowPreviewError : '';
            const contextKey = `row-${w.id}`;
            const cached = this.rowPreviewCache[w.id];
            const previewConfigForm = isExpanded ? (0, $562e457696e077d0$export$ef89630dc9a46e69)(cached?.configSchema, contextKey, this.previewConfigValues[contextKey] || {}) : '';
            return `
      <div class="widget-list-item card${isExpanded ? ' widget-list-item-expanded' : ''}">
        <div class="widget-list-item-header">
          <div class="widget-list-info">
            <div class="widget-list-meta">
              <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.name)}</strong>
              ${this.systemCatalogBadge(w)}
            </div>
            ${this.renderWidgetDetails(w)}
          </div>
          <div class="widget-list-actions">
            <button type="button" class="btn btn-secondary btn-sm" data-action="preview" data-id="${w.id}" aria-expanded="${isExpanded}">${isExpanded ? 'Hide preview' : 'Preview'}</button>
            <button type="button" class="btn btn-secondary btn-sm" data-action="edit" data-id="${w.id}">Edit</button>
            ${this.canDeleteWidget(w) ? `<button type="button" class="btn btn-secondary btn-sm" data-action="delete" data-id="${w.id}">Delete</button>` : ''}
          </div>
        </div>
        ${isExpanded ? `
          <div class="widget-row-preview">
            ${previewConfigForm}
            <p class="form-text widget-preview-error" data-preview-error="row-${w.id}" role="alert"${rowError ? '' : ' hidden'}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(rowError)}</p>
            <iframe
              class="widget-row-preview-frame widget-preview-frame"
              name="widget-row-preview-${w.id}"
              data-preview-name="widget-row-preview-${w.id}"
              data-widget-id="${w.id}"
              title="Preview of ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.name)}"
              sandbox="allow-scripts allow-same-origin"
            ></iframe>
          </div>
        ` : ''}
      </div>
    `;
        }).join('');
    }
    renderEditor() {
        if (!this.editingId && !this._showNew) return '';
        const editingWidget = this.editingId ? this.widgets.find((w)=>w.id === this.editingId) || this._editingWidgetMeta : null;
        const hasOAuthClientSecret = Boolean(editingWidget?.hasOAuthClientSecret ?? this._editingWidgetMeta?.hasOAuthClientSecret);
        const rejectionNote = editingWidget?.rejectionReason ? this.renderRejectionReason(editingWidget) : '';
        const adminBanner = this.adminEditMeta ? `<p class="form-text widget-admin-edit-banner" role="status">Editing <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.adminEditMeta.name)}</strong> (owned by @${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.adminEditMeta.ownerUsername)}).</p>` : '';
        return `
      <div class="widget-editor card">
        <h3>${this.editingId ? 'Edit widget' : 'New widget'}</h3>
        ${adminBanner}
        <p class="form-text">Need help? ${this.docLink('/docs/widgets/html-css-js', 'HTML/CSS/JS rules')} \xb7 ${this.docLink('/docs/widgets/message-channel', 'fot.fetch API')} \xb7 ${this.docLink('/docs/widgets/config-and-secrets', 'Config &amp; secrets')} \xb7 ${this.docLink('/docs/widgets/oauth', 'OAuth')} \xb7 ${this.docLink('/docs/widgets/submit-and-review', 'Submit &amp; review')}</p>
        ${rejectionNote}
        <div class="form-group">
          <label class="form-label">Name</label>
          <input type="text" class="form-control" data-field="name" maxlength="255" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.name)}" />
        </div>
        <div class="form-group">
          <label class="form-label">Description</label>
          <textarea class="form-control widget-description" data-field="description" rows="2">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.description)}</textarea>
        </div>
        <div class="widget-code-grid">
          <div class="form-group">
            <label class="form-label">HTML</label>
            <textarea class="form-control widget-code" data-field="htmlContent" rows="6">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.htmlContent)}</textarea>
          </div>
          <div class="form-group">
            <label class="form-label">CSS</label>
            <textarea class="form-control widget-code" data-field="cssContent" rows="6">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.cssContent)}</textarea>
          </div>
          <div class="form-group">
            <label class="form-label">JavaScript</label>
            <textarea class="form-control widget-code" data-field="jsContent" rows="6">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.jsContent)}</textarea>
          </div>
        </div>
        <div class="form-group">
          <label class="form-label">Allowed API hosts</label>
          <textarea class="form-control" data-field="allowedHosts" rows="2" placeholder="ws.audioscrobbler.com, last.fm">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.allowedHosts)}</textarea>
          <button type="button" class="btn btn-secondary widget-suggest-hosts-btn" data-action="suggest-hosts">Suggest hosts from my JS</button>
          <p class="form-text">Only these domains can be called via <code>fot.fetch</code>. Include API hosts and CDNs. See ${this.docLink('/docs/widgets/message-channel', 'fot.fetch')} and ${this.docLink('/docs/widgets/config-and-secrets', 'secrets')}.</p>
          <p class="form-text widget-suggest-hosts-hint" data-suggest-hosts-hint hidden></p>
        </div>
        ${this.renderConfigFieldsSection()}
        <collapsible-section summary="OAuth (optional)" hint="Connect button for profile owners">
          <p class="form-text">Register this redirect URI with your OAuth provider: <code>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.getOAuthCallbackDisplayUrl())}</code></p>
          <div class="form-group">
            <label class="form-label">Service label</label>
            <input type="text" class="form-control" data-field="oauthServiceLabel" placeholder="GitHub" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.oauthServiceLabel)}" />
          </div>
          <div class="form-group">
            <label class="form-label">Authorization URL</label>
            <input type="url" class="form-control" data-field="oauthAuthUrl" placeholder="https://github.com/login/oauth/authorize" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.oauthAuthUrl)}" />
          </div>
          <div class="form-group">
            <label class="form-label">Token URL</label>
            <input type="url" class="form-control" data-field="oauthTokenUrl" placeholder="https://github.com/login/oauth/access_token" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.oauthTokenUrl)}" />
          </div>
          <div class="form-group">
            <label class="form-label">Scopes</label>
            <input type="text" class="form-control" data-field="oauthScopes" placeholder="read:user" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.oauthScopes)}" />
          </div>
          <div class="form-group">
            <label class="form-label">OAuth client ID</label>
            <input type="text" class="form-control" data-field="oauthClientId" autocomplete="off" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.form.oauthClientId)}" />
          </div>
          <div class="form-group">
            <label class="form-label">OAuth client secret</label>
            <input type="password" class="form-control" data-field="oauthClientSecret" autocomplete="new-password" placeholder="${hasOAuthClientSecret ? 'Leave blank to keep existing' : ''}" />
            ${hasOAuthClientSecret ? '<p class="form-text">Leave blank when saving \u2014 your existing secret is kept.</p>' : ''}
          </div>
          <div class="form-group widget-oauth-pkce-row">
            <div class="widget-oauth-pkce-info">
              <span class="form-label">Use PKCE</span>
              <p class="form-text">Enable for providers that require Proof Key for Code Exchange.</p>
            </div>
            <label class="toggle-switch" aria-label="Use PKCE">
              <input type="checkbox" data-field="oauthPkce" ${this.form.oauthPkce ? 'checked' : ''} />
              <span class="toggle-slider"></span>
            </label>
          </div>
        </collapsible-section>
        <div class="widget-preview-block">
          <h4>Preview</h4>
          <p class="form-text">Updates live as you edit (sandboxed on widget-host). Save to persist changes.</p>
          ${(0, $562e457696e077d0$export$ef89630dc9a46e69)(null, 'editor', this.previewConfigValues.editor || {}, this.form.configFields)}
          <p class="form-text widget-preview-error" data-preview-error="editor" role="alert"${this.editorPreviewError ? '' : ' hidden'}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.editorPreviewError)}</p>
          <iframe
            class="widget-editor-preview-frame widget-preview-frame"
            name="widget-editor-preview"
            data-preview-name="widget-editor-preview"
            title="Widget preview"
            sandbox="allow-scripts allow-same-origin"
          ></iframe>
        </div>
        <div class="widget-editor-actions">
          <button type="button" class="btn btn-primary" data-action="save" ${this.saving ? 'disabled' : ''}>Save</button>
          <button type="button" class="btn btn-secondary" data-action="submit" ${!this.editingId || editingWidget && !this.canShareToCatalog(editingWidget) ? 'disabled' : ''}>Share to community catalog</button>
          <button type="button" class="btn btn-secondary" data-action="cancel">Cancel</button>
        </div>
      </div>
    `;
    }
    render() {
        this.captureConfigSectionOpen();
        this.capturePreviewConfigState();
        this.innerHTML = `
      <div class="widget-management">
        <div class="widget-management-header">
          <h1>My Widgets</h1>
          <p>Create sandboxed blocks for your profile \u{2014} use on your page right away, or share to the community catalog.</p>
          ${this.docLink('/docs/widgets', 'Widget docs', 'btn btn-secondary')}
          <button type="button" class="btn btn-primary" data-action="new">Create widget</button>
        </div>
        ${this.message ? `<p class="widget-message">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.message)}</p>` : ''}
        <div class="widget-list">${this.renderList()}</div>
        ${this.renderEditor()}
      </div>
    `;
    }
    attachListeners() {
        this.querySelector('[data-action="new"]')?.addEventListener('click', ()=>{
            this.resetForm();
            this._showNew = true;
            this.previewRowId = null;
            this.render();
            this.attachListeners();
            this.updateEditorPreview();
        });
        this.querySelectorAll('[data-action="preview"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.toggleRowPreview(parseInt(btn.dataset.id, 10)));
        });
        this.querySelectorAll('[data-action="edit"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.openEdit(parseInt(btn.dataset.id, 10)));
        });
        this.querySelectorAll('[data-action="delete"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.deleteWidget(parseInt(btn.dataset.id, 10)));
        });
        this.querySelector('[data-action="save"]')?.addEventListener('click', ()=>{
            this.syncFormFromDom();
            this.saveDraft();
        });
        this.querySelector('[data-action="submit"]')?.addEventListener('click', ()=>this.submitForReview());
        this.querySelector('[data-action="cancel"]')?.addEventListener('click', ()=>{
            this.resetForm();
            this.render();
            this.attachListeners();
        });
        this.querySelector('[data-action="add-config-field"]')?.addEventListener('click', ()=>{
            this.addConfigField();
        });
        this.querySelector('[data-config-section]')?.addEventListener('collapsible-toggle', (event)=>{
            this._configSectionOpen = Boolean(event.detail?.open);
        });
        this.querySelectorAll('[data-action="remove-config-field"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                this.removeConfigField(btn.dataset.rowId);
            });
        });
        this.querySelectorAll('[data-config-row]').forEach((rowEl)=>{
            const secretInput = rowEl.querySelector('[data-config-field="secret"]');
            const markdownInput = rowEl.querySelector('[data-config-field="markdown"]');
            secretInput?.addEventListener('change', ()=>{
                if (secretInput.checked && markdownInput) {
                    markdownInput.checked = false;
                    markdownInput.disabled = true;
                } else if (markdownInput) markdownInput.disabled = false;
            });
            markdownInput?.addEventListener('change', ()=>{
                if (markdownInput.checked && secretInput) {
                    secretInput.checked = false;
                    secretInput.disabled = true;
                } else if (secretInput) secretInput.disabled = false;
            });
        });
        this.querySelector('[data-action="suggest-hosts"]')?.addEventListener('click', ()=>{
            this.syncFormFromDom();
            const js = this.querySelector('[data-field="jsContent"]')?.value || '';
            const extracted = (0, $7ba36a01d015ebb8$export$cf21550e9bab74a5)(js);
            const hostsField = this.querySelector('[data-field="allowedHosts"]');
            const hint = this.querySelector('[data-suggest-hosts-hint]');
            if (!extracted.length) {
                if (hint) {
                    hint.hidden = false;
                    hint.textContent = "No fot.fetch URLs found \u2014 add hosts manually or use fot.fetch in your JS first.";
                }
                return;
            }
            if (hostsField) {
                hostsField.value = (0, $7ba36a01d015ebb8$export$7fb50f25b17a502e)(hostsField.value, extracted);
                this.form.allowedHosts = hostsField.value;
            }
            if (hint) {
                hint.hidden = false;
                hint.textContent = `Added: ${extracted.join(', ')}`;
            }
        });
        this.querySelectorAll('[data-preview-config]').forEach((section)=>{
            const contextKey = section.dataset.previewConfig;
            section.querySelectorAll('[data-preview-config-field]').forEach((field)=>{
                field.addEventListener('input', ()=>{
                    this.previewConfigValues[contextKey] = (0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, contextKey);
                    if (contextKey === 'editor') this.scheduleEditorPreviewUpdate();
                    else if (contextKey.startsWith('row-')) {
                        const widgetId = parseInt(contextKey.slice(4), 10);
                        if (!Number.isNaN(widgetId)) {
                            if (this._previewDebounceTimer) clearTimeout(this._previewDebounceTimer);
                            this._previewDebounceTimer = setTimeout(()=>{
                                this._previewDebounceTimer = null;
                                this.updateRowPreviewIframe(widgetId);
                            }, $4511425752c95c4f$var$PREVIEW_DEBOUNCE_MS);
                        }
                    }
                });
            });
        });
        if (this.editingId || this._showNew) {
            const previewFields = [
                'name',
                'htmlContent',
                'cssContent',
                'jsContent'
            ];
            previewFields.forEach((field)=>{
                this.querySelector(`[data-field="${field}"]`)?.addEventListener('input', ()=>{
                    this.scheduleEditorPreviewUpdate();
                });
            });
            this.updateEditorPreview();
        }
        if (this.previewRowId) this.updateRowPreviewIframe(this.previewRowId);
    }
}
customElements.define('widget-management', $4511425752c95c4f$var$WidgetManagement);






const $8cc290a05e0a44e0$var$PREVIEW_DEBOUNCE_MS = 300;
class $8cc290a05e0a44e0$var$AdminWidgetManagement extends HTMLElement {
    constructor(){
        super();
        this.widgets = [];
        this.loading = true;
        this.reviewWidgetId = null;
        this.widgetDetailCache = {};
        this.reviewPreviewError = null;
        this.previewConfigValues = {};
        this._previewDebounceTimer = null;
    }
    disconnectedCallback() {
        if (this._previewDebounceTimer) {
            clearTimeout(this._previewDebounceTimer);
            this._previewDebounceTimer = null;
        }
    }
    connectedCallback() {
        this.render();
        this.loadWidgets();
    }
    async loadWidgets() {
        try {
            const res = await window.API.request('/widgets/admin/all');
            this.widgets = res.widgets || [];
            this.loading = false;
            this.render();
            this.attachListeners();
        } catch (err) {
            window.logger.error(err);
            this.loading = false;
            this.innerHTML = '<div class="admin-widget-management"><p class="help-error">Failed to load widgets.</p></div>';
        }
    }
    async updateStatus(id, status, rejectionReason) {
        try {
            await window.API.request(`/widgets/admin/${id}/status`, {
                method: 'PUT',
                body: JSON.stringify({
                    status: status,
                    rejectionReason: rejectionReason || null
                })
            });
            delete this.widgetDetailCache[id];
            if (this.reviewWidgetId === id) {
                this.reviewWidgetId = null;
                this.reviewPreviewError = null;
            }
            await this.loadWidgets();
        } catch (err) {
            alert(err.message || 'Update failed');
        }
    }
    updateReviewPreviewErrorDom(widgetId) {
        const el = this.querySelector(`[data-preview-error="review-${widgetId}"]`);
        if (el) {
            el.textContent = this.reviewPreviewError || '';
            el.hidden = !this.reviewPreviewError;
        }
    }
    capturePreviewConfigState() {
        if (!this.reviewWidgetId) return;
        const key = `review-${this.reviewWidgetId}`;
        this.previewConfigValues[key] = (0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, key);
    }
    async updateReviewPreview(widgetId) {
        const iframe = this.querySelector(`.admin-widget-preview-frame[data-widget-id="${widgetId}"]`);
        if (!iframe) return;
        try {
            const res = await window.API.request(`/widgets/${widgetId}/preview-token`, {
                method: 'POST'
            });
            this.reviewPreviewError = null;
            const host = (0, $af08569b79d42cf2$export$93120b5c6ce37c17)();
            (0, $af08569b79d42cf2$export$2ac4fca7f859164f)(iframe, `${host}/render/preview/${widgetId}?token=${encodeURIComponent(res.token)}`, {
                widgetId: widgetId,
                getInstanceConfig: ()=>(0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, `review-${widgetId}`),
                onError: ()=>{
                    this.reviewPreviewError = (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)();
                    this.updateReviewPreviewErrorDom(widgetId);
                }
            });
            this.updateReviewPreviewErrorDom(widgetId);
        } catch (err) {
            window.logger.warn('Admin widget preview failed:', err);
            this.reviewPreviewError = (0, $af08569b79d42cf2$export$80ae1d8e0ce464c7)();
            this.updateReviewPreviewErrorDom(widgetId);
        }
    }
    async toggleReview(id) {
        if (this.reviewWidgetId === id) {
            this.capturePreviewConfigState();
            this.reviewWidgetId = null;
            this.reviewPreviewError = null;
            this.render();
            this.attachListeners();
            return;
        }
        this.reviewWidgetId = id;
        this.reviewPreviewError = null;
        if (!this.widgetDetailCache[id]) try {
            const res = await window.API.request(`/widgets/${id}`);
            this.widgetDetailCache[id] = res.widget;
        } catch (err) {
            window.logger.error(err);
            alert('Could not load widget for review');
            this.reviewWidgetId = null;
            return;
        }
        this.render();
        this.attachListeners();
        await this.updateReviewPreview(id);
    }
    renderModerationSection(w) {
        const sc = w.systemCatalogStatus || 'none';
        if (sc !== 'pending') return '';
        return `
      <div class="admin-widget-moderation">
        <div class="form-group">
          <label class="form-label" for="admin-rejection-${w.id}">Feedback for creator</label>
          <textarea
            id="admin-rejection-${w.id}"
            class="form-control"
            data-rejection-comment="${w.id}"
            rows="3"
            maxlength="2000"
            placeholder="Required when rejecting \u{2014} explain what needs to change"
          ></textarea>
          <p class="form-text">The creator will see this message on My Widgets when the widget is rejected.</p>
        </div>
        <div class="admin-widget-moderation-actions">
          <button type="button" class="btn btn-primary btn-sm" data-action="approve" data-id="${w.id}">Approve</button>
          <button type="button" class="btn btn-secondary btn-sm" data-action="reject" data-id="${w.id}">Reject with feedback</button>
        </div>
      </div>
    `;
    }
    getRejectionComment(widgetId) {
        return this.querySelector(`[data-rejection-comment="${widgetId}"]`)?.value?.trim() || '';
    }
    async rejectWidget(id) {
        const reason = this.getRejectionComment(id);
        if (!reason) {
            const field = this.querySelector(`[data-rejection-comment="${id}"]`);
            field?.focus();
            field?.classList.add('is-invalid');
            alert('Please add feedback explaining why the widget was rejected.');
            return;
        }
        if (!window.confirm('Reject this widget and send feedback to the creator?')) return;
        await this.updateStatus(id, 'rejected', reason);
    }
    renderOAuthAudit(widget) {
        if (!widget?.oauthConfig) return '';
        const cfg = widget.oauthConfig;
        const scopes = (cfg.scopes || []).join(' ') || '(none)';
        const tokenHost = (()=>{
            try {
                return new URL(cfg.tokenUrl || cfg.token_url).hostname;
            } catch  {
                return '(invalid)';
            }
        })();
        const authHost = (()=>{
            try {
                return new URL(cfg.authorizationUrl || cfg.authorization_url).hostname;
            } catch  {
                return '(invalid)';
            }
        })();
        const allowed = widget.allowedHosts || widget.networkPolicy?.allowedHosts || [];
        const apiWarn = tokenHost && allowed.length && !allowed.some((h)=>{
            if (h.startsWith('*.')) {
                const suffix = h.slice(1);
                return tokenHost.endsWith(suffix) || tokenHost === h.slice(2);
            }
            return h === tokenHost || h === authHost;
        }) ? `<p class="form-text widget-hosts-warn" role="alert">OAuth token host (${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(tokenHost)}) may not match allowed API hosts.</p>` : '';
        return `
      <div class="admin-widget-oauth-audit">
        <h4>OAuth configuration</h4>
        <p class="form-text"><strong>Service:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(cfg.serviceLabel || 'service')}</p>
        <p class="form-text"><strong>Authorization URL:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(cfg.authorizationUrl || cfg.authorization_url || '')}</p>
        <p class="form-text"><strong>Token URL:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(cfg.tokenUrl || cfg.token_url || '')}</p>
        <p class="form-text"><strong>Scopes:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(scopes)}</p>
        <p class="form-text"><strong>Client ID:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.oauthClientId || '(not set)')}</p>
        <p class="form-text"><strong>Client secret:</strong> ${widget.hasOAuthClientSecret ? 'configured' : '(not set)'}</p>
        ${apiWarn}
      </div>
    `;
    }
    renderHostsAudit(widget) {
        if (!widget) return '';
        const declared = (widget.allowedHosts || []).join(', ') || '(none)';
        const extracted = (0, $7ba36a01d015ebb8$export$cf21550e9bab74a5)(widget.jsContent || '');
        const extractedText = extracted.length ? extracted.join(', ') : '(none found in JS)';
        const missing = extracted.filter((h)=>!(widget.allowedHosts || []).some((allowed)=>{
                if (allowed.startsWith('*.')) {
                    const suffix = allowed.slice(1);
                    return h.endsWith(suffix) || h === allowed.slice(2);
                }
                return h === allowed;
            }));
        const warn = missing.length ? `<p class="form-text widget-hosts-warn" role="alert">JS calls hosts not in allowed list: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(missing.join(', '))}</p>` : '';
        return `
      <div class="admin-widget-hosts-audit">
        <h4>Allowed API hosts</h4>
        <p class="form-text"><strong>Declared:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(declared)}</p>
        <p class="form-text"><strong>From JS scan:</strong> ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(extractedText)}</p>
        ${warn}
      </div>
    `;
    }
    renderCodeSection(widget) {
        if (!widget) return '';
        return `
      <div class="admin-widget-code">
        <h4>Source code</h4>
        <p class="form-text">Review HTML, CSS, and JavaScript before approving.</p>
        <div class="widget-code-grid">
          <div class="form-group">
            <label class="form-label">HTML</label>
            <textarea class="form-control widget-code" readonly rows="8">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.htmlContent || '')}</textarea>
          </div>
          <div class="form-group">
            <label class="form-label">CSS</label>
            <textarea class="form-control widget-code" readonly rows="8">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.cssContent || '')}</textarea>
          </div>
          <div class="form-group">
            <label class="form-label">JavaScript</label>
            <textarea class="form-control widget-code" readonly rows="8">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widget.jsContent || '')}</textarea>
          </div>
        </div>
      </div>
    `;
    }
    renderList() {
        if (this.loading) return '<div class="loading-state"><span class="spinner"></span></div>';
        if (this.widgets.length === 0) return '<p class="form-text">No widgets to moderate.</p>';
        return this.widgets.map((w)=>{
            const isExpanded = this.reviewWidgetId === w.id;
            const rowError = isExpanded && this.reviewPreviewError ? this.reviewPreviewError : '';
            const detail = isExpanded ? this.widgetDetailCache[w.id] : null;
            const contextKey = `review-${w.id}`;
            const previewConfigForm = isExpanded ? (0, $562e457696e077d0$export$ef89630dc9a46e69)(detail?.configSchema, contextKey, this.previewConfigValues[contextKey] || {}) : '';
            return `
      <div class="admin-widget-row card${isExpanded ? ' admin-widget-row-expanded' : ''}">
        <div class="admin-widget-row-header">
          <div class="admin-widget-info">
            <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.name)}</strong>
            <span class="widget-status-badge widget-status-${w.systemCatalogStatus || 'none'}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.systemCatalogStatus || 'none')}</span>
            ${w.isPlatform ? '<span class="widget-status-badge widget-status-platform">platform</span>' : ''}
            <div class="form-text">by ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.ownerUsername || 'user #' + w.ownerUserId)}</div>
            ${w.description ? `<div class="form-text">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.description)}</div>` : ''}
            ${w.rejectionReason ? `<div class="form-text">Reason: ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.rejectionReason)}</div>` : ''}
          </div>
          <div class="admin-widget-actions">
            <button type="button" class="btn btn-secondary btn-sm" data-action="edit-widget" data-id="${w.id}">Edit widget</button>
            <button type="button" class="btn btn-secondary btn-sm" data-action="review" data-id="${w.id}" aria-expanded="${isExpanded}">${isExpanded ? 'Hide review' : 'Review'}</button>
            ${(w.systemCatalogStatus || 'none') === 'pending' ? `
              <button type="button" class="btn btn-primary btn-sm" data-action="approve" data-id="${w.id}">Approve</button>
            ` : ''}
            ${w.systemCatalogStatus === 'approved' ? `
              <button type="button" class="btn btn-secondary btn-sm" data-action="disable" data-id="${w.id}">Disable</button>
            ` : ''}
            ${w.systemCatalogStatus === 'disabled' ? `
              <button type="button" class="btn btn-primary btn-sm" data-action="approve" data-id="${w.id}">Re-approve</button>
            ` : ''}
          </div>
        </div>
        ${isExpanded ? `
          <div class="admin-widget-review-panel">
            <div class="widget-preview-block">
              <h4>Preview</h4>
              <p class="form-text">Sandboxed on widget-host \u{2014} same as on the creator's profile.</p>
              ${previewConfigForm}
              <p class="form-text widget-preview-error" data-preview-error="review-${w.id}" role="alert"${rowError ? '' : ' hidden'}>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(rowError)}</p>
              <iframe
                class="admin-widget-preview-frame widget-preview-frame"
                name="admin-widget-preview-${w.id}"
                data-preview-name="admin-widget-preview-${w.id}"
                data-widget-id="${w.id}"
                title="Preview of ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(w.name)}"
                sandbox="allow-scripts allow-same-origin"
              ></iframe>
            </div>
            ${this.renderOAuthAudit(detail)}
            ${this.renderHostsAudit(detail)}
            ${this.renderCodeSection(detail)}
            ${this.renderModerationSection(w)}
          </div>
        ` : ''}
      </div>
    `;
        }).join('');
    }
    render() {
        this.capturePreviewConfigState();
        this.innerHTML = `
      <div class="admin-widget-management">
        <header class="admin-widget-header">
          <h2>Widget moderation</h2>
          <p class="form-text">Review user-submitted profile widgets before they appear in the public catalog.</p>
        </header>
        <div class="admin-widget-list">${this.renderList()}</div>
      </div>
    `;
    }
    attachListeners() {
        this.querySelectorAll('[data-action="edit-widget"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const id = parseInt(btn.dataset.id, 10);
                if (Number.isNaN(id)) return;
                window.router?.navigate(`/settings/widgets?edit=${id}`);
            });
        });
        this.querySelectorAll('[data-action="review"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.toggleReview(parseInt(btn.dataset.id, 10)));
        });
        this.querySelectorAll('[data-action="approve"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.updateStatus(parseInt(btn.dataset.id, 10), 'approved'));
        });
        this.querySelectorAll('[data-action="disable"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.updateStatus(parseInt(btn.dataset.id, 10), 'disabled'));
        });
        this.querySelectorAll('[data-action="reject"]').forEach((btn)=>{
            btn.addEventListener('click', ()=>this.rejectWidget(parseInt(btn.dataset.id, 10)));
        });
        this.querySelectorAll('[data-rejection-comment]').forEach((field)=>{
            field.addEventListener('input', ()=>field.classList.remove('is-invalid'));
        });
        this.querySelectorAll('[data-preview-config]').forEach((section)=>{
            const contextKey = section.dataset.previewConfig;
            section.querySelectorAll('[data-preview-config-field]').forEach((field)=>{
                field.addEventListener('input', ()=>{
                    this.previewConfigValues[contextKey] = (0, $562e457696e077d0$export$fd5ef8e3c4fdafdf)(this, contextKey);
                    if (contextKey.startsWith('review-')) {
                        const widgetId = parseInt(contextKey.slice(7), 10);
                        if (!Number.isNaN(widgetId)) {
                            if (this._previewDebounceTimer) clearTimeout(this._previewDebounceTimer);
                            this._previewDebounceTimer = setTimeout(()=>{
                                this._previewDebounceTimer = null;
                                this.updateReviewPreview(widgetId);
                            }, $8cc290a05e0a44e0$var$PREVIEW_DEBOUNCE_MS);
                        }
                    }
                });
            });
        });
        if (this.reviewWidgetId) this.updateReviewPreview(this.reviewWidgetId);
    }
}
customElements.define('admin-widget-management', $8cc290a05e0a44e0$var$AdminWidgetManagement);


// Prompt Picker Web Component
class $e3c49c3badf3fae9$var$PromptPicker extends HTMLElement {
    constructor(){
        super();
        this.prompts = [];
        this.currentPrompt = null;
        this.isLoading = false;
        this.currentUser = null;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        // Try to load prompts, with retry if API isn't ready yet
        this.loadPrompts();
        this.handleOpenProposePrompt = (e)=>{
            this.openPromptModal(e.detail || {});
        };
        document.addEventListener('open-propose-prompt', this.handleOpenProposePrompt);
    }
    render() {
        this.innerHTML = `
      <div class="prompt-picker">
        <div class="prompt-display">
          <post-type-selector selected-type="text" id="promptPickerPostTypeSelector"></post-type-selector>
          <div class="prompt-actions">
            <washing-machine-icon 
              id="washingMachineBtn" 
              size="medium" 
              interactive="true"
              title="Get a writing prompt!"
            ></washing-machine-icon>
            <button class="propose-prompt-btn" id="proposePromptBtn" title="Propose a new writing prompt">
              \u{1F4A1}
            </button>
          </div>
        </div>
        <div class="prompt-body" id="promptBody" style="display: none;"></div>
      </div>
    `;
    }
    attachEventListeners() {
        const washingMachineBtn = this.querySelector('#washingMachineBtn');
        const proposePromptBtn = this.querySelector('#proposePromptBtn');
        const postTypeSelector = this.querySelector('#promptPickerPostTypeSelector');
        // Listen for post type changes from selector
        if (postTypeSelector) postTypeSelector.addEventListener('post-type-selected', (e)=>{
            // Dispatch event to parent post-writer to switch types
            this.dispatchEvent(new CustomEvent('switch-post-type', {
                detail: {
                    type: e.detail.type
                },
                bubbles: true
            }));
        });
        washingMachineBtn.addEventListener('click', ()=>{
            this.getRandomPrompt();
        });
        proposePromptBtn.addEventListener('click', ()=>{
            this.openPromptModal();
        });
    }
    async loadPrompts() {
        if (this.isLoading) return;
        this.isLoading = true;
        try {
            // TODO: this should probably be done on the server side
            const response = await window.API.request('/prompts/public');
            this.prompts = response.prompts || [];
        } catch (error) {
            window.logger.error('Failed to load prompts:', error);
            this.prompts = [];
        } finally{
            this.isLoading = false;
        }
    }
    getRandomPrompt() {
        if (this.isLoading || this.prompts.length === 0) {
            // If no prompts loaded, try to load them
            if (this.prompts.length === 0) this.loadPrompts().then(()=>{
                if (this.prompts.length > 0) this.getRandomPrompt();
            });
            return;
        }
        // Add spinning animation
        const washingMachineBtn = this.querySelector('#washingMachineBtn');
        const promptBody = this.querySelector('#promptBody');
        washingMachineBtn.spin();
        // Get a random prompt (different from current if possible)
        let newPrompt;
        if (this.prompts.length === 1) newPrompt = this.prompts[0];
        else do newPrompt = this.prompts[Math.floor(Math.random() * this.prompts.length)];
        while (newPrompt === this.currentPrompt && this.prompts.length > 1);
        // Update after animation
        setTimeout(()=>{
            this.currentPrompt = newPrompt;
            // Don't show body here - it will be populated in the textarea or poll editor
            promptBody.style.display = 'none';
            // Dispatch event for parent components
            this.dispatchEvent(new CustomEvent('prompt-selected', {
                detail: {
                    prompt: newPrompt
                },
                bubbles: true
            }));
        }, 600);
    }
    getCurrentPrompt() {
        return this.currentPrompt;
    }
    clearPrompt() {
        this.currentPrompt = null;
        const promptBody = this.querySelector('#promptBody');
        promptBody.style.display = 'none';
        // Dispatch event
        this.dispatchEvent(new CustomEvent('prompt-cleared', {
            bubbles: true
        }));
    }
    openPromptModal(opts = {}) {
        // Create true modal outside component hierarchy
        const modal = document.createElement('div');
        modal.className = 'user-prompt-modal';
        modal.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h3>\u{1F4A1} Propose a Writing Prompt</h3>
            <button class="close-btn" id="closeUserModal">&times;</button>
          </div>
          <form class="user-prompt-form" id="userPromptForm">
            <div class="form-group">
              <label>Prompt Type *</label>
              <div class="prompt-type-selector">
                <label class="prompt-type-option">
                  <input type="radio" name="prompt_type" value="text" checked>
                  <span>\u{1F4DD} Text Prompt</span>
                </label>
                <label class="prompt-type-option">
                  <input type="radio" name="prompt_type" value="poll">
                  <span>\u{1F4CA} Poll Prompt</span>
                </label>
              </div>
            </div>
            <div class="form-group">
              <label for="userPromptTitle">Prompt Title *</label>
              <input 
                type="text" 
                id="userPromptTitle" 
                name="title" 
                placeholder="e.g., What made you smile today?"
                maxlength="255"
                required
              />
            </div>
            <div class="form-group" id="textPromptBodyGroup">
              <label for="userPromptBody">
                Optional Body
                <span class="help-text">(Additional context or template for the prompt)</span>
              </label>
              <textarea 
                id="userPromptBody" 
                name="body" 
                placeholder="e.g., You could do one of those lists where people bold all the things they've done..."
                rows="3"
                maxlength="1000"
              ></textarea>
            </div>
            <div class="form-group" id="pollPromptOptionsGroup" style="display: none;">
              <label for="pollPromptOptions">
                Poll Options *
                <span class="help-text">(2-10 options, one per line)</span>
              </label>
              <textarea 
                id="pollPromptOptions" 
                name="poll_options" 
                placeholder="Spring&#10;Summer&#10;Fall&#10;Winter"
                rows="6"
              ></textarea>
              <div class="option-count">
                <span id="pollOptionCount">0</span> options
              </div>
            </div>
            <div class="form-notice">
              <div class="notice-icon">\u{1F99D}</div>
              <div class="notice-text">
                Your prompt will be submitted for admin review before appearing in the global pool.
                You can use it immediately for your own posts!
              </div>
            </div>
            <div class="form-actions">
              <button type="button" class="btn btn-secondary" id="cancelUserPrompt">Cancel</button>
              <button type="submit" class="btn btn-primary" id="submitUserPrompt">
                <span class="btn-text">Propose Prompt</span>
                <span class="btn-loading" style="display: none;">\u{23F3} Creating...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    `;
        document.body.appendChild(modal);
        // Add event listeners
        modal.querySelector('#closeUserModal').addEventListener('click', ()=>{
            this.closePromptModal(modal);
        });
        modal.querySelector('#cancelUserPrompt').addEventListener('click', ()=>{
            this.closePromptModal(modal);
        });
        modal.querySelector('.modal-backdrop').addEventListener('click', (e)=>{
            if (e.target.classList.contains('modal-backdrop')) this.closePromptModal(modal);
        });
        const applyPromptTypeUI = (isPoll)=>{
            const textBodyGroup = modal.querySelector('#textPromptBodyGroup');
            const pollOptionsGroup = modal.querySelector('#pollPromptOptionsGroup');
            const pollOptionsInput = modal.querySelector('#pollPromptOptions');
            if (isPoll) {
                textBodyGroup.style.display = 'none';
                pollOptionsGroup.style.display = 'block';
                pollOptionsInput.focus();
            } else {
                textBodyGroup.style.display = 'block';
                pollOptionsGroup.style.display = 'none';
            }
        };
        // Handle prompt type change
        modal.querySelectorAll('input[name="prompt_type"]').forEach((radio)=>{
            radio.addEventListener('change', (e)=>{
                applyPromptTypeUI(e.target.value === 'poll');
            });
        });
        if (opts.presetType === 'poll') {
            const pollRadio = modal.querySelector('input[name="prompt_type"][value="poll"]');
            if (pollRadio) {
                pollRadio.checked = true;
                applyPromptTypeUI(true);
            }
        }
        // Handle poll options input
        const pollOptionsInput = modal.querySelector('#pollPromptOptions');
        if (pollOptionsInput) pollOptionsInput.addEventListener('input', (e)=>{
            const options = e.target.value.split('\n').filter((opt)=>opt.trim().length > 0);
            const countSpan = modal.querySelector('#pollOptionCount');
            if (countSpan) countSpan.textContent = options.length;
        });
        modal.querySelector('#userPromptForm').addEventListener('submit', (e)=>{
            e.preventDefault();
            this.handlePromptSubmission(modal);
        });
        // Close modal with Escape key
        const escapeHandler = (e)=>{
            if (e.key === 'Escape') {
                this.closePromptModal(modal);
                document.removeEventListener('keydown', escapeHandler);
            }
        };
        document.addEventListener('keydown', escapeHandler);
        // Focus on title input (or poll options when preset to poll)
        setTimeout(()=>{
            if (opts.presetType === 'poll') {
                const pollOptionsInput = modal.querySelector('#pollPromptOptions');
                if (pollOptionsInput) pollOptionsInput.focus();
            } else modal.querySelector('#userPromptTitle').focus();
        }, 100);
    }
    closePromptModal(modal) {
        modal.remove();
    }
    async handlePromptSubmission(modal) {
        const titleInput = modal.querySelector('#userPromptTitle');
        const bodyInput = modal.querySelector('#userPromptBody');
        const pollOptionsInput = modal.querySelector('#pollPromptOptions');
        const promptTypeRadios = modal.querySelectorAll('input[name="prompt_type"]');
        const submitBtn = modal.querySelector('#submitUserPrompt');
        const btnText = submitBtn.querySelector('.btn-text');
        const btnLoading = submitBtn.querySelector('.btn-loading');
        const title = titleInput.value.trim();
        const selectedType = Array.from(promptTypeRadios).find((r)=>r.checked)?.value || 'text';
        const isPoll = selectedType === 'poll';
        if (!title) {
            alert('Please enter a prompt title');
            titleInput.focus();
            return;
        }
        // Validate poll options if it's a poll prompt
        if (isPoll) {
            const pollOptions = pollOptionsInput.value.split('\n').map((opt)=>opt.trim()).filter((opt)=>opt.length > 0);
            if (pollOptions.length < 2) {
                alert('Poll prompts must have at least 2 options');
                pollOptionsInput.focus();
                return;
            }
            if (pollOptions.length > 10) {
                alert('Poll prompts can have at most 10 options');
                pollOptionsInput.focus();
                return;
            }
            // Check for duplicates (case-insensitive)
            const optionTexts = pollOptions.map((opt)=>opt.toLowerCase());
            const uniqueOptions = new Set(optionTexts);
            if (optionTexts.length !== uniqueOptions.size) {
                alert('Poll options must be unique');
                pollOptionsInput.focus();
                return;
            }
            // Check option length
            for (const option of pollOptions)if (option.length > 500) {
                alert('Each poll option must be 500 characters or less');
                pollOptionsInput.focus();
                return;
            }
        }
        // Set loading state
        submitBtn.disabled = true;
        btnText.style.display = 'none';
        btnLoading.style.display = 'inline';
        try {
            const promptData = {
                title: title,
                prompt_type: selectedType
            };
            if (isPoll) {
                const pollOptions = pollOptionsInput.value.split('\n').map((opt)=>opt.trim()).filter((opt)=>opt.length > 0);
                promptData.poll_options = pollOptions;
            } else {
                const body = bodyInput.value.trim();
                promptData.body = body || null;
            }
            const response = await window.API.prompts.create(promptData);
            // Auto-select the newly created prompt
            this.currentPrompt = {
                id: response.prompt.id,
                title: response.prompt.title,
                body: response.prompt.body,
                prompt_type: response.prompt.prompt_type,
                poll_options: response.prompt.poll_options
            };
            // Update UI to show selected prompt
            const promptBody = this.querySelector('#promptBody');
            // Don't show body here - it will be populated in the textarea or poll editor
            promptBody.style.display = 'none';
            // Dispatch event for parent components
            this.dispatchEvent(new CustomEvent('prompt-selected', {
                detail: {
                    prompt: this.currentPrompt
                },
                bubbles: true
            }));
            // Show success message
            this.showSuccessMessage('Prompt created and selected! Start writing with your new prompt.');
            // Close modal
            this.closePromptModal(modal);
            // Reload prompts for future use
            await this.loadPrompts();
        } catch (error) {
            window.logger.error('Failed to create prompt:', error);
            let errorMessage = 'Failed to create prompt. Please try again.';
            if (error.message) errorMessage = error.message;
            else if (error.details && Array.isArray(error.details)) errorMessage = error.details.map((d)=>d.message).join(', ');
            alert(errorMessage);
            // Reset button state
            submitBtn.disabled = false;
            btnText.style.display = 'inline';
            btnLoading.style.display = 'none';
        }
    }
    showSuccessMessage(message) {
        // Create temporary success message
        const successEl = document.createElement('div');
        successEl.style.cssText = `
      position: fixed;
      top: 2rem;
      right: 2rem;
      background: #10b981;
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 8px;
      font-weight: 500;
      z-index: 10001;
      animation: slideInRight 0.3s ease-out;
      max-width: 300px;
    `;
        successEl.textContent = message;
        // Add animation
        const style = document.createElement('style');
        style.textContent = `
      @keyframes slideInRight {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
    `;
        document.head.appendChild(style);
        document.body.appendChild(successEl);
        // Remove after 4 seconds
        setTimeout(()=>{
            successEl.remove();
            style.remove();
        }, 4000);
    }
    isAuthenticated() {
        return this.currentUser !== null;
    }
    disconnectedCallback() {
        if (this.handleOpenProposePrompt) document.removeEventListener('open-propose-prompt', this.handleOpenProposePrompt);
        // Remove event listeners when component is removed
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
        if (this.handleAuthSuccess) document.removeEventListener('auth-success', this.handleAuthSuccess);
    }
}
// Register the custom element
customElements.define('prompt-picker', $e3c49c3badf3fae9$var$PromptPicker);





var $eZQHH = parcelRequire("eZQHH");


// Release Notes Web Component
class $b4ee7a6e79954189$var$ReleaseNotes extends HTMLElement {
    constructor(){
        super();
        this.releaseNotes = null;
    }
    async connectedCallback() {
        await this.loadReleaseNotes();
        this.render();
    }
    async loadReleaseNotes() {
        try {
            const response = await fetch('/api/release-notes', {
                credentials: 'include'
            });
            if (!response.ok) throw new Error(`Failed to load release notes: ${response.status}`);
            this.releaseNotes = await response.json();
        } catch (error) {
            (0, $eZQHH.default).error('Error loading release notes:', {
                error: error
            });
            // Fallback to empty array if fetch fails
            this.releaseNotes = [];
        }
    }
    formatDate(dateString) {
        const date = new Date(dateString);
        const months = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ];
        return `${months[date.getMonth()]} ${date.getDate()}`;
    }
    formatFullDate(dateString) {
        const date = new Date(dateString);
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];
        return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
    }
    scrollToVersionHash() {
        const hash = window.location.hash;
        if (!hash || !hash.startsWith('#v')) return;
        const target = this.querySelector(hash);
        if (target) target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
    renderRelease(release) {
        const dateFormatted = this.formatDate(release.date);
        const dateFull = this.formatFullDate(release.date);
        const versionId = `v${release.version}`;
        // Handle special mascot rendering for version 1.0
        let content = release.content;
        if (release.version === '1.0') {
            // Replace placeholder comments with actual mascot renders
            content = content.replace('<!-- Safety Armadillo will be rendered here -->', (0, $72156d6136272719$export$37862db051631868)());
            content = content.replace('<!-- Party Panda will be rendered here -->', (0, $72156d6136272719$export$1bb9b41c0ac99906)());
            content = content.replace('<!-- Disco Capybara will be rendered here -->', (0, $72156d6136272719$export$c122825150439c0c)());
        }
        return `
      <section class="release" id="${versionId}">
        <div class="release-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDCC5", `Version ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(release.version)} - "${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(release.codename)}"`)}
          <time datetime="${release.date}" title="${dateFull}">${dateFormatted}</time>
        </div>
        ${release.summary ? `<p>${release.summary}</p>` : ''}
        <div class="release-content">
          ${content}
        </div>
      </section>
    `;
    }
    render() {
        if (!this.releaseNotes || this.releaseNotes.length === 0) {
            this.innerHTML = `
        <article class="public-page release-notes-page" aria-label="Release Notes">
          <header>
            <p>\u{1F389} All the fun stuff we've been building!</p>
            <h1>Release Notes</h1>
            <p>Your friendly changelog of whimsy and wonder</p>
          </header>
          <p>Loading release notes...</p>
        </article>
      `;
            return;
        }
        const releasesHtml = this.releaseNotes.map((release)=>this.renderRelease(release)).join('\n');
        this.innerHTML = `
      <article class="public-page release-notes-page" aria-label="Release Notes">
        <header>
          <p>\u{1F389} All the fun stuff we've been building!</p>
          <h1>Release Notes</h1>
          <p>Your friendly changelog of whimsy and wonder</p>
        </header>

        ${releasesHtml}

        <section class="release-footer">
          <p>\u{1F4A1} Have ideas for future releases? We'd love to hear them! Click on the Safety Armadillo in the Taco Menu. The best features come from our community.</p>
        </section>
      </article>
    `;
        this.scrollToVersionHash();
    }
}
customElements.define('release-notes', $b4ee7a6e79954189$var$ReleaseNotes);



var $eZQHH = parcelRequire("eZQHH");



class $d7c8abffa4daf1a2$var$DocsPage extends HTMLElement {
    constructor(){
        super();
        this.sections = [];
        this.article = null;
        this.loading = true;
        this.error = null;
    }
    connectedCallback() {
        this.render();
        this.loadContent();
    }
    parsePath() {
        const path = window.location.pathname.replace(/\/$/, '') || '/docs';
        if (path === '/docs') return {
            view: 'hub'
        };
        const parts = path.split('/').filter(Boolean);
        if (parts[0] !== 'docs') return {
            view: 'hub'
        };
        if (parts.length === 2) return {
            view: 'section',
            section: parts[1]
        };
        if (parts.length >= 3) return {
            view: 'article',
            section: parts[1],
            slug: parts.slice(2).join('/')
        };
        return {
            view: 'hub'
        };
    }
    async loadContent() {
        const route = this.parsePath();
        try {
            if (route.view === 'article') {
                const res = await fetch(`/api/docs/${encodeURIComponent(route.section)}/${encodeURIComponent(route.slug)}`, {
                    credentials: 'include'
                });
                if (!res.ok) throw new Error('Article not found');
                this.article = await res.json();
            } else {
                const res = await fetch('/api/docs', {
                    credentials: 'include'
                });
                if (!res.ok) throw new Error('Failed to load docs');
                const data = await res.json();
                this.sections = data.sections || [];
            }
            this.route = route;
            this.loading = false;
            this.render();
            this.attachListeners();
        } catch (err) {
            (0, $eZQHH.default).error('Docs load error:', err);
            this.error = err.message;
            this.loading = false;
            this.render();
        }
    }
    attachListeners() {
        this.querySelector('[data-action="open-armadillo"]')?.addEventListener('click', ()=>{
            document.dispatchEvent(new CustomEvent('open-support'));
        });
    }
    docsHref(path) {
        return (0, $82c5ec211b0f131c$export$7be6c6c696c8413b)(path);
    }
    renderReturnNav() {
        return '<return-nav></return-nav>';
    }
    renderSupportCard() {
        return `
      <section class="docs-support-card card" aria-label="Safety Armadillo support">
        <div class="docs-support-mascot">${(0, $72156d6136272719$export$37862db051631868)()}</div>
        <div class="docs-support-body">
          <h2>Need help from a human?</h2>
          <p>The Safety Armadillo handles bugs, support questions, and safety reports \u{2014} separate from these how-to guides.</p>
          <button type="button" class="btn btn-primary" data-action="open-armadillo">Open Safety Armadillo</button>
        </div>
      </section>
    `;
    }
    renderHub() {
        const cards = this.sections.map((sec)=>`
      <a class="docs-section-card card" href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.docsHref(`/docs/${sec.id}`))}">
        <h2>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(sec.title)}</h2>
        <p>${sec.articles.length} article${sec.articles.length === 1 ? '' : 's'}</p>
      </a>
    `).join('');
        return `
      <article class="public-page docs-page" aria-label="Documentation">
        ${this.renderReturnNav()}
        <header class="docs-page-header">
          <h1>Docs</h1>
          <p class="docs-page-intro">Guides for making the most of Fun Old Times.</p>
        </header>
        ${this.renderSupportCard()}
        <div class="docs-section-grid">${cards}</div>
      </article>
    `;
    }
    renderSection(sectionId) {
        const sec = this.sections.find((s)=>s.id === sectionId);
        if (!sec) return '<article class="public-page docs-page"><p class="docs-error">Section not found.</p></article>';
        const links = sec.articles.map((a)=>`
      <a class="docs-article-link card" href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.docsHref(`/docs/${sec.id}/${a.slug}`))}">
        <h3>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(a.title)}</h3>
        ${a.description ? `<p>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(a.description)}</p>` : ''}
      </a>
    `).join('');
        return `
      <article class="public-page docs-page" aria-label="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(sec.title)}">
        ${this.renderReturnNav()}
        <nav class="docs-breadcrumb"><a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.docsHref('/docs'))}">Docs</a> \u{2192} ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(sec.title)}</nav>
        <header class="docs-page-header"><h1>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(sec.title)}</h1></header>
        <div class="docs-article-list">${links}</div>
      </article>
    `;
    }
    renderArticle() {
        const a = this.article;
        return `
      <article class="public-page docs-page docs-article-body" aria-label="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(a.title)}">
        ${this.renderReturnNav()}
        <nav class="docs-breadcrumb">
          <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.docsHref('/docs'))}">Docs</a> \u{2192}
          <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.docsHref(`/docs/${a.section}`))}">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(a.sectionTitle)}</a> \u{2192}
          ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(a.title)}
        </nav>
        <header class="docs-page-header"><h1>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(a.title)}</h1></header>
        <div class="docs-article-content">${a.html}</div>
      </article>
    `;
    }
    render() {
        if (this.loading) {
            this.innerHTML = `
        <article class="public-page docs-page">
          <div class="loading-state"><span class="spinner"></span><p>Loading docs\u{2026}</p></div>
        </article>
      `;
            return;
        }
        if (this.error) {
            this.innerHTML = `
        <article class="public-page docs-page">
          <p class="docs-error">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.error)}</p>
          <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.docsHref('/docs'))}" class="btn btn-primary">Back to Docs</a>
        </article>
      `;
            return;
        }
        const route = this.route || this.parsePath();
        if (route.view === 'article') this.innerHTML = this.renderArticle();
        else if (route.view === 'section') this.innerHTML = this.renderSection(route.section);
        else this.innerHTML = this.renderHub();
    }
}
customElements.define('docs-page', $d7c8abffa4daf1a2$var$DocsPage);


/**
 * @component return-nav
 * @css return-nav.css
 * @primitives .btn.btn-secondary
 */ 

class $9c26c9fc5b22ede4$var$ReturnNav extends HTMLElement {
    connectedCallback() {
        this.render();
        this.attachListeners();
    }
    getReturnPath() {
        const attr = this.getAttribute('return-to');
        if (attr && (0, $82c5ec211b0f131c$export$2c92ee81e846ef01)(attr)) return attr;
        return (0, $82c5ec211b0f131c$export$5792f1b1a678cbfd)();
    }
    render() {
        const returnTo = this.getReturnPath();
        if (!returnTo) {
            this.innerHTML = '';
            return;
        }
        const label = this.getAttribute('label') || (0, $82c5ec211b0f131c$export$505b44d8f33f195f)(returnTo);
        this.innerHTML = `
      <a href="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(returnTo)}" class="btn btn-secondary return-nav-btn" data-return-to="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(returnTo)}">
        \u{2190} Back to ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(label)}
      </a>
    `;
    }
    attachListeners() {
        const link = this.querySelector('[data-return-to]');
        link?.addEventListener('click', (e)=>{
            e.preventDefault();
            const path = link.dataset.returnTo;
            if (path && window.router) window.router.navigate(path);
        });
    }
}
customElements.define('return-nav', $9c26c9fc5b22ede4$var$ReturnNav);


// Reminder Configuration Component
// Allows users to configure reminders for event invitations

class $c331fa5fdac1f230$var$ReminderConfig extends HTMLElement {
    constructor(){
        super();
        this.eventId = null;
        this.reminders = [];
        this.loading = false;
        this.isOpen = false;
    }
    connectedCallback() {
        this.eventId = this.getAttribute('event-id');
        if (this.eventId) this.loadReminders();
    }
    async open(eventId) {
        this.eventId = eventId;
        this.isOpen = true;
        this.render();
        await this.loadReminders();
    }
    close() {
        this.isOpen = false;
        this.render();
    }
    async loadReminders() {
        if (!this.eventId) return;
        try {
            this.loading = true;
            const data = await window.API.request(`/events/${this.eventId}/reminders`);
            this.reminders = data.reminders || [];
        } catch (error) {
            // 404 is OK - means not invited
            if (error.statusCode !== 404) window.logger.error('Failed to load reminders:', error);
            this.reminders = [];
        } finally{
            this.loading = false;
            this.render();
        }
    }
    async saveReminders() {
        if (!this.eventId) return;
        try {
            const reminders = this.reminders.map((r)=>({
                    reminder_offset_minutes: r.reminder_offset_minutes,
                    notification_type: r.notification_type
                }));
            await window.API.request(`/events/${this.eventId}/reminders`, {
                method: 'POST',
                body: JSON.stringify({
                    reminders: reminders
                })
            });
            // Dispatch event on document so event-detail can listen
            document.dispatchEvent(new CustomEvent('reminders-saved', {
                detail: {
                    eventId: this.eventId
                }
            }));
            this.close();
        } catch (error) {
            alert(error.message || 'Failed to save reminders');
        }
    }
    async deleteReminder(reminderId) {
        if (!reminderId) return;
        if (!confirm('Are you sure you want to delete this reminder?')) return;
        try {
            await window.API.request(`/events/reminders/${reminderId}`, {
                method: 'DELETE'
            });
            this.reminders = this.reminders.filter((r)=>r.id !== reminderId);
            this.render();
            this.dispatchEvent(new CustomEvent('reminder-deleted', {
                bubbles: true
            }));
        } catch (error) {
            alert(error.message || 'Failed to delete reminder');
        }
    }
    addReminder() {
        if (this.reminders.length >= 10) {
            alert('Maximum 10 reminders allowed');
            return;
        }
        this.reminders.push({
            id: null,
            reminder_offset_minutes: 1440,
            notification_type: 'email',
            reminder_time: null,
            sent: false
        });
        this.render();
    }
    updateReminder(index, field, value) {
        if (this.reminders[index]) {
            this.reminders[index][field] = value;
            // If this is an existing reminder, update it on the server
            if (this.reminders[index].id) this.updateReminderOnServer(this.reminders[index].id, field, value);
        }
    }
    async updateReminderOnServer(reminderId, field, value) {
        try {
            const updateData = {};
            updateData[field] = value;
            const data = await window.API.request(`/events/reminders/${reminderId}`, {
                method: 'PUT',
                body: JSON.stringify(updateData)
            });
            // Update local reminder
            const index = this.reminders.findIndex((r)=>r.id === reminderId);
            if (index !== -1) {
                this.reminders[index] = data.reminder;
                this.render();
            }
        } catch (error) {
            window.logger.error('Failed to update reminder:', error);
        }
    }
    removeReminder(index) {
        const reminder = this.reminders[index];
        if (reminder.id) // Delete from server
        this.deleteReminder(reminder.id);
        else {
            // Just remove from local array
            this.reminders.splice(index, 1);
            this.render();
        }
    }
    formatOffset(minutes) {
        if (minutes < 60) return `${minutes} minute${minutes !== 1 ? 's' : ''} before`;
        else if (minutes < 1440) {
            const hours = Math.floor(minutes / 60);
            return `${hours} hour${hours !== 1 ? 's' : ''} before`;
        } else {
            const days = Math.floor(minutes / 1440);
            return `${days} day${days !== 1 ? 's' : ''} before`;
        }
    }
    render() {
        if (!this.isOpen) {
            this.innerHTML = '';
            return;
        }
        this.innerHTML = `
      <div class="reminder-config-overlay" id="reminderOverlay">
        <div class="reminder-config-modal">
          <div class="modal-header">
            ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDD14", 'Configure Reminders')}
            <button class="close-btn" id="closeBtn">\xd7</button>
          </div>
          <div class="modal-body">
            ${this.loading ? this.renderLoading() : this.renderContent()}
          </div>
        </div>
      </div>
    `;
        this.attachEventListeners();
    }
    renderLoading() {
        return `
      <div class="loading-container">
        <div class="spinner"></div>
        <p>Loading reminders...</p>
      </div>
    `;
    }
    renderContent() {
        return `
      <div class="reminder-config-content">
        <p class="help-text">
          Set up reminders so you don't forget about this event. 
          You can have up to 10 reminders per event.
        </p>

        <div class="reminders-list" id="remindersList">
          ${this.reminders.map((reminder, index)=>this.renderReminderItem(reminder, index)).join('')}
        </div>

        <div class="actions">
          ${this.reminders.length < 10 ? `
            <button class="btn btn-secondary" id="addReminderBtn">
              + Add Reminder
            </button>
          ` : ''}
          <button class="btn btn-primary" id="saveBtn">
            Save Reminders
          </button>
        </div>
      </div>
    `;
    }
    renderReminderItem(reminder, index) {
        const isNew = !reminder.id;
        return `
      <div class="reminder-item ${isNew ? 'new' : ''}" data-index="${index}">
        <div class="reminder-header">
          <h3>Reminder ${index + 1}</h3>
          ${!isNew ? `
            <button class="btn-icon delete-btn" data-index="${index}" title="Delete reminder">
              \u{1F5D1}\u{FE0F}
            </button>
          ` : `
            <button class="btn-icon remove-btn" data-index="${index}" title="Remove reminder">
              \xd7
            </button>
          `}
        </div>

        <div class="reminder-fields">
          <div class="field-group">
            <label>Time Before Event:</label>
            <div class="offset-selector">
              <select class="offset-days" data-index="${index}" data-field="days">
                ${this.renderDaysOptions(reminder.reminder_offset_minutes)}
              </select>
              <select class="offset-hours" data-index="${index}" data-field="hours">
                ${this.renderHoursOptions(reminder.reminder_offset_minutes)}
              </select>
              <select class="offset-minutes" data-index="${index}" data-field="minutes">
                ${this.renderMinutesOptions(reminder.reminder_offset_minutes)}
              </select>
            </div>
            <p class="offset-preview">${this.formatOffset(reminder.reminder_offset_minutes)}</p>
          </div>

          <div class="field-group">
            <label>Notification Type:</label>
            <div class="notification-type-selector">
              <label class="radio-label">
                <input type="radio" name="notification_${index}" value="email" 
                       ${reminder.notification_type === 'email' ? 'checked' : ''}
                       data-index="${index}" data-field="notification_type">
                <span>\u{1F4E7} Email</span>
              </label>
              <label class="radio-label">
                <input type="radio" name="notification_${index}" value="sms" 
                       ${reminder.notification_type === 'sms' ? 'checked' : ''}
                       data-index="${index}" data-field="notification_type">
                <span>\u{1F4F1} SMS</span>
              </label>
            </div>
          </div>

          ${reminder.sent ? `
            <div class="reminder-status">
              <span class="status-badge sent">\u{2705} Sent</span>
              ${reminder.sent_at ? `
                <span class="sent-time">at ${new Date(reminder.sent_at).toLocaleString()}</span>
              ` : ''}
            </div>
          ` : ''}
        </div>
      </div>
    `;
    }
    renderDaysOptions(offsetMinutes) {
        const days = Math.floor(offsetMinutes / 1440);
        let options = '<option value="0">0 days</option>';
        for(let i = 1; i <= 30; i++)options += `<option value="${i}" ${days === i ? 'selected' : ''}>${i} day${i !== 1 ? 's' : ''}</option>`;
        return options;
    }
    renderHoursOptions(offsetMinutes) {
        const remainingMinutes = offsetMinutes % 1440;
        const hours = Math.floor(remainingMinutes / 60);
        let options = '<option value="0">0 hours</option>';
        for(let i = 1; i < 24; i++)options += `<option value="${i}" ${hours === i ? 'selected' : ''}>${i} hour${i !== 1 ? 's' : ''}</option>`;
        return options;
    }
    renderMinutesOptions(offsetMinutes) {
        const minutes = offsetMinutes % 60;
        const options = [
            0,
            15,
            30,
            45
        ].map((m)=>`<option value="${m}" ${minutes === m ? 'selected' : ''}>${m} minutes</option>`);
        return options.join('');
    }
    calculateOffset(days, hours, minutes) {
        return parseInt(days) * 1440 + parseInt(hours) * 60 + parseInt(minutes);
    }
    attachEventListeners() {
        const closeBtn = this.querySelector('#closeBtn');
        if (closeBtn) closeBtn.addEventListener('click', ()=>this.close());
        const overlay = this.querySelector('#reminderOverlay');
        if (overlay) overlay.addEventListener('click', (e)=>{
            if (e.target === overlay) this.close();
        });
        const addBtn = this.querySelector('#addReminderBtn');
        if (addBtn) addBtn.addEventListener('click', ()=>this.addReminder());
        const saveBtn = this.querySelector('#saveBtn');
        if (saveBtn) saveBtn.addEventListener('click', ()=>this.saveReminders());
        // Handle offset changes
        const offsetSelects = this.querySelectorAll('.offset-days, .offset-hours, .offset-minutes');
        offsetSelects.forEach((select)=>{
            select.addEventListener('change', (e)=>{
                const index = parseInt(e.target.dataset.index);
                const daysSelect = this.querySelector(`.offset-days[data-index="${index}"]`);
                const hoursSelect = this.querySelector(`.offset-hours[data-index="${index}"]`);
                const minutesSelect = this.querySelector(`.offset-minutes[data-index="${index}"]`);
                const days = parseInt(daysSelect.value) || 0;
                const hours = parseInt(hoursSelect.value) || 0;
                const minutes = parseInt(minutesSelect.value) || 0;
                const totalMinutes = this.calculateOffset(days, hours, minutes);
                this.updateReminder(index, 'reminder_offset_minutes', totalMinutes);
            });
        });
        // Handle notification type changes
        const notificationRadios = this.querySelectorAll('input[type="radio"][data-field="notification_type"]');
        notificationRadios.forEach((radio)=>{
            radio.addEventListener('change', (e)=>{
                const index = parseInt(e.target.dataset.index);
                this.updateReminder(index, 'notification_type', e.target.value);
            });
        });
        // Handle delete/remove buttons
        const deleteBtns = this.querySelectorAll('.delete-btn, .remove-btn');
        deleteBtns.forEach((btn)=>{
            btn.addEventListener('click', (e)=>{
                const index = parseInt(e.target.dataset.index);
                this.removeReminder(index);
            });
        });
    }
}
customElements.define('reminder-config', $c331fa5fdac1f230$var$ReminderConfig);


// RSS Feeds Management Web Component


class $e76868b71df5ad2c$var$RssFeeds extends HTMLElement {
    constructor(){
        super();
        this.feeds = [];
        this.isLoading = false;
        this.showAddForm = false;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.loadFeeds();
    }
    renderIntro() {
        return `
      <section class="rss-feeds-intro card">
        <h4 class="rss-feeds-intro-title">Your blog, your words, your friends</h4>
        <p class="rss-feeds-intro-body">
          Fun Old Times is built for connection, not captivity. We encourage you to run your own blog
          somewhere you control, then import posts here via RSS. You keep ownership of your writing \u{2014}
          and your friends still get notified when you publish.
        </p>
        <p class="rss-feeds-intro-body">
          Need a cozy corner for your words? These indie microblogging platforms are great places to start:
        </p>
        <ul class="rss-platform-list">
          <li>
            <a href="https://pckt.blog/" target="_blank" rel="noopener noreferrer">Pckt</a>
            <span class="rss-platform-blurb">\u{2014} pocket-sized posts, big personality</span>
          </li>
          <li>
            <a href="https://leaflet.pub/home" target="_blank" rel="noopener noreferrer">Leaflet</a>
            <span class="rss-platform-blurb">\u{2014} simple pages for sharing what&apos;s on your mind</span>
          </li>
          <li>
            <a href="https://offprint.app/" target="_blank" rel="noopener noreferrer">Offprint</a>
            <span class="rss-platform-blurb">\u{2014} a lovely little home for independent publishing</span>
          </li>
        </ul>
        <p class="rss-feeds-intro-footer">
          Already have a feed? Paste its URL below and we&apos;ll pull in new posts automatically.
          <a href="${(0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/docs/rss/import-your-blog')}" class="rss-feeds-help-link">Learn how to import your blog \u{2192}</a>
        </p>
      </section>
    `;
    }
    render() {
        this.innerHTML = `
      <div class="rss-feeds">
        ${this.renderIntro()}
        <div class="rss-feeds-header">
          <h3>\u{1F4E1} RSS Feeds</h3>
          <button class="btn btn-primary add-feed-btn">+ Add Feed</button>
        </div>

        ${this.showAddForm ? this.renderAddForm() : ''}

        ${this.renderFeedsList()}
      </div>
    `;
    }
    renderAddForm() {
        return `
      <div class="add-feed-form">
        <h4>Add RSS Feed</h4>
        <form id="addFeedForm">
          <div class="form-group">
            <label for="feedUrl">Feed URL</label>
            <input 
              type="url" 
              id="feedUrl" 
              name="url" 
              placeholder="https://example.com/feed.xml" 
              required
              class="form-control"
            />
            <small class="form-help">Enter the URL of an RSS or Atom feed</small>
          </div>
          <div class="form-group">
            <label class="checkbox-label">
              <input type="checkbox" id="notifyFriendsEmail" name="notify_friends_email" />
              Email friends when this feed updates
            </label>
            <small class="form-help">Friends who have new-post emails enabled will be notified</small>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary">Add Feed</button>
            <button type="button" class="btn btn-secondary cancel-btn">Cancel</button>
          </div>
        </form>
      </div>
    `;
    }
    renderFeedsList() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <p>Loading feeds...</p>
        </div>
      `;
        if (this.feeds.length === 0) return `
        <div class="empty-state">
          <div class="empty-icon">\u{1F4E1}</div>
          <p>No RSS feeds configured</p>
          <p class="empty-hint">Add a feed to automatically import posts</p>
        </div>
      `;
        return `
      <div class="feeds-list">
        ${this.feeds.map((feed)=>this.renderFeedItem(feed)).join('')}
      </div>
    `;
    }
    renderFeedItem(feed) {
        const statusClass = feed.status === 'active' ? 'status-active' : feed.status === 'paused' ? 'status-paused' : feed.status === 'error' ? 'status-error' : 'status-pending';
        const statusIcon = feed.status === 'active' ? "\u2705" : feed.status === 'paused' ? "\u23F8\uFE0F" : feed.status === 'error' ? "\u274C" : "\u23F3";
        const lastChecked = feed.last_checked_at ? new Date(feed.last_checked_at).toLocaleString() : 'Never';
        const nextCheck = feed.next_check_after ? new Date(feed.next_check_after).toLocaleString() : 'Soon';
        return `
      <div class="feed-item" data-feed-id="${feed.id}">
        <div class="feed-header">
          <div class="feed-info">
            <h4 class="feed-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(feed.title || feed.feed_url || 'Untitled Feed')}</h4>
            <div class="feed-meta">
              <span class="feed-url">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(feed.discovered_feed_url || feed.feed_url)}</span>
              ${feed.site_url ? `<span class="feed-site">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(feed.site_url)}</span>` : ''}
            </div>
          </div>
          <div class="feed-status ${statusClass}">
            <span class="status-icon">${statusIcon}</span>
            <span class="status-text">${feed.status}</span>
          </div>
        </div>
        
        <div class="feed-details">
          <div class="feed-stat">
            <span class="stat-label">Last checked:</span>
            <span class="stat-value">${lastChecked}</span>
          </div>
          <div class="feed-stat">
            <span class="stat-label">Next check:</span>
            <span class="stat-value">${nextCheck}</span>
          </div>
          ${feed.failure_count > 0 ? `
            <div class="feed-stat">
              <span class="stat-label">Failures:</span>
              <span class="stat-value error">${feed.failure_count}</span>
            </div>
          ` : ''}
        </div>

        <div class="feed-actions">
          <button type="button" class="btn btn-sm btn-outline email-toggle-btn"
                  data-feed-id="${feed.id}"
                  data-notify="${feed.notify_friends_email ? '1' : '0'}"
                  title="Friend email notifications">
            ${feed.notify_friends_email ? "\uD83D\uDD14" : "\uD83D\uDD15"}
          </button>
          ${feed.status === 'active' ? `
            <button class="btn btn-sm btn-secondary pause-btn" data-feed-id="${feed.id}">Pause</button>
          ` : feed.status === 'paused' ? `
            <button class="btn btn-sm btn-primary resume-btn" data-feed-id="${feed.id}">Resume</button>
          ` : ''}
          <button class="btn btn-sm btn-danger delete-btn" data-feed-id="${feed.id}">Delete</button>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Add feed button
        const addBtn = this.querySelector('.add-feed-btn');
        addBtn?.addEventListener('click', ()=>{
            this.showAddForm = true;
            this.render();
            this.attachEventListeners();
            this.querySelector('#feedUrl')?.focus();
        });
        // Cancel add form
        const cancelBtn = this.querySelector('.cancel-btn');
        cancelBtn?.addEventListener('click', ()=>{
            this.showAddForm = false;
            this.render();
            this.attachEventListeners();
        });
        // Add feed form submit
        const form = this.querySelector('#addFeedForm');
        form?.addEventListener('submit', async (e)=>{
            e.preventDefault();
            await this.handleAddFeed(e.target);
        });
        // Pause/Resume/Delete/Email toggle buttons
        this.addEventListener('click', async (e)=>{
            const emailBtn = e.target.closest('.email-toggle-btn');
            if (emailBtn) {
                const feedId = parseInt(emailBtn.dataset.feedId, 10);
                const currentlyOn = emailBtn.dataset.notify === '1';
                try {
                    await window.API.rss.update(feedId, {
                        notify_friends_email: !currentlyOn
                    });
                    await this.loadFeeds();
                    this.showSuccess(currentlyOn ? 'Friend emails off' : 'Friend emails on');
                } catch (error) {
                    window.logger.error('Failed to toggle RSS email:', error);
                    this.showError('Failed to update email setting');
                }
                return;
            }
            const btn = e.target.closest('.pause-btn, .resume-btn, .delete-btn');
            if (!btn) return;
            const feedId = parseInt(btn.dataset.feedId, 10);
            if (btn.classList.contains('pause-btn')) await this.handlePauseFeed(feedId);
            else if (btn.classList.contains('resume-btn')) await this.handleResumeFeed(feedId);
            else if (btn.classList.contains('delete-btn')) await this.handleDeleteFeed(feedId);
        });
    }
    async loadFeeds() {
        this.isLoading = true;
        this.render();
        try {
            this.feeds = await window.API.rss.list();
        } catch (error) {
            window.logger.error('Failed to load RSS feeds:', error);
            this.showError('Failed to load feeds. Please try again.');
        } finally{
            this.isLoading = false;
            this.render();
            this.attachEventListeners();
        }
    }
    async handleAddFeed(form) {
        const formData = new FormData(form);
        const url = formData.get('url');
        const notifyFriendsEmail = formData.get('notify_friends_email') === 'on';
        if (!url || !url.trim()) {
            this.showError('Please enter a feed URL');
            return;
        }
        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
        try {
            await window.API.rss.add({
                url: url.trim(),
                notify_friends_email: notifyFriendsEmail
            });
            this.showAddForm = false;
            await this.loadFeeds();
            this.showSuccess('Feed added successfully! It will be checked soon.');
        } catch (error) {
            window.logger.error('Failed to add feed:', error);
            const message = error.message || error.error || 'Failed to add feed';
            this.showError(message);
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
        }
    }
    async handlePauseFeed(feedId) {
        try {
            await window.API.rss.update(feedId, {
                status: 'paused'
            });
            await this.loadFeeds();
            this.showSuccess('Feed paused');
        } catch (error) {
            window.logger.error('Failed to pause feed:', error);
            this.showError('Failed to pause feed');
        }
    }
    async handleResumeFeed(feedId) {
        try {
            await window.API.rss.update(feedId, {
                status: 'active'
            });
            await this.loadFeeds();
            this.showSuccess('Feed resumed');
        } catch (error) {
            window.logger.error('Failed to resume feed:', error);
            this.showError('Failed to resume feed');
        }
    }
    async handleDeleteFeed(feedId) {
        if (!confirm('Are you sure you want to delete this feed? This will stop importing new posts.')) return;
        try {
            await window.API.rss.delete(feedId);
            await this.loadFeeds();
            this.showSuccess('Feed deleted');
        } catch (error) {
            window.logger.error('Failed to delete feed:', error);
            this.showError('Failed to delete feed');
        }
    }
    showError(message) {
        const alert = document.createElement('div');
        alert.className = 'alert alert-error';
        alert.textContent = message;
        this.appendChild(alert);
        setTimeout(()=>alert.remove(), 5000);
    }
    showSuccess(message) {
        const alert = document.createElement('div');
        alert.className = 'alert alert-success';
        alert.textContent = message;
        this.appendChild(alert);
        setTimeout(()=>alert.remove(), 3000);
    }
}
customElements.define('rss-feeds', $e76868b71df5ad2c$var$RssFeeds);


// Safety Armadillo Support Component
// Provides support ticket management interface


class $94d153be490b10ae$var$SafetyArmadillo extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.currentView = 'list'; // 'list', 'detail', 'create'
        this.selectedTicketId = null;
        this.tickets = [];
        this.currentTicket = null;
        this.isLoading = false;
        this.ticketType = 'support'; // 'support', 'bug', 'feature'
    }
    connectedCallback() {
        this.render();
        this.setupEventListeners();
    }
    setupEventListeners() {
        // Remove existing listeners to prevent duplicates
        this.removeEventListeners();
        // Listen for open-support events from taco menu
        this.openSupportHandler = ()=>{
            this.open();
        };
        document.addEventListener('open-support', this.openSupportHandler);
        // Close on backdrop click
        this.backdropClickHandler = (e)=>{
            if (e.target.classList.contains('safety-armadillo-backdrop')) this.close();
        };
        this.addEventListener('click', this.backdropClickHandler);
        // Handle button clicks
        this.buttonClickHandler = async (e)=>{
            const closeBtn = e.target.closest('.close-btn');
            if (closeBtn) {
                this.close();
                return;
            }
            const createBtn = e.target.closest('[data-action="create-ticket"]');
            if (createBtn) {
                this.showCreateForm();
                return;
            }
            const ticketItem = e.target.closest('[data-ticket-id]');
            if (ticketItem) {
                const ticketId = ticketItem.dataset.ticketId;
                await this.viewTicket(ticketId);
                return;
            }
            const backBtn = e.target.closest('[data-action="back-to-list"]');
            if (backBtn) {
                this.showList();
                return;
            }
            const submitBtn = e.target.closest('[data-action="submit-ticket"]');
            if (submitBtn) {
                await this.submitTicket();
                return;
            }
            const submitCommentBtn = e.target.closest('[data-action="submit-comment"]');
            if (submitCommentBtn) {
                await this.submitComment();
                return;
            }
            const tabBtn = e.target.closest('[data-tab]');
            if (tabBtn) {
                this.ticketType = tabBtn.dataset.tab;
                this.updateCreateFormTabs();
                return;
            }
        };
        this.addEventListener('click', this.buttonClickHandler);
        // Handle form submission - these will be re-attached after render
        this.attachFormListeners();
    }
    removeEventListeners() {
        if (this.openSupportHandler) document.removeEventListener('open-support', this.openSupportHandler);
        if (this.backdropClickHandler) this.removeEventListener('click', this.backdropClickHandler);
        if (this.buttonClickHandler) this.removeEventListener('click', this.buttonClickHandler);
    }
    attachFormListeners() {
        // Handle form submission
        const createForm = this.querySelector('#createTicketForm');
        if (createForm && !createForm.dataset.listenerAttached) {
            createForm.dataset.listenerAttached = 'true';
            createForm.addEventListener('submit', async (e)=>{
                e.preventDefault();
                await this.submitTicket();
            });
        }
        const commentForm = this.querySelector('#commentForm');
        if (commentForm && !commentForm.dataset.listenerAttached) {
            commentForm.dataset.listenerAttached = 'true';
            commentForm.addEventListener('submit', async (e)=>{
                e.preventDefault();
                await this.submitComment();
            });
        }
    }
    open() {
        this.isOpen = true;
        this.currentView = 'list';
        this.render();
        this.loadTickets();
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
    close() {
        this.isOpen = false;
        this.currentView = 'list';
        this.selectedTicketId = null;
        this.currentTicket = null;
        this.render();
        document.body.style.overflow = ''; // Restore scrolling
    }
    showList() {
        this.currentView = 'list';
        this.selectedTicketId = null;
        this.currentTicket = null;
        this.render();
        this.loadTickets();
    }
    showCreateForm() {
        this.currentView = 'create';
        this.ticketType = 'support';
        this.render();
    }
    async viewTicket(ticketId) {
        this.selectedTicketId = ticketId;
        this.currentView = 'detail';
        this.render();
        await this.loadTicket(ticketId);
    }
    async loadTickets() {
        this.isLoading = true;
        this.updateLoadingState();
        try {
            const response = await window.API.request('/support/tickets?status=all&limit=50');
            this.tickets = response.tickets || [];
            this.renderTicketList();
        } catch (error) {
            window.logger.error('Failed to load tickets:', error);
            const message = error?.statusCode === 503 ? 'The help desk is starting up. Please try again in a minute.' : 'Failed to load tickets. Please try again.';
            this.showError(message);
        } finally{
            this.isLoading = false;
            this.updateLoadingState();
        }
    }
    async loadTicket(ticketId) {
        this.isLoading = true;
        this.updateLoadingState();
        try {
            const ticket = await window.API.request(`/support/tickets/${ticketId}`);
            this.currentTicket = ticket;
            this.renderTicketDetail();
        } catch (error) {
            window.logger.error('Failed to load ticket:', error);
            this.showError('Failed to load ticket. Please try again.');
        } finally{
            this.isLoading = false;
            this.updateLoadingState();
        }
    }
    async submitTicket() {
        const form = this.querySelector('#createTicketForm');
        if (!form) return;
        const formData = new FormData(form);
        const subject = formData.get('subject')?.trim();
        const body = formData.get('body')?.trim();
        if (!subject || !body) {
            this.showError('Please fill in all required fields.');
            return;
        }
        const submitBtn = this.querySelector('[data-action="submit-ticket"]');
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.querySelector('.btn-text').textContent = 'Creating...';
        }
        try {
            await window.API.request('/support/tickets', {
                method: 'POST',
                body: JSON.stringify({
                    subject: subject,
                    body: body,
                    type: this.ticketType,
                    priority: 'normal'
                })
            });
            // Show success message
            this.showMessage('Ticket created successfully!', 'success');
            // Reset form and go back to list
            form.reset();
            setTimeout(()=>{
                this.showList();
                this.loadTickets();
            }, 1000);
        } catch (error) {
            window.logger.error('Failed to create ticket:', error);
            this.showError(error.message || 'Failed to create ticket. Please try again.');
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.querySelector('.btn-text').textContent = 'Create Ticket';
            }
        }
    }
    async submitComment() {
        const form = this.querySelector('#commentForm');
        if (!form) return;
        const formData = new FormData(form);
        const body = formData.get('body')?.trim();
        if (!body) {
            this.showError('Please enter a comment.');
            return;
        }
        const submitBtn = this.querySelector('[data-action="submit-comment"]');
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.querySelector('.btn-text').textContent = 'Sending...';
        }
        try {
            await window.API.request(`/support/tickets/${this.selectedTicketId}/comments`, {
                method: 'POST',
                body: JSON.stringify({
                    body: body
                })
            });
            // Reload ticket to show new comment
            form.reset();
            await this.loadTicket(this.selectedTicketId);
            this.showMessage('Comment added successfully!', 'success');
        } catch (error) {
            window.logger.error('Failed to add comment:', error);
            this.showError(error.message || 'Failed to add comment. Please try again.');
            if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.querySelector('.btn-text').textContent = 'Add Comment';
            }
        }
    }
    updateLoadingState() {
        const loadingEl = this.querySelector('.loading-overlay');
        if (loadingEl) loadingEl.style.display = this.isLoading ? 'flex' : 'none';
    }
    updateCreateFormTabs() {
        const tabs = this.querySelectorAll('[data-tab]');
        tabs.forEach((tab)=>{
            tab.classList.toggle('active', tab.dataset.tab === this.ticketType);
        });
    }
    showError(message) {
        this.showMessage(message, 'error');
    }
    showMessage(message, type = 'info') {
        // Remove existing messages
        const existing = this.querySelector('.message-banner');
        if (existing) existing.remove();
        const banner = document.createElement('div');
        banner.className = `message-banner message-${type}`;
        banner.textContent = message;
        banner.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 1rem 1.5rem;
      background: ${type === 'error' ? '#dc3545' : '#28a745'};
      color: white;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.2);
      z-index: 10001;
      animation: slideIn 0.3s ease-out;
    `;
        document.body.appendChild(banner);
        setTimeout(()=>banner.remove(), 5000);
    }
    formatDate(dateString) {
        if (!dateString) return 'Unknown';
        const date = new Date(dateString);
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
        });
    }
    getStatusBadge(status) {
        const statusMap = {
            'open': {
                text: 'Open',
                color: '#28a745'
            },
            'closed': {
                text: 'Closed',
                color: '#6c757d'
            },
            'pending': {
                text: 'Pending',
                color: '#ffc107'
            },
            'active': {
                text: 'Active',
                color: '#17a2b8'
            }
        };
        const statusInfo = statusMap[status?.toLowerCase()] || {
            text: status || 'Unknown',
            color: '#6c757d'
        };
        return `<span class="status-badge" style="background: ${statusInfo.color}; color: white; padding: 0.25rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: 600;">${statusInfo.text}</span>`;
    }
    renderTicketList() {
        const listContainer = this.querySelector('.tickets-list');
        if (!listContainer) return;
        if (this.tickets.length === 0) {
            listContainer.innerHTML = `
        <div class="empty-state">
          <div class="empty-icon">${(0, $72156d6136272719$export$37862db051631868)()}</div>
          <p>No tickets yet. Create your first support request!</p>
        </div>
      `;
            return;
        }
        listContainer.innerHTML = this.tickets.map((ticket)=>`
      <div class="ticket-item" data-ticket-id="${ticket.id || ticket.conversation_id || ticket.number}">
        <div class="ticket-header">
          <h4 class="ticket-subject">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(ticket.subject || ticket.title || 'No Subject')}</h4>
          ${this.getStatusBadge(ticket.status)}
        </div>
        <div class="ticket-meta">
          <span class="ticket-type">${ticket.type || 'support'}</span>
          <span class="ticket-date">${this.formatDate(ticket.created_at || ticket.date)}</span>
        </div>
        ${ticket.body || ticket.preview ? `<p class="ticket-preview">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)((ticket.body || ticket.preview || '').substring(0, 150))}${(ticket.body || ticket.preview || '').length > 150 ? '...' : ''}</p>` : ''}
      </div>
    `).join('');
    }
    renderTicketDetail() {
        const detailContainer = this.querySelector('.ticket-detail');
        if (!detailContainer || !this.currentTicket) return;
        let thread = this.currentTicket.thread || this.currentTicket.conversation || [];
        // Sort thread by created_at ascending (oldest first)
        thread = [
            ...thread
        ].sort((a, b)=>{
            const dateA = new Date(a.created_at || a.date || 0);
            const dateB = new Date(b.created_at || b.date || 0);
            return dateA - dateB; // Ascending order (oldest first)
        });
        detailContainer.innerHTML = `
      <div class="ticket-detail-header">
        <div>
          <h3>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.currentTicket.subject || this.currentTicket.title || 'No Subject')}</h3>
          <div class="ticket-meta">
            ${this.getStatusBadge(this.currentTicket.status)}
            <span>Created: ${this.formatDate(this.currentTicket.created_at || this.currentTicket.date)}</span>
          </div>
        </div>
      </div>

      <div class="ticket-thread">
        ${thread.map((message)=>{
            // Determine if message is from customer or agent/staff
            const isCustomer = message.type === 'customer' || message.from === 'customer';
            // Get sender name - use from_user from backend if available (agent name), otherwise default
            const senderName = isCustomer ? 'You' : message.from_user || 'Support Team';
            return `
          <div class="thread-message ${isCustomer ? 'customer' : 'agent'}">
            <div class="message-header">
              <strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(senderName)}</strong>
              <span class="message-date">${this.formatDate(message.created_at || message.date)}</span>
            </div>
            <div class="message-body">${this.formatMessageBody(message.body || message.text || '')}</div>
          </div>
        `;
        }).join('')}
      </div>

      <form id="commentForm" class="comment-form">
        <div class="form-group">
          <label for="commentBody">Add a comment</label>
          <textarea 
            id="commentBody" 
            name="body" 
            rows="4" 
            placeholder="Type your reply here..."
            required
          ></textarea>
        </div>
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" data-action="back-to-list">Back to List</button>
          <button type="submit" class="btn btn-primary" data-action="submit-comment">
            <span class="btn-text">Add Comment</span>
          </button>
        </div>
      </form>
    `;
    }
    formatMessageBody(body) {
        if (!body) return '';
        // Check if body contains HTML tags
        const hasHtmlTags = /<[a-z][\s\S]*>/i.test(body);
        if (hasHtmlTags) // Body contains HTML - sanitize and render it safely using DOMParser
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(body, 'text/html');
            // Remove dangerous elements
            const dangerous = doc.querySelectorAll('script, style, iframe, object, embed, form, input, button');
            dangerous.forEach((el)=>el.remove());
            // Remove dangerous attributes from all elements
            const allElements = doc.querySelectorAll('*');
            allElements.forEach((el)=>{
                // Remove all attributes that could be dangerous
                Array.from(el.attributes).forEach((attr)=>{
                    const attrName = attr.name.toLowerCase();
                    if (attrName.startsWith('on') || // event handlers
                    attrName === 'href' && attr.value.toLowerCase().startsWith('javascript:') || attrName === 'src' && attr.value.toLowerCase().startsWith('javascript:')) el.removeAttribute(attr.name);
                });
            });
            // Get sanitized HTML from body
            const sanitized = doc.body.innerHTML;
            return sanitized;
        } catch (error) {
            // If parsing fails, fall back to escaping
            window.logger?.warn('Failed to parse HTML, falling back to escaped text', error);
            return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(body).replace(/\n/g, '<br>');
        }
        else // Plain text - escape and add basic formatting
        return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(body).replace(/\n/g, '<br>').replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\*(.*?)\*/g, '<em>$1</em>');
    }
    render() {
        if (!this.isOpen) {
            this.innerHTML = '';
            return;
        }
        this.innerHTML = `
      <div class="safety-armadillo-backdrop">
        <div class="safety-armadillo-modal">
          <div class="modal-header">
            <div class="header-content">
              <div class="armadillo-icon">${(0, $72156d6136272719$export$37862db051631868)()}</div>
              <h2>Safety Armadillo Support</h2>
            </div>
            <button class="close-btn" aria-label="Close">\xd7</button>
          </div>

          <div class="modal-body">
            ${this.renderCurrentView()}
          </div>

          <div class="loading-overlay" style="display: none;">
            <div class="spinner"></div>
          </div>
        </div>
      </div>
    `;
        // Re-attach form listeners after render
        this.attachFormListeners();
    }
    renderCurrentView() {
        switch(this.currentView){
            case 'create':
                return this.renderCreateForm();
            case 'detail':
                return this.renderDetailView();
            default:
                return this.renderListView();
        }
    }
    renderListView() {
        return `
      <div class="view-header">
        <h3>Your Support Tickets</h3>
        <button class="btn btn-primary" data-action="create-ticket">
          <span class="btn-text">+ New Ticket</span>
        </button>
      </div>
      <div class="tickets-list">
        ${this.isLoading ? '<div class="loading">Loading tickets...</div>' : ''}
      </div>
    `;
    }
    renderCreateForm() {
        return `
      <div class="view-header">
        <h3>Create Support Ticket</h3>
        <button class="btn btn-secondary" data-action="back-to-list">Back</button>
      </div>

      <div class="ticket-type-tabs">
        <button class="tab ${this.ticketType === 'support' ? 'active' : ''}" data-tab="support">
          \u{1F4AC} Support Request
        </button>
        <button class="tab ${this.ticketType === 'bug' ? 'active' : ''}" data-tab="bug">
          \u{1F41B} Bug Report
        </button>
        <button class="tab ${this.ticketType === 'feature' ? 'active' : ''}" data-tab="feature">
          \u{2728} Feature Request
        </button>
      </div>

      <form id="createTicketForm" class="create-ticket-form">
        <div class="form-group">
          <label for="ticketSubject">Subject *</label>
          <input 
            type="text" 
            id="ticketSubject" 
            name="subject" 
            placeholder="Brief description of your issue or request"
            maxlength="200"
            required
          />
        </div>
        <div class="form-group">
          <label for="ticketBody">Description *</label>
          <textarea 
            id="ticketBody" 
            name="body" 
            rows="8" 
            placeholder="Please provide as much detail as possible..."
            maxlength="10000"
            required
          ></textarea>
        </div>
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" data-action="back-to-list">Cancel</button>
          <button type="submit" class="btn btn-primary" data-action="submit-ticket">
            <span class="btn-text">Create Ticket</span>
          </button>
        </div>
      </form>
    `;
    }
    renderDetailView() {
        return `
      <div class="ticket-detail">
        ${this.isLoading ? '<div class="loading">Loading ticket...</div>' : ''}
      </div>
    `;
    }
}
// Register the custom element
customElements.define('safety-armadillo', $94d153be490b10ae$var$SafetyArmadillo);


// Settings Page Web Component - Index/List View

class $450592136cc160b9$var$SettingsPage extends HTMLElement {
    connectedCallback() {
        this.render();
        this.attachEventListeners();
    }
    render() {
        this.innerHTML = `
      <div class="settings-page">
        <div class="settings-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\u2699\uFE0F", 'Settings', 'h1')}
          <p>Manage your account preferences and security settings</p>
        </div>

        <div class="settings-list">
          <a href="/settings/security" class="settings-item" data-route="/settings/security">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\uD83D\uDD12", 'md')}
            <div class="item-content">
              <span class="item-title">Security</span>
              <span class="item-description">Set up 2FA and reset your password</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/settings/notifications" class="settings-item" data-route="/settings/notifications">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\uD83D\uDD14", 'md')}
            <div class="item-content">
              <span class="item-title">Notifications</span>
              <span class="item-description">Choose how you want to be notified</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/settings/sparkle-sources" class="settings-item" data-route="/settings/sparkle-sources">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\u2728", 'md')}
            <div class="item-content">
              <span class="item-title">Sparkle Sources</span>
              <span class="item-description">Connect cloud storage accounts</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/settings/facebook-import-friends" class="settings-item" data-route="/settings/facebook-import-friends">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\uD83D\uDC65", 'md')}
            <div class="item-content">
              <span class="item-title">Import Facebook Friends</span>
              <span class="item-description">Import your Facebook friends list</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/settings/facebook-import-posts" class="settings-item" data-route="/settings/facebook-import-posts">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\uD83D\uDCDD", 'md')}
            <div class="item-content">
              <span class="item-title">Import Facebook Posts</span>
              <span class="item-description">Import your Facebook posts, comments, photos, and videos</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/settings/imported-friends" class="settings-item" data-route="/settings/imported-friends">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\uD83D\uDC65", 'md')}
            <div class="item-content">
              <span class="item-title">Imported Friends</span>
              <span class="item-description">Manage friends from Facebook import</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
          
          <a href="/settings/rss-feeds" class="settings-item" data-route="/settings/rss-feeds">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\uD83D\uDCE1", 'md')}
            <div class="item-content">
              <span class="item-title">RSS Feeds</span>
              <span class="item-description">Import posts from your own blog via RSS</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>

          <a href="/settings/widgets" class="settings-item" data-route="/settings/widgets" id="widgetsSettingsItem">
            ${(0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)("\uD83E\uDDE9", 'md')}
            <div class="item-content">
              <span class="item-title">My Widgets</span>
              <span class="item-description">Create profile widgets for your layout</span>
            </div>
            <span class="item-arrow">\u{2192}</span>
          </a>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
    // Navigation is handled by the router via href links
    // No additional listeners needed
    }
}
// Register the custom element
customElements.define('settings-page', $450592136cc160b9$var$SettingsPage);


// Site Footer Web Component

class $d08af0fc47e510ee$var$SiteFooter extends HTMLElement {
    constructor(){
        super();
        this.currentYear = new Date().getFullYear();
    }
    connectedCallback() {
        this.render();
        this.startYearUpdater();
        this._updateDocsLinkBound = this.updateDocsLink.bind(this);
        document.addEventListener('route-changed', this._updateDocsLinkBound);
        document.addEventListener('section-shown', this._updateDocsLinkBound);
        this.updateDocsLink();
    }
    disconnectedCallback() {
        document.removeEventListener('route-changed', this._updateDocsLinkBound);
        document.removeEventListener('section-shown', this._updateDocsLinkBound);
        if (this.yearUpdateInterval) clearInterval(this.yearUpdateInterval);
    }
    render() {
        this.innerHTML = `
      <footer class="main-footer">
        <div class="container">
          <div class="footer-content">
            <div class="footer-main">
              <p class="footer-copyright">
                &copy; <span id="copyright-year">${this.currentYear}</span> Fun Old Times - Bringing back the fun of social networking
              </p>
            </div>
            <div class="footer-extras">
              <span class="footer-emoji">\u{2728}</span>
              <span class="footer-tagline">Built with \u{2764}\u{FE0F} for the fun of it!</span>
            </div>
            <div class="footer-links" aria-label="Helpful links">
              <a href="/docs">Docs</a>
              <span aria-hidden="true">\u{2022}</span>
              <a href="/privacy">Privacy Policy</a>
              <span aria-hidden="true">\u{2022}</span>
              <a href="/terms">Terms & Conditions</a>
            </div>
          </div>
        </div>
      </footer>
    `;
    }
    updateDocsLink() {
        const docsLink = this.querySelector('.footer-links a[href^="/docs"]');
        if (!docsLink) return;
        const currentPath = window.location.pathname;
        if (currentPath === '/docs' || currentPath.startsWith('/docs/')) {
            docsLink.href = '/docs';
            return;
        }
        docsLink.href = (0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/docs');
    }
    startYearUpdater() {
        // Check for year change every minute
        this.yearUpdateInterval = setInterval(()=>{
            this.updateYear();
        }, 60000); // Check every minute
        // Also check on visibility change (when user returns to tab)
        document.addEventListener('visibilitychange', ()=>{
            if (!document.hidden) this.updateYear();
        });
    }
    updateYear() {
        const newYear = new Date().getFullYear();
        const yearElement = this.querySelector('#copyright-year');
        if (newYear !== this.currentYear && yearElement) {
            this.currentYear = newYear;
            // Add animation class
            yearElement.classList.add('year-updated');
            // Update the year
            yearElement.textContent = this.currentYear;
            // Remove animation class after animation completes
            setTimeout(()=>{
                yearElement.classList.remove('year-updated');
            }, 600);
            // Special New Year's celebration
            this.celebrateNewYear();
            window.logger.info(`\u{1F389} Happy New Year! Updated copyright to ${this.currentYear}`);
        }
    }
    celebrateNewYear() {
        // Create temporary celebration elements
        const celebration = document.createElement('div');
        celebration.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 3rem;
      z-index: 10000;
      pointer-events: none;
      animation: newYearCelebration 3s ease-out forwards;
    `;
        celebration.innerHTML = "\uD83C\uDF89 Happy New Year! \uD83C\uDF89";
        // Add celebration styles
        const style = document.createElement('style');
        style.textContent = `
      @keyframes newYearCelebration {
        0% { 
          opacity: 0; 
          transform: translate(-50%, -50%) scale(0.5); 
        }
        20% { 
          opacity: 1; 
          transform: translate(-50%, -50%) scale(1.2); 
        }
        80% { 
          opacity: 1; 
          transform: translate(-50%, -50%) scale(1); 
        }
        100% { 
          opacity: 0; 
          transform: translate(-50%, -50%) scale(0.8); 
        }
      }
    `;
        document.head.appendChild(style);
        document.body.appendChild(celebration);
        // Create confetti effect
        this.createConfetti();
        // Clean up after animation
        setTimeout(()=>{
            document.body.removeChild(celebration);
            document.head.removeChild(style);
        }, 3000);
    }
    createConfetti() {
        const confettiColors = [
            '#FFD700',
            '#FF6B9D',
            '#00BFFF',
            '#FF69B4',
            '#32CD32'
        ];
        const confettiEmojis = [
            "\uD83C\uDF89",
            "\u2728",
            "\uD83C\uDF8A",
            "\uD83C\uDF1F",
            "\uD83D\uDCAB"
        ];
        for(let i = 0; i < 20; i++)setTimeout(()=>{
            const confetti = document.createElement('div');
            const isEmoji = Math.random() > 0.5;
            confetti.style.cssText = `
          position: fixed;
          top: -10px;
          left: ${Math.random() * 100}vw;
          font-size: ${isEmoji ? '1.5rem' : '8px'};
          z-index: 9999;
          pointer-events: none;
          animation: confettiFall 3s linear forwards;
        `;
            if (isEmoji) confetti.textContent = confettiEmojis[Math.floor(Math.random() * confettiEmojis.length)];
            else {
                confetti.style.backgroundColor = confettiColors[Math.floor(Math.random() * confettiColors.length)];
                confetti.style.width = '8px';
                confetti.style.height = '8px';
                confetti.style.borderRadius = '50%';
            }
            // Add confetti animation
            if (!document.querySelector('#confetti-styles')) {
                const confettiStyle = document.createElement('style');
                confettiStyle.id = 'confetti-styles';
                confettiStyle.textContent = `
            @keyframes confettiFall {
              to {
                transform: translateY(100vh) rotate(360deg);
                opacity: 0;
              }
            }
          `;
                document.head.appendChild(confettiStyle);
            }
            document.body.appendChild(confetti);
            // Clean up confetti
            setTimeout(()=>{
                if (confetti.parentNode) confetti.parentNode.removeChild(confetti);
            }, 3000);
        }, i * 100);
    }
}
// Register the custom element
customElements.define('site-footer', $d08af0fc47e510ee$var$SiteFooter);


// Site Statistics Web Component
class $72fe81bafaf24109$var$SiteStats extends HTMLElement {
    constructor(){
        super();
        this.stats = null;
        this.isLoading = true;
        this.currentUser = null;
        this.isLoadingStats = false; // Prevent multiple simultaneous calls
    }
    connectedCallback() {
        this.render();
        this.setupSectionListener();
        this.loadStats();
    }
    disconnectedCallback() {
        // Remove event listener when component is removed
        if (this.handleSectionShown) document.removeEventListener('section-shown', this.handleSectionShown);
    }
    setupSectionListener() {
        // Listen for admin section shown events to load stats when admin section is displayed
        this.handleSectionShown = (event)=>{
            if (event.detail.section === 'admin') {
                // Check if we're on the site-stats tab and should load stats
                const siteStatsContent = document.getElementById('site-stats-content');
                const isOnSiteStatsTab = siteStatsContent && siteStatsContent.style.display !== 'none';
                if (isOnSiteStatsTab && this.currentUser && window.API) this.loadStats();
            }
        };
        document.addEventListener('section-shown', this.handleSectionShown);
    }
    isVisible() {
        // Check if this component is currently visible on the page
        // For admin components, check if the admin dashboard is visible
        const adminSection = document.getElementById('admin-section');
        const adminVisible = adminSection && !adminSection.classList.contains('hidden');
        // Also check if the site-stats content div is visible (not hidden by tab switching)
        const siteStatsContent = document.getElementById('site-stats-content');
        const statsContentVisible = siteStatsContent && siteStatsContent.style.display !== 'none';
        return adminVisible && statsContentVisible;
    }
    setCurrentUser(user) {
        this.currentUser = user;
        if (!window.API) {
            // If API is missing, set loading to false and show error state
            this.isLoading = false;
            this.updateContent();
            return;
        }
        // If we're visible and have user data, load stats
        if (this.isVisible() && this.currentUser && window.API) this.loadStats();
    }
    render() {
        this.innerHTML = `
      <div class="site-stats">
        <div class="stats-header">
          <h2>Site Statistics</h2>
          <p>Overview of your Fun Old Times community</p>
        </div>

        <div class="stats-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading statistics...</div>
        </div>
      `;
        if (!this.stats) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Failed to load statistics</div>
        </div>
      `;
        return `
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-icon">\u{1F465}</div>
          <div class="stat-value">${this.stats.users.total}</div>
          <div class="stat-label">Total Users</div>
          <div class="stat-description">Registered members</div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">\u{1F451}</div>
          <div class="stat-value">${this.stats.users.admins}</div>
          <div class="stat-label">Administrators</div>
          <div class="stat-description">Admin users</div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">\u{1F4DD}</div>
          <div class="stat-value">${this.stats.posts.total}</div>
          <div class="stat-label">Total Posts</div>
          <div class="stat-description">All time posts</div>
        </div>

        <div class="stat-card">
          <div class="stat-icon">\u{1F91D}</div>
          <div class="stat-value">${this.stats.friendships.total}</div>
          <div class="stat-label">Friendships</div>
          <div class="stat-description">Active connections</div>
        </div>
      </div>

      <div class="recent-activity">
        <h3 class="activity-title">Recent Activity (Last 7 Days)</h3>
        <div class="activity-grid">
          <div class="activity-card">
            <div class="activity-value">${this.stats.users.recent}</div>
            <div class="activity-label">New Users</div>
          </div>
          <div class="activity-card">
            <div class="activity-value">${this.stats.posts.recent}</div>
            <div class="activity-label">New Posts</div>
          </div>
        </div>
      </div>
    `;
    }
    async loadStats() {
        // Prevent multiple simultaneous calls
        if (this.isLoadingStats) return;
        // Only load if user is admin and component is visible
        if (!this.currentUser || this.currentUser.role !== 'admin') return;
        if (!this.isVisible()) return;
        // Check if API is available
        if (!window.API) {
            window.logger.error('API not available');
            return;
        }
        this.isLoadingStats = true;
        this.isLoading = true;
        this.updateContent();
        try {
            this.stats = await window.API.request('/admin/stats');
        } catch (error) {
            window.logger.error('Failed to load site stats:', error);
            this.stats = null;
        } finally{
            this.isLoading = false;
            this.isLoadingStats = false;
            this.updateContent();
        }
    }
    updateContent() {
        const content = this.querySelector('.stats-content');
        if (content) content.innerHTML = this.renderContent();
    }
}
// Register the custom element
customElements.define('site-stats', $72fe81bafaf24109$var$SiteStats);








// Taco Menu Web Component
class $1960ad6cba9395e9$var$TacoMenu extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this._syncContextNavBound = this.syncContextNavDom.bind(this);
        this._unsubContextNav = null;
        this.isOpen = false;
        // Defer reading window.innerWidth to avoid forced reflow on construction
        // Will be set properly in setupResponsiveHandling
        this.isWideScreen = false;
        this.currentUser = null;
        this.friendRequestCount = 0;
        this.pendingInvitationCount = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
        this.attachEventListeners();
        this.setupResponsiveHandling();
        this._unsubContextNav = (0, $22b79cf8d2430b20$export$c64f546521fe1e9b)(()=>this.syncContextNavDom());
        document.addEventListener('route-changed', this._syncContextNavBound);
        document.addEventListener('section-shown', this._syncContextNavBound);
        this.handleFeatureFlagsLoaded = ()=>this.updateFeatureNavVisibility();
        document.addEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
        this.syncContextNavDom();
        this.updateActiveMenuItem();
    }
    disconnectedCallback() {
        if (this._unsubContextNav) {
            this._unsubContextNav();
            this._unsubContextNav = null;
        }
        document.removeEventListener('route-changed', this._syncContextNavBound);
        document.removeEventListener('section-shown', this._syncContextNavBound);
        if (this.handleFeatureFlagsLoaded) document.removeEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
        super.disconnectedCallback();
    }
    render() {
        // Start hidden until auth status is confirmed
        this.style.display = 'none';
        this.innerHTML = `
      <div class="taco-menu-container">
        <!-- Slide-in Menu -->
        <nav class="slide-menu ${this.isWideScreen ? 'always-open' : ''}" id="slideMenu">
          <div class="menu-header">
            ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83C\uDF2E", 'Menu')}
            <button class="close-menu-btn" id="closeMenuBtn">&times;</button>
          </div>
          
          <div class="menu-content">
            <div id="contextNavMount" class="context-nav-mount" hidden></div>

            <!-- Main Navigation (hidden while context nav stack has layers) -->
            <div class="menu-section primary-site-nav" id="primarySiteNav">
              <h3>Navigation</h3>
              <ul class="menu-items">
                <li><a href="/" class="menu-item" data-route="/">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83C\uDFE0", 'Home')}</a></li>
                <li><a href="/profile/me" class="menu-item" data-route="/profile/me">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83D\uDC64", 'My Profile')}</a></li>
                <li><a href="/friends" class="menu-item" data-route="/friends">
                  ${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83C\uDFAA", 'Friends')}
                  <span class="notification-badge" id="friendsBadge" style="display: none;">0</span>
                </a></li>
                <li><a href="/events" class="menu-item" data-route="/events">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83D\uDCC5", 'Events')}</a></li>
                <li id="groupsNavItem"><a href="/groups" class="menu-item" data-route="/groups">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83C\uDF31", 'Groups')}</a></li>
                <li id="mascotParadeNavItem" style="display: none;"><a href="/mascot-parade" class="menu-item" data-route="/mascot-parade">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83C\uDFAA", 'Mascot Parade')}</a></li>
                <li><a href="/memories" class="menu-item" data-route="/memories">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83D\uDD70\uFE0F", 'Memories')}</a></li>
                <li><a href="/settings" class="menu-item" data-route="/settings">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\u2699\uFE0F", 'Settings')}</a></li>
                <li><a href="/docs" class="menu-item" data-route="/docs">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83D\uDCD6", 'Docs')}</a></li>
              </ul>
            </div>

            <!-- Admin Section -->
            <div class="menu-section admin-section" id="adminSection" style="display: none;">
              <h3>\u{1F6E0}\u{FE0F} Admin</h3>
              <ul class="menu-items">
                <li><a href="/admin" class="menu-item" data-route="/admin">${(0, $b58f9d07dbba7b59$export$5a7512680e571ab2)("\uD83D\uDEE0\uFE0F", 'Admin Settings')}</a></li>
              </ul>
            </div>

            <!-- Utilities -->
            <div class="menu-section">
              <h3>Settings</h3>
              <div class="menu-utilities">
                <theme-toggle></theme-toggle>
              </div>
            </div>

            <!-- Support Armadillo Mascot -->
            <div class="menu-section support-mascot-section">
              <button class="support-mascot-btn" id="supportMascotBtn" title="Get Help & Support">
                ${(0, $72156d6136272719$export$37862db051631868)()}
              </button>
            </div>
          </div>
        </nav>

        <!-- Overlay for mobile -->
        <div class="menu-overlay" id="menuOverlay"></div>
      </div>
    `;
        // Update admin visibility after render if we have user info
        if (this.currentUser) this.updateAdminVisibility();
        this.updateFeatureNavVisibility();
    }
    attachEventListeners() {
        const menuOverlay = this.querySelector('#menuOverlay');
        const closeMenuBtn = this.querySelector('#closeMenuBtn');
        const supportMascotBtn = this.querySelector('#supportMascotBtn');
        // Listen for mobile taco button click from header
        const mobileTacoBtn = document.querySelector('#mobileTacoBtn');
        if (mobileTacoBtn) mobileTacoBtn.addEventListener('click', ()=>{
            this.toggleMenu();
        });
        // Close button click
        closeMenuBtn.addEventListener('click', ()=>{
            this.closeMenu();
        });
        // Overlay click
        menuOverlay.addEventListener('click', ()=>{
            this.closeMenu();
        });
        // Support mascot click - opens support interface
        if (supportMascotBtn) supportMascotBtn.addEventListener('click', ()=>{
            this.openSupportInterface();
        });
        // Menu item clicks
        this.addEventListener('click', (e)=>{
            if (e.target.closest('[data-context-pop-top]')) {
                e.preventDefault();
                (0, $22b79cf8d2430b20$export$c56185e4b7d20e85)();
                return;
            }
            const menuItem = e.target.closest('.menu-item');
            if (menuItem) // Close menu on mobile after navigation
            {
                if (!this.isWideScreen) setTimeout(()=>this.closeMenu(), 100);
            }
        });
        // Listen for route changes to update active item
        window.addEventListener('popstate', ()=>{
            this.updateActiveMenuItem();
        });
        document.addEventListener('section-shown', ()=>{
            this.updateActiveMenuItem();
        });
    }
    setupResponsiveHandling() {
        let resizeTimeout;
        const handleResize = ()=>{
            // Debounce resize events to avoid excessive reflows
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(()=>{
                // Use requestAnimationFrame to batch DOM reads and writes
                requestAnimationFrame(()=>{
                    const wasWideScreen = this.isWideScreen;
                    // Read layout property once
                    const width = window.innerWidth;
                    this.isWideScreen = width >= 1024;
                    if (wasWideScreen !== this.isWideScreen) {
                        // Batch all DOM queries
                        const slideMenu = this.querySelector('#slideMenu');
                        const menuOverlay = this.querySelector('#menuOverlay');
                        const mobileTacoBtn = document.querySelector('#mobileTacoBtn');
                        // Batch all DOM writes in a single frame
                        requestAnimationFrame(()=>{
                            if (this.isWideScreen) {
                                // Switch to always-open mode
                                slideMenu.classList.add('always-open');
                                slideMenu.classList.remove('open');
                                menuOverlay.classList.remove('visible');
                                // Hide mobile button on wide screens
                                if (mobileTacoBtn) mobileTacoBtn.style.display = 'none';
                                this.isOpen = false;
                            } else {
                                // Switch to mobile mode
                                slideMenu.classList.remove('always-open');
                                // Show mobile button on small screens (if authenticated)
                                if (mobileTacoBtn && this.currentUser) mobileTacoBtn.style.display = 'flex';
                                if (this.isOpen) {
                                    slideMenu.classList.add('open');
                                    menuOverlay.classList.add('visible');
                                }
                            }
                        });
                    }
                });
            }, 100); // Debounce by 100ms
        };
        window.addEventListener('resize', handleResize);
        // Defer initial check to avoid forced reflow on component mount
        requestAnimationFrame(()=>{
            handleResize();
        });
    }
    setCurrentUser(user) {
        super.setCurrentUser(user);
        if (user) {
            this.updateAdminVisibility();
            this.updateFeatureNavVisibility();
            this.showMenu();
            this.loadFriendRequestCount();
            return;
        }
        this.hideMenu();
    }
    showMenu() {
        this.style.display = 'block';
        // Only show mobile taco button on small screens
        const mobileTacoBtn = document.querySelector('#mobileTacoBtn');
        if (mobileTacoBtn && !this.isWideScreen) mobileTacoBtn.style.display = 'flex';
    }
    hideMenu() {
        (0, $22b79cf8d2430b20$export$7c0b41a63515e17f)();
        this.style.display = 'none';
        // Also hide mobile taco button
        const mobileTacoBtn = document.querySelector('#mobileTacoBtn');
        if (mobileTacoBtn) mobileTacoBtn.style.display = 'none';
        // Close menu if it's open
        this.closeMenu();
    }
    updateAdminVisibility() {
        const adminSection = this.querySelector('#adminSection');
        if (adminSection) {
            if (this.currentUser && this.currentUser.role === 'admin') adminSection.style.display = 'block';
            else adminSection.style.display = 'none';
        }
    }
    updateFeatureNavVisibility() {
        const paradeItem = this.querySelector('#mascotParadeNavItem');
        if (paradeItem) paradeItem.style.display = (0, $4bd131ffd9e749e2$export$87e0f7dd6dec932f)('mascot_parade') ? '' : 'none';
    }
    toggleMenu() {
        if (this.isWideScreen) return; // No toggle on wide screens
        const mobileTacoBtn = document.querySelector('#mobileTacoBtn');
        const slideMenu = this.querySelector('#slideMenu');
        const menuOverlay = this.querySelector('#menuOverlay');
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            slideMenu.classList.add('open');
            menuOverlay.classList.add('visible');
            if (mobileTacoBtn) mobileTacoBtn.classList.add('menu-open');
        } else {
            slideMenu.classList.remove('open');
            menuOverlay.classList.remove('visible');
            if (mobileTacoBtn) mobileTacoBtn.classList.remove('menu-open');
        }
    }
    closeMenu() {
        if (this.isWideScreen) return; // No close on wide screens
        const mobileTacoBtn = document.querySelector('#mobileTacoBtn');
        const slideMenu = this.querySelector('#slideMenu');
        const menuOverlay = this.querySelector('#menuOverlay');
        this.isOpen = false;
        slideMenu.classList.remove('open');
        menuOverlay.classList.remove('visible');
        if (mobileTacoBtn) mobileTacoBtn.classList.remove('menu-open');
    }
    escapeNavHtml(str) {
        if (str === null || str === undefined) return '';
        return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    syncContextNavDom() {
        const mount = this.querySelector('#contextNavMount');
        const primary = this.querySelector('#primarySiteNav');
        if (!mount || !primary) return;
        const stack = (0, $22b79cf8d2430b20$export$b4c4ef0686a8a0f8)();
        if (stack.length === 0) {
            mount.innerHTML = '';
            mount.hidden = true;
            primary.hidden = false;
            return;
        }
        mount.hidden = false;
        primary.hidden = true;
        const blocks = stack.map((layer, index)=>{
            const isTop = index === stack.length - 1;
            const title = this.escapeNavHtml(layer.title);
            const subtitle = layer.subtitle ? `<p class="context-nav-subtitle">${this.escapeNavHtml(layer.subtitle)}</p>` : '';
            const backBtn = isTop ? '<button type="button" class="context-nav-back-btn" data-context-pop-top>\u2190 Back</button>' : '';
            const itemsHtml = (layer.items || []).map((it)=>{
                const label = this.escapeNavHtml(it.label);
                if (it.kind === 'heading') return `<li class="context-nav-heading-item"><span class="context-nav-heading">${label}</span></li>`;
                const href = this.escapeNavHtml(it.href || '#');
                const icon = it.icon ? (0, $b58f9d07dbba7b59$export$6453439b9bcd1b5d)(it.icon, 'sm') : '';
                const dr = it.dataRoute || it.href || '';
                const dataRoute = this.escapeNavHtml(dr);
                const badge = it.badge ? `<span class="notification-badge context-nav-badge">${this.escapeNavHtml(it.badge)}</span>` : '';
                const indentClass = it.indent ? ' context-nav-item-indented' : '';
                return `<li><a href="${href}" class="menu-item context-nav-item${indentClass}" data-route="${dataRoute}">${icon}${label}${badge}</a></li>`;
            }).join('');
            const titleBlock = title ? `<h3 class="context-nav-title">${title}</h3>` : '';
            return `
        <div class="menu-section context-nav-layer" data-context-owner="${this.escapeNavHtml(layer.ownerId)}" data-context-id="${this.escapeNavHtml(layer.id)}">
          <div class="context-nav-layer-head">
            ${titleBlock}
            ${backBtn}
          </div>
          ${subtitle}
          <ul class="menu-items">${itemsHtml}</ul>
        </div>
      `;
        }).join('');
        mount.innerHTML = blocks;
        this.updateActiveMenuItem();
    }
    updateDocsLink() {
        const docsLink = this.querySelector('#primarySiteNav a[data-route="/docs"], #primarySiteNav a[href^="/docs"]');
        if (!docsLink) return;
        const currentPath = window.location.pathname;
        if (currentPath === '/docs' || currentPath.startsWith('/docs/')) {
            docsLink.href = '/docs';
            docsLink.dataset.route = '/docs';
            return;
        }
        const href = (0, $82c5ec211b0f131c$export$7be6c6c696c8413b)('/docs');
        docsLink.href = href;
        docsLink.dataset.route = href;
    }
    updateActiveMenuItem() {
        const currentPath = window.location.pathname;
        this.updateDocsLink();
        this.querySelectorAll('#primarySiteNav .menu-item').forEach((item)=>{
            const route = item.dataset.route;
            if (route === currentPath || route === '/' && currentPath === '/' || route === '/groups' && (currentPath === '/groups' || currentPath.startsWith('/groups/')) || route === '/memories' && currentPath.startsWith('/memories') || route === '/settings' && currentPath.startsWith('/settings')) item.classList.add('active');
            else item.classList.remove('active');
        });
        const contextLinks = [
            ...this.querySelectorAll('a.context-nav-item')
        ];
        contextLinks.forEach((a)=>a.classList.remove('active'));
        if (contextLinks.length > 0) {
            const matching = contextLinks.filter((a)=>{
                const r = a.dataset.route;
                return r && (currentPath === r || currentPath.startsWith(`${r}/`));
            });
            if (matching.length > 0) {
                matching.sort((a, b)=>(b.dataset.route || '').length - (a.dataset.route || '').length);
                matching[0].classList.add('active');
            }
        }
    }
    async loadFriendRequestCount() {
        if (!this.currentUser || !window.API) return;
        try {
            const response = await window.API.request('/friends');
            const counts = response.counts || {};
            const receivedRequests = counts.receivedRequests || 0;
            const pendingInvitations = counts.pendingInvitations || 0;
            const totalCount = receivedRequests + pendingInvitations;
            this.updateNotificationBadge(totalCount);
        } catch (error) {
            window.logger.error('Failed to load friend request count:', error);
            this.updateNotificationBadge(0);
        }
    }
    updateNotificationBadge(count) {
        const badge = this.querySelector('#friendsBadge');
        if (!badge) return;
        if (count > 0) {
            badge.textContent = count;
            badge.style.display = 'flex';
        } else badge.style.display = 'none';
    }
    openSupportInterface() {
        // TODO: Open support interface when <safety-armadillo> component is implemented
        // For now, we'll dispatch an event that can be handled by the support component
        // or navigate to a support route when it's created
        const event = new CustomEvent('open-support', {
            bubbles: true,
            detail: {
                source: 'taco-menu'
            }
        });
        this.dispatchEvent(event);
        // Close menu on mobile after opening support
        if (!this.isWideScreen) this.closeMenu();
    }
}
// Register the custom element
customElements.define('taco-menu', $1960ad6cba9395e9$var$TacoMenu);


class $36f0b60c64af5c5e$var$TermsConditions extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.innerHTML = `
      <article class="public-page" aria-label="Terms and Conditions">
        <header>
          <p>Short, friendly, and still legally useful.</p>
          <h1>Terms & Conditions</h1>
          <p>Last updated: ${new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        })}</p>
        </header>

        <section>
          <h2>1. The vibe</h2>
          <p>Fun Old Times is a friends-first social network. By using it you agree to be kind, respect privacy boundaries, and never weaponize screenshots or exports against other members.</p>
        </section>

        <section>
          <h2>2. Accounts & access</h2>
          <ul>
            <li>You must be 16+ and use accurate contact info so we can verify invites.</li>
            <li>You\u{2019}re responsible for safeguarding your password, 2FA codes, and whatever device you use to spin the writing prompt washing machine.</li>
            <li>We can pause or remove accounts that spam, harass, or otherwise harsh the mellow.</li>
          </ul>
        </section>

        <section>
          <h2>3. Content ownership</h2>
          <p>You own your posts, photos, events, and prompts. You grant us a limited license to store and display them to the friends (and invited guests) you choose so the app works as expected.</p>
        </section>

        <section>
          <h2>4. Guests & events</h2>
          <p>Hosts can invite people without Fun Old Times accounts. We\u{2019}ll email them on your behalf, track RSVPs, and show them the event info. They can\u{2019}t see anything else unless they sign up and become friends.</p>
        </section>

        <section>
          <h2>5. Absolutely no ads or AI data grabs</h2>
          <ul>
            <li>No advertising, sponsored posts, or third-party trackers.</li>
            <li>No using your content to train AI models. If we ever consider it, we will explain why and collect an explicit opt-in that only affects future content.</li>
          </ul>
        </section>

        <section>
          <h2>6. Service changes</h2>
          <p>We ship new features often (hello, disco capybara). We may update these terms as we iterate, and we\u{2019}ll post a notice plus an in-app alert when we do.</p>
        </section>

        <section>
          <h2>7. Liability stuff</h2>
          <p>Fun Old Times is provided \u{201C}as is.\u{201D} We aim for 100% uptime but can\u{2019}t promise it. If something breaks we\u{2019}ll fix it fast, but we\u{2019}re not liable for lost data, emotional damage from puns, or missed events.</p>
        </section>

        <section>
          <p class="note">Need clarification? Email support@funoldtimes.com \u{2014} we read every message, usually with a neon highlighter.</p>
        </section>
      </article>
    `;
    }
}
customElements.define('terms-conditions', $36f0b60c64af5c5e$var$TermsConditions);


// Theme Toggle Web Component
class $984805793b0fa50a$var$ThemeToggle extends HTMLElement {
    constructor(){
        super();
        this.currentTheme = this.getInitialTheme();
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.applyTheme();
    }
    getInitialTheme() {
        // Check localStorage first
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme && [
            'light',
            'dark',
            'auto'
        ].includes(savedTheme)) return savedTheme;
        // Default to auto (OS preference)
        return 'auto';
    }
    render() {
        this.innerHTML = `
      <div class="theme-toggle">
        <button class="theme-toggle-btn" id="themeToggleBtn" title="Change theme">
          <span class="theme-icon" id="themeIcon">${this.getThemeIcon()}</span>
          <span class="theme-label" id="themeLabel">${this.getThemeLabel()}</span>
        </button>
      </div>
    `;
    }
    attachEventListeners() {
        const toggleBtn = this.querySelector('#themeToggleBtn');
        toggleBtn?.addEventListener('click', ()=>{
            this.cycleTheme();
        });
    }
    cycleTheme() {
        const themes = [
            'auto',
            'light',
            'dark'
        ];
        const currentIndex = themes.indexOf(this.currentTheme);
        const nextIndex = (currentIndex + 1) % themes.length;
        this.currentTheme = themes[nextIndex];
        this.saveTheme();
        this.applyTheme();
        this.updateUI();
    }
    applyTheme() {
        const html = document.documentElement;
        // Remove existing theme attributes
        html.removeAttribute('data-theme');
        if (this.currentTheme === 'light') html.setAttribute('data-theme', 'light');
        else if (this.currentTheme === 'dark') html.setAttribute('data-theme', 'dark');
    // For 'auto', we let CSS media queries handle it
    }
    saveTheme() {
        localStorage.setItem('theme', this.currentTheme);
    }
    updateUI() {
        const icon = this.querySelector('#themeIcon');
        const label = this.querySelector('#themeLabel');
        if (icon) icon.textContent = this.getThemeIcon();
        if (label) label.textContent = this.getThemeLabel();
    }
    getThemeIcon() {
        switch(this.currentTheme){
            case 'light':
                return "\u2600\uFE0F";
            case 'dark':
                return "\uD83C\uDF19";
            case 'auto':
                return "\uD83C\uDFA8";
            default:
                return "\uD83C\uDFA8";
        }
    }
    getThemeLabel() {
        switch(this.currentTheme){
            case 'light':
                return 'Light';
            case 'dark':
                return 'Dark';
            case 'auto':
                return 'Auto';
            default:
                return 'Auto';
        }
    }
    // Public method to get current effective theme
    getEffectiveTheme() {
        if (this.currentTheme === 'auto') return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        return this.currentTheme;
    }
    // Public method to set theme programmatically
    setTheme(theme) {
        if ([
            'light',
            'dark',
            'auto'
        ].includes(theme)) {
            this.currentTheme = theme;
            this.saveTheme();
            this.applyTheme();
            this.updateUI();
        }
    }
}
// Register the custom element
customElements.define('theme-toggle', $984805793b0fa50a$var$ThemeToggle);
// Initialize theme system
document.addEventListener('DOMContentLoaded', ()=>{
    // Listen for OS theme changes when in auto mode
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', ()=>{
        const themeToggle = document.querySelector('theme-toggle');
        if (themeToggle && themeToggle.currentTheme === 'auto') // Re-apply auto theme to pick up OS changes
        themeToggle.applyTheme();
    });
});


// Toolbar Action Bar Component
// A reusable contextual action bar (shadow styles inlined — not served from dist as a standalone file)
const $d77b14bc31c9696f$var$TOOLBAR_SHADOW_STYLES = `
:host {
  display: block;
  width: 100%;
}

.toolbar-action-bar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  width: 100%;
  box-sizing: border-box;
  background: var(--card-bg);
  border: 2px solid var(--border-color);
  border-radius: 999px;
  padding: 0.5rem 0.875rem;
  box-shadow: var(--shadow-fun);
  isolation: isolate;
  transition: var(--transition);
  overflow: hidden;
}

.toolbar-action-bar::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px;
  background: linear-gradient(
    90deg,
    var(--primary-color),
    var(--accent-secondary),
    var(--accent-color)
  );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
  z-index: -1;
}

.toolbar-action-bar:hover {
  box-shadow:
    var(--shadow-fun),
    0 0 0 1px rgba(var(--primary-color-rgb, 255, 107, 157), 0.12);
}

.toolbar-label {
  flex-shrink: 0;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-secondary);
  white-space: nowrap;
  user-select: none;
}

.toolbar-divider {
  flex-shrink: 0;
  align-self: stretch;
  width: 1px;
  min-height: 1.25rem;
  background: var(--border-color);
}

.toolbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
}

::slotted([slot="actions"]) {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  flex: 1 1 0;
  min-width: 0;
  max-width: 100%;
}

.toolbar-action-bar[data-align="left"] .toolbar-actions,
.toolbar-action-bar[data-align="left"] ::slotted([slot="actions"]) {
  justify-content: flex-start;
}

.toolbar-action-bar[data-spacing="small"] {
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
}

.toolbar-action-bar[data-spacing="small"] .toolbar-actions,
.toolbar-action-bar[data-spacing="small"] ::slotted([slot="actions"]) {
  gap: 0.375rem;
}

.toolbar-action-bar[data-spacing="large"] {
  gap: 0.875rem;
  padding: 0.625rem 1rem;
}

.toolbar-action-bar[data-spacing="large"] .toolbar-actions,
.toolbar-action-bar[data-spacing="large"] ::slotted([slot="actions"]) {
  gap: 0.75rem;
}

@media (prefers-reduced-motion: reduce) {
  .toolbar-action-bar {
    transition: none;
  }
}
`;
const $d77b14bc31c9696f$var$DEFAULT_LABEL = 'Actions';
class $d77b14bc31c9696f$var$ToolbarActionBar extends HTMLElement {
    constructor(){
        super();
    }
    connectedCallback() {
        this.createShadow();
    }
    static get observedAttributes() {
        return [
            'align',
            'spacing',
            'label'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue && this.shadowRoot) {
            if (name === 'label') {
                const labelEl = this.shadowRoot.querySelector('.toolbar-label');
                if (labelEl) labelEl.textContent = newValue || $d77b14bc31c9696f$var$DEFAULT_LABEL;
            } else this.updateStyles();
        }
    }
    createShadow() {
        this.attachShadow({
            mode: 'open'
        });
        const align = this.getAttribute('align') || 'right';
        const spacing = this.getAttribute('spacing') || 'medium';
        const label = this.getAttribute('label') || $d77b14bc31c9696f$var$DEFAULT_LABEL;
        this.shadowRoot.innerHTML = `
      <style>${$d77b14bc31c9696f$var$TOOLBAR_SHADOW_STYLES}</style>
      <div class="toolbar-action-bar" data-align="${align}" data-spacing="${spacing}" role="toolbar" aria-label="${this.escapeAttr(label)}">
        <span class="toolbar-label">${this.escapeHtml(label)}</span>
        <div class="toolbar-divider" aria-hidden="true"></div>
        <div class="toolbar-actions">
          <slot name="actions"></slot>
        </div>
      </div>
    `;
    }
    updateStyles() {
        const toolbar = this.shadowRoot?.querySelector('.toolbar-action-bar');
        if (toolbar) {
            const align = this.getAttribute('align') || 'right';
            const spacing = this.getAttribute('spacing') || 'medium';
            toolbar.setAttribute('data-align', align);
            toolbar.setAttribute('data-spacing', spacing);
        }
    }
    escapeHtml(text) {
        return String(text ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    escapeAttr(text) {
        return String(text ?? '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
}
customElements.define('toolbar-action-bar', $d77b14bc31c9696f$var$ToolbarActionBar);


/**
 * @component toolbar-overflow-actions
 * @css toolbar-overflow-actions.css
 * @primitives btn, toolbar-action-bar
 */ 
class $55adb5379e29743d$var$ToolbarOverflowActions extends HTMLElement {
    constructor(){
        super();
        this.isMenuOpen = false;
        this._popupPortal = null;
        this._resizeObserver = null;
        this._layoutFrame = null;
        this._escapeHandler = null;
        this._isCollapsed = false;
    }
    connectedCallback() {
        this.render();
        this.attachEventListeners();
        this.scheduleLayout();
    }
    disconnectedCallback() {
        this._popupPortal?.close();
        this._resizeObserver?.disconnect();
        if (this._layoutFrame) {
            cancelAnimationFrame(this._layoutFrame);
            this._layoutFrame = null;
        }
        if (this._escapeHandler) {
            document.removeEventListener('keydown', this._escapeHandler);
            this._escapeHandler = null;
        }
    }
    render() {
        if (this.querySelector('.toolbar-overflow-actions-row')) return;
        const row = document.createElement('div');
        row.className = 'toolbar-overflow-actions-row';
        row.innerHTML = `
        <div class="toolbar-overflow-inline">
          <slot name="overflow"></slot>
        </div>
        <div class="toolbar-overflow-trailing">
          <div class="toolbar-overflow-primary">
            <slot name="primary"></slot>
          </div>
          <div class="toolbar-overflow-menu-wrap" hidden>
            <button
              type="button"
              class="btn btn-secondary toolbar-overflow-trigger"
              aria-haspopup="menu"
              aria-expanded="false"
              aria-label="More actions"
            >
              <span class="toolbar-overflow-trigger-icon" aria-hidden="true">\u{2630}</span>
            </button>
            <ul class="toolbar-overflow-menu" role="menu" aria-label="More actions"></ul>
          </div>
        </div>
    `;
        this.appendChild(row);
    }
    attachEventListeners() {
        const primarySlot = this.querySelector('slot[name="primary"]');
        const overflowSlot = this.querySelector('slot[name="overflow"]');
        primarySlot?.addEventListener('slotchange', ()=>this.scheduleLayout());
        overflowSlot?.addEventListener('slotchange', ()=>this.scheduleLayout());
        if (!this._popupPortal) this._popupPortal = (0, $b4aba70cea4dadba$export$b13eaba63895f49c)(this, {
            openClass: 'open',
            align: 'right',
            gap: 8,
            onClose: ()=>{
                this.isMenuOpen = false;
                this.updateMenuState();
            }
        });
        this.addEventListener('click', (e)=>{
            if (e.target.closest('.toolbar-overflow-trigger')) {
                e.stopPropagation();
                this.toggleMenu();
            }
        });
        this.addEventListener('keydown', (e)=>{
            if (!e.target.closest('.toolbar-overflow-trigger')) return;
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggleMenu();
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                this.openMenu();
                this.focusMenuItem(0);
            }
        });
        this._escapeHandler = (e)=>{
            if (e.key === 'Escape' && this.isMenuOpen) {
                this.closeMenu();
                this.querySelector('.toolbar-overflow-trigger')?.focus();
            }
        };
        document.addEventListener('keydown', this._escapeHandler);
        if (typeof ResizeObserver !== 'undefined') {
            this._resizeObserver = new ResizeObserver(()=>this.scheduleLayout());
            this._resizeObserver.observe(this);
        } else window.addEventListener('resize', ()=>this.scheduleLayout());
    }
    scheduleLayout() {
        if (this._layoutFrame) cancelAnimationFrame(this._layoutFrame);
        this._layoutFrame = requestAnimationFrame(()=>{
            this._layoutFrame = null;
            this.layout();
        });
    }
    getSlottedButtons(slotName) {
        const slot = this.querySelector(`slot[name="${slotName}"]`);
        const assigned = slot?.assignedElements?.() ?? [];
        const elements = assigned.length ? assigned : Array.from(this.querySelectorAll(`[slot="${slotName}"]`));
        return elements.filter((el)=>el instanceof HTMLElement);
    }
    layout() {
        const overflowButtons = this.getSlottedButtons('overflow');
        const menuWrap = this.querySelector('.toolbar-overflow-menu-wrap');
        if (!overflowButtons.length) {
            if (menuWrap) menuWrap.hidden = true;
            this.dataset.collapsed = 'false';
            this._isCollapsed = false;
            this.closeMenu();
            return;
        }
        overflowButtons.forEach((button)=>{
            button.hidden = true;
        });
        if (menuWrap) menuWrap.hidden = false;
        this.dataset.collapsed = 'true';
        this._isCollapsed = true;
        this.rebuildMenu(overflowButtons);
    }
    rebuildMenu(overflowButtons) {
        const menu = this.querySelector('.toolbar-overflow-menu');
        if (!menu) return;
        menu.replaceChildren();
        overflowButtons.forEach((button, index)=>{
            const item = document.createElement('li');
            item.setAttribute('role', 'menuitem');
            item.tabIndex = -1;
            item.className = 'toolbar-overflow-menu-item';
            item.dataset.index = String(index);
            item.innerHTML = button.innerHTML;
            item.addEventListener('click', (e)=>{
                e.stopPropagation();
                button.click();
                this.closeMenu();
            });
            item.addEventListener('keydown', (e)=>{
                const items = this.getMenuItems();
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    button.click();
                    this.closeMenu();
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    this.focusMenuItem((index + 1) % items.length);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    this.focusMenuItem((index - 1 + items.length) % items.length);
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    this.closeMenu();
                    this.querySelector('.toolbar-overflow-trigger')?.focus();
                }
            });
            menu.appendChild(item);
        });
    }
    getMenu() {
        return this._popupPortal?.getMenu() ?? this.querySelector('.toolbar-overflow-menu');
    }
    getMenuItems() {
        const menu = this.getMenu();
        return menu ? Array.from(menu.querySelectorAll('.toolbar-overflow-menu-item')) : [];
    }
    toggleMenu() {
        if (this.isMenuOpen) this.closeMenu();
        else this.openMenu();
    }
    openMenu() {
        const menuWrap = this.querySelector('.toolbar-overflow-menu-wrap');
        const trigger = this.querySelector('.toolbar-overflow-trigger');
        const menu = this.querySelector('.toolbar-overflow-menu');
        if (menuWrap?.hidden || !trigger || !menu || !this._popupPortal) return;
        this.isMenuOpen = true;
        this._popupPortal.open(trigger, menu);
        this.updateMenuState();
    }
    closeMenu() {
        if (!this.isMenuOpen) return;
        this._popupPortal?.close();
    }
    updateMenuState() {
        const trigger = this.querySelector('.toolbar-overflow-trigger');
        const menu = this.getMenu();
        trigger?.setAttribute('aria-expanded', String(this.isMenuOpen));
        menu?.classList.toggle('open', this.isMenuOpen);
    }
    focusMenuItem(index) {
        const items = this.getMenuItems();
        if (index >= 0 && index < items.length) items[index].focus({
            preventScroll: true
        });
    }
}
customElements.define('toolbar-overflow-actions', $55adb5379e29743d$var$ToolbarOverflowActions);


// Two-Factor Authentication Settings Component
class $6886351288770062$var$TwoFactorSettings extends HTMLElement {
    constructor(){
        super();
        this.twoFactorEnabled = false;
        this.isLoading = true;
    }
    connectedCallback() {
        this.render();
        this.load2FAStatus().then(()=>{
            this.attachEventListeners();
        });
    }
    async load2FAStatus() {
        try {
            // Use centralized API helper
            if (!window.API) throw new Error('API not available');
            const data = await window.API.request('/auth/2fa/status');
            this.twoFactorEnabled = data.twoFactorEnabled;
        } catch (error) {
            window.logger.error('Failed to load 2FA status:', error);
        } finally{
            this.isLoading = false;
            this.render();
        }
    }
    render() {
        if (this.isLoading) {
            this.innerHTML = `
        <div class="two-factor-settings">
          <div class="loading-state">
            <div class="spinner"></div>
            <div>Loading 2FA settings...</div>
          </div>
        </div>
      `;
            return;
        }
        this.innerHTML = `
      <div class="two-factor-settings">
        <div class="settings-header">
          <h3>\u{1F510} Two-Factor Authentication</h3>
          <p class="settings-description">
            Add an extra layer of security to your account with two-factor authentication.
          </p>
        </div>

        <div class="settings-content">
          <div class="two-factor-status">
            <div class="status-indicator ${this.twoFactorEnabled ? 'enabled' : 'disabled'}">
              <span class="status-icon">${this.twoFactorEnabled ? "\u2705" : "\u274C"}</span>
              <span class="status-text">
                ${this.twoFactorEnabled ? 'Enabled' : 'Disabled'}
              </span>
            </div>
            <p class="status-description">
              ${this.twoFactorEnabled ? 'Your account is protected with two-factor authentication.' : 'Your account is not protected with two-factor authentication.'}
            </p>
          </div>

          <div class="two-factor-actions">
            ${this.twoFactorEnabled ? this.renderDisableSection() : this.renderEnableSection()}
          </div>
        </div>

        <div class="alert-container" id="twoFactorAlertContainer"></div>

        <div class="settings-footer">
          <button class="btn btn-secondary" id="returnToSettingsBtn">
            \u{2190} Return to Settings
          </button>
        </div>
      </div>
    `;
    }
    renderEnableSection() {
        return `
      <div class="enable-2fa">
        <h4>Enable Two-Factor Authentication</h4>
        <p>Use an authenticator app like Google Authenticator or Authy to generate time-based codes.</p>
        <button class="btn btn-primary" id="enable2FABtn">
          <span class="btn-text">Setup 2FA</span>
          <span class="spinner hidden"></span>
        </button>
      </div>
    `;
    }
    renderDisableSection() {
        return `
      <div class="disable-2fa">
        <h4>Disable Two-Factor Authentication</h4>
        <p>You'll need to enter a verification code from your authenticator app to disable 2FA.</p>
        
        <div class="disable-form" id="disableForm" style="display: none;">
          <div class="form-group">
            <label class="form-label" for="disableToken">Verification Code</label>
            <input 
              type="text" 
              class="form-control" 
              id="disableToken" 
              placeholder="Enter 6-digit code"
              maxlength="6"
              pattern="[0-9]{6}"
            />
            <div class="form-text">Enter the current code from your authenticator app</div>
          </div>
          <div class="form-actions">
            <button class="btn btn-danger" id="confirmDisableBtn">
              <span class="btn-text">Disable 2FA</span>
              <span class="spinner hidden"></span>
            </button>
            <button class="btn btn-outline" id="cancelDisableBtn">Cancel</button>
          </div>
        </div>

        <button class="btn btn-outline" id="showDisableFormBtn">
          Disable 2FA
        </button>
      </div>
    `;
    }
    attachEventListeners() {
        // Enable 2FA button
        const enableBtn = this.querySelector('#enable2FABtn');
        if (enableBtn) enableBtn.addEventListener('click', ()=>this.setup2FA());
        // Show disable form button
        const showDisableBtn = this.querySelector('#showDisableFormBtn');
        if (showDisableBtn) showDisableBtn.addEventListener('click', ()=>this.showDisableForm());
        // Cancel disable button
        const cancelBtn = this.querySelector('#cancelDisableBtn');
        if (cancelBtn) cancelBtn.addEventListener('click', ()=>this.hideDisableForm());
        // Confirm disable button
        const confirmBtn = this.querySelector('#confirmDisableBtn');
        if (confirmBtn) confirmBtn.addEventListener('click', ()=>this.disable2FA());
        // Return to settings button
        const returnBtn = this.querySelector('#returnToSettingsBtn');
        if (returnBtn) returnBtn.addEventListener('click', ()=>{
            if (window.router) window.router.navigate('/settings');
        });
    }
    async setup2FA() {
        const btn = this.querySelector('#enable2FABtn');
        const btnText = btn.querySelector('.btn-text');
        const spinner = btn.querySelector('.spinner');
        btn.disabled = true;
        btnText.classList.add('hidden');
        spinner.classList.remove('hidden');
        try {
            // Open the auth modal in 2FA setup mode
            const authModal = document.querySelector('auth-modal');
            if (authModal) {
                await authModal.open2FASetup();
                // Listen for successful 2FA setup
                authModal.addEventListener('auth-success', ()=>{
                    this.twoFactorEnabled = true;
                    this.render();
                    this.attachEventListeners();
                });
            } else {
                window.logger.error('Auth modal not found in DOM');
                this.showAlert('Auth modal not available. Please refresh the page.', 'error');
            }
        } catch (error) {
            window.logger.error('2FA setup error:', error);
            this.showAlert('Failed to setup 2FA. Please try again.', 'error');
        } finally{
            btn.disabled = false;
            btnText.classList.remove('hidden');
            spinner.classList.add('hidden');
        }
    }
    showDisableForm() {
        const form = this.querySelector('#disableForm');
        const showBtn = this.querySelector('#showDisableFormBtn');
        form.style.display = 'block';
        showBtn.style.display = 'none';
        // Focus the input
        const input = this.querySelector('#disableToken');
        input.focus();
    }
    hideDisableForm() {
        const form = this.querySelector('#disableForm');
        const showBtn = this.querySelector('#showDisableFormBtn');
        form.style.display = 'none';
        showBtn.style.display = 'block';
        // Clear the input
        const input = this.querySelector('#disableToken');
        input.value = '';
    }
    async disable2FA() {
        const tokenInput = this.querySelector('#disableToken');
        const token = tokenInput.value.trim();
        if (!token || token.length !== 6) {
            this.showAlert('Please enter a valid 6-digit verification code.', 'error');
            return;
        }
        const btn = this.querySelector('#confirmDisableBtn');
        const btnText = btn.querySelector('.btn-text');
        const spinner = btn.querySelector('.spinner');
        btn.disabled = true;
        btnText.classList.add('hidden');
        spinner.classList.remove('hidden');
        try {
            // Use centralized API helper
            if (!window.API) throw new Error('API not available');
            await window.API.request('/auth/2fa/disable', {
                method: 'POST',
                body: JSON.stringify({
                    token: token
                })
            });
            this.showAlert('Two-factor authentication has been disabled successfully.', 'success');
            this.twoFactorEnabled = false;
            this.hideDisableForm();
            this.render();
            this.attachEventListeners();
        } catch (error) {
            window.logger.error('2FA disable error:', error);
            this.showAlert(error.message, 'error');
        } finally{
            btn.disabled = false;
            btnText.classList.remove('hidden');
            spinner.classList.add('hidden');
        }
    }
    showAlert(message, type = 'info') {
        const container = this.querySelector('#twoFactorAlertContainer');
        const alert = document.createElement('div');
        alert.className = `alert alert-${type}`;
        alert.textContent = message;
        container.innerHTML = '';
        container.appendChild(alert);
        // Auto-remove after 5 seconds
        setTimeout(()=>{
            if (alert.parentNode) alert.parentNode.removeChild(alert);
        }, 5000);
    }
    clearAlerts() {
        const container = this.querySelector('#twoFactorAlertContainer');
        if (container) container.innerHTML = '';
    }
}
customElements.define('two-factor-settings', $6886351288770062$var$TwoFactorSettings);





const $b16312f6cf17b5ce$var$TWO_WEEKS_MS = 1209600000;
class $b16312f6cf17b5ce$var$UpcomingEventsBanner extends (0, $c9e818c1ca68a5d1$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.events = [];
        this.hasMore = false;
        this.isLoading = false;
        this.error = null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.render();
    }
    async load() {
        if (!this.isAuthenticated()) {
            this.clear();
            return;
        }
        this.isLoading = true;
        this.error = null;
        this.render();
        try {
            const now = new Date();
            const endDate = new Date(now.getTime() + $b16312f6cf17b5ce$var$TWO_WEEKS_MS);
            const params = new URLSearchParams({
                upcoming: 'true',
                startDate: now.toISOString(),
                endDate: endDate.toISOString()
            });
            const response = await window.API.request(`/events?${params.toString()}`);
            const upcoming = Array.isArray(response?.upcoming_events) ? response.upcoming_events : [];
            const filtered = upcoming.map((event)=>({
                    ...event,
                    _parsedStart: (0, $abf83f7e582f4a57$export$d1d7aa5ddaf1e876)(event.start_time, event.timezone || 'UTC')
                })).filter((event)=>{
                const { _parsedStart: _parsedStart } = event;
                if (!_parsedStart || Number.isNaN(_parsedStart.getTime())) return false;
                return _parsedStart >= now && _parsedStart <= endDate;
            }).sort((a, b)=>a._parsedStart - b._parsedStart);
            this.hasMore = filtered.length > 2;
            this.events = filtered.slice(0, 2).map((event)=>({
                    ...event,
                    startDateLabel: (0, $abf83f7e582f4a57$export$3d49a77a0c87c6aa)(event._parsedStart),
                    startTimeLabel: (0, $abf83f7e582f4a57$export$e6fb52c7265a62e5)(event._parsedStart)
                }));
        } catch (error) {
            this.error = error?.message || 'Unable to load upcoming events.';
            window.logger.error('UpcomingEventsBanner: failed to load events', error);
        } finally{
            this.isLoading = false;
            this.render();
        }
    }
    clear() {
        this.events = [];
        this.hasMore = false;
        this.isLoading = false;
        this.error = null;
        this.innerHTML = '';
    }
    render() {
        if (this.isLoading) {
            this.innerHTML = `
        <section class="upcoming-events-banner loading">
          <div class="banner-header">
            <div class="banner-title">
              <span class="banner-icon" aria-hidden="true">\u{1F388}</span>
              <span>Upcoming Fun</span>
            </div>
          </div>
          <div class="banner-body">
            <div class="loading-state">
              <div class="spinner" role="status" aria-live="polite"></div>
              <p>Checking the party calendar\u{2026}</p>
            </div>
          </div>
        </section>
      `;
            return;
        }
        if (this.error) {
            this.innerHTML = `
        <section class="upcoming-events-banner error">
          <div class="banner-header">
            <div class="banner-title">
              <span class="banner-icon" aria-hidden="true">\u{1F388}</span>
              <span>Upcoming Fun</span>
            </div>
          </div>
          <div class="banner-body">
            <div class="error-state">
              <span class="error-icon" aria-hidden="true">\u{1F63F}</span>
              <p class="error-message">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.error)}</p>
            </div>
          </div>
        </section>
      `;
            return;
        }
        if (!this.events || this.events.length === 0) {
            this.innerHTML = '';
            return;
        }
        const eventsHtml = this.events.map((event)=>`
      <article class="banner-event-card">
        <a href="/events/${event.id}" class="event-link" data-event-id="${event.id}">
          <div class="event-date">
            <span class="event-weekday">${event.startDateLabel}</span>
            <span class="event-time">${event.startTimeLabel}</span>
          </div>
          <div class="event-details">
            <h3 class="event-title">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.title)}</h3>
            ${event.location ? `<p class="event-location">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(event.location)}</p>` : ''}
          </div>
          <span class="event-arrow" aria-hidden="true">\u{2192}</span>
        </a>
      </article>
    `).join('');
        this.innerHTML = `
      <section class="upcoming-events-banner">
        <div class="banner-header">
          <div class="banner-title">
            <span class="banner-icon" aria-hidden="true">\u{1F388}</span>
            <span>Don't miss these!</span>
          </div>
          <span class="banner-subtitle">Happening within the next two weeks</span>
        </div>
        <div class="banner-body">
          ${eventsHtml}
        </div>
        ${this.hasMore ? `
          <div class="banner-footer">
            <button type="button" class="more-events-btn">
              <span>See more events</span>
              <span class="sparkle" aria-hidden="true">\u{2728}</span>
            </button>
          </div>
        ` : ''}
      </section>
    `;
        this.attachEventHandlers();
    }
    attachEventHandlers() {
        this.querySelectorAll('.event-link').forEach((link)=>{
            link.addEventListener('click', (event)=>{
                event.preventDefault();
                const targetId = event.currentTarget.getAttribute('data-event-id');
                if (targetId) window.router.navigate(`/events/${targetId}`);
            });
        });
        const moreBtn = this.querySelector('.more-events-btn');
        if (moreBtn) moreBtn.addEventListener('click', ()=>{
            window.router.navigate('/events/calendar');
        });
    }
}
customElements.define('upcoming-events-banner', $b16312f6cf17b5ce$var$UpcomingEventsBanner);
var $b16312f6cf17b5ce$export$2e2bcd8739ae039 = $b16312f6cf17b5ce$var$UpcomingEventsBanner;


// User Management Web Component
class $45894cf19ea08c2f$var$UserManagement extends HTMLElement {
    constructor(){
        super();
        this.users = [];
        this.isLoading = false;
        this.currentUser = null;
        this.isLoadingUsers = false; // Prevent multiple simultaneous calls
        this.currentPage = 1;
        this.totalPages = 1;
        this.expandedUsers = new Set(); // Track which users have expanded friends
        this.userFriends = new Map(); // Cache friends for each user
        this.loadingFriends = new Set(); // Track which users are loading friends
    }
    connectedCallback() {
        this.render();
        this.setupAuthListener();
        // If we already have a current user (e.g., setCurrentUser was called before connectedCallback),
        // try to load users after a brief delay to ensure DOM is ready
        if (this.currentUser && this.currentUser.role === 'admin') setTimeout(()=>{
            if (!this.isLoadingUsers && this.currentUser && this.currentUser.role === 'admin') this.loadUsers();
        }, 100);
    }
    disconnectedCallback() {
        // Remove event listener when component is removed
        if (this.handleAuthStatusLoaded) document.removeEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
    }
    setupAuthListener() {
        // Listen for centralized auth status
        this.handleAuthStatusLoaded = (e)=>{
            const { user: user, authenticated: authenticated } = e.detail;
            if (authenticated && user && user.role === 'admin') {
                this.currentUser = user;
                // Only load users if component is visible
                if (this.isVisible()) this.loadUsers();
            } else this.currentUser = null;
        };
        document.addEventListener('auth-status-loaded', this.handleAuthStatusLoaded);
    }
    isVisible() {
        // Check if this component is currently visible on the page
        // offsetParent is null if the element or any parent is hidden
        if (this.offsetParent === null) return false;
        // Also check if display is explicitly set to none
        const style = window.getComputedStyle(this);
        return style.display !== 'none' && style.visibility !== 'hidden';
    }
    render() {
        this.innerHTML = `
      <div class="user-management">
        <div class="user-header">
          <h2>User Management</h2>
          <p>Manage user accounts and roles</p>
        </div>

        <div class="user-content">
          ${this.renderContent()}
        </div>

        ${this.renderPagination()}
      </div>
    `;
        this.attachEventListeners();
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading users...</div>
        </div>
      `;
        if (this.users.length === 0) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F465}</div>
          <h3>No users found</h3>
          <p>There are no users in the system.</p>
        </div>
      `;
        return `
      <div class="user-list">
        ${this.users.map((user)=>this.renderUser(user)).join('')}
      </div>
    `;
    }
    renderUser(user) {
        const isExpanded = this.expandedUsers.has(user.id);
        const friends = this.userFriends.get(user.id) || [];
        const isLoadingFriends = this.loadingFriends.has(user.id);
        const createdDate = new Date(user.created_at).toLocaleDateString();
        const roleBadge = user.role === 'admin' ? '<span class="role-badge admin">Admin</span>' : '<span class="role-badge user">User</span>';
        const verifiedBadge = user.email_verified ? '<span class="verified-badge">\u2713 Verified</span>' : '<span class="verified-badge unverified">\u2717 Unverified</span>';
        return `
      <div class="user-item">
        <div class="user-main">
          <div class="user-info">
            <div class="user-header-row">
              <h3 class="user-username">${this.escapeHtml(user.username)}</h3>
              ${roleBadge}
              ${verifiedBadge}
            </div>
            <div class="user-details">
              <div class="user-detail">
                <span class="detail-label">Email:</span>
                <span class="detail-value">${this.escapeHtml(user.email)}</span>
              </div>
              ${user.first_name || user.last_name ? `
                <div class="user-detail">
                  <span class="detail-label">Name:</span>
                  <span class="detail-value">${this.escapeHtml((user.first_name || '') + ' ' + (user.last_name || '')).trim() || 'N/A'}</span>
                </div>
              ` : ''}
              <div class="user-detail">
                <span class="detail-label">User ID:</span>
                <span class="detail-value">${user.id}</span>
              </div>
              <div class="user-detail">
                <span class="detail-label">Joined:</span>
                <span class="detail-value">${createdDate}</span>
              </div>
            </div>
          </div>
          <button class="toggle-friends-btn" data-user-id="${user.id}" ${isLoadingFriends ? 'disabled' : ''}>
            ${isExpanded ? "\u25BC" : "\u25B6"} Friends
          </button>
        </div>
        ${isExpanded ? `
          <div class="user-friends">
            ${isLoadingFriends ? `
              <div class="friends-loading">
                <div class="spinner-small"></div>
                <span>Loading friends...</span>
              </div>
            ` : friends.length > 0 ? `
              <div class="friends-list">
                ${friends.map((friend)=>`
                  <div class="friend-item">
                    <span class="friend-username">${this.escapeHtml(friend.username)}</span>
                    <span class="friend-email">${this.escapeHtml(friend.email)}</span>
                    ${friend.first_name || friend.last_name ? `
                      <span class="friend-name">${this.escapeHtml((friend.first_name || '') + ' ' + (friend.last_name || '')).trim()}</span>
                    ` : ''}
                  </div>
                `).join('')}
              </div>
            ` : `
              <div class="friends-empty">
                <span>No friends</span>
              </div>
            `}
          </div>
        ` : ''}
      </div>
    `;
    }
    renderPagination() {
        if (this.totalPages <= 1) return '';
        const startPage = Math.max(1, this.currentPage - 2);
        const endPage = Math.min(this.totalPages, this.currentPage + 2);
        const pages = [];
        for(let i = startPage; i <= endPage; i++)pages.push(i);
        return `
      <div class="pagination">
        <div class="pagination-info">
          Page ${this.currentPage} of ${this.totalPages}
        </div>
        
        <div class="pagination-controls">
          <button class="pagination-btn" ${this.currentPage === 1 ? 'disabled' : ''} data-page="${this.currentPage - 1}">
            \u{2190} Previous
          </button>
          
          ${pages.map((page)=>`
            <button class="pagination-btn ${page === this.currentPage ? 'active' : ''}" data-page="${page}">
              ${page}
            </button>
          `).join('')}
          
          <button class="pagination-btn" ${this.currentPage === this.totalPages ? 'disabled' : ''} data-page="${this.currentPage + 1}">
            Next \u{2192}
          </button>
        </div>
      </div>
    `;
    }
    attachEventListeners() {
        // Pagination event delegation
        this.addEventListener('click', (e)=>{
            if (e.target.classList.contains('pagination-btn') && !e.target.disabled) {
                const page = parseInt(e.target.dataset.page);
                if (page && page !== this.currentPage) {
                    this.currentPage = page;
                    this.loadUsers();
                }
            }
            // Toggle friends
            if (e.target.classList.contains('toggle-friends-btn')) {
                const userId = parseInt(e.target.dataset.userId);
                if (userId) this.toggleFriends(userId);
            }
        });
    }
    async toggleFriends(userId) {
        if (this.expandedUsers.has(userId)) {
            // Collapse
            this.expandedUsers.delete(userId);
            this.updateContent();
        } else {
            // Expand - load friends if not cached
            this.expandedUsers.add(userId);
            if (!this.userFriends.has(userId)) await this.loadUserFriends(userId);
            else this.updateContent();
        }
    }
    async loadUserFriends(userId) {
        this.loadingFriends.add(userId);
        this.updateContent();
        try {
            const response = await fetch(`/api/admin/users/${userId}/friends`, {
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                this.userFriends.set(userId, data.friends || []);
            } else throw new Error('Failed to fetch friends');
        } catch (error) {
            window.logger.error('Failed to load user friends:', error);
            this.userFriends.set(userId, []);
        } finally{
            this.loadingFriends.delete(userId);
            this.updateContent();
        }
    }
    async loadUsers() {
        // Prevent multiple simultaneous calls
        if (this.isLoadingUsers) return;
        // Only load if user is admin and component is visible
        if (!this.currentUser || this.currentUser.role !== 'admin') return;
        if (!this.isVisible()) return;
        this.isLoadingUsers = true;
        this.isLoading = true;
        this.updateContent();
        try {
            const params = new URLSearchParams({
                page: this.currentPage,
                limit: 20
            });
            const response = await fetch(`/api/admin/users?${params}`, {
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                this.users = data.users || [];
                this.totalPages = data.pagination?.pages || 1;
                this.currentPage = data.pagination?.page || 1;
            } else throw new Error('Failed to fetch users');
        } catch (error) {
            window.logger.error('Failed to load users:', error);
            this.users = [];
            this.showError('Failed to load users. Please try again.');
        } finally{
            this.isLoading = false;
            this.isLoadingUsers = false;
            this.updateContent();
        }
    }
    updateContent() {
        const content = this.querySelector('.user-content');
        if (content) content.innerHTML = this.renderContent();
        const pagination = this.querySelector('.pagination');
        if (pagination) pagination.outerHTML = this.renderPagination();
    }
    showError(message) {
        const content = this.querySelector('.user-content');
        if (content) content.innerHTML = `
        <div class="empty-state">
          <div class="empty-state-icon">\u{274C}</div>
          <h3>Error</h3>
          <p>${this.escapeHtml(message)}</p>
        </div>
      `;
    }
    setCurrentUser(user) {
        this.currentUser = user;
        // If we have user data and they're an admin, load users
        // Use a small delay to ensure component is fully connected and visible
        if (this.currentUser && this.currentUser.role === 'admin') // Small delay to ensure DOM is ready, then load users
        setTimeout(()=>{
            if (this.currentUser && this.currentUser.role === 'admin' && !this.isLoadingUsers) this.loadUsers();
        }, 50);
    }
    escapeHtml(text) {
        if (text === null || text === undefined) return '';
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
}
// Register the custom element
customElements.define('user-management', $45894cf19ea08c2f$var$UserManagement);


// User Mention Web Component
// Displays a username with friend request button/badge based on relationship

class $6d967b19cb787830$var$UserMention extends HTMLElement {
    // Static cache for relationship data
    static cache = new Map();
    // Static map to track in-flight requests (deduplication)
    static inFlightRequests = new Map();
    // Cache TTL: 5 minutes
    static CACHE_TTL = 300000;
    // Flag to track if event listeners are set up
    static eventListenersSetup = false;
    constructor(){
        super();
        this.userId = null;
        this.mentionedUserId = null;
        this.username = null;
        this.realUsername = null;
        this.relationship = null;
        this.isLoading = false;
        // Set up static event listeners once
        if (!$6d967b19cb787830$var$UserMention.eventListenersSetup) {
            $6d967b19cb787830$var$UserMention.setupStaticEventListeners();
            $6d967b19cb787830$var$UserMention.eventListenersSetup = true;
        }
    }
    /**
   * Set up static event listeners for cache invalidation
   */ static setupStaticEventListeners() {
        // Listen for friend request sent
        document.addEventListener('friend-request-sent', (e)=>{
            const { userId: mentionedUserId } = e.detail || {};
            if (mentionedUserId) // Invalidate cache for the mentioned user
            // This will invalidate all relationships involving this user
            $6d967b19cb787830$var$UserMention.invalidateUserRelationship(mentionedUserId);
        });
        // Listen for friend request accepted
        document.addEventListener('friend-request-accepted', (e)=>{
            const { friendship: friendship } = e.detail || {};
            if (friendship) {
                // Invalidate cache for both users in the friendship
                if (friendship.userId) $6d967b19cb787830$var$UserMention.invalidateUserRelationship(friendship.userId);
                if (friendship.friendId) $6d967b19cb787830$var$UserMention.invalidateUserRelationship(friendship.friendId);
            } else // If no friendship object, invalidate all (safer approach)
            $6d967b19cb787830$var$UserMention.clearCache();
        });
        // Listen for friend request declined
        document.addEventListener('friend-request-declined', (_e)=>{
            // When declined, we might not have user info in event
            // Invalidate all cache to be safe (relationship status might have changed)
            $6d967b19cb787830$var$UserMention.clearCache();
        });
        // Listen for invitation accepted (creates friendship)
        document.addEventListener('invitation-accepted', (e)=>{
            const { friendship: friendship } = e.detail || {};
            if (friendship) {
                if (friendship.userId) $6d967b19cb787830$var$UserMention.invalidateUserRelationship(friendship.userId);
                if (friendship.friendId) $6d967b19cb787830$var$UserMention.invalidateUserRelationship(friendship.friendId);
            } else $6d967b19cb787830$var$UserMention.clearCache();
        });
    }
    /**
   * Generate cache key from current user ID and mentioned username/userId
   */ static getCacheKey(currentUserId, username, mentionedUserId = null) {
        if (mentionedUserId) // Use IDs for more reliable caching
        return `${currentUserId}:${mentionedUserId}`;
        // Fallback to username if ID not available yet
        return `${currentUserId}:${username}`;
    }
    /**
   * Check if cached data is still valid
   */ static isCacheValid(cacheEntry) {
        if (!cacheEntry) return false;
        const now = Date.now();
        return now - cacheEntry.timestamp < $6d967b19cb787830$var$UserMention.CACHE_TTL;
    }
    /**
   * Get cached relationship data
   * Tries multiple cache key formats to find cached data
   */ static getCachedRelationship(currentUserId, username, mentionedUserId = null) {
        // Try with mentionedUserId first if available
        if (mentionedUserId) {
            const keyWithId = $6d967b19cb787830$var$UserMention.getCacheKey(currentUserId, username, mentionedUserId);
            const cacheEntryWithId = $6d967b19cb787830$var$UserMention.cache.get(keyWithId);
            if (cacheEntryWithId && $6d967b19cb787830$var$UserMention.isCacheValid(cacheEntryWithId)) return cacheEntryWithId.data;
            // Remove expired entry
            if (cacheEntryWithId) $6d967b19cb787830$var$UserMention.cache.delete(keyWithId);
        }
        // Try with username (fallback for when mentionedUserId wasn't available when cached)
        const keyWithUsername = $6d967b19cb787830$var$UserMention.getCacheKey(currentUserId, username, null);
        const cacheEntryWithUsername = $6d967b19cb787830$var$UserMention.cache.get(keyWithUsername);
        if (cacheEntryWithUsername && $6d967b19cb787830$var$UserMention.isCacheValid(cacheEntryWithUsername)) {
            // Found a cache entry by username - use it and update cache with ID-based key if we have ID
            const data = cacheEntryWithUsername.data;
            // Use the ID from cached data if available, otherwise use the one passed in
            const finalMentionedUserId = data.mentionedUserId || mentionedUserId;
            // If we have an ID, also cache it with the ID-based key for future lookups
            if (finalMentionedUserId) {
                // Update the data if we're adding an ID that wasn't there before
                if (!data.mentionedUserId && mentionedUserId) data.mentionedUserId = mentionedUserId;
                const keyWithId = $6d967b19cb787830$var$UserMention.getCacheKey(currentUserId, username, finalMentionedUserId);
                // Update the cache entry to include the ID
                const updatedEntry = {
                    ...cacheEntryWithUsername,
                    mentionedUserId: finalMentionedUserId
                };
                $6d967b19cb787830$var$UserMention.cache.set(keyWithId, updatedEntry);
            }
            return data;
        }
        // Remove expired entry
        if (cacheEntryWithUsername) $6d967b19cb787830$var$UserMention.cache.delete(keyWithUsername);
        return null;
    }
    /**
   * Store relationship data in cache
   * Stores under both ID-based and username-based keys for better cross-component lookups
   */ static setCachedRelationship(currentUserId, username, mentionedUserId, relationship) {
        const cacheEntry = {
            data: relationship,
            timestamp: Date.now(),
            mentionedUserId: mentionedUserId || relationship.mentionedUserId // Store for easier invalidation
        };
        // Store with ID-based key if we have an ID
        if (mentionedUserId || relationship.mentionedUserId) {
            const idKey = $6d967b19cb787830$var$UserMention.getCacheKey(currentUserId, username, mentionedUserId || relationship.mentionedUserId);
            $6d967b19cb787830$var$UserMention.cache.set(idKey, cacheEntry);
        }
        // Also always store with username-based key (for components that don't have ID yet)
        const usernameKey = $6d967b19cb787830$var$UserMention.getCacheKey(currentUserId, username, null);
        $6d967b19cb787830$var$UserMention.cache.set(usernameKey, cacheEntry);
    }
    /**
   * Invalidate cache entries for a specific user relationship
   * This invalidates all cache entries that involve the given userId
   * (either as current user or mentioned user)
   */ static invalidateUserRelationship(userId) {
        if (!userId) return;
        // Remove all cache entries that involve this user
        // Cache keys are in format: "currentUserId:mentionedUserId" or "currentUserId:username"
        const keysToDelete = [];
        for (const [key, entry] of $6d967b19cb787830$var$UserMention.cache.entries()){
            // Check if entry has this user as mentionedUserId
            if (entry.mentionedUserId === userId) keysToDelete.push(key);
            else if (key.includes(`:${userId}`) || key.startsWith(`${userId}:`)) keysToDelete.push(key);
        }
        keysToDelete.forEach((key)=>{
            $6d967b19cb787830$var$UserMention.cache.delete(key);
            // Also remove from in-flight requests to prevent stale data
            $6d967b19cb787830$var$UserMention.inFlightRequests.delete(key);
        });
        if (keysToDelete.length > 0) window.logger.debug(`Invalidated ${keysToDelete.length} cache entries for user ${userId}`);
    }
    /**
   * Clear all cached relationship data
   */ static clearCache() {
        $6d967b19cb787830$var$UserMention.cache.clear();
    }
    static get observedAttributes() {
        return [
            'user-id',
            'username',
            'real-username',
            'mentioned-user-id'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            if (name === 'user-id') this.userId = newValue ? parseInt(newValue, 10) : null;
            else if (name === 'username') this.username = newValue;
            else if (name === 'real-username') this.realUsername = newValue;
            else if (name === 'mentioned-user-id') this.mentionedUserId = newValue;
            this.loadRelationship();
        }
    }
    connectedCallback() {
        // Get initial values from attributes
        // this is the current user
        this.userId = this.getAttribute('user-id') ? parseInt(this.getAttribute('user-id'), 10) : null;
        // this is the username to disply
        this.username = this.getAttribute('username');
        // this is the real username
        this.realUsername = this.getAttribute('real-username');
        this.mentionedUserId = this.getAttribute('mentioned-user-id');
        this.render();
        this.setupEventListeners();
        // Load relationship if we have both userId and currentUser
        if (this.userId && this.currentUser) this.loadRelationship();
    }
    setupEventListeners() {
        // Handle friend request button clicks
        this.addEventListener('click', async (e)=>{
            const button = e.target.closest('[data-action="send-friend-request"]');
            if (button) await this.handleSendFriendRequest(button);
        });
    }
    /**
   * Set the current user (called by parent components)
   */ setCurrentUser(user) {
        this.currentUser = user;
        // Load relationship if we have userId
        if (this.userId) this.loadRelationship();
    }
    async loadRelationship() {
        // Don't load if we don't have currentUser or userId or username
        if (!this.userId || !this.username) return;
        // Determine the username to use
        let username = this.username;
        if (this.realUsername) username = this.realUsername;
        // Check cache first (try with mentionedUserId if we have it, otherwise by username)
        const cachedRelationship = $6d967b19cb787830$var$UserMention.getCachedRelationship(this.userId, username, this.mentionedUserId);
        if (cachedRelationship) {
            this.relationship = cachedRelationship;
            // If we got from cache and don't have mentionedUserId yet, try to extract it
            if (!this.mentionedUserId && cachedRelationship.mentionedUserId) this.mentionedUserId = cachedRelationship.mentionedUserId;
            // always override this so it links to the right page
            this.realUsername = cachedRelationship.realUsername;
            this.render();
            return;
        }
        // Check if there's an in-flight request for this relationship
        // Try both cache key formats to catch in-flight requests from other components
        const cacheKeyWithId = $6d967b19cb787830$var$UserMention.getCacheKey(this.userId, username, this.mentionedUserId);
        const cacheKeyWithUsername = $6d967b19cb787830$var$UserMention.getCacheKey(this.userId, username, null);
        // Check for in-flight request by ID first, then by username
        let inFlightRequest = $6d967b19cb787830$var$UserMention.inFlightRequests.get(cacheKeyWithId);
        if (!inFlightRequest && cacheKeyWithUsername !== cacheKeyWithId) inFlightRequest = $6d967b19cb787830$var$UserMention.inFlightRequests.get(cacheKeyWithUsername);
        if (inFlightRequest) {
            // Wait for the existing request to complete
            // Set loading state while waiting (other component is making the request)
            this.isLoading = true;
            this.render();
            try {
                const relationship = await inFlightRequest;
                this.relationship = relationship;
                if (!this.mentionedUserId && relationship.mentionedUserId) this.mentionedUserId = relationship.mentionedUserId;
                // Clear loading state before rendering
                this.isLoading = false;
                this.render();
            } catch (error) {
                // If the request failed, clear loading and try to show something
                window.logger.error('In-flight request failed:', error);
                this.isLoading = false;
                this.relationship = {
                    canSendFriendRequest: false,
                    hasPendingRequest: false,
                    isFriend: false,
                    isSelf: false
                };
                this.render();
            }
            return;
        }
        // Start loading
        this.isLoading = true;
        this.render();
        // Create a promise for this request
        // Store it under both key formats so other components can find it
        const requestPromise = this.fetchRelationship(username);
        $6d967b19cb787830$var$UserMention.inFlightRequests.set(cacheKeyWithId, requestPromise);
        if (cacheKeyWithUsername !== cacheKeyWithId) $6d967b19cb787830$var$UserMention.inFlightRequests.set(cacheKeyWithUsername, requestPromise);
        try {
            const relationship = await requestPromise;
            this.relationship = relationship;
            // Store in cache
            $6d967b19cb787830$var$UserMention.setCachedRelationship(this.userId, username, this.mentionedUserId, relationship);
            // Set loading to false before rendering
            this.isLoading = false;
            this.render();
        } catch (error) {
            window.logger.error('Failed to load relationship:', error);
            this.relationship = {
                canSendFriendRequest: false,
                hasPendingRequest: false,
                isFriend: false,
                isSelf: false
            };
            // Set loading to false before rendering
            this.isLoading = false;
            this.render();
        } finally{
            // Clean up in-flight requests from both key formats
            const cacheKeyWithId = $6d967b19cb787830$var$UserMention.getCacheKey(this.userId, username, this.mentionedUserId);
            const cacheKeyWithUsername = $6d967b19cb787830$var$UserMention.getCacheKey(this.userId, username, null);
            $6d967b19cb787830$var$UserMention.inFlightRequests.delete(cacheKeyWithId);
            if (cacheKeyWithUsername !== cacheKeyWithId) $6d967b19cb787830$var$UserMention.inFlightRequests.delete(cacheKeyWithUsername);
        }
    }
    /**
   * Fetch relationship data from API
   */ async fetchRelationship(username) {
        const response = await fetch(`/api/users/profile/${encodeURIComponent(username)}`, {
            credentials: 'include'
        });
        if (response.ok) {
            const data = await response.json();
            const mentionedUserId = data.user.id;
            // Store mentionedUserId if we don't have it
            if (!this.mentionedUserId) this.mentionedUserId = mentionedUserId;
            // always set the canonical username from the server
            this.realUsername = data.user.username;
            // Check if it's self
            if (this.userId === mentionedUserId) {
                const relationship = {
                    isSelf: true,
                    mentionedUserId: mentionedUserId,
                    realUsername: data.user.username
                };
                return relationship;
            }
            // Return relationship data with mentionedUserId included
            if (data.relationship) return {
                ...data.relationship,
                mentionedUserId: mentionedUserId,
                realUsername: data.user.username
            };
            else // If no relationship data, assume we can't send a request
            return {
                canSendFriendRequest: false,
                hasPendingRequest: false,
                isFriend: false,
                isSelf: false,
                mentionedUserId: mentionedUserId
            };
        } else // If profile is not accessible, assume we can't send a request
        return {
            canSendFriendRequest: false,
            hasPendingRequest: false,
            isFriend: false,
            isSelf: false,
            mentionedUserId: null
        };
    }
    async handleSendFriendRequest(button) {
        if (!this.mentionedUserId) {
            window.logger.error('No user ID provided for friend request');
            return;
        }
        try {
            button.disabled = true;
            button.textContent = 'Sending...';
            const response = await fetch('/api/friends/request', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    friendId: Number(this.mentionedUserId)
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.message || data.error || 'Failed to send friend request');
            window.logger.info('Friend request sent successfully');
            // Invalidate cache for this relationship
            if (this.mentionedUserId) $6d967b19cb787830$var$UserMention.invalidateUserRelationship(this.mentionedUserId);
            // Reload the relationship to update the UI
            await this.loadRelationship();
            // Dispatch event to update friends list if it's visible
            // Note: userId here refers to the mentioned user, not current user
            document.dispatchEvent(new CustomEvent('friend-request-sent', {
                detail: {
                    userId: this.mentionedUserId
                }
            }));
        } catch (error) {
            window.logger.error('Failed to send friend request:', error);
            button.disabled = false;
            button.innerHTML = '\uD83E\uDD1D<span class="add-friend-title">Add Friend</span>';
            alert(`Failed to send friend request: ${error.message}`);
        }
    }
    render() {
        if (!this.username) {
            this.innerHTML = '';
            return;
        }
        let username = this.username;
        if (this.realUsername) username = this.realUsername;
        if (this.relationship) username = this.relationship.realUsername;
        const usernameLink = `<a href="/profile/${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(username)}" class="user-mention-link">${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(this.username)}</a>`;
        // If loading, show username with loading state
        if (this.isLoading) {
            this.innerHTML = `
        <div class="user-mention">
          ${usernameLink}
          <span class="user-mention-loading">\u{23F3}</span>
        </div>
      `;
            return;
        }
        // If no relationship data yet, just show username
        if (!this.relationship) {
            this.innerHTML = `
        <div class="user-mention">
          ${usernameLink}
        </div>
      `;
            return;
        }
        // If it's self, just show username
        if (this.relationship.isSelf) {
            this.innerHTML = `
        <div class="user-mention">
          ${usernameLink}
        </div>
      `;
            return;
        }
        // If already friends, just show username
        if (this.relationship.isFriend) {
            this.innerHTML = `
        <div class="user-mention">
          ${usernameLink}
        </div>
      `;
            return;
        }
        // Show username with friend request button or pending badge
        const friendRequestButton = this.relationship.canSendFriendRequest ? `<button title="Add Friend" class="btn btn-sm btn-success" data-action="send-friend-request" data-user-id="${this.userId}">\u{1F91D}<span class="add-friend-title"> Add Friend</span></button>` : '';
        const pendingBadge = this.relationship.hasPendingRequest ? '<span class="pending-badge">\u23F3 Pending</span>' : '';
        this.innerHTML = `
      <div class="user-mention">
        ${usernameLink}
        ${friendRequestButton}
        ${pendingBadge}
      </div>
    `;
    }
}
// Register the custom element
customElements.define('user-mention', $6d967b19cb787830$var$UserMention);


// User Profile Web Component





class $0ad2148afb589f74$var$UserProfile extends HTMLElement {
    constructor(){
        super();
        this.profileData = null;
        this.currentUsername = null;
        this.isLoading = false;
        this.isLoadingPosts = false;
        this.currentUser = null;
        this.currentPage = 1;
        this.pagination = null;
        this.isEditingProfile = false;
        this._editSnapshot = null;
        this._myWidgetCatalog = [];
        this._communityWidgetCatalog = [];
        this._savedSectionIds = new Set();
        this._pendingInstanceConfigs = new Map();
        this._flaggableWidgets = [];
    }
    connectedCallback() {
        this.render();
        this.setupEventListeners();
        this.handleFeatureFlagsLoaded = ()=>{
            if (this.profileData) this.render();
        };
        document.addEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
    }
    disconnectedCallback() {
        document.removeEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
    }
    setupEventListeners() {
        this.addEventListener('click', async (e)=>{
            const editButton = e.target.closest('[data-action="edit-profile"]');
            if (editButton) {
                e.preventDefault();
                await this.handleEditProfile();
                return;
            }
            const flagBtn = e.target.closest('[data-action="open-widget-flag-picker"]');
            if (flagBtn) {
                e.preventDefault();
                await this._openWidgetFlagPicker();
                return;
            }
            // Delegated: posts/pagination are mounted into layout-grid-surface after render
            if (e.target.closest('.load-more-btn')) {
                e.preventDefault();
                await this.loadMore();
                return;
            }
            if (e.target.closest('.load-previous-btn')) {
                e.preventDefault();
                await this.loadPrevious();
            }
        });
        this.addEventListener('layout-surface-save', (e)=>{
            this.handleSaveProfile(e.detail.layout, e.detail.instanceConfigs);
        });
        this.addEventListener('layout-surface-cancel', ()=>{
            this.handleCancelProfileEdit();
        });
        this.addEventListener('layout-oauth-connect', (e)=>{
            this.handleLayoutOAuthConnect(e.detail);
        });
        // Handle profile-load events
        document.addEventListener('profile-load', (e)=>{
            const { username: username } = e.detail;
            const usernameChanged = this.currentUsername !== username;
            this.currentUsername = username;
            if (usernameChanged) {
                this.currentPage = 1;
                const urlParams = new URLSearchParams(window.location.search);
                const pageParam = urlParams.get('page');
                if (pageParam) {
                    const page = parseInt(pageParam, 10);
                    if (!isNaN(page) && page > 0) this.currentPage = page;
                }
            }
            this.loadProfile();
        });
        // Listen for friend request sent events to reload profile
        document.addEventListener('friend-request-sent', async (e)=>{
            // Reload profile if it's the user we're viewing
            if (this.profileData && this.profileData.user && e.detail.userId === this.profileData.user.id) await this.loadProfile();
        });
    }
    render() {
        const editingClass = this.isEditingProfile ? ' is-editing' : '';
        this.innerHTML = `
      <div class="user-profile${editingClass}">
        <div class="profile-header">
          ${(0, $b58f9d07dbba7b59$export$9861bc22ef8417be)("\uD83D\uDC64", 'User Profile')}
        </div>

        <div class="profile-content">
          ${this.renderContent()}
        </div>
      </div>
    `;
        this._mountProfileSurface();
    }
    _syncSavedSectionIdsFromLayout(layoutDoc) {
        const layout = (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(layoutDoc);
        this._savedSectionIds = new Set((0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layout.root).map((s)=>s.id));
    }
    _isSectionSaved(sectionId) {
        return this._savedSectionIds.has(sectionId);
    }
    getProfileComponentCatalog() {
        return (0, $52a42ad6d68b93da$export$2fd4d96047f2d97d)({
            myWidgets: this._myWidgetCatalog || [],
            communityWidgets: this._communityWidgetCatalog || []
        });
    }
    _mountProfileSurface() {
        const surface = this.querySelector('layout-grid-surface');
        if (!surface || !this.profileData?.user || this.profileData.error) return;
        const { user: user } = this.profileData;
        const layout = (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(user.profile_layout);
        surface.setComponentCatalog(this.getProfileComponentCatalog());
        surface.setLayout(layout);
        surface.setSectionRenderer((section, ctx)=>this.renderProfileSection(section, ctx.mode));
        if (this.isEditingProfile) {
            surface.setPendingInstanceConfigs(this._pendingInstanceConfigs);
            surface.enterEditMode();
        }
        this._refreshFlaggableWidgets();
    }
    _getAllCatalogWidgets() {
        const seen = new Set();
        const merged = [];
        for (const w of [
            ...this._myWidgetCatalog || [],
            ...this._communityWidgetCatalog || []
        ]){
            if (!w?.id || seen.has(w.id)) continue;
            seen.add(w.id);
            merged.push(w);
        }
        return merged;
    }
    _getWidgetFromCatalog(widgetId) {
        const wid = parseInt(widgetId, 10);
        return this._getAllCatalogWidgets().find((w)=>parseInt(w.id, 10) === wid) || null;
    }
    _widgetHasMarkdownConfig(widget) {
        const props = widget?.configSchema?.properties;
        if (!props || typeof props !== 'object') return false;
        return Object.values(props).some((field)=>field?.format === 'markdown');
    }
    async _loadInstanceConfigsForEdit(user) {
        this._pendingInstanceConfigs = new Map();
        if (!user?.id) return;
        const layout = (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(user.profile_layout);
        const sections = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layout.root).filter((s)=>s.type === 'widget' && s.widgetId);
        await Promise.all(sections.map(async (section)=>{
            try {
                const res = await fetch(`/api/widget-instances/${encodeURIComponent(user.id)}/${encodeURIComponent(section.id)}/config`, {
                    credentials: 'include'
                });
                if (!res.ok) return;
                const data = await res.json();
                if (data.config && typeof data.config === 'object') this._pendingInstanceConfigs.set(section.id, data.config);
            } catch (err) {
                window.logger?.warn('Failed to load widget instance config:', err);
            }
        }));
    }
    renderProfileSection(section, mode) {
        const { posts: posts, relationship: relationship } = this.profileData;
        if (section.type === 'posts') return this.renderPostsSection(posts, relationship);
        if (section.type === 'widget' && section.widgetId) return this.renderWidgetSection(section, mode);
        return '';
    }
    renderContent() {
        if (this.isLoading) return `
        <div class="loading-state">
          <div class="spinner"></div>
          <div>Loading profile...</div>
        </div>
      `;
        if (!this.profileData) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F464}</div>
          <h3>No Profile Selected</h3>
          <p>Select a user profile to view their information and posts.</p>
        </div>
      `;
        // Handle error responses
        if (this.profileData.error) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F512}</div>
          <h3>Profile Not Available</h3>
          <p>${this.profileData.error === 'User not found' ? 'This profile is not accessible. You can only view profiles of yourself, your friends, or friends of friends.' : this.profileData.error}</p>
        </div>
      `;
        const { user: user, posts: posts, stats: stats, relationship: relationship } = this.profileData;
        const isSelf = relationship?.isSelf || false;
        const isFriendOfFriend = relationship?.isFriendOfFriend || false;
        const widgetFlagChrome = !this.isEditingProfile ? this.renderWidgetFlagChrome() : '';
        const layoutArea = `${widgetFlagChrome}<layout-grid-surface
          class="profile-layout-grid"
          edit-label="Editing your profile layout"
        ></layout-grid-surface>`;
        const nameBlock = this.isEditingProfile ? this.renderEditableNameFields(user) : `<h1 class="profile-name">${this.getDisplayName(user)}</h1>`;
        return `
      <div class="profile-info">
        <div class="profile-avatar">
          <div class="avatar">${user.username.charAt(0).toUpperCase()}</div>
          ${isSelf && !this.isEditingProfile ? '<button class="btn btn-primary" data-action="edit-profile">Edit Profile</button>' : ''}
          ${!isSelf && this.currentUser ? `<user-mention user-id="${this.currentUser.id}" mentioned-user-id="${user.id}" username="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.username)}"></user-mention>` : ''}
        </div>
        
        <div class="profile-details">
          ${nameBlock}
          <div class="profile-username">@${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.username)}</div>
          ${user.email ? `<div class="profile-email">${user.email}</div>` : ''}
          <div class="profile-joined">Joined ${new Date(user.created_at).toLocaleDateString()}</div>
          ${user.role === 'admin' ? '<div class="admin-badge">\uD83D\uDEE0\uFE0F Administrator</div>' : ''}
          ${isFriendOfFriend ? '<div class="connection-badge">\uD83D\uDC65 Friend of a Friend</div>' : ''}
        </div>
      </div>

      <div class="profile-stats">
        <div class="stat-item">
          <div class="stat-value">${stats.friends}</div>
          <div class="stat-label">Friends</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">${stats.posts}</div>
          <div class="stat-label">Posts</div>
        </div>
        <div class="stat-item">
          <div class="stat-value">${Math.floor((Date.now() - new Date(user.created_at)) / 86400000)}</div>
          <div class="stat-label">Days Active</div>
        </div>
      </div>

      ${layoutArea}
    `;
    }
    renderEditableNameFields(user) {
        const firstName = this._editSnapshot?.first_name ?? user.first_name ?? '';
        const lastName = this._editSnapshot?.last_name ?? user.last_name ?? '';
        return `
      <div class="profile-name-fields">
        <div class="form-group">
          <label class="form-label" for="profileFirstName">First Name</label>
          <input type="text" id="profileFirstName" class="form-control profile-name-input" maxlength="100" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(firstName)}" />
        </div>
        <div class="form-group">
          <label class="form-label" for="profileLastName">Last Name</label>
          <input type="text" id="profileLastName" class="form-control profile-name-input" maxlength="100" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(lastName)}" />
        </div>
      </div>
    `;
    }
    renderWidgetSection(section, mode = 'view') {
        if (mode === 'edit') {
            if (!this._isSectionSaved(section.id)) {
                const widgetName = this._getWidgetFromCatalog(section.widgetId)?.name || 'Widget';
                return `
          <div class="profile-widget-block profile-widget-preview-placeholder card profile-layout-section">
            <div class="card-body">
              <p class="form-text"><strong>${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(widgetName)}</strong> preview will appear after you save your layout.</p>
            </div>
          </div>
        `;
            }
            const widget = this._getWidgetFromCatalog(section.widgetId);
            if (this._widgetHasMarkdownConfig(widget)) return `
          <div class="profile-widget-block profile-widget-edit-hint card profile-layout-section">
            <div class="card-body">
              <p class="form-text">Edit your text in the <strong>Content</strong> field above. This preview updates after you save.</p>
            </div>
          </div>
        `;
        }
        const userId = this.profileData?.user?.id;
        return `
      <div class="profile-widget-block card profile-layout-section" data-section-id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(section.id)}">
        <div class="card-body">
          <fot-widget
            widget-id="${section.widgetId}"
            instance-id="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(section.id)}"
            owner-user-id="${userId}"
          ></fot-widget>
        </div>
      </div>
    `;
    }
    renderWidgetFlagChrome() {
        return `
      <div class="profile-widget-flag-bar" hidden>
        <button
          type="button"
          class="profile-widget-flag-trigger"
          data-action="open-widget-flag-picker"
          title="Flag a widget"
          aria-label="Flag a widget"
        >\u{1F6A9}</button>
      </div>
      <widget-flag-picker-modal></widget-flag-picker-modal>
    `;
    }
    _getWidgetSections() {
        const user = this.profileData?.user;
        if (!user?.profile_layout) return [];
        const layout = (0, $db8fbdb30433d4e7$export$874c24d959cd4878)(user.profile_layout);
        return (0, $db8fbdb30433d4e7$export$2d43a298984e547a)(layout.root).filter((s)=>s.type === 'widget' && s.widgetId);
    }
    _canShowWidgetFlagControls() {
        if (!this.profileData?.user || this.profileData.error) return false;
        if (this.isEditingProfile) return false;
        if (this.profileData.relationship?.isSelf) return false;
        if (!this.currentUser) return false;
        return this._getWidgetSections().length > 0;
    }
    async _loadWidgetCatalogForView() {
        if (this._myWidgetCatalog.length || this._communityWidgetCatalog.length) return;
        try {
            const response = await fetch('/api/widgets/profile-catalog', {
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                this._myWidgetCatalog = data.myWidgets || [];
                this._communityWidgetCatalog = data.communityWidgets || data.widgets || [];
            }
        } catch (error) {
            window.logger?.warn('Failed to load widget catalog for view:', error);
        }
    }
    async _refreshFlaggableWidgets() {
        const bar = this.querySelector('.profile-widget-flag-bar');
        if (!this._canShowWidgetFlagControls()) {
            this._flaggableWidgets = [];
            if (bar) bar.hidden = true;
            return;
        }
        await this._loadWidgetCatalogForView();
        const userId = this.profileData.user.id;
        const sections = this._getWidgetSections();
        const items = sections.map((section)=>({
                widgetId: section.widgetId,
                profileOwnerUserId: userId,
                sectionId: section.id
            }));
        try {
            const params = new URLSearchParams({
                items: JSON.stringify(items)
            });
            const res = await fetch(`/api/widgets/flag-status/batch?${params}`, {
                credentials: 'include'
            });
            if (!res.ok) {
                this._flaggableWidgets = [];
                if (bar) bar.hidden = true;
                return;
            }
            const data = await res.json();
            const flaggedBySection = new Map((data.results || []).map((result)=>[
                    result.sectionId,
                    result.flaggedByCurrentUser
                ]));
            this._flaggableWidgets = sections.filter((section)=>!flaggedBySection.get(section.id)).map((section)=>{
                const catalogWidget = this._getWidgetFromCatalog(section.widgetId);
                return {
                    sectionId: section.id,
                    widgetId: section.widgetId,
                    profileOwnerUserId: userId,
                    name: catalogWidget?.name || 'Widget',
                    icon: "\uD83E\uDDE9"
                };
            });
            if (bar) bar.hidden = this._flaggableWidgets.length === 0;
        } catch (error) {
            window.logger?.warn('Failed to load widget flag status:', error);
            this._flaggableWidgets = [];
            if (bar) bar.hidden = true;
        }
    }
    async _openWidgetFlagPicker() {
        await this._refreshFlaggableWidgets();
        if (!this._flaggableWidgets.length) return;
        const picker = this.querySelector('widget-flag-picker-modal');
        if (!picker) return;
        picker.open({
            widgets: [
                ...this._flaggableWidgets
            ],
            onSelect: (widget, reason)=>this._submitWidgetFlag(widget, reason)
        });
    }
    _showFlagToast(message) {
        const toast = document.createElement('div');
        toast.className = 'toast-notification';
        toast.textContent = message;
        document.body.appendChild(toast);
        setTimeout(()=>toast.remove(), 3000);
    }
    async _submitWidgetFlag(widget, reason) {
        const res = await fetch('/api/widgets/flag', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                widgetId: parseInt(widget.widgetId, 10),
                profileOwnerUserId: parseInt(widget.profileOwnerUserId, 10),
                sectionId: widget.sectionId,
                reason: reason
            })
        });
        if (!res.ok) {
            const json = await res.json().catch(()=>({}));
            throw new Error(json.error || 'Failed to flag widget');
        }
        const embed = this.querySelector(`fot-widget[instance-id="${widget.sectionId}"]`);
        if (embed?.refreshFlagStatus) await embed.refreshFlagStatus();
        this._showFlagToast("Thanks \u2014 we will review this widget.");
        await this._refreshFlaggableWidgets();
    }
    renderPostsSection(posts, relationship) {
        return `
      <div class="profile-posts">
        <div class="posts-header">
          <h3>Recent Posts</h3>
        </div>
        
        ${this.renderPosts(posts, relationship)}
      </div>
    `;
    }
    renderPosts(posts, relationship) {
        if (!relationship.isSelf && !relationship.isFriend) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F512}</div>
          <h3>Posts are Private</h3>
          <p>You need to be friends with ${this.profileData.user.username} to see their posts.</p>
        </div>
      `;
        if (this.isLoadingPosts) return `
        <div class="loading-state posts-loading">
          <div class="spinner"></div>
          <div>Loading posts...</div>
        </div>
      `;
        if (posts.length === 0) return `
        <div class="empty-state">
          <div class="empty-state-icon">\u{1F4DD}</div>
          <h3>No Posts Yet</h3>
          <p>${relationship.isSelf ? 'You haven\'t posted anything yet.' : `${this.profileData.user.username} hasn't posted anything yet.`}</p>
        </div>
      `;
        return `
      <div class="posts-list">
        ${posts.map((post)=>`
          <post-item post-data='${JSON.stringify(post).replace(/'/g, '&apos;')}'></post-item>
        `).join('')}
      </div>
      ${this.renderPagination()}
    `;
    }
    renderPagination() {
        if (this.isEditingProfile) return '';
        const hasNext = this.pagination && this.pagination.hasNext;
        const hasPrevious = this.currentPage > 1;
        const showPagination = hasNext || hasPrevious;
        if (!showPagination) return '';
        return `
      <div class="load-more-container">
        <div class="pagination-buttons">
          ${hasPrevious ? `
            <button class="load-previous-btn">
              <span class="load-more-arrow">\u{2B06}\u{FE0F}</span>
              <span class="load-more-text">Previous Page</span>
            </button>
          ` : ''}
          ${hasNext ? `
            <button class="load-more-btn">
              <span class="load-more-icon">\u{2728}</span>
              <span class="load-more-text">Next Page</span>
              <span class="load-more-arrow">\u{2B07}\u{FE0F}</span>
            </button>
          ` : ''}
        </div>
        <div class="pagination-info">
          Page ${this.currentPage}${this.pagination ? ` of ${this.pagination.totalPages || Math.ceil(this.pagination.total / 10)}` : ''}
          (${this.profileData.posts.length}${this.pagination ? ` of ${this.pagination.total}` : ''} posts)
        </div>
      </div>
    `;
    }
    async loadMore() {
        if (this.isEditingProfile) return;
        if (this.pagination && this.pagination.hasNext && !this.isLoadingPosts && !this.isLoading) {
            this.currentPage++;
            this.updateProfilePageUrl();
            await this.loadProfile(true);
        }
    }
    async loadPrevious() {
        if (this.isEditingProfile) return;
        if (this.currentPage > 1 && !this.isLoadingPosts && !this.isLoading) {
            this.currentPage--;
            this.updateProfilePageUrl();
            await this.loadProfile(true);
        }
    }
    updateProfilePageUrl() {
        const url = new URL(window.location);
        if (this.currentPage === 1) url.searchParams.delete('page');
        else url.searchParams.set('page', this.currentPage.toString());
        window.history.pushState({
            page: this.currentPage
        }, '', url);
    }
    async loadProfile(postsOnly = false) {
        if (!this.currentUsername) return;
        if (postsOnly) this.isLoadingPosts = true;
        else this.isLoading = true;
        this.updateContent();
        try {
            const endpoint = this.currentUsername === 'me' ? '/api/users/profile/me' : `/api/users/profile/${this.currentUsername}`;
            const url = new URL(endpoint, window.location.origin);
            url.searchParams.set('page', this.currentPage.toString());
            url.searchParams.set('limit', '10');
            const response = await fetch(url.toString(), {
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                this.profileData = data;
                this.pagination = data.pagination || null;
                if (data.user?.profile_layout) this._syncSavedSectionIdsFromLayout(data.user.profile_layout);
            } else if (response.status === 404) {
                this.profileData = {
                    error: 'User not found'
                };
                this.pagination = null;
            } else {
                this.profileData = {
                    error: 'Failed to load profile'
                };
                this.pagination = null;
            }
        } catch (error) {
            window.logger.error('Failed to load profile:', error);
            this.profileData = {
                error: 'Network error'
            };
            this.pagination = null;
        } finally{
            this.isLoading = false;
            this.isLoadingPosts = false;
            this.updateContent();
            if (postsOnly) this.querySelector('.profile-posts')?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
    updateContent() {
        const profileRoot = this.querySelector('.user-profile');
        if (profileRoot) profileRoot.classList.toggle('is-editing', this.isEditingProfile);
        const content = this.querySelector('.profile-content');
        if (content) {
            content.innerHTML = this.renderContent();
            // Set current user for comments sections
            const commentsSections = content.querySelectorAll('comments-section');
            commentsSections.forEach((commentsSection)=>{
                if (commentsSection.currentUser) commentsSection.setCurrentUser(this.currentUser);
            });
            // Set current user for user-mention components
            const userMentions = content.querySelectorAll('user-mention');
            userMentions.forEach((userMention)=>{
                if (userMention.setCurrentUser && this.currentUser) userMention.setCurrentUser(this.currentUser);
            });
            this._mountProfileSurface();
        }
    }
    // Method to update current user (called by MainContent)
    // Note: This does NOT load the profile - that's handled by profile-load events
    setCurrentUser(user) {
        this.currentUser = user;
        // Don't set currentUsername here - that's only for "me" profile view
        if (this.profileData && !this.profileData.error) this.updateContent();
    }
    async handleEditProfile() {
        if (!this.profileData?.user) return;
        const user = this.profileData.user;
        this._editSnapshot = {
            first_name: user.first_name || '',
            last_name: user.last_name || ''
        };
        try {
            const response = await fetch('/api/widgets/profile-catalog', {
                credentials: 'include'
            });
            if (response.ok) {
                const data = await response.json();
                this._myWidgetCatalog = data.myWidgets || [];
                this._communityWidgetCatalog = data.communityWidgets || data.widgets || [];
            } else {
                window.logger.warn('Failed to load widget catalog:', response.status);
                this._myWidgetCatalog = [];
                this._communityWidgetCatalog = [];
            }
        } catch (error) {
            window.logger.warn('Failed to load widget catalog:', error);
            this._myWidgetCatalog = [];
            this._communityWidgetCatalog = [];
        }
        this.isEditingProfile = true;
        this._syncSavedSectionIdsFromLayout(user.profile_layout);
        await this._loadInstanceConfigsForEdit(user);
        this.updateContent();
    }
    handleCancelProfileEdit() {
        if (!this._editSnapshot || !this.profileData?.user) {
            this.isEditingProfile = false;
            this.updateContent();
            return;
        }
        const user = this.profileData.user;
        user.first_name = this._editSnapshot.first_name;
        user.last_name = this._editSnapshot.last_name;
        this.isEditingProfile = false;
        this._editSnapshot = null;
        this.updateContent();
    }
    async handleSaveProfile(layout, instanceConfigs = []) {
        try {
            await this._persistProfileLayout(layout, instanceConfigs, {
                exitEditMode: true
            });
        } catch (error) {
            window.logger.error('Failed to update profile:', error);
            alert(`Failed to update profile: ${error.message}`);
        }
    }
    async handleLayoutOAuthConnect(detail) {
        const { connectUrl: connectUrl, sectionId: sectionId } = detail || {};
        if (!connectUrl || !sectionId) return;
        const surface = this.querySelector('layout-grid-surface');
        const layout = surface?.getLayout?.();
        const editor = surface?.querySelector('layout-split-editor');
        const connectBtn = editor?.querySelector(`[data-action="oauth-connect"][data-section-id="${sectionId}"]`);
        if (connectBtn) {
            connectBtn.disabled = true;
            connectBtn.classList.add('loading');
        }
        try {
            await this._persistProfileLayout(layout, [], {
                exitEditMode: false,
                refreshPreviews: true
            });
            window.location.href = connectUrl;
        } catch (error) {
            window.logger.error('Failed to save layout before OAuth connect:', error);
            const oauthPanel = editor?.querySelector(`[data-oauth-section="${sectionId}"]`);
            let errEl = oauthPanel?.querySelector('.layout-widget-oauth-error');
            if (oauthPanel && !errEl) {
                errEl = document.createElement('p');
                errEl.className = 'form-text layout-widget-oauth-error';
                errEl.setAttribute('role', 'alert');
                oauthPanel.appendChild(errEl);
            }
            if (errEl) errEl.textContent = error.message || 'Could not save layout before connecting.';
            if (connectBtn) {
                connectBtn.disabled = false;
                connectBtn.classList.remove('loading');
            }
        }
    }
    async _persistProfileLayout(layout, instanceConfigs = [], options = {}) {
        const { exitEditMode: exitEditMode = true, refreshPreviews: refreshPreviews = false } = options;
        const firstNameInput = this.querySelector('#profileFirstName');
        const lastNameInput = this.querySelector('#profileLastName');
        const data = {
            first_name: firstNameInput?.value?.trim() || null,
            last_name: lastNameInput?.value?.trim() || null,
            profileLayout: layout
        };
        const saveBtn = this.querySelector('[data-action="surface-save"]');
        if (saveBtn && exitEditMode) {
            saveBtn.disabled = true;
            saveBtn.classList.add('loading');
        }
        try {
            const response = await fetch('/api/users/me', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || errorData.message || 'Failed to update profile');
            }
            if (Array.isArray(instanceConfigs) && instanceConfigs.length) for (const item of instanceConfigs){
                const cfgRes = await fetch(`/api/users/me/widget-instances/${encodeURIComponent(item.sectionId)}/config`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        widgetId: item.widgetId,
                        config: item.config
                    })
                });
                if (!cfgRes.ok) {
                    const err = await cfgRes.json();
                    throw new Error(err.error || 'Failed to save widget configuration');
                }
            }
            const updatedUser = await response.json();
            window.logger.info('Profile updated successfully');
            if (this.profileData?.user) {
                this.profileData.user.profile_layout = layout;
                if (updatedUser.profile_layout) this.profileData.user.profile_layout = updatedUser.profile_layout;
            }
            this._syncSavedSectionIdsFromLayout(layout);
            if (exitEditMode) {
                this.isEditingProfile = false;
                this._editSnapshot = null;
                const surface = this.querySelector('layout-grid-surface');
                surface?.exitEditMode(false);
                await this.loadProfile();
                document.dispatchEvent(new CustomEvent('profile-updated', {
                    detail: {
                        user: updatedUser
                    }
                }));
            } else if (refreshPreviews) {
                const surface = this.querySelector('layout-grid-surface');
                const sections = (0, $db8fbdb30433d4e7$export$2d43a298984e547a)((0, $db8fbdb30433d4e7$export$874c24d959cd4878)(layout).root);
                for (const section of sections)if (section.type === 'widget') surface?._refreshSectionPreview?.(section.id);
            }
            return updatedUser;
        } catch (error) {
            if (exitEditMode && saveBtn) {
                saveBtn.disabled = false;
                saveBtn.classList.remove('loading');
            }
            throw error;
        }
    }
    async openEditNameModal() {
        if (!this.profileData?.user) return;
        const user = this.profileData.user;
        const modal = document.createElement('div');
        modal.className = 'edit-profile-modal';
        modal.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Edit Profile</h3>
            <button class="close-btn" id="closeEditProfileModal">&times;</button>
          </div>
          <form class="edit-profile-form" id="editProfileForm">
            <div class="form-group">
              <label for="firstName">First Name</label>
              <input type="text" id="firstName" name="first_name" maxlength="100" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.first_name || '')}" />
            </div>
            <div class="form-group">
              <label for="lastName">Last Name</label>
              <input type="text" id="lastName" name="last_name" maxlength="100" value="${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.last_name || '')}" />
            </div>
            <div class="form-actions">
              <button type="button" class="btn btn-secondary" id="cancelEditProfile">Cancel</button>
              <button type="submit" class="btn btn-primary" id="submitEditProfile">Save Changes</button>
            </div>
          </form>
        </div>
      </div>
    `;
        this.prepend(modal);
        const closeModal = ()=>modal.remove();
        modal.querySelector('#closeEditProfileModal').addEventListener('click', closeModal);
        modal.querySelector('#cancelEditProfile').addEventListener('click', closeModal);
        modal.querySelector('.modal-backdrop').addEventListener('click', (e)=>{
            if (e.target === e.currentTarget) closeModal();
        });
        modal.querySelector('#editProfileForm').addEventListener('submit', async (e)=>{
            e.preventDefault();
            const formData = new FormData(e.target);
            const submitBtn = modal.querySelector('#submitEditProfile');
            submitBtn.disabled = true;
            try {
                const response = await fetch('/api/users/me', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include',
                    body: JSON.stringify({
                        first_name: formData.get('first_name') || null,
                        last_name: formData.get('last_name') || null
                    })
                });
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || 'Failed to update profile');
                }
                closeModal();
                await this.loadProfile();
            } catch (error) {
                alert(`Failed to update profile: ${error.message}`);
                submitBtn.disabled = false;
            }
        });
    }
    getDisplayName(user) {
        if (user.first_name && user.last_name) return `${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.first_name)} ${(0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.last_name)}`;
        else if (user.first_name) return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.first_name);
        else if (user.last_name) return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.last_name);
        else return (0, $89169a3d85b55cc3$export$4cf11838cdc2a8a8)(user.username);
    }
}
// Register the custom element
customElements.define('user-profile', $0ad2148afb589f74$var$UserProfile);


// Washing Machine Icon Web Component
class $1d0b4955bc28ee9b$var$WashingMachineIcon extends HTMLElement {
    constructor(){
        super();
        this.size = this.getAttribute('size') || 'medium'; // small, medium, large
        this.interactive = this.getAttribute('interactive') !== 'false'; // default true
    }
    static get observedAttributes() {
        return [
            'size',
            'interactive'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            if (name === 'size') this.size = newValue || 'medium';
            else if (name === 'interactive') this.interactive = newValue !== 'false';
            this.render();
        }
    }
    connectedCallback() {
        this.render();
    }
    render() {
        this.innerHTML = `
      <div class="washing-machine-container ${this.interactive ? 'interactive' : 'static'}">
        <div class="washing-machine">
          <div class="machine-body">
            <div class="machine-door">
              <div class="machine-drum">
                <div class="drum-inner">
                  <div class="clothes-item"></div>
                  <div class="clothes-item"></div>
                  <div class="clothes-item"></div>
                </div>
              </div>
              <div class="door-handle"></div>
            </div>
            <div class="control-panel">
              <div class="control-button"></div>
              <div class="control-button"></div>
            </div>
          </div>
        </div>
      </div>
    `;
        // Set data attribute for size-specific styling
        this.querySelector('.washing-machine-container').setAttribute('data-size', this.size);
    }
    // Method to trigger spinning animation
    spin() {
        if (this.interactive) {
            const container = this.querySelector('.washing-machine-container');
            container.classList.add('spinning');
            setTimeout(()=>{
                container.classList.remove('spinning');
            }, 600);
        }
    }
    // Method to start/stop continuous spinning
    startSpinning() {
        if (this.interactive) {
            const drumInner = this.querySelector('.drum-inner');
            const clothesItems = this.querySelectorAll('.clothes-item');
            drumInner.style.animation = 'gentle-spin 2s linear infinite';
            clothesItems.forEach((item)=>{
                item.style.animation = 'gentle-tumble 2s linear infinite';
            });
        }
    }
    stopSpinning() {
        if (this.interactive) {
            const drumInner = this.querySelector('.drum-inner');
            const clothesItems = this.querySelectorAll('.clothes-item');
            drumInner.style.animation = '';
            clothesItems.forEach((item)=>{
                item.style.animation = '';
            });
        }
    }
}
// Register the custom element
customElements.define('washing-machine-icon', $1d0b4955bc28ee9b$var$WashingMachineIcon);


// Note: All route-specific components are now loaded lazily via component-loader
// when their routes are accessed. This includes:
// - post-writer, posts-feed, post-detail, comments-section, post-item
// - friends-list, friend-requests, invitations-list
// - user-profile, admin-dashboard, settings-page
// - events-list, events-calendar, event-detail, event-edit
// - memories, and all other route-specific components
//
// Sub-components (like markdown-toolbar, mood-selector, etc.) are imported
// by their parent components and will be loaded automatically when needed.
// timezone setup
dayjs.extend(window.dayjs_plugin_utc);
dayjs.extend(window.dayjs_plugin_timezone);
dayjs.extend(window.dayjs_plugin_localizedFormat);
const $851675b4b57255c4$var$PUBLIC_INFO_ROUTES = {
    '/privacy': 'privacy',
    '/terms': 'terms',
    '/release-notes': 'release-notes'
};
// Enhanced navigation with clean URLs
class $851675b4b57255c4$var$Navigation {
    constructor(){
        this.init();
    }
    init() {
        // Navigation is now handled by the router
        // This class can handle additional navigation-specific logic
        // Update navigation when auth state changes
        document.addEventListener('auth-status-loaded', (e)=>{
            const { authenticated: authenticated } = e.detail;
            this.updateNavigationForAuth(authenticated);
        });
        // Handle logout navigation
        document.addEventListener('user-logged-out', ()=>{
            // Redirect to login page
            window.router.navigate('/login');
        });
    }
    updateNavigationForAuth(isAuthenticated) {
        const nav = document.querySelector('.main-nav');
        if (nav) {
            if (isAuthenticated) nav.style.display = 'block';
            else nav.style.display = 'none';
        }
    }
}
// Initialize navigation when DOM is loaded
document.addEventListener('DOMContentLoaded', async ()=>{
    new $851675b4b57255c4$var$Navigation();
    // Load auth + feature flags before first route render so gated UI is correct
    await $851675b4b57255c4$var$initializeApp();
    window.router.doInitialPageLoad();
});
// Initialize app with authentication check
async function $851675b4b57255c4$var$initializeApp() {
    window.logger.info('Initializing Fun Old Times frontend');
    try {
        // Check authentication status and feature flags in parallel
        window.logger.debug('Checking authentication status');
        const [response, featuresResponse] = await Promise.all([
            fetch('/api/auth/status', {
                credentials: 'include'
            }),
            fetch('/api/features', {
                credentials: 'include'
            })
        ]);
        if (featuresResponse.ok) {
            const featuresData = await featuresResponse.json();
            (0, $4bd131ffd9e749e2$export$9378dc6d04015c6c)(featuresData.features || {});
            document.dispatchEvent(new CustomEvent('feature-flags-loaded', {
                detail: {
                    features: featuresData.features || {}
                },
                bubbles: true
            }));
        } else window.logger.warn('Failed to load feature flags', {
            status: featuresResponse.status
        });
        if (response.ok) {
            const data = await response.json();
            const user = data.authenticated ? data.user : null;
            window.logger.auth('status_checked', user?.id, {
                authenticated: !!user,
                username: user?.username
            });
            document.dispatchEvent(new CustomEvent('auth-status-loaded', {
                detail: {
                    user: user,
                    authenticated: !!user
                },
                bubbles: true
            }));
            if (!data.authenticated) $851675b4b57255c4$var$handleUnauthenticatedAccess(window.location.pathname);
            else // User is authenticated - check if on public info route
            if ($851675b4b57255c4$var$isPublicInfoRoute(window.location.pathname)) {
                $851675b4b57255c4$var$hideMainContent();
                $851675b4b57255c4$var$showPublicPage($851675b4b57255c4$var$resolvePublicPageKey(window.location.pathname));
            } else // Show main content and continue with routing
            $851675b4b57255c4$var$showMainContent();
        } else // Error checking auth status, check if on special route
        $851675b4b57255c4$var$handleUnauthenticatedAccess(window.location.pathname);
    } catch (error) {
        window.logger.error('Auth check failed', error, {
            path: window.location.pathname,
            url: window.location.href
        });
        $851675b4b57255c4$var$handleUnauthenticatedAccess(window.location.pathname);
    } finally{
        $851675b4b57255c4$var$hideLoadingScreen();
    }
}
function $851675b4b57255c4$var$hideLoadingScreen() {
    const loadingScreen = document.querySelector('#loadingScreen');
    if (loadingScreen) loadingScreen.style.display = 'none';
}
function $851675b4b57255c4$var$handleUnauthenticatedAccess(currentPath) {
    if ((0, $0f47089e90838514$export$53f44bfb1c4a0685)(currentPath)) {
        $851675b4b57255c4$var$hideMainContent();
        $851675b4b57255c4$var$showLandingPage();
        return;
    }
    $851675b4b57255c4$var$hideLandingPage();
    if ($851675b4b57255c4$var$isPublicInfoRoute(currentPath)) {
        $851675b4b57255c4$var$hideMainContent();
        $851675b4b57255c4$var$showPublicPage($851675b4b57255c4$var$resolvePublicPageKey(currentPath));
        return;
    }
    $851675b4b57255c4$var$hidePublicPage();
    if ((0, $0c1c38b6cb0e7c6b$export$77dd37d1faf34783)(currentPath)) {
        $851675b4b57255c4$var$showMainContent();
        document.dispatchEvent(new CustomEvent('route-changed', {
            detail: {
                route: currentPath
            }
        }));
        return;
    }
    if ((0, $2a71a25ef8798626$export$a70f9cc74b4a9f22)(currentPath)) {
        $851675b4b57255c4$var$hideMainContent();
        return;
    }
    if (!(0, $0f47089e90838514$export$2b943233a7784d73)(currentPath)) {
        $851675b4b57255c4$var$hideMainContent();
        window.router.redirectToLogin();
        return;
    }
    if ($851675b4b57255c4$var$isGuestRoute(currentPath)) {
        $851675b4b57255c4$var$showGuestRouteShell();
        return;
    }
    $851675b4b57255c4$var$hideMainContent();
    const modalMode = $851675b4b57255c4$var$normalizeModalMode(currentPath);
    $851675b4b57255c4$var$showAuthModal(modalMode);
}
function $851675b4b57255c4$var$isGuestRoute(path) {
    return path.startsWith('/events/guest');
}
function $851675b4b57255c4$var$isPublicInfoRoute(path) {
    if (Object.prototype.hasOwnProperty.call($851675b4b57255c4$var$PUBLIC_INFO_ROUTES, path)) return true;
    return path === '/docs' || path.startsWith('/docs/');
}
function $851675b4b57255c4$var$resolvePublicPageKey(path) {
    if (path === '/docs' || path.startsWith('/docs/')) return 'docs';
    return $851675b4b57255c4$var$PUBLIC_INFO_ROUTES[path] || null;
}
function $851675b4b57255c4$var$normalizeModalMode(path) {
    let mode = path;
    if (mode.charAt(0) === '/') mode = mode.slice(1);
    if (mode.charAt(mode.length - 1) === '/') mode = mode.slice(0, -1);
    return mode || 'login';
}
// Show authentication modal
function $851675b4b57255c4$var$showAuthModal(mode = 'login', required = false) {
    let authModal = document.querySelector('auth-modal');
    if (!authModal) {
        authModal = document.createElement('auth-modal');
        document.body.appendChild(authModal);
    }
    authModal.open(mode, required);
}
// Hide main content when not authenticated
function $851675b4b57255c4$var$hideMainContent() {
    const mainContent = document.querySelector('.main-content');
    const loadingScreen = document.querySelector('#loadingScreen');
    const guestHost = document.getElementById('guest-route-host');
    const primaryContent = document.querySelector('main-content');
    if (mainContent) mainContent.style.display = 'none';
    if (guestHost) {
        guestHost.classList.add('hidden');
        guestHost.innerHTML = '';
    }
    if (primaryContent) primaryContent.style.display = '';
    if (loadingScreen) loadingScreen.style.display = 'none';
}
// Show main content when authenticated
function $851675b4b57255c4$var$showMainContent() {
    const mainContent = document.querySelector('.main-content');
    const loadingScreen = document.querySelector('#loadingScreen');
    const guestHost = document.getElementById('guest-route-host');
    const primaryContent = document.querySelector('main-content');
    $851675b4b57255c4$var$hideLandingPage();
    $851675b4b57255c4$var$hidePublicPage();
    $851675b4b57255c4$var$hideLandingPage();
    if (loadingScreen) loadingScreen.style.display = 'none';
    if (guestHost) {
        guestHost.classList.add('hidden');
        guestHost.innerHTML = '';
    }
    if (primaryContent) primaryContent.style.display = '';
    if (mainContent) mainContent.style.display = 'block';
}
function $851675b4b57255c4$var$showGuestRouteShell() {
    const mainContent = document.querySelector('.main-content');
    const guestHost = document.getElementById('guest-route-host');
    const primaryContent = document.querySelector('main-content');
    const loadingScreen = document.querySelector('#loadingScreen');
    $851675b4b57255c4$var$hideLandingPage();
    $851675b4b57255c4$var$hidePublicPage();
    if (loadingScreen) loadingScreen.style.display = 'none';
    if (mainContent) mainContent.style.display = 'block';
    if (primaryContent) primaryContent.style.display = 'none';
    if (guestHost) guestHost.classList.remove('hidden');
}
function $851675b4b57255c4$var$showLandingPage() {
    const host = document.getElementById('landingPageHost');
    const appLayout = document.querySelector('.app-layout');
    $851675b4b57255c4$var$hidePublicPage();
    if (document.body) document.body.classList.add('landing-visible');
    if (appLayout) appLayout.setAttribute('aria-hidden', 'true');
    if (host) host.classList.remove('hidden');
}
function $851675b4b57255c4$var$hideLandingPage() {
    const host = document.getElementById('landingPageHost');
    const appLayout = document.querySelector('.app-layout');
    if (document.body) document.body.classList.remove('landing-visible');
    if (appLayout) appLayout.removeAttribute('aria-hidden');
    if (host && !host.classList.contains('hidden')) host.classList.add('hidden');
}
function $851675b4b57255c4$var$showPublicPage(pageKey) {
    const host = document.getElementById('publicPageHost');
    const appLayout = document.querySelector('.app-layout');
    if (!host) return;
    $851675b4b57255c4$var$hideLandingPage();
    const componentTag = pageKey === 'privacy' ? 'privacy-policy' : pageKey === 'terms' ? 'terms-conditions' : pageKey === 'release-notes' ? 'release-notes' : pageKey === 'docs' ? 'docs-page' : null;
    if (!componentTag) {
        $851675b4b57255c4$var$hidePublicPage();
        return;
    }
    if (document.body) document.body.classList.add('public-page-visible');
    if (appLayout) appLayout.setAttribute('aria-hidden', 'true');
    host.innerHTML = `<${componentTag}></${componentTag}>`;
    host.classList.remove('hidden');
    host.classList.add('active');
}
function $851675b4b57255c4$var$hidePublicPage() {
    const host = document.getElementById('publicPageHost');
    const appLayout = document.querySelector('.app-layout');
    if (!host) return;
    if (document.body) document.body.classList.remove('public-page-visible');
    if (appLayout) appLayout.removeAttribute('aria-hidden');
    host.classList.add('hidden');
    host.classList.remove('active');
    host.innerHTML = '';
}
// Handle authentication success
document.addEventListener('auth-success', ()=>{
    $851675b4b57255c4$var$showMainContent();
});
// Handle authentication required events
document.addEventListener('auth-required', async ()=>{
    $851675b4b57255c4$var$hideMainContent();
    window.router.redirectToLogin();
});
// Handle user logout
document.addEventListener('user-logged-out', async ()=>{
    $851675b4b57255c4$var$hideMainContent();
    window.router.navigate('/login');
});
document.addEventListener('landing-auth-request', (event)=>{
    const mode = event?.detail?.mode || 'login';
    $851675b4b57255c4$var$hideLandingPage();
    $851675b4b57255c4$var$hidePublicPage();
    $851675b4b57255c4$var$showAuthModal(mode, true);
});
document.addEventListener('public-page-request', (event)=>{
    const page = event?.detail?.page;
    if (page && (Object.values($851675b4b57255c4$var$PUBLIC_INFO_ROUTES).includes(page) || page === 'docs')) {
        $851675b4b57255c4$var$hideMainContent();
        $851675b4b57255c4$var$showPublicPage(page);
    }
});
// Listen for hide-public-page event from router
document.addEventListener('hide-public-page', ()=>{
    $851675b4b57255c4$var$hidePublicPage();
});
// Listen for show-landing-page event from router
document.addEventListener('show-landing-page', ()=>{
    $851675b4b57255c4$var$hidePublicPage();
    $851675b4b57255c4$var$hideMainContent();
    $851675b4b57255c4$var$showLandingPage();
});
// Expose showMainContent globally so router can call it
window.showMainContent = $851675b4b57255c4$var$showMainContent;


//# sourceMappingURL=public.d620622d.js.map
